(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6051],{

/***/ 32873:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-down.aa284948.svg","height":11,"width":20});

/***/ }),

/***/ 29157:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-right.bd9ef851.svg","height":17,"width":10});

/***/ }),

/***/ 97274:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-up.f1d1d9a0.svg","height":10,"width":16});

/***/ }),

/***/ 12522:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-top-arrow.62e44c63.svg","height":20,"width":12});

/***/ }),

/***/ 65110:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/calendar.3ccff5e2.svg","height":19,"width":19});

/***/ }),

/***/ 82821:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/cart-gray.abab88ab.svg","height":20,"width":25});

/***/ }),

/***/ 27644:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/cart-icon-empty.02db72e9.svg","height":20,"width":26});

/***/ }),

/***/ 36868:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/down-arrow-sort.99077165.svg","height":11,"width":10});

/***/ }),

/***/ 91883:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download-dark-gray.44fffa51.svg","height":16,"width":14});

/***/ }),

/***/ 62617:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/edit.3743e0da.svg","height":16,"width":16});

/***/ }),

/***/ 24495:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/filter.df2e3489.svg","height":14,"width":21});

/***/ }),

/***/ 8909:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/grid-off.7efb787f.svg","height":17,"width":17});

/***/ }),

/***/ 7520:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/grid-on.72b9c8b7.svg","height":17,"width":17});

/***/ }),

/***/ 1405:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/pdf-grey.950162d0.svg","height":23,"width":19});

/***/ }),

/***/ 30402:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/print.9f8da7b0.svg","height":17,"width":17});

/***/ }),

/***/ 83790:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/search.9197ce09.svg","height":19,"width":18});

/***/ }),

/***/ 66773:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/share.c1bcda3a.svg","height":17,"width":14});

/***/ }),

/***/ 29875:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wish.b0a7483e.svg","height":14,"width":15});

/***/ }),

/***/ 62084:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wishlist-gray-filled.091dca10.svg","height":20,"width":23});

/***/ }),

/***/ 36562:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/swatch-missing.457436f1.jpeg","height":368,"width":368,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAABAwUAAAAAAAAAAAAAAAAAARIUBBETIWH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AraT5m8K07uusAAP/2Q==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 55064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AemGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Shared/ContainerComponent.jsx




const ContainerComponent = (param)=>{
    let { children , extraProps , item , count  } = param;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timeOut = setTimeout(()=>{
            var ref;
            var ref1;
            const hashValue = (ref1 = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[1]) !== null && ref1 !== void 0 ? ref1 : "";
            if (hashValue) {
                var ref2;
                var ref3;
                const element = (ref3 = document.querySelector("[id='".concat(hashValue, "']"))) !== null && ref3 !== void 0 ? ref3 : {};
                var ref4;
                const offsetTop = (ref4 = element === null || element === void 0 ? void 0 : (ref2 = element.parentNode) === null || ref2 === void 0 ? void 0 : ref2.offsetTop) !== null && ref4 !== void 0 ? ref4 : 0;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }, 1000);
        return ()=>{
            clearTimeout(timeOut);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-container".concat((extraProps === null || extraProps === void 0 ? void 0 : extraProps.fragment) === constants.FRAGMENT_TYPES.HEADER && (extraProps === null || extraProps === void 0 ? void 0 : extraProps.hasGlobalNavigation) && count === 0 ? " desk-header-height" : ""),
        id: item === null || item === void 0 ? void 0 : item.containerId,
        children: children
    });
};
/* harmony default export */ var Shared_ContainerComponent = (ContainerComponent);

;// CONCATENATED MODULE: ./components/AemGridColumn.jsx







const AemGridColumn = (props)=>{
    const { data , itemKey , count , eventHandler , containerId , ...extraProps } = props;
    const Element = modules/* default.Element */.ZP.Element;
    const scrollElementCondition = (item, key)=>{
        return (data === null || data === void 0 ? void 0 : data.columnClassNames) && (data === null || data === void 0 ? void 0 : data.columnClassNames[key]) && !(0,utils/* isTeaser */.j$)(item) && !(0,utils/* isBreadcrumb */.Z3)(item) && !(0,utils/* isCarousel */.C2)(item) && !(0,utils/* isAemForm */.np)(item) && !(0,utils/* isProductAccordion */.eq)(item) && !(0,utils/* isVideo */.Wv)(item) && !(0,utils/* isImage */.Or)(item) && !(0,utils/* isInPageSearch */.L8)(item) && !(0,utils/* isText */.Gs)(item) && !(0,utils/* isShopTheRoomCard */.ck)(item) && !(0,utils/* isProductcardV3 */.DN)(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: scrollElementCondition(item, key),
                    wrapper: (children)=>{
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Element, {
                            className: "".concat((0,utils/* isImageV3 */.EE)(item) ? "image-v3 image" : "").concat((0,utils/* isContainer */.Nm)(item) ? constants.staticClasses.CONTAINER : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNames) && ((0,utils/* isContainer */.Nm)(item) || (0,utils/* isTab */.wR)(item)) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNames) : "").concat((item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) ? " ".concat(item === null || item === void 0 ? void 0 : item.appliedCssClassNamesCustom) : "").concat((0,utils/* isSlick */.bd)(item) ? "carousel-slick carousel ".concat((ref = item["carouselComponentProperties"]) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames, " ") : "").concat((data === null || data === void 0 ? void 0 : data.columnClassNames[key]) ? !(0,utils/* isSlick */.bd)(item) ? " ".concat(data === null || data === void 0 ? void 0 : data.columnClassNames[key], " ") : "" : "").concat((0,utils/* isSpacer */.MW)(item) ? "spacer separator" : "").concat((0,utils/* isTab */.wR)(item) ? "tabs" : "").concat((0,utils/* isAemList */.K5)(item) ? "list" : ""),
                            children: children
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                        condition: (0,utils/* isContainer */.Nm)(item) && key !== constants.COMPONENT_TYPES.ROOT_CONTAINER,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ContainerComponent, {
                                item: item,
                                extraProps: extraProps,
                                count: count,
                                children: children
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                            fullData: data[":items"] && data[":items"],
                            data: item,
                            itemKey: key ? key : itemKey,
                            count: count + 1,
                            containerId: (item === null || item === void 0 ? void 0 : item.containerId) || containerId,
                            eventHandler: eventHandler,
                            ...extraProps
                        })
                    })
                })
            }, item.id ? item.id : index);
        })
    });
};
/* harmony default export */ var components_AemGridColumn = (AemGridColumn);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
;// CONCATENATED MODULE: ./components/Shared/BrandSwitcher.jsx


const BrandSwitcher = (props)=>{
    const { data , datalayerPageName  } = props;
    const handleClick = (e, item)=>{
        const linkUrl = item.link ? item.link : item === null || item === void 0 ? void 0 : item.authoredLink;
        const eventInfo = {
            clickInternalLinks: "".concat(item.linkToNewTab ? "false" : "true"),
            internalLinkPosition: "global header",
            internalLinkZoneName: "global header",
            internalLinkURL: "".concat(window.location.origin).concat(linkUrl === null || linkUrl === void 0 ? void 0 : linkUrl.split("/content/kohler-india/in").join("").replace(".html", "")),
            internalLinkName: "brand sync:".concat(item.brandName.toLowerCase()),
            eventName: "brand sync",
            internalLinkType: "global header:navigation",
            eventType: "click",
            eventAction: "brand sync"
        };
        (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "brand-switcher ".concat(datalayerPageName === "checkout" ? "checkout-brand" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "gbh-nav-panel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "gbh-nav navbar navbar-xpand-sm navbar-dark justify-content-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "gbh-nav__list navbar-nav",
                    children: data.items.map((item, index)=>{
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "gbh-nav__item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "gbh-nav--link ".concat(item.highlight && item.highlight === "true" ? "gbh-nav__link--active" : ""),
                                href: item.link ? (ref = item.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler-india/in").join("").replace(".html", "").replace("en", "") : (ref1 = item.authoredLink) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler-india/in").join("").replace(".html", "").replace("en", ""),
                                "aria-label": "".concat(item.brandName, ". Go to ").concat(item.brandName, "'s Home Page"),
                                target: "".concat(item.linkToNewTab ? "_blank" : "_self"),
                                rel: "".concat(item.linkRef ? "noreferrer" : ""),
                                onClick: (e)=>handleClick(e, item),
                                children: item.brandName
                            })
                        }, "brand-".concat(index));
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandSwitcher = (BrandSwitcher);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.jsx + 2 modules
var AuthUtilityNav = __webpack_require__(46576);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilNavLink.jsx


const CountryUtilNavLink = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , isMobile , datalayerPageName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: languageLink,
        "aria-label": "".concat(countryName, " ").concat(language),
        className: "gbh-data-layer lang ".concat(isMobile && "mobile"),
        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"languageselector","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat(languageLink, '","internalLinkName":"language select:').concat(isMobile ? language.toLowerCase() : languageAbbreviation.toLowerCase(), '","eventName":"language selector","internalLinkType":"homepage:navigation","eventType":"language selector","eventAction":"language selector"}'),
        rel: "noreferrer",
        children: isMobile ? language : languageAbbreviation
    });
};
/* harmony default export */ var v1_CountryUtilNavLink = (CountryUtilNavLink);

;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilNavLinks.jsx



const CountryUtilNavLinks = (props)=>{
    const { languageLink , language , countryName , languageAbbreviation , datalayerPageName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: false,
                    datalayerPageName: datalayerPageName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLink, {
                    languageLink: languageLink,
                    language: language,
                    countryName: countryName,
                    languageAbbreviation: languageAbbreviation,
                    isMobile: true,
                    datalayerPageName: datalayerPageName
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNavLinks = (CountryUtilNavLinks);

// EXTERNAL MODULE: ./src/hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(92798);
;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilContainer.jsx





const CountryUtilContainer = (props)=>{
    const { countryarea , activeTab , title , description , countryselectorItems , datalayerPageName  } = props;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const [expanded, setExpanded] = (0,react.useState)([]);
    const handleExpand = (url, country)=>{
        if (!url) {
            if (expanded.includes(country)) {
                const exp = [
                    ...expanded
                ].filter((item)=>item !== country);
                setExpanded(exp);
            } else {
                const exp1 = [
                    ...expanded
                ];
                exp1.push(country);
                setExpanded(exp1);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: countryarea,
        className: "gbh-tab__content ".concat(activeTab === countryarea ? "gbh-tab__content--active" : "", " "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-lg-4 left d-none d-lg-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(description)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-lg-8 right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-lg-12 col-12 p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "gbh-tab__list",
                                    role: "list",
                                    children: countryselectorItems && countryselectorItems.map(function(item, index) {
                                        var ref;
                                        if (!item.country) return null;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            role: "listitem",
                                            className: "".concat(item.country).concat(winWidth <= 1200 && !item.countryLink ? " arrowdropdown" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: (ref = item.countryLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler-india/in").join("").replace(".html", ""),
                                                    className: "gbh-data-layer gbh-tab__item--link",
                                                    role: "link",
                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"n/a","internalLinkName":"country select:').concat(item.countryName.toLowerCase(), '","eventName":"country selector","internalLinkType":"homepage:navigation","eventType":"country selector","eventAction":"country selector"}'),
                                                    "aria-current": "page",
                                                    onClick: ()=>handleExpand(item.countryLink, item.country),
                                                    children: [
                                                        item.countryName,
                                                        " "
                                                    ]
                                                }),
                                                (item.languageOneAbbreviation || item.languageTwoAbbreviation || item.languageThreeAbbreviation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    style: expanded.includes(item.country) ? {
                                                        display: "block"
                                                    } : {},
                                                    children: [
                                                        item.languageOneAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageOneLink,
                                                            language: item.languageOne,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageOneAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageTwoAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageTwoLink,
                                                            language: item.languageTwo,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageTwoAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        }),
                                                        item.languageThreeAbbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavLinks, {
                                                            languageLink: item.languageThreeLink,
                                                            language: item.languageThree,
                                                            countryName: item.countryName,
                                                            languageAbbreviation: item.languageThreeAbbreviation,
                                                            datalayerPageName: datalayerPageName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "".concat(item.country, "+").concat(index));
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_CountryUtilContainer = (CountryUtilContainer);

;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilNavTabLink.jsx


const CountryUtilNavTabLink = (props)=>{
    const { activeTab , countryArea , onclickVal , countryAreaValue  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        onClick: ()=>{
            onclickVal(countryArea);
        },
        "data-tab": countryArea,
        role: "tab",
        tabIndex: "0",
        "data-region": "#".concat(countryArea),
        "aria-label": countryArea,
        className: "gbh-tabs__tab ".concat(activeTab === countryArea ? "gbh-tabs__tab--active" : ""),
        "data-testid": "countrySelectorSection_tabLink",
        children: countryAreaValue
    });
};
/* harmony default export */ var v1_CountryUtilNavTabLink = (CountryUtilNavTabLink);

// EXTERNAL MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNav.module.scss
var CountryUtilNav_module = __webpack_require__(19371);
var CountryUtilNav_module_default = /*#__PURE__*/__webpack_require__.n(CountryUtilNav_module);
;// CONCATENATED MODULE: ./src/components/Default/CountryUtilNav/v1/CountryUtilNav.jsx






const CountryUtilNav = (props)=>{
    const { show , active , toggleCountryNav , eventHandler , countryselector , datalayerPageName  } = props;
    const { callbacks: { setRegionNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const [activeTab, setActiveTab] = (0,react.useState)("");
    const addCountrySelectorAnalytics = (type)=>{
        let eventInfo;
        if (type === "Americas") {
            eventInfo = getAmericaTabEventInfo(type);
        } else if (type === "Africa") {
            eventInfo = getAfricaTabEventInfo(type);
        } else if (type === "Asia") {
            eventInfo = getAsiaTabEventInfo(type);
        } else if (type === "Australasia") {
            eventInfo = getAustralasiaTabEventInfo(type);
        } else if (type === "Middle East") {
            eventInfo = getMiddleEastTabEventInfo(type);
        } else if (type === "Europe") {
            eventInfo = getEuropeTabEventInfo(type);
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const getAmericaTabEventInfo = (type)=>{
        if (type === "Americas") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:americas",
                eventName: "country select:americas",
                eventType: "navigation",
                internalLinkName: "americas",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAfricaTabEventInfo = (type)=>{
        if (type === "Africa") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:africa",
                eventName: "country select:africa",
                eventType: "navigation",
                internalLinkName: "africa",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAsiaTabEventInfo = (type)=>{
        if (type === "Asia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:asia",
                eventName: "country select:asia",
                eventType: "navigation",
                internalLinkName: "asia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getAustralasiaTabEventInfo = (type)=>{
        if (type === "Australasia") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:australasia",
                eventName: "country select:australasia",
                eventType: "navigation",
                internalLinkName: "australasia",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getMiddleEastTabEventInfo = (type)=>{
        if (type === "Middle East") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:middle east",
                eventName: "country select:middle east",
                eventType: "navigation",
                internalLinkName: "middle east",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    const getEuropeTabEventInfo = (type)=>{
        if (type === "Europe") {
            return {
                clickInternalLinks: "true",
                eventAction: "country select:europe",
                eventName: "country select:europe",
                eventType: "navigation",
                internalLinkName: "europe",
                internalLinkPosition: "countryselector",
                internalLinkType: "global header : navigation",
                internalLinkZoneName: "global header",
                internalLinkURL: "n/a"
            };
        }
    };
    (0,react.useEffect)(()=>{
        if (winWidth <= 1200) {
            setActiveTab("");
        } else {
            setActiveTab("america");
        }
    }, [
        winWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CountryUtilNav_module_default()).countrySelectorMain,
        "data-testid": "countrySelectorSection",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "gbh_utheader",
            className: "gbh-countryselector ".concat(active ? "active" : ""),
            style: show ? {
                left: 0,
                display: "block"
            } : {
                display: "block"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gbh-tab",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            "data-testid": "countrySelectorSection_menu",
                            className: "gbh-close-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>{
                                toggleCountryNav(), setRegionNav(false);
                            },
                            children: "Menu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            role: "tablist",
                            "aria-multiselectable": "false",
                            className: "tablist",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "selection-bar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Americas"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "america",
                                        countryAreaValue: "Americas",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Africa"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "africa",
                                        countryAreaValue: "Africa",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Asia"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "asia",
                                        countryAreaValue: "Asia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Australasia"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "australia",
                                        countryAreaValue: "Australasia",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Middle East"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "middleEast",
                                        countryAreaValue: "Middle East",
                                        onclickVal: setActiveTab
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: ()=>addCountrySelectorAnalytics("Europe"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNavTabLink, {
                                        activeTab: activeTab,
                                        countryArea: "europe",
                                        countryAreaValue: "Europe",
                                        onclickVal: setActiveTab
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gbh-tab__panels",
                    style: winWidth <= 1200 && activeTab ? {
                        display: "block"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            className: "gbh-hamber-menu gbh-close icon-Close-Medium"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: "0",
                            className: "gbh-back-btn d-block d-lg-none pl-4 mb-2",
                            onClick: ()=>setActiveTab(""),
                            children: "Region"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "america",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.americasItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "africa",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.africaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "asia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.asiaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "australia",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.oceaniaItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "middleEast",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.middleEastItems,
                            datalayerPageName: datalayerPageName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilContainer, {
                            countryarea: "europe",
                            activeTab: activeTab,
                            title: countryselector === null || countryselector === void 0 ? void 0 : countryselector.title,
                            description: countryselector === null || countryselector === void 0 ? void 0 : countryselector.description,
                            countryselectorItems: countryselector === null || countryselector === void 0 ? void 0 : countryselector.europeItems,
                            datalayerPageName: datalayerPageName
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_CountryUtilNav = (CountryUtilNav);

// EXTERNAL MODULE: ./components/Shared/MiniCart/v1/MiniCart.jsx + 3 modules
var MiniCart = __webpack_require__(2901);
// EXTERNAL MODULE: ./src/components/Shared/index.module.scss
var index_module = __webpack_require__(24707);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss
var UtilityWidgets_module = __webpack_require__(84181);
var UtilityWidgets_module_default = /*#__PURE__*/__webpack_require__.n(UtilityWidgets_module);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/Shared/UtilityNavHeader.jsx


















const UtilityNavHeader = (param)=>{
    let { data , eventHandler  } = param;
    var ref, ref1, ref2, ref3;
    const router = (0,next_router.useRouter)();
    const { store: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  } , callbacks: { setRegionNav =()=>console.log("Event Not Defined") , setAuthNav =()=>console.log("Event Not Defined")  }  } = eventHandler;
    const [currentPagePath, setCurrentPagePath] = (0,react.useState)("/");
    const [findAStoreURL, setFindAStorURL] = (0,react.useState)(null);
    const [isBrandEnabled, setIsBrandEnabled] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (router.locale && router.pathname) {
            setCurrentPagePath("/" + router.locale + router.asPath);
        }
        const url = "/locations/find-a-store";
        setFindAStorURL(url);
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setIsBrandEnabled(get_default()(config, "general.isEnableBrand", ""));
        });
    }, []);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const { datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [findAStoreShow, setFindAStoreShow] = (0,react.useState)(false);
    const [findAStoreActive, setFindAStoreActive] = (0,react.useState)(false);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { favorites  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const [authNavShow, setAuthNavShow] = (0,react.useState)(false);
    const [authNavActive, setAuthNavActive] = (0,react.useState)(false);
    const [favoritesPage, setFavoritesPage] = (0,react.useState)([]);
    const [countryNavShow, setCountryNavShow] = (0,react.useState)(false);
    const [countryNavActive, setCountryNavActive] = (0,react.useState)(false);
    eventHandler.callbacks.toggleFindAStore = ()=>{
        setFindAStoreActive(false);
    };
    (0,react.useEffect)(()=>{
        if (findAStoreShow) {
            setFindAStoreActive(true);
        }
        if (authNavShow) {
            setAuthNavActive(true);
        }
        if (countryNavShow) {
            setCountryNavActive(true);
        }
    }, [
        findAStoreShow,
        authNavShow,
        countryNavShow
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getFavorites */._l)()).unwrap().then((rsp)=>{
                if (rsp && rsp !== null) {
                    setFavoritesPage(rsp.lineItems);
                } else {
                    setFavoritesPage([]);
                }
            });
        }
    }, [
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if ((favorites === null || favorites === void 0 ? void 0 : favorites.lineItems) && (favorites === null || favorites === void 0 ? void 0 : favorites.lineItems.length) > 0) {
            setFavoritesPage(favorites === null || favorites === void 0 ? void 0 : favorites.lineItems);
        } else {
            setFavoritesPage([]);
        }
    }, [
        favorites
    ]);
    (0,react.useEffect)(()=>{
        if (!findAStoreActive) {
            setTimeout(()=>{
                setFindAStoreShow(false);
            }, 1000);
        }
        if (!authNavActive) {
            setTimeout(()=>{
                setAuthNavShow(false);
            }, 1000);
        }
        if (!countryNavActive) {
            if (winWidth <= 1200) {
                setCountryNavShow(false);
            } else {
                setTimeout(()=>{
                    setCountryNavShow(false);
                }, 1000);
            }
        }
    }, [
        findAStoreActive,
        authNavActive,
        countryNavActive
    ]);
    const closeAuth = (0,es/* useSelector */.v9)((state)=>state.auth.closeAuth);
    (0,react.useEffect)(()=>{
        if (closeAuth === true && authNavShow) {
            toggleAuthNav();
            setAuthNavShow(false);
        }
    }, [
        closeAuth
    ]);
    const toggleFindAStore = ()=>{
        if (!findAStoreShow) {
            setFindAStoreShow(true);
            (0,helper.toggeleBodyScroll)(true);
        } else {
            setFindAStoreActive(false);
            (0,helper.toggeleBodyScroll)(false);
        }
    };
    const toggleAuthNav = ()=>{
        if (!authNavShow) {
            setAuthNavShow(true);
            (0,helper.toggeleBodyScroll)(true);
        } else {
            setAuthNavActive(false);
            (0,helper.toggeleBodyScroll)(false);
        }
    };
    const toggleCountryNav = ()=>{
        if (!countryNavActive) {
            setCountryNavShow(true);
            (0,helper.toggeleBodyScroll)(true);
        } else {
            setCountryNavActive(false);
            (0,helper.toggeleBodyScroll)(false);
        }
    };
    const clickEvent = (e)=>{
        if (!(0,helper.isElementExcluded)(e, [
            "header-container",
            "modal-popup",
            "auth-modal"
        ])) {
            setAuthNavActive(false);
            setFindAStoreActive(false);
            setCountryNavActive(false);
            (0,helper.toggeleBodyScroll)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (findAStoreActive) {
            setAuthNavActive(false);
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        findAStoreActive
    ]);
    (0,react.useEffect)(()=>{
        if (authNavActive) {
            setFindAStoreActive(false);
            setCountryNavActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        authNavActive
    ]);
    (0,react.useEffect)(()=>{
        if (countryNavActive) {
            setAuthNavActive(false);
            setFindAStoreActive(false);
            document.addEventListener("click", clickEvent);
        } else {
            document.removeEventListener("click", clickEvent);
        }
        return ()=>document.removeEventListener("click", clickEvent);
    }, [
        countryNavActive
    ]);
    const style = {
        display: "list-item"
    };
    const displayNone = {
        display: "none"
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = (e)=>{
        e.preventDefault();
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
        dispatch((0,authSlice/* setFavoritesLogin */.Up)());
    };
    const onAuthMenuClick = (payload)=>{
        setAuthNavActive(payload);
        setAuthNav(payload);
    };
    const isBrandOrTransact = (0,utils/* isBrandTransact */.AY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__findStore",
                                ...isOpen && !mainCategoryActive && !isRegionOpen && !isAuthNavOpen ? {
                                    style: style
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "button",
                                    tabIndex: "0",
                                    "aria-live": "polite",
                                    "aria-labelledby": "find-ada",
                                    className: "gbh-data-layer gbh-nav__findStore--link cmp-find-place",
                                    href: findAStoreURL ? findAStoreURL : "",
                                    "data-gbh-data-layer": '{"eventAction":"find a store","eventName":"find a store","eventType":"find a store","internalLinkName":"find a store","internalLinkPosition":"find a store","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    children: "Find a Store"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "country-ada",
                                style: displayNone,
                                children: [
                                    "Country Selector",
                                    " ",
                                    "India" || (0),
                                    " -",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "gbh-nav__region region_arrowdropdown",
                                id: "India".toLowerCase().split(" ").join("_") || (data === null || data === void 0 ? void 0 : data.country.toLowerCase().split(" ").join("_")),
                                ...isOpen && !mainCategoryActive ? {
                                    style: style
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        role: "button",
                                        tabIndex: "0",
                                        "aria-labelledby": "country-ada",
                                        "aria-expanded": countryNavActive,
                                        onClick: ()=>{
                                            setRegionNav(true);
                                            toggleCountryNav();
                                        },
                                        className: "gbh-data-layer gbh-nav__region--link active-country ".concat(countryNavActive ? "expand" : "", " "),
                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"n/a","internalLinkName":"'.concat((ref = "India" || (0)) === null || ref === void 0 ? void 0 : ref.toLowerCase(), " - ").concat((ref1 = "EN" || (0)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","eventName":"country select","internalLinkType":"global header : navigation","eventType":"click","eventAction":"country select"}'),
                                        children: [
                                            "India" || (0),
                                            " -",
                                            " ",
                                            "EN" || (0)
                                        ]
                                    }),
                                    ((ref2 = data[":items"]) === null || ref2 === void 0 ? void 0 : ref2.countryselector) && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CountryUtilNav, {
                                        show: countryNavShow,
                                        countryselector: (ref3 = data[":items"]) === null || ref3 === void 0 ? void 0 : ref3.countryselector,
                                        active: countryNavActive,
                                        eventHandler: eventHandler,
                                        toggleCountryNav: toggleCountryNav,
                                        datalayerPageName: datalayerPageName
                                    })
                                ]
                            }),
                            !isBrandOrTransact && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin",
                                ...isOpen && !mainCategoryActive && !isRegionOpen ? {
                                    style: style
                                } : {},
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthUtilityNav/* default */.Z, {
                                                show: authNavShow,
                                                active: authNavActive,
                                                toggleAuthNav: toggleAuthNav,
                                                setAuthNav: setAuthNav,
                                                onAuthMenuClick: onAuthMenuClick
                                            }),
                                            winWidth > 1200 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "wishlist-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: isAuth ? "/my-account/my-favorites" : currentPagePath,
                                                            "aria-label": "View your wishlist",
                                                            className: "gbh-data-layer",
                                                            "data-gbh-data-layer": '{"eventName":"wishlist icon","eventAction":"wishlist icon","internalLinkName":"wishlist","internalLinkType":"global header:wishlist","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header wishlist","eventMsg":"n/a","eventStatus":"n/a"}',
                                                            onClick: !isAuth && onClickSignIn,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                alt: "View your wishlist",
                                                                "aria-hidden": "true",
                                                                role: "presentation",
                                                                src: favoritesPage && favoritesPage.length > 0 ? "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTUgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbi9XaXNobGlzdDwvdGl0bGU+CiAgICA8ZyBpZD0iQjEtQ29tcGFyZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb24vV2lzaGxpc3QiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAtOC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgPHBhdGggZD0iTTguMTQwNjA3MTQsOS42ODg0ODE5NyBMNy41MDEsMTAuMzM0IEw2Ljg2MTU5MzY5LDkuNjg4NDgxOTcgQzUuMjkyNDIzNTIsOC4xMDM4MzkzNCAyLjc0NjI0NDc5LDguMTAzODM5MzQgMS4xNzcwNzQ2Myw5LjY4ODQ4MTk3IEMtMC4zNDg3ODE5NTgsMTEuMjI5MzgzOSAtMC4zOTYyNTE5NTksMTMuNzE4NTgzNCAxLjA2NDMyMjM2LDE1LjI5NzA0NDIgTDEuMTcwNzE4NTIsMTUuNDA4NTcwNyBMNy41MDExMTM0NCwyMS44MDE1MDMzIEwxMy44MDg0ODM5LDE1LjQzMjE5OTggTDEzLjkxNTE4NzgsMTUuMzIxMTQwOCBDMTUuMzk1NTk2OCwxMy43MjE3MTI1IDE1LjM1Mzk3MDMsMTEuMjMyNDAxIDEzLjgyNTEyNjIsOS42ODg0ODE5NyBDMTIuMjU1OTU2LDguMTAzODM5MzQgOS43MDk3NzczMSw4LjEwMzgzOTM0IDguMTQwNjA3MTQsOS42ODg0ODE5NyBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+" : "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4="
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "listitem",
                                                        className: "cart-indicator-widget",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* default */.Z, {
                                                            eventHandler: eventHandler,
                                                            source: "from desk"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_UtilityNavHeader = (UtilityNavHeader);

// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./public/icons/cart-icon-empty.svg
var cart_icon_empty = __webpack_require__(27644);
;// CONCATENATED MODULE: ./components/Shared/BrandHeaderFiller.jsx




const BrandHeaderFiller = ()=>{
    const avatarIcon = "/icons/avatar.svg";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).utilityNavHeaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitynavheader",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-utility-nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "gbh-utility-navbar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__findStore",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-live": "polite",
                                    "aria-labelledby": "find-ada",
                                    className: "gbh-nav__findStore--link cmp-find-place",
                                    children: "Find a Store"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__region region_arrowdropdown",
                                id: "united_states",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    role: "button",
                                    tabIndex: 0,
                                    "aria-labelledby": "country-ada",
                                    "aria-expanded": "false",
                                    className: "gbh-nav__region--link active-country ",
                                    children: "".concat("India", " -EN")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "gbh-nav__signin",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "UtilityWidgets_utilityWidgetsWrapper__Wz0ZS",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        role: "list",
                                        className: "utility-widgets utility-widgets__brand-switcher",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "auth-widget auth-widget__menu AuthUtilityNav_authUtilityNavWrapper__iJgYU",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "auth-nav",
                                                    "aria-expanded": "false",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            tabIndex: 0,
                                                            role: "button",
                                                            name: "avatarIcon",
                                                            "aria-label": "Sign In Collapsed",
                                                            src: avatarIcon,
                                                            alt: "Sign In"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "auth-nav__menu ",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "wishlist-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    "aria-label": "View your wishlist",
                                                    className: "gbh-data-layer",
                                                    href: "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        alt: "View your wishlist",
                                                        "aria-hidden": "true",
                                                        role: "presentation",
                                                        src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTRweCIgdmlld0JveD0iMCAwIDE1IDE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT5JY29uL1dpc2hsaXN0PC90aXRsZT4NCiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJCdXR0b24vSW1hZ2UtSWNvbnMvV2lzaGxpc3QtRW1wdHkvRGFyay1HcmF5LUJHIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEuMDAwMDAwLCAtMTEuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiI+DQogICAgICAgICAgICA8ZyBpZD0iSWNvbi9XaXNobGlzdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEuMDAwMDAwLCAzLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjE0MDYwNzE0LDkuNjg4NDgxOTcgTDcuNTAxLDEwLjMzNCBMNi44NjE1OTM2OSw5LjY4ODQ4MTk3IEM1LjI5MjQyMzUyLDguMTAzODM5MzQgMi43NDYyNDQ3OSw4LjEwMzgzOTM0IDEuMTc3MDc0NjMsOS42ODg0ODE5NyBDLTAuMzQ4NzgxOTU4LDExLjIyOTM4MzkgLTAuMzk2MjUxOTU5LDEzLjcxODU4MzQgMS4wNjQzMjIzNiwxNS4yOTcwNDQyIEwxLjE3MDcxODUyLDE1LjQwODU3MDcgTDcuNTAxMTEzNDQsMjEuODAxNTAzMyBMMTMuODA4NDgzOSwxNS40MzIxOTk4IEwxMy45MTUxODc4LDE1LjMyMTE0MDggQzE1LjM5NTU5NjgsMTMuNzIxNzEyNSAxNS4zNTM5NzAzLDExLjIzMjQwMSAxMy44MjUxMjYyLDkuNjg4NDgxOTcgQzEyLjI1NTk1Niw4LjEwMzgzOTM0IDkuNzA5Nzc3MzEsOC4xMDM4MzkzNCA4LjE0MDYwNzE0LDkuNjg4NDgxOTcgWiBNMTMuMTE0NTU4OSwxMC4zOTIxMTEzIEMxNC4yNjY2NjkyLDExLjU1NTU4MTYgMTQuMjk4MTAyMiwxMy40MzUzMTE1IDEzLjE4NzU0NTEsMTQuNjM1MjQ1MyBMMTMuMDkyNTIwMiwxNC43MzQxMDUzIEw3LjUwMSwyMC4zOCBMMS44ODc2NDE4OSwxNC43MTE0NzgzIEwxLjc5Mjk1NDA5LDE0LjYxMjE4MzEgQzAuNzAxOTMzNDQxLDEzLjQzMzAxMzYgMC43Mzc3ODAxMDEsMTEuNTUzMzExIDEuODg3NjQxODksMTAuMzkyMTExMyBDMy4wNjU1MDk0NSw5LjIwMjYyOTU4IDQuOTczMTU4ODcsOS4yMDI2Mjk1OCA2LjE1MTAyNjQyLDEwLjM5MjExMTMgTDcuNTAxMTAwNDIsMTEuNzU1NDk3NCBMOC44NTExNzQ0MSwxMC4zOTIxMTEzIEMxMC4wMjkwNDIsOS4yMDI2Mjk1OCAxMS45MzY2OTE0LDkuMjAyNjI5NTggMTMuMTE0NTU4OSwxMC4zOTIxMTEzIFoiIGlkPSJQYXRoIj48L3BhdGg+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4="
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "listitem",
                                                className: "cart-indicator-widget",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cart-indicator false",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        "aria-label": "View your cart containing 0 item",
                                                        role: "link",
                                                        className: "gbh-data-layer",
                                                        href: "/en/cart",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: cart_icon_empty/* default.src */.Z.src,
                                                            alt: "Cart"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_BrandHeaderFiller = (BrandHeaderFiller);

;// CONCATENATED MODULE: ./src/components/Shared/CheckoutUtilityNavheader.jsx


const CheckoutUtilityNavHeader = (param)=>{
    let { data , eventHandler  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            role: "listitem",
            className: "cart-indicator-widget__checkout",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* default */.Z, {
                checkoutPage: data === null || data === void 0 ? void 0 : data.linkCart,
                eventHandler: eventHandler,
                source: "from desk"
            })
        })
    });
};
/* harmony default export */ var CheckoutUtilityNavheader = (CheckoutUtilityNavHeader);

;// CONCATENATED MODULE: ./src/components/Shared/BrandHeader.jsx









const BrandHeader = (props)=>{
    const { data , eventHandler  } = props;
    const { datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const isSsr = (0,useIsSsr/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            if (key === "brand_switcher" || key === "brand_switcher_copy") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandSwitcher, {
                    data: item,
                    datalayerPageName: datalayerPageName
                }, key);
            }
            if (key === "utilitynavheader" || key === "utilitynavheader_v2") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeaderFiller, {}) : key === "utilitynavheader_v2" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutUtilityNavheader, {
                        data: item,
                        eventHandler: eventHandler
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_UtilityNavHeader, {
                        data: item,
                        eventHandler: eventHandler
                    })
                }, key);
            }
            return null;
        })
    });
};
/* harmony default export */ var Shared_BrandHeader = (BrandHeader);

;// CONCATENATED MODULE: ./public/icons/BLOK_LOGO.svg
/* harmony default export */ var BLOK_LOGO = ({"src":"/_next/static/media/BLOK_LOGO.00edf835.svg","height":35,"width":115});
;// CONCATENATED MODULE: ./components/Shared/HeaderNavLogo.jsx






const HeaderNavLogo = (props)=>{
    const { data , columnClassNames , eventHandler: { store: { brandLogoImg =""  } = {} , callbacks: { setBrandLogoImg =()=>console.log("Event Not Defined") , toggleMenu =()=>console.log("Event Not Defined")  } = {}  } = {} , isOmnichannel =false , omniQRParams ={} , isQrService =false  } = props;
    (0,react.useEffect)(()=>{
        var ref, ref1;
        if ((data === null || data === void 0 ? void 0 : (ref = data.dataLayer) === null || ref === void 0 ? void 0 : ref[data === null || data === void 0 ? void 0 : data.id]) && ((ref1 = data === null || data === void 0 ? void 0 : data.dataLayer[data === null || data === void 0 ? void 0 : data.id]) === null || ref1 === void 0 ? void 0 : ref1.image)) {
            var ref2;
            const brandLogoPath = (ref2 = data === null || data === void 0 ? void 0 : data.dataLayer[data === null || data === void 0 ? void 0 : data.id]) === null || ref2 === void 0 ? void 0 : ref2.image["repo:path"];
            brandLogoPath && setBrandLogoImg(constants.authorBaseUrl + brandLogoPath);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        setBrandLogoImg(BLOK_LOGO === null || BLOK_LOGO === void 0 ? void 0 : BLOK_LOGO.src);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isOmnichannel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "gbh-hamber-menu icon-Hamburger",
                tabIndex: "0",
                "aria-label": "Hamburger-menu",
                role: "button",
                onClick: toggleMenu
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp cmp-image ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    // coming from AEM
                    href: (0,utils/* getOmniLogoCondnlLink */.Qf)(data, isOmnichannel, omniQRParams, isQrService),
                    title: data === null || data === void 0 ? void 0 : data.alt,
                    className: "cmp-image--link",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: BLOK_LOGO.src,
                            alt: data === null || data === void 0 ? void 0 : data.alt
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_HeaderNavLogo = (HeaderNavLogo);

// EXTERNAL MODULE: ./components/core/Image/DynamicImage.jsx
var DynamicImage = __webpack_require__(18377);
// EXTERNAL MODULE: ./src/hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83839);
;// CONCATENATED MODULE: ./components/Shared/ProductsNavTab.jsx










const ProductsNavTab = (props)=>{
    const { navOpen , setNavOpen , productNavigationItems , onClickNav , eventHandler: { store: { isOpen  }  } , datalayerPageName , selectedTab , hideMobImages , showMobileImages , panelTitle  } = props;
    const { locale , asPath  } = (0,next_router.useRouter)();
    const routerAsPath = "/" + locale + asPath;
    const [activeMainCategory, setActiveMainCategory] = (0,react.useState)("");
    const [activeSubCategory, setActiveSubCategory] = (0,react.useState)("");
    const isSsr = (0,useIsSsr/* default */.Z)();
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const onHoverMainCategory = (name)=>{
        setActiveMainCategory(name);
    };
    const onHoverSubCategory = (name)=>{
        setActiveSubCategory(name);
    };
    (0,react.useEffect)(()=>{
        if (!isOpen || !navOpen) {
            setActiveSubCategory("");
            setActiveMainCategory("");
        }
    }, [
        isOpen,
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        if (productNavigationItems && activeMainCategory) {
            productNavigationItems.map((mainCategory, i)=>{
                if ((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory) {
                    const subCategoryDetails = mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails;
                    if (subCategoryDetails) {
                        var ref;
                        const childItem = (subCategoryDetails === null || subCategoryDetails === void 0 ? void 0 : (ref = subCategoryDetails.childItems) === null || ref === void 0 ? void 0 : ref[0]) || null;
                        if (childItem) {
                            const activeSubCategory = (childItem === null || childItem === void 0 ? void 0 : childItem.subCategory) || null;
                            if (activeSubCategory) {
                                setActiveSubCategory(activeSubCategory);
                            }
                        }
                    }
                }
            });
        }
    }, [
        activeMainCategory,
        productNavigationItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "tabpanel",
        tabIndex: "-1",
        className: "cmp-tabs__tabpanel ".concat(navOpen === panelTitle ? "cmp-tabs__tabpanel--active" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(constants.staticClasses.CONTAINER),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "globalnavigation aem-GridColumn aem-GridColumn--default--12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-product-menu ".concat(hideMobImages ? "hide-mobile-images" : "", " ").concat(navOpen === panelTitle ? "open" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "gbh-pro-menu__inner",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "flex-column gbh-pro-menu__list nav",
                                            role: "tablist",
                                            "aria-label": "list of 6",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "gbh-mob-back-btn",
                                                    onClick: ()=>onClickNav({
                                                            "cq:panelTitle": navOpen
                                                        }),
                                                    children: "Menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "global-menu-selected",
                                                    children: navOpen
                                                }),
                                                productNavigationItems && productNavigationItems.map((item, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "nav-item",
                                                        "data-tab": item === null || item === void 0 ? void 0 : item.categoryName,
                                                        role: "tab",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onMouseOver: ()=>{
                                                                return onHoverMainCategory(!(!(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink)) ? item === null || item === void 0 ? void 0 : item.categoryName : "");
                                                            },
                                                            className: "gbh-data-layer nav-link ".concat((item === null || item === void 0 ? void 0 : item.categoryName) === activeMainCategory ? "link-active" : ""),
                                                            "aria-hidden": "false",
                                                            "aria-label": item === null || item === void 0 ? void 0 : item.categoryName,
                                                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"","internalLinkName":"products > '.concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase(), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                            "data-hover": "tab",
                                                            "data-target": "#submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                            "aria-controls": "submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                            rel: "noreferrer",
                                                            role: "tab",
                                                            tabIndex: "0",
                                                            href: !(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink) ? (0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.categoryLink) : null,
                                                            "aria-selected": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                            "aria-expanded": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : item.categoryName)
                                                            }
                                                        })
                                                    }, "productNavigation-".concat(index));
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tab-content gbh-pro-menu__cont",
                                            children: productNavigationItems && productNavigationItems.map((mainCategory, i)=>{
                                                var ref, ref1, ref2, ref3;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tab-pane fade ".concat((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory ? "active show" : ""),
                                                    role: "tabpanel",
                                                    "aria-labelledby": mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cmp-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "aem-Grid aem-Grid--12 aem-Grid--default--12 ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "globalnavigation-subcategory aem-GridColumn aem-GridColumn--default--12",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                        className: "nav gbh-pro-collection gbh-two-column",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                className: "gbh-mob-back-btn",
                                                                                onClick: ()=>onHoverMainCategory(""),
                                                                                children: "Products"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "global-menu-selected sub-cat-select",
                                                                                children: mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName
                                                                            }),
                                                                            (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.childItems) === null || ref1 === void 0 ? void 0 : ref1.map((subCategory, j)=>{
                                                                                var ref;
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    className: "nav-item gbh-pro-collection__category-link",
                                                                                    onMouseOver: ()=>{
                                                                                        return onHoverSubCategory(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory);
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        "data-purelink": "true",
                                                                                        href: (0,helper.removeAndCleanLinkConcat)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                        className: "gbh-data-layer nav-link",
                                                                                        id: "pills-".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.split(" ").join("-"), "-").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), "-tab"),
                                                                                        "aria-hidden": "false",
                                                                                        "aria-label": "tab ".concat(j, " of ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : ref.childItems.length, " Collections"),
                                                                                        "data-hover": "tab",
                                                                                        tabIndex: "0",
                                                                                        target: "_self",
                                                                                        "data-target": "#".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")).concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-")),
                                                                                        role: "link",
                                                                                        "aria-controls": "pills-".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")),
                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat((0,helper.removeAndCleanLinkConcat)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" ').concat(selectedTab, " > ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "nav-link",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                }, "subCategory-".concat(j));
                                                                            }))
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "tab-content gbh-pro-collection-cont gbh-two-column",
                                                                        children: (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref2 = mainCategory.subCategoryDetails) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.childItems) === null || ref3 === void 0 ? void 0 : ref3.map((subCategory, j)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "tab-pane fade gbh-mob-col ".concat((subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory) === activeSubCategory ? "active show" : ""),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    href: (0,helper.removeAndCleanLinkConcat)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                    className: "gbh-data-layer",
                                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat((0,helper.removeAndCleanLinkConcat)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" > ').concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "hello gbh-subcattext",
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                            }
                                                                                        }),
                                                                                        showMobileImages && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "cmp-image",
                                                                                            children: [
                                                                                                smartCrop.scriptStatus && !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage/* default */.Z, {
                                                                                                    imgUrl: subCategory === null || subCategory === void 0 ? void 0 : subCategory.sceneSevenImage,
                                                                                                    alt: subCategory === null || subCategory === void 0 ? void 0 : subCategory.imageAlt,
                                                                                                    className: "cmp-image__image with-crop",
                                                                                                    uniqueId: "subcatImage-".concat(j)
                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                    src: subCategory === null || subCategory === void 0 ? void 0 : subCategory.sceneSevenImage,
                                                                                                    alt: subCategory === null || subCategory === void 0 ? void 0 : subCategory.imageAlt,
                                                                                                    className: "cmp-image__image without-crop"
                                                                                                }, "subcatImage-".concat(j)),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    dangerouslySetInnerHTML: {
                                                                                                        __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.description)
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, "subcatInfo-".concat(j));
                                                                        }))
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }, "mainCategory-".concat(i));
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "gbh-promenu-close-btn icon-Close-Large",
                                            "aria-label": "close",
                                            role: "button",
                                            tabIndex: "0",
                                            onClick: ()=>{
                                                setNavOpen("");
                                                setActiveMainCategory("");
                                                setActiveSubCategory();
                                                (0,helper.preventBodyScrollTab)(false);
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "productbg ".concat(navOpen === panelTitle ? "open" : "")
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_ProductsNavTab = (ProductsNavTab);

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs.jsx









const HeaderNavTabs = (props)=>{
    const { data , columnClassNames , eventHandler , eventHandler: { store: { isOpen  } , callbacks: { toggleMenu =()=>console.log("Event Not Defined") , setMainCategory =()=>console.log("Event Not Defined")  }  }  } = props;
    const { datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const [selectedTab, setTab] = (0,react.useState)("");
    const menuVisible = (0,react.useRef)(0);
    const dataRecursion = (0,react.useCallback)((data)=>{
        if (data && data[":itemsOrder"]) {
            data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                return dataRecursion(item);
            });
        }
    }, []);
    const onClickNav = (data)=>{
        if (selectedTab !== data["cq:panelTitle"]) {
            setTab(data["cq:panelTitle"]);
        }
        if (navOpen !== data["cq:panelTitle"]) {
            setNavOpen(data["cq:panelTitle"]);
            if (!lib/* isMobile */.tq) {
                setNavOpen(data["cq:panelTitle"]);
            }
            setMainCategory({
                item: data["cq:panelTitle"]
            });
            menuVisible.current = 1;
            (0,helper.preventBodyScrollTab)(true);
            addHeaderNavTabAnalytics(data);
        } else {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper.preventBodyScrollTab)(false);
        }
    };
    const addHeaderNavTabAnalytics = (data)=>{
        const eventInfo = {
            eventAction: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventName: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventType: "tab",
            internalLinkName: data["cq:panelTitle"].toLowerCase(),
            internalLinkPosition: "global header",
            internalLinkType: "global navigation",
            internalLinkZoneName: "global header",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const onMenuClickEvent = (e)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("gbh-pro-menu__inner")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".gbh-pro-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".gbh-full-w-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".cmp-tabs__tablist")) === null && !lib/* isMobile */.tq) && menuVisible.current) {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper.preventBodyScrollTab)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (navOpen) {
            document.addEventListener("click", onMenuClickEvent);
        } else {
            document.removeEventListener("click", onMenuClickEvent);
        }
        return ()=>document.removeEventListener("click", onMenuClickEvent);
    }, [
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : "", " ").concat(isOpen ? "open" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-tabs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                    "aria-label": "close button",
                    tabIndex: "0",
                    onClick: ()=>{
                        toggleMenu(), onClickNav({
                            "cq:panelTitle": navOpen
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    role: "tablist",
                    className: "cmp-tabs__tablist",
                    "aria-multiselectable": "false",
                    children: [
                        data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                            const item = data[":items"][key];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab ".concat(selectedTab == item["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                tabIndex: "0",
                                onMouseEnter: ()=>setTimeout(()=>onClickNav(item), 1000),
                                children: item["cq:panelTitle"]
                            }, "navItem-".concat(index));
                        }),
                        (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab",
                                tabIndex: "0",
                                children: key
                            }, "navItem-".concat(index));
                        })
                    ]
                }),
                data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                    var ref, ref1;
                    const items = data[":items"][key];
                    var ref2;
                    const item = (ref2 = (ref = items[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation) !== null && ref2 !== void 0 ? ref2 : (ref1 = items[":items"]) === null || ref1 === void 0 ? void 0 : ref1.globalnavigation_cop;
                    if ((item === null || item === void 0 ? void 0 : item.mainNavigation) === "Products") {
                        // Rendered per-tab (not gated behind pageIsInteractive/hover) so
                        // category & sub-category links are present in the initial HTML for crawlers.
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ProductsNavTab, {
                            productNavigationItems: item === null || item === void 0 ? void 0 : item.categoryItems,
                            navOpen: navOpen,
                            panelTitle: items["cq:panelTitle"],
                            setNavOpen: (data)=>setNavOpen(data),
                            onClickNav: onClickNav,
                            isOpen: isOpen,
                            eventHandler: eventHandler,
                            datalayerPageName: datalayerPageName,
                            selectedTab: items["cq:panelTitle"],
                            hideMobImages: item === null || item === void 0 ? void 0 : item.hideMobileImages,
                            showMobileImages: !(lib/* isMobile */.tq && (item === null || item === void 0 ? void 0 : item.hideMobileImages))
                        }, "navTabs-".concat(index));
                    }
                    if ((item === null || item === void 0 ? void 0 : item.mainNavigation) === "drawer") {
                        var ref3, ref4, ref5, ref6;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "tabpanel",
                            tabIndex: "-1",
                            className: "cmp-tabs__tabpanel ".concat(navOpen === items["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(constants.staticClasses.CONTAINER),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "globalnavigation aem-GridColumn aem-GridColumn--default--11",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "gbh-full-w-menu",
                                                    style: {
                                                        transition: "none 0s ease 0s"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "bg-dim",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "gbh-full-w-menu__inner",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "gbh-full-max-width",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__left-cont",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "gbh-full-w-menu__left-cont__top",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "gbh-full-w-menu__left-cont__top__cont",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.mainTitle)
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "gbh-full-w-menu__left-cont__description",
                                                                                            style: {
                                                                                                transition: "none 0s ease 0s"
                                                                                            },
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.description)
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                    className: "nav flex-column gbh-full-w-menu__left-cont__menu-list",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                            className: "gbh-mob-back-btn",
                                                                                            onClick: ()=>onClickNav({
                                                                                                    "cq:panelTitle": navOpen
                                                                                                }),
                                                                                            children: "Menu"
                                                                                        }),
                                                                                        item === null || item === void 0 ? void 0 : (ref3 = item.drawerItems) === null || ref3 === void 0 ? void 0 : ref3.map((navItem, index)=>{
                                                                                            var ref;
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                className: "nav-item ",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                    className: "gbh-data-layer nav-link".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? " extranal-sub-nav" : "", " "),
                                                                                                    target: "".concat(navItem.newTab ? "_blank" : "_self"),
                                                                                                    href: (0,helper.removeAndCleanLinkConcat)(navItem === null || navItem === void 0 ? void 0 : navItem.subNavLink),
                                                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "false" : "true", '","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"').concat((0,helper.getAnalyticLinkUrl)((0,helper.removeAndCleanLinkConcat)(navItem === null || navItem === void 0 ? void 0 : navItem.subNavLink)), '","internalLinkName":"').concat((ref = items["cq:panelTitle"]) === null || ref === void 0 ? void 0 : ref.toLowerCase(), " > ").concat(navItem === null || navItem === void 0 ? void 0 : navItem.subNavName.toLowerCase(), '","eventName":"main dropdown  menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                                    rel: "".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "noreferrer" : ""),
                                                                                                    "data-hover": "tab",
                                                                                                    role: "link",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            dangerouslySetInnerHTML: {
                                                                                                                __html: browser_default().sanitize(navItem.subNavName)
                                                                                                            }
                                                                                                        }),
                                                                                                        (navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "sub-cat-img",
                                                                                                            children: (item === null || item === void 0 ? void 0 : item.externalIconCheckbox) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                src: item === null || item === void 0 ? void 0 : item.externalIcon,
                                                                                                                alt: "external link",
                                                                                                                href: navItem.subNavLink
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }, "navItem-".concat(index));
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__right-img",
                                                                        children: (item === null || item === void 0 ? void 0 : (ref4 = item.drawerImage) === null || ref4 === void 0 ? void 0 : ref4.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: item === null || item === void 0 ? void 0 : (ref5 = item.drawerImage) === null || ref5 === void 0 ? void 0 : ref5.imageUrl,
                                                                            className: "cmp-image__image",
                                                                            alt: item === null || item === void 0 ? void 0 : (ref6 = item.drawerImage) === null || ref6 === void 0 ? void 0 : ref6.imageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "productbg"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }, "navTabs-".concat(index));
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var Shared_HeaderNavTabs = (HeaderNavTabs);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabsLoader.jsx





const HeaderNavTabsLoader = (props)=>{
    const { data , columnClassNames , eventHandler  } = props;
    const selectedTab = "Bathroom";
    const dataRecursion = (0,react.useCallback)((data)=>{
        if (data && data[":itemsOrder"]) {
            data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                return dataRecursion(item);
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    const getCategoryHref = (item)=>{
        if (!(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink)) {
            return (0,helper.removeAndCleanLinkConcat)(item.categoryLink);
        }
        return (item === null || item === void 0 ? void 0 : item.categoryName) ? "/".concat(item.categoryName.toLowerCase().split(" ").join("-")) : "";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-tabs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                    "aria-label": "close button",
                    tabIndex: "0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    role: "tablist",
                    className: "cmp-tabs__tablist",
                    "aria-multiselectable": "false",
                    children: [
                        data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                            const item = data[":items"][key];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab ",
                                tabIndex: "0",
                                children: item["cq:panelTitle"]
                            }, "navItem-".concat(index));
                        }),
                        (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab",
                                tabIndex: "0",
                                children: key
                            }, "navItem-".concat(index));
                        })
                    ]
                }),
                data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                    var ref, ref1;
                    const items = data[":items"][key];
                    const item = ((ref = items[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation) || ((ref1 = items[":items"]) === null || ref1 === void 0 ? void 0 : ref1.globalnavigation_cop);
                    const categoryItems = item === null || item === void 0 ? void 0 : item.categoryItems;
                    if ((item === null || item === void 0 ? void 0 : item.mainNavigation) === "drawer") {
                        var ref2, ref3, ref4, ref5;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "tabpanel",
                            tabIndex: "-1",
                            className: "cmp-tabs__tabpanel",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(constants.staticClasses.CONTAINER),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "globalnavigation aem-GridColumn aem-GridColumn--default--11",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "gbh-full-w-menu",
                                                    style: {
                                                        transition: "all 2s ease 0s"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "bg-dim",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "gbh-full-w-menu__inner",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "gbh-full-max-width",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__left-cont",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "gbh-full-w-menu__left-cont__top",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "gbh-full-w-menu__left-cont__top__cont",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.mainTitle)
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "gbh-full-w-menu__left-cont__description",
                                                                                            style: {
                                                                                                transition: "none 0s ease 0s"
                                                                                            },
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.description)
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                    className: "nav flex-column gbh-full-w-menu__left-cont__menu-list",
                                                                                    children: item === null || item === void 0 ? void 0 : (ref2 = item.drawerItems) === null || ref2 === void 0 ? void 0 : ref2.map((navItem, index)=>{
                                                                                        var ref;
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                            className: "nav-item ",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                className: "gbh-data-layer nav-link".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? " extranal-sub-nav" : "", " "),
                                                                                                target: "".concat(navItem.newTab ? "_blank" : "_self"),
                                                                                                href: (0,helper.removeAndCleanLinkConcat)(navItem === null || navItem === void 0 ? void 0 : navItem.subNavLink),
                                                                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "false" : "true", '","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"').concat((0,helper.getAnalyticLinkUrl)((0,helper.removeAndCleanLinkConcat)(navItem === null || navItem === void 0 ? void 0 : navItem.subNavLink)), '","internalLinkName":"').concat((ref = items["cq:panelTitle"]) === null || ref === void 0 ? void 0 : ref.toLowerCase(), " > ").concat(navItem === null || navItem === void 0 ? void 0 : navItem.subNavName.toLowerCase(), '","eventName":"main dropdown  menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                                rel: "".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "noreferrer" : ""),
                                                                                                "data-hover": "tab",
                                                                                                role: "link",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                        dangerouslySetInnerHTML: {
                                                                                                            __html: browser_default().sanitize(navItem.subNavName)
                                                                                                        }
                                                                                                    }),
                                                                                                    (navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: "sub-cat-img",
                                                                                                        children: (item === null || item === void 0 ? void 0 : item.externalIconCheckbox) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                            src: item === null || item === void 0 ? void 0 : item.externalIcon,
                                                                                                            alt: "external link",
                                                                                                            href: navItem.subNavLink
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }, "navItem-".concat(index));
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__right-img",
                                                                        children: (item === null || item === void 0 ? void 0 : (ref3 = item.drawerImage) === null || ref3 === void 0 ? void 0 : ref3.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: item === null || item === void 0 ? void 0 : (ref4 = item.drawerImage) === null || ref4 === void 0 ? void 0 : ref4.imageUrl,
                                                                            className: "cmp-image__image",
                                                                            alt: item === null || item === void 0 ? void 0 : (ref5 = item.drawerImage) === null || ref5 === void 0 ? void 0 : ref5.imageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "productbg"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }, "navTabs-".concat(index));
                    } else if (categoryItems) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "tabpanel",
                            tabIndex: "-1",
                            className: "cmp-tabs__tabpanel",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(constants.staticClasses.CONTAINER),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "globalnavigation aem-GridColumn aem-GridColumn--default--12",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "gbh-product-menu",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "gbh-pro-menu__inner",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                className: "flex-column gbh-pro-menu__list nav",
                                                                role: "tablist",
                                                                "aria-label": "list of 6",
                                                                tabIndex: "0",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "gbh-mob-back-btn",
                                                                        children: "Menu"
                                                                    }),
                                                                    categoryItems && categoryItems.map((item, index)=>{
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            className: "nav-item",
                                                                            "data-tab": item === null || item === void 0 ? void 0 : item.categoryName,
                                                                            role: "tab",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                className: "gbh-data-layer nav-link ",
                                                                                "aria-hidden": "false",
                                                                                "aria-label": item === null || item === void 0 ? void 0 : item.categoryName,
                                                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"","internalLinkName":"products > '.concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase(), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                "data-hover": "tab",
                                                                                "data-target": "#submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                                                "aria-controls": "submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                                                rel: "noreferrer",
                                                                                role: "tab",
                                                                                tabIndex: "0",
                                                                                href: getCategoryHref(item),
                                                                                "aria-selected": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                                                "aria-expanded": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : item.categoryName)
                                                                                }
                                                                            })
                                                                        }, "productNavigation-".concat(index));
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "tab-content gbh-pro-menu__cont",
                                                                children: categoryItems && categoryItems.map((mainCategory, i)=>{
                                                                    var ref, ref1, ref2, ref3;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "tab-pane fade ",
                                                                        role: "tabpanel",
                                                                        "aria-labelledby": mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "cmp-container",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "aem-Grid aem-Grid--12 aem-Grid--default--12 ",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "globalnavigation-subcategory aem-GridColumn aem-GridColumn--default--12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                            className: "nav gbh-pro-collection gbh-two-column",
                                                                                            children: (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.childItems) === null || ref1 === void 0 ? void 0 : ref1.map((subCategory, j)=>{
                                                                                                var ref;
                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                    className: "nav-item gbh-pro-collection__category-link",
                                                                                                    onMouseOver: ()=>{
                                                                                                        return onHoverSubCategory(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory);
                                                                                                    },
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                        "data-purelink": "true",
                                                                                                        href: (0,helper.removeAndCleanLinkConcat)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                                        className: "gbh-data-layer nav-link",
                                                                                                        id: "pills-".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.split(" ").join("-"), "-").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), "-tab"),
                                                                                                        "aria-hidden": "false",
                                                                                                        "aria-label": "tab ".concat(j, " of ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : ref.childItems.length, " Collections"),
                                                                                                        "data-hover": "tab",
                                                                                                        tabIndex: "0",
                                                                                                        target: "_self",
                                                                                                        "data-target": "#".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")).concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-")),
                                                                                                        role: "link",
                                                                                                        "aria-controls": "pills-".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")),
                                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat((0,helper.removeAndCleanLinkConcat)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" ').concat(selectedTab, " > ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            className: "nav-link",
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                dangerouslySetInnerHTML: {
                                                                                                                    __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                                                }
                                                                                                            })
                                                                                                        })
                                                                                                    })
                                                                                                }, "subCategory-".concat(j));
                                                                                            }))
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "tab-content gbh-pro-collection-cont gbh-two-column",
                                                                                            children: (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref2 = mainCategory.subCategoryDetails) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.childItems) === null || ref3 === void 0 ? void 0 : ref3.map((subCategory, j)=>{
                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    className: "tab-pane fade gbh-mob-col ",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                        href: (0,helper.removeAndCleanLinkConcat)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                                        className: "gbh-data-layer",
                                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat((0,helper.removeAndCleanLinkConcat)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" > ').concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}')
                                                                                                    })
                                                                                                }, "subcatInfo-".concat(j));
                                                                                            }))
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    }, "mainCategory-".concat(i));
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "gbh-promenu-close-btn icon-Close-Large",
                                                                "aria-label": "close",
                                                                role: "button",
                                                                tabIndex: "0"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "productbg"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        });
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var Shared_HeaderNavTabsLoader = (HeaderNavTabsLoader);

;// CONCATENATED MODULE: ./components/Shared/HeaderNav.jsx






const UtilityWidgets = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5938).then(__webpack_require__.bind(__webpack_require__, 55938)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(55938)
            ]
    },
    ssr: false
});
const UtilityWidgetsLoader = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5982).then(__webpack_require__.bind(__webpack_require__, 35982)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(35982)
            ]
    },
    ssr: false
});






const HeaderNav = (props)=>{
    var ref;
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data , eventHandler , isOmnichannel =false , omniQRParams ={} , isQrService =false  } = props;
    const utilityWidgets = (ref = data[":items"]) === null || ref === void 0 ? void 0 : ref.utilitywidgets;
    const toggleMenu = ()=>{
        isOpen ? dispatch((0,genericSlice/* closeMenu */.Wj)()) : dispatch((0,genericSlice/* openMenu */.qn)());
    };
    const [scrollDir, setScrollDir] = (0,react.useState)("scrolling down");
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;
        const updateScrollDir = ()=>{
            const scrollY = window.pageYOffset;
            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            if (!document.body.classList.contains("gbh-of-scroll")) setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
            lastScrollY = scrollY > 0 ? scrollY : 1;
            ticking = false;
            setLastScrollY(lastScrollY);
        };
        const onScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };
        const onScrollThrottle = throttle_default()(onScroll, 1000);
        if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/checkout") {
            window.removeEventListener("scroll", onScrollThrottle);
            window.addEventListener("scroll", onScrollThrottle);
        }
        return ()=>window.removeEventListener("scroll", onScrollThrottle);
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        if (scrollDir === "scrolling down") {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-plp-listing", "nav-down", "nav-up");
            (0,utils/* alterClass */.bU)("sticky-pdp-page", "stick-down", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-checkout-page", "stick-down", "nav-down");
        } else if (scrollDir === "scrolling up") {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-plp-listing", "nav-up", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-pdp-page", "stick-down", "nav-down");
            (0,utils/* alterClass */.bU)("sticky-checkout-page", "stick-down", "nav-down");
        } else return;
    }, [
        scrollDir,
        lastScrollY
    ]);
    (0,react.useEffect)(()=>{
        if (lastScrollY < 200) {
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", null, "nav-down");
            (0,utils/* alterClass */.bU)("gbh-header-logo-menu", null, "nav-up");
        }
    }, [
        lastScrollY,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(data === null || data === void 0 ? void 0 : data.gridClassNames),
        children: data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            if (key.includes("image")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavLogo, {
                    data: item.imageComponentProperties ? item.imageComponentProperties : item,
                    columnClassNames: "".concat(data.columnClassNames[key]),
                    eventHandler: eventHandler,
                    isOmnichannel: isOmnichannel,
                    omniQRParams: omniQRParams,
                    isQrService: isQrService
                }, "logo-".concat(index));
            }
            if (key === "tabs") {
                if (!isSsr) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavTabs, {
                    data: item,
                    columnClassNames: "".concat(data.columnClassNames[key]),
                    isOpen: isOpen,
                    toggleMenu: toggleMenu,
                    eventHandler: eventHandler
                }, "tabs-".concat(index));
                else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavTabsLoader, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler
                    }, "tabs-".concat(index));
                }
            }
            if (key === "utilitywidgets") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgets, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        eventHandler: eventHandler,
                        utilityWidgets: utilityWidgets
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityWidgetsLoader, {})
                }, "utilitywidgets-".concat(index));
            }
            return null;
        })
    });
};
/* harmony default export */ var Shared_HeaderNav = (HeaderNav);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./components/Default/Video/videoAnalytics.js


let analyticsTimer;
const pushClickEvent = (eventInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    if (isEmpty_default()(page)) {
        analyticsTimer = setTimeout(()=>pushClickEvent(eventInfo), 500);
        return;
    }
    if (analyticsTimer) {
        clearTimeout(analyticsTimer);
    }
    Object.keys(eventInfo).forEach((key)=>{
        if (eventInfo[key].includes(":rm")) {
            let _eventInfo$key;
            eventInfo[key] = (_eventInfo$key = eventInfo[key]) === null || _eventInfo$key === void 0 ? void 0 : _eventInfo$key.replace(/:rm/g, "");
        }
    });
    if (eventInfo) {
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo: eventInfo,
            page: page
        });
    }
};
const videoAnalytics_getComponentZone = (element)=>{
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className === "cmp-container");
    const zoneName = container.getAttribute("id");
    if (zoneName) {
        return zoneName.toLowerCase().replaceAll("-", " ");
    } else {
        return "";
    }
};
const playVideoDatalayer = (element, video, setFavVideoIdCb, videoModalClose)=>{
    const container = (0,utils/* closest */.oq)(element, (el)=>el.className.includes("cmp-teaser__image"));
    const nearestDatalayerAttribute = container === null || container === void 0 ? void 0 : container.getAttribute("data-gbh-data-layer");
    const videoIdAttribute = video;
    const jsonObject = JSON.parse(nearestDatalayerAttribute.replaceAll(/(\r\n|\n|\r)/gm, ""));
    jsonObject["internalLinkZoneName"] = window.eventPageType + ":" + videoAnalytics_getComponentZone(element);
    jsonObject["eventName"] = jsonObject["eventName"].replaceAll("zoneForVideo", videoAnalytics_getComponentZone(element));
    // splitting video id from URL
    const splitVideoId = decodeURI(videoIdAttribute).split("PAWEB/")[1];
    if (videoIdAttribute && undefined !== splitVideoId && null !== splitVideoId) {
        jsonObject["videoId"] = splitVideoId.toLowerCase();
        const favVideoId = splitVideoId.toLowerCase();
        setFavVideoIdCb && setFavVideoIdCb(favVideoId);
    }
    // condition to check when the video ends
    if (videoModalClose) {
        const { eventName =""  } = jsonObject;
        const closeEvent = "".concat(eventName, ":close");
        const videoJsonObject = {
            ...jsonObject,
            eventAction: closeEvent,
            eventName: closeEvent,
            internalLinkName: "close",
            internalLinkType: window.eventPageType + ":" + "close"
        };
        pushClickEvent(videoJsonObject);
    } else {
        if (element.ended) {
            jsonObject["internalLinkName"] = "video complete";
            jsonObject["eventName"] = jsonObject["eventAction"] = jsonObject["eventName"] + ":" + "video complete";
        } else {
            jsonObject["eventName"] = jsonObject["eventAction"] = jsonObject["eventName"] + ":" + "video play";
        }
        pushClickEvent(jsonObject);
    }
};

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/hooks/useScreenOrientation.js



/**
 *
 * @return {String}
 */ const useScreenOrientation = ()=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [orientation, setOrientation] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const getOrientation = ()=>{
            var ref, ref1;
            return (ref = window.screen) === null || ref === void 0 ? void 0 : (ref1 = ref.orientation) === null || ref1 === void 0 ? void 0 : ref1.type;
        };
        setOrientation(getOrientation());
        const updateOrientation = debounce_default()(()=>{
            setOrientation(getOrientation());
        }, 300);
        if (!isSsr) {
            window.addEventListener("resize", updateOrientation);
        }
        return ()=>{
            window.removeEventListener("resize", updateOrientation);
        };
    }, [
        isSsr
    ]);
    return orientation;
};
/* harmony default export */ var hooks_useScreenOrientation = (useScreenOrientation);

// EXTERNAL MODULE: ./src/constants/regex.js
var regex = __webpack_require__(71990);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/analytics.js


const getEventInfo = function() {
    let pageType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", mainTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventLabel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", eventType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", zone = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", parseJson = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    const zoneName = zone ? zone === null || zone === void 0 ? void 0 : zone.replace(regex/* SPECIAL_CHAR_REGEX */.FU, " ") : "zone";
    let internalLinkType = "";
    if (eventLabel === "print") {
        internalLinkType = "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":print");
    } else {
        internalLinkType = "".concat(dataLayerLinkType);
    }
    const internalLinkZoneName = zone ? "".concat(pageType.toLowerCase(), ":").concat(zoneName) : "teaser";
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
        internalLinkZoneName,
        internalLinkURL: "n/a",
        internalLinkName: "".concat(eventLabel),
        eventName: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share")),
        internalLinkType: internalLinkType,
        eventType: eventType,
        eventAction: "".concat(pageType.toLowerCase(), ":").concat(eventLabel === "print" ? eventLabel : "".concat(zoneName, ":share"))
    };
    if (parseJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addDatalayerShare = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "{}";
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = JSON.parse(data);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getDownloadEventInfo = function() {
    let downLoadLink = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", pageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", componentPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", dataLayerLinkType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    let eventInfo = {};
    if (downLoadLink) {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "".concat(downLoadLink),
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(pageType.toLowerCase(), ":").concat(mainTitle.toLowerCase(), ":download"),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    } else {
        eventInfo = {
            clickInternalLinks: "true",
            internalLinkPosition: "".concat(pageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkZoneName: "teaser",
            internalLinkURL: "n/a",
            internalLinkName: "download",
            eventName: "".concat(pageType.toLowerCase(), ":download"),
            internalLinkType: "".concat(dataLayerLinkType),
            eventType: "teaser",
            eventAction: "".concat(pageType.toLowerCase(), ":download")
        };
    }
    return JSON.stringify(eventInfo);
};
const getTitleEventInfo = function() {
    let linkNewTab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, componentPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", linkURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", pageType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", componentLinkType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    return '{"clickInternalLinks":"'.concat(linkNewTab ? "false" : "true", '","internalLinkPosition":"').concat(componentPosition ? componentPosition : "teaser", '","internalLinkZoneName":"teaser","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat(mainTitle.toLowerCase(), '","eventName":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '","internalLinkType":"').concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase(), '","eventType":"teaser","eventAction":"').concat(pageType.toLowerCase(), ":zone:").concat(mainTitle.toLowerCase(), '"}');
};
const addTeaserActionAnalytics = (param)=>{
    let { newTab , pageType , componentPosition , videoTitle , link , text , eventName: eventNameDatalayer , dataLayerLinkType , eventAction: eventActionDataLayer , productCategory , productCollectionsName , productRoom , datalayerPageType , compInfo , mainTitle  } = param;
    let eventAction = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || "zone", ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
    let eventName = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) || "zone", ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
    let internalLinkZoneName = "".concat(videoTitle || pageType.toLowerCase() === "plp" ? "".concat(pageType.toLowerCase(), ":hero banner") : eventActionDataLayer ? "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(eventActionDataLayer === null || eventActionDataLayer === void 0 ? void 0 : eventActionDataLayer.toLowerCase()) : "teaser");
    if (datalayerPageType.includes("locations")) {
        eventName = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        eventAction = "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(text === null || text === void 0 ? void 0 : text.toLowerCase());
        internalLinkZoneName = pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase();
    }
    const eventInfo = {
        clickInternalLinks: newTab ? "true" : "false",
        internalLinkPosition: componentPosition ? "".concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition) : "teaser",
        internalLinkZoneName,
        internalLinkURL: link ? "".concat(link.indexOf("http") === -1 ? window.location.origin : "").concat((0,helper.removeAndCleanLink)(link)) : "n/a",
        internalLinkName: "".concat(!text ? "explore more arrow" : text.toLowerCase()),
        eventName,
        internalLinkType: "".concat(videoTitle ? "".concat(pageType.toLowerCase(), ":").concat(videoTitle) : dataLayerLinkType === null || dataLayerLinkType === void 0 ? void 0 : dataLayerLinkType.replace(/&amp;/g, "&")),
        eventType: "teaser",
        eventAction,
        eventMsg: "n/a",
        eventStatus: "n/a"
    };
    if (pageType.includes("experience centre")) {
        eventInfo.internalLinkType = "find a store:".concat(mainTitle);
    }
    if (!text) {
        eventInfo.clickInternalLinks = "true";
        eventInfo.eventAction = "".concat(pageType.toLowerCase(), ":hero banner:explore more arrow");
        eventInfo.eventName = "".concat(pageType.toLowerCase(), ":hero banner:explore more arrow");
        eventInfo.internalLinkType = "".concat(pageType.toLowerCase(), ":navigation");
        eventInfo.internalLinkZoneName = "".concat(pageType.toLowerCase(), ":hero banner");
    }
    let componentInfoData = compInfo && JSON.parse(compInfo).componentInfo;
    const customDataLayer = componentInfoData ? {
        componentInfo: componentInfoData,
        productInfo: {
            productCategory: productCategory || "n/a",
            productCollectionsName: productCollectionsName || "n/a",
            productRoom: productRoom || "n/a"
        }
    } : {
        productInfo: {
            productCategory: productCategory || "n/a",
            productCollectionsName: productCollectionsName || "n/a",
            productRoom: productRoom || "n/a"
        }
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo, "cmp:click", {}, customDataLayer);
};

// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
;// CONCATENATED MODULE: ./components/OmniChannel/common-methods.js
const getSuccessMessageByPageType = function() {
    let authorData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    let message = [];
    if (authorData.selfRegistrationFormFlag) {
        message = [
            "Thank you for registering with us."
        ];
    } else if (authorData.siteRegistrationFormFlag) {
        message = [
            "Request received successfully.",
            "Our Kohler representative will reach out soon."
        ];
    } else if (authorData.bathroomInspirationFormFlag) {
        message = [
            "Thank you for registering."
        ];
    } else if (authorData.warrantyRegistrationFormFlag) {
        message = [
            "Request received successfully.",
            "Our Kohler representative will reach out soon."
        ];
    } else if (authorData.omniChannelKECFormFlag) {
        message = [
            "Appointment booked successfully.",
            "Our Kohler representative will reach out soon."
        ];
    }
    return message;
};
const getSuccessMessageByPageTypeService = function() {
    let authorData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    let message = [
        "Request received successfully.",
        "Our Kohler representative will reach out soon."
    ];
    return message;
};
const getParamsByURL = function() {
    let omniQRParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { placementType , placementId , qrId , kaspId  } = omniQRParams;
    if (placementType && placementId && qrId) {
        return {
            campaignId: placementType === "ServiceCamp" || placementType === "Service Camp" ? placementId : "",
            kecId: placementType === "Kec" ? placementId : "",
            eventId: placementType === "Event" ? placementId : "",
            dealerId: placementType === "Dealer" ? placementId : "",
            technicianId: placementType === "ServiceTechnician" || placementType === "Service Technician" ? placementId : "",
            qrId,
            leadSubSourceSegment: placementType === "ServiceTechnician" || placementType === "Service Technician" ? "Service Technician" : placementType === "ServiceCamp" || placementType === "Service Camp" ? "Service Camp" : "Dealer",
            kaspId: kaspId
        };
    }
    return {
        dealerId: "",
        qrId: "",
        leadSubSourceSegment: "",
        campaignId: "",
        technicianId: "",
        kaspId: ""
    };
};
const getPageParamsByType = (authorData)=>{
    if (authorData.selfRegistrationFormFlag) {
        return {
            pageName: "selfregistration",
            pageNamePascalCase: "SelfRegistration",
            pagenamehyphen: "self-registration",
            pageTitle: "Self Registration",
            contentType: "selfregistration"
        };
    } else if (authorData.bathroomInspirationFormFlag) {
        return {
            pageName: "bathroominspiration",
            pageNamePascalCase: "BathroomInspiration",
            pagenamehyphen: "bathroom-inspiration",
            pageTitle: "Bathroom Inspiration",
            contentType: "inspiration"
        };
    } else if (authorData.omniChannelKECFormFlag) {
        return {
            pageName: "kecappointment",
            pageNamePascalCase: "KECAppointment",
            pagenamehyphen: "kec-appointment",
            pageTitle: "KEC Appointment",
            contentType: "appointment"
        };
    } else if (authorData.warrantyRegistrationFormFlag) {
        return {
            pageName: "warrantyregistration",
            pageNamePascalCase: "WarrantyRegistration",
            pagenamehyphen: "warranty-registration",
            pageTitle: "Warranty Registration",
            contentType: "warranty"
        };
    } else if (authorData.siteRegistrationFormFlag) {
        return {
            pageName: "sitevisit",
            pageNamePascalCase: "SiteVisit",
            pagenamehyphen: "site-visit",
            pageTitle: "Site Visit",
            contentType: "sitevisit"
        };
    } else if (authorData.amcFormFlag) {
        return {
            pageName: "amc",
            pageNamePascalCase: "AMC",
            pagenamehyphen: "amc",
            pageTitle: "AMC",
            contentType: "amc"
        };
    } else if (authorData.serviceRequestFormFlag) {
        return {
            pageName: "servicerequest",
            pageNamePascalCase: "ServiceRequest",
            pagenamehyphen: "service-request",
            pageTitle: "Service Request",
            contentType: "servicerequest"
        };
    }
};
const getEventInfoForOtp = (authorData)=>{
    const pageURL = window.location.href;
    const { pageName ="" , pageTitle ="" , contentType =""  } = getPageParamsByType(authorData);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "omnichannel:".concat(pageName, ":otpvalidation:success"),
        eventName: "omnichannel:".concat(pageName, ":otpvalidation:success"),
        eventStatus: "success",
        eventMsg: "User OTP validation successful for ".concat(pageTitle, "  form"),
        eventType: "form_interaction",
        internalLinkName: "otp validation",
        internalLinkPosition: "".concat(pageTitle, " Form"),
        internalLinkType: "retail:".concat(contentType, ":otp"),
        internalLinkZoneName: "".concat(pageTitle, " Section"),
        internalLinkURL: pageURL,
        selectRating: "",
        selectOption: ""
    };
    return eventInfo;
};
const getFormInfoForOtp = (data, authorData)=>{
    const { firstName ="" , lastName ="" , mobileNumber =""  } = data || {};
    const { pageTitle =""  } = getPageParamsByType(authorData);
    return {
        form: {
            formName: "Lead Creation",
            formType: "Retail / ".concat(pageTitle),
            formStatus: "otp_validated",
            formValues: {
                firstName: firstName,
                lastName: lastName,
                phoneNumber: mobileNumber
            }
        }
    };
};
const getEventInfoFormSubmit = (authorData, resultType)=>{
    const pageURL = window.location.href;
    const { pageNamePascalCase , pageTitle , contentType  } = getPageParamsByType(authorData);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "omnichannel:landing:".concat(pageNamePascalCase, ":").concat(resultType),
        eventName: "omnichannel:landing:".concat(pageNamePascalCase, ":").concat(resultType),
        eventStatus: "".concat(resultType),
        eventMsg: "Retail customer navigated to ".concat(pageTitle, " page"),
        eventType: "navigation",
        internalLinkName: "".concat(pageTitle),
        internalLinkPosition: "Omnichannel Landing Page",
        internalLinkType: "retail:".concat(contentType),
        internalLinkZoneName: "".concat(pageTitle, " Section"),
        internalLinkURL: pageURL,
        selectRating: "",
        selectOption: ""
    };
    return eventInfo;
};
const getEventInfoFormFilled = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "kohler-india:kec appointment : Form",
        internalLinkZoneName: "kohler-india:kec appointment",
        internalLinkURL: "n/a",
        internalLinkName: "success",
        eventName: "kohler-india:kec appointment:form step1",
        internalLinkType: "Form Submission",
        eventType: "Form",
        eventAction: "kohler-india:kec appointment:Form Fill Complete"
    };
    return eventInfo;
};
const getEventInfoRecaptcha = (isSuccess)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "kohler-india:kec appointment : Form",
        internalLinkZoneName: "kohler-india:kec appointment",
        internalLinkURL: "n/a",
        internalLinkName: "".concat(isSuccess ? "success" : "failure"),
        eventName: "kohler-india:kec appointment:form step2",
        internalLinkType: "Form Submission",
        eventType: "Form",
        eventAction: "kohler-india:kec appointment:Form Captcha ".concat(isSuccess ? "Complete" : "Failed")
    };
    return eventInfo;
};
const getFormInfoForSubmittion = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, authorData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, paramsByUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const { pageTitle  } = getPageParamsByType(authorData);
    const { firstName , lastName , mobileNumber , email , pinCode , noOfBathroom , budget , purchasePick , whatsAppConsent , smsAppConsent , productCategory ="" , siteAddress ="" , productImages =[] , fileType ="" , state ="" , city ="" , kecCity =""  } = data;
    const { campaignId , kecId , eventId , dealerId , qrId  } = paramsByUrl;
    return {
        form: {
            formName: "Lead Creation",
            formType: "Retail / ".concat(pageTitle),
            formStatus: "initiated",
            formValues: {
                firstName: firstName,
                lastName: lastName,
                phoneNumber: mobileNumber,
                email: email,
                pincode: pinCode,
                noOfBathrooms: noOfBathroom,
                budget: budget,
                expectedPurchase: purchasePick,
                whatsappOptIn: whatsAppConsent,
                otherOptIn: smsAppConsent,
                segment: "Retail",
                productCategory: productCategory,
                address: siteAddress,
                qrId: qrId,
                campaignId: campaignId,
                kecId: kecId,
                kecCity: kecCity,
                state: state,
                city: city,
                eventId: eventId,
                dealerId: dealerId,
                scanEventType: pageTitle,
                leadSubSourceSegment: "Omnichannel",
                leadType: "Retail",
                leadSource: "Omnichannel Landing",
                leadSubSource: pageTitle,
                leadStatus: "New",
                leadCurrency: "INR",
                appointment: {
                    dateTime: "",
                    slot: "",
                    status: "",
                    capacity: ""
                },
                warranty: {
                    uploadFileType: fileType,
                    source: productImages.length > 0 ? productImages[0] : ""
                },
                siteVisit: {
                    symptom: "",
                    callerNumber: "",
                    callerType: "",
                    callAllocationType: ""
                }
            }
        }
    };
};
const kecCityMapping = [
    {
        Bangalore: "KEC Bangalore"
    },
    {
        Delhi: "KEC Delhi"
    },
    {
        Mumbai: "KEC Mumbai"
    },
    {
        Ahmedabad: "Studio Ahmedabad"
    },
    {
        Hyderabad: "Studio Hyderabad"
    },
    {
        Chennai: "Studio Chennai"
    },
    {
        Pune: "Studio Pune"
    }
];
const getOmniCTAEventInfo = function() {
    let pageTitle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", buttonName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return {
        clickInternalLinks: "true",
        internalLinkPosition: "kohler-india:".concat(pageTitle),
        internalLinkZoneName: "kohler-india:".concat(pageTitle),
        internalLinkURL: "".concat(window.location.href),
        internalLinkName: buttonName,
        eventName: "kohler-india:".concat(pageTitle, ":").concat(buttonName),
        internalLinkType: "Other",
        eventType: "Button",
        eventAction: "kohler-india:".concat(pageTitle, ":").concat(buttonName)
    };
};
const sessionStoreClosure = ()=>{
    let userDetailsRef = {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        email: "",
        pinCode: "",
        city: "",
        state: ""
    };
    const acceptedAttributes = Object.keys(userDetailsRef);
    const filterAcceptedFormData = (_obj)=>{
        return Object.fromEntries(Object.entries(_obj).filter((param)=>{
            let [key] = param;
            return acceptedAttributes.includes(key);
        }));
    };
    const addSessionUserDetails = function(qrId, formObj) {
        const filteredFormObj = filterAcceptedFormData(formObj);
        window.sessionStorage.setItem("".concat(qrId), JSON.stringify({
            ...filteredFormObj
        }));
    };
    const getSessionUserDetails = function(qrId) {
        if (!qrId) {
            return {};
        }
        let localStorage_userdata = JSON.parse(window.sessionStorage.getItem(qrId));
        if (localStorage_userdata) {
            return {
                ...localStorage_userdata
            };
        } else {
            return userDetailsRef;
        }
    };
    return {
        addSessionUserDetails,
        getSessionUserDetails
    };
};
const { addSessionUserDetails , getSessionUserDetails  } = sessionStoreClosure();
const getInitialDataValues = function(paramsByUrl) {
    const { qrId  } = paramsByUrl;
    const _session_userDetails = getSessionUserDetails(qrId);
    return {
        ..._session_userDetails,
        noOfBathroom: "",
        budget: "",
        whatsAppConsent: true,
        smsAppConsent: true,
        kecCity: "",
        purchasePick: "",
        productCategory: "",
        constructionType: "",
        siteAddress: "",
        customerImage: [],
        uploadedImage: [],
        reportIssue: "",
        alternateMobileNumber: "",
        landmark: "",
        slot: "",
        appointmentDate: ""
    };
};
const verifyRecaptchaToken = async (token)=>{
    if (!token) return false;
    try {
        const response = await fetch("/api/verify-recaptcha", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
                token
            })
        });
        const data = await response.json();
        return data.success;
    } catch (error) {
        console.error("Recaptcha verification failed:", error);
        return false;
    }
};
const placementIdArray = (/* unused pure expression or super */ null && ([
    "0015j000008BUEhAAO",
    "001e1000001uMyGAAU",
    "0015j000008BVcfAAG",
    "0015j00000tdjPGAAY",
    "0015j000012TBjAAAW",
    "0015j00000reXnyAAE",
    "0015j000008BVfWAAW",
    "0015j000008BU6yAAG",
    "0015j000008BU21AAG",
    "0015j00000uBWfMAAW",
    "0015j00000ucXDqAAM",
    "0015j00001Bn8pJAAR",
    "0015j000008BUF0AAO",
    "0015j00000ZqVf5AAF",
    "0015j00000UDCfTAAX",
    "0015j000008BVS1AAO",
    "0015j000008BVRwAAO",
    "0015j000008BVgkAAG",
    "0015j000008BVpxAAG",
    "0015j000008BV0rAAG",
    "0015j000008BJA9AAO",
    "0015j000008BVq4AAG",
    "0015j000008BTgJAAW",
    "001J400000S9Yn4IAF",
    "001J400000VxGxIIAV",
    "0015j000008BVQBAA4",
    "0015j00000qwuzOAAQ",
    "0015j000008BJc0AAG",
    "0015j000008BSJzAAO",
    "0015j00001EIo8gAAD",
    "001fv00000CLat7AAD",
    "0015j000008BVg6AAG",
    "0015j000008BVKnAAO",
    "0015j00000g85MzAAI",
    "001J400000LcHEdIAN"
]));
const recaptchaSiteKey = "6LewhUctAAAAAKK3MHlJqQPX8_0V9izr7NGXY2Fi";
const recaptchaError = "/kdx/recaptcha-error";


;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Action.jsx














const Action = (props)=>{
    const { primaryCTA ="" , secondaryCTA ="" , playVideoCTA ="" , videoTitle ="" , mainTitle ="" , link ="" , text ="" , newTab ="" , urlRef ="" , id ="" , pageType ="" , linkAll ="" , componentPosition =null , eventName =null , eventAction =null , dataLayerLinkType ="".concat(pageType, ":").concat(mainTitle) , productCategory =null , productCollectionsName =null , productRoom =null , propertiesPageType ="" , playVideoCTAcb =()=>"" , index =0 , compInfo , activeIndex =0 , setActive =()=>"" , isScrollToForm =false , isOpenPopup =false , isOmnichannel =false , omniQRParams ={} , datalayerLinkName =""  } = props;
    const { scroll , findAPro , installationServices  } = constants.DEFAULT_SCROLL;
    const [general, setGeneral] = (0,react.useState)(null);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageType: datalayerPageType = ""  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [actionLink, setActionLink] = (0,react.useState)("");
    const [target, setTarget] = (0,react.useState)("");
    const [loginRegisterCallback, setLoginRegisterCallback] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        if (loginRegisterCallback && isAuth && router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            handleOnLinkClick(loginRegisterCallback);
        }
    }, [
        loginRegisterCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(link) && !isEmpty_default()(general)) {
            const actLink = (0,helper.getShortenedUrlwithGeneral)(link, general);
            setActionLink(actLink);
        }
    }, [
        link,
        general
    ]);
    const handleLogin = (e)=>{
        if (router.pathname.includes(constants.MY_ACCOUNT_PATH)) {
            e.preventDefault();
            e.stopPropagation();
            window.loginRegisterCallback = ()=>{
                setLoginRegisterCallback(e);
                if (actionLink) router.push(actionLink);
            };
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            handleOnLinkClick();
        }
    };
    const handleOnLinkClick = (event)=>{
        return propertiesPageType == "modalWindow" && playVideoCTA ? playVideoCTAcb(event) : undefined;
    };
    const handleOnClick = (event)=>{
        var ref;
        var ref1;
        const actionLink = (ref1 = event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.getAttribute("href")) !== null && ref1 !== void 0 ? ref1 : "";
        if (actionLink === null || actionLink === void 0 ? void 0 : actionLink.startsWith("#KPN")) {
            event.preventDefault();
            const link1 = actionLink.split("::");
            const id = link1[0];
            const url = link1[1];
            if (link1) {
                dispatch((0,authSlice/* setHideCustomerSignupCTA */.n$)(true));
                if (id === null || id === void 0 ? void 0 : id.includes("signIn")) {
                    window.KPNSignIn = true;
                    (0,helper.isAuthenticated)(url, 0, true);
                } else if (id === null || id === void 0 ? void 0 : id.includes("createAccount")) {
                    window.KPNSignIn = false;
                    (0,helper.isAuthenticated)(url, 1, true);
                } else {
                    (0,helper.isAuthenticated)(url);
                }
            }
        }
        const currentIndex = Number(event.target.getAttribute("data-index")) || 0;
        setActive(currentIndex);
        if (event.target.getAttribute("href").startsWith("#") && Object.values(constants.MORE_OPTIONS).includes(event.target.text)) {
            exploreMoreScroll(event);
        } else if (router.pathname.includes(constants.MY_ACCOUNT_PATH) && !isAuth) {
            handleLogin(event);
        } else {
            handleOnLinkClick(event);
        }
        addTeaserActionAnalytics({
            newTab,
            pageType,
            componentPosition,
            videoTitle,
            link,
            text,
            eventName,
            dataLayerLinkType,
            eventAction,
            productCategory,
            productCollectionsName,
            productRoom,
            datalayerPageType,
            compInfo,
            mainTitle
        });
    };
    // global explore more scroll
    const exploreMoreScroll = (e)=>{
        e.preventDefault();
        const hash = e.target.hash;
        if (hash === "") return;
        const element = document.querySelector(hash);
        if (!element) return;
        const offsetTop = (0,helper.getOffsetTop)(element) - (hash === constants.FIND_A_PRO_HASH ? findAPro : hash === constants.INSTALLATION_SERVICES_HASH ? installationServices : scroll);
        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    };
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (newTab === false || newTab === "false") {
            setTarget("_self");
        } else {
            setTarget("_blank");
        }
    }, [
        newTab
    ]);
    const handleAction = ()=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
        const eventInfo = getOmniCTAEventInfo(pageType, text);
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
        if (isScrollToForm) {
            const element = document.getElementById("omni-channel-form");
            if (element) {
                const y = element.getBoundingClientRect().top + window.scrollY - 250;
                setTimeout(()=>{
                    window.scrollTo({
                        top: y,
                        behavior: "smooth"
                    });
                }, 5);
            }
        } else if (isOpenPopup) {
            dispatch((0,cartSlice/* showLeadForm */.I_)());
        }
    };
    if (!linkAll) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "cmp-teaser__action-link ".concat((0,helper.convertStringToBoolean)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper.convertStringToBoolean)(secondaryCTA) ? "gbh-secondary-button " : "").concat(propertiesPageType === "modalWindow" && playVideoCTA ? "video-play-button " : "", " ").concat(index === activeIndex ? "active" : ""),
            role: "button",
            "aria-describedby": id,
            href: !isOpenPopup && !isScrollToForm ? isOmnichannel ? (0,utils/* getOmniImgCTALink */.hm)(omniQRParams, actionLink, isOmnichannel, datalayerLinkName) : actionLink : "#",
            "aria-label": text,
            target: target,
            rel: urlRef ? "noreferrer" : "",
            onClick: !isOpenPopup && !isScrollToForm ? handleOnClick : handleAction,
            "data-index": index,
            children: text
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__action-link ".concat((0,helper.convertStringToBoolean)(primaryCTA) ? "gbh-primary-button " : "").concat((0,helper.convertStringToBoolean)(secondaryCTA) ? "gbh-secondary-button " : "").concat(pageType == "modalWindow" && playVideoCTA ? "video-play-button " : ""),
        role: "button",
        "aria-describedby": id || "",
        rel: urlRef ? "noreferrer" : "",
        "aria-label": text,
        children: text
    });
};
/* harmony default export */ var v1_Action = (Action);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/PLPDescription.jsx



const PLPDescription = (param)=>{
    let { desc =""  } = param;
    const [showMore, setShowMore] = (0,react.useState)(false);
    const descText = desc === null || desc === void 0 ? void 0 : desc.replace(/<[^>]*>/g, "").replace(/[\r\n]/g, "");
    const split = descText.split(".");
    const mainText = split[0];
    split.shift();
    const moreText = split.join(".");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "plp-desc",
        children: [
            "".concat(mainText, ". ").concat(showMore ? moreText : "", " "),
            moreText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "read-more",
                onClick: ()=>{
                    setShowMore(!showMore);
                },
                children: [
                    "Read ",
                    showMore ? "less" : "more"
                ]
            }) : null
        ]
    });
};
PLPDescription.propTypes = {
    desc: (prop_types_default()).string
};
/* harmony default export */ var v1_PLPDescription = (PLPDescription);

;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Description.jsx







const Description = (props)=>{
    const { linkURL ="" , linkURLRef ="" , linkNewTab ="" , description ="" , mainTitle ="" , componentPosition =null , componentLinkType =null , pageType ="" , linkDescription =false , general ={}  } = props;
    const [shortenedLinkUrl, setShortenedLinkUrl] = (0,react.useState)("");
    const [target, setTarget] = (0,react.useState)("");
    const [details, setDetails] = (0,react.useState)(description);
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(general)) {
            if (linkURL) {
                setShortenedLinkUrl((0,helper.getShortenedUrlwithGeneral)(linkURL, general));
            }
            if (description) {
                setDetails((0,helper.getShortenedUrlwithGeneral)(description, general));
            }
        }
    }, [
        linkURL,
        description,
        general
    ]);
    // Added to fix eslint error Disallow target="_blank" attribute without rel="noreferrer" (react/jsx-no-target-blank)
    (0,react.useEffect)(()=>{
        if (linkNewTab) {
            setTarget("_blank");
        } else {
            setTarget("_self");
        }
    }, [
        linkNewTab
    ]);
    const shortenUrl = (url)=>{
        return (0,helper.sanitizeInnerHtml)(url.replace("/content/kohler-india/in/en", "").replace(".html", ""));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__description",
        "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(linkNewTab ? "false" : "true", '","internalLinkPosition":"').concat(pageType.toLowerCase(), ":").concat(componentPosition ? componentPosition : "teaser", '","internalLinkZoneName": "').concat(mainTitle ? "".concat(pageType.toLowerCase(), ":").concat(mainTitle) : "teaser", '","internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat((0,helper.sanitizeTextArticle)(description.toLowerCase()), '","eventName":"').concat(pageType.toLowerCase(), ":").concat(mainTitle, ':rm","internalLinkType":"').concat(pageType, ":").concat(componentLinkType ? componentLinkType : mainTitle.toLowerCase(), '","eventType":"teaser","eventAction":"').concat(pageType.toLowerCase(), ":").concat(mainTitle, ':rm"}'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
            condition: linkDescription,
            wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: shortenedLinkUrl,
                    rel: linkURLRef ? "noreferrer" : "",
                    target: target,
                    children: children
                }),
            children: pageType === "plp" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PLPDescription, {
                desc: details
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: isSsr ? shortenUrl(details) : (0,helper.sanitizeInnerHtml)(details)
            })
        })
    });
};
/* harmony default export */ var v1_Description = (Description);

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
;// CONCATENATED MODULE: ./utils/videoHelper.js


const onVolumeChange = (ref)=>{
    if (ref) {
        const { muted , volume  } = ref;
        if (volume == 0 && muted) {
            ref.setAttribute("volume", 1);
            ref.setAttribute("muted", false);
        }
    }
};
// will not work as the element is stacked behind. existing code also have same behavior
const onClickHeroVideo = (event, ref)=>{
    event.preventDefault();
    (ref === null || ref === void 0 ? void 0 : ref.paused) ? ref === null || ref === void 0 ? void 0 : ref.play() : ref === null || ref === void 0 ? void 0 : ref.pause();
};
const onVideoInteraction = (action, cbVideoPlayed, cbVideoPlaying, ref, video, setFavVideoIdCb)=>{
    cbVideoPlayed();
    if (action === constants.VIDEO_EVENTS.PLAY) {
        cbVideoPlaying(true);
        playVideoDatalayer(ref, video, setFavVideoIdCb);
    }
    if (action === constants.VIDEO_EVENTS.PAUSE) {
        cbVideoPlaying(false);
    }
    if (action === constants.VIDEO_EVENTS.ENDED) {
        playVideoDatalayer(ref, video, setFavVideoIdCb);
        ref.play();
    }
};
const onPlayVideoInModal = (event, pageType, videoContainerRef, videoRef)=>{
    if (pageType == "modalWindow") {
        var ref;
        event.preventDefault();
        if (videoContainerRef && !(videoContainerRef === null || videoContainerRef === void 0 ? void 0 : (ref = videoContainerRef.classList) === null || ref === void 0 ? void 0 : ref.contains("open-video-module"))) {
            videoContainerRef.classList.add("open-video-module");
            document.body.classList.add("modal-open");
            videoRef === null || videoRef === void 0 ? void 0 : videoRef.play();
        }
    }
};
const onPlayVideo = (videoRef, cb)=>{
    if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.paused) {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.play();
    } else {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.pause();
    }
    const cbRes = (videoRef === null || videoRef === void 0 ? void 0 : videoRef.paused) ? true : false;
    cb && cb(cbRes);
};
const onVideoPopupClose = (videoContainerRef, videoRef, video)=>{
    videoContainerRef.classList.remove("open-video-module");
    document.body.classList.remove("modal-open");
    videoRef === null || videoRef === void 0 ? void 0 : videoRef.pause();
    playVideoDatalayer(videoRef, video, null, true);
};
const onShareVideo = (e, shareVideoCallback)=>{
    shareVideoCallback && shareVideoCallback();
    if (window.shareSrcElement === undefined || window.shareSrcElement === null) {
        window.shareSrcElement = e.target.children[0];
    }
};
const onFavVideo = function(event) {
    let asset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", url = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", caption = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", videoname = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", favVideoId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "", favouriteCallback = arguments.length > 7 ? arguments[7] : void 0;
    let _$$closest;
    const id = event.target.getAttribute("data-id");
    const sharedZoneName = (_$$closest = $(void 0).closest(".cmp-container")) === null || _$$closest === void 0 ? void 0 : _$$closest.attr("id");
    if (id) {
        window.removeFavorites([
            id
        ], "", "", null, caption, sharedZoneName, videoname, favVideoId);
        favouriteCallback && favouriteCallback(false);
    } else {
        const assetUrl = asset;
        let _assetUrl;
        const url1 = (_assetUrl = assetUrl) !== null && _assetUrl !== void 0 && _assetUrl.startsWith("/") ? window.location.origin + assetUrl : assetUrl;
        window.addMediaToFavorites && window.addMediaToFavorites("video", title, url1, "", "", caption, sharedZoneName, videoname, favVideoId);
        favouriteCallback && favouriteCallback(true);
    }
};

// EXTERNAL MODULE: ./components/cart/OrderSummary/SocialShare.jsx + 1 modules
var SocialShare = __webpack_require__(13200);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
;// CONCATENATED MODULE: ./components/Default/Video/v1/Video.jsx

















const Video = (props)=>{
    const { data: { videoTitle ="" , videoMobile ="" , videoMobileLandscape ="" , videoMobilePoster ="" , videoDesktopPoster ="" , videoDesktop ="" , muteEnableAutoPlay ="false" , hideEnableAutoPlay ="false" , alt ="" , appliedCssClassNames ="" , items =[] , teaserProperties: { title ="" , description ="" , linkURLRef =false , linkCTA ="" , linkNewTab =false , videoPosterMobileLandscape ="" , controlType ="" , pageType ="" , componentPosition ="" , componentZone ="" , componentLinkType ="" , playsAboveFold ="false" , eventName ="" , dynamicTabName ="" , eventAction ="" , caption ="" , pretitle ="" , actionsEnabled =false , actions =[] , linkAll =false , dataLayerLinkType ="" , mainTitle ="" , enableFav =false , enableShare =false , linkDescription =false , propertiesPageType =""  } = {}  } = {}  } = props;
    console.log(props.data, "data");
    const { eventPageType , toaster: { content  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const screenOrientation = hooks_useScreenOrientation();
    const [video, setVideo] = (0,react.useState)("");
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const [videoPlayed, setVideoPlayed] = (0,react.useState)(false);
    const [isVideoPlaying, setIsVideoPlaying] = (0,react.useState)(false);
    const [showSocialShare, setShowSocialShare] = (0,react.useState)(false);
    const [interactionState, setInteractionState] = (0,react.useState)("");
    const { ref: inViewRef , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0.5
    });
    const videoContainerRef = (0,react.useRef)(null);
    const videoRef = (0,react.useRef)(null);
    const favEle = (0,react.useRef)(null);
    const [general, setGeneral] = (0,react.useState)(null);
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const [flagState, setFlagState] = (0,react.useState)({
        flag25: false,
        flag75: false,
        flag50: false
    });
    const getVideoId = (video)=>{
        var ref, ref1;
        return (ref1 = (ref = decodeURI(video)) === null || ref === void 0 ? void 0 : ref.split("PAWEB/")[1]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (videoTitle) {
            const dynamicId = (0,helper.createIdFromString)(videoTitle);
            setDynamicId(dynamicId);
        }
    }, [
        videoTitle
    ]);
    (0,react.useEffect)(()=>{
        if (content) {
            setToasterMessage();
        }
    }, [
        content
    ]);
    const onTimeUpdate = (event)=>{
        const videoDuration = videoRef.current.duration;
        const percent25 = Math.floor(videoDuration * 0.25);
        const percent50 = Math.floor(videoDuration * 0.5);
        const percent75 = Math.floor(videoDuration * 0.75);
        const progressTime = Math.floor(videoRef.current.currentTime);
        if (percent75 <= progressTime && flagState.flag75 === false) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag75: true
                }));
            addVideoDataLayer(75);
        } else if (percent50 <= progressTime && flagState.flag50 === false) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag50: true
                }));
            addVideoDataLayer(50);
        } else if (percent25 <= progressTime && flagState.flag25 === false) {
            setFlagState((prevState)=>({
                    ...prevState,
                    flag25: true
                }));
            addVideoDataLayer(25);
        }
    };
    const addVideoDataLayer = (percentViewed)=>{
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed, "% video viewed"),
            eventMsg: "n/a",
            eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(percentViewed, "% video viewed"),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: "".concat(percentViewed, "% video viewed"),
            internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase()),
            videoId: "".concat(getVideoId(video)),
            videoName: "".concat(videoTitle || componentLinkType.toLowerCase() || "hero video")
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const setToasterMessage = async ()=>{
        const { successMessage , unfavoriteSuccessMessage  } = content;
        setToasterContent({
            successMessage: await (0,utils_location/* getShortenedUrl */.Pp)(successMessage),
            unfavoriteSuccessMessage: await (0,utils_location/* getShortenedUrl */.Pp)(unfavoriteSuccessMessage)
        });
    };
    const setVideoSource = (0,react.useCallback)(()=>{
        if (winWidth > 1023) {
            setVideo(videoDesktop);
        } else {
            if (screenOrientation === null || screenOrientation === void 0 ? void 0 : screenOrientation.includes("landscape")) {
                setVideo(videoMobileLandscape);
            } else {
                setVideo(videoMobile);
            }
        }
    }, [
        videoMobile,
        videoMobileLandscape,
        videoDesktop,
        screenOrientation,
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (inView) {
            setVideoSource();
            if ((0,helper.convertStringToBoolean)(muteEnableAutoPlay) || videoPlayed && interactionState === constants.VIDEO_EVENTS.PLAY) {
                var ref;
                videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play();
            }
        } else {
            var ref1;
            videoRef === null || videoRef === void 0 ? void 0 : (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
        }
    }, [
        setVideoSource,
        inView
    ]);
    (0,react.useEffect)(()=>{
        if (isVideoPlaying) setVideoPlayed(true);
    }, [
        isVideoPlaying
    ]);
    const eventActionTabName = dynamicTabName || "zoneForVideo";
    const eventActionName = "".concat(dynamicTabName || "rm", ":video:rm");
    const [favVideoId, setFavVideoId] = (0,react.useState)("");
    const analyticEventData = {
        clickInternalLinks: true,
        internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser"),
        internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser"),
        internalLinkURL: "n/a",
        internalLinkName: "n/a",
        eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        internalLinkType: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        eventType: "informative",
        eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":share"),
        videoName: "".concat(videoTitle || componentLinkType.toLowerCase() || "hero video"),
        videoId: "".concat(getVideoId(video))
    };
    const checkVideoTitle = videoTitle || componentLinkType.toLowerCase() || "hero video";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "video teaser ".concat(appliedCssClassNames),
        ref: inViewRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-teaser".concat(controlType == "customControl" ? " gbh-custom-control" : "").concat(propertiesPageType == "modalWindow" ? " gbh-model-window" : "").concat((0,helper.convertStringToBoolean)(hideEnableAutoPlay) ? " gbh-hide-mute" : ""),
            ref: videoContainerRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__image video_poster_height".concat(videoPlayed ? " video-played" : ""),
                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ':\'hero banner\' ","internalLinkURL":"n/a","internalLinkName":"video play","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '",\n             "internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle ? videoTitle : componentLinkType.toLowerCase() || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventActionTabName, '","videoName":"').concat(videoTitle || componentLinkType.toLowerCase() || "hero video", '"}'),
                    style: showSocialShare ? {
                        overflow: "visible"
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "gbh-play-video desktop".concat(isVideoPlaying ? " active" : ""),
                            onClick: (event)=>{
                                return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "playinside desktop",
                                id: "videoinnerbtn-".concat(dynamicId),
                                "aria-label": "play video",
                                onClick: ()=>{
                                    return onPlayVideo(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, (res)=>{
                                        setIsVideoPlaying(res);
                                        setInteractionState(res ? constants.VIDEO_EVENTS.PAUSE : constants.VIDEO_EVENTS.PLAY);
                                    }, videoDesktopPoster, videoMobilePoster, video, isVideoPlaying);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            className: "poster-img",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:1025)",
                                    srcSet: "".concat(videoDesktopPoster)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(min-width:640px) and (max-width:1024px)",
                                    srcSet: "".concat(videoPosterMobileLandscape)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    media: "(max-width:639px)",
                                    srcSet: "".concat(videoMobilePoster)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(videoDesktopPoster),
                                    alt: alt,
                                    className: "desktop-poster"
                                })
                            ]
                        }),
                        video && /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            ref: videoRef,
                            id: "video-desktop-".concat(dynamicId),
                            width: "100%",
                            muted: (0,helper.convertStringToBoolean)(muteEnableAutoPlay),
                            autoPlay: (0,helper.convertStringToBoolean)(muteEnableAutoPlay),
                            loop: (0,helper.convertStringToBoolean)(muteEnableAutoPlay),
                            playsInline: true,
                            preload: "metadata",
                            onLoadedData: ()=>{
                                (0,helper.convertStringToBoolean)(muteEnableAutoPlay) ? playVideoDatalayer(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (id)=>setFavVideoId(id)) : {};
                            },
                            className: "hero-video videoelement".concat((0,helper.convertStringToBoolean)(muteEnableAutoPlay) ? " muted" : "").concat((0,helper.convertStringToBoolean)(playsAboveFold) ? "" : " lazy-video"),
                            onVolumeChange: ()=>{
                                return onVolumeChange(videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            onClick: (event)=>{
                                return onClickHeroVideo(event, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                            },
                            ...controlType === "defaultControl" && !(0,helper.convertStringToBoolean)(hideEnableAutoPlay) ? {
                                controls: true
                            } : {},
                            onPlay: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PLAY, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper.convertStringToBoolean)(muteEnableAutoPlay), (id)=>setFavVideoId(id));
                            },
                            onPause: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.PAUSE, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper.convertStringToBoolean)(muteEnableAutoPlay));
                            },
                            onEnded: ()=>{
                                return onVideoInteraction(constants.VIDEO_EVENTS.ENDED, ()=>setVideoPlayed(true), (res)=>setIsVideoPlaying(res), videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video, (0,helper.convertStringToBoolean)(muteEnableAutoPlay));
                            },
                            onTimeUpdate: onTimeUpdate,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: video,
                                    type: "video/mp4"
                                }),
                                items.map((transcript, index)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("track", {
                                        label: transcript === null || transcript === void 0 ? void 0 : transcript.languageLabel,
                                        kind: "subtitles",
                                        srcLang: transcript === null || transcript === void 0 ? void 0 : transcript.languageCode,
                                        src: transcript === null || transcript === void 0 ? void 0 : transcript.transcriptSrcPath,
                                        default: (items === null || items === void 0 ? void 0 : items.length) ? true : false
                                    }, "video-track-".concat(dynamicId, "-").concat(index));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-img-caption",
                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentPosition || "teaser", '","internalLinkZoneName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(componentZone || "teaser", '","internalLinkURL":"n/a","internalLinkName":"n/a","eventName":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventName || eventActionName, '","internalLinkType":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(videoTitle || componentLinkType || "teaser", '","eventType":"navigation","eventAction":"').concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":").concat(eventAction || eventActionName, '"}'),
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(caption)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "vidio_popup_close_button",
                            onClick: ()=>{
                                return onVideoPopupClose(videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current, video);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                role: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: "\xd7"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-teaser__content",
                    children: [
                        pretitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__pretitle",
                            children: (0,helper.sanitizeInnerHtml)(pretitle)
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__title",
                            children: (0,helper.sanitizeInnerHtml)(title)
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                            general: general,
                            linkURL: linkCTA,
                            linkURLRef: linkURLRef,
                            linkNewTab: linkNewTab,
                            description: description,
                            mainTitle: mainTitle,
                            componentPosition: componentPosition,
                            componentLinkType: componentLinkType,
                            pageType: pageType,
                            linkDescription: linkDescription
                        }),
                        actionsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-teaser__action-container",
                            children: actions.map((action, index)=>{
                                const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                    primaryCTA: (0,helper.convertStringToBoolean)(primaryCTA),
                                    secondaryCTA: (0,helper.convertStringToBoolean)(secondaryCTA),
                                    playVideoCTA: (0,helper.convertStringToBoolean)(playVideoCTA),
                                    link: url,
                                    text: title,
                                    newTab: (0,helper.convertStringToBoolean)(newTab),
                                    urlRef: urlRef,
                                    id: dynamicId,
                                    pageType: pageType,
                                    videoTitle: videoTitle,
                                    linkAll: (0,helper.convertStringToBoolean)(linkAll),
                                    mainTitle: mainTitle,
                                    dataLayerLinkType: dataLayerLinkType,
                                    eventName: eventName,
                                    eventAction: eventAction,
                                    componentPosition: componentPosition,
                                    propertiesPageType: propertiesPageType,
                                    playVideoCTAcb: (event)=>{
                                        return onPlayVideoInModal(event, propertiesPageType, videoContainerRef === null || videoContainerRef === void 0 ? void 0 : videoContainerRef.current, videoRef === null || videoRef === void 0 ? void 0 : videoRef.current);
                                    }
                                }, "video-action-".concat(index + 1, "-").concat((0,helper.getRandom)()));
                            })
                        }),
                        (enableFav || enableShare) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__icons",
                            children: [
                                enableFav && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: favEle,
                                    className: "favorite fav-video-trigger",
                                    tabIndex: "0",
                                    "data-asset": videoDesktop,
                                    "data-url": videoDesktop,
                                    onClick: (event)=>onFavVideo(event, videoDesktop, alt, componentLinkType || caption, videoTitle || componentLinkType.toLowerCase() || "hero video", checkVideoTitle, favVideoId, favEle, toasterContent)
                                }),
                                enableShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "share share-video-trigger",
                                    tabIndex: "0",
                                    "aria-label": "share",
                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), '","internalLinkZoneName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((componentZone === null || componentZone === void 0 ? void 0 : componentZone.toLowerCase()) || "teaser", '","internalLinkURL":"n/a","internalLinkName":"share","eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ':share", "internalLinkType":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || "share", '","eventType":"navigation","eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ':share"}'),
                                    "data-gbh-clickable": "true",
                                    onClick: (e)=>onShareVideo(e, ()=>setShowSocialShare(!showSocialShare)),
                                    children: showSocialShare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "share-cmp",
                                        style: {
                                            display: "block"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                            analyticEventData: analyticEventData,
                                            componentProp: {
                                                assetUrl: videoDesktop
                                            },
                                            enableDownload: false,
                                            videoComp: true
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Video = (/*#__PURE__*/react.memo(Video));

// EXTERNAL MODULE: ./node_modules/overlayscrollbars-react/dist/overlayscrollbars-react.esm.js
var overlayscrollbars_react_esm = __webpack_require__(1861);
;// CONCATENATED MODULE: ./src/components/core/Image/ImagePlaceHolder.jsx


const ImagePlaceHolder = (param)=>{
    let { assetID =""  } = param;
    if (!assetID) return null;
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: imgPlaceholder,
        "data-src": imgPlaceholder,
        "data-mode": "smartcrop",
        alt: "Image Placeholder",
        className: "fluidimage cmp-image__image image-placeholder"
    });
};
/* harmony default export */ var Image_ImagePlaceHolder = (ImagePlaceHolder);

// EXTERNAL MODULE: ./i18n/useSearchi18n.js
var useSearchi18n = __webpack_require__(81294);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/FavouritesUtility.jsx











const FavouritesUtility = (param)=>{
    let { title ="" , assetID ="" , imageServerUrl ="" , alt ="" , containerId: zone = ""  } = param;
    let isTriggered = false;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [isFavourite, setIsFavourite] = (0,react.useState)(false);
    const [pageUrl, setPageUrl] = (0,react.useState)("");
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const favEle = (0,react.useRef)(null);
    const { favorites: favoritesLabel , favSuccessMsg , favErrorMsg , removeItem  } = (0,useSearchi18n/* default */.Z)({});
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { favorites: { id  } = {} , isLoginFavouriteCallback: { isCallBack =false , callBackAssetID =""  }  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const dataUrl = assetID ? "".concat(imageServerUrl).concat(assetID) : "";
    (0,react.useEffect)(()=>{
        var ref;
        const ogUrl = document.querySelector('meta[property="og:url"]') ? (ref = document.querySelector('meta[property="og:url"]')) === null || ref === void 0 ? void 0 : ref.content : "";
        const url = ogUrl ? ogUrl.replace(constants.publicWebsiteUrl, constants.baseUrl) : "".concat(window.location.pathname.split(".")[0]);
        setPageUrl(url);
    }, []);
    const { eventPageType , toaster: { content  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (content) {
            setToasterMessage();
        }
    }, [
        content
    ]);
    (0,react.useEffect)(()=>{
        if (!isTriggered && isCallBack && isAuth && id && callBackAssetID === assetID) {
            isTriggered = true;
            dispatch((0,favoritesSlice/* setLoginFavouriteCallback */.x9)({
                isCallBack: false,
                callBackAssetID: ""
            }));
            onFavClick({});
        }
    }, [
        isCallBack,
        callBackAssetID,
        isAuth,
        id
    ]);
    const setToasterMessage = async ()=>{
        const { successMessage , unfavoriteSuccessMessage  } = content;
        setToasterContent({
            successMessage: await (0,utils_location/* getShortenedUrl */.Pp)(successMessage),
            unfavoriteSuccessMessage: await (0,utils_location/* getShortenedUrl */.Pp)(unfavoriteSuccessMessage)
        });
    };
    const onFavClick = (event)=>{
        (event === null || event === void 0 ? void 0 : event.preventDefault) && (event === null || event === void 0 ? void 0 : event.preventDefault());
        (event === null || event === void 0 ? void 0 : event.stopPropagation) && (event === null || event === void 0 ? void 0 : event.stopPropagation());
        let payload = {};
        const id = favEle.current.getAttribute("data-id");
        window.zoneName = zone;
        window.internalLinkType = title;
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":main content area:favorite add"),
            eventMsg: "n/a",
            eventName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":main content area:favorite add"),
            eventStatus: "success",
            eventType: "navigation",
            internalLinkName: "favorite add",
            internalLinkPosition: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase()),
            internalLinkType: "".concat(eventPageType, ":").concat((0,helper.sanitizeTextArticle)(title.replace(/\&nbsp;/g, " "))),
            internalLinkURL: "n/a",
            internalLinkZoneName: "".concat(eventPageType === null || eventPageType === void 0 ? void 0 : eventPageType.toLowerCase(), ":main content area"),
            imageName: assetID.includes("/") ? "".concat(assetID.split("/").at(1)) : "".concat(assetID)
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
        if (id) {
            dispatch((0,favoritesSlice/* removeItems */.Er)([
                id
            ])).unwrap().then((response)=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: toasterContent.unfavoriteSuccessMessage || removeItem,
                    isVisible: true
                }));
                favEle.current.removeAttribute("data-id");
                favEle.current.classList.remove("favorite-filled");
            }).catch((error)=>{
                console.error(error);
            });
            return;
        }
        if (!isAuth) {
            handleLogin();
            return;
        }
        // For images
        if (assetID) {
            payload = getPayload({
                type: "image"
            });
            postData(payload);
        } else {
            Promise.all([
                (0,api/* aemAxiosInstance */.Gb)({
                    url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(pageUrl).concat(constants.ARTICLE_CONTENT_END_POINT)
                    }
                }),
                (0,api/* aemAxiosInstance */.Gb)({
                    url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                    params: {
                        path: "".concat(pageUrl).concat(constants.ARTICLE_IMG_END_POINT)
                    }
                })
            ]).then((response)=>{
                const [{ data  } = {}, { data: { fileReference  } = {}  }] = response;
                payload = getPayload({
                    type: "article",
                    content: data,
                    thumbnail: fileReference
                });
                postData(payload);
            }).catch((error)=>{
                console.error(error);
            });
        }
    };
    const postData = (payload)=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* addMedia */.rA)(payload));
        } else {
            handleLogin();
        }
    };
    const getPayload = (param)=>{
        let { type , content , thumbnail  } = param;
        const payload = {
            type,
            content,
            thumbnail,
            successCallback,
            errorCallback,
            section: zone
        };
        if (type === "image") {
            payload["name"] = alt;
            payload["url"] = dataUrl;
        } else if (type === "article") {
            payload["caption"] = title;
            payload["name"] = content["jcr:title"];
            payload["description"] = content["searchDescription"];
            payload["articleType"] = content["eyeBrowText"];
            payload["thumbnail"] = thumbnail;
            payload["url"] = window.location.href;
        }
        return payload;
    };
    const handleLogin = ()=>{
        dispatch((0,favoritesSlice/* setLoginFavouriteCallback */.x9)({
            isCallBack: true,
            callBackAssetID: assetID
        }));
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const successCallback = ()=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: toasterContent.successMessage || favSuccessMsg,
            isVisible: true
        }));
        setIsFavourite(true);
    };
    const errorCallback = ()=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: favErrorMsg,
            isVisible: true
        }));
        setIsFavourite(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "favorite fav-trigger ".concat(isFavourite ? "favorite-filled" : ""),
        "aria-label": "favorite",
        "data-asset": assetID,
        "data-url": dataUrl,
        "data-title": alt,
        "data-internal-link-type": title,
        ref: favEle,
        onClick: (event)=>onFavClick(event),
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: favoritesLabel
            })
        ]
    });
};
/* harmony default export */ var v1_FavouritesUtility = (FavouritesUtility);

// EXTERNAL MODULE: ./components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(13678);
;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/ShareUtility.jsx








const ShareUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , dataLayerLinkType ="" , containerId: zone = ""  } = param;
    const [showShare, setShowShare] = (0,react.useState)(false);
    const [pageUrl, setPageUrl] = (0,react.useState)("");
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { share  } = (0,useSearchi18n/* default */.Z)({});
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (pageIsInteractive) setPageUrl(window.location.href);
    }, [
        pageIsInteractive
    ]);
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowShare(!showShare);
        const eventInfo = getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative");
        addDatalayerShare(eventInfo);
    };
    return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "share share-trigger",
                "aria-label": "share",
                tabIndex: "0",
                onClick: handleShare,
                children: [
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: share
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "share-cmp",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                        showModal: showShare,
                        url: pageUrl,
                        onClose: ()=>setShowShare(false),
                        disableInstagram: true,
                        analyticData: getEventInfo(pageType, componentPosition, "", "share", dataLayerLinkType, "informative", zone, true)
                    })
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var v1_ShareUtility = (ShareUtility);

;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/PrintUtility.jsx




const PrintUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , mainTitle =""  } = param;
    const { print  } = (0,useSearchi18n/* default */.Z)({});
    const handlePrint = ()=>{
        window.print();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        class: "print",
        onClick: ()=>handlePrint(),
        tabIndex: "0",
        "data-gbh-data-layer": getEventInfo(pageType, componentPosition, mainTitle, "print", "", "teaser"),
        "data-gbh-clickable": "true",
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: print
            })
        ]
    });
};
/* harmony default export */ var v1_PrintUtility = (PrintUtility);

;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/DownloadUtility.jsx






const DownloadUtility = (param)=>{
    let { pageType ="" , componentPosition ="" , dataLayerLinkType ="" , downLoadLink =null , mainTitle =""  } = param;
    const { download , downloadSuccess , downloadFailure  } = (0,useSearchi18n/* default */.Z)({});
    const [downloadUrl, setUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (downLoadLink) {
            updateUrl();
        }
    }, [
        downLoadLink
    ]);
    const updateUrl = async ()=>{
        const url = await (0,helper.getShortenedUrl)(downLoadLink);
        setUrl("".concat(constants.authorBaseUrl).concat(url));
    };
    const downloadHandle = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        const getDownloadUrl = downloadUrl ? downloadUrl : window.location.href;
        (0,helper.downloadArticle)(getDownloadUrl, event, "", downloadSuccess, downloadFailure);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "download",
        "aria-label": "download",
        tabIndex: "0",
        children: downLoadLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: downLoadLink,
            className: "download-trigger",
            "data-gbh-data-layer": getDownloadEventInfo(downLoadLink, pageType, componentPosition, mainTitle, dataLayerLinkType),
            "data-gbh-clickable": "true",
            onClick: downloadHandle,
            children: [
                "\xa0",
                download
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "download-trigger",
                    "data-gbh-data-layer": getDownloadEventInfo(downLoadLink, pageType, componentPosition, mainTitle, dataLayerLinkType),
                    "data-gbh-clickable": "true",
                    onClick: downloadHandle,
                    children: download
                })
            ]
        })
    });
};
/* harmony default export */ var v1_DownloadUtility = (DownloadUtility);

;// CONCATENATED MODULE: ./src/components/Default/Teaser/v1/Utilities.jsx







const Utilities = (param)=>{
    let { utilities =[] , title ="" , assetID ="" , imageServerUrl ="" , alt ="" , pageType ="" , dataLayerLinkType ="" , mainTitle ="" , downLoadLink ="" , containerId =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-teaser__icons",
        children: utilities.map((item, index)=>{
            switch(item === null || item === void 0 ? void 0 : item.utilitiesType){
                case constants.UTILITY_CONSTANTS.FAVOURITES:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FavouritesUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        containerId: containerId
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.SHARE:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ShareUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        containerId: containerId
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.PRINT:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PrintUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        mainTitle: mainTitle
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                case constants.UTILITY_CONSTANTS.DOWNLOAD:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_DownloadUtility, {
                        title: title,
                        assetID: assetID,
                        imageServerUrl: imageServerUrl,
                        alt: alt,
                        pageType: pageType,
                        dataLayerLinkType: dataLayerLinkType,
                        mainTitle: mainTitle,
                        downLoadLink: downLoadLink
                    }, "".concat(item === null || item === void 0 ? void 0 : item.utilitiesType, "-").concat(index));
                default:
                    return null;
            }
        })
    });
};
/* harmony default export */ var v1_Utilities = (Utilities);

// EXTERNAL MODULE: ./public/icons/down-arrow-sort.svg
var down_arrow_sort = __webpack_require__(36868);
;// CONCATENATED MODULE: ./components/Default/Teaser/v1/Teaser.jsx
/* eslint-disable react/jsx-no-target-blank */ 
















const Teaser = (props)=>{
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data: { id ="" , appliedCssClassNamesCustom ="" , linkURLRef =false , linkNewTab =false , linkAll =false , linkTitle =false , linkImage =false , title ="" , description ="" , enableFav =false , enableShare =false , mainTitle ="" , componentPosition ="" , pageType ="" , linkDescription ="" , linkURL ="" , caption ="" , datalayerLinkName ="" , componentLinkType ="" , eventName ="" , eventAction ="" , actions =[] , downLoadLink =null , imageResource: { imageServerUrl ="" , assetID ="" , pretitle: preTitle = "" , urlModifiers ="" , alt =""  } = {} , utilities =[] , utilitiesEnabled =false , dataLayerLinkType =""  } = {} , fullData ={} , showEmptyPlaceholder =false , maxHeight ="" , containerId ="" , isOmnichannel =false , omniQRParams ={}  } = props;
    const [parentActionLink, setParentActionLink] = (0,react.useState)(linkURL);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [appliedCssClassNamesCustoms, setAppliedCssClassNamesCustoms] = (0,react.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react.useState)("");
    const [general, setGeneral] = (0,react.useState)(null);
    const [innerCaption, setInnerCaption] = (0,react.useState)(false);
    const [isInsideImage, setIsInsideImage] = (0,react.useState)(false);
    const [activeIndex, setActive] = (0,react.useState)(0);
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [isScrollToForm, setIsScrollToForm] = (0,react.useState)(false);
    const [isOpenPopup, setIsOpenPopup] = (0,react.useState)(false);
    const backToTopRef = (0,react.useRef)(null);
    const isCaptionOnly = Boolean(title || description || (actions === null || actions === void 0 ? void 0 : actions.length) || preTitle || assetID || showEmptyPlaceholder);
    const handleScroll = ()=>{
        const backToTopBtn = backToTopRef === null || backToTopRef === void 0 ? void 0 : backToTopRef.current;
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScroll < 50) {
            backToTopBtn.style.display = "block";
        } else {
            backToTopBtn.style.display = "none";
        }
    };
    const handleBackToTop = ()=>{
        const scrollableHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        const y = Math.max(0, Math.floor(scrollableHeight / 3));
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
        const backToTopBtn = backToTopRef === null || backToTopRef === void 0 ? void 0 : backToTopRef.current;
        if (backToTopBtn) {
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScroll < 50) {
                backToTopBtn.style.display = "block";
            } else {
                backToTopBtn.style.display = "none";
            }
            window.addEventListener("scroll", handleScroll);
            return ()=>{
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (assetID) {
            const dynamicId = (0,helper.createIdFromString)(assetID);
            setDynamicId(dynamicId);
        } else {
            const dynamicId1 = (0,helper.createIdFromString)((0,helper.getRandom)() + "");
            setDynamicId(dynamicId1);
        }
    }, [
        assetID
    ]);
    (0,react.useEffect)(()=>{
        if (linkURL) {
            (0,helper.getShortenedUrl)(linkURL).then((res)=>{
                setParentActionLink(res);
            });
        }
    }, [
        linkURL
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setAppliedCssClassNamesCustoms((appliedCssClassNamesCustom)=>[
                        ...appliedCssClassNamesCustom,
                        fullData[key]["appliedCssClassNamesCustom"]
                    ]);
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react.useEffect)(()=>{
        let classNameCustom = "";
        if (componentGroup.length > 0) {
            if (componentGroup.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.TEASER);
            }) > -1 && appliedCssClassNamesCustoms.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes("hero-banner-article-top");
            }) > -1 && appliedCssClassNamesCustoms.findIndex((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes("hero-banner-article-bottom");
            }) === -1) {
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("hero-banner-top-only"))) {
                    classNameCustom += " hero-banner-top-only ";
                }
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("paddingbasedbreadcrum")) && componentGroup.findIndex((a)=>{
                    return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
                }) > -1) {
                    classNameCustom += " paddingbasedbreadcrum ";
                }
                if (!(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("without-breadcrumb")) && componentGroup.findIndex((a)=>{
                    return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
                }) === -1) {
                    classNameCustom += " without-breadcrumb ";
                }
            }
        }
        setColumnClassNames((className)=>className += classNameCustom);
    }, [
        componentGroup
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            if (constants.TEASER_CAPTION_CLASSES_LIST.some((classNames)=>{
                return classNames.split(" ").every((className)=>{
                    var ref;
                    return (ref = appliedCssClassNamesCustom === null || appliedCssClassNamesCustom === void 0 ? void 0 : appliedCssClassNamesCustom.trim()) === null || ref === void 0 ? void 0 : ref.includes(className);
                });
            })) {
                setInnerCaption(true);
            }
        }
    }, [
        isSsr,
        pageIsInteractive
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNamesCustom) {
            checkUtilityPosition();
        }
        if (appliedCssClassNamesCustom) {
            checkForIsScrollToForm();
        }
    }, [
        appliedCssClassNamesCustom
    ]);
    const checkForIsScrollToForm = ()=>{
        if (appliedCssClassNamesCustom.includes("omnichannel-form-scroll")) {
            setIsScrollToForm(true);
        } else if (appliedCssClassNamesCustom.includes("omnichannel-form-popup")) {
            setIsOpenPopup(true);
        }
    };
    const checkUtilityPosition = ()=>{
        let isInsideImage = false;
        constants.TEASER_CLASSES.forEach((item)=>{
            isInsideImage = appliedCssClassNamesCustom.includes(item);
            if (isInsideImage) {
                setIsInsideImage(isInsideImage);
                return;
            }
        });
    };
    const getDataLayerLinkType = ()=>{
        if (mainTitle || title) {
            return "".concat(pageType, ":").concat(mainTitle || title);
        }
        return dataLayerLinkType;
    };
    let finalEventString = "";
    let mid = "";
    let end = "";
    let combinedZoneName = "";
    let instagramTitle = "follow us on instagram";
    if (eventName) {
        mid = eventName === "image cards" ? "follow us on instagram" : eventAction || datalayerLinkName ? "main content area" : "zone";
        end = eventAction.replace(/;/g, "") || datalayerLinkName.replace(/;/g, "") || "rm";
        if (eventName === "register your kohler products") {
            mid = eventName;
            combinedZoneName = eventName;
        }
        if (eventName !== "register your kohler products") {
            finalEventString = "".concat(mid, ":").concat(end);
            combinedZoneName = eventName === "image cards" ? "follow us on instagram" : "main content area";
        } else {
            finalEventString = "".concat(mid, ":learn more");
        }
    } else finalEventString = "zone:".concat(mainTitle.toLowerCase() || instagramTitle);
    const shortenUrl = (url)=>{
        return url.replace("/content/kohler-india/in/en", "").replace(".html", "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "teaser ".concat(appliedCssClassNamesCustom ? appliedCssClassNamesCustom : "").concat(columnClassNames),
        children: [
            isCaptionOnly ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-teaser",
                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(linkNewTab ? "false" : "true", '",\n          "internalLinkPosition":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentPosition || "teaser", '",\n          "internalLinkZoneName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(combinedZoneName, '",\n          "internalLinkURL":"').concat(linkURL, '","internalLinkName":"').concat(eventName === "image cards" ? assetID.substring(assetID.indexOf("/") + 1) : datalayerLinkName, '",\n          "eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(finalEventString, '"\n          ,"internalLinkType":"').concat(pageType, ":").concat(componentLinkType || mainTitle, '","eventType":"teaser",\n          "eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(finalEventString, '"}'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(utils/* ConditionalWrapper */.M2, {
                    condition: linkAll,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: !isSsr ? (0,utils/* getOmniImgCTALink */.hm)(omniQRParams, parentActionLink, isOmnichannel, datalayerLinkName) : shortenUrl(parentActionLink),
                            target: linkNewTab ? "_blank" : "_self",
                            "data-gbh-clickable": "true",
                            rel: "noreferrer",
                            children: children
                        }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cq-dd-image cmp-teaser__image",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "s7responsiveContainer cmp-teaser__image cmp-image__image",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                                            condition: linkImage,
                                            wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: parentActionLink,
                                                    target: linkNewTab ? "_blank" : "_self",
                                                    "data-gbh-clickable": "true",
                                                    rel: "noreferrer",
                                                    children: children
                                                }),
                                            children: !isSsr ? assetID || showEmptyPlaceholder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage/* default */.Z, {
                                                style: maxHeight && showEmptyPlaceholder && !assetID ? {
                                                    maxHeight
                                                } : {},
                                                className: "fluidimage cmp-image__image",
                                                imgUrl: "".concat(assetID ? "".concat(imageServerUrl).concat(assetID) : constants.EMPTY_PIXEL),
                                                alt: caption,
                                                itemProp: "contentUrl",
                                                uniqueId: dynamicId,
                                                urlModifiers: urlModifiers,
                                                fetchPriority: appliedCssClassNamesCustom.includes("hero-banner") ? "high" : "auto"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_ImagePlaceHolder, {
                                                assetID: assetID
                                            }) : null
                                        })
                                    })
                                }),
                                isInsideImage && utilitiesEnabled && (utilities === null || utilities === void 0 ? void 0 : utilities.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Utilities, {
                                    utilities: utilities,
                                    title: title,
                                    assetID: assetID,
                                    imageServerUrl: imageServerUrl,
                                    alt: alt,
                                    pageType: pageType,
                                    dataLayerLinkType: getDataLayerLinkType(),
                                    mainTitle: mainTitle,
                                    downLoadLink: downLoadLink,
                                    containerId: containerId
                                }) : null,
                                innerCaption && caption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-img-caption",
                                    children: (0,helper.sanitizeInnerHtml)(caption)
                                }) : null
                            ]
                        }),
                        title || description || enableFav || enableShare || actions && actions.length || preTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cmp-teaser__content",
                            children: [
                                preTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__pretitle",
                                    children: (0,helper.sanitizeInnerHtml)(preTitle)
                                }) : null,
                                title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__title",
                                    id: id,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                                        condition: linkTitle,
                                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: parentActionLink,
                                                rel: linkURLRef ? "noreferrer" : "",
                                                target: linkNewTab ? "_blank" : "_self",
                                                "data-gbh-data-layer": getTitleEventInfo(linkNewTab, componentPosition, linkURL, mainTitle, pageType, componentLinkType),
                                                "data-gbh-clickable": "true",
                                                children: children
                                            }),
                                        children: (0,helper.sanitizeInnerHtml)(title)
                                    })
                                }) : null,
                                description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Description, {
                                    linkURLRef: linkURLRef,
                                    general: general,
                                    linkNewTab: linkNewTab,
                                    description: description,
                                    mainTitle: mainTitle,
                                    componentPosition: componentPosition,
                                    pageType: pageType,
                                    linkDescription: linkDescription
                                }) : null,
                                actions && (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-teaser__action-container",
                                    children: actions.map((action, index)=>{
                                        const { playVideoCTA =false , primaryCTA =false , secondaryCTA =false , url ="" , title ="" , newTab ="" , urlRef =""  } = action;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                            playVideoCTA: (0,helper.convertStringToBoolean)(playVideoCTA),
                                            primaryCTA: (0,helper.convertStringToBoolean)(primaryCTA),
                                            secondaryCTA: (0,helper.convertStringToBoolean)(secondaryCTA),
                                            link: url,
                                            text: title,
                                            newTab: (0,helper.convertStringToBoolean)(newTab),
                                            urlRef: urlRef,
                                            id: id,
                                            dataLayerLinkType: dataLayerLinkType,
                                            pageType: pageType,
                                            linkAll: (0,helper.convertStringToBoolean)(linkAll),
                                            mainTitle: mainTitle,
                                            index: index,
                                            activeIndex: activeIndex,
                                            setActive: setActive,
                                            eventAction: eventAction,
                                            eventName: eventName,
                                            isScrollToForm: isScrollToForm,
                                            isOpenPopup: isOpenPopup,
                                            isOmnichannel: isOmnichannel,
                                            omniQRParams: omniQRParams,
                                            datalayerLinkName: datalayerLinkName
                                        }, "teaser-action-".concat(index + 1, "-").concat((0,helper.getRandom)()));
                                    })
                                }) : null,
                                !isInsideImage && utilitiesEnabled && (utilities === null || utilities === void 0 ? void 0 : utilities.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Utilities, {
                                    utilities: utilities,
                                    title: title,
                                    assetID: assetID,
                                    imageServerUrl: imageServerUrl,
                                    alt: alt,
                                    pageType: pageType,
                                    dataLayerLinkType: getDataLayerLinkType(),
                                    mainTitle: mainTitle,
                                    downLoadLink: downLoadLink,
                                    containerId: containerId
                                }) : null
                            ]
                        }) : null
                    ]
                })
            }) : null,
            !innerCaption && caption ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-img-caption",
                children: (0,helper.sanitizeInnerHtml)(caption)
            }) : null,
            isOmnichannel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "stickychattop",
                ref: backToTopRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    role: "link",
                    className: "gbh-data-layer stickytop",
                    onClick: handleBackToTop,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            "aria-hidden": "true",
                            src: down_arrow_sort/* default */.Z === null || down_arrow_sort/* default */.Z === void 0 ? void 0 : down_arrow_sort/* default.src */.Z.src,
                            alt: "Scroll Down",
                            className: "backtopimg",
                            width: "18px",
                            height: "25px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "backtoptext",
                            children: "Scroll Down"
                        })
                    ]
                })
            }) : null
        ]
    });
};
/* harmony default export */ var v1_Teaser = (Teaser);

;// CONCATENATED MODULE: ./src/components/Default/Carousel/v1/CarouselFiller.jsx



const CarouselFiller = (param)=>{
    let { itemsOrder =[] , items =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-carousel__whole",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-carousel__content",
            children: itemsOrder.map((itemOrder, i)=>{
                const item = items[itemOrder];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-carousel__item".concat(i === 0 ? " cmp-carousel__item--active" : ""),
                    role: "tabpanel",
                    "aria-label": "Slide ".concat(i + 1, " of ").concat(itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
                        data: item
                    })
                }, "carousel-".concat(i));
            })
        })
    });
};
/* harmony default export */ var v1_CarouselFiller = (CarouselFiller);

;// CONCATENATED MODULE: ./components/Default/Carousel/v1/Carousel.jsx










const Carousel = (props)=>{
    const { data: { carouselComponentProperties: { appliedCssClassNames ="" , ":itemsOrder": itemsOrder = [] , ":items": items = [] , autoplay =false  } = {} , bodytitle ="" , texttitle ="" , description ="" , showSlideIndicators =true , slidertype =""  } = {} , fullData ={}  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [isOverlayScrollbar, setIsOverlayScrollbar] = (0,react.useState)(false);
    const [componentGroup, setComponentGroup] = (0,react.useState)([]);
    const [customClassNames, setCustomClassNames] = (0,react.useState)("");
    const [cmpCarouselCustomClass, setCmpCarouselCustomClass] = (0,react.useState)("");
    const [cmpCarouselCurrentImage, setCmpCarouselCurrentImage] = (0,react.useState)(0);
    const scrollOptions = {
        className: "os-theme-dark cmp-carousel__whole",
        style: "height:auto",
        scrollbars: {
            visibility: "auto",
            autoHide: "never"
        }
    };
    const showCarouselText = bodytitle || texttitle || description;
    const scrollerRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (scrollerRef.current) {
            setTimeout(()=>{
                document.querySelectorAll(".carousel-bottom-scroll").forEach((scrollDiv, index)=>{
                    let heightToSet = 0;
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".cmp-carousel__content").forEach((scrollDivContent, index)=>{
                        if (scrollDivContent && heightToSet < (scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight)) {
                            heightToSet = scrollDivContent === null || scrollDivContent === void 0 ? void 0 : scrollDivContent.offsetHeight;
                        }
                    });
                    scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.querySelectorAll(".os-content-glue").forEach((scrollDivglu, index)=>{
                        if (scrollDivglu && heightToSet > 0) {
                            scrollDivglu.style.height = heightToSet + "px";
                        }
                    });
                });
            }, 3000);
        }
    }, [
        scrollerRef.current
    ]);
    (0,react.useEffect)(()=>{
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-bottom-scroll")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-btm-scroll-title-small"))) {
            setIsOverlayScrollbar(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react.useEffect)(()=>{
        itemsOrder.forEach((key, i)=>{
            var ref;
            const item = items[key];
            if ((item === null || item === void 0 ? void 0 : (ref = item.appliedCssClassNamesCustom) === null || ref === void 0 ? void 0 : ref.includes("hero-banner-des-medium-center")) && i === 0 && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("center-double-btn"))) {
                setCustomClassNames((className)=>className += " center-double-btn");
            }
        });
    }, [
        itemsOrder
    ]);
    (0,react.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.CAROUSEL);
            }) && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("breadcrums-withcarosel paddingbasedbreadcrum"))) {
                setCustomClassNames((className)=>className += " breadcrums-withcarosel paddingbasedbreadcrum");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(constants.COMPONENT_TYPES.CAROUSEL);
            }) && !(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setCustomClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    (0,react.useEffect)(()=>{
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-btm-scroll-title-small")) && !(cmpCarouselCustomClass === null || cmpCarouselCustomClass === void 0 ? void 0 : cmpCarouselCustomClass.includes("carousel-btm-scroll-title-small"))) {
            setCmpCarouselCustomClass((className)=>className += " slide-scrollbar");
        }
    }, [
        appliedCssClassNames
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "carousel ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(customClassNames),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-carousel".concat(cmpCarouselCustomClass),
            children: [
                showCarouselText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "cmp-carousel-text",
                    children: [
                        bodytitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__pretitle",
                            role: "heading",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(bodytitle)
                            }
                        }) : null,
                        texttitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__title",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(texttitle)
                            }
                        }) : null,
                        description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-carousel__description",
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(description)
                            }
                        }) : null
                    ]
                }) : null,
                !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: isOverlayScrollbar,
                    wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(overlayscrollbars_react_esm/* OverlayScrollbarsComponent */.E, {
                            options: scrollOptions,
                            ref: scrollerRef,
                            defer: true,
                            children: children
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cmp-carousel__content",
                        children: [
                            itemsOrder && itemsOrder.map((key, i)=>{
                                const item = items[key];
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-carousel__item".concat(i === cmpCarouselCurrentImage ? " cmp-carousel__item--active" : ""),
                                    role: "tabpanel",
                                    "aria-label": "Slide ".concat(i + 1, " of ").concat(itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                                        data: item
                                    })
                                }, "carousel-".concat(i));
                            }),
                            (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cmp-carousel__actions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--previous",
                                        type: "button",
                                        "aria-label": "Previous",
                                        "data-cmp-hook-carousel": "previous",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Previous"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--next",
                                        type: "button",
                                        "aria-label": "Next",
                                        "data-cmp-hook-carousel": "next",
                                        onClick: ()=>cmpCarouselCurrentImage === itemsOrder.length - 1 ? setCmpCarouselCurrentImage(0) : setCmpCarouselCurrentImage(cmpCarouselCurrentImage + 1),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Next"
                                            })
                                        ]
                                    }),
                                    autoplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--pause",
                                        type: "button",
                                        "aria-label": "Pause",
                                        "data-cmp-hook-carousel": "pause",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Pause"
                                            })
                                        ]
                                    }),
                                    autoplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "cmp-carousel__action cmp-carousel__action--play cmp-carousel__action--disabled",
                                        type: "button",
                                        "aria-label": "Play",
                                        "data-cmp-hook-carousel": "play",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-icon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__action-text",
                                                children: "Play"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (slidertype === "slideindicator" || showSlideIndicators) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                className: "".concat(slidertype === "slideindicator" || showSlideIndicators ? "cmp-carousel__indicators" : "cmp-carousel__hyphen"),
                                role: "tablist",
                                "aria-label": "Choose a slide to display",
                                "data-cmp-hook-carousel": "indicators",
                                children: itemsOrder && (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.length) > 1 && itemsOrder.map((key, i, arr)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "cmp-carousel__indicator".concat(i === 0 ? " cmp-carousel__indicator--active" : ""),
                                        role: "tab",
                                        "aria-label": "Slide ".concat(i + 1),
                                        "data-cmp-hook-carousel": "indicator",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cmp-carousel__indicator--activeNum",
                                                children: i + 1
                                            }),
                                            "/ ".concat(arr === null || arr === void 0 ? void 0 : arr.length)
                                        ]
                                    }, "carousel-".concat(i));
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CarouselFiller, {
                    itemsOrder: itemsOrder,
                    items: items
                })
            ]
        })
    });
};
/* harmony default export */ var v1_Carousel = (Carousel);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./components/Default/CarouselSlick/v1/SlickSettings.js + 1 modules
var SlickSettings = __webpack_require__(86466);
;// CONCATENATED MODULE: ./src/components/Default/Image/v1/Image.jsx


const Image = (props)=>{
    const { data: { id: uniqueId = "" , alt ="" , src: imgUrl = "" , imageComponentProperties ={
        src: "",
        alt: ""
    }  } = {}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "eaem-bounding-div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage/* default */.Z, {
                    uniqueId,
                    imgUrl: imgUrl || imageComponentProperties.src,
                    alt: alt || imageComponentProperties.alt,
                    className: "cmp-image__image transition"
                })
            })
        })
    });
};
/* harmony default export */ var v1_Image = (Image);

;// CONCATENATED MODULE: ./src/components/Default/CarouselSlick/v1/AnalyticCarouselSlick.js
const getDataLayerValues = function(isSSR) {
    let pageName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", link = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", linkName = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (!isSSR && window) {
        var ref;
        const dataLayer = (ref = window === null || window === void 0 ? void 0 : window.adobeDataLayer) !== null && ref !== void 0 ? ref : {};
        var _page;
        const page = (_page = dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.getState().page) !== null && _page !== void 0 ? _page : {};
        if (Object.keys(page).length) {
            const eventInfo = {
                clickInternalLinks: "true",
                eventAction: "".concat(pageName, ":").concat(title.toLowerCase(), ":").concat(linkName.toLowerCase()),
                eventMsg: "n/a",
                eventName: "".concat(pageName, ":").concat(title.toLowerCase(), ":").concat(linkName.toLowerCase()),
                eventStatus: "n/a",
                eventType: "teaser",
                internalLinkName: "".concat(linkName.toLowerCase()),
                internalLinkPosition: "".concat(title.toLowerCase()),
                internalLinkType: "".concat(pageName, ":").concat(linkName.toLowerCase()),
                internalLinkURL: "".concat(link),
                internalLinkZoneName: "".concat(pageName, ":").concat(title.toLowerCase())
            };
            return JSON.stringify(eventInfo);
        }
    }
    return "";
};

;// CONCATENATED MODULE: ./src/components/Default/CarouselSlick/v1/CarouselSlick.jsx














const CarouselSlick = (props)=>{
    var ref;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { data , data: { carouselComponentProperties: { id ="" , autoplay =false , delay =constants["default"].SLICK.DEFAULT_DELAY , appliedCssClassNames ="" , ":itemsOrder": itemsOrder = [] , ":items": items = [] , accessibilityLabel =""  } = {} , pageName ="" , datalayerTitleText ="" , componentLinkType ="" , link: linkUrl = "" , componentPosition ="" , linkAll =false , isNewTab =false , bodytitle ="" , texttitle ="" , description ="" , actionsEnabled =false , text ="" , showSlideIndicators =false  } = {} , fullData ={}  } = props;
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const sliderDelay = 1500;
    const [slickSettings, setSlickSettings] = (0,react.useState)({});
    const [cardIndex, setCardIndex] = (0,react.useState)(0);
    const [sliderKey, setSliderKey] = (0,react.useState)("");
    const [cardCount, setCardCount] = (0,react.useState)(0);
    const [isDoubleFeatureContentCard, setIsDoubleFeatureContentCard] = (0,react.useState)(false);
    const [isSingleSlider, setIsSingleSlider] = (0,react.useState)(false);
    const [isSingleItemsSlider, setIsSingleItemsSlider] = (0,react.useState)(false);
    const [isFeatureContentSlider, setIsFeatureContentSlider] = (0,react.useState)(false);
    const [isInspiredThemeCarouselSlider, setIsInspiredThemeCarouselSlider] = (0,react.useState)(false);
    const [activeSlide, setActiveSlide] = (0,react.useState)(1);
    const [link, setLink] = (0,react.useState)(linkUrl);
    const carouselHeaderInfoRef = (0,react.useRef)(null);
    const sliderRef = (0,react.useRef)(null);
    const [topContentHeight, setTopContentHeight] = (0,react.useState)(0);
    const [sliderImageHeight, setSliderImageHeight] = (0,react.useState)(0);
    const [countHeight, setCountHeight] = (0,react.useState)(0);
    const [arrowHeight, setArrowHeight] = (0,react.useState)(0);
    const [sliderRerenderKey, setSliderRerenderKey] = (0,react.useState)("");
    let dynamicMediaTimer;
    const getImageHeight = (list)=>{
        if (dynamicMediaTimer) {
            clearTimeout(dynamicMediaTimer);
            dynamicMediaTimer = undefined;
        }
        // using query selector as s7responsiveImage is invoking functions on real dom elements ans was unable to get updated data using useRef
        const teaserImages = list.querySelectorAll(".slick-active .teaser .cmp-teaser__image .cmp-image");
        var ref;
        const teaserImageComponent = (ref = teaserImages[0]) !== null && ref !== void 0 ? ref : null;
        let teaserImage = null;
        if (teaserImageComponent) {
            teaserImage = teaserImageComponent.querySelector("img");
        }
        let imageUrl = null;
        if (teaserImage) {
            imageUrl = teaserImage === null || teaserImage === void 0 ? void 0 : teaserImage.currentSrc;
        }
        if (!window.s7responsiveImage || !imageUrl || imageUrl && imageUrl.startsWith("data:")) {
            dynamicMediaTimer = setTimeout(()=>getImageHeight(list), 200);
            return;
        }
        const imageHeight = teaserImageComponent === null || teaserImageComponent === void 0 ? void 0 : teaserImageComponent.offsetHeight;
        if (imageHeight) setSliderImageHeight(imageHeight);
    };
    (0,react.useEffect)(()=>{
        const { current: { offsetHeight =0  } = {}  } = carouselHeaderInfoRef;
        if (offsetHeight > 0) {
            setTopContentHeight(offsetHeight);
        }
    }, [
        carouselHeaderInfoRef
    ]);
    (0,react.useEffect)(()=>{
        const { current: { innerSlider: { list  }  } = {}  } = sliderRef;
        if (list && sliderRerenderKey) {
            getImageHeight(list);
        }
    }, [
        sliderRef,
        sliderRerenderKey
    ]);
    (0,react.useEffect)(()=>{
        const countHeight = parseInt(topContentHeight) + parseInt(sliderImageHeight) + constants["default"].SLICK.COUNT_OFFSET;
        setCountHeight(countHeight);
        if (winWidth <= 1023) {
            const arrowHeight = parseInt(sliderImageHeight) + constants["default"].SLICK.ARROW_OFFSET;
            setArrowHeight(arrowHeight);
        }
    }, [
        topContentHeight,
        sliderImageHeight
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fullData) && isDoubleFeatureContentCard) {
            const cardCount = Object.keys(fullData).length - 1;
            setCardCount(cardCount);
            Object.keys(fullData).forEach((key, index)=>{
                if (isEqual_default()(fullData[key], data)) {
                    setCardIndex(index + 1);
                }
            });
        }
    }, [
        fullData,
        isDoubleFeatureContentCard
    ]);
    (0,react.useEffect)(()=>{
        let timer;
        if (isDoubleFeatureContentCard) {
            if (cardIndex > 0 && cardCount > 0) {
                const delay = 1500 * (cardIndex - 1);
                timer = setTimeout(()=>{
                    setSlickSettings(()=>({
                            ...SlickSettings/* doubleFeatureContentCardSettings */.C,
                            autoplay: true,
                            speed: 2 * sliderDelay,
                            autoplaySpeed: cardCount * sliderDelay
                        }));
                    setSliderKey(cardIndex);
                }, delay);
            }
        }
        return ()=>{
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [
        cardIndex,
        cardCount,
        isDoubleFeatureContentCard
    ]);
    (0,react.useEffect)(()=>{
        if (isSingleSlider) {
            const slickSettings = (0,SlickSettings/* singleSliderSettings */.N)(setActiveSlide, arrowHeight, autoplay, delay);
            setSlickSettings(slickSettings);
        }
        if (isSingleItemsSlider || isFeatureContentSlider) {
            const settings = (0,SlickSettings/* singleSliderSettings */.N)(setActiveSlide, arrowHeight, autoplay, delay);
            const slickSettings1 = ()=>({
                    ...settings,
                    ...isSingleItemsSlider ? {
                        centerPadding: winWidth > 1600 ? winWidth / 8 : 72
                    } : {},
                    centerMode: winWidth >= 640
                });
            setSlickSettings(slickSettings1());
        }
        if (isInspiredThemeCarouselSlider) {
            const settings1 = (0,SlickSettings/* singleSliderSettings */.N)();
            const slickSettings2 = ()=>({
                    ...settings1,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    slidesToShow: winWidth > 1140 ? 4 : winWidth > 640 ? 2 : 1
                });
            setSlickSettings(slickSettings2());
        }
    }, [
        isSingleSlider,
        isSingleItemsSlider,
        isFeatureContentSlider,
        isInspiredThemeCarouselSlider,
        arrowHeight,
        winWidth
    ]);
    (0,react.useEffect)(()=>{
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("two-column-layout")) {
            setIsDoubleFeatureContentCard(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("feature-collection-carousel")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("room-inspiration-carousel"))) {
            setIsSingleSlider(true);
        }
        if ((appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("carousel-text-left-overlap")) || (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("full-bleed-image-hover"))) {
            setIsSingleItemsSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("featured-content-carousel")) {
            setIsFeatureContentSlider(true);
        }
        if (appliedCssClassNames === null || appliedCssClassNames === void 0 ? void 0 : appliedCssClassNames.includes("inspired-theme-carousel")) {
            setIsInspiredThemeCarouselSlider(true);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (linkUrl) {
            (0,helper.getShortenedUrl)(linkUrl).then((res)=>{
                setLink(res);
            });
        }
    }, [
        linkUrl
    ]);
    (0,react.useEffect)(()=>{
        let key = "slider-default";
        if (sliderKey) {
            key = "slider-".concat(sliderKey);
        }
        if (isSingleItemsSlider || isSingleSlider || isFeatureContentSlider || isInspiredThemeCarouselSlider) {
            key = "slider-".concat(id ? id : appliedCssClassNames);
        }
        setSliderRerenderKey(key);
    }, [
        sliderKey,
        isSingleItemsSlider,
        isSingleSlider,
        isFeatureContentSlider,
        isInspiredThemeCarouselSlider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-carousel cmp-carousel-slick",
                role: "group",
                "aria-label": accessibilityLabel || undefined,
                "aria-roledescription": "carousel",
                "data-gbh-data-layer": '{"eventName":"'.concat(pageName, ':carousel:interaction","eventAction":"').concat(pageName, ':carousel:interaction","internalLinkName":"carousel:').concat(datalayerTitleText || "rm", '","internalLinkType":"').concat(pageName, ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || datalayerTitleText || "rm", '","internalLinkZoneName":"').concat(pageName, ':carousel","clickInternalLinks":"true","eventType":"carousel","internalLinkURL":"').concat(link, '","internalLinkPosition":"').concat(pageName, ":").concat(componentPosition || "carousel", '"}'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                    condition: (0,helper.convertStringToBoolean)(linkAll),
                    wrapper: (children)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                            href: link,
                            "data-gbh-data-layer": '{"eventName":"'.concat(pageName, ':carousel:interaction","eventAction":"').concat(pageName, ':carousel:interaction","internalLinkName":"carousel:').concat(datalayerTitleText || "rm", '","internalLinkType":"').concat(pageName, ":").concat((componentLinkType === null || componentLinkType === void 0 ? void 0 : componentLinkType.toLowerCase()) || datalayerTitleText || "rm", '","internalLinkZoneName":"').concat(pageName, ':carousel","clickInternalLinks":"true","eventType":"carousel","internalLinkURL":"').concat(link, '","internalLinkPosition":"').concat(pageName, ":").concat(componentPosition || "carousel", '"}'),
                            "data-gbh-clickable": "true",
                            target: "".concat((0,helper.convertStringToBoolean)(isNewTab) ? "_blank" : "_self"),
                            children: children
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "carousel-header-info",
                                ref: carouselHeaderInfoRef,
                                children: [
                                    bodytitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__pretitle",
                                        dangerouslySetInnerHTML: {
                                            __html: bodytitle
                                        }
                                    }),
                                    texttitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__title",
                                        dangerouslySetInnerHTML: {
                                            __html: texttitle
                                        }
                                    }),
                                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-carousel__description",
                                        dangerouslySetInnerHTML: {
                                            __html: description
                                        }
                                    }),
                                    (0,helper.convertStringToBoolean)(actionsEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "cmp-carousel__action-container",
                                        children: [
                                            !(0,helper.convertStringToBoolean)(linkAll) && link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: link,
                                                className: "cmp-carousel__action-link",
                                                target: "".concat((0,helper.convertStringToBoolean)(isNewTab) ? "_blank" : "_self"),
                                                "data-gbh-data-layer": getDataLayerValues(isSsr, pageName, link, (0,helper.sanitizeTextArticle)(texttitle), (0,helper.sanitizeTextArticle)(text)),
                                                children: (0,helper.sanitizeInnerHtml)(text)
                                            }),
                                            ((0,helper.convertStringToBoolean)(linkAll) || !link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cmp-carousel__action-link",
                                                dangerouslySetInnerHTML: {
                                                    __html: text
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                                ...slickSettings,
                                className: "cmp-carousel-slick__content",
                                ref: sliderRef,
                                children: itemsOrder && (itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((key, index, arr)=>{
                                    const item = items[key];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            isDoubleFeatureContentCard && !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
                                                data: item
                                            }) : null,
                                            isSingleItemsSlider || isSingleSlider || isFeatureContentSlider || isInspiredThemeCarouselSlider ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
                                                data: item,
                                                showEmptyPlaceholder: showSlideIndicators,
                                                maxHeight: sliderImageHeight
                                            }) : null
                                        ]
                                    }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : "cpm-carousel-".concat(index, "-").concat((0,helper.getRandom)()));
                                }))
                            }, "".concat(sliderRerenderKey)),
                            showSlideIndicators && !isDoubleFeatureContentCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "slider__counter",
                                style: {
                                    top: countHeight + "px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "current-count",
                                        children: activeSlide
                                    }),
                                    "/",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "total-count",
                                        children: (ref = data["carouselComponentProperties"][":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.length
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hide",
                children: showSlideIndicators
            })
        ]
    });
};
/* harmony default export */ var v1_CarouselSlick = (CarouselSlick);

;// CONCATENATED MODULE: ./components/Shared/MainFooter.jsx





const MainFooter = (props)=>{
    const { data , columnClassNames , isOmnichannel , omniQRParams  } = props;
    const [gbhExpand, setGbhExpand] = (0,react.useState)([]);
    const handleGbhExpand = (key)=>{
        if (!gbhExpand.includes(key)) {
            const newGbhExpand = [
                ...gbhExpand
            ];
            newGbhExpand.push(key);
            setGbhExpand(newGbhExpand);
        } else {
            const newGbhExpand1 = [
                ...gbhExpand
            ];
            const idx = gbhExpand.indexOf(key);
            newGbhExpand1.splice(idx, 1);
            setGbhExpand(newGbhExpand1);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((index_module_default()).mainFooterWrapper, " ").concat(isOmnichannel ? "line-separator" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "gbh-footer-main-nav main-footer ".concat(isOmnichannel ? "change-background-color" : ""),
                "aria-label": "Footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "gbh-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleOne,
                                role: "list",
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationOne) == "descriptionOne" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleOne
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "gbh-find-store",
                                                role: "listitem",
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescOne)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationOne) == "linksOne" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !isOmnichannel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksOne") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksOne"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleOne)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksOne") ? {
                                                        display: "none"
                                                    } : {},
                                                    children: data === null || data === void 0 ? void 0 : data.items.map((item, index)=>{
                                                        var ref, ref1, ref2;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    className: "gbh-data-layer",
                                                                    href: (0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkOne),
                                                                    "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameOne).concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? " external link opens in a new tab" : ""),
                                                                    target: "".concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "_blank" : "_self"),
                                                                    rel: "noreferrer",
                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleOne.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat((0,helper.getAnalyticLinkUrl)((0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkOne)), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref = item.brandNameOne) === null || ref === void 0 ? void 0 : ref.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandNameOne) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameOne) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '"}'),
                                                                    children: item === null || item === void 0 ? void 0 : item.brandNameOne
                                                                })
                                                            })
                                                        }, "gbh-footer-main-nav-link-".concat(index));
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "footer-inner-head gbh-expand",
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleOne)
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    children: data === null || data === void 0 ? void 0 : data.items.map((item, index)=>{
                                                        var ref, ref1, ref2, ref3, ref4;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: "gbh-data-layer",
                                                                    href: !isOmnichannel ? (0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkOne) : (item === null || item === void 0 ? void 0 : item.brandLinkOne) !== "" ? ((ref1 = item === null || item === void 0 ? void 0 : (ref = item.brandNameOne) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("whatsapp")) ? "".concat((0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkOne.replace("Ref+ID%3A+", "Ref+ID%3A+".concat(encodeURIComponent(omniQRParams.qrId))))) : "".concat((0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkOne)) : undefined,
                                                                    style: {
                                                                        cursor: isOmnichannel ? item.brandLinkOne !== "" ? "pointer" : "auto" : "pointer"
                                                                    },
                                                                    "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameOne).concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? " external link opens in a new tab" : ""),
                                                                    target: "".concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "_blank" : "_self"),
                                                                    rel: "noreferrer",
                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabOne) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleOne.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat((0,helper.getAnalyticLinkUrl)((0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkOne)), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameOne) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref3 = item.brandNameOne) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref4 = item.brandNameOne) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(), '"}'),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "".concat(item === null || item === void 0 ? void 0 : item.brandNameOne.split(":")[0], ": ")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "underline",
                                                                            children: item === null || item === void 0 ? void 0 : item.brandNameOne.split(":")[1].trim()
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }, "gbh-footer-main-nav-link-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            !isOmnichannel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleTwo,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationTwo) == "descriptionTwo" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "footer-inner-head",
                                                role: "heading",
                                                "aria-level": "2",
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleTwo
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescTwo)
                                                }
                                            })
                                        ]
                                    }),
                                    data.radioNavigationTwo == "linksTwo" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksTwo") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksTwo"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleTwo)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksTwo") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsOne.length) > 4 ? "odd-even" : "",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsOne.map((item, index)=>{
                                                        var ref, ref1, ref2;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                href: (0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkTwo),
                                                                target: (item === null || item === void 0 ? void 0 : item.newTabTwo) ? "_blank" : "",
                                                                rel: "noreferrer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameTwo).concat((item === null || item === void 0 ? void 0 : item.newTabTwo) ? " external link opens in a new tab" : ""),
                                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabTwo) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleTwo.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat((0,helper.getAnalyticLinkUrl)((0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkTwo)), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref = item.brandNameTwo) === null || ref === void 0 ? void 0 : ref.toLowerCase(), '", "eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandNameTwo) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '", "internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameTwo) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '"}'),
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameTwo) && (item === null || item === void 0 ? void 0 : item.brandNameTwo)
                                                            })
                                                        }, "linksTwo-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : null,
                            !isOmnichannel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleThree,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.descriptionThree) == "descriptionThree" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleThree
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescThree)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationThree) == "linksThree" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksThree") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksThree"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleThree)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksThree") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsTwo.length) > 4 ? "odd-even" : "",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsTwo.map((item, index)=>{
                                                        var ref, ref1, ref2;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                href: (0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkThree),
                                                                target: (item === null || item === void 0 ? void 0 : item.newTabThree) ? "_blank" : "",
                                                                rel: "noreferrer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameThree).concat((item === null || item === void 0 ? void 0 : item.newTabThree) ? " external link opens in a new tab" : ""),
                                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabThree) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleThree.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat((0,helper.getAnalyticLinkUrl)((0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkThree)), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref = item.brandNameThree) === null || ref === void 0 ? void 0 : ref.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandNameThree) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameThree) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '"}'),
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameThree) && (item === null || item === void 0 ? void 0 : item.brandNameThree)
                                                            })
                                                        }, "linksThree-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : null,
                            !isOmnichannel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col",
                                "aria-label": data === null || data === void 0 ? void 0 : data.quadrantTitleFour,
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFour) == "descriptionFour" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: data === null || data === void 0 ? void 0 : data.quadrantTitleFour
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantDescFour)
                                                }
                                            })
                                        ]
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.radioNavigationFour) == "linksFour" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "gbh-footer-main-nav-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "footer-inner-head ".concat(gbhExpand.includes("linksFour") ? "gbh-expand" : ""),
                                                    role: "heading",
                                                    "aria-level": "2",
                                                    onClick: ()=>handleGbhExpand("linksFour"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: browser_default().sanitize(data === null || data === void 0 ? void 0 : data.quadrantTitleFour)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "accordion",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-1"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "line line-2"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    style: !gbhExpand.includes("linksFour") ? {
                                                        display: "none"
                                                    } : {},
                                                    className: (data === null || data === void 0 ? void 0 : data.itemsThree.length) > 4 ? "odd-even" : "",
                                                    children: data === null || data === void 0 ? void 0 : data.itemsThree.map((item, index)=>{
                                                        var ref, ref1, ref2;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "gbh-data-layer",
                                                                href: (0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkFour),
                                                                target: (item === null || item === void 0 ? void 0 : item.newTabFour) ? "_blank" : "",
                                                                rel: "noreferrer",
                                                                "aria-label": "".concat(item === null || item === void 0 ? void 0 : item.brandNameFour).concat((item === null || item === void 0 ? void 0 : item.newTabFour) ? " external link opens in a new tab" : ""),
                                                                "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((item === null || item === void 0 ? void 0 : item.newTabFour) ? "false" : "true", '","internalLinkPosition":"').concat(data === null || data === void 0 ? void 0 : data.quadrantTitleFour.toLowerCase(), '","internalLinkZoneName":"global footer","internalLinkURL":"').concat((0,helper.getAnalyticLinkUrl)((0,helper.removeAndCleanLinkConcat)(item === null || item === void 0 ? void 0 : item.brandLinkFour)), '","internalLinkName":"').concat(item === null || item === void 0 ? void 0 : (ref = item.brandNameFour) === null || ref === void 0 ? void 0 : ref.toLowerCase(), '","eventName":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref1 = item.brandNameFour) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"global footer:navigation","eventType":"footer submenu","eventAction":"footer menu:').concat(item === null || item === void 0 ? void 0 : (ref2 = item.brandNameFour) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '"}'),
                                                                children: (item === null || item === void 0 ? void 0 : item.brandNameFour) && (item === null || item === void 0 ? void 0 : item.brandNameFour)
                                                            })
                                                        }, "linksThree-".concat(index));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_MainFooter = (MainFooter);

// EXTERNAL MODULE: ./components/core/Accordion/Accordion.jsx
var Accordion = __webpack_require__(92173);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./public/icons/back-top-arrow.svg
var back_top_arrow = __webpack_require__(12522);
;// CONCATENATED MODULE: ./src/components/Default/Tab/v1/TabHelper.js


const that = {};
let dataLayerEnabled;
let dataLayer;
const getDataLayerId = (componentDataLayer)=>{
    return Object.keys(JSON.parse(componentDataLayer))[0];
};
const readData = function() {
    let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const { dataset: data = {}  } = element;
    const options = [];
    let capitalized = constants.IS;
    capitalized = ((ref = capitalized === null || capitalized === void 0 ? void 0 : capitalized.charAt(0)) === null || ref === void 0 ? void 0 : ref.toUpperCase()) + (capitalized === null || capitalized === void 0 ? void 0 : capitalized.slice(1));
    const reserved = [
        "is",
        "hook" + capitalized
    ];
    for(const key in data){
        if (data === null || data === void 0 ? void 0 : data.hasOwnProperty(key)) {
            const value = data[key];
            if ((key === null || key === void 0 ? void 0 : key.indexOf(constants.NS)) === 0) {
                var ref1;
                const newKey = key === null || key === void 0 ? void 0 : key.slice(constants.NS.length);
                const finalKey = ((ref1 = newKey === null || newKey === void 0 ? void 0 : newKey.charAt(0)) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) + (newKey === null || newKey === void 0 ? void 0 : newKey.substring(1));
                if ((reserved === null || reserved === void 0 ? void 0 : reserved.indexOf(finalKey)) === -1) {
                    options[finalKey] = value;
                }
            }
        }
    }
    return options;
};
const getActiveIndex = function() {
    let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (tabs) {
        return tabs === null || tabs === void 0 ? void 0 : tabs.findIndex((tab)=>{
            var ref, ref1;
            return tab === null || tab === void 0 ? void 0 : (ref = tab.classList) === null || ref === void 0 ? void 0 : ref.contains(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref1 = constants.selectors.active) === null || ref1 === void 0 ? void 0 : ref1.tab);
        });
    }
    return 0;
};
const cacheElements = function() {
    let wrapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    that._elements = {};
    that._elements.self = wrapper;
    const hooks = that === null || that === void 0 ? void 0 : (ref = that._elements) === null || ref === void 0 ? void 0 : (ref1 = ref.self) === null || ref1 === void 0 ? void 0 : ref1.querySelectorAll("[data-" + constants.NS + "-hook-" + constants.IS + "]");
    for (const hook of hooks){
        var ref2;
        if ((hook === null || hook === void 0 ? void 0 : hook.closest("." + constants.NS + "-" + constants.IS)) === (that === null || that === void 0 ? void 0 : (ref2 = that._elements) === null || ref2 === void 0 ? void 0 : ref2.self)) {
            var ref3;
            // only process own tab elements
            let capitalized = constants.IS;
            capitalized = ((ref3 = capitalized === null || capitalized === void 0 ? void 0 : capitalized.charAt(0)) === null || ref3 === void 0 ? void 0 : ref3.toUpperCase()) + (capitalized === null || capitalized === void 0 ? void 0 : capitalized.slice(1));
            const key = hook === null || hook === void 0 ? void 0 : hook.dataset[constants.NS + "Hook" + capitalized];
            if (that === null || that === void 0 ? void 0 : that._elements[key]) {
                var ref4;
                if (!(Array === null || Array === void 0 ? void 0 : Array.isArray(that === null || that === void 0 ? void 0 : that._elements[key]))) {
                    const tmp = that === null || that === void 0 ? void 0 : that._elements[key];
                    that._elements[key] = [
                        tmp
                    ];
                }
                (ref4 = that === null || that === void 0 ? void 0 : that._elements[key]) === null || ref4 === void 0 ? void 0 : ref4.push(hook);
            } else {
                that._elements[key] = hook;
            }
        }
    }
};
const focusWithoutScroll = function() {
    let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const x = (window === null || window === void 0 ? void 0 : window.scrollX) || (window === null || window === void 0 ? void 0 : window.pageXOffset);
    const y = (window === null || window === void 0 ? void 0 : window.scrollY) || (window === null || window === void 0 ? void 0 : window.pageYOffset);
    element === null || element === void 0 ? void 0 : element.focus();
    window === null || window === void 0 ? void 0 : window.scrollTo(x, y);
};
const refreshActive = ()=>{
    const tabpanels = that === null || that === void 0 ? void 0 : that._elements["tabpanel"];
    const tabs = that === null || that === void 0 ? void 0 : that._elements["tab"];
    const headerTabs = document === null || document === void 0 ? void 0 : document.querySelectorAll(".header-mega-menu-container .cmp-tabs div.cmp-tabs__tabpanel");
    if (tabpanels) {
        if (Array.isArray(tabpanels)) {
            tabpanels === null || tabpanels === void 0 ? void 0 : tabpanels.forEach((tabpanel, i)=>{
                var ref, ref1;
                if (i === parseInt(that === null || that === void 0 ? void 0 : that._active) && !((ref = headerTabs[that === null || that === void 0 ? void 0 : that._active]) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("cmp-tabs__tabpanel--active"))) {
                    var ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                    tabpanel === null || tabpanel === void 0 ? void 0 : (ref2 = tabpanel.classList) === null || ref2 === void 0 ? void 0 : ref2.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref3 = constants.selectors.active) === null || ref3 === void 0 ? void 0 : ref3.tabpanel);
                    tabpanel === null || tabpanel === void 0 ? void 0 : tabpanel.removeAttribute("aria-hidden");
                    (ref4 = tabs[i]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref6 = constants.selectors.active) === null || ref6 === void 0 ? void 0 : ref6.tab);
                    (ref7 = tabs[i]) === null || ref7 === void 0 ? void 0 : ref7.setAttribute("aria-selected", true);
                    (ref8 = tabs[i]) === null || ref8 === void 0 ? void 0 : ref8.setAttribute("tabindex", "0");
                } else {
                    var ref9, ref10, ref11, ref12, ref13, ref14;
                    tabpanel === null || tabpanel === void 0 ? void 0 : (ref9 = tabpanel.classList) === null || ref9 === void 0 ? void 0 : ref9.remove(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref10 = constants.selectors.active) === null || ref10 === void 0 ? void 0 : ref10.tabpanel);
                    tabpanel === null || tabpanel === void 0 ? void 0 : tabpanel.setAttribute("aria-hidden", true);
                    (ref11 = tabs[i]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.classList) === null || ref12 === void 0 ? void 0 : ref12.remove(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref13 = constants.selectors.active) === null || ref13 === void 0 ? void 0 : ref13.tab);
                    (ref14 = tabs[i]) === null || ref14 === void 0 ? void 0 : ref14.setAttribute("aria-selected", false);
                }
            });
        } else {
            var // only one tab
            ref, ref1, ref2, ref3;
            tabpanels === null || tabpanels === void 0 ? void 0 : (ref = tabpanels.classList) === null || ref === void 0 ? void 0 : ref.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref1 = constants.selectors.active) === null || ref1 === void 0 ? void 0 : ref1.tabpanel);
            tabs === null || tabs === void 0 ? void 0 : (ref2 = tabs.classList) === null || ref2 === void 0 ? void 0 : ref2.add(constants.selectors === null || constants.selectors === void 0 ? void 0 : (ref3 = constants.selectors.active) === null || ref3 === void 0 ? void 0 : ref3.tab);
        }
    }
};
const TabHelper_navigate = function() {
    let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    that._active = index;
    refreshActive();
};
const navigateAndFocusTab = function() {
    let index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    const exActive = that === null || that === void 0 ? void 0 : that._active;
    TabHelper_navigate(index);
    focusWithoutScroll(that === null || that === void 0 ? void 0 : that._elements["tab"][index]);
    if (dataLayerEnabled) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        const activeItem = getDataLayerId((ref1 = that === null || that === void 0 ? void 0 : (ref = that._elements) === null || ref === void 0 ? void 0 : ref.tabpanel[index]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dataset) === null || ref2 === void 0 ? void 0 : ref2.gbhDataLayer);
        const exActiveItem = getDataLayerId((ref4 = that === null || that === void 0 ? void 0 : (ref3 = that._elements) === null || ref3 === void 0 ? void 0 : ref3.tabpanel[exActive]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.dataset) === null || ref5 === void 0 ? void 0 : ref5.gbhDataLayer);
        dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
            event: "cmp:show",
            eventInfo: {
                path: "component." + activeItem
            }
        });
        dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
            event: "cmp:hide",
            eventInfo: {
                path: "component." + exActiveItem
            }
        });
        const tabsId = that === null || that === void 0 ? void 0 : (ref6 = that._elements) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.self) === null || ref7 === void 0 ? void 0 : ref7.id;
        const uploadPayload = {
            component: {}
        };
        uploadPayload.component[tabsId] = {
            shownItems: [
                activeItem
            ]
        };
        const removePayload = {
            component: {}
        };
        removePayload.component[tabsId] = {
            shownItems: undefined
        };
        dataLayer.push(removePayload);
        dataLayer.push(uploadPayload);
    }
};
const onKeyDown = function() {
    let event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    const index = that === null || that === void 0 ? void 0 : that._active;
    const lastIndex = ((ref = that === null || that === void 0 ? void 0 : that._elements["tab"]) === null || ref === void 0 ? void 0 : ref.length) - 1;
    const { ARROW_LEFT , ARROW_UP , ARROW_RIGHT , ARROW_DOWN , HOME , END  } = constants.keyCodes;
    const { keyCode =""  } = event;
    switch(keyCode){
        case ARROW_LEFT:
        case ARROW_UP:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            if (index > 0) {
                navigateAndFocusTab(index - 1);
            }
            break;
        case ARROW_RIGHT:
        case ARROW_DOWN:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            if (index < lastIndex) {
                navigateAndFocusTab(index + 1);
            }
            break;
        case HOME:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            navigateAndFocusTab(0);
            break;
        case END:
            event === null || event === void 0 ? void 0 : event.preventDefault();
            navigateAndFocusTab(lastIndex);
            break;
        default:
            return;
    }
};
const bindEvents = ()=>{
    const tabs = that === null || that === void 0 ? void 0 : that._elements["tab"];
    if (tabs) {
        tabs === null || tabs === void 0 ? void 0 : tabs.forEach((tab, index)=>{
            tab.addEventListener("click", ()=>{
                navigateAndFocusTab(index);
            });
            tab.addEventListener("keydown", (event)=>{
                onKeyDown(event);
            });
        });
    }
};
const init = function() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var // prevents multiple initialization
    ref, ref1;
    that._config = config;
    config === null || config === void 0 ? void 0 : (ref = config.element) === null || ref === void 0 ? void 0 : ref.removeAttribute("data-" + constants.NS + "-is");
    cacheElements(config === null || config === void 0 ? void 0 : config.element);
    that._active = getActiveIndex(that === null || that === void 0 ? void 0 : that._elements["tab"]);
    if (that === null || that === void 0 ? void 0 : (ref1 = that._elements) === null || ref1 === void 0 ? void 0 : ref1.tabpanel) {
        refreshActive();
        bindEvents();
    }
};
const tabs = function() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (config === null || config === void 0 ? void 0 : config.element) {
        init(config);
    }
};
const onDocumentReady = ()=>{
    dataLayerEnabled = false;
    dataLayer = dataLayerEnabled ? (window === null || window === void 0 ? void 0 : window.adobeDataLayer) || [] : undefined;
    const elements = document === null || document === void 0 ? void 0 : document.querySelectorAll(constants.selectors === null || constants.selectors === void 0 ? void 0 : constants.selectors.self);
    elements === null || elements === void 0 ? void 0 : elements.forEach(function() {
        let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        tabs({
            element: element,
            options: readData(element)
        });
    });
    const MutationObserver = (window === null || window === void 0 ? void 0 : window.MutationObserver) || (window === null || window === void 0 ? void 0 : window.WebKitMutationObserver) || (window === null || window === void 0 ? void 0 : window.MozMutationObserver);
    const body = document === null || document === void 0 ? void 0 : document.querySelector("body");
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            var ref, ref1;
            // needed for IE
            const nodesArray = (ref = []) === null || ref === void 0 ? void 0 : (ref1 = ref.slice) === null || ref1 === void 0 ? void 0 : ref1.call(mutation.addedNodes);
            if ((nodesArray === null || nodesArray === void 0 ? void 0 : nodesArray.length) > 0) {
                nodesArray === null || nodesArray === void 0 ? void 0 : nodesArray.forEach((addedNode)=>{
                    if (addedNode === null || addedNode === void 0 ? void 0 : addedNode.querySelectorAll) {
                        var ref, ref1;
                        const elementsArray = (ref = []) === null || ref === void 0 ? void 0 : (ref1 = ref.slice) === null || ref1 === void 0 ? void 0 : ref1.call(addedNode === null || addedNode === void 0 ? void 0 : addedNode.querySelectorAll(constants.selectors === null || constants.selectors === void 0 ? void 0 : constants.selectors.self));
                        elementsArray === null || elementsArray === void 0 ? void 0 : elementsArray.forEach((element)=>{
                            tabs({
                                element: element,
                                options: readData(element)
                            });
                        });
                    }
                });
            }
        });
    });
    observer === null || observer === void 0 ? void 0 : observer.observe(body, {
        subtree: true,
        childList: true,
        characterData: true
    });
};
const getActiveHash = (cb)=>{
    var ref;
    const url = new URL(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
    const hashed = (browser_default()) === null || (browser_default()) === void 0 ? void 0 : browser_default().sanitize(url === null || url === void 0 ? void 0 : url.hash);
    if ((hashed === null || hashed === void 0 ? void 0 : hashed.length) === 0) {
        return false;
    }
    const hashValue = decodeURIComponent(hashed === null || hashed === void 0 ? void 0 : hashed.slice(1));
    if (hashValue !== "") {
        const tabElements = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs .cmp-tabs__tablist .cmp-tabs__tab");
        tabElements === null || tabElements === void 0 ? void 0 : tabElements.forEach(function() {
            let child = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            const attr = child === null || child === void 0 ? void 0 : child.getAttribute("id");
            if (attr !== null) {
                var ref;
                child === null || child === void 0 ? void 0 : (ref = child.classList) === null || ref === void 0 ? void 0 : ref.remove("cmp-tabs__tab--active");
            }
            if (attr === hashValue) {
                var ref1;
                child === null || child === void 0 ? void 0 : (ref1 = child.classList) === null || ref1 === void 0 ? void 0 : ref1.add("cmp-tabs__tab--active");
            }
        });
        const tabPanelElements = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs .cmp-tabs__tabpanel");
        tabPanelElements === null || tabPanelElements === void 0 ? void 0 : tabPanelElements.forEach(function() {
            let child = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var ref;
            const attr = (ref = child === null || child === void 0 ? void 0 : child.getAttribute("data-hashid")) === null || ref === void 0 ? void 0 : ref.replaceAll("-", " ");
            if (attr !== null) {
                var ref1;
                child === null || child === void 0 ? void 0 : (ref1 = child.classList) === null || ref1 === void 0 ? void 0 : ref1.remove("cmp-tabs__tabpanel--active");
            }
            if (attr === hashValue) {
                var ref2;
                child === null || child === void 0 ? void 0 : (ref2 = child.classList) === null || ref2 === void 0 ? void 0 : ref2.add("cmp-tabs__tabpanel--active");
                cb && cb(hashValue);
            }
        });
    }
};
const setTabAnimation = function() {
    let tab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isTransitionDurationRemove = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const parent = tab === null || tab === void 0 ? void 0 : tab.closest(".tabs");
    const vertical = (parent === null || parent === void 0 ? void 0 : (ref = parent.classList) === null || ref === void 0 ? void 0 : ref.contains("vertical-tabs")) && ((ref1 = window === null || window === void 0 ? void 0 : window.matchMedia("(min-width: 1024px)")) === null || ref1 === void 0 ? void 0 : ref1.matches);
    const borderClr = (parent === null || parent === void 0 ? void 0 : (ref2 = parent.classList) === null || ref2 === void 0 ? void 0 : ref2.contains("bg-charcoal")) || (parent === null || parent === void 0 ? void 0 : (ref3 = parent.classList) === null || ref3 === void 0 ? void 0 : ref3.contains("bg-slate")) || ((ref4 = parent === null || parent === void 0 ? void 0 : parent.closest(".container")) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.classList) === null || ref5 === void 0 ? void 0 : ref5.contains("bg-charcoal")) || ((ref6 = parent === null || parent === void 0 ? void 0 : parent.closest(".container")) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.classList) === null || ref7 === void 0 ? void 0 : ref7.contains("bg-slate")) ? "#FFF" : "#212121";
    const tabList = tab === null || tab === void 0 ? void 0 : tab.parentElement;
    const selectionBar = tabList === null || tabList === void 0 ? void 0 : tabList.querySelector(".selectionBarcss");
    selectionBar.style.borderColor = borderClr;
    selectionBar.style.transitionDuration = isTransitionDurationRemove ? "0s" : ".5s";
    (ref8 = document === null || document === void 0 ? void 0 : document.querySelectorAll(".cmp-tabs__tablist")) === null || ref8 === void 0 ? void 0 : ref8.forEach(function() {
        let element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        element.style.position = "relative";
    });
    const rectTargetTab = tab === null || tab === void 0 ? void 0 : tab.getBoundingClientRect();
    const rectTabList = tabList === null || tabList === void 0 ? void 0 : tabList.getBoundingClientRect();
    if (vertical) {
        const selectionBarWidth = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.height) / (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.height);
        const selectionBarPosition = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.bottom) - (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.bottom);
        selectionBar.style.height = (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.height) + "px";
        selectionBar.style.transform = "matrix(1, 0, 0, ".concat(selectionBarWidth + (tabList === null || tabList === void 0 ? void 0 : tabList.scrollTop), ", 0, ").concat(selectionBarPosition, ")");
    } else {
        const selectionBarWidth1 = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.width) / (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.width);
        const selectionBarPosition1 = (rectTargetTab === null || rectTargetTab === void 0 ? void 0 : rectTargetTab.left) - (rectTabList === null || rectTabList === void 0 ? void 0 : rectTabList.left);
        selectionBar.style.transform = "matrix(".concat(selectionBarWidth1, ", 0, 0, 1, ").concat(selectionBarPosition1 + (tabList === null || tabList === void 0 ? void 0 : tabList.scrollLeft), ", -1)");
    }
};
const handleResizeEvent = ()=>{
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach(function() {
        let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            const activeTab = tabs === null || tabs === void 0 ? void 0 : tabs.querySelector(".cmp-tabs__tab.cmp-tabs__tab--active");
            if (activeTab) {
                setTabAnimation(activeTab, true);
            }
        }
    });
};
const handleHashchangeEvent = ()=>{
    getActiveHash();
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach(function() {
        let tabs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            const activeTab = tabs === null || tabs === void 0 ? void 0 : tabs.querySelector(".cmp-tabs__tab.cmp-tabs__tab--active");
            if (activeTab) {
                setTabAnimation(activeTab, false);
            }
        }
    });
};

;// CONCATENATED MODULE: ./components/Shared/CollapsibleFooter.jsx










const CollapsibleFooter = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const menuVisible = (0,react.useRef)(0);
    const backToTopRef = (0,react.useRef)(null);
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { data ={
        accordionProperties: {
            [":items"]: {
                tabs: {
                    [":items"]: {}
                }
            }
        }
    }  } = props;
    const [navOpen, setNavOpen] = (0,react.useState)(data === null || data === void 0 ? void 0 : (ref = data.accordionProperties) === null || ref === void 0 ? void 0 : (ref1 = ref[":items"]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tabs) === null || ref2 === void 0 ? void 0 : ref2.activeItem);
    const [menuOpen, setMenuOpen] = (0,react.useState)(false);
    const [width] = (0,useWindowResize/* default */.Z)();
    const [isMobile, setIsMobile] = (0,react.useState)( false ? 0 : width <= 1024);
    (0,react.useEffect)(()=>{
        setIsMobile(width <= 1024);
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        const selectionBar = document === null || document === void 0 ? void 0 : document.querySelectorAll(".selectionBarcss");
        if (!(selectionBar === null || selectionBar === void 0 ? void 0 : selectionBar.length)) {
            onDocumentReady();
            getActiveHash();
            window === null || window === void 0 ? void 0 : window.addEventListener("resize", handleResizeEvent);
            window === null || window === void 0 ? void 0 : window.addEventListener("hashchange", handleHashchangeEvent);
            // Create selectionBarDiv element
            const selectionBarDiv = document === null || document === void 0 ? void 0 : document.createElement("div");
            selectionBarDiv.className = "selectionBarcss";
            // Loop through each .tabs element
            const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
            tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach((tabs)=>{
                var ref;
                if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
                    var ref1, ref2, ref3, ref4;
                    const tab = tabs === null || tabs === void 0 ? void 0 : tabs.querySelector(".cmp-tabs__tablist");
                    tab === null || tab === void 0 ? void 0 : tab.insertAdjacentElement("afterbegin", selectionBarDiv);
                    const additionalCss = (tabs === null || tabs === void 0 ? void 0 : (ref1 = tabs.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("vertical-tabs")) && ((ref2 = window === null || window === void 0 ? void 0 : window.matchMedia("(min-width: 1201px)")) === null || ref2 === void 0 ? void 0 : ref2.matches) ? "selectionBar-vertical" : "selectionBar-horizontal";
                    (ref3 = tab === null || tab === void 0 ? void 0 : tab.querySelector(".selectionBarcss")) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.classList) === null || ref4 === void 0 ? void 0 : ref4.add(additionalCss);
                    const activeTab = tab === null || tab === void 0 ? void 0 : tab.querySelector(".cmp-tabs__tab.cmp-tabs__tab--active");
                    if (activeTab) setTabAnimation(activeTab);
                    const tabChildContainer = tab === null || tab === void 0 ? void 0 : tab.querySelectorAll(".cmp-tabs__tab");
                    tabChildContainer === null || tabChildContainer === void 0 ? void 0 : tabChildContainer.forEach((tabElement)=>{
                        tabElement === null || tabElement === void 0 ? void 0 : tabElement.addEventListener("click", function() {
                            let event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                            const { currentTarget ={}  } = event;
                            const clickedTab = currentTarget;
                            // Move the tabbed navigation to the center of viewport when clicking
                            clickedTab === null || clickedTab === void 0 ? void 0 : clickedTab.scrollIntoView({
                                block: "nearest",
                                inline: "center"
                            });
                            if (clickedTab) setTabAnimation(clickedTab);
                        });
                    });
                }
            });
        }
        return ()=>{
            window === null || window === void 0 ? void 0 : window.removeEventListener("resize", handleResizeEvent);
            window === null || window === void 0 ? void 0 : window.removeEventListener("hashchange", handleHashchangeEvent);
        };
    }, []);
    const onClickNav = (data)=>{
        if (navOpen !== data["cq:panelTitle"]) {
            setNavOpen(data["cq:panelTitle"]);
            menuVisible.current = 1;
            tabNavAnalytics(data["cq:panelTitle"]);
        }
    };
    const shortenUrl = (url)=>{
        return url.replace("/content/kohler-india/in/en", "").replace(".html", "");
    };
    const itemsOrder = data === null || data === void 0 ? void 0 : (ref3 = data.accordionProperties) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[":items"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.tabs) === null || ref5 === void 0 ? void 0 : ref5[":itemsOrder"];
    const items = data === null || data === void 0 ? void 0 : (ref6 = data.accordionProperties) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[":items"]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.tabs) === null || ref8 === void 0 ? void 0 : ref8[":items"];
    const eventPageType = "global footer";
    const expandAnalytics = ()=>{
        (0,helper.pushAnalyticsObjToDataLayer)({
            clickInternalLinks: "true",
            eventAction: "".concat(eventPageType, ":tabs:accordion ").concat(menuOpen ? "collapse" : "expand"),
            eventName: "".concat(eventPageType, ":tabs:accordion ").concat(menuOpen ? "collapse" : "expand"),
            eventType: "navigation",
            internalLinkName: "accordion ".concat(menuOpen ? "collapse" : "expand"),
            internalLinkPosition: eventPageType,
            internalLinkType: "".concat(eventPageType, ":tab navigation"),
            internalLinkZoneName: "".concat(eventPageType, ":tabs"),
            internalLinkURL: "n/a"
        });
    };
    const tabNavAnalytics = (tabName)=>{
        var ref;
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventPageType, ":tabs:tab navigation"),
            eventName: "".concat(eventPageType, ":tabs:tab navigation"),
            eventType: "navigation",
            internalLinkName: (ref = tabName === null || tabName === void 0 ? void 0 : tabName.toLowerCase()) !== null && ref !== void 0 ? ref : "",
            internalLinkPosition: eventPageType,
            internalLinkType: "".concat(eventPageType, ":tab navigation"),
            internalLinkZoneName: "".concat(eventPageType, ":tabs"),
            internalLinkURL: "n/a"
        };
        (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
    };
    let scrollTimer;
    let lastScrollTop = 0;
    const handleScroll = ()=>{
        const backToTopBtn = backToTopRef === null || backToTopRef === void 0 ? void 0 : backToTopRef.current;
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScroll < lastScrollTop && currentScroll > 50) {
            backToTopBtn.style.display = "block";
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(()=>{
                backToTopBtn.style.display = "none";
            }, 3000);
        } else {
            backToTopBtn.style.display = "none";
        }
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    };
    (0,react.useEffect)(()=>{
        const backToTopBtn = backToTopRef === null || backToTopRef === void 0 ? void 0 : backToTopRef.current;
        backToTopBtn.style.display = "none";
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const tabLinkAnalytics = (option, category)=>{
        const { subDisplayName ="" , subPageLink ="/"  } = option;
        const categoryName = (0,helper.cleanText)(category).replace(/&amp;/g, "&").replace(/\r/, "").replace(/\n/g, "").toLowerCase();
        var ref;
        const tabName = (ref = navOpen === null || navOpen === void 0 ? void 0 : navOpen.toLowerCase()) !== null && ref !== void 0 ? ref : "";
        const linkText = subDisplayName.toLowerCase();
        const linkUrl = window.location.origin + (0,helper.removeAndCleanLinkConcat)(subPageLink);
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventPageType, ":tabs:").concat(tabName, ":").concat(linkText),
            eventName: "".concat(eventPageType, ":tabs:").concat(tabName, ":").concat(linkText),
            eventType: "navigation",
            internalLinkName: linkText,
            internalLinkPosition: eventPageType,
            internalLinkType: "".concat(eventPageType, ":").concat(categoryName),
            internalLinkZoneName: "".concat(eventPageType, ":tabs:").concat(tabName),
            internalLinkURL: linkUrl
        };
        (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                isOpen: isSsr ? true : false,
                isArrow: true,
                contentElementId: "collapsible-footer-content",
                triggerElementId: "collapsible-footer",
                handleOpen: ()=>setMenuOpen(true),
                handleClose: ()=>setMenuOpen(false),
                expandAnalyticsEvent: expandAnalytics,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-accordion__item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cmp-accordion__panel",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tabs panelcontainer bg-slate",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cmp-tabs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                        role: "tablist",
                                        className: "cmp-tabs__tablist",
                                        "aria-multiselectable": "false",
                                        children: itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((key, index)=>{
                                            var ref, ref1;
                                            const item = items[key];
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        role: "tab",
                                                        className: "cmp-tabs__tab ".concat(navOpen == item["cq:panelTitle"] ? "cmp-tabs__tab--active" : isSsr ? "cmp-tabs__tab--active" : ""),
                                                        onClick: ()=>onClickNav(item),
                                                        tabIndex: "0",
                                                        children: item["cq:panelTitle"]
                                                    }),
                                                    isMobile && navOpen === item["cq:panelTitle"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "tabpanel",
                                                        tabIndex: "-1",
                                                        className: "cmp-tabs__tabpanel ".concat(navOpen === item["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : isSsr ? "cmp-tabs__tab--active" : ""),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(constants.staticClasses.CONTAINER),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "cmp-container",
                                                                children: (ref = Object.values(item[":itemsOrder"])) === null || ref === void 0 ? void 0 : ref.map((ele, i)=>{
                                                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "list",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "list-inner",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                    dangerouslySetInnerHTML: {
                                                                                        __html: DOMPurify.sanitize(item === null || item === void 0 ? void 0 : (ref = item[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref[ele]) === null || ref1 === void 0 ? void 0 : ref1.siteMapHeading)
                                                                                    }
                                                                                }),
                                                                                item === null || item === void 0 ? void 0 : (ref2 = item[":items"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[ele]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3["optionsSubHeader"]) === null || ref4 === void 0 ? void 0 : ref4.map((option, i)=>{
                                                                                    var ref;
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                href: isSsr ? shortenUrl(option === null || option === void 0 ? void 0 : option.subPageLink) : option === null || option === void 0 ? void 0 : (ref = option.subPageLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler-india/in").join(""),
                                                                                                "aria-label": "".concat(option === null || option === void 0 ? void 0 : option.subDisplayName).concat((option === null || option === void 0 ? void 0 : option.isNewTab) ? " external link opens in a new tab" : ""),
                                                                                                target: "".concat((option === null || option === void 0 ? void 0 : option.isNewTab) ? "_blank" : "_self"),
                                                                                                rel: "noreferrer",
                                                                                                onClick: ()=>tabLinkAnalytics(option),
                                                                                                children: option === null || option === void 0 ? void 0 : option.subDisplayName
                                                                                            })
                                                                                        })
                                                                                    }, "gbh-footer-main-nav-link-".concat(i));
                                                                                }),
                                                                                item === null || item === void 0 ? void 0 : (ref5 = item[":items"]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[ele]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6["options"]) === null || ref7 === void 0 ? void 0 : ref7.map((option, i)=>{
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: DOMPurify.sanitize(option === null || option === void 0 ? void 0 : option.subHeader)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    }, "gbh-footer-main-nav-link-".concat(i));
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        })
                                                    }, "navTabs-".concat(index)),
                                                    isSsr && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        role: "tabpanel",
                                                        tabIndex: "-1",
                                                        className: "cmp-tabs__tabpanel cmp-tabs__tab--active",
                                                        style: {
                                                            display: "block"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(constants.staticClasses.CONTAINER),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "cmp-container",
                                                                children: (ref1 = Object.values(item[":itemsOrder"])) === null || ref1 === void 0 ? void 0 : ref1.map((ele, i)=>{
                                                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "list",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "list-inner",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                    dangerouslySetInnerHTML: {
                                                                                        __html: DOMPurify.sanitize(item === null || item === void 0 ? void 0 : (ref = item[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref[ele]) === null || ref1 === void 0 ? void 0 : ref1.siteMapHeading)
                                                                                    }
                                                                                }),
                                                                                item === null || item === void 0 ? void 0 : (ref2 = item[":items"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[ele]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3["optionsSubHeader"]) === null || ref4 === void 0 ? void 0 : ref4.map((option, i)=>{
                                                                                    var ref;
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                href: isSsr ? shortenUrl(option === null || option === void 0 ? void 0 : option.subPageLink) : option === null || option === void 0 ? void 0 : (ref = option.subPageLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler-india/in").join(""),
                                                                                                "aria-label": "".concat(option === null || option === void 0 ? void 0 : option.subDisplayName).concat((option === null || option === void 0 ? void 0 : option.isNewTab) ? " external link opens in a new tab" : ""),
                                                                                                target: "".concat((option === null || option === void 0 ? void 0 : option.isNewTab) ? "_blank" : "_self"),
                                                                                                rel: "noreferrer",
                                                                                                onClick: ()=>tabLinkAnalytics(option),
                                                                                                children: option === null || option === void 0 ? void 0 : option.subDisplayName
                                                                                            })
                                                                                        })
                                                                                    }, "gbh-footer-main-nav-link-".concat(i));
                                                                                }),
                                                                                item === null || item === void 0 ? void 0 : (ref5 = item[":items"]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[ele]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6["options"]) === null || ref7 === void 0 ? void 0 : ref7.map((option, i)=>{
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: DOMPurify.sanitize(option === null || option === void 0 ? void 0 : option.subHeader)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    }, "gbh-footer-main-nav-link-".concat(i));
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        })
                                                    }, "navTabs-".concat(index))
                                                ]
                                            });
                                        })
                                    }),
                                    itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((key, index)=>{
                                        var ref, ref1;
                                        const item = items[key];
                                        if (!isMobile && navOpen === item["cq:panelTitle"]) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            role: "tabpanel",
                                            tabIndex: "-1",
                                            className: "cmp-tabs__tabpanel ".concat(navOpen === item["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : isSsr ? "cmp-tabs__tab--active" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(constants.staticClasses.CONTAINER),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cmp-container",
                                                    children: (ref = Object.values(item[":itemsOrder"])) === null || ref === void 0 ? void 0 : ref.map((ele, i)=>{
                                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "list",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "list-inner",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: DOMPurify.sanitize(item === null || item === void 0 ? void 0 : (ref = item[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref[ele]) === null || ref1 === void 0 ? void 0 : ref1.siteMapHeading)
                                                                        }
                                                                    }),
                                                                    item === null || item === void 0 ? void 0 : (ref2 = item[":items"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[ele]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3["optionsSubHeader"]) === null || ref4 === void 0 ? void 0 : ref4.map((option, i)=>{
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: isSsr ? shortenUrl(option === null || option === void 0 ? void 0 : option.subPageLink) : (0,helper.removeAndCleanLinkConcat)(option === null || option === void 0 ? void 0 : option.subPageLink),
                                                                                    "aria-label": "".concat(option === null || option === void 0 ? void 0 : option.subDisplayName).concat((option === null || option === void 0 ? void 0 : option.isNewTab) ? " external link opens in a new tab" : ""),
                                                                                    target: "".concat((option === null || option === void 0 ? void 0 : option.isNewTab) ? "_blank" : "_self"),
                                                                                    rel: "noreferrer",
                                                                                    onClick: ()=>{
                                                                                        var ref, ref1;
                                                                                        return tabLinkAnalytics(option, item === null || item === void 0 ? void 0 : (ref = item[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref[ele]) === null || ref1 === void 0 ? void 0 : ref1.siteMapHeading);
                                                                                    },
                                                                                    children: option === null || option === void 0 ? void 0 : option.subDisplayName
                                                                                })
                                                                            })
                                                                        }, "gbh-footer-main-nav-link-".concat(i));
                                                                    }),
                                                                    item === null || item === void 0 ? void 0 : (ref5 = item[":items"]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[ele]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6["options"]) === null || ref7 === void 0 ? void 0 : ref7.map((option, i)=>{
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                    dangerouslySetInnerHTML: {
                                                                                        __html: DOMPurify.sanitize(option === null || option === void 0 ? void 0 : option.subHeader)
                                                                                    }
                                                                                })
                                                                            })
                                                                        }, "gbh-footer-main-nav-link-".concat(i));
                                                                    })
                                                                ]
                                                            })
                                                        }, i);
                                                    })
                                                })
                                            })
                                        }, "navTabs-".concat(index));
                                        else if (!isMobile && isSsr) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            role: "tabpanel",
                                            tabIndex: "-1",
                                            className: "cmp-tabs__tabpanel cmp-tabs__tab--active",
                                            style: {
                                                display: "block"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(constants.staticClasses.CONTAINER),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "cmp-container",
                                                    children: (ref1 = Object.values(item[":itemsOrder"])) === null || ref1 === void 0 ? void 0 : ref1.map((ele, i)=>{
                                                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "list",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "list-inner",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: DOMPurify.sanitize(item === null || item === void 0 ? void 0 : (ref = item[":items"]) === null || ref === void 0 ? void 0 : (ref1 = ref[ele]) === null || ref1 === void 0 ? void 0 : ref1.siteMapHeading)
                                                                        }
                                                                    }),
                                                                    item === null || item === void 0 ? void 0 : (ref2 = item[":items"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[ele]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3["optionsSubHeader"]) === null || ref4 === void 0 ? void 0 : ref4.map((option, i)=>{
                                                                        var ref;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: isSsr ? shortenUrl(option === null || option === void 0 ? void 0 : option.subPageLink) : option === null || option === void 0 ? void 0 : (ref = option.subPageLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler-india/in").join(""),
                                                                                    "aria-label": "".concat(option === null || option === void 0 ? void 0 : option.subDisplayName).concat((option === null || option === void 0 ? void 0 : option.isNewTab) ? " external link opens in a new tab" : ""),
                                                                                    target: "".concat((option === null || option === void 0 ? void 0 : option.isNewTab) ? "_blank" : "_self"),
                                                                                    rel: "noreferrer",
                                                                                    onClick: ()=>tabLinkAnalytics(option),
                                                                                    children: option === null || option === void 0 ? void 0 : option.subDisplayName
                                                                                })
                                                                            })
                                                                        }, "gbh-footer-main-nav-link-".concat(i));
                                                                    }),
                                                                    item === null || item === void 0 ? void 0 : (ref5 = item[":items"]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[ele]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6["options"]) === null || ref7 === void 0 ? void 0 : ref7.map((option, i)=>{
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                    dangerouslySetInnerHTML: {
                                                                                        __html: DOMPurify.sanitize(option === null || option === void 0 ? void 0 : option.subHeader)
                                                                                    }
                                                                                })
                                                                            })
                                                                        }, "gbh-footer-main-nav-link-".concat(i));
                                                                    })
                                                                ]
                                                            })
                                                        }, i);
                                                    })
                                                })
                                            })
                                        }, "navTabs-".concat(index));
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "stickychattop",
                ref: backToTopRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    role: "link",
                    className: "gbh-data-layer stickytop",
                    onClick: handleBackToTop,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            "aria-hidden": "true",
                            src: back_top_arrow/* default */.Z === null || back_top_arrow/* default */.Z === void 0 ? void 0 : back_top_arrow/* default.src */.Z.src,
                            alt: "Back to Top",
                            className: "backtopimg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "backtoptext",
                            children: "Back to Top"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_CollapsibleFooter = (CollapsibleFooter);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(62863);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(95357);
;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/SubscribeInfoModal.jsx





const SubscribeInfoModal = (props)=>{
    var ref, ref1, ref2;
    const { show , handleModalClose , homePagePath , className , staticTexts , modalContent: modalContent  } = props;
    const { getReady , signupSuccess , getStarted  } = staticTexts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        showModal: show,
        onModalClose: handleModalClose,
        modalTitle: getReady !== null && getReady !== void 0 ? getReady : "",
        describedBy: "newsletter-description",
        labelledBy: "newsletter-title",
        className: "".concat(className ? className : "", " newsletter"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "newsletter",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "newsletter__content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter__thanks test-class",
                        id: "newsletter-title",
                        children: !isEmpty_default()(modalContent) ? (0,helper.sanitizeInnerHtml)(modalContent === null || modalContent === void 0 ? void 0 : (ref = modalContent.modalContent) === null || ref === void 0 ? void 0 : ref.title) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: (0,helper.sanitizeInnerHtml)(getReady)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "newsletter__success",
                        id: "newsletter-description",
                        children: !isEmpty_default()(modalContent) ? (0,helper.sanitizeInnerHtml)(modalContent === null || modalContent === void 0 ? void 0 : (ref1 = modalContent.modalContent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.description) === null || ref2 === void 0 ? void 0 : ref2.split("/content/kohler-india/in").join("").replace(".html", "")) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: (0,helper.sanitizeInnerHtml)(signupSuccess)
                        })
                    }),
                     false && /*#__PURE__*/ 0
                ]
            })
        })
    });
};
/* harmony default export */ var NewsletterFooter_SubscribeInfoModal = (SubscribeInfoModal);

// EXTERNAL MODULE: ./components/Shared/NewsletterFooter/index.module.scss
var NewsletterFooter_index_module = __webpack_require__(62582);
var NewsletterFooter_index_module_default = /*#__PURE__*/__webpack_require__.n(NewsletterFooter_index_module);
;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/localization.js
const getTranslations = (t)=>{
    return {
        thanks: t("kf.newsletter.label.thanks"),
        getReady: t("kf.newsletter.label.getReady"),
        signupSuccess: t("kf.newsletter.label.signupSuccess"),
        signUp: t("kf.newsletter.label.signUp"),
        getStarted: t("kf.newsletter.label.getStarted"),
        enterEmail: t("kf.newsletter.label.enterEmail"),
        validEmail: t("kf.newsletter.label.validEmail"),
        genError: t("kf.error.message.genericError"),
        alreadySubscribed: t("kf.newsletter.label.alreadySubscribed")
    };
};

;// CONCATENATED MODULE: ./components/Shared/NewsletterFooter/NewsletterFooter.jsx














const NewsletterFooter = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const [validationError, setValidationError] = (0,react.useState)("");
    const [email, setEmail] = (0,react.useState)("");
    const [captchaActive, setCaptchaActive] = (0,react.useState)(false);
    const submitButton = (0,react.useRef)(null);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [staticTexts, setStaticTexts] = (0,react.useState)({});
    const [siteName, setSiteName] = (0,react.useState)("");
    const [homePagePath, setHomePagePath] = (0,react.useState)("/");
    const [isShowModal, setIsShowModal] = (0,react.useState)(false);
    const [isResetForm, setIsResetForm] = (0,react.useState)(false);
    const [isAlreadyExist, setIsAlreadyExist] = (0,react.useState)(false);
    const { subscribeModal  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { data , columnClassNames  } = props;
    const addNewsletterSignupAnalytics = (status, message)=>{
        if (window.adobeDataLayer) {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const eventInfo = {
                "@type": (siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()) + "/components/newslettersignin",
                eventMsg: message || "n/a",
                eventStatus: status,
                clickInternalLinks: "true",
                internalLinkPosition: "newslettersignin",
                internalLinkZoneName: "global footer",
                internalLinkURL: "n/a",
                internalLinkName: "newsletter submit",
                eventName: "newsletter submit",
                internalLinkType: "global footer:submit",
                eventType: "click",
                eventAction: "newsletter submit"
            };
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo: eventInfo,
                page: page
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (isResetForm) setEmail("");
    }, [
        isResetForm,
        isAlreadyExist
    ]);
    (0,react.useEffect)(()=>{
        setCaptchaActive(false);
        setStaticTexts(getTranslations(t));
        setInitalData();
    }, []);
    const handleModalClose = ()=>{
        setIsShowModal(false);
    };
    const setInitalData = async ()=>{
        const config = await (0,constants_config/* getConfig */.i)();
        setSiteName(get_default()(config, "general.siteName", ""));
        setHomePagePath(await (0,helper.getShortenedUrl)(get_default()(config, "general.homepageUrl", "/")));
    };
    const getSubscriptionData = (email)=>{
        const body = {
            email: email
        };
        (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
            if (res.success) {
                api/* apim.post */.TH.post(constants.emailSubscribeEndPoint, body).then((response)=>{
                    if (response && response.data) {
                        var _resultMessages;
                        const isSuccess = (_resultMessages = response.data.resultMessages) !== null && _resultMessages !== void 0 ? _resultMessages : [];
                        if (isSuccess) {
                            setIsShowModal(true);
                            setIsResetForm(true);
                        }
                        setEmail("");
                        addNewsletterSignupAnalytics("success");
                    } else {
                        addNewsletterSignupAnalytics("failure", "news letter subscription api: error occured while fetching data from get url property");
                    // log.error(
                    //   "News letter subscription API: Error occured while fetching data from Get URL Property"
                    // )
                    }
                }).catch((err)=>{
                    var ref, ref1;
                    if (((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.statusCode) === 400) {
                        setIsAlreadyExist(true);
                        setValidationError(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed);
                        addNewsletterSignupAnalytics("failure", staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.alreadySubscribed.toLowerCase());
                    } else {
                        console.log(staticTexts.genError);
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: staticTexts.genError,
                            isVisible: true
                        }));
                        addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
                    }
                });
            } else {
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: staticTexts.genError,
                    isVisible: true
                }));
                addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
            }
        }).catch(()=>{
            dispatch((0,genericSlice/* showToast */.CF)({
                message: staticTexts.genError,
                isVisible: true
            }));
            addNewsletterSignupAnalytics("failure", staticTexts.genError.toLowerCase());
        });
    };
    const onSubmit = async ()=>{
        if (email === "" || email == null || (email === null || email === void 0 ? void 0 : email.length) == 0) {
            setValidationError(staticTexts.enterEmail);
            addNewsletterSignupAnalytics("failure", staticTexts.enterEmail.toLowerCase());
        }
        if ((email === null || email === void 0 ? void 0 : email.length) > 0) {
            const isValid = await (0,helper.validateField)("email", email);
            if (!isValid) {
                addNewsletterSignupAnalytics("failure", staticTexts.enterEmail.toLowerCase());
                setValidationError(staticTexts.validEmail);
            } else {
                setValidationError("");
                getSubscriptionData(email);
            }
        }
        handleFocus();
    };
    const handleFocus = ()=>{
        // removing focus
        submitButton.current.blur();
    };
    const handleChangeEmail = (e)=>{
        setEmail(e.target.value);
        setIsAlreadyExist(false);
        setValidationError("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((NewsletterFooter_index_module_default()).wrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "gbh-footer-newsletter-nav",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "gbh-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "gbh-footer-news-letter",
                                    "aria-label": data === null || data === void 0 ? void 0 : data.title,
                                    role: "list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: data === null || data === void 0 ? void 0 : data.title
                                        }),
                                        (0,helper.sanitizeInnerHtml)(data === null || data === void 0 ? void 0 : data.description),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-group newsletter-form-group",
                                            role: "listitem",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: "newsletter_input",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        className: "form-control",
                                                        type: "text",
                                                        "aria-label": data === null || data === void 0 ? void 0 : data.placeholder,
                                                        placeholder: data === null || data === void 0 ? void 0 : data.placeholder,
                                                        maxLength: "60",
                                                        id: "newsletter_input",
                                                        onChange: handleChangeEmail,
                                                        value: email,
                                                        "data-testid": "newsletter-input"
                                                    })
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.submit) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    "aria-label": "Submit button. Tap or click here to subscribe for Koher newsletter to receive news and promotions.",
                                                    className: "btn btn-secondary ".concat(email.length ? "active-btn" : ""),
                                                    id: "newsletter_submit",
                                                    onClick: ()=>onSubmit(),
                                                    ref: submitButton,
                                                    "data-testid": "newsletter-submit",
                                                    children: data === null || data === void 0 ? void 0 : data.submit
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            role: "listitem",
                                            className: "subsribe-error-container",
                                            children: validationError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                id: "subsribe-mail-error",
                                                tabIndex: "0",
                                                "data-testid": "email-error",
                                                children: (0,helper.sanitizeDOMString)(validationError)
                                            })
                                        })
                                    ]
                                })
                            }),
                            captchaActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterFooter_SubscribeInfoModal, {
                show: isShowModal,
                handleModalClose: handleModalClose,
                staticTexts: staticTexts,
                homePagePath: homePagePath,
                className: (NewsletterFooter_index_module_default()).wrapper,
                setEmail: setEmail,
                modalContent: subscribeModal
            })
        ]
    });
};
/* harmony default export */ var NewsletterFooter_NewsletterFooter = (NewsletterFooter);

;// CONCATENATED MODULE: ./components/Shared/AdditionalFooter.jsx





const AdditionalFooter = (props)=>{
    const { data , columnClassNames , isOmnichannel =false  } = props;
    const router = (0,next_router.useRouter)();
    const [location, setLocation] = (0,react.useState)("");
    const [docTitle, setDocTitle] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        setLocation(window.location.href);
        setDocTitle(document.title);
    }, [
        router.pathname
    ]);
    const getFooterLinkEvent = (item)=>{
        var ref, ref1, ref2;
        const linkUrl = (item === null || item === void 0 ? void 0 : item.link) ? item === null || item === void 0 ? void 0 : item.link : item === null || item === void 0 ? void 0 : item.authoredLink;
        const link = linkUrl ? ( true && (linkUrl === null || linkUrl === void 0 ? void 0 : linkUrl.indexOf("http")) === -1 ? window.location.origin : "") + (0,helper.removeAndCleanLinkConcat)(linkUrl) : "n/a";
        const eventInfo = {
            clickInternalLinks: (item === null || item === void 0 ? void 0 : item.newTab) ? "false" : "true",
            eventAction: "global footer:".concat(item === null || item === void 0 ? void 0 : (ref = item.linkLabel) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            eventName: "global footer:".concat(item === null || item === void 0 ? void 0 : (ref1 = item.linkLabel) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
            eventType: "footer menu-2",
            internalLinkName: item === null || item === void 0 ? void 0 : (ref2 = item.linkLabel) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(),
            internalLinkPosition: "global footer",
            internalLinkType: "global footer:navigation",
            internalLinkURL: link,
            internalLinkZoneName: "global footer"
        };
        return JSON.stringify(eventInfo);
    };
    const getSocialLinkEvent = function() {
        let siteName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", siteLink = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
        const eventInfo = {
            clickInternalLinks: "false",
            eventAction: "social media:".concat(siteName.toLowerCase()),
            eventName: "social media:".concat(siteName.toLowerCase()),
            eventType: "social icon",
            internalLinkName: "social media:".concat(siteName.toLowerCase()),
            internalLinkPosition: "global footer",
            internalLinkType: "global footer:navigation",
            internalLinkURL: siteLink,
            internalLinkZoneName: "global footer"
        };
        return JSON.stringify(eventInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(columnClassNames ? columnClassNames : "", " ").concat((index_module_default()).additionalFooterWrapper, " ").concat(isOmnichannel ? "line-separator change-background-color" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "additional-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "gbh-footer-add-nav",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "gbh-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "gbh-footer-add-panel",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "gbh-footer-nav__links",
                                    children: (data === null || data === void 0 ? void 0 : data.items) && (data === null || data === void 0 ? void 0 : data.items.map((item, index)=>{
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                id: item === null || item === void 0 ? void 0 : item.idLabel,
                                                className: item === null || item === void 0 ? void 0 : item.classLabel,
                                                "aria-label": item.linkLabel,
                                                target: item.newTab ? "_blank" : "_self",
                                                href: (0,helper.removeAndCleanLinkConcat)((item === null || item === void 0 ? void 0 : item.link) ? item === null || item === void 0 ? void 0 : item.link : item === null || item === void 0 ? void 0 : item.authoredLink),
                                                rel: "noreferrer",
                                                "data-gbh-data-layer": getFooterLinkEvent(item),
                                                children: item.linkLabel
                                            })
                                        }, "additionalfooteritem-".concat(index));
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "gbh-copy__rights",
                                    children: data.copyright
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "gbh-social__links",
                                    children: [
                                        (data === null || data === void 0 ? void 0 : data.email) == "email" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__email",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                className: "gbh-data-layer",
                                                "aria-label": "Email corporate page link opens in a new tab",
                                                href: "mailto:?body=".concat(location, "&subject=").concat(docTitle),
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelEmail,
                                                "data-gbh-data-layer": getSocialLinkEvent(data === null || data === void 0 ? void 0 : data.linkLabelEmail, data === null || data === void 0 ? void 0 : data.linkEmail)
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.facebook) == "facebook" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__facebook",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Facebook corporate page link opens in a new tab",
                                                href: data.linkFacebook,
                                                rel: "noreferrer noopener",
                                                title: data === null || data === void 0 ? void 0 : data.linkLabelFacebook,
                                                "data-gbh-data-layer": getSocialLinkEvent(data === null || data === void 0 ? void 0 : data.linkLabelFacebook, data === null || data === void 0 ? void 0 : data.linkFacebook),
                                                className: "gbh-data-layer"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.twitter) == "twitter" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__twitter",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Twitter corporate page link opens in a new tab",
                                                href: data.linkTwitter,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelTwitter,
                                                "data-gbh-data-layer": getSocialLinkEvent(data === null || data === void 0 ? void 0 : data.linkLabelTwitter, data === null || data === void 0 ? void 0 : data.linkTwitter),
                                                className: "gbh-data-layer"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.instagram) == "instagram" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__insta",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Instagram corporate page link opens in a new tab",
                                                href: data.linkInstagram,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelInstagram,
                                                "data-gbh-data-layer": getSocialLinkEvent(data === null || data === void 0 ? void 0 : data.linkLabelInstagram, data === null || data === void 0 ? void 0 : data.linkInstagram),
                                                className: "gbh-data-layer"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.pinterest) == "pinterest" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__pintrest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Pinterest corporate page link opens in a new tab",
                                                href: data.linkPinterest,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelPinterest,
                                                "data-gbh-data-layer": getSocialLinkEvent(data === null || data === void 0 ? void 0 : data.linkLabelPinterest, data === null || data === void 0 ? void 0 : data.linkPinterest),
                                                className: "gbh-data-layer"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.youtube) == "youtube" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__youtube",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Youtube corporate page link opens in a new tab",
                                                href: data.linkYoutube,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelYoutube,
                                                "data-gbh-data-layer": getSocialLinkEvent(data === null || data === void 0 ? void 0 : data.linkLabelYoutube, data === null || data === void 0 ? void 0 : data.linkYoutube),
                                                className: "gbh-data-layer"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.houzz) == "houzz" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__houzz",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Houzz corporate page link opens in a new tab",
                                                href: data.linkHouzz,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelHouzz,
                                                "data-gbh-data-layer": getSocialLinkEvent(data === null || data === void 0 ? void 0 : data.linkLabelHouzz, data === null || data === void 0 ? void 0 : data.linkHouzz),
                                                className: "gbh-data-layer"
                                            })
                                        }),
                                        (data === null || data === void 0 ? void 0 : data.linkedin) == "linkedin" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "gbh-social__linkedin",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                "aria-label": "Linkedin corporate page link opens in a new tab",
                                                href: data.linkLinkedin,
                                                rel: "noreferrer noopener",
                                                title: data.linkLabelLinkedin,
                                                "data-gbh-data-layer": getSocialLinkEvent(data === null || data === void 0 ? void 0 : data.linkLabelLinkedin, data === null || data === void 0 ? void 0 : data.linkLinkedin),
                                                className: "gbh-data-layer"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_AdditionalFooter = (AdditionalFooter);

;// CONCATENATED MODULE: ./components/Default/Text/v1/Text.jsx




const Text = (props)=>{
    const [dataVal, setDataVal] = (0,react.useState)("");
    const { data: { text ="" , appliedCssClassNames ="" , richText =false  } = {} , omniQRParams , isOmnichannel  } = props;
    const removeHtmlExtension = async ()=>{
        const newData = await (0,utils_location/* getShortenedUrl */.Pp)(text);
        if (isOmnichannel && omniQRParams.qrId !== "") {
            const updatedDataVal = newData.replace("Ref+ID%3A+", "Ref+ID%3A+".concat(encodeURIComponent(omniQRParams.qrId)));
            setDataVal(updatedDataVal);
        } else {
            setDataVal(newData);
        }
    };
    (0,react.useEffect)(()=>{
        if (richText) {
            removeHtmlExtension();
        }
    }, [
        richText
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        children: richText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: (0,helper.sanitizeInnerHtml)(dataVal)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "cmp-text__paragraph",
                "aria-label": text,
                children: text
            })
        })
    });
};
/* harmony default export */ var v1_Text = (Text);

;// CONCATENATED MODULE: ./components/Shared/Footer.jsx











const SitewideWarning = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3998).then(__webpack_require__.bind(__webpack_require__, 13998)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(13998)
            ]
    },
    ssr: false
});
const Footer = (props)=>{
    const { data , isOmnichannel , omniQRParams  } = props;
    const { siteWideWarning  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data[":itemsOrder"].map((key, index)=>{
            var ref;
            const item = data[":items"][key];
            if (key === "accordion") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_CollapsibleFooter, {
                        data: item,
                        columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key])
                    }, "".concat(key, "-").concat(index))
                }, "".concat(key, "-").concat(index));
            }
            if (key === "mainfooter") {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_MainFooter, {
                            data: item,
                            columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key]),
                            isOmnichannel: isOmnichannel,
                            omniQRParams: omniQRParams
                        }, "".concat(key, "-").concat(index)),
                        (siteWideWarning === null || siteWideWarning === void 0 ? void 0 : siteWideWarning.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SitewideWarning, {
                            isRendered: siteWideWarning.isRendered,
                            siteWideWarning: siteWideWarning === null || siteWideWarning === void 0 ? void 0 : siteWideWarning.content
                        }, "".concat(key, "-").concat(index, "-SitewideWarning"))
                    ]
                }, "".concat(key, "-").concat(index));
            }
            if (key === "newslettersignin") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterFooter_NewsletterFooter, {
                    data: item,
                    columnClassNames: "".concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
            if (key.includes("additionalfooter")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_AdditionalFooter, {
                    data: item,
                    columnClassNames: "".concat(data[":items"][key]["appliedCssClassNames"], " ").concat(key, " ").concat(data.columnClassNames[key]),
                    isOmnichannel: isOmnichannel
                }, "".concat(key, "-").concat(index));
            }
            if ((ref = item[":type"]) === null || ref === void 0 ? void 0 : ref.includes(constants.COMPONENT_TYPES.TEXT)) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Text, {
                    data: item,
                    columnClassNames: "".concat(data[":items"][key]["appliedCssClassNames"], " ").concat(key, " ").concat(data.columnClassNames[key])
                }, "".concat(key, "-").concat(index));
            }
        })
    });
};
/* harmony default export */ var Shared_Footer = (Footer);

;// CONCATENATED MODULE: ./utils/lazyLoadImage.js
const loadLazyImage = (srcRef, imgRef)=>{
    const newSourceRef = Array.isArray(srcRef === null || srcRef === void 0 ? void 0 : srcRef.current) ? srcRef === null || srcRef === void 0 ? void 0 : srcRef.current : [
        srcRef === null || srcRef === void 0 ? void 0 : srcRef.current
    ];
    if ((newSourceRef === null || newSourceRef === void 0 ? void 0 : newSourceRef.length) > 0) {
        newSourceRef.forEach((src, index)=>{
            if (src === null || src === void 0 ? void 0 : src.hasAttribute("data-srcset")) {
                var ref;
                (ref = newSourceRef[index]) === null || ref === void 0 ? void 0 : ref.setAttribute("srcset", src === null || src === void 0 ? void 0 : src.getAttribute("data-srcset"));
                src === null || src === void 0 ? void 0 : src.removeAttribute("data-srcset");
            }
        });
    }
    const newImageRef = Array.isArray(imgRef === null || imgRef === void 0 ? void 0 : imgRef.current) ? imgRef === null || imgRef === void 0 ? void 0 : imgRef.current : [
        imgRef === null || imgRef === void 0 ? void 0 : imgRef.current
    ];
    if ((newImageRef === null || newImageRef === void 0 ? void 0 : newImageRef.length) > 0) {
        newImageRef.forEach((img, index)=>{
            if (img === null || img === void 0 ? void 0 : img.hasAttribute("data-src")) {
                var ref;
                (ref = newImageRef[index]) === null || ref === void 0 ? void 0 : ref.setAttribute("src", img === null || img === void 0 ? void 0 : img.getAttribute("data-src"));
                img === null || img === void 0 ? void 0 : img.removeAttribute("data-src");
            }
        });
    }
};

;// CONCATENATED MODULE: ./src/components/Default/Image/v3/Image.jsx






const CustomImage = (props)=>{
    const { data  } = props;
    const { linkURL , newTab , fileReference , imageLazyLoad , defaultRenditions: imageModifiersScene7 , defaultImageURL , imageURLWithoutCrop , displayPopupTitle , imageComponentProperties: { alt , title  } , description , items  } = data;
    const pictureRef = (0,react.useRef)(null);
    const sourcesRef = (0,react.useRef)([]);
    const imageRef = (0,react.useRef)(null);
    const { ref: inViewRef , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        threshold: 0
    });
    const placeholderImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const lazyLoadValue = (0,helper.convertStringToBoolean)(imageLazyLoad) ? "false" : "true";
    const finalSrcValue = "".concat(defaultImageURL ? defaultImageURL : imageURLWithoutCrop).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "");
    const content = (0,helper.convertStringToBoolean)(imageLazyLoad) && fileReference ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        ref: pictureRef,
        lazyload: lazyLoadValue,
        children: [
            items.map((obj, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    ref: (el)=>sourcesRef.current[index] = el,
                    media: "(min-width: ".concat(obj.deviceSize, ")"),
                    alt: alt || "true",
                    srcSet: placeholderImage,
                    "data-srcset": "".concat(obj.imageURL).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "")
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                ref: imageRef,
                className: "cmp-image__image",
                src: placeholderImage,
                "data-src": finalSrcValue,
                alt: alt || "true",
                style: {
                    width: "100%"
                }
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        lazyload: lazyLoadValue,
        children: [
            items.map((obj, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    ref: (el)=>sourcesRef.current[index] = el,
                    media: "(min-width: ".concat(obj.deviceSize, ")"),
                    alt: alt || "true",
                    srcSet: "".concat(obj.imageURL).concat(imageModifiersScene7 ? "?" : "").concat(imageModifiersScene7 ? imageModifiersScene7 : "")
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                ref: imageRef,
                className: "cmp-image__image",
                src: finalSrcValue,
                alt: alt || "true",
                style: {
                    width: "100%"
                }
            })
        ]
    });
    (0,react.useEffect)(()=>{
        if (inView) {
            if ((0,helper.convertStringToBoolean)(imageLazyLoad)) {
                loadLazyImage(sourcesRef, imageRef);
            }
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cmp-image",
        itemScope: true,
        itemType: "https://schema.org/ImageObject",
        ref: inViewRef,
        children: [
            linkURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "cmp-image__link",
                href: linkURL,
                target: (0,helper.convertStringToBoolean)(newTab) ? "_blank" : "_self",
                rel: "noreferrer",
                children: content
            }) : content,
            !(0,helper.convertStringToBoolean)(displayPopupTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "cmp-image__title",
                itemProp: "caption",
                dangerouslySetInnerHTML: {
                    __html: browser_default().sanitize(description)
                }
            }),
            (0,helper.convertStringToBoolean)(displayPopupTitle) && title && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "caption",
                content: title
            })
        ]
    });
};
/* harmony default export */ var v3_Image = (CustomImage);

;// CONCATENATED MODULE: ./components/Default/List/v1/List.jsx




const List = (param)=>{
    let { data ={}  } = param;
    const [open, setopen] = (0,react.useState)(false);
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    const { siteMapHeading ="" , options =[]  } = data;
    const [width] = (0,useWindowResize/* default */.Z)();
    (0,react.useEffect)(()=>{
        setIsMobile(width <= 991);
    }, [
        width
    ]);
    const handleOpen = ()=>{
        if (isMobile) {
            setopen(!open);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "list-inner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "cmp-list__heading ".concat(open ? "active" : ""),
                onClick: handleOpen,
                children: siteMapHeading === null || siteMapHeading === void 0 ? void 0 : siteMapHeading.replace(/<[^>]*>/g, "")
            }),
            options.map((listItem)=>{
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("ul", {
                    className: "cmp-list",
                    style: {
                        display: !isMobile || open ? "block" : "none"
                    },
                    children: [
                        listItem.subHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "cmp-list__subhead",
                            children: listItem.subHeader
                        }) : null,
                        (ref = listItem.subHeaderItem) === null || ref === void 0 ? void 0 : ref.map((innerListItem)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "cmp-page-name",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: innerListItem.isNewTab ? "_blank" : "",
                                        rel: innerListItem.subPageLinkRef ? "noreferrer" : "",
                                        href: (0,helper.removeAndCleanLinkConcat)(innerListItem.subPageLink),
                                        children: innerListItem.subDisplayName
                                    })
                                })
                            }))
                    ]
                });
            })
        ]
    });
};
/* harmony default export */ var v1_List = (List);

// EXTERNAL MODULE: ./src/components/HelpSupport/v1/index.module.scss
var v1_index_module = __webpack_require__(18476);
var v1_index_module_default = /*#__PURE__*/__webpack_require__.n(v1_index_module);
;// CONCATENATED MODULE: ./components/HelpSupport/v1/HelpSupport.jsx






const HelpSupport = (param)=>{
    let { data  } = param;
    const { helpTitle ="" , helpDescription ="" , chatTitle ="" , chatDescription ="" , chatLink ="" , chatLinkRef =false , contactTitle ="" , contactDescription ="" , prodSupportTitle ="" , prodSupportDescription ="" , prodSupportItems =[] , chatText ="" , contactItems =[] , pageName ="" , enableChat =false  } = data;
    const whatsappRef = (0,react.useRef)(null);
    const addWhatsappLinkAnalytics = (page, text, link)=>{
        const eventInfo = {
            clickInternalLinks: "false",
            eventAction: "".concat(page, ":call us:").concat(text),
            eventName: "".concat(page, ":call us:").concat(text),
            eventType: "navigation",
            internalLinkName: text,
            internalLinkPosition: "help support",
            internalLinkType: "".concat(page, ":").concat(text),
            internalLinkZoneName: "".concat(page, ":call us"),
            internalLinkURL: link
        };
        (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
    };
    const addWhatsappClickEvent = ()=>{
        const links = whatsappRef.current.querySelectorAll("a");
        const titles = whatsappRef.current.querySelectorAll("h1, h2, h3, h4, h5, h6");
        if (links[0]) {
            links[0].addEventListener("click", ()=>{
                var ref, ref1;
                return addWhatsappLinkAnalytics(pageName, (ref = titles[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.innerText) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), links[0].getAttribute("href"));
            });
        }
    };
    (0,react.useEffect)(()=>{
        // to add analytics for whatsapp link
        if (chatTitle) {
            setTimeout(addWhatsappClickEvent, 100);
        }
    }, [
        chatTitle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (v1_index_module_default()).helpSupportWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "help-support ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "gbh-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "help-support-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "help-support-left-title",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(helpTitle)
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "help-support-left-description",
                                dangerouslySetInnerHTML: {
                                    __html: browser_default().sanitize(helpDescription)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "help-support-right",
                        children: [
                            chatTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(chatTitle)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(chatDescription)
                                        }
                                    }),
                                    chatLink && enableChat && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: (0,helper.removeAndCleanLink)(chatLink),
                                        target: chatLinkRef ? "_blank" : "_self",
                                        rel: "noopener noreferrer",
                                        "data-gbh-data-layer": '{"clickInternalLinks":"'.concat(!chatLinkRef, '","internalLinkPosition":"help support","internalLinkZoneName":"').concat(pageName, ':help and support","internalLinkURL":"').concat((0,helper.removeAndCleanLink)(chatLink), '","internalLinkName":"').concat(chatTitle, '","eventName":"').concat(pageName, ":help and support:").concat(chatTitle, '","internalLinkType":"').concat(pageName, ':navigation","eventType":"help support","eventAction":"').concat(pageName, ":help and support:").concat(chatTitle, '"}'),
                                        className: "gbh-data-layer",
                                        children: chatText
                                    })
                                ]
                            }),
                            contactTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: whatsappRef,
                                        className: "chat-title wa",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(contactTitle)
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(contactDescription)
                                        }
                                    }),
                                    contactItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "contact-number",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: contactItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:".concat(item.phoneNumber),
                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"help support","internalLinkZoneName":"'.concat(pageName, ':help and support","internalLinkURL":"tel:').concat(item.phoneNumber, '","internalLinkName":"').concat(item.phoneNumber, '","eventName":"').concat(pageName, ":help and support:").concat(item.phoneNumber, '","internalLinkType":"').concat(pageName, ':call our team","eventType":"help support","eventAction":"').concat(pageName, ":help and support:").concat(item.phoneNumber, '"}'),
                                                        className: "gbh-data-layer",
                                                        children: item.phoneNumber
                                                    })
                                                }, "".concat(item.phoneNumber, "+").concat(index)))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "chat",
                                children: [
                                    prodSupportTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-title",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(prodSupportTitle)
                                        }
                                    }),
                                    prodSupportDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "chat-description",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize((0,helper.removeAndCleanLink)(prodSupportDescription))
                                        }
                                    }),
                                    prodSupportItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "support-links",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: prodSupportItems.map((item)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                    className: item.isDisplayButton ? "chat-button" : "",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: (0,helper.removeAndCleanLink)(item === null || item === void 0 ? void 0 : item.linkProdSup),
                                                        target: item.isNewTabProd ? "_blank" : "_self",
                                                        rel: "noopener noreferrer",
                                                        "data-gbh-data-layer": '{"clickInternalLinks": "'.concat(item.isNewTabProd ? "false" : "true", '", "internalLinkPosition": "help support", "internalLinkZoneName": "').concat(pageName, ':help and support", "internalLinkURL": "').concat((0,helper.removeAndCleanLink)(item === null || item === void 0 ? void 0 : item.linkProdSup), '", "internalLinkName": "').concat(item.labelProdSup, '", "eventName": "').concat(pageName, ":help and support:").concat(item.labelProdSup, '", "internalLinkType": "').concat(pageName, ':product support", "eventType": "help support", "eventAction": "').concat(pageName, ":help and support:").concat(item.labelProdSup, '"}'),
                                                        className: "gbh-data-layer",
                                                        children: item.labelProdSup
                                                    })
                                                }, item.labelProdSup);
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_HelpSupport = (HelpSupport);

// EXTERNAL MODULE: ./components/FindAStore/FindAStore.jsx + 5 modules
var FindAStore = __webpack_require__(55089);
;// CONCATENATED MODULE: ./components/Default/Tab/v1/TabAnalytics.js

const TabAnalytics_getEventInfo = function() {
    let componentPosition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", eventName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", componentLinkType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", eventAction = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", eventPageType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", pageType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", item = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {};
    var ref;
    const panelTitle = ((ref = item["cq:panelTitle"]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
    const isSupportPage = eventPageType.includes("support");
    const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
    let zoneVal;
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach((tabs)=>{
        var ref;
        if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
            zoneVal = videoAnalytics_getComponentZone(tabs === null || tabs === void 0 ? void 0 : tabs.parentElement);
        }
    });
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "tabs",
        internalLinkZoneName: "".concat(eventPageType, ":").concat(zoneVal),
        internalLinkURL: "n/a",
        internalLinkName: "".concat(panelTitle),
        eventName: "".concat(eventPageType, ":").concat(zoneVal, ":").concat(eventName || isSupportPage ? "submenu" : panelTitle || "submenu navigation link"),
        internalLinkType: "".concat(eventPageType, ":").concat(componentLinkType || "navigation"),
        eventType: "tab",
        eventAction: "".concat(eventPageType, ":").concat(zoneVal, ":").concat(eventAction || isSupportPage ? "submenu" : panelTitle || "submenu navigation link")
    };
    if (eventPageType.includes("find a store")) {
        eventInfo.internalLinkType = "find a store:navigation";
        eventInfo.eventName = "".concat(eventPageType, ":").concat(zoneVal, ":tab navigation");
        eventInfo.eventAction = "".concat(eventPageType, ":").concat(zoneVal, ":tab navigation");
    }
    return eventInfo;
};
const handleTabClickDatalayer = (eventInfo)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window !== null && window !== void 0 ? window : {};
    const page = getState ? getState("page") : {};
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const handleDatalayer = (param)=>{
    let { componentPosition ="" , eventName ="" , componentLinkType ="" , eventAction ="" , eventPageType ="" , item ={} , selectedTab ="" , panelTitle =""  } = param;
    if (selectedTab != panelTitle) {
        var ref, ref1, ref2;
        let zoneVal;
        const tabContainer = document === null || document === void 0 ? void 0 : document.querySelectorAll(".tabs");
        tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.forEach((tabs)=>{
            var ref;
            if (!(tabs === null || tabs === void 0 ? void 0 : (ref = tabs.classList) === null || ref === void 0 ? void 0 : ref.contains("gbh-global-tab"))) {
                zoneVal = getComponentZone(tabs === null || tabs === void 0 ? void 0 : tabs.parentElement);
            }
        });
        const replacements = {
            zone: zoneVal,
            "global header": zoneVal
        };
        const regex = new RegExp((ref = Object.keys(replacements)) === null || ref === void 0 ? void 0 : ref.join("|"), "g");
        const { adobeDataLayer: { getState  } = {}  } = window !== null && window !== void 0 ? window : {};
        const page = getState ? getState("page") : {};
        const eventInfoData = (ref1 = TabAnalytics_getEventInfo(componentPosition, eventName, componentLinkType, eventAction, eventPageType, item)) === null || ref1 === void 0 ? void 0 : ref1.replaceAll(regex, (match)=>replacements[match]);
        window === null || window === void 0 ? void 0 : (ref2 = window.adobeDataLayer) === null || ref2 === void 0 ? void 0 : ref2.push({
            event: "cmp:click",
            eventInfo: JSON.parse(eventInfoData),
            page: page
        });
    }
};

// EXTERNAL MODULE: ./src/components/ShopTheRoomCard/v1/index.module.scss
var ShopTheRoomCard_v1_index_module = __webpack_require__(5196);
var ShopTheRoomCard_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(ShopTheRoomCard_v1_index_module);
;// CONCATENATED MODULE: ./components/Default/Tab/v1/Tab.jsx











const Tab = (props)=>{
    var ref, ref1, ref2;
    const { data ={} , itemKey ="" , ...extraProps } = props;
    const [selectedTab, setTab] = (0,react.useState)("");
    const tabElement = (0,react.useRef)(null);
    const tabContainerRef = (0,react.useRef)(null);
    const { eventPageType , pageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const tabNavigationItems = (0,react.useRef)([]);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const getDataLayerProps = (item)=>{
        return (0,utils/* recursiveDataFunction */.Qe)(item, constants.COMPONENT_TYPES === null || constants.COMPONENT_TYPES === void 0 ? void 0 : constants.COMPONENT_TYPES.TEASER);
    };
    const onClickTab = (data, event, eventInfo)=>{
        if (selectedTab !== data["cq:panelTitle"]) {
            setTab(data["cq:panelTitle"]);
        }
        handleTabClickDatalayer(eventInfo);
        const { currentTarget ={}  } = event;
        const clickedTab = currentTarget;
        // Move the tabbed navigation to the center of viewport when clicking
        clickedTab === null || clickedTab === void 0 ? void 0 : clickedTab.scrollIntoView({
            block: "nearest",
            inline: "center"
        });
    };
    (0,react.useEffect)(()=>{
        const selectedItemKey = data["activeItem"];
        if (data[":items"][selectedItemKey]) setTab(data[":items"][selectedItemKey]["cq:panelTitle"]);
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        const selectionBar = document === null || document === void 0 ? void 0 : document.querySelectorAll(".selectionBarcss");
        if (!(selectionBar === null || selectionBar === void 0 ? void 0 : selectionBar.length)) {
            onDocumentReady();
            getActiveHash((hashValue)=>{
                setTab(hashValue);
            });
            window === null || window === void 0 ? void 0 : window.addEventListener("resize", handleResizeEvent);
            window === null || window === void 0 ? void 0 : window.addEventListener("hashchange", handleHashchangeEvent);
        }
        return ()=>{
            window === null || window === void 0 ? void 0 : window.removeEventListener("resize", handleResizeEvent);
            window === null || window === void 0 ? void 0 : window.removeEventListener("hashchange", handleHashchangeEvent);
        };
    }, []);
    const getActiveTabIndex = (data)=>{
        var ref;
        return (ref = data[":itemsOrder"].map((key)=>{
            const item = data[":items"][key];
            const panelTitle = item["cq:panelTitle"] || "";
            return panelTitle;
        }).indexOf(selectedTab)) !== null && ref !== void 0 ? ref : "";
    };
    (0,react.useEffect)(()=>{
        if (data && selectedTab) {
            const activeTabIndex = getActiveTabIndex(data);
            if (activeTabIndex !== "") {
                const tabNavEl = tabNavigationItems === null || tabNavigationItems === void 0 ? void 0 : tabNavigationItems.current[activeTabIndex];
                setTabAnimation(tabNavEl);
            }
        }
    }, [
        data,
        selectedTab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "cmp-tabs",
        "data-cmp-is": "tabs",
        ref: tabContainerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                role: "tablist",
                className: "cmp-tabs__tablist",
                "aria-multiselectable": "false",
                ref: tabElement,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "selectionBarcss".concat((data === null || data === void 0 ? void 0 : (ref = data.appliedCssClassNames) === null || ref === void 0 ? void 0 : ref.includes("vertical-tabs")) && winWidth >= 1024 ? " selectionBar-vertical" : " selectionBar-horizontal")
                    }),
                    data[":itemsOrder"] ? (ref1 = data[":itemsOrder"]) === null || ref1 === void 0 ? void 0 : ref1.map(function() {
                        let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                        const item = data[":items"][key];
                        const panelTitle = item["cq:panelTitle"] || "";
                        const dataLayerProps = getDataLayerProps(item);
                        const { componentPosition ="" , eventName ="" , componentLinkType ="" , eventAction =""  } = dataLayerProps !== null && dataLayerProps !== void 0 ? dataLayerProps : {};
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            ref: (ref)=>{
                                tabNavigationItems.current[index] = ref;
                            },
                            role: "tab",
                            "aria-expanded": "false",
                            className: "cmp-tabs__tab ".concat(selectedTab === "" && index === 0 || selectedTab == panelTitle ? "cmp-tabs__tab--active" : ""),
                            id: panelTitle,
                            tabIndex: "0",
                            "data-cmp-hook-tabs": "tab",
                            "data-gbh-clickable": "true",
                            onClick: (event)=>{
                                const eventInfo = TabAnalytics_getEventInfo(componentPosition, eventName, componentLinkType, eventAction, eventPageType, pageType, item);
                                onClickTab(item, event, eventInfo);
                            },
                            children: panelTitle
                        }, panelTitle);
                    }) : null
                ]
            }),
            data[":itemsOrder"] ? (ref2 = data[":itemsOrder"]) === null || ref2 === void 0 ? void 0 : ref2.map(function() {
                let key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var ref;
                const item = data[":items"][key];
                const { id =""  } = item;
                const panelTitle = item["cq:panelTitle"] || "";
                const hashValue = panelTitle === null || panelTitle === void 0 ? void 0 : panelTitle.replaceAll(" ", "-");
                // set for rerendering child component when nested tabs are present for recalculating the active indicator
                const hasNestedTab = item[":itemsOrder"].some((childKey)=>{
                    const obj = item[":items"][childKey];
                    return (0,utils/* isTab */.wR)(obj);
                });
                const isShopTheRoom = item === null || item === void 0 ? void 0 : (ref = item[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.some((itemKey)=>{
                    const itemData = item[":items"][itemKey];
                    return (0,utils/* isShopTheRoomCard */.ck)(itemData);
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    role: "tabpanel",
                    "aria-label": panelTitle,
                    "data-hashid": hashValue,
                    className: "cmp-tabs__tabpanel ".concat(selectedTab == panelTitle ? "cmp-tabs__tabpanel--active" : ""),
                    "data-cmp-hook-tabs": "tabpanel",
                    "aria-hidden": selectedTab !== panelTitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                        condition: isShopTheRoom,
                        wrapper: (children)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ShopTheRoomCard_v1_index_module_default()).shopTheRoomWrapper,
                                children: children
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
                            condition: (0,utils/* isContainer */.Nm)(item),
                            wrapper: (children)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((0,utils/* isContainer */.Nm)(item) ? constants.staticClasses.CONTAINER : "", " ").concat(item.appliedCssClassNames),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cmp-container",
                                        children: (item === null || item === void 0 ? void 0 : item.gridClassNames) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: item === null || item === void 0 ? void 0 : item.gridClassNames,
                                            children: children
                                        }) : {
                                            children
                                        }
                                    })
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGrid, {
                                ...hasNestedTab ? {
                                    key: selectedTab
                                } : {},
                                data: item,
                                containerId: id,
                                itemKey: key ? key : itemKey,
                                ...extraProps
                            })
                        })
                    })
                }, "navItem-".concat(index));
            }) : null
        ]
    });
};
/* harmony default export */ var v1_Tab = (Tab);

;// CONCATENATED MODULE: ./src/components/Shared/Embed.jsx







const Embed = (props)=>{
    const { data: { script ="" , matterportUrl ="" , visualIcon =false , html ="" , etype =""  } = {}  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const [stylesVal, setStylesVal] = (0,react.useState)([]);
    const [reloadStyles, setReloadStyles] = (0,react.useState)(false);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const etypeUppercase = etype === null || etype === void 0 ? void 0 : etype.toUpperCase();
    (0,react.useEffect)(()=>{
        if (!isSsr && pageIsInteractive) {
            const { styles =[]  } = (0,helper.isEmbeddedStyles)(script);
            setStylesVal(styles);
            if (!reloadStyles) {
                // This is to make sure any 3rdParty Component loaded to the page will get styles applied after loading
                setTimeout(function() {
                    setReloadStyles(true);
                    dispatch((0,genericSlice/* toggleSiteWideWarning */.jy)());
                }, 3000);
            }
        }
    }, [
        isSsr,
        pageIsInteractive,
        reloadStyles
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isSsr && visualIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gbh-visual-icons",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "gbh-visual-icon-area",
                    tabIndex: "0",
                    role: "button",
                    "aria-label": constants.VISUALICON_ARIA_LABEL
                })
            }),
            !isSsr && etypeUppercase === constants.EMBED_TYPE_HTML && html && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            }),
            !isSsr && etypeUppercase === constants.EMBED_TYPE_SCRIPT && (0,helper.isEmbeddedElement)(script) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "embed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-embed",
                    dangerouslySetInnerHTML: {
                        __html: script
                    }
                })
            }),
            pageIsInteractive && etypeUppercase === constants.EMBED_TYPE_SCRIPT && stylesVal.map((style, i)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        id: "embedStyle-".concat(i, "-").concat((0,helper.getRandom)()),
                        children: style
                    })
                }, "embedStyle-".concat(i, "-").concat((0,helper.getRandom)()));
            }),
            !isSsr && matterportUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal fade virtual-tour-popup",
                tabIndex: "-1",
                role: "dialog",
                "aria-labelledby": constants.MATTERPORT_ARIA_LABEL,
                "aria-hidden": "true",
                "data-keyboard": "false",
                "data-backdrop": "static",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-dialog",
                    role: "document",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "modal-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "close",
                                    "data-dismiss": "modal",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "\xd7"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: matterportUrl,
                                    title: "",
                                    style: {
                                        width: "100%",
                                        height: "800px",
                                        border: "0"
                                    },
                                    allowFullScreen: true
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_Embed = (Embed);

;// CONCATENATED MODULE: ./src/components/Default/Spacer/v1/Spacer.jsx



const Spacer = (param)=>{
    let { data  } = param;
    const { backgroundColor ="" , desktopHeight ="" , ipadHeight ="" , mobileHeight =""  } = data;
    const [style, setStyle] = (0,react.useState)({
        backgroundColor: backgroundColor,
        color: backgroundColor,
        height: desktopHeight
    });
    (0,react.useEffect)(()=>{
        if (lib/* isTablet */.Em) {
            setStyle((style)=>{
                return {
                    ...style,
                    height: ipadHeight
                };
            });
        }
        if (lib/* isMobile */.tq) {
            setStyle((style)=>{
                return {
                    ...style,
                    height: mobileHeight
                };
            });
        }
    }, [
        lib/* isTablet */.Em,
        lib/* isMobile */.tq
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cmp-separator",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
            className: "cmp-separator__horizontal-rule",
            style: style
        })
    });
};
/* harmony default export */ var v1_Spacer = (Spacer);

// EXTERNAL MODULE: ./components/Default/PromoBanner/v1/index.module.scss
var PromoBanner_v1_index_module = __webpack_require__(38326);
var PromoBanner_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(PromoBanner_v1_index_module);
;// CONCATENATED MODULE: ./components/Default/PromoBanner/v1/PromoBanner.jsx









const PromoBanner = (param)=>{
    let { data ={} , properties ={} , isOmnichannel =false , omniQRParams ={}  } = param;
    var ref, ref1, ref2, ref3;
    const promoBannerSettings = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: true,
        centerMode: false
    };
    const { eventPageType  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { placementName  } = omniQRParams;
    const setPromoModal = (data)=>{
        dispatch((0,genericSlice/* showPromoModal */.Wv)(data));
        (0,helper.preventBodyScroll)(true);
    };
    const getPromoAnalytics = function() {
        let href = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", text = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "redirect link click",
            eventName: "promo banner click",
            eventType: "click",
            internalLinkName: text,
            internalLinkPosition: "promo-banner",
            internalLinkType: "promo-banner:redirect",
            internalLinkZoneName: "promo-banner",
            internalLinkURL: window.location.origin + href
        };
        (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
    };
    const handleClick = (event)=>{
        if (event.target.closest("a")) {
            event.preventDefault();
            const anchorTag = event.target.closest("a");
            const href = anchorTag.getAttribute("href");
            const anchorText = anchorTag.textContent.trim();
            getPromoAnalytics(href, anchorText);
            window.location.href = href;
        }
    };
    (0,react.useEffect)(()=>{
        const handleClickEvent = (event)=>{
            const clickedDiv = event.target.closest(".parent-div");
            if (clickedDiv) {
                handleClick(event);
            }
        };
        const parentDiv = document.querySelectorAll(".parent-div");
        parentDiv.forEach((div)=>{
            div.addEventListener("click", handleClickEvent);
        });
        return ()=>{
            parentDiv.forEach((div)=>{
                div.removeEventListener("click", handleClickEvent);
            });
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (PromoBanner_v1_index_module_default()).promoBannerWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "carousel-slick carousel ".concat(data === null || data === void 0 ? void 0 : (ref = data.carouselComponentProperties) === null || ref === void 0 ? void 0 : ref.appliedCssClassNames),
            role: "group",
            "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
            "aria-roledescription": "carousel",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(eventPageType, ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "carousel", '","internalLinkZoneName":"').concat(data === null || data === void 0 ? void 0 : data.pageName.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "carousel", '","internalLinkURL":"n/a","internalLinkName":"carousel:rm","eventName":"').concat(data === null || data === void 0 ? void 0 : (ref1 = data.pageName) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventType":"carousel","eventAction":"').concat(data === null || data === void 0 ? void 0 : (ref2 = data.pageName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), '"}'),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-carousel cmp-carousel-slick ",
                role: "group",
                "aria-label": data["carouselComponentProperties"]["accessibilityLabel"] || undefined,
                "aria-roledescription": "carousel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                    ...promoBannerSettings,
                    className: "cmp-carousel-slick__content single-slider",
                    children: data["carouselComponentProperties"][":itemsOrder"] && ((ref3 = data["carouselComponentProperties"][":itemsOrder"]) === null || ref3 === void 0 ? void 0 : ref3.map((key, index, arr)=>{
                        var ref;
                        const item = data["carouselComponentProperties"][":items"][key];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "promo-banner",
                                style: {
                                    visibility: "visible"
                                },
                                children: !isOmnichannel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cmp-promo__description",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "parent-div",
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : item.description.replace("/content/kohler-india/in/en", "").replace(".html", ""))
                                            }
                                        }),
                                        (item === null || item === void 0 ? void 0 : item.actionsEnabled) && (item === null || item === void 0 ? void 0 : (ref = item.actionItems) === null || ref === void 0 ? void 0 : ref.map((action, index)=>{
                                            var ref;
                                            return action.enablePopup ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                onClick: ()=>setPromoModal({
                                                        show: true,
                                                        modalContent: {
                                                            banner: item,
                                                            item: action,
                                                            count: index
                                                        }
                                                    }),
                                                "data-toggle": "modal",
                                                "data-target": "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index),
                                                className: "cmp-promo__action-link btn promo-banner-fragment",
                                                rel: "".concat(action.linkRef ? "noreferrer" : ""),
                                                "data-gbh-component": item === null || item === void 0 ? void 0 : item.componentInfos,
                                                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(item === null || item === void 0 ? void 0 : (ref = item.pageType) === null || ref === void 0 ? void 0 : ref.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentPosition) ? properties.componentPosition : "promo banner", '","internalLinkZoneName":"').concat(item === null || item === void 0 ? void 0 : item.pageType.toLowerCase(), ":").concat((properties === null || properties === void 0 ? void 0 : properties.componentZone) ? properties.componentZone : "global header", '","internalLinkURL":"n/a","internalLinkName":"').concat(action === null || action === void 0 ? void 0 : action.text, '","eventName":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '","internalLinkType":"').concat((properties === null || properties === void 0 ? void 0 : properties.componentLinkType) ? properties.componentLinkType : "navigation", '","eventType":"promo banner","eventAction":"').concat(action === null || action === void 0 ? void 0 : action.text.toLowerCase(), '"}'),
                                                "data-gbh-clickable": true,
                                                children: action === null || action === void 0 ? void 0 : action.text
                                            }, "#".concat(item === null || item === void 0 ? void 0 : item.promoId, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Action, {
                                                ...action,
                                                link: (action === null || action === void 0 ? void 0 : action.ctaLink) || (action === null || action === void 0 ? void 0 : action.link),
                                                newTab: action === null || action === void 0 ? void 0 : action.isNewTab,
                                                compInfo: item === null || item === void 0 ? void 0 : item.componentInfos
                                            }, "promo-banner-action-".concat(index + 1, "-").concat((0,helper.getRandom)()));
                                        }))
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "cmp-promo__description cmp-promo__flex-div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cmp-promo__title-omnichannel",
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(item === null || item === void 0 ? void 0 : item.description)
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "cmp-promo__title-omnichannel",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: ": ".concat(placementName)
                                            })
                                        })
                                    ]
                                })
                            })
                        }, (item === null || item === void 0 ? void 0 : item.id) ? item === null || item === void 0 ? void 0 : item.id : "cmp-promo-banner-".concat(index, "-").concat((0,helper.getRandom)()));
                    }))
                })
            })
        })
    });
};
/* harmony default export */ var v1_PromoBanner = (PromoBanner);

// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
;// CONCATENATED MODULE: ./src/components/Default/AemForm.jsx






const AemForm = (props)=>{
    var ref;
    const { data: { formPath , submitType , thankyouMessage , useiframe , enableFocusOnFirstField , thankyouConfig  }  } = props;
    const [innerHtmlToSet, setInnerHtmlToSet] = (0,react.useState)("");
    const [formScripts, setFormScripts] = (0,react.useState)(null);
    const [noOfScripts, setNoOfScripts] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        (0,api/* aemAxiosInstance */.Gb)({
            url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
            params: {
                path: formPath + ".html"
            }
        }).then((res)=>{
            const scriptsList = [];
            let innerHTML = res.data;
            if ((location === null || location === void 0 ? void 0 : location.hostname) === "localhost") {
                innerHTML = innerHTML.split('rel="stylesheet" href="').join('rel="stylesheet" href="'.concat(constants.authorBaseUrl));
                innerHTML = innerHTML.split('<script src="').join('<script src="'.concat(constants.authorBaseUrl));
            }
            const doc = new DOMParser().parseFromString(innerHTML, "text/html");
            (0,helper.extractScriptsFromDOM)(doc, (item)=>scriptsList.push(item));
            setFormScripts(scriptsList);
            setInnerHtmlToSet(doc);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "aemFormInitialLoadJavascript",
                "data-nscript": "afterInteractive",
                children: 'const onAemFormScriptLoad = evnt => {\n    const formApp = evnt.detail.formApp\n    formApp.initializeAEMForm({\n      form: "true",\n      submitType: "'.concat(submitType, '",\n      thankyouConfig: "').concat(thankyouConfig, '",\n      thankyouMessage: "').concat(encodeURI(thankyouMessage), '",\n      thankyouPage: "",\n      useIframe: "').concat(useiframe, '",\n      height: "auto",\n      aemFormComponentPath: "aemform",\n      enableFocusOnFirstField: "').concat(enableFocusOnFirstField, '",\n    })\n    // remove the event listener after completion\n    window.removeEventListener("aemform-onscript-load", onAemFormScriptLoad)\n  };\n  window.addEventListener("aemform-onscript-load", onAemFormScriptLoad);')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "/js/formapp.js"
            }),
            formScripts && formScripts.map((script, i)=>{
                if (!script.innerHTML && noOfScripts === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: script.src,
                    id: "aemform-src-script-".concat(i),
                    onReady: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    onError: ()=>{
                        setNoOfScripts(i + 1);
                    }
                }, "aemform-src-script-".concat(i));
                if (script.innerHTML && noOfScripts === i) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "aemform-innerscript-".concat(i),
                    onReady: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    onError: ()=>{
                        setNoOfScripts(i + 1);
                    },
                    children: "".concat(script.innerHTML)
                }, "aemform-innerscript-".concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "aemform aem-genericForm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aemformcontainer",
                    "data-form-page-path": formPath,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: innerHtmlToSet === null || innerHtmlToSet === void 0 ? void 0 : (ref = innerHtmlToSet.documentElement) === null || ref === void 0 ? void 0 : ref.innerHTML
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Default_AemForm = (AemForm);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
// EXTERNAL MODULE: ./components/productCard/v1/ProductCard.view.jsx
var ProductCard_view = __webpack_require__(27221);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./src/components/productCard/v1/analytics.js
var analytics = __webpack_require__(41740);
// EXTERNAL MODULE: ./src/components/productCard/v1/productCardHelper.js
var productCardHelper = __webpack_require__(15011);
// EXTERNAL MODULE: ./src/components/productCard/v1/index.module.scss
var productCard_v1_index_module = __webpack_require__(49696);
var productCard_v1_index_module_default = /*#__PURE__*/__webpack_require__.n(productCard_v1_index_module);
;// CONCATENATED MODULE: ./src/components/productCard/v1/ProductCardService.jsx


















const ProductCardService = (props)=>{
    const { staticTexts ={} , imagePosition ="" , narrativeDescription , productFeatures =[] , productCategory ="" , badgeVal ="" , currencySign ="" , isNearestValueUpdated =Boolean , resetNearestValueUpdateFlag =()=>{} , cart ={} , price =Number , skuId ="" , images ="" , userZipCode ="" , slug ="" , getZipCode =()=>{} , customerBrand ="" , name: servicePlanName = ""  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [isNearest, setIsNearest] = (0,react.useState)(false);
    const [isNotNearestError, setIsNotNearestError] = (0,react.useState)(false);
    const [isCheckAvailability, setIsCheckAvailability] = (0,react.useState)(true);
    const [checkZipCode, setCheckZipCode] = (0,react.useState)("");
    const [zipCodeError, setZipCodeError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    const [findaProLandingPagePath, setFindaProLandingPagePath] = (0,react.useState)("");
    const [siteName, setSiteName] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            const { general  } = CONFIG;
            var ref;
            (0,helper.getShortenedUrl)((ref = general === null || general === void 0 ? void 0 : general.findaProLandingPagePath) !== null && ref !== void 0 ? ref : "/").then((url)=>{
                setFindaProLandingPagePath(url);
            });
            var ref1;
            (0,helper.getShortenedUrl)((ref1 = general === null || general === void 0 ? void 0 : general.cartLandingPagePath) !== null && ref1 !== void 0 ? ref1 : "/").then((url)=>{
                setCartUrl(url);
            });
            setSiteName((general === null || general === void 0 ? void 0 : general.siteName) ? general.siteName[0] : "");
        });
    }, []);
    const showToaster = (msg)=>{
        dispatch((0,genericSlice/* showToast */.CF)({
            message: msg,
            isVisible: true
        }));
    };
    const { altTextForServiceImg ="" , virtualService ="" , virtualTooltip ="" , nearestInPerson ="" , nearestService ="" , change ="" , zipCode ="" , eligibleZipCodeSuccess ="" , eligibleZipCodeError ="" , discountPercentage ="" , off ="" , yourCart , itemAdded , itemsAdded , zipcodeEmptyError ="" , zipodeEmptyError ="" , validZipcode ="" , search =""  } = staticTexts;
    const installServices = productCategory === "Install Services";
    const designServices = productCategory === "Design Services";
    (0,react.useEffect)(()=>{
        if (isNearestValueUpdated && resetNearestValueUpdateFlag) {
            resetNearestValueUpdateFlag();
            if (!isNearest) {
                addZipcodeAnalytics("failure", eligibleZipCodeError.toLowerCase());
            } else {
                addZipcodeAnalytics("success");
            }
        }
    }, [
        isNearestValueUpdated
    ]);
    let discountedPrice = props.discountedPrice;
    let discountPercent = props.discountPercent;
    let discountType = "";
    if ((cart === null || cart === void 0 ? void 0 : cart.lineItems) && cart.lineItems.length > 0) {
        cart.lineItems.filter((item)=>item.productSlug["en-US"] === slug).map((product)=>{
            if (product.discountedPrice) {
                discountedPrice = (Number(get_default()(product.discountedPrice, "value.centAmount", 0)) / 100).toFixed(2);
                discountType = get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.type", "");
                discountPercent = discountType === "absolute" ? Number(get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(product.discountedPrice, "includedDiscounts[0].discount.obj.value.permyriad", 0)) / 100;
            }
            if (discountPercent === 0) {
                discountedPrice = Number(get_default()(product.price, "discounted.value.centAmount", 0) / 100).toFixed(2);
                discountType = get_default()(product.price, "discounted.discount.obj.value.type", "");
                discountPercent = discountType === "absolute" ? Number(get_default()(product.price, "discounted.discount.obj.value.money[0].centAmount", 0)) / 100 : Number(get_default()(product.price, "discounted.discount.obj.value.permyriad", 0)) / 100;
            }
        });
    }
    const productPrice = discountPercent > 0 ? discountedPrice : price;
    if (discountType === "") {
        var ref;
        discountType = badgeVal && ((ref = badgeVal === null || badgeVal === void 0 ? void 0 : badgeVal.split(" ")) === null || ref === void 0 ? void 0 : ref.includes("Percent")) ? "relative" : "absolute";
    }
    const getSaleOffer = "<p class='offer-percent'>".concat(discountType === "relative" ? discountPercent + discountPercentage : currencySign + discountPercent + "<span class='offer-percent-text'>" + off + "</span>", "</p>");
    const productAnalyticsData = {
        desc: productFeatures ? (0,helper.sanitizeTextForAnalytics)(productFeatures.join(". ")) : "n/a",
        discountPrice: discountPercent > 0 ? discountedPrice : 0,
        discountPriceState: discountPercent > 0 ? "percentOff|" + discountPercent : "regular price",
        unitPrice: price,
        category: (0,helper.sanitizeTextForAnalytics)(productCategory),
        color: "n/a",
        sku: skuId,
        name: (0,helper.sanitizeTextForAnalytics)(props.name),
        image: images,
        customerFacingSKU: props.customerFacingSKU || (siteName ? siteName[0] + "-" + skuId : ""),
        skuInitials: props.customerFacingSKU ? props.customerFacingSKU.split("-")[0] + "-" : siteName ? siteName[0] + "-" : "",
        discountName: badgeVal,
        superSku: false,
        selectedColor: "n/a",
        productSaleable: true
    };
    const { desc ="n/a" , unitPrice =0 , discountPriceState , category , color , customerFacingSKU , name , discountName  } = productAnalyticsData;
    const serviceName = productCategory === "Design Services" ? "bathroom design services" : (0,helper.sanitizeTextForAnalytics)(productCategory);
    let globalDiscount = props.globalDiscount;
    const { productCouponCode , productCoupondiscount , globalDiscountNames , globalDiscountValues  } = (0,helper.getCurrentSkuCouponDiscounts)({
        cart: cart,
        sku: skuId
    });
    let globalOffer = [
        discountName
    ];
    if ((globalDiscountNames === null || globalDiscountNames === void 0 ? void 0 : globalDiscountNames.length) && globalDiscountValues) {
        globalOffer = [
            discountName,
            ...globalDiscountNames
        ];
        globalDiscount += globalDiscountValues;
    }
    const productInfo = {
        description: desc,
        frequency: "n/a",
        globalPromotionPrice: discountedPrice > 0 ? Number((price - globalDiscount).toFixed(2)) : 0,
        globalOffer: globalOffer.join("|") || "n/a",
        globalDiscount: globalDiscount ? Number(globalDiscount.toFixed(2)) : 0,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        priceState: discountPriceState,
        productBasePrice: Number(unitPrice) || "n/a",
        productCategory: category || "n/a",
        productColor: color || "n/a",
        productCoupondiscount: productCoupondiscount || 0,
        productCouponCode: productCouponCode.join("|") || "n/a",
        productID: customerFacingSKU || "n/a",
        productName: name || desc || category || "n/a",
        productPartnerBuyNow: "n/a",
        productRoom: "service" || 0,
        productSalePrice: Number(productPrice),
        productSaleable: true,
        productStatus: "in stock",
        productSuperSku: false,
        productTileName: name || "n/a",
        quantity: quantity || "n/a",
        defaultImageName: productAnalyticsData.image || "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a",
        pdpType: "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCollectionsName: category || "n/a",
        productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
        itemType: "service" || 0
    };
    const getToasterMsg = (msg)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                msg,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: cartUrl,
                    children: yourCart
                }),
                "."
            ]
        });
    const handleCallback = (res, msg)=>{
        if (productCategory === "Install Services") {
            const eventInfoObj = getEventInfoObject("add to cart");
            const { status , message ="n/a"  } = res;
            eventInfoObj.eventStatus = status === 200 ? "success" : "failure";
            if (status !== 200) {
                eventInfoObj.eventMsg = message ? (0,helper.sanitizeTextForAnalytics)(message) : "n/a";
            }
            (0,analytics/* callInstallServiceAddToCartAnalytics */.gA)({
                resInfo: res,
                eventInfoObj,
                productInfo,
                cartID: cart === null || cart === void 0 ? void 0 : cart.id
            });
        }
        if (productCategory === "Design Services") {
            (0,analytics/* callDesignServicesAddToCartAnalytics */.__)(res, productInfo, serviceName, cart === null || cart === void 0 ? void 0 : cart.id);
        }
        if (lib/* isMobile */.tq) showToaster(getToasterMsg(msg));
    };
    const addtoCart = (items)=>{
        let totalAdded = 0;
        items.forEach((item)=>totalAdded += item.quantity);
        const msg = totalAdded === 1 ? "".concat(totalAdded, " ").concat(itemAdded, " ") : "".concat(totalAdded, " ").concat(itemsAdded, " ");
        (0,productCardHelper/* productCardAddToCart */.x)([
            ...items
        ], true, "", (res)=>handleCallback(res, msg), false);
    };
    const handleAddToCart = ()=>{
        if (productCategory === "Design Services") {
            addtoCart([
                {
                    sku: skuId,
                    quantity: quantity,
                    brand: customerBrand
                }
            ]);
        } else {
            if (!isEmpty_default()(userZipCode)) {
                addtoCart([
                    {
                        sku: skuId,
                        quantity: quantity,
                        userZipCode: userZipCode,
                        brand: customerBrand
                    }
                ]);
            }
        }
    };
    const handleChange = async (qty)=>{
        if (qty && qty !== 0) {
            setQuantity(qty);
        }
    };
    const handleCheckAvailability = async ()=>{
        setZipCodeError({
            show: false,
            message: ""
        });
        let valid = true;
        let errorMessage = "";
        if (isEmpty_default()(checkZipCode)) {
            setZipCodeError({
                show: true,
                message: zipcodeEmptyError
            });
            valid = false;
            errorMessage = zipodeEmptyError.toLowerCase();
        } else if (!(0,helper.validateField)("zipcode", checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
            valid = false;
            errorMessage = validZipcode === null || validZipcode === void 0 ? void 0 : validZipcode.toLowerCase();
        } else if (!await (0,utils_location/* validateZip */.$8)(checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
            valid = false;
            errorMessage = validZipcode === null || validZipcode === void 0 ? void 0 : validZipcode.toLowerCase();
        }
        if (valid) {
            getZipCode(checkZipCode, true, callBackZipCode);
        } else {
            addZipcodeAnalytics("failure", errorMessage);
        }
    };
    const handleChangeZipCode = (e)=>{
        const { value  } = e.target;
        if ((0,helper.validateField)("zipCodeNumeric", value) || value === "") {
            setCheckZipCode(value);
        }
        setIsNotNearestError(false);
        setZipCodeError({
            show: false,
            message: ""
        });
    };
    const zipCodeCheck = ()=>{
        if (!(0,helper.validateField)("zipcode", checkZipCode)) {
            setZipCodeError({
                show: true,
                message: validZipcode
            });
        } else {
            setZipCodeError({
                show: false,
                message: ""
            });
        }
    };
    const getEventInfoObject = (eventNameText, buttonName)=>{
        return {
            clickInternalLinks: "true",
            eventAction: "installation services:install service:" + eventNameText,
            eventName: "installation services:install service:" + eventNameText,
            eventType: "navigation",
            internalLinkName: buttonName !== null && buttonName !== void 0 ? buttonName : eventNameText,
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkPosition: "find installation services",
            internalLinkType: "installation services:" + (eventNameText !== "check availability" || !checkZipCode ? "navigation" : checkZipCode),
            internalLinkURL: eventNameText === "find a pro" ? ((findaProLandingPagePath === null || findaProLandingPagePath === void 0 ? void 0 : findaProLandingPagePath.indexOf("http")) === -1 ? window.location.origin : "") + findaProLandingPagePath : "n/a",
            internalLinkZoneName: "installation services:" + productAnalyticsData.name
        };
    };
    const addZipcodeAnalytics = (status, message)=>{
        const eventInfoObj = getEventInfoObject("check availability", "search");
        eventInfoObj.eventMsg = message || "n/a";
        eventInfoObj.eventStatus = status;
        (0,analytics/* callInstallServiceAddToCartAnalytics */.gA)({
            resInfo: {},
            productInfo,
            eventInfoObj,
            cartID: cart === null || cart === void 0 ? void 0 : cart.id
        });
    };
    const callBackZipCode = (isServiceAvailable)=>{
        setIsNearest(isServiceAvailable);
        setIsNotNearestError(!isServiceAvailable);
        setIsCheckAvailability(!isServiceAvailable);
        if (isServiceAvailable) sessionStorage.setItem("verifiedZip", checkZipCode);
    };
    (0,react.useEffect)(()=>{
        const isVerifiedZip = sessionStorage.getItem("verifiedZip");
        if (isVerifiedZip) {
            setIsNearest(true);
            setIsNotNearestError(false);
            setIsCheckAvailability(false);
            setCheckZipCode(isVerifiedZip);
        }
    }, []);
    const handleClickChangeBtn = ()=>{
        setIsCheckAvailability(true);
        setIsNearest(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (productCard_v1_index_module_default()).productCardWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-card-service",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "kf-react-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row ml-0 mr-0 no-gutters",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col product-card-service__details \n                  ".concat(imagePosition === "left" ? " product-card-service__details-align" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(productCategory === "Install Services" ? "product-card-service__details-header" : "product-card-service__service-install"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        className: "product-card-service__name",
                                                        children: servicePlanName
                                                    }),
                                                    productCategory === "Install Services" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "product-card-service__desc",
                                                        children: narrativeDescription
                                                    }) : null,
                                                    productCategory === "Design Services" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-card-service__virtual-list",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: productFeatures.map((list, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: list
                                                                }, index))
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-card-service__img-container \n                              ".concat(imagePosition === "left" ? " product-card-service__img-container-align" : "", " \n                              mobile-landscape-image"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: images,
                                                    className: "product-card-service__img",
                                                    alt: altTextForServiceImg
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-service__virtual-service \n                          ".concat(productCategory ? " product-card-service__virtual-service-zip" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-card-service__eligible-service",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "left",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "product-card-service__eligible-service-txt",
                                                                    children: designServices ? virtualService : isNearest ? nearestInPerson : nearestService
                                                                }),
                                                                isNearest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "product-card-service__zipcode",
                                                                            children: checkZipCode
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            tabIndex: "0",
                                                                            role: "link",
                                                                            className: "product-card-service__eligible-service-edit gbh-data-layer",
                                                                            "data-gbh-data-layer": JSON.stringify(getEventInfoObject("edit", "change")),
                                                                            "data-gbh-data-layer-custom": JSON.stringify({
                                                                                productInfo
                                                                            }),
                                                                            onClick: handleClickChangeBtn,
                                                                            children: [
                                                                                " ",
                                                                                change
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-card-service__price",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    className: "product-card-service__price-value",
                                                                    value: productPrice,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                }),
                                                                discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "product-card-service__discount-price",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "product-card-service__offer-price",
                                                                            children: (0,helper.sanitizeInnerHtml)(getSaleOffer)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                            className: "strike-through-price",
                                                                            value: price,
                                                                            displayType: "text",
                                                                            thousandSeparator: true,
                                                                            prefix: currencySign,
                                                                            decimalScale: 2,
                                                                            fixedDecimalScale: true
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                isCheckAvailability && installServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "product-card-service__zipcode-availability",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                                    id: "zipCode-".concat((0,helper.getRandom)()),
                                                                    type: "text",
                                                                    maxLength: 60,
                                                                    placeholder: "".concat(zipCode),
                                                                    label: "".concat(zipCode),
                                                                    value: checkZipCode,
                                                                    customClass: "".concat(zipCodeError.show ? "product-card-service__zipcode-input-error" : ""),
                                                                    onKeyDown: (e)=>e.key === "Enter" && handleCheckAvailability(),
                                                                    onChange: handleChangeZipCode,
                                                                    onBlur: zipCodeCheck
                                                                }),
                                                                checkZipCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    role: "button",
                                                                    className: "product-card-service__check-availability-cta",
                                                                    label: search,
                                                                    size: "small",
                                                                    type: " ",
                                                                    disabled: checkZipCode.length < 5,
                                                                    onClick: handleCheckAvailability
                                                                }) : null
                                                            ]
                                                        }),
                                                        zipCodeError.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "product-card-service__zipcode-error",
                                                            children: zipCodeError.message
                                                        })
                                                    ]
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-card-service__eligible-service-container",
                                                    children: [
                                                        isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "product-card-service__eligible-service-message",
                                                            children: designServices ? virtualTooltip : eligibleZipCodeSuccess
                                                        }) : null,
                                                        isNotNearestError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "error",
                                                            children: [
                                                                eligibleZipCodeError,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: findaProLandingPagePath,
                                                                    className: "product-card-service__find-a-pro gbh-data-layer",
                                                                    "data-gbh-data-layer": JSON.stringify(getEventInfoObject("find a pro")),
                                                                    "data-gbh-data-layer-custom": JSON.stringify({
                                                                        productInfo
                                                                    }),
                                                                    children: staticTexts.findaPro
                                                                })
                                                            ]
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    isNearest || designServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-service__price-and-cart",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-card-service__cart",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cartAction mx-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "quantity-selector-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                                            doNotRequiredAnalyticsData: true,
                                                            productData: productAnalyticsData,
                                                            value: quantity,
                                                            onChange: handleChange,
                                                            isPDPQuantitySelector: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "add-to-cart-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            role: "button",
                                                            label: staticTexts.addToCart,
                                                            onClick: handleAddToCart,
                                                            size: "large",
                                                            type: "primary",
                                                            flexible: true,
                                                            disabled: productCategory !== "Design Services" ? !isNearest : false
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-card-service__img-container ".concat(imagePosition === "left" ? " product-card-service__img-container-align" : "", " product-card-service-main-image"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: images,
                                className: "product-card-service__img",
                                alt: altTextForServiceImg
                            })
                        })
                    ]
                })
            })
        })
    });
};
ProductCardService.defaultProps = {
    newTab: false,
    staticTexts: {}
};
ProductCardService.propTypes = {
    newTab: (prop_types_default()).bool,
    staticTexts: (prop_types_default()).object
};
/* harmony default export */ var v1_ProductCardService = (ProductCardService);

;// CONCATENATED MODULE: ./i18n/useProductCardi18n.js

const useProductCardi18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("plp");
    const i18n = {
        color: t("kf.productcard.color"),
        colors: t("kf.productcard.colors"),
        altText: t("kf.productCard.altText"),
        altTextForServiceImg: t("kf.productCard.altTextForServiceImg"),
        virtualService: t("kf.productCard.virtualService"),
        virtualTooltip: t("kf.productCard.virtualTooltip"),
        addToCart: t("kf.productCard.addToCart"),
        toolTipAlt: t("kf.productCard.toolTipAlt"),
        nearestService: t("kf.productCard.nearestService"),
        nearestInPerson: t("kf.productCard.nearestInPerson"),
        edit: t("kf.productCard.edit"),
        eligibleZipCodeSuccess: t("kf.productCard.eligibleZipCodeSuccess"),
        eligibleZipCodeError: t("kf.productCard.eligibleZipCodeError"),
        zipcode: t("kf.productCard.zipcode"),
        findaPro: t("kf.productCard.findaPro"),
        checkAvailability: t("kf.productCard.checkAvailability"),
        maxInventory: t("kf.productCard.maxInventory"),
        itemsAdded: t("kf.productCard.itemsAdded"),
        itemAdded: t("kf.productCard.itemAdded"),
        yourCart: t("kf.productCard.yourCart"),
        zipcodeEmptyError: t("kf.productCard.zipcodeEmptyError"),
        validZipcode: t("kf.productCard.validZipcode"),
        ariaLabel: {
            color: t("kf.productCard.aria.colors"),
            tooltip: t("kf.productCard.aria.tooltip"),
            editZip: t("kf.productCard.aria.label.editZip"),
            findPro: t("kf.productCard.aria.label.findPro")
        },
        discountPercentage: t("kf.productCard.discountPercentage"),
        off: t("kf.productCard.off"),
        lfLabel: t("annsacks.pdpTrimCalculator.label.LF"),
        sfLabel: t("annsacks.pdpTrimCalculator.label.SF"),
        boxLabel: t("annsacks.pdpProductSummary.label.perBox"),
        recentlyViewedColor: t("kf.productcard.color"),
        recentlyViewedColors: t("kf.productcard.colors")
    };
    return i18n;
};
/* harmony default export */ var i18n_useProductCardi18n = (useProductCardi18n);

// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/productCard/v1/ProductCard.jsx
















const ProductCard = (props)=>{
    const { data: authorData , data: { presetConfigs  }  } = props;
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [state] = (0,react.useState)({
        productSkuId: authorData.type === "productSku" ? get_default()(authorData, "productSkuId", "") : get_default()(authorData, "serviceSkuId", ""),
        newTab: get_default()(authorData, "newTab", false),
        skuType: get_default()(authorData, "type", ""),
        imagePosition: get_default()(authorData, "imagePosition", ""),
        jsonFileUrl: get_default()(authorData, "jsonFilePath", ""),
        swatchUrl: authorData.swatchUrl,
        bestSellerContent: get_default()(authorData, "bestSellerContent")
    });
    const [productDetailData, setProductDetailData] = (0,react.useState)({});
    const [userZipCode, setUserZipCode] = (0,react.useState)("");
    const [isNearest, setIsNearest] = (0,react.useState)(false);
    const [isNearestValueUpdated, setIsNearestValueUpdated] = (0,react.useState)(false);
    const [zipCodeData, setZipCodeData] = (0,react.useState)([]);
    const [info, setInfo] = (0,react.useState)({});
    const staticTexts = i18n_useProductCardi18n({});
    const persona = (0,helper.getUserPersona)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            var ref;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const language = get_default()(config, "internationalization.language", "en");
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            (0,api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: state.jsonFileUrl
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _zipcode;
                    setZipCodeData((_zipcode = response.data.zipcode) !== null && _zipcode !== void 0 ? _zipcode : []);
                }
            }).catch((err)=>{
                console.error("Failed to get compare attributes JSON file", err);
            });
            const info = {
                locale: locale,
                language: language,
                currencySign: currencySign,
                currencyCode: currencyCode,
                brandName: brandName
            };
            setInfo(info);
        });
    }, []);
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(info)) {
                fetchFromSku();
            }
        } catch (error) {
            console.error(error);
        }
        getUserLocation();
    }, [
        info
    ]);
    const getUserLocation = ()=>{
        (0,helper.getLocationByCookies)().then((getLocation)=>{
            var _zipcode;
            const userZipCode = (_zipcode = getLocation.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "";
            checkUserZipCode(userZipCode);
        });
    };
    const checkUserZipCode = function(userZipCodeVal, callBack) {
        let needAnalytics = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        const newCodes = [];
        zipCodeData.map((codes)=>{
            Object.keys(codes).forEach((key)=>{
                newCodes.push(codes[key].includes(userZipCodeVal));
            });
        });
        const isNearest = newCodes.find((result)=>result === true) ? true : false;
        setIsNearest(isNearest);
        setIsNearestValueUpdated(needAnalytics);
        callBack && callBack(isNearest);
    };
    const getZipCode = function(zipCodeVal) {
        let needAnalytics = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setUserZipCode(zipCodeVal);
        checkUserZipCode(zipCodeVal, needAnalytics);
    };
    const fetchFromSku = ()=>{
        const fl = [
            "id",
            "slug_s",
            "productName_s",
            "masterSKU_s",
            "sourceId_s",
            "preferenceSku_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "Color.SKU.Details_ss",
            "ProductWebFeatures_ss",
            "ProductWebFeatures_s",
            "ProductExclusive_s",
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "title_s",
            "ProductNarrativeDescription_s",
            "priceList.".concat(persona, ".finalPrice_d"),
            "CustomerFacingBrand_s",
            "RegionBrandName_s",
            "priceList.ANY.price_d",
            "Color.".concat(persona, ".Details_ss")
        ];
        api/* apim.get */.TH.get("/search/plp", {
            params: {
                fl: fl.join(","),
                q: "*:*",
                fq: [
                    'sku_s:("'.concat(state.productSkuId, '")'),
                    'language_s:("'.concat(info.language, '")')
                ],
                collections: info.brandName.toLowerCase(),
                profilename: "profile_".concat(info.brandName.toLowerCase(), "_General")
            },
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        }).then((res)=>{
            if (res && res.data) {
                const productData = get_default()(res.data, "response.docs[0]", {});
                setProductDetailData(productData);
            } else {
                console.error("Error occured while fetching product data");
            }
        });
    };
    const productCardProps = {};
    productCardProps.presetConfigs = presetConfigs !== null && presetConfigs !== void 0 ? presetConfigs : "";
    var _swatchUrl;
    productCardProps.swatchUrl = (_swatchUrl = state.swatchUrl) !== null && _swatchUrl !== void 0 ? _swatchUrl : "";
    if (productDetailData) {
        var ref;
        // get product images
        // get product colors
        if (productDetailData["Color.SKU.Details_ss"]) {
            var ref1;
            const colors = (ref1 = productDetailData["Color.SKU.Details_ss"]) !== null && ref1 !== void 0 ? ref1 : [];
            productCardProps.colors = colors.filter((item)=>{
                const color = item.split("|");
                return color[4] === "false" || Date.parse(color[4]) > Date.now();
            });
        } else {
            var ref2;
            productCardProps.colors = [
                (ref2 = productDetailData["SKUColorSwatchFilename_s"]) !== null && ref2 !== void 0 ? ref2 : ""
            ];
        }
        // get product web features
        if (productDetailData["ProductWebFeatures_s"]) {
            var ref3;
            productCardProps.productFeatures = (ref3 = [
                productDetailData["ProductWebFeatures_s"]
            ]) !== null && ref3 !== void 0 ? ref3 : [];
        } else {
            var ref4;
            productCardProps.productFeatures = (ref4 = productDetailData["ProductWebFeatures_ss"]) !== null && ref4 !== void 0 ? ref4 : [];
        }
        productCardProps.currencySign = info.currencySign;
        productCardProps.productCategory = get_default()(productDetailData, "Product_Category", "");
        productCardProps.name = get_default()(productDetailData, "productName_s", "");
        productCardProps.brandName = get_default()(productDetailData, "RegionBrandName_s", "");
        productCardProps.mrpPrice = get_default()(productDetailData, "priceList.ANY.price_d", 0);
        var ref5;
        const colorPricing = (ref5 = productDetailData["Color.".concat(persona, ".Details_ss")]) !== null && ref5 !== void 0 ? ref5 : [];
        const selSkuDetails = colorPricing.find((item)=>{
            return item.split("|")[0] === state.productSkuId;
        });
        if (productDetailData["productImages.url_s"] || productDetailData["productImages.url_ss"]) {
            var ref6;
            productCardProps.images = (ref6 = selSkuDetails === null || selSkuDetails === void 0 ? void 0 : selSkuDetails.split("|")[5]) !== null && ref6 !== void 0 ? ref6 : "";
        } else {
            productCardProps.images = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
        }
        productCardProps.selSku = selSkuDetails === null || selSkuDetails === void 0 ? void 0 : selSkuDetails.split("|")[0];
        const personaprice = selSkuDetails === null || selSkuDetails === void 0 ? void 0 : selSkuDetails.split("|")[3];
        const mrpprice = selSkuDetails === null || selSkuDetails === void 0 ? void 0 : selSkuDetails.split("|")[2];
        productCardProps.discountPrice = personaprice;
        productCardProps.mrpPrice = mrpprice;
        productCardProps.discountpercent = (Number(mrpprice) - Number(personaprice)) / Number(mrpprice) * 100;
        productCardProps.description = get_default()(productDetailData, "title_s", "");
        productCardProps.narrativeDescription = get_default()(productDetailData, "ProductNarrativeDescription_s", "");
        productCardProps.price = get_default()(productDetailData, "priceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountedPrice = get_default()(productDetailData, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.slug = get_default()(productDetailData, "slug_s", "");
        productCardProps.customerBrand = get_default()(productDetailData, "CustomerFacingBrand_s", "");
        let tempColorDetails = get_default()(productDetailData, "Color.SKU.Details_s", get_default()(productDetailData, "Color.SKU.Details_ss", null));
        if (tempColorDetails) {
            if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                tempColorDetails = tempColorDetails[0];
            }
            productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
        }
        productCardProps.badgeVal = get_default()(productDetailData, "priceList.".concat(persona, ".saleOffer_s"), "");
        productCardProps.globalDiscount = productCardProps.price - get_default()(productDetailData, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
        const productCategory = productCardProps === null || productCardProps === void 0 ? void 0 : (ref = productCardProps.productCategory) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        productCardProps.priceType = "";
        if (productCategory === "field tiles" || productCategory === "slabs" || productCategory === "mosaics") {
            productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.sfLabel);
        }
        if (productCategory === "trims & moldings") {
            productCardProps.priceType = "/" + (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.lfLabel);
        }
        if (productCategory === "grout") {
            productCardProps.priceType = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.boxLabel;
        }
    }
    const resetNearestValueUpdateFlag = ()=>{
        setIsNearestValueUpdated(false);
    };
    return state.skuType !== "productSku" && !isEmpty_default()(state.productSkuId) && !isEmpty_default()(productCardProps) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCardService, {
        ...productCardProps,
        imagePosition: state.imagePosition,
        newTab: state.newTab,
        staticTexts: staticTexts,
        currencySign: info.currencySign,
        userZipCode: userZipCode,
        isNearest: isNearest,
        skuId: state.productSkuId,
        getZipCode: getZipCode,
        resetNearestValueUpdateFlag: resetNearestValueUpdateFlag,
        isNearestValueUpdated: isNearestValueUpdated,
        cart: cart
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_view/* default */.Z, {
        ...productCardProps,
        product: productCardProps,
        i18n: staticTexts,
        currencySign: info.currencySign,
        presetConfigs: presetConfigs,
        title: productCardProps === null || productCardProps === void 0 ? void 0 : productCardProps.brandName,
        bestSellerContent: state.bestSellerContent
    });
};
/* harmony default export */ var v1_ProductCard = (ProductCard);

;// CONCATENATED MODULE: ./src/components/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    var ref, ref1, ref2;
    if (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : (ref1 = type.subCategory1) === null || ref1 === void 0 ? void 0 : ref1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : (ref2 = type.subCategory1) === null || ref2 === void 0 ? void 0 : ref2.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref3;
    return (ref3 = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref3 !== void 0 ? ref3 : "";
};
const getAnalyticsEventInfo = ()=>{
    var ref;
    const type = window.adobeDataLayer.length ? window.adobeDataLayer[0]["page"]["category"] : {};
    const eventFor = getEventFor(type);
    const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:close" : "".concat(eventFor, ":close");
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "".concat(eventFor, ":modal:where do i find my product model number:close"),
        eventName: "".concat(eventFor, ":modal:where do i find my product model number:close"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
        internalLinkType,
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
    });
};
const productInfoNextEventInfo = ()=>{
    ;
    '{"eventAction":"my account:register non kohler products:product information:next","eventName":"my account:register non kohler products:product information:next","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"next","internalLinkPosition":"register products","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:register non kohler products:product information","internalLinkURL":"n/a","clickInternalLinks":"true"}';
};


;// CONCATENATED MODULE: ./src/components/FindingModelNumber/v1/FindingModelNumber.jsx











const FindingModelNumber = (param)=>{
    let { authorData ={}  } = param;
    var ref;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { FindingModelModal: { show: isShowModelNumberModal  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [findingModelData, setFindingModelData] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        document.querySelectorAll('a[href="#FindingModelNumber"]').forEach((el)=>{
            el.addEventListener("click", showFindingModelPopupHandler);
        });
        findModelNumber();
        return ()=>{
            document.querySelectorAll('a[href="#FindingModelNumber"]').forEach((el)=>{
                el.removeEventListener("click", showFindingModelPopupHandler);
            });
        };
    }, []);
    const showFindingModelPopupHandler = (e)=>{
        e.preventDefault();
        dispatch((0,genericSlice/* showFindingModelPopup */.RS)());
    };
    const findModelNumber = ()=>{
        if (!isEmpty_default()(authorData.findModelNumber)) {
            (0,api/* aemAxiosInstance */.Gb)({
                url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
                params: {
                    path: authorData.findModelNumber
                }
            }).then((response)=>{
                if (response && response.data) {
                    var _data;
                    setFindingModelData((_data = response.data) !== null && _data !== void 0 ? _data : {});
                } else {
                    console.error("Finding a model number: Error occured while fetching data from Get URL Property");
                }
            }).catch((err)=>console.error(err));
        }
    };
    const compareWidth = (a, b)=>{
        if (Number(a.width) > Number(b.width)) return -1;
        if (Number(a.width) < Number(b.width)) return 1;
        return 0;
    };
    var ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "finding-model-number",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            StickCloseButton: true,
            closeButtonAnalytics: getAnalyticsEventInfo(),
            needAnalyticsOnContentsLink: true,
            onModalClose: ()=>dispatch((0,genericSlice/* hideFindingModelPopup */._W)()),
            showModal: isShowModelNumberModal,
            children: !isEmpty_default()(findingModelData) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: !isEmpty_default()(findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.title) ? (0,helper.sanitizeText)(findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.title) : ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-explanation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.assetPath) ? findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.assetPath : findingModelData === null || findingModelData === void 0 ? void 0 : (ref = findingModelData.smartcrop) === null || ref === void 0 ? void 0 : ref.sort(compareWidth),
                            width: "80%",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "finding-model-number__content ".concat((findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.style) === "des-bg-off-white" ? "finding-model-number__content-bg" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "description",
                                children: (0,helper.sanitizeInnerHtml)((ref1 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.description) !== null && ref1 !== void 0 ? ref1 : "")
                            }),
                            (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLinkText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "signUp-text",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": productInfoNextEventInfo(),
                                    type: "black",
                                    label: (ref2 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLinkText) !== null && ref2 !== void 0 ? ref2 : "",
                                    to: (ref3 = findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.ctaLink) !== null && ref3 !== void 0 ? ref3 : "",
                                    target: (findingModelData === null || findingModelData === void 0 ? void 0 : findingModelData.newTabLink) === "true" ? "_blank" : "_self"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_FindingModelNumber = (FindingModelNumber);

// EXTERNAL MODULE: ./components/ProductEnquiry/ProductEnquiryView/index.jsx + 4 modules
var ProductEnquiryView = __webpack_require__(90864);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./utils/blog.jsx


const getBlogs = async ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await api/* apim.get */.TH.get("".concat(constants.PLP_END_POINT_CLIENT, "?q=*:*&rows=50&profilename=profile_kohler-india_PLP_Blogs&collections=kohler-india&fl=id,url_s,thumbNailImage_s,title_s,releaseDate_s,category_ss"));
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getBlogsByCategory = async (category_ss, paginationState)=>{
    const { start , rows  } = paginationState;
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await api/* apim.get */.TH.get("".concat(constants.PLP_END_POINT_CLIENT), {
                params: {
                    fl: "id,url_s,thumbNailImage_s,title_s,releaseDate_s,category_ss",
                    q: "*:*",
                    fq: 'category_ss:("'.concat(category_ss, '")'),
                    collections: "kohler-india",
                    profilename: "profile_kohler-india_PLP_Blogs",
                    rows: "".concat(rows),
                    start: "".concat(start)
                }
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};
const getAllBlogsByCategory = async (category_ss, totalCount)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const { data: content  } = await api/* apim.get */.TH.get("".concat(constants.PLP_END_POINT_CLIENT), {
                params: {
                    fl: "id,url_s,thumbNailImage_s,title_s,releaseDate_s,category_ss",
                    q: "*:*",
                    fq: 'category_ss:("'.concat(category_ss, '")'),
                    collections: "kohler-india",
                    profilename: "profile_kohler-india_PLP_Blogs",
                    rows: "".concat(totalCount),
                    start: 0
                }
            });
            resolve(content);
        } catch (error) {
            reject(error);
        }
    });
};

// EXTERNAL MODULE: ./components/Blog/index.module.scss
var Blog_index_module = __webpack_require__(37764);
var Blog_index_module_default = /*#__PURE__*/__webpack_require__.n(Blog_index_module);
// EXTERNAL MODULE: ./components/ArticleCard/index.module.scss
var ArticleCard_index_module = __webpack_require__(49578);
var ArticleCard_index_module_default = /*#__PURE__*/__webpack_require__.n(ArticleCard_index_module);
;// CONCATENATED MODULE: ./components/ArticleCard/index.jsx




function ArticleCard(param) {
    let { data , eyebrowText  } = param;
    const { title_s ="" , thumbNailImage_s , url_s  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ArticleCard_index_module_default()).articleCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "article-card-page__details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "article-card-page__eyebrow",
                        children: eyebrowText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "article-card-page__title",
                        children: title_s
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: url_s,
                        className: "article-card-page__cta",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ctaText",
                            children: "Read More"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "article-card-page__article-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: thumbNailImage_s !== null && thumbNailImage_s !== void 0 ? thumbNailImage_s : image_missing/* default.src */.Z.src,
                    alt: title_s,
                    onError: (e)=>{
                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                    }
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Blog/Pagination.module.scss
var Pagination_module = __webpack_require__(62219);
var Pagination_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_module);
;// CONCATENATED MODULE: ./public/icons/arrow-left.svg
/* harmony default export */ var arrow_left = ({"src":"/_next/static/media/arrow-left.6e32dfa9.svg","height":17,"width":10});
// EXTERNAL MODULE: ./public/icons/arrow-right.svg
var arrow_right = __webpack_require__(29157);
;// CONCATENATED MODULE: ./components/Blog/Pagination.jsx





const Pagination = (props)=>{
    const { activePage , setActivePage , numberOfPages  } = props;
    const [pageNumbers, setPageNumbers] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        let pages = [];
        for(let i = 1; i <= numberOfPages; i++){
            pages = [
                ...pages,
                i
            ];
        }
        setPageNumbers(pages);
    }, [
        numberOfPages
    ]);
    const disabledNext = !(activePage < numberOfPages);
    const disabledPrevious = !(activePage > 1);
    const scrollToTopOfPage = ()=>{
        const element = document.getElementById("blog-page__tab-list");
        if (element) {
            setTimeout(function() {
                window.scrollTo({
                    top: element.offsetTop - 50,
                    behavior: "smooth"
                });
            }, 2);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Pagination_module_default()).pagination,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page-item",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>{
                        setActivePage(activePage - 1);
                        scrollToTopOfPage();
                    },
                    className: "page-item__arrow-icon ".concat(disabledPrevious ? "disabled" : ""),
                    disabled: disabledPrevious,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: arrow_left.src,
                        alt: "Arrow Left"
                    })
                }),
                pageNumbers.map((pageNumber)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: ()=>{
                            setActivePage(pageNumber);
                            scrollToTopOfPage();
                        },
                        className: "page-item__pageNumbers ".concat(activePage === pageNumber ? "page-item__active" : ""),
                        children: pageNumber
                    }, pageNumber)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>{
                        setActivePage(activePage + 1);
                        scrollToTopOfPage();
                    },
                    className: "page-item__arrow-icon ".concat(disabledNext ? "disabled" : ""),
                    disabled: disabledNext,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: arrow_right/* default.src */.Z.src,
                        alt: "Arrow Right"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Blog_Pagination = (Pagination);

// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
;// CONCATENATED MODULE: ./components/Blog/BlogCategory.jsx








const BlogCategory = (param)=>{
    let { activeTab , categories  } = param;
    var ref;
    const [blogs, setBlogs] = (0,react.useState)([]);
    const [width] = (0,useWindowResize/* default */.Z)(true);
    const [viewAll, setViewAll] = (0,react.useState)(false);
    const [totalCount, setTotalCount] = (0,react.useState)(0);
    const [numberOfPages, setNumberOfPages] = (0,react.useState)(0);
    const [activePage, setActivePage] = (0,react.useState)(1);
    const [paginationState, setPaginationState] = (0,react.useState)({
        rows: width >= 992 ? 9 : 5,
        start: 0
    });
    const [loading, setLoading] = (0,react.useState)(false);
    const { rows , start  } = paginationState;
    const getBlogByCategoryData = async ()=>{
        var ref;
        setLoading(true);
        const category = (ref = categories.find((c)=>c.url === activeTab)) === null || ref === void 0 ? void 0 : ref.categoryName;
        if (category) {
            const { response: { docs =[] , numFound =0  }  } = await getBlogsByCategory(category, paginationState);
            setLoading(false);
            const blogsData = docs.filter((item)=>item.url_s);
            setBlogs(blogsData);
            setTotalCount(numFound);
        }
    };
    const getAllBlogs = async ()=>{
        const { response: { docs =[]  }  } = await getAllBlogsByCategory(category, totalCount);
        setLoading(false);
        const blogsData = docs.filter((item)=>item.url_s);
        setBlogs(blogsData);
    };
    (0,react.useEffect)(()=>{
        setPaginationState((state)=>({
                ...state,
                rows: width >= 992 ? 9 : 5
            }));
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        if (viewAll) {
            getAllBlogs();
        }
    }, [
        viewAll
    ]);
    (0,react.useEffect)(()=>{
        getBlogByCategoryData();
    }, [
        activeTab,
        start,
        rows
    ]);
    (0,react.useEffect)(()=>{
        const itemsPerPage = width >= 992 ? 9 : 5;
        const startIndex = (activePage - 1) * itemsPerPage;
        setPaginationState((state)=>({
                ...state,
                start: startIndex
            }));
    }, [
        activePage
    ]);
    (0,react.useEffect)(()=>{
        const itemPerPage = width >= 992 ? 9 : 5;
        if (totalCount > 0) {
            setNumberOfPages(Math.ceil(totalCount / itemPerPage));
        }
    }, [
        totalCount
    ]);
    const category = (ref = categories.find((c)=>c.url === activeTab)) === null || ref === void 0 ? void 0 : ref.categoryName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "blog-page__list-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "blog-page__list-content",
                    id: "blog-page__list-content",
                    children: blogs.map((item)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "blog-page__article-card-wrapper-list",
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                                data: item,
                                eyebrowText: category
                            })
                        }, item.id);
                    })
                }),
                !viewAll && blogs.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "blog-page__footer-div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "blog-page__view-all",
                            onClick: ()=>setViewAll(true),
                            children: "View All"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_Pagination, {
                            numberOfPages: numberOfPages,
                            activePage: activePage,
                            setActivePage: setActivePage,
                            itemsPerPage: width >= 992 ? 9 : 5
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var Blog_BlogCategory = (BlogCategory);

;// CONCATENATED MODULE: ./components/Blog/index.jsx







const BlogLanding = (props)=>{
    const { data: { categoryTab  }  } = props;
    const [blogs, setBlogs] = (0,react.useState)([]);
    const [categories, setCategories] = (0,react.useState)([]);
    const [activeTab, setActiveTab] = (0,react.useState)(null);
    const getCategoryUrl = function() {
        let category = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return "/blog/" + category.toLowerCase().replace(/\s+/g, "-");
    };
    (0,react.useEffect)(()=>{
        if (categoryTab === null || categoryTab === void 0 ? void 0 : categoryTab.length) {
            const tabData = [];
            categoryTab.forEach((item)=>{
                tabData.push({
                    ...item,
                    url: getCategoryUrl(item.categoryName)
                });
            });
            tabData.unshift({
                categoryName: "All",
                url: "/blog"
            });
            setCategories(tabData);
        }
        if (window.location.pathname === "/blog") getBlogData();
        setActiveTab(window.location.pathname);
    }, []);
    (0,react.useEffect)(()=>{
        if (blogs.length) {
            setTimeout(()=>{
                const carousels = categories.map((c)=>"carousel-".concat(c.categoryName.toLowerCase().replace(" ", "-")));
                carousels.forEach((cId)=>{
                    const elem = document.getElementById(cId);
                    if (elem) {
                        window.OverlayScrollbars(elem, {
                            className: "os-theme-dark",
                            resize: "none",
                            sizeAutoCapable: true,
                            clipAlways: true,
                            normalizeRTL: true,
                            paddingAbsolute: false,
                            autoUpdate: null,
                            autoUpdateInterval: 33,
                            nativeScrollbarsOverlaid: {
                                showNativeScrollbars: false,
                                initialize: true
                            },
                            overflowBehavior: {
                                y: "hidden"
                            },
                            scrollbars: {
                                visibility: "auto",
                                autoHide: "never",
                                autoHideDelay: 800,
                                dragScrolling: true,
                                clickScrolling: true,
                                touchSupport: true,
                                snapHandle: true
                            }
                        });
                    }
                });
            }, 100);
        }
    }, [
        blogs
    ]);
    const getBlogData = async ()=>{
        const { response: { docs =[]  }  } = await getBlogs();
        const blogsData = docs.filter((item)=>item.url_s);
        setBlogs(blogsData);
    };
    const changeActive = (item)=>{
        setActiveTab(item.url);
        window.history.replaceState(null, null, item.url);
        const element = document.getElementById("blog-page__tab-list");
        if (element) {
            window.scrollTo({
                top: element.offsetTop - 50
            });
        }
    };
    const categoryContent = (category)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "blog-page__content",
            id: "carousel-".concat(category.toLowerCase().replace(" ", "-")),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "blog-page__slider",
                role: "listbox",
                children: blogs && blogs.filter((e)=>{
                    var ref;
                    return ((ref = e.category_ss) === null || ref === void 0 ? void 0 : ref[0]) === category;
                }).map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "blog-page__article-card-wrapper",
                        role: "listitem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                            data: item,
                            eyebrowText: category
                        })
                    }, item.id);
                })
            })
        });
    };
    const activeTabContent = (url)=>{
        var ref;
        const category = (ref = categories.find((c)=>c.url === url)) === null || ref === void 0 ? void 0 : ref.categoryName;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "blog-page__list-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "blog-page__list-content",
                id: "blog-page__list-content",
                children: blogs && blogs.filter((e)=>{
                    var ref;
                    return ((ref = e.category_ss) === null || ref === void 0 ? void 0 : ref[0]) === category;
                }).map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "blog-page__article-card-wrapper-list",
                        role: "listitem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                            data: item,
                            eyebrowText: category
                        })
                    }, item.id);
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Blog_index_module_default()).blogLanding,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                id: "blog-page__tab-list",
                className: "blog-page__tab-list",
                role: "tablist",
                children: categories === null || categories === void 0 ? void 0 : categories.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        id: "".concat(item.categoryName, "-tab"),
                        role: "tab",
                        "aria-selected": activeTab === item.url,
                        tabIndex: activeTab === item.url ? 0 : -1,
                        className: classnames_default()({
                            "blog-page__tab-list-item": true,
                            "blog-page__tab-list-active": activeTab === item.url
                        }),
                        onClick: ()=>changeActive(item),
                        children: item.categoryName
                    }, item.url))
            }),
            activeTab === "/blog" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: categories.map((item)=>{
                    if (item.categoryName.toLowerCase() !== "all" && blogs.some((b)=>{
                        var ref;
                        return (ref = b.category_ss) === null || ref === void 0 ? void 0 : ref.includes(item.categoryName);
                    })) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "blog-page__carousel",
                            id: "blog-page__carousel",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "blog-page__heading",
                                    children: item.categoryName
                                }),
                                categoryContent(item.categoryName),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "blog-page__viewAllLink",
                                    onClick: ()=>changeActive(item),
                                    children: "View All"
                                })
                            ]
                        }, "carousel-".concat(item.url.replace("/", "")));
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_BlogCategory, {
                activeTab: activeTab,
                categories: categories
            })
        ]
    });
};
/* harmony default export */ var Blog = (BlogLanding);

// EXTERNAL MODULE: ./components/LeadGeneration/LeadGenerationView/index.module.scss
var LeadGenerationView_index_module = __webpack_require__(48809);
var LeadGenerationView_index_module_default = /*#__PURE__*/__webpack_require__.n(LeadGenerationView_index_module);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./i18n/useLeadGenerationi18n.js


const useLeadGeneration = (authorData)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        mainTitle: "Need Shopping help?",
        enquiryForm: (authorData === null || authorData === void 0 ? void 0 : authorData.formTitle) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.formTitle.replaceAll("&amp;nbsp;", " ")) : t("kf.productEnquiry.main.enquiryTitle"),
        requiredInfoText: (authorData === null || authorData === void 0 ? void 0 : authorData.formDescription) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.formDescription.replaceAll("&amp;nbsp;", " ")) : t("kf.leadGeneration.description"),
        mobileNumber: "Phone Number*",
        name: t("kf.pdp.label.username"),
        nameError: "Your Name is required",
        privacyText: (authorData === null || authorData === void 0 ? void 0 : authorData.leadGenerationPrivacyPolicyText) ? authorData === null || authorData === void 0 ? void 0 : authorData.leadGenerationPrivacyPolicyText : t("kf.leadGeneration.privacyText"),
        submit: "Submit",
        cancel: t("kf.customerSupport.label.cancel"),
        messageDescriptionSuccess: t("kf.leadGeneration.messageDescriptionSuccess", "Thanks for providing your details. One of our expert will contact you shortly."),
        backToForm: t("kf.leadGeneration.backToForm", "Close"),
        errorMobileNumber: "Please enter a valid number",
        validEmailId: t("kf.contactus.error.validEmail"),
        email: t("kf.registration.label.email"),
        phoneNumber: t("kf.pdp.label.phoneNumber"),
        city: t("kf.dealershipEnquiry.city"),
        state: t("kf.account.label.state"),
        scheduleAVisit: t("kf.leadGeneration.scheduleAVisit"),
        validCity: t("kf.account.error.cityError"),
        createDesignPlan: t("kf.kec.label.createDesignPlan"),
        chooseAppointments: t("kf.kec.label.chooseAppointments"),
        bookAppointment: t("kf.kec.button.label"),
        heading1: t("kf.kec.heading1.label"),
        heading2: t("kf.kec.heading2.label"),
        requiredFields: t("kf.dealershipEnquiry.dealershipFormDescription")
    };
    return i18n;
};
/* harmony default export */ var useLeadGenerationi18n = (useLeadGeneration);

;// CONCATENATED MODULE: ./components/LeadGeneration/analytics.js

const pageType = "lead generation";
const componentType = "lead generation";
const submitLeadGenerationAnalytics = (status, statusMsg)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(componentType, ":form:submit"),
        eventName: "".concat(pageType, ":").concat(componentType, ":form:submit"),
        eventStatus: status,
        eventMsg: statusMsg !== null && statusMsg !== void 0 ? statusMsg : "n/a",
        eventType: "navigation",
        internalLinkName: "submit",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":").concat(componentType, ":form"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const navigateToLeadGenerationAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "kohler-experience-center:book-an-appointment",
        eventName: "kohler-experience-center:book-an-appointment",
        eventStatus: "n/a",
        eventMsg: "n/a",
        eventType: "navigation",
        internalLinkName: "book-an-appointment",
        internalLinkPosition: "kohler-experience-center",
        internalLinkType: "kohler-experience-center:navigation",
        internalLinkZoneName: "kohler-experience-center",
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};

;// CONCATENATED MODULE: ./components/LeadGeneration/Confirmation.jsx





const Confirmation = (props)=>{
    const { staticText , setConfirmationSuccess  } = props;
    const onClick = ()=>{
        setConfirmationSuccess(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LeadGenerationView_index_module_default()).leadGenerationLanding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lead-generation__success-box",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lead-generation__success-description",
                    children: staticText.messageDescriptionSuccess
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        customClass: "kf-react-button",
                        className: "kf-react-button button large black flexible",
                        role: "button",
                        id: "submit-contact-form-button",
                        onClick: onClick,
                        type: "black",
                        label: staticText === null || staticText === void 0 ? void 0 : staticText.backToForm
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LeadGeneration_Confirmation = (Confirmation);

// EXTERNAL MODULE: ./utils/validate.js
var validate = __webpack_require__(45648);
// EXTERNAL MODULE: ./utils/enquiry.js
var enquiry = __webpack_require__(55754);
// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/LeadGeneration/Form/Enquiry.jsx















const Enquiry = (props)=>{
    var ref, ref1;
    const { staticText , setConfirmationSuccess , authorData , stateWithCities  } = props;
    const [error, setError] = (0,react.useState)({});
    const [data, setData] = (0,react.useState)({});
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [numberOfBathrooms, setNumberOfBathrooms] = (0,react.useState)([]);
    const [city, setCity] = (0,react.useState)([]);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const cities = authorData === null || authorData === void 0 ? void 0 : (ref = authorData.citiesAvailableItems) === null || ref === void 0 ? void 0 : ref.map((item)=>{
            return item.citiesAvailable;
        });
        const numberOfBathroom = authorData === null || authorData === void 0 ? void 0 : (ref1 = authorData.quantityAvailableItems) === null || ref1 === void 0 ? void 0 : ref1.map((item)=>{
            return item.quantity;
        });
        setNumberOfBathrooms(numberOfBathroom);
        setCity(cities);
    }, []);
    const onNameChange = (e)=>{
        const { value  } = e.target;
        if (value === "" || (0,validate/* validText */.WQ)(value)) {
            setData({
                ...data,
                name: value
            });
        }
    };
    const onBlur = (field)=>{
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const validateExist = (field)=>{
        if (field === "name") {
            var ref;
            if (!((ref = data[field]) === null || ref === void 0 ? void 0 : ref.trim()) || !(0,helper.validateField)("name", data[field])) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.nameError;
            } else return "";
        } else if (field === "phone") {
            var ref1, ref2;
            if ((data === null || data === void 0 ? void 0 : (ref1 = data.phone) === null || ref1 === void 0 ? void 0 : ref1.trim()) && !constants.PHONE_REGEX.test(data === null || data === void 0 ? void 0 : data.phone)) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.errorMobileNumber;
            } else if (!authorData.kecFormFlag && !(data === null || data === void 0 ? void 0 : (ref2 = data.phone) === null || ref2 === void 0 ? void 0 : ref2.trim())) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.errorMobileNumber;
            }
        } else if (field === "email") {
            if (!data[field]) return "";
            else if (!(0,helper.validateField)("email", data[field]) || !(0,validate/* validateEmail */.oH)(data[field])) return staticText === null || staticText === void 0 ? void 0 : staticText.validEmailId;
        } else if (field === "city") {
            var ref3;
            if (authorData.kecFormFlag && !((ref3 = data[field]) === null || ref3 === void 0 ? void 0 : ref3.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.validCity;
        }
    };
    const onChangeEmailId = (e)=>{
        const { value  } = e.target;
        setData({
            ...data,
            email: value
        });
        if (value) {
            if ((0,validate/* validateEmail */.oH)(value)) {
                setError({
                    ...error,
                    email: ""
                });
            } else {
                setError({
                    ...error,
                    email: staticText.validEmailId
                });
            }
        }
    };
    const handleSubmit = async ()=>{
        var ref;
        const errorList = getErrorList();
        const { id , ...rest } = router.query;
        setIsLoading(true);
        let errorDataList = [];
        setError(errorList);
        if (errorList === null || errorList === void 0 ? void 0 : errorList.name) {
            errorDataList.push("name");
        }
        errorDataList.forEach((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            const { name , phone , email , city , state , numberOfBathrooms  } = data;
            if (authorData === null || authorData === void 0 ? void 0 : authorData.kecFormFlag) {
                var ref1;
                const date = (ref1 = moment_default()(new Date())) === null || ref1 === void 0 ? void 0 : ref1.format("DD/MM/YYYY");
                const payload = {
                    name: name === null || name === void 0 ? void 0 : name.trim(),
                    ...phone && {
                        mobileNumber: phone
                    },
                    email: email ? [
                        email
                    ] : [],
                    city: city,
                    state: state,
                    ...numberOfBathrooms && {
                        numberOfBathrooms: numberOfBathrooms
                    },
                    date: date
                };
                const utmParams = [
                    "utm_source",
                    "utm_content",
                    "utm_medium",
                    "utm_term",
                    "utm_campaign"
                ];
                utmParams === null || utmParams === void 0 ? void 0 : utmParams.forEach((param)=>{
                    if (rest === null || rest === void 0 ? void 0 : rest[param]) {
                        payload[param] = decodeURIComponent(rest[param]);
                    }
                });
                const response = await (0,enquiry/* submitLeadGeneration */.go)({
                    payload,
                    isKECForm: true
                });
                if (response.statusCode === 200) {
                    submitLeadGenerationAnalytics("success");
                    setConfirmationSuccess(true);
                } else {
                    submitLeadGenerationAnalytics("failure", "form submission failed");
                    setConfirmationSuccess(false);
                }
                setIsLoading(false);
            } else {
                const payload1 = {
                    name: name === null || name === void 0 ? void 0 : name.trim(),
                    contactNumber: phone
                };
                const response1 = await (0,enquiry/* submitLeadGeneration */.go)({
                    payload: payload1
                });
                if (response1.statusCode === 200) {
                    submitLeadGenerationAnalytics("success");
                    setConfirmationSuccess(true);
                } else {
                    submitLeadGenerationAnalytics("failure", "form submission failed");
                    setConfirmationSuccess(false);
                }
                setIsLoading(false);
            }
        } else {
            submitLeadGenerationAnalytics("failure", "form validation failed");
        }
        setIsLoading(false);
    };
    const getErrorList = ()=>{
        const errorList = {
            name: validateExist("name"),
            phone: validateExist("phone"),
            city: validateExist("city")
        };
        return errorList;
    };
    const isEnabled = ((ref = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref === void 0 ? void 0 : ref.find((el)=>el)) ? true : false;
    const handleChangeNumber = (event)=>{
        const { value  } = event.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                phone: value
            });
            setError({
                ...error,
                phone: ""
            });
        }
    };
    const handleNumberOfBathrooms = (numberOfBathrooms)=>{
        setData({
            ...data,
            numberOfBathrooms
        });
    };
    const handleCityChange = (city)=>{
        var ref, ref1;
        const stateName = (ref = stateWithCities === null || stateWithCities === void 0 ? void 0 : stateWithCities.filter((ele)=>{
            var ref;
            return ele === null || ele === void 0 ? void 0 : (ref = ele.cityName) === null || ref === void 0 ? void 0 : ref.includes(city);
        })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.stateName;
        setData({
            ...data,
            state: stateName,
            city: city
        });
        setError({
            ...error,
            city: ""
        });
    };
    var ref2, ref3, ref4, _numberOfBathrooms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lead-generation__margin-div",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "lead-generation-name",
                type: "text",
                placeholder: "Name*",
                label: "Name*",
                value: (ref2 = data === null || data === void 0 ? void 0 : data.name) !== null && ref2 !== void 0 ? ref2 : "",
                onChange: onNameChange,
                onInput: onNameChange,
                showError: (error === null || error === void 0 ? void 0 : error.name) !== "" && (error === null || error === void 0 ? void 0 : error.name),
                errorMessage: error === null || error === void 0 ? void 0 : error.name,
                onBlur: ()=>onBlur("name"),
                autoComplete: false,
                maxLength: 40
            }),
            authorData.kecFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "contact-user-emailId",
                type: "text",
                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.email,
                label: staticText === null || staticText === void 0 ? void 0 : staticText.email,
                value: (ref3 = data === null || data === void 0 ? void 0 : data.email) !== null && ref3 !== void 0 ? ref3 : "",
                onChange: onChangeEmailId,
                showError: error === null || error === void 0 ? void 0 : error.email,
                errorMessage: error === null || error === void 0 ? void 0 : error.email,
                maxLength: 60,
                onBlur: ()=>onBlur("email"),
                autoComplete: false,
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/icons/email.svg",
                    alt: "",
                    "aria-hidden": "true"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "lead-generation-phone",
                type: "text",
                placeholder: authorData.kecFormFlag ? staticText.phoneNumber : staticText.mobileNumber,
                label: authorData.kecFormFlag ? staticText.phoneNumber : staticText.mobileNumber,
                value: (ref4 = data === null || data === void 0 ? void 0 : data.phone) !== null && ref4 !== void 0 ? ref4 : "",
                maxLength: 10,
                autoComplete: false,
                onChange: handleChangeNumber,
                showError: error === null || error === void 0 ? void 0 : error.phone,
                errorMessage: error === null || error === void 0 ? void 0 : error.phone,
                onBlur: ()=>onBlur("phone"),
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/icons/phone-icon.svg",
                    alt: "",
                    "aria-hidden": "true"
                })
            }),
            authorData.kecFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                    id: "lead-form-numberOfBathrooms",
                    data: numberOfBathrooms,
                    value: (_numberOfBathrooms = data.numberOfBathrooms) !== null && _numberOfBathrooms !== void 0 ? _numberOfBathrooms : "",
                    label: "Number of bathrooms that require Kohler products",
                    onChange: handleNumberOfBathrooms
                })
            }) : null,
            authorData.kecFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(lib/* isMobile */.tq ? "pr-0" : "pr-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            customClass: "customer-support-inputfield",
                            id: "lead-form-city",
                            type: "text",
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.city,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.city,
                            value: data.city,
                            data: city,
                            onChange: handleCityChange,
                            showError: error.city,
                            errorMessage: error.city,
                            onBlur: ()=>onBlur("city")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(lib/* isMobile */.tq ? "pl-0" : "pl-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "customer-support-inputfield enquiry-state",
                            className: "enquiry-state",
                            id: "contact-user-state",
                            type: "text",
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.state,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.state,
                            value: data.state,
                            showError: error.state,
                            errorMessage: error.state,
                            disabled: true
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lead-generation__buttonDiv",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "black",
                    role: "button",
                    label: authorData.kecFormFlag ? staticText.scheduleAVisit : staticText.submit,
                    className: "lead-generation__button",
                    flexible: true,
                    onClick: handleSubmit,
                    disabled: isEnabled,
                    loading: isLoading
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lead-generation__privacyText",
                children: (0,html_react_parser/* default */.ZP)((ref1 = staticText.privacyText) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler-india/in").join("").replace(".html", "").replace("/en", ""))
            })
        ]
    });
};
/* harmony default export */ var Form_Enquiry = (Enquiry);

// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var react_sticky_el_lib = __webpack_require__(75198);
// EXTERNAL MODULE: ./components/LeadGeneration/Sticky.module.scss
var Sticky_module = __webpack_require__(70427);
var Sticky_module_default = /*#__PURE__*/__webpack_require__.n(Sticky_module);
;// CONCATENATED MODULE: ./components/LeadGeneration/StickyHeader.jsx






const StickyHeader = (props)=>{
    const { sticky , setSticky , navigateToBookAppointment =()=>{} , staticText ={}  } = props;
    const [scrollUp, setScrollUp] = (0,react.useState)(false);
    const [width] = (0,useWindowResize/* default */.Z)(true);
    const [showText, setShowText] = (0,react.useState)(width >= 992);
    let lastScrollY = 0;
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY > lastScrollY) {
                setScrollUp(true);
            } else {
                setScrollUp(false);
            }
            lastScrollY = window.scrollY;
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(()=>{
        setShowText(width > 992);
    }, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Sticky_module_default()).blogStickyHeadWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_sticky_el_lib/* default */.ZP, {
            className: "blog-sticky-header",
            stickyClassName: "sticky sticky-blog-page",
            onFixedToggle: ()=>setSticky(!sticky),
            children: sticky && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "blog-sticky-header container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "blog-sticky-header__details-wrap container-fluid",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "blog-sticky-header__container kf-react-plp-container",
                        children: [
                            showText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "blog-sticky-header__details",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "blog-sticky-header__brand-name",
                                        children: staticText.createDesignPlan
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "blog-sticky-header__description",
                                        children: staticText.chooseAppointments
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blog-sticky-header__right ".concat(!showText ? "blog-sticky-header__align-center" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: navigateToBookAppointment,
                                    useDefaultClass: true,
                                    className: "gbh-data-layer",
                                    role: "button",
                                    size: "small",
                                    type: "primary",
                                    label: staticText.bookAppointment
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var LeadGeneration_StickyHeader = (StickyHeader);

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./public/icons/calendar.svg
var calendar = __webpack_require__(65110);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
// EXTERNAL MODULE: ./components/OmniChannel/index.module.scss
var OmniChannel_index_module = __webpack_require__(56384);
var OmniChannel_index_module_default = /*#__PURE__*/__webpack_require__.n(OmniChannel_index_module);
;// CONCATENATED MODULE: ./i18n/useOmniChanneli18n.js

const useOmniChannel = function() {
    let authorData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        firstNameLabel: "First Name",
        lastNameLabel: "Last Name",
        mobileNumberLabel: "Mobile Number",
        getOtpLabel: "Get OTP",
        emailLabel: "Email",
        pinCodeLabel: "Pin Code",
        noOfBathroomLabel: "Number of Bathrooms",
        budgetLabel: "Budget",
        submitLabel: "Submit Request",
        kecCityLabel: "Kohler Experience Center/Studio City",
        cityLabel: "City",
        stateLabel: "State",
        productCategoryLable: "Product Category",
        fileTypeLabel: "Choose document type",
        constructionTypeLabel: "Construction Type",
        siteAddressLabel: "Site Address",
        purchasePickListLabel: "When do you expect to make your purchase?",
        mandatoryLabel: "Fields marked with * are required.",
        disclaimerTxt: "This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.",
        disclaimerLink1: "Privacy  Policy",
        disclaimerLink2: "Subject Access Request",
        inspirationTitle: "PLEASE ENTER YOUR DETAILS TO DOWNLOAD INSPIRATION GALLERY",
        selfRegistrationTitle: "PLEASE ENTER YOUR DETAILS TO DOWNLOAD INSPIRATION GALLERY",
        kecAppointmentTitle: "Fill in the form below, and our team will get in touch to schedule your appointment at a convenient time.",
        siteVisitTitle: "Fill in the form below, and our team will get in touch to schedule your appointment at a convenient time.",
        whatAppConent: "I consent to receive marketing communication and offers from Kohler on WhatsApp.",
        smsEmailConsent: "I consent to receive marketing communication and offers from Kohler on SMS and Email.",
        defaultAddress: "Default Address",
        firstNameError: "Your first name is required",
        lastNameError: "Your last name is required",
        noEmailError: "Please provide your email address",
        emailAddressError: "Please enter a valid email address",
        wrongPincodeError: "Invalid pincode",
        noPinCodeError: "Pin Code is required",
        inValidPinCodeError: "Please enter a 6 digit valid pincode",
        bathroomNoEmpty: "Please enter valid number of bathrooms",
        mobileNumberError: "Please enter mobile number",
        validMobileNoError: "Please enter a valid mobile number",
        mobileVerifyNumber: "Please verify your Mobile Number",
        mobileNumberVerified: "Your number has been verified",
        productCategoryError: "Please Select Product Category",
        kecCityError: "Please select Kec City",
        purchasePickError: "Please select purchase timeline",
        verificationTitle: "Mobile number verification",
        verify: "Verify",
        confirmationmodal: 'Thank you for completing mobile number verification. Click "Close" to return to the form.',
        receiveOTP: "Your OTP has expired",
        resend: "Resend OTP",
        invalidOTP: "OTP is invalid or no longer active",
        firstNameDescription: "Please enter the first name as mentioned on the invoice",
        lastNameDescription: "Please enter the last name as mentioned on the invoice",
        invoice: "An invoice or receipt from the place of purchase",
        stamped: "Stamped directly onto the product itself",
        uploadFileSizeError: "You have exceeded the maximum file size limit of 5MB. Please upload less than 5MB",
        provideImageError: "Please provide the invoice in PNG, JPG, JPEG or PDF format",
        uploadFileTypeError: "You shall upload only PNG, JPG, JPEG, PDF format.",
        ariaLabel: {
            imageRemove: "Document removed successfully"
        },
        drag: "Drag",
        drop: "Drop",
        or: "Or",
        uploadPhoto: "Upload File",
        addPhoto: "Add More Photo(s)",
        stateError: "Please provide your state",
        cityError: "Please provide your city",
        siteAddressError: "Please provide site address",
        constructionTypeError: "Please Select Construction Type",
        fileTypeError: "Please Select Document Type",
        alternateMobileNumberLabel: "Alternate Mobile Number",
        addressLabel: "Address",
        landmarkLabel: "Landmark",
        productDetailsLabel: "Product Details",
        reportIssueLabel: "Report Issue",
        dateOfInvoiceLabel: "Date of Invoice DD/MM/YYYY",
        addressError: "Please provide Address",
        productDetailsError: "Please Select Product Details",
        reportIssueError: "Please provide report issue",
        slotError: "Please Choose Date and Time"
    };
    return i18n;
};
/* harmony default export */ var useOmniChanneli18n = (useOmniChannel);

// EXTERNAL MODULE: ./components/checkout/ConfimationModal/ConfirmationModal.jsx
var ConfirmationModal = __webpack_require__(24562);
// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/ImageUpload/index.jsx + 1 modules
var ImageUpload = __webpack_require__(32753);
// EXTERNAL MODULE: ./utils/findStore.js
var findStore = __webpack_require__(42605);
// EXTERNAL MODULE: ./components/OmniChannel/DateTimePicker.module.scss
var DateTimePicker_module = __webpack_require__(92752);
var DateTimePicker_module_default = /*#__PURE__*/__webpack_require__.n(DateTimePicker_module);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(69119);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/index.js + 29 modules
var dist = __webpack_require__(35571);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/Calendar.css
var Calendar = __webpack_require__(45787);
;// CONCATENATED MODULE: ./components/OmniChannel/analytics.js
const analytics_getEventInfo = function(text) {
    let date = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    let eventType = "";
    let internalLinkType = "";
    let eventName = "";
    let internalLinkName = "";
    if (text === "date select") {
        eventType = "Calendar";
        internalLinkType = "Calendar";
    } else if (text === "slot select") {
        eventType = "Slot";
        internalLinkType = "Appointment Slot";
    } else if (text === "no slot available") {
        eventType = "Error";
        internalLinkType = "Availability Status";
    } else if (text === "change slot") {
        eventType = "Button";
        internalLinkType = "Button";
    } else if (text === "success") {
        internalLinkType = "Form Submission";
        eventType = "Form";
    } else if (text === "slot full alternative") {
        internalLinkType = "Popup";
        eventType = "Error";
    }
    if (date !== "") {
        eventName = "kohler-india:kec appointment:".concat(text, ":").concat(date);
        internalLinkName = "".concat(date);
    } else {
        eventName = "kohler-india:kec appointment:".concat(text);
        internalLinkName = "".concat(text);
    }
    const eventInfo = {
        clickInternalLinks: "true",
        internalLinkPosition: "kohler-india:kec appointment",
        internalLinkZoneName: "kohler-india:kec appointment",
        internalLinkURL: "n/a",
        internalLinkName: internalLinkName,
        eventName: eventName,
        internalLinkType: "".concat(internalLinkType),
        eventType: "".concat(eventType),
        eventAction: eventName
    };
    return eventInfo;
};
const selectDateAnalytics = (date, data)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = analytics_getEventInfo("date select", date);
    page.user.kecCity = data.kecCity;
    page.user.pinCode = data.pinCode;
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const selectSlotAnalytics = (slot, data)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = analytics_getEventInfo("slot select", slot);
    page.user.kecCity = data.kecCity;
    page.user.pinCode = data.pinCode;
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const noAvailableSlotsAnalytics = (data)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = analytics_getEventInfo("no slot available");
    page.user.kecCity = data.kecCity;
    page.user.pinCode = data.pinCode;
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const changeSlotAnalytics = (data)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = analytics_getEventInfo("change slot");
    page.user.kecCity = data.kecCity;
    page.user.pinCode = data.pinCode;
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const confirmSlotAnalytics = (data)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = analytics_getEventInfo("success");
    page.user.kecCity = data.kecCity;
    page.user.pinCode = data.pinCode;
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const slotAlreadyBookedAnalytics = (data)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const eventInfo = analytics_getEventInfo("slot full alternative");
    page.user.kecCity = data.kecCity;
    page.user.pinCode = data.pinCode;
    window === null || window === void 0 ? void 0 : (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};

;// CONCATENATED MODULE: ./components/OmniChannel/DateTimePicker.jsx









const DateTimePicker = (props)=>{
    const { disabled , onChangeDateTime =()=>{} , isEdit =false , kecData ={} , setIsEdit =()=>{} , monthlyAvailability ={} , error ={} , setError =()=>{}  } = props;
    const [isVisible, setIsVisible] = (0,react.useState)(false);
    const [selectedDate, setSelectedDate] = (0,react.useState)((0,format["default"])(new Date(), "yyyy-MM-dd"));
    const [selectedSlot, setSelectedSlot] = (0,react.useState)(null);
    const [slots, setSlots] = (0,react.useState)([]);
    const minDate = new Date();
    const maxDate = (0,addDays["default"])(new Date(), 29);
    const TIME_SLOTS = [
        {
            apiKey: "11AM - 1PM",
            label: "11 am - 1 pm"
        },
        {
            apiKey: "1PM - 3PM",
            label: "1 pm - 3 pm"
        },
        {
            apiKey: "3PM - 5PM",
            label: "3 pm - 5 pm"
        },
        {
            apiKey: "5PM - 7PM",
            label: "5 pm - 7 pm"
        }
    ];
    const showDateTimePicker = (event)=>{
        if (disabled) {
            event.preventDefault();
        } else {
            setIsVisible(true);
        }
    };
    const modalCloseHandler = ()=>{
        setIsVisible(false);
        setIsEdit(false);
        const element = document.getElementById("omni-channel-form");
        if (element) {
            setTimeout(function() {
                window.scrollTo({
                    top: element.offsetTop - 250,
                    behavior: "smooth"
                });
            }, 50);
        }
        setError({
            ...error,
            "slot": "Please Choose Date & Time"
        });
    };
    const tileDisabled = (param)=>{
        let { date , view  } = param;
        if (view !== "month") return false;
        if (date < (0,startOfDay["default"])(minDate) || date > (0,startOfDay["default"])(maxDate)) return true;
        return false;
    };
    const filterSlots = (slots, selectedDate)=>{
        const now = new Date();
        const selected = new Date(selectedDate);
        // Check if selected date is today
        const isToday = now.getFullYear() === selected.getFullYear() && now.getMonth() === selected.getMonth() && now.getDate() === selected.getDate();
        if (!isToday) {
            return slots; // return all slots
        }
        return Object.fromEntries(Object.entries(slots).filter((param)=>{
            let [timeRange] = param;
            const [startTime] = timeRange.split(" - ");
            const slotDate = new Date();
            const parsed = parseTime(startTime);
            slotDate.setHours(parsed.hours, parsed.minutes, 0);
            return slotDate > now; // keep future slots only
        }));
    };
    const parseTime = (timeStr)=>{
        const match = timeStr.match(/(\d+)(AM|PM)/);
        let hours = parseInt(match[1]);
        const period = match[2];
        if (period === "PM" && hours !== 12) hours += 12;
        if (period === "AM" && hours === 12) hours = 0;
        return {
            hours,
            minutes: 0
        };
    };
    const getSlotsForDate = (date)=>{
        if (Object.keys(monthlyAvailability).length) {
            var ref, ref1;
            if ((monthlyAvailability === null || monthlyAvailability === void 0 ? void 0 : (ref = monthlyAvailability[date]) === null || ref === void 0 ? void 0 : ref.isBlock) || (monthlyAvailability === null || monthlyAvailability === void 0 ? void 0 : (ref1 = monthlyAvailability[date]) === null || ref1 === void 0 ? void 0 : ref1.isHoliday)) {
                setSlots([]);
                noAvailableSlotsAnalytics(kecData);
            } else {
                let slotData = monthlyAvailability === null || monthlyAvailability === void 0 ? void 0 : monthlyAvailability[date];
                const keysToRemove = [
                    "isBlock",
                    "isHoliday"
                ];
                keysToRemove.forEach((key)=>{
                    delete slotData[key];
                });
                Object.entries(slotData).forEach((ele)=>{
                    if (ele[1] === 0) {
                        delete slotData[ele[0]];
                    }
                });
                slotData = filterSlots(slotData, date);
                const slotOutput = [
                    slotData
                ].map((obj)=>{
                    var _apiKey;
                    return TIME_SLOTS.map((param)=>{
                        let { apiKey , label  } = param;
                        return {
                            apiKey,
                            label,
                            remaining: Number((_apiKey = obj[apiKey]) !== null && _apiKey !== void 0 ? _apiKey : 0)
                        };
                    }).filter((slot)=>slot.remaining > 0);
                });
                if (slotOutput[0].length === 0) {
                    noAvailableSlotsAnalytics(kecData);
                }
                setSlots(...slotOutput);
            }
        } else {
            setSlots([]);
        }
    };
    const confirmSlot = ()=>{
        onChangeDateTime(selectedSlot, selectedDate);
        confirmSlotAnalytics(kecData);
        setIsVisible(false);
        setIsEdit(false);
        const element = document.getElementById("omni-channel-form");
        if (element) {
            if (element.offsetTop > 250) setTimeout(function() {
                window.scrollTo({
                    top: element.offsetTop - 250,
                    behavior: "smooth"
                });
            }, 50);
            else setTimeout(function() {
                window.scrollTo({
                    top: element.offsetTop + 1900,
                    behavior: "smooth"
                });
            }, 50);
        }
    };
    (0,react.useEffect)(()=>{
        if (!selectedDate) return;
        getSlotsForDate(selectedDate);
    }, [
        isVisible,
        selectedDate
    ]);
    (0,react.useEffect)(()=>{
        if (isEdit) {
            setSelectedDate(kecData === null || kecData === void 0 ? void 0 : kecData.appointmentDate);
            setSelectedSlot(kecData === null || kecData === void 0 ? void 0 : kecData.slot);
            setIsVisible(isEdit);
        }
    }, [
        isEdit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((DateTimePicker_module_default()).imageUploadWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-upload-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "file-upload-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "upload-button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "upload-button-text ".concat(disabled ? "disable" : ""),
                                onClick: showDateTimePicker,
                                children: "Select date & time"
                            }),
                            error && error.slot !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "file-upload-container__error-msg",
                                children: error.slot
                            })
                        ]
                    })
                })
            }),
            isVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                onModalClose: modalCloseHandler,
                showModal: isVisible,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-calendar",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                            value: selectedDate,
                            onChange: (v)=>{
                                const d = Array.isArray(v) ? v[0] : v;
                                setSelectedDate((0,format["default"])(new Date(d), "yyyy-MM-dd"));
                                setSelectedSlot(null);
                                selectDateAnalytics((0,format["default"])(new Date(d), "yyyy-MM-dd"), kecData);
                            },
                            minDetail: "month",
                            maxDetail: "month",
                            prev2Label: null,
                            next2Label: null,
                            tileDisabled: tileDisabled
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slots",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "slot-grid",
                            children: (slots === null || slots === void 0 ? void 0 : slots.length) === 0 || Object.keys(slots === null || slots === void 0 ? void 0 : slots[0]).length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "no-slots",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "no-slots-text",
                                        children: "No available slots for this date."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "no-slots-text",
                                        children: "Please select alternate date."
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "slots-title",
                                        children: "Available slots"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: slots === null || slots === void 0 ? void 0 : slots.map((ele)=>{
                                            const isSelected = selectedSlot && ele.apiKey === selectedSlot;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "slots-details ".concat(isSelected ? "selected" : ""),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "slot-text",
                                                    onClick: ()=>{
                                                        setSelectedSlot(ele.apiKey);
                                                        selectSlotAnalytics(ele.label, kecData);
                                                    },
                                                    children: ele.label
                                                })
                                            });
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "gbh-data-layer",
                        useDefaultClass: true,
                        type: "black",
                        role: "button",
                        label: "Confirm Slot",
                        onClick: confirmSlot,
                        customClass: "slot-button",
                        disabled: !selectedSlot
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var OmniChannel_DateTimePicker = (DateTimePicker);

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var lib_esm = __webpack_require__(34853);
;// CONCATENATED MODULE: ./components/OmniChannel/RecaptchaForm.jsx



























const RecaptchaForm = (props)=>{
    var ref, ref1, ref2, ref3;
    const { authorData , omniQRParams , isQrService , isKohlerCare =false  } = props;
    const staticText = useOmniChanneli18n(authorData);
    const { budgetItems , purchaseTimeItems , citiesAvailableItems , productCategoryItems , typeItems  } = authorData;
    const [error, setError] = (0,react.useState)({});
    const [data, setData] = (0,react.useState)({});
    const [recaptchaVerified, setRecaptchaVerified] = (0,react.useState)(false);
    const [modalDisplayFlag, setModalDisplayFlag] = (0,react.useState)(false);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [paramsByUrl, setParamsByUrl] = (0,react.useState)({});
    const [showErrorModal, setShowErrorModal] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [stateCityDisabled, setStateCityDisabled] = (0,react.useState)(true);
    const [clearImage, setClearImage] = (0,react.useState)(false);
    const [uploadImageLoading, setUploadImageLoading] = (0,react.useState)(false);
    const [isEdit, setIsEdit] = (0,react.useState)(false);
    const [monthlyAvailabilityData, setMonthlyAvailabilityData] = (0,react.useState)({});
    const [kecSlotBooked, setKecSlotBooked] = (0,react.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    const [numberOfReTries, setNumberOfReTries] = (0,react.useState)(0);
    const [token, setToken] = (0,react.useState)(null);
    const numberOfTriesAllowed = 2;
    (0,react.useEffect)(()=>{
        const _url_params = getParamsByURL(omniQRParams);
        setParamsByUrl(_url_params);
        const dataInitialValue = getInitialDataValues(_url_params);
        setData(dataInitialValue);
    }, []);
    const handleTextFieldChange = (e1)=>{
        const { name , value  } = e1.target;
        if (value === "" || (0,validate/* validText */.WQ)(value)) {
            setData({
                ...data,
                [name]: value
            });
            setError({
                ...error,
                [name]: ""
            });
        }
    };
    const handleAlphaNumericFieldChange = (e1)=>{
        const { name , value  } = e1.target;
        setData({
            ...data,
            [name]: value
        });
        setError({
            ...error,
            [name]: ""
        });
    };
    const changeDateFormat = (date)=>{
        if (date) {
            const dateVal = moment_default()(date).format("YYYY-MM-DD");
            setData({
                ...data,
                dateOfInvoice: dateVal
            });
            setError({});
        } else {
            setData({
                ...data,
                dateOfInvoice: ""
            });
        }
    };
    const handleNumberFieldChange = (e1)=>{
        const { name , value  } = e1.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                [name]: value
            });
            setError({
                ...error,
                [name]: ""
            });
        }
    };
    const getAppointments = async (kecCity)=>{
        const response = await (0,enquiry/* getKECAppointments */.HQ)({
            city: kecCityMapping === null || kecCityMapping === void 0 ? void 0 : kecCityMapping.find((item)=>item[kecCity])[kecCity]
        });
        const { monthlyAvailability  } = response;
        setMonthlyAvailabilityData(monthlyAvailability);
    };
    const handleDropDownChange = (value, field)=>{
        if (field === "kecCity") {
            getAppointments(value);
            setData({
                ...data,
                slot: "",
                appointmentDate: "",
                [field]: value
            });
            setError({
                ...error,
                [field]: ""
            });
        } else {
            setData({
                ...data,
                [field]: value
            });
            setError({
                ...error,
                [field]: ""
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (authorData.warrantyRegistrationFormFlag || authorData.siteRegistrationFormFlag || authorData.serviceRequestFormFlag || authorData.omniChannelKECFormFlag) {
            if ((data === null || data === void 0 ? void 0 : data.pinCode) && (0,validate/* validPincode */.cE)(data === null || data === void 0 ? void 0 : data.pinCode)) {
                const response = (0,findStore/* getDetailsFromZipCode */.k_)(data === null || data === void 0 ? void 0 : data.pinCode);
                response.then((resp)=>{
                    const { statusCode , result ={}  } = resp;
                    if (statusCode === 200) {
                        var ref;
                        const { city , state  } = (ref = result === null || result === void 0 ? void 0 : result.data) !== null && ref !== void 0 ? ref : {};
                        setData({
                            ...data,
                            city: city,
                            state: state
                        });
                        setStateCityDisabled(true);
                        if (authorData.omniChannelKECFormFlag) {
                            if (citiesAvailableItems.findIndex((ele)=>ele.citiesAvailable.toLowerCase() === city.toLowerCase()) >= 0) {
                                setData({
                                    ...data,
                                    kecCity: city
                                });
                                getAppointments(city);
                                setError({
                                    ...error,
                                    kecCity: ""
                                });
                            }
                        }
                    } else {
                        setError({
                            ...error,
                            pinCode: staticText.wrongPincodeError
                        });
                        setStateCityDisabled(true);
                    }
                });
            } else if (data === null || data === void 0 ? void 0 : data.pinCode) {
                setData({
                    ...data,
                    city: "",
                    state: ""
                });
                if (authorData.omniChannelKECFormFlag) {
                    setData({
                        ...data,
                        kecCity: "",
                        slot: "",
                        appointmentDate: ""
                    });
                    setMonthlyAvailabilityData({});
                }
            }
        }
    }, [
        data === null || data === void 0 ? void 0 : data.pinCode
    ]);
    const onChangeEmail = (e1)=>{
        const { value  } = e1.target;
        setData({
            ...data,
            email: value
        });
        if (value) {
            if ((0,validate/* validateOptionalEmail */.Uc)(value)) {
                setError({
                    ...error,
                    email: null
                });
            } else {
                setError({
                    ...error,
                    email: staticText.emailAddressError
                });
            }
        }
    };
    const handleConsent = (e1, fieldname)=>{
        setData({
            ...data,
            [fieldname]: e1.target.checked
        });
    };
    const modalCloseHandler = ()=>{
        setModalDisplayFlag(false);
        const form_session_val = getInitialDataValues(paramsByUrl);
        setData(form_session_val);
        if (authorData.bathroomInspirationFormFlag || authorData.selfRegistrationFormFlag) dispatch((0,cartSlice/* hideLeadForm */.gY)());
        if (authorData.bathroomInspirationFormFlag) window.open(authorData.pdfPath, "_blank");
        setTimeout(function() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }, 5);
    };
    const closeErrorModal = ()=>{
        setShowErrorModal(false);
        const form_session_val = getInitialDataValues(paramsByUrl);
        if (!kecSlotBooked) {
            setData(form_session_val);
        } else {
            setData({
                ...data,
                slot: "",
                appointmentDate: ""
            });
            getAppointments(data.kecCity);
            handleModalClose();
        }
        setKecSlotBooked(false);
        if (authorData.bathroomInspirationFormFlag || authorData.selfRegistrationFormFlag) dispatch((0,cartSlice/* hideLeadForm */.gY)());
    };
    const getNoOfBathroomLabel = ()=>{
        return authorData.omniChannelKECFormFlag || authorData.amcFormFlag ? "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.noOfBathroomLabel, "*") : "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.noOfBathroomLabel);
    };
    const isValidNumber = constants.PHONE_REGEX_MICROSITE.test(data === null || data === void 0 ? void 0 : data.mobileNumber) && (data === null || data === void 0 ? void 0 : data.firstName) && (data === null || data === void 0 ? void 0 : data.lastName);
    const onBlur = (field)=>{
        setError({
            ...error,
            [field]: validateFormValues(field)
        });
    };
    const validateFormValues = (field)=>{
        if (field === "firstName" || field === "lastName") {
            var ref;
            if (!((ref = data[field]) === null || ref === void 0 ? void 0 : ref.trim()) || !(0,helper.validateField)("name", data[field])) {
                switch(field){
                    case "firstName":
                        return staticText === null || staticText === void 0 ? void 0 : staticText.firstNameError;
                    case "lastName":
                        return staticText === null || staticText === void 0 ? void 0 : staticText.lastNameError;
                    default:
                        return "";
                }
            }
        } else if (field === "email") {
            if (!(0,validate/* validateOptionalEmail */.Uc)(data[field])) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.emailAddressError;
            } else {
                return "";
            }
        } else if (field === "pinCode") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.noPinCodeError;
            } else if (!(0,validate/* validPincode */.cE)(data[field])) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.inValidPinCodeError;
            } else if (authorData.siteRegistrationFormFlag || authorData.warrantyRegistrationFormFlag) {
                return error.pinCode;
            }
        } else if (field === "noOfBathroom") {
            if (authorData.omniChannelKECFormFlag || authorData.amcFormFlag) {
                if (!(0,validate/* validateNoOfBathroom_mandatroy */.v6)(data[field])) {
                    return staticText === null || staticText === void 0 ? void 0 : staticText.bathroomNoEmpty;
                }
            } else {
                if (!(0,validate/* validateNoOfBathroom_optional */.Nt)(data[field])) {
                    return staticText === null || staticText === void 0 ? void 0 : staticText.bathroomNoEmpty;
                }
            }
        } else if (field === "mobileNumber") {
            var ref1;
            if (!((ref1 = data[field]) === null || ref1 === void 0 ? void 0 : ref1.trim())) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumberError;
            } else if (!constants.PHONE_REGEX_MICROSITE.test(data[field])) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.validMobileNoError;
            }
        } else if (field === "productCategory") {
            if (!data[field]) {
                return !authorData.serviceRequestFormFlag ? staticText === null || staticText === void 0 ? void 0 : staticText.productCategoryError : staticText.productDetailsError;
            }
        } else if (field === "purchasePick") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.purchasePickError;
            }
        } else if (field === "kecCity") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.kecCityError;
            }
        } else if (field === "productImages") {
            if (data[field] && !data[field].length) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.provideImageError;
            }
        } else if (field === "state") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.stateError;
            }
        } else if (field === "city") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.cityError;
            }
        } else if (field === "siteAddress") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.siteAddressError;
            }
        } else if (field === "constructionType") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.constructionTypeError;
            }
        } else if (field === "fileType") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.fileTypeError;
            }
        } else if (field === "reportIssue") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.reportIssueError;
            }
        } else if (field === "alternateMobileNumber") {
            if (data[field] && !constants.PHONE_REGEX_MICROSITE.test(data[field])) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.validMobileNoError;
            }
        } else if (field === "slot") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.slotError;
            }
        }
    };
    const getErrorList = ()=>{
        let errorList;
        errorList = {
            firstName: validateFormValues("firstName"),
            lastName: validateFormValues("lastName"),
            pinCode: validateFormValues("pinCode"),
            mobileNumber: validateFormValues("mobileNumber")
        };
        if (authorData.omniChannelKECFormFlag) {
            errorList = {
                ...errorList,
                kecCity: validateFormValues("kecCity"),
                purchasePick: validateFormValues("purchasePick"),
                noOfBathroom: validateFormValues("noOfBathroom"),
                slot: validateFormValues("slot")
            };
        } else if (authorData.warrantyRegistrationFormFlag) {
            errorList = {
                ...errorList,
                state: validateFormValues("state"),
                city: validateFormValues("city"),
                siteAddress: validateFormValues("siteAddress")
            };
        } else if (authorData.siteRegistrationFormFlag) {
            errorList = {
                ...errorList,
                productCategory: validateFormValues("productCategory"),
                constructionType: validateFormValues("constructionType"),
                state: validateFormValues("state"),
                city: validateFormValues("city"),
                siteAddress: validateFormValues("siteAddress")
            };
        } else if (authorData.serviceRequestFormFlag) {
            errorList = {
                ...errorList,
                state: validateFormValues("state"),
                city: validateFormValues("city"),
                siteAddress: validateFormValues("siteAddress"),
                productCategory: validateFormValues("productCategory"),
                reportIssue: validateFormValues("reportIssue")
            };
        } else if (authorData.amcFormFlag) {
            errorList = {
                ...errorList,
                siteAddress: validateFormValues("siteAddress"),
                noOfBathroom: validateFormValues("noOfBathroom")
            };
        }
        return errorList;
    };
    const isSubmitBtnEnabled = ((ref = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref === void 0 ? void 0 : ref.find((el)=>el)) || !recaptchaVerified ? true : false;
    const isAllFieldsFilled = ((ref1 = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref1 === void 0 ? void 0 : ref1.find((el)=>el)) ? false : true;
    (0,react.useEffect)(()=>{
        if (isAllFieldsFilled) {
            pushFormFilledAnalytics();
        }
    }, [
        isAllFieldsFilled
    ]);
    const handleError = (tries)=>{
        if (tries < numberOfTriesAllowed) {
            setNumberOfReTries(tries);
        } else {
            e.preventDefault();
            window.location.href = window.location.origin + recaptchaError;
        }
    };
    const pushFormSubmitAnalytics = (resultType)=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
        const eventInfo = getEventInfoFormSubmit(authorData, resultType);
        const formInfo = getFormInfoForSubmittion(data, authorData, paramsByUrl);
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            ...formInfo
        });
    };
    const pushFormFilledAnalytics = ()=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
        const eventInfo = getEventInfoFormFilled();
        const formInfo = getFormInfoForSubmittion(data, authorData, paramsByUrl);
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            ...formInfo
        });
    };
    const recaptchaAnalytics = (isSuccess)=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
        const eventInfo = getEventInfoRecaptcha(isSuccess);
        const formInfo = getFormInfoForSubmittion(data, authorData, paramsByUrl);
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            ...formInfo
        });
    };
    const getPayload = (data)=>{
        let payloadJson;
        const { firstName , lastName , mobileNumber , email , pinCode , city , state , siteAddress , constructionType , kecCity , noOfBathroom , budget , purchasePick , productCategory , whatsAppConsent , smsAppConsent , productImages , fileType , dateOfInvoice , reportIssue , alternateMobileNumber , landmark , slot , appointmentDate  } = data;
        if (authorData.selfRegistrationFormFlag || authorData.bathroomInspirationFormFlag) {
            payloadJson = {
                leadInfo: {
                    firstName: firstName,
                    lastName: lastName,
                    phone: mobileNumber,
                    ...email !== "" && {
                        email
                    },
                    pincode: pinCode,
                    scanEventType: authorData.selfRegistrationFormFlag ? "Self Lead" : "Bathroom Inspiration",
                    whatsappOptIn: whatsAppConsent,
                    otherOptIn: smsAppConsent,
                    ...noOfBathroom !== "" && {
                        numberOfBathrooms: noOfBathroom
                    },
                    ...budget !== "" && {
                        budget: budget
                    },
                    leadSubSourceSegment: paramsByUrl["leadSubSourceSegment"],
                    qrId: paramsByUrl["qrId"],
                    campaignId: paramsByUrl["campaignId"] !== "" ? paramsByUrl["campaignId"] : null,
                    kecId: paramsByUrl["kecId"] !== "" ? paramsByUrl["kecId"] : null,
                    eventId: paramsByUrl["eventId"] !== "" ? paramsByUrl["eventId"] : null,
                    dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
                    technicianId: paramsByUrl["technicianId"] !== "" ? paramsByUrl["technicianId"] : null
                }
            };
        } else if (authorData.omniChannelKECFormFlag) {
            payloadJson = {
                leadInfo: {
                    firstName: firstName,
                    lastName: lastName,
                    phone: mobileNumber,
                    email: email,
                    pincode: pinCode,
                    scanEventType: "KEC Appointment",
                    whatsappOptIn: whatsAppConsent,
                    otherOptIn: smsAppConsent,
                    numberOfBathrooms: noOfBathroom,
                    budget: budget,
                    KECCity: kecCityMapping === null || kecCityMapping === void 0 ? void 0 : kecCityMapping.find((item)=>item[kecCity])[kecCity],
                    projectTimeline: purchasePick,
                    leadSubSourceSegment: paramsByUrl["leadSubSourceSegment"],
                    qrId: paramsByUrl["qrId"],
                    campaignId: paramsByUrl["campaignId"] !== "" ? paramsByUrl["campaignId"] : null,
                    kecId: paramsByUrl["kecId"] !== "" ? paramsByUrl["kecId"] : null,
                    eventId: paramsByUrl["eventId"] !== "" ? paramsByUrl["eventId"] : null,
                    dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
                    technicianId: paramsByUrl["technicianId"] !== "" ? paramsByUrl["technicianId"] : null
                },
                ...slot !== "" && appointmentDate !== "" && {
                    appointmentInfo: {
                        slot: slot,
                        appointmentDate: appointmentDate
                    }
                }
            };
        } else if (authorData.warrantyRegistrationFormFlag) {
            payloadJson = {
                warrantyInfo: {
                    firstName: firstName,
                    lastName: lastName,
                    phone: mobileNumber,
                    pincode: pinCode,
                    scanEventType: "Warranty Registration",
                    whatsappOptIn: whatsAppConsent,
                    otherOptIn: smsAppConsent,
                    siteAddress: siteAddress,
                    state: state,
                    city: city,
                    uploadFileType: fileType,
                    ...productImages && {
                        invoiceUrl: productImages[0]
                    },
                    qrId: paramsByUrl["qrId"],
                    campaignId: paramsByUrl["campaignId"] !== "" ? paramsByUrl["campaignId"] : null,
                    kecId: paramsByUrl["kecId"] !== "" ? paramsByUrl["kecId"] : null,
                    eventId: paramsByUrl["eventId"] !== "" ? paramsByUrl["eventId"] : null,
                    dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
                    technicianId: paramsByUrl["technicianId"] !== "" ? paramsByUrl["technicianId"] : null,
                    source: "QR-".concat(paramsByUrl["leadSubSourceSegment"])
                }
            };
        } else if (authorData.siteRegistrationFormFlag) {
            payloadJson = {
                leadInfo: {
                    firstName: firstName,
                    lastName: lastName,
                    phone: mobileNumber,
                    pincode: pinCode,
                    scanEventType: "Site Visit",
                    whatsappOptIn: whatsAppConsent,
                    otherOptIn: smsAppConsent,
                    siteAddress: siteAddress,
                    state: state,
                    KECCity: city,
                    segment: constructionType,
                    ...email !== "" && {
                        email
                    },
                    ...noOfBathroom !== "" && {
                        numberOfBathrooms: noOfBathroom
                    },
                    ...budget !== "" && {
                        budget: budget
                    },
                    leadSubSourceSegment: paramsByUrl["leadSubSourceSegment"],
                    qrId: paramsByUrl["qrId"],
                    campaignId: paramsByUrl["campaignId"] !== "" ? paramsByUrl["campaignId"] : null,
                    kecId: paramsByUrl["kecId"] !== "" ? paramsByUrl["kecId"] : null,
                    eventId: paramsByUrl["eventId"] !== "" ? paramsByUrl["eventId"] : null,
                    dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
                    technicianId: paramsByUrl["technicianId"] !== "" ? paramsByUrl["technicianId"] : null
                },
                accountInfo: {
                    defaultAddress: true
                },
                caseInfo: {
                    productBroadCategory: productCategory
                }
            };
        } else if (authorData.amcFormFlag) {
            if (isKohlerCare) {
                payloadJson = {
                    accountInfo: {
                        firstName: firstName,
                        lastName: lastName,
                        phone: mobileNumber,
                        pincode: pinCode,
                        siteAddress: siteAddress,
                        whatsappOptIn: whatsAppConsent,
                        otherOptIn: smsAppConsent
                    },
                    mainPlanInfo: {
                        numberOfBathrooms: noOfBathroom,
                        ...productImages && {
                            invoiceUrl: productImages[0]
                        },
                        ...constructionType !== "" && {
                            type: constructionType
                        }
                    }
                };
            } else {
                payloadJson = {
                    accountInfo: {
                        firstName: firstName,
                        lastName: lastName,
                        phone: mobileNumber,
                        pincode: pinCode,
                        address: siteAddress,
                        whatsappOptIn: whatsAppConsent,
                        otherOptIn: smsAppConsent
                    },
                    mainplanInfo: {
                        numberOfBathrooms: noOfBathroom,
                        ...constructionType !== "" && {
                            type: constructionType
                        },
                        qrId: "".concat(paramsByUrl["qrId"]),
                        source: "".concat(paramsByUrl["leadSubSourceSegment"]),
                        campaignId: paramsByUrl["campaignId"] !== "" ? paramsByUrl["campaignId"] : null,
                        ...productImages && {
                            invoiceUrl: productImages[0]
                        }
                    },
                    caseInfo: {
                        scanEventType: "AMC",
                        kecId: paramsByUrl["kecId"] !== "" ? paramsByUrl["kecId"] : null,
                        eventId: paramsByUrl["eventId"] !== "" ? paramsByUrl["eventId"] : null,
                        dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
                        technicianId: paramsByUrl["technicianId"] !== "" ? paramsByUrl["technicianId"] : null,
                        productBroadCategory: "Not Defined"
                    }
                };
            }
        } else if (authorData.serviceRequestFormFlag) {
            payloadJson = {
                accountInfo: {
                    firstName: firstName,
                    lastName: lastName,
                    phone: mobileNumber,
                    ...alternateMobileNumber !== "" && {
                        alternatePhone: alternateMobileNumber
                    },
                    ...email !== "" && {
                        email
                    },
                    siteAddress: siteAddress,
                    pincode: pinCode,
                    city: city,
                    state: state,
                    whatsappOptIn: whatsAppConsent,
                    otherOptIn: smsAppConsent,
                    landmark: landmark,
                    defaultAddress: true
                },
                caseInfo: {
                    scanEventType: "Service Request",
                    dateOfInvoice: dateOfInvoice,
                    qrId: "".concat(paramsByUrl["qrId"]),
                    campaignId: paramsByUrl["campaignId"] !== "" ? paramsByUrl["campaignId"] : null,
                    kecId: paramsByUrl["kecId"] !== "" ? paramsByUrl["kecId"] : null,
                    eventId: paramsByUrl["eventId"] !== "" ? paramsByUrl["eventId"] : null,
                    dealerId: paramsByUrl["leadSubSourceSegment"] === "Dealer" ? paramsByUrl["dealerId"] : paramsByUrl["kaspId"],
                    technicianId: paramsByUrl["technicianId"] !== "" ? paramsByUrl["technicianId"] : null,
                    reportIssue: reportIssue,
                    productBroadCategory: productCategory,
                    source: "".concat(paramsByUrl["leadSubSourceSegment"])
                }
            };
        }
        return payloadJson;
    };
    const getCleverTapPayload = (data)=>{
        const { firstName , lastName , mobileNumber , whatsAppConsent , smsAppConsent , email  } = data;
        return {
            firstName: firstName,
            lastName: lastName,
            phoneNumber: "+91".concat(mobileNumber),
            whatsAppOptIn: whatsAppConsent,
            ...email !== "" && {
                emailId: email
            },
            emailOptIn: smsAppConsent,
            smsOptIn: smsAppConsent
        };
    };
    const handleSubmit = async ()=>{
        var ref;
        const errorList = getErrorList();
        let resultType = "failed";
        setIsLoading(true);
        let errorDataList = [];
        setError(errorList);
        errorDataList.map((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            const payload = getPayload(data);
            const cleverTapPayload = getCleverTapPayload(data);
            const response = await (0,enquiry/* leadCreation */.DB)({
                payload,
                authorData
            });
            await (0,enquiry/* cleverTapSubscribe */.kM)({
                payload: cleverTapPayload
            });
            if (response.status === "success" || response.status === "Success") {
                const { qrId  } = paramsByUrl;
                addSessionUserDetails(qrId, data);
                setModalDisplayFlag(true);
                setClearImage(true);
                resultType = "success";
            } else {
                setShowErrorModal(true);
                setClearImage(true);
                resultType = "failed";
                if (response.response.data.errorCode === "ER026" && authorData.omniChannelKECFormFlag) {
                    const message = response.response.data.message;
                    const match = message.match(/\d{4}-\d{2}-\d{2}/);
                    let extractedDate = match[0];
                    setErrorMessage("An active appointment already exists for you on ".concat(extractedDate, "."));
                    setKecSlotBooked(true);
                    slotAlreadyBookedAnalytics(data);
                } else if ((response.response.data.errorCode === "ER027" || response.response.data.errorCode === "ER028") && authorData.omniChannelKECFormFlag) {
                    setKecSlotBooked(true);
                    slotAlreadyBookedAnalytics(data);
                    setErrorMessage("Sorry! this slot just got book by another user. Please select alternate slot.");
                }
            }
            setClearImage(true);
            setIsLoading(false);
        }
        pushFormSubmitAnalytics(resultType);
    };
    const handleModalClose = ()=>{
        const element = document.getElementById("omni-channel-form");
        if (element) {
            if (element.offsetTop > 250) setTimeout(function() {
                window.scrollTo({
                    top: element.offsetTop - 250,
                    behavior: "smooth"
                });
            }, 50);
            else setTimeout(function() {
                window.scrollTo({
                    top: element.offsetTop + 2100,
                    behavior: "smooth"
                });
            }, 50);
        }
    };
    const onChangeDateTime = (slot, date)=>{
        setData({
            ...data,
            slot: slot,
            appointmentDate: date
        });
    };
    const formatDate = (input)=>{
        const date = new Date(input);
        const options = {
            day: "numeric",
            month: "short",
            year: "numeric"
        };
        const formatted = date.toLocaleDateString("en-GB", options);
        return formatted;
    };
    const onChangeHandler = (value)=>{
        setToken(value);
        const isSuccess = verifyRecaptchaToken(value);
        setRecaptchaVerified(isSuccess);
        if (!isSuccess) {
            handleError(numberOfReTries + 1);
        }
        recaptchaAnalytics(isSuccess);
    };
    var ref4, ref5, ref6, ref7, ref8, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: uploadImageLoading,
                loadingMessage: uploadImageLoading ? "Upload In Progress..." : "Loading..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OmniChannel_index_module_default()).OmniChannelFormWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "omni-channel-form",
                        id: "omni-channel-form",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "omni-channel-form_firstname",
                                type: "text",
                                placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.firstNameLabel),
                                label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.firstNameLabel, "*"),
                                value: (ref4 = data === null || data === void 0 ? void 0 : data.firstName) !== null && ref4 !== void 0 ? ref4 : "",
                                onChange: handleTextFieldChange,
                                onInput: handleTextFieldChange,
                                showError: error === null || error === void 0 ? void 0 : error.firstName,
                                errorMessage: error === null || error === void 0 ? void 0 : error.firstName,
                                onBlur: ()=>onBlur("firstName"),
                                autoComplete: false,
                                maxLength: 40,
                                name: "firstName"
                            }),
                            authorData.warrantyRegistrationFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "omni-channel-form__nameText",
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.firstNameDescription
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "omni-channel-form_lastname",
                                type: "text",
                                placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.lastNameLabel, "*"),
                                label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.lastNameLabel, "*"),
                                value: (ref5 = data === null || data === void 0 ? void 0 : data.lastName) !== null && ref5 !== void 0 ? ref5 : "",
                                onChange: handleTextFieldChange,
                                onInput: handleTextFieldChange,
                                showError: error === null || error === void 0 ? void 0 : error.lastName,
                                errorMessage: error === null || error === void 0 ? void 0 : error.lastName,
                                onBlur: ()=>onBlur("lastName"),
                                autoComplete: false,
                                maxLength: 40,
                                name: "lastName"
                            }),
                            authorData.warrantyRegistrationFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "omni-channel-form__nameText",
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.lastNameDescription
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "omni-channel-form__phoneDiv flex-mobile",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__countryIcon country-code",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            customClass: "",
                                            id: "contact-user-country-code",
                                            type: "text",
                                            disabled: true,
                                            value: "+91"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__mobileNumber mobile-number",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            customClass: "customer-support-inputfield",
                                            id: "contact-user-mobile-number",
                                            type: "text",
                                            value: data === null || data === void 0 ? void 0 : data.mobileNumber,
                                            maxLength: 10,
                                            placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumberLabel, "*"),
                                            label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumberLabel, "*"),
                                            onChange: handleNumberFieldChange,
                                            showError: error === null || error === void 0 ? void 0 : error.mobileNumber,
                                            errorMessage: error === null || error === void 0 ? void 0 : error.mobileNumber,
                                            onBlur: ()=>onBlur("mobileNumber"),
                                            name: "mobileNumber"
                                        })
                                    })
                                ]
                            }),
                            isQrService && authorData.serviceRequestFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                customClass: "customer-support-inputfield",
                                id: "contact-user-mobile-number",
                                type: "text",
                                value: data === null || data === void 0 ? void 0 : data.alternateMobileNumber,
                                maxLength: 10,
                                placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.alternateMobileNumberLabel),
                                label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.alternateMobileNumberLabel),
                                onChange: handleNumberFieldChange,
                                showError: error === null || error === void 0 ? void 0 : error.alternateMobileNumber,
                                errorMessage: error === null || error === void 0 ? void 0 : error.alternateMobileNumber,
                                onBlur: ()=>onBlur("alternateMobileNumber"),
                                name: "alternateMobileNumber"
                            }),
                            isQrService && authorData.serviceRequestFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                customClass: "customer-support-inputfield",
                                id: "contact-user-mobile-number",
                                type: "text",
                                value: data === null || data === void 0 ? void 0 : data.siteAddress,
                                maxLength: 255,
                                placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.addressLabel, "*"),
                                label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.addressLabel, "*"),
                                onChange: handleAlphaNumericFieldChange,
                                onInput: handleAlphaNumericFieldChange,
                                showError: error === null || error === void 0 ? void 0 : error.siteAddress,
                                errorMessage: error === null || error === void 0 ? void 0 : error.siteAddress,
                                onBlur: ()=>onBlur("siteAddress"),
                                name: "siteAddress"
                            }),
                            isQrService && authorData.serviceRequestFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                customClass: "customer-support-inputfield",
                                id: "contact-user-mobile-number",
                                type: "text",
                                value: data === null || data === void 0 ? void 0 : data.landmark,
                                maxLength: 80,
                                placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.landmarkLabel),
                                label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.landmarkLabel),
                                onChange: handleAlphaNumericFieldChange,
                                onInput: handleAlphaNumericFieldChange,
                                onBlur: ()=>onBlur("landmark"),
                                name: "landmark"
                            }),
                            !authorData.warrantyRegistrationFormFlag && !authorData.amcFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "contact-user-email",
                                type: "text",
                                placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.emailLabel),
                                label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.emailLabel),
                                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/icons/email.svg",
                                    alt: "",
                                    "aria-hidden": "true"
                                }),
                                value: (ref6 = data === null || data === void 0 ? void 0 : data.email) !== null && ref6 !== void 0 ? ref6 : "",
                                maxLength: 60,
                                autoComplete: true,
                                onChange: onChangeEmail,
                                onInput: onChangeEmail,
                                showError: (error === null || error === void 0 ? void 0 : error.email) !== "" && (error === null || error === void 0 ? void 0 : error.email),
                                errorMessage: error === null || error === void 0 ? void 0 : error.email,
                                onBlur: ()=>onBlur("email"),
                                name: "email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "omni-channel-form_pinCode",
                                type: "text",
                                placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.pinCodeLabel, "*"),
                                label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.pinCodeLabel, "*"),
                                value: (ref7 = data === null || data === void 0 ? void 0 : data.pinCode) !== null && ref7 !== void 0 ? ref7 : "",
                                onChange: handleNumberFieldChange,
                                onInput: handleNumberFieldChange,
                                showError: error === null || error === void 0 ? void 0 : error.pinCode,
                                errorMessage: error === null || error === void 0 ? void 0 : error.pinCode,
                                onBlur: ()=>onBlur("pinCode"),
                                autoComplete: false,
                                maxLength: 6,
                                name: "pinCode"
                            }),
                            (authorData.siteRegistrationFormFlag || authorData.warrantyRegistrationFormFlag || isQrService && authorData.serviceRequestFormFlag) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "omni-channel-form__gap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__state-city",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            id: "omni-channel-form_city",
                                            type: "text",
                                            placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.cityLabel, "*"),
                                            label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.cityLabel, "*"),
                                            value: (ref8 = data === null || data === void 0 ? void 0 : data.city) !== null && ref8 !== void 0 ? ref8 : "",
                                            onChange: handleTextFieldChange,
                                            onInput: handleTextFieldChange,
                                            autoComplete: false,
                                            maxLength: 30,
                                            name: "city",
                                            disabled: stateCityDisabled
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__state-city",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            id: "omni-channel-state",
                                            type: "text",
                                            placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.cityLabel, "*"),
                                            label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.stateLabel, "*"),
                                            value: data === null || data === void 0 ? void 0 : data.state,
                                            onChange: handleTextFieldChange,
                                            onInput: handleTextFieldChange,
                                            autoComplete: false,
                                            maxLength: 30,
                                            name: "state",
                                            disabled: stateCityDisabled
                                        })
                                    })
                                ]
                            }),
                            (authorData.siteRegistrationFormFlag || authorData.warrantyRegistrationFormFlag || authorData.amcFormFlag) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    id: "omni-channel-form_SiteAddress",
                                    type: "text",
                                    placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.siteAddressLabel, "*"),
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.siteAddressLabel, "*"),
                                    value: (ref9 = data === null || data === void 0 ? void 0 : data.siteAddress) !== null && ref9 !== void 0 ? ref9 : "",
                                    onChange: handleAlphaNumericFieldChange,
                                    onInput: handleAlphaNumericFieldChange,
                                    autoComplete: false,
                                    maxLength: 255,
                                    name: "siteAddress",
                                    onBlur: ()=>onBlur("siteAddress"),
                                    showError: (error === null || error === void 0 ? void 0 : error.siteAddress) !== "" && (error === null || error === void 0 ? void 0 : error.siteAddress),
                                    errorMessage: error === null || error === void 0 ? void 0 : error.siteAddress
                                })
                            }),
                            authorData.siteRegistrationFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    data: typeItems === null || typeItems === void 0 ? void 0 : typeItems.map((item)=>item.type),
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.constructionTypeLabel, "*"),
                                    onChange: (val)=>handleDropDownChange(val, "constructionType"),
                                    value: data === null || data === void 0 ? void 0 : data.constructionType,
                                    id: "omni-channel-construction-type",
                                    name: "constructionType"
                                })
                            }),
                            authorData.omniChannelKECFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    data: citiesAvailableItems.map((item)=>item.citiesAvailable),
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.kecCityLabel, "*"),
                                    onChange: (val)=>handleDropDownChange(val, "kecCity"),
                                    value: data === null || data === void 0 ? void 0 : data.kecCity,
                                    id: "omni-channel-kec",
                                    name: "kecCity",
                                    errorMessage: staticText === null || staticText === void 0 ? void 0 : staticText.kecCityError,
                                    showError: !error.kecCity || error.kecCity === "" ? false : true,
                                    onBlur: ()=>onBlur("kecCity")
                                })
                            }),
                            !authorData.warrantyRegistrationFormFlag && !(isQrService && authorData.serviceRequestFormFlag) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "omni-channel-form_noOfBathroom",
                                type: "text",
                                placeholder: getNoOfBathroomLabel(),
                                label: getNoOfBathroomLabel(),
                                value: data === null || data === void 0 ? void 0 : data.noOfBathroom,
                                onChange: handleNumberFieldChange,
                                onInput: handleNumberFieldChange,
                                autoComplete: false,
                                maxLength: 2,
                                name: "noOfBathroom",
                                onBlur: ()=>onBlur("noOfBathroom"),
                                errorMessage: error === null || error === void 0 ? void 0 : error.noOfBathroom,
                                showError: !error.noOfBathroom || error.noOfBathroom === "" ? false : true
                            }),
                            !authorData.warrantyRegistrationFormFlag && !(isQrService && authorData.serviceRequestFormFlag) && !(isQrService && authorData.amcFormFlag) && !isKohlerCare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    data: budgetItems === null || budgetItems === void 0 ? void 0 : budgetItems.map((item)=>item.budget),
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.budgetLabel),
                                    onChange: (val)=>handleDropDownChange(val, "budget"),
                                    onBlur: ()=>onBlur("budget"),
                                    value: data === null || data === void 0 ? void 0 : data.budget,
                                    id: "omni-channel-budget",
                                    name: "budget",
                                    errorMessage: error === null || error === void 0 ? void 0 : error.budget,
                                    showError: !error.budget || error.budget === "" ? false : true
                                })
                            }),
                            authorData.amcFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    data: typeItems === null || typeItems === void 0 ? void 0 : typeItems.map((item)=>item.type),
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.constructionTypeLabel),
                                    onChange: (val)=>handleDropDownChange(val, "constructionType"),
                                    value: data === null || data === void 0 ? void 0 : data.constructionType,
                                    id: "omni-channel-type",
                                    name: "constructionType"
                                })
                            }),
                            authorData.omniChannelKECFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.purchasePickListLabel, "*"),
                                    data: purchaseTimeItems === null || purchaseTimeItems === void 0 ? void 0 : purchaseTimeItems.map((item)=>item.timeSlot),
                                    onChange: (val)=>handleDropDownChange(val, "purchasePick"),
                                    value: data === null || data === void 0 ? void 0 : data.purchasePick,
                                    errorMessage: staticText === null || staticText === void 0 ? void 0 : staticText.purchasePickError,
                                    showError: !error.purchasePick || error.purchasePick === "" ? false : true,
                                    onBlur: ()=>onBlur("purchasePick"),
                                    id: "omni-channel-purchasepick",
                                    name: "purchasepick"
                                })
                            }),
                            authorData.siteRegistrationFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    data: productCategoryItems.map((item)=>item.productCategoryValues),
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.productCategoryLable, "*"),
                                    onChange: (val)=>handleDropDownChange(val, "productCategory"),
                                    onBlur: ()=>onBlur("productCategory"),
                                    value: data === null || data === void 0 ? void 0 : data.productCategory,
                                    id: "omni-channel-productCategory",
                                    name: "productCategory",
                                    errorMessage: error === null || error === void 0 ? void 0 : error.productCategory,
                                    showError: !error.productCategory || error.productCategory === "" ? false : true
                                })
                            }),
                            (authorData.warrantyRegistrationFormFlag || authorData.amcFormFlag) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    !authorData.amcFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__upload-text",
                                        children: "Upload document [Material Requisition/ Quote/ Invoice]"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__upload-text",
                                        children: "Upload Invoice"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__upload-description",
                                        children: "Supported Files Are: .jpg, .jpeg, .png, .pdf, .gif"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__upload-description",
                                        children: "Maximum File Size per image: 5MB"
                                    }),
                                    !authorData.amcFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__mt-40",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                            data: typeItems.map((item)=>item.type),
                                            label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.fileTypeLabel),
                                            onChange: (val)=>handleDropDownChange(val, "fileType"),
                                            onBlur: ()=>onBlur("fileType"),
                                            value: data === null || data === void 0 ? void 0 : data.fileType,
                                            id: "omni-channel-fileType",
                                            name: "fileType"
                                        })
                                    })
                                ]
                            }),
                            (authorData.warrantyRegistrationFormFlag || authorData.amcFormFlag) && Object.keys(data).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "omni-channel-form__image-upload-section omni-channel-form__mt-40",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUpload/* default */.Z, {
                                    uploadButtonAnalytics: '{"eventAction":"my account:register non kohler products:product information:upload photos","eventName":"my account:register non kohler products:product information:upload photos","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"upload photos","internalLinkPosition":"register products","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:register non kohler products:product information","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    data: data,
                                    staticText: staticText,
                                    handleData: setData,
                                    isOmnichannel: true,
                                    clearImage: clearImage,
                                    authorData: authorData,
                                    setUploadImageLoading: setUploadImageLoading,
                                    setClearImage: setClearImage
                                })
                            }) : null,
                            authorData.omniChannelKECFormFlag && data.slot === "" && data.appointmentDate === "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__visit-title ".concat(!Object.keys(monthlyAvailabilityData).length ? "omni-channel-form__disabled" : ""),
                                        children: "Schedule Your Visit*"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__visit-description ".concat(!Object.keys(monthlyAvailabilityData).length ? "omni-channel-form__disabled" : ""),
                                        children: "Choose a date & time. Visit can be scheduled for next 30 days."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__image-upload-section omni-channel-form__mt-40",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniChannel_DateTimePicker, {
                                            disabled: !Object.keys(monthlyAvailabilityData).length,
                                            onChangeDateTime: (slot, date)=>onChangeDateTime(slot, date),
                                            isEdit: isEdit,
                                            kecData: data,
                                            setIsEdit: setIsEdit,
                                            monthlyAvailability: monthlyAvailabilityData,
                                            error: error,
                                            setError: setError
                                        })
                                    })
                                ]
                            }) : null,
                            authorData.omniChannelKECFormFlag && data.slot !== "" && data.appointmentDate !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "omni-channel-form__visit-title",
                                        children: [
                                            " ",
                                            "Your Selected Slot"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "omni-channel-form__selected-slot-details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "omni-channel-form__selected-slot",
                                                children: "".concat(formatDate(data.appointmentDate), " • ").concat(data === null || data === void 0 ? void 0 : data.slot)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                role: "link",
                                                className: "omni-channel-form__change-slot",
                                                onClick: ()=>{
                                                    setIsEdit(true);
                                                    changeSlotAnalytics(data);
                                                },
                                                children: "Change Slot"
                                            })
                                        ]
                                    }),
                                    isEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__image-upload-section omni-channel-form__mt-40",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniChannel_DateTimePicker, {
                                            disabled: !Object.keys(monthlyAvailabilityData).length,
                                            onChangeDateTime: (slot, date)=>onChangeDateTime(slot, date),
                                            isEdit: isEdit,
                                            kecData: data,
                                            setIsEdit: setIsEdit,
                                            monthlyAvailability: monthlyAvailabilityData
                                        })
                                    })
                                ]
                            }) : null,
                            isQrService && authorData.serviceRequestFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    data: productCategoryItems.map((item)=>item.productCategoryValues),
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.productDetailsLabel, "*"),
                                    onChange: (val)=>handleDropDownChange(val, "productCategory"),
                                    onBlur: ()=>onBlur("productCategory"),
                                    value: data === null || data === void 0 ? void 0 : data.productCategory,
                                    id: "omni-channel-productCategory",
                                    name: "productCategory",
                                    errorMessage: error === null || error === void 0 ? void 0 : error.productCategory,
                                    showError: !error.productCategory || error.productCategory === "" ? false : true
                                })
                            }),
                            isQrService && authorData.serviceRequestFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                customClass: "customer-support-inputfield",
                                id: "contact-user-mobile-number",
                                type: "text",
                                value: data === null || data === void 0 ? void 0 : data.reportIssue,
                                maxLength: 255,
                                placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.reportIssueLabel, "*"),
                                label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.reportIssueLabel, "*"),
                                onChange: handleAlphaNumericFieldChange,
                                onInput: handleAlphaNumericFieldChange,
                                showError: error === null || error === void 0 ? void 0 : error.reportIssue,
                                errorMessage: error === null || error === void 0 ? void 0 : error.reportIssue,
                                onBlur: ()=>onBlur("reportIssue"),
                                name: "reportIssue"
                            }),
                            isQrService && authorData.serviceRequestFormFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                                value: Date.parse(data === null || data === void 0 ? void 0 : data.dateOfInvoice),
                                selected: Date.parse(data === null || data === void 0 ? void 0 : data.dateOfInvoice),
                                dateFormat: "dd/MM/yyyy",
                                customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    customClass: "customer-support-inputfield",
                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: calendar/* default */.Z === null || calendar/* default */.Z === void 0 ? void 0 : calendar/* default.src */.Z.src,
                                        alt: "calendar-icon"
                                    }),
                                    placeholder: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.dateOfInvoiceLabel),
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.dateOfInvoiceLabel),
                                    showError: error === null || error === void 0 ? void 0 : error.dateOfInvoice,
                                    errorMessage: error === null || error === void 0 ? void 0 : error.dateOfInvoice
                                }),
                                id: "contact-installed-installDate",
                                onChange: (date)=>changeDateFormat(date),
                                minDate: new Date("01/01/2001"),
                                maxDate: new Date(),
                                isClearable: !!(data === null || data === void 0 ? void 0 : data.dateOfInvoice)
                            }),
                            isAllFieldsFilled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "omni-channel-form__recaptcha-div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_esm/* default */.Z, {
                                    sitekey: recaptchaSiteKey,
                                    onChange: (value)=>{
                                        onChangeHandler(value);
                                    },
                                    onErrored: ()=>handleError(numberOfReTries + 1),
                                    onExpired: ()=>setRecaptchaVerified(false)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "omni-channel-form__consent-checkbox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    type: "black",
                                    value: staticText === null || staticText === void 0 ? void 0 : staticText.whatAppConent,
                                    onChange: (e1)=>handleConsent(e1, "whatsAppConsent"),
                                    checked: data === null || data === void 0 ? void 0 : data.whatsAppConsent,
                                    textClassName: "omni-channel-form__consent-checkbox-label"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "omni-channel-form__consent-checkbox",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    ttype: "black",
                                    value: staticText === null || staticText === void 0 ? void 0 : staticText.smsEmailConsent,
                                    onChange: (e1)=>handleConsent(e1, "smsAppConsent"),
                                    checked: data === null || data === void 0 ? void 0 : data.smsAppConsent,
                                    textClassName: "omni-channel-form__consent-checkbox-label"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lead-generation__buttonDiv",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "black",
                                    role: "button",
                                    label: "".concat(staticText === null || staticText === void 0 ? void 0 : staticText.submitLabel),
                                    className: "lead-generation__button",
                                    flexible: true,
                                    onClick: handleSubmit,
                                    disabled: isSubmitBtnEnabled,
                                    loading: isLoading
                                })
                            })
                        ]
                    }),
                    modalDisplayFlag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        onModalClose: modalCloseHandler,
                        showModal: modalDisplayFlag,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "omni-channel-form__success-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "omni-channel-form__success-description",
                                        children: !isQrService && !isKohlerCare ? (ref2 = getSuccessMessageByPageType(authorData)) === null || ref2 === void 0 ? void 0 : ref2.map((msg, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: msg
                                            }, "1" + index);
                                        }) : (ref3 = getSuccessMessageByPageTypeService(authorData)) === null || ref3 === void 0 ? void 0 : ref3.map((msg, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: msg
                                            }, "1" + index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "button-holder",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "black",
                                            role: "button",
                                            label: "".concat(authorData.bathroomInspirationFormFlag ? "View Catalogue" : "Close"),
                                            className: "omni-channel-form__success-button",
                                            flexible: true,
                                            onClick: modalCloseHandler
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    showErrorModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        hideCloseIcon: true,
                        onModalClose: closeErrorModal,
                        showModal: showErrorModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "omni-channel-form__error-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "omni-channel-form__success-description",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "omni-channel-form__error-title",
                                                children: !kecSlotBooked ? "Something went wrong!" : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "omni-channel-form__error-title",
                                                children: !kecSlotBooked ? "Please try again after some time or call us at 1-800-103-2244." : errorMessage
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "button-holder",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "black",
                                            role: "button",
                                            label: "Close",
                                            className: "omni-channel-form__success-button",
                                            flexible: true,
                                            onClick: closeErrorModal
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var OmniChannel_RecaptchaForm = (RecaptchaForm);

;// CONCATENATED MODULE: ./components/LeadGeneration/LeadGenerationView/index.jsx













const LeadGenerationView = (props)=>{
    const { data: authorData = {} , stateWithCities , omniQRParams ={} , isQrService =false , isKohlerCare =false  } = props;
    const confirmationRef = (0,react.useRef)(null);
    const staticText = useLeadGenerationi18n(authorData);
    const [confirmationSuccess, setConfirmationSuccess] = (0,react.useState)(null);
    const [sticky, setSticky] = (0,react.useState)(true);
    const [showLeadForm, setShowLeadForm] = (0,react.useState)(false);
    const [width] = (0,useWindowResize/* default */.Z)(true);
    const divRef = (0,react.useRef)();
    const [isMobile, setIsMobile] = (0,react.useState)(!(width >= 992));
    const { isOpenLeadForm  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            setSticky(entry.boundingClientRect.top > 0 && !entry.isIntersecting);
        });
        if (divRef.current) observer.observe(divRef.current);
        return ()=>{
            if (divRef.current) {
                observer.unobserve(divRef.current);
            }
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (!confirmationSuccess) {
            const observer = new IntersectionObserver((param)=>{
                let [entry] = param;
                setSticky(entry.boundingClientRect.top > 0 && !entry.isIntersecting);
            });
            if (divRef.current) observer.observe(divRef.current);
        }
    }, [
        confirmationSuccess
    ]);
    (0,react.useEffect)(()=>{
        setShowLeadForm(isOpenLeadForm);
    }, [
        isOpenLeadForm
    ]);
    (0,react.useEffect)(()=>{
        setIsMobile(!(width > 992));
    }, [
        width
    ]);
    const navigateToBookAppointment = ()=>{
        divRef.current.scrollIntoView({
            block: isMobile ? "start" : "end",
            inline: "nearest",
            behaviour: "smooth"
        });
        navigateToLeadGenerationAnalytics();
    };
    const getHeadingTitle = ()=>{
        return authorData.kecFormFlag ? staticText.enquiryForm : authorData.omniChannelKECFormFlag || authorData.siteRegistrationFormFlag ? staticText.heading1 : authorData.warrantyRegistrationFormFlag ? staticText.heading2 : staticText.mainTitle;
    };
    const getHeadingTitleForService = ()=>{
        return authorData.warrantyRegistrationFormFlag ? "Enter information below to start warranty registration" : authorData.selfRegistrationFormFlag || authorData.amcFormFlag ? "Enter your information below to express your interest" : "Enter your information below to log a service request. ";
    };
    const handleModalClose = ()=>{
        dispatch((0,cartSlice/* hideLeadForm */.gY)());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            authorData.kecFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGeneration_StickyHeader, {
                sticky: sticky,
                setSticky: setSticky,
                navigateToBookAppointment: navigateToBookAppointment,
                staticText: staticText
            }) : null,
            (authorData.selfRegistrationFormFlag || authorData.bathroomInspirationFormFlag) && !isQrService && !isKohlerCare ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                showModal: showLeadForm,
                onModalClose: handleModalClose,
                i18n: staticText,
                isConfirm: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LeadGenerationView_index_module_default()).leadGenerationLanding,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lead-generation__no-margin",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lead-generation__title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lead-generation__heading-capital",
                                    children: "Fill in the details to register and stay updated"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lead-generation__required-fields",
                                children: staticText.requiredFields
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniChannel_RecaptchaForm, {
                                staticText: staticText,
                                setConfirmationSuccess: setConfirmationSuccess,
                                authorData: authorData,
                                stateWithCities: stateWithCities,
                                omniQRParams: omniQRParams,
                                isQrService: isQrService
                            })
                        ]
                    })
                })
            }) : null,
            !confirmationSuccess && isQrService && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LeadGenerationView_index_module_default()).leadGenerationLanding,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lead-generation",
                    ref: divRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lead-generation__title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lead-generation__heading",
                                    children: getHeadingTitleForService()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "lead-generation__required-fields",
                                    children: staticText.requiredFields
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniChannel_RecaptchaForm, {
                            staticText: staticText,
                            setConfirmationSuccess: setConfirmationSuccess,
                            authorData: authorData,
                            stateWithCities: stateWithCities,
                            omniQRParams: omniQRParams,
                            isQrService: isQrService
                        })
                    ]
                })
            }),
            !confirmationSuccess && isKohlerCare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LeadGenerationView_index_module_default()).leadGenerationLanding,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lead-generation",
                    ref: divRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lead-generation__title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lead-generation__heading",
                                    children: getHeadingTitleForService()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "lead-generation__required-fields",
                                    children: staticText.requiredFields
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniChannel_RecaptchaForm, {
                            staticText: staticText,
                            setConfirmationSuccess: setConfirmationSuccess,
                            authorData: authorData,
                            stateWithCities: stateWithCities,
                            omniQRParams: omniQRParams,
                            isQrService: isQrService
                        })
                    ]
                })
            }),
            !confirmationSuccess && !authorData.selfRegistrationFormFlag && !authorData.bathroomInspirationFormFlag && !isQrService && !isKohlerCare && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LeadGenerationView_index_module_default()).leadGenerationLanding,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lead-generation",
                    ref: divRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lead-generation__title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lead-generation__heading",
                                    children: getHeadingTitle()
                                }),
                                !authorData.kecFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "lead-generation__required-fields",
                                    children: (authorData === null || authorData === void 0 ? void 0 : authorData.omniChannelKECFormFlag) || (authorData === null || authorData === void 0 ? void 0 : authorData.warrantyRegistrationFormFlag) || (authorData === null || authorData === void 0 ? void 0 : authorData.bathroomInspirationFormFlag) || (authorData === null || authorData === void 0 ? void 0 : authorData.siteRegistrationFormFlag) || (authorData === null || authorData === void 0 ? void 0 : authorData.selfRegistrationFormFlag) ? staticText.requiredFields : staticText.requiredInfoText
                                }) : ""
                            ]
                        }),
                        (authorData === null || authorData === void 0 ? void 0 : authorData.omniChannelKECFormFlag) || authorData.warrantyRegistrationFormFlag || authorData.siteRegistrationFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniChannel_RecaptchaForm, {
                            staticText: staticText,
                            setConfirmationSuccess: setConfirmationSuccess,
                            authorData: authorData,
                            stateWithCities: stateWithCities,
                            omniQRParams: omniQRParams,
                            isQrService: isQrService
                        }) : !authorData.bathroomInspirationFormFlag && !authorData.selfRegistrationFormFlag && !(authorData === null || authorData === void 0 ? void 0 : authorData.omniChannelKECFormFlag) && !authorData.warrantyRegistrationFormFlag && !authorData.siteRegistrationFormFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Enquiry, {
                            staticText: staticText,
                            setConfirmationSuccess: setConfirmationSuccess,
                            authorData: authorData,
                            stateWithCities: stateWithCities
                        }) : null
                    ]
                })
            }),
            confirmationSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: confirmationRef,
                className: (LeadGenerationView_index_module_default()).leadGenerationLanding,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lead-generation",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGeneration_Confirmation, {
                        staticText: staticText,
                        setConfirmationSuccess: setConfirmationSuccess
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var LeadGeneration_LeadGenerationView = (LeadGenerationView);

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/modern/queryClient.js + 4 modules
var modern_queryClient = __webpack_require__(88021);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
;// CONCATENATED MODULE: ./components/Quiz/QuizContext.jsx

const QuizContext = /*#__PURE__*/ (0,react.createContext)(null);
const QuizProvider = QuizContext.Provider;
const useQuizContext = ()=>{
    const context = (0,react.useContext)(QuizContext);
    if (!context) {
        throw new Error("useQuizContext must be used within a QuizProvider");
    }
    return context;
};

;// CONCATENATED MODULE: ./components/Quiz/helper.js

const formatQuizData = (data)=>{
    for(const key in data){
        let curItem = data[key];
        if (Array.isArray(curItem)) {
            curItem.forEach((item)=>formatQuizData(item));
            return;
        }
        if (key !== "info") {
            data[key] = curItem === null || curItem === void 0 ? void 0 : curItem.replace(/<[^>]*>/g, "").replace(/[\r\n]/g, "");
        }
    }
};
const navQuestion = (dir, curQuestion, setQuestion, totalQuestions)=>{
    if (dir === 1 && curQuestion < totalQuestions || dir === -1 && curQuestion > 1) {
        setQuestion(curQuestion + dir);
    }
};
const generateImageUrl = (url, config, w, h)=>{
    if (url) {
        var ref, ref1;
        const baseUrl = "".concat(config === null || config === void 0 ? void 0 : config.scene7BaseUrl).concat(config === null || config === void 0 ? void 0 : config.dmScene7AccountName);
        const assetId = (ref1 = (ref = url.split("/")) === null || ref === void 0 ? void 0 : ref.pop()) === null || ref1 === void 0 ? void 0 : ref1.split(".")[0];
        return "".concat(baseUrl, "/").concat(assetId, "?wid=").concat(w, "&hei=").concat(h, "&fit=crop&fmt=webp");
    }
    return "#";
};
const selectAnswer = function(q, a, setData) {
    let reset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    setData((prevState)=>{
        const newState = structuredClone(prevState);
        const updatedData = {
            ...newState,
            questions: newState.questions.map((question, i)=>{
                if (i === q) {
                    var ref;
                    return {
                        ...question,
                        answers: (ref = question.answers) === null || ref === void 0 ? void 0 : ref.map((answer, j)=>{
                            if (reset) {
                                return {
                                    ...answer,
                                    isSelected: false
                                };
                            }
                            if (j === a) {
                                return {
                                    ...answer,
                                    isSelected: !(answer === null || answer === void 0 ? void 0 : answer.isSelected)
                                };
                            }
                            return answer;
                        })
                    };
                }
                return question;
            })
        };
        return updatedData;
    });
};
const getFilterQuery = function(questions) {
    let format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "string";
    const queries = {};
    questions.forEach((question)=>{
        var ref;
        (ref = question.answers) === null || ref === void 0 ? void 0 : ref.forEach((answer)=>{
            if (answer.isSelected) {
                let attrs = [];
                let values = [];
                if (answer.productAttribute.includes(";")) {
                    attrs = answer.productAttribute.split(";");
                    values = answer.productValue.split(";");
                } else {
                    attrs.push(answer.productAttribute);
                    values.push(answer.productValue);
                }
                attrs.forEach((attr, i)=>{
                    if (Array.isArray(queries[attr])) {
                        queries[attr].push(values[i]);
                        queries[attr] = Array.from(new Set(queries[attr]));
                    } else {
                        queries[attr] = [
                            values[i]
                        ];
                    }
                });
            }
        });
    });
    let qs = [];
    if (format === "string") {
        for(let q in queries){
            qs.push("".concat(q, ':("').concat(queries[q].join('","'), '")'));
        }
        if (!qs.length) {
            return "";
        }
        qs = qs.join(" AND ");
    }
    if (format === "array") {
        for(let q1 in queries){
            var ref;
            (ref = queries[q1]) === null || ref === void 0 ? void 0 : ref.forEach((item)=>qs.push({
                    key: q1,
                    value: item
                }));
        }
    }
    return qs;
};
const fetchProducts = async (query, category)=>{
    if (!query) {
        return {};
    }
    const { data  } = await api/* apim.get */.TH.get("/search/plp", {
        params: {
            rows: 0,
            start: 0,
            profilename: "profile_kohler-india_".concat(category),
            collections: "kohler-india",
            q: "*:*",
            fq: query
        }
    });
    return data;
};
const isAnswered = function() {
    let answers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return answers.some((answer)=>answer.isSelected);
};
const isFilterValid = function(qIndx, facets, setData) {
    let reset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    setData((prevState)=>{
        const newState = structuredClone(prevState);
        const updatedData = {
            ...newState,
            questions: newState.questions.map((question, i)=>{
                if (i === qIndx) {
                    var ref;
                    return {
                        ...question,
                        answers: (ref = question.answers) === null || ref === void 0 ? void 0 : ref.map((answer)=>({
                                ...answer,
                                notApplicable: reset ? false : !isFacetAvailable(answer.productAttribute, answer.productValue, facets)
                            }))
                    };
                }
                return question;
            })
        };
        return updatedData;
    });
};
const isFacetAvailable = (attrName, attrValue, facets)=>{
    if (attrName.includes(";")) {
        const attrNames = attrName.split(";");
        const attrValues = attrValue.split(";");
        let isAvailable = false;
        attrNames.forEach((item, i)=>{
            var ref;
            if ((ref = facets[item]) === null || ref === void 0 ? void 0 : ref.includes(attrValues[i])) {
                isAvailable = true;
            }
        });
        return isAvailable;
    } else {
        var ref;
        return (ref = facets[attrName]) === null || ref === void 0 ? void 0 : ref.includes(attrValue);
    }
};
const resetQuiz = (setData, setCurQuestion)=>{
    setData((prevState)=>{
        const newState = structuredClone(prevState);
        const updatedData = {
            ...newState,
            questions: newState.questions.map((question)=>{
                var ref;
                return {
                    ...question,
                    answers: (ref = question.answers) === null || ref === void 0 ? void 0 : ref.map((answer)=>({
                            ...answer,
                            notApplicable: false,
                            isSelected: false
                        }))
                };
            })
        };
        return updatedData;
    });
    setCurQuestion(1);
};
const sections = {
    LANDING: "landing",
    QUIZ: "quiz",
    RESULTS: "results"
};
const helper_plpConfig = {
    share: "false",
    promoLayout: "one-column",
    promoPlacementDesktop: "4",
    promoPlacementMobile: "4",
    defaultImageTag: "kohler-india:imageiso",
    hoverImageTag: "kohler-india:imgroomscene",
    enablePrint: "true",
    enableShare: "true",
    enablePrintPlp: "true",
    enableSharePlp: "true",
    enableShopNowPlp: false,
    bgColor: "bg-gainsboro",
    filterview: "showFilter",
    mpview: "1-col-mpview",
    presentOnDesktop: "false",
    presentOnMobile: "false",
    isServiceParts: "",
    presetConfigs: '{"Desktop":"PLPDesktop596","MobilePortrait1":"PLPMobile354","MobilePortrait2":"PLPMobile174","MobileLandscape1":"$PLPMobile1up$","MobileLandscape2":"PLPMobile426","PotraitCategory":"GBH_DataDrivenVerticalTemplate"}',
    swatchUrl: "https://kohler.scene7.com/is/image/PAWEB/"
};

;// CONCATENATED MODULE: ./components/Quiz/QuizIntro.jsx





const QuizIntro = ()=>{
    const { setSection =()=>{} , data ={} , setData , setCurQuestion , config ={} , quizAnalytics , eventIds  } = useQuizContext();
    (0,react.useEffect)(()=>{
        resetQuiz(setData, setCurQuestion);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "quiz-intro",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "banner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: generateImageUrl(data === null || data === void 0 ? void 0 : data.landingImage, config, 700, 700),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: data === null || data === void 0 ? void 0 : data.landingTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: data === null || data === void 0 ? void 0 : data.landingDescription
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "ghost",
                            role: "button",
                            label: data === null || data === void 0 ? void 0 : data.landingButtonTxt,
                            onClick: ()=>{
                                setSection(sections.QUIZ);
                                quizAnalytics(eventIds.TAKE_YOUR_QUIZ);
                            },
                            size: "small"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Quiz_QuizIntro = (QuizIntro);

// EXTERNAL MODULE: ./components/Quiz/quiz.module.scss
var quiz_module = __webpack_require__(80484);
var quiz_module_default = /*#__PURE__*/__webpack_require__.n(quiz_module);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 6 modules
var useQuery = __webpack_require__(33934);
;// CONCATENATED MODULE: ./components/Quiz/AnswerTile.jsx






const AnswerTile = (param)=>{
    let { data , onClick  } = param;
    const { config ={}  } = useQuizContext();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "answer-tile".concat(data.isSelected ? " selected" : ""),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "answer-img",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: generateImageUrl(data.img, config, 420, 380),
                    alt: data.title,
                    onError: (e)=>{
                        return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "answer-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        dangerouslySetInnerHTML: {
                            __html: data.title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: data.desc
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Quiz_AnswerTile = (AnswerTile);
AnswerTile.propTypes = {
    data: prop_types_default().shape({
        title: (prop_types_default()).string.isRequired,
        desc: (prop_types_default()).string,
        img: (prop_types_default()).string.isRequired,
        isSelected: (prop_types_default()).bool
    }).isRequired,
    onClick: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./public/icons/close-icon-black.svg
/* harmony default export */ var close_icon_black = ({"src":"/_next/static/media/close-icon-black.a8fcfcc5.svg","height":14,"width":14});
;// CONCATENATED MODULE: ./public/icons/arrow-right-black.svg
/* harmony default export */ var arrow_right_black = ({"src":"/_next/static/media/arrow-right-black.e162891c.svg","height":24,"width":34});
;// CONCATENATED MODULE: ./public/icons/idea-icon.svg
/* harmony default export */ var idea_icon = ({"src":"/_next/static/media/idea-icon.2c64cba3.svg","height":32,"width":32});
;// CONCATENATED MODULE: ./components/Quiz/Questionnaire.jsx










const Questionnaire = ()=>{
    var ref;
    const prevBtn = (0,react.useRef)(null);
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const { setSection =()=>{} , totalQuestions , curQuestion , setCurQuestion , data ={} , setData =()=>{} , quizAnalytics , eventIds  } = useQuizContext();
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const { questions =[]  } = data;
    const question = questions[curQuestion - 1];
    const answerClass = (question === null || question === void 0 ? void 0 : (ref = question.answers) === null || ref === void 0 ? void 0 : ref.length) < 4 ? "col-6 col-md-4" : "col-6 col-md-3";
    const isMobile = (navigator === null || navigator === void 0 ? void 0 : navigator.maxTouchPoints) > 0;
    const { isFetching , refetch  } = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "stepData",
            curQuestion
        ],
        queryFn: ()=>{
            return fetchProducts(getFilterQuery(questions), data === null || data === void 0 ? void 0 : data.plpCategory);
        },
        staleTime: Infinity
    });
    (0,react.useEffect)(()=>{
        const nextQuestion = curQuestion + 1;
        queryClient.prefetchQuery({
            queryKey: [
                "stepData",
                nextQuestion
            ],
            queryFn: ()=>{
                return fetchProducts(getFilterQuery(questions), data === null || data === void 0 ? void 0 : data.plpCategory);
            }
        });
        document.addEventListener("click", ()=>{
            if (isMobile) {
                setShowTooltip(false);
            }
        });
    }, [
        questions,
        curQuestion,
        queryClient
    ]);
    const handleNext = ()=>{
        refetch().then((param)=>{
            let { data: d  } = param;
            const { facet_counts: { facet_fields: facets = {}  } = {}  } = d;
            isFilterValid(curQuestion, facets, setData);
            navQuestion(1, curQuestion, setCurQuestion, totalQuestions);
        }).catch((err)=>console.log(err)).finally(()=>{
            var ref;
            prevBtn === null || prevBtn === void 0 ? void 0 : (ref = prevBtn.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
        });
    };
    const handleContinue = ()=>{
        setSection(sections.RESULTS);
    };
    const isLastQuestion = curQuestion === totalQuestions;
    const handleToolTip = (showTooltip)=>{
        if (!isMobile) {
            setShowTooltip(showTooltip);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "questionnaire kf-react-plp-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 d-flex justify-content-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "top-controls previous".concat(curQuestion < 2 ? " hidden" : ""),
                            onClick: ()=>{
                                quizAnalytics(eventIds.PREVIOUS);
                                selectAnswer(curQuestion - 1, null, setData, true);
                                navQuestion(-1, curQuestion, setCurQuestion, totalQuestions);
                            },
                            ref: prevBtn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_right_black.src,
                                    alt: "close"
                                }),
                                " Previous"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "top-controls close",
                            onClick: ()=>{
                                quizAnalytics(eventIds.CLOSE);
                                setSection(sections.LANDING);
                            },
                            children: [
                                "Close ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: close_icon_black.src,
                                    alt: "close"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-9 col-md-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "progress-text",
                            children: [
                                "Question ",
                                curQuestion,
                                " of ",
                                totalQuestions
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("progress", {
                            max: totalQuestions,
                            value: curQuestion
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 question-text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: question === null || question === void 0 ? void 0 : question.questionsTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: question === null || question === void 0 ? void 0 : question.questionDescription
                                }),
                                (question === null || question === void 0 ? void 0 : question.info) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onMouseOver: ()=>{
                                                handleToolTip(true);
                                            },
                                            onFocus: ()=>{
                                                handleToolTip(true);
                                            },
                                            onMouseOut: ()=>{
                                                handleToolTip(false);
                                            },
                                            onBlur: ()=>{
                                                handleToolTip(false);
                                            },
                                            onClick: (e)=>{
                                                if (isMobile) {
                                                    e.stopPropagation();
                                                    setShowTooltip(!showTooltip);
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: idea_icon.src,
                                                    alt: ""
                                                }),
                                                "Why We Ask?"
                                            ]
                                        }),
                                        showTooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "question-modal",
                                            dangerouslySetInnerHTML: {
                                                __html: question === null || question === void 0 ? void 0 : question.info
                                            }
                                        }) : null
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row answer-row",
                children: question === null || question === void 0 ? void 0 : question.answers.map((answer, answerIndex)=>{
                    return !(answer === null || answer === void 0 ? void 0 : answer.notApplicable) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: answerClass,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_AnswerTile, {
                            data: {
                                title: answer === null || answer === void 0 ? void 0 : answer.answerTitle,
                                desc: answer === null || answer === void 0 ? void 0 : answer.answerDescription,
                                img: answer === null || answer === void 0 ? void 0 : answer.image,
                                isSelected: answer === null || answer === void 0 ? void 0 : answer.isSelected
                            },
                            onClick: ()=>{
                                quizAnalytics(eventIds.ANSWER_SELECTED, curQuestion, answerIndex + 1, question === null || question === void 0 ? void 0 : question.questionsTitle, answer === null || answer === void 0 ? void 0 : answer.answerTitle);
                                selectAnswer(curQuestion - 1, answerIndex, setData);
                            }
                        }, curQuestion + answerIndex)
                    }, curQuestion + answerIndex) : null;
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row controls",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 d-flex justify-content-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "skip-button",
                            onClick: ()=>{
                                quizAnalytics(eventIds.SKIP);
                                if (isLastQuestion) {
                                    handleContinue();
                                } else {
                                    selectAnswer(curQuestion - 1, null, setData, true);
                                    isFilterValid(curQuestion, null, setData, true);
                                    navQuestion(1, curQuestion, setCurQuestion, totalQuestions);
                                }
                            },
                            children: "Skip"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "ghost",
                            role: "button",
                            label: isLastQuestion ? "Continue" : "Next Question",
                            onClick: ()=>{
                                if (isLastQuestion) {
                                    quizAnalytics(eventIds.CONTINUE);
                                    handleContinue();
                                } else {
                                    quizAnalytics(eventIds.NEXT);
                                    handleNext();
                                }
                            },
                            size: "small",
                            disabled: !isAnswered(question === null || question === void 0 ? void 0 : question.answers),
                            loading: isFetching
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Quiz_Questionnaire = (Questionnaire);

// EXTERNAL MODULE: ./components/ProductList/v2/ProductList.jsx + 4 modules
var ProductList = __webpack_require__(79903);
;// CONCATENATED MODULE: ./components/Quiz/QuizResults.jsx






const QuizResults = ()=>{
    var ref;
    const attrName = [];
    const attrValue = [];
    const { data ={} , setSection  } = useQuizContext();
    const { questions =[] , resultTitle , resultDescription  } = data;
    const queries = getFilterQuery(questions, "array");
    queries.forEach((query)=>{
        attrName.push(query.key);
        attrValue.push(query.value);
    });
    const plpConfig = {
        categoryKey: data === null || data === void 0 ? void 0 : (ref = data.plpCategory) === null || ref === void 0 ? void 0 : ref.replace("PLP_", ""),
        attributeName: attrName,
        attributevalue: attrValue,
        ...helper_plpConfig
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "quiz-results",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "kf-react-plp-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "back-button",
                                onClick: ()=>setSection(sections.LANDING),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: arrow_right_black.src,
                                        alt: "close"
                                    }),
                                    " Back to home"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "title",
                                children: resultTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "desc",
                                children: resultDescription
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                data: plpConfig
            })
        ]
    });
};
/* harmony default export */ var Quiz_QuizResults = (QuizResults);

;// CONCATENATED MODULE: ./components/Quiz/analytics.js
const eventIds = {
    TAKE_YOUR_QUIZ: "take_your_quiz",
    NEXT: "next",
    SKIP: "skip",
    PREVIOUS: "previous",
    CLOSE: "close",
    CONTINUE: "continue",
    ANSWER_SELECTED: "answer_selected"
};
const eventInfo = {
    [eventIds.TAKE_YOUR_QUIZ]: {
        clickInternalLinks: "true",
        internalLinkPosition: "intro section",
        internalLinkZoneName: "mirror quiz",
        internalLinkURL: "n/a",
        internalLinkName: "take your quiz",
        eventName: "mirror quiz:start",
        internalLinkType: "CTA",
        eventType: "button",
        eventAction: "mirror quiz:start"
    },
    [eventIds.NEXT]: {
        clickInternalLinks: "true",
        internalLinkPosition: "question section",
        internalLinkZoneName: "mirror quiz",
        internalLinkURL: "n/a",
        internalLinkName: "next question",
        eventName: "mirror quiz:next",
        internalLinkType: "navigation",
        eventType: "button",
        eventAction: "mirror quiz:next"
    },
    [eventIds.SKIP]: {
        clickInternalLinks: "true",
        internalLinkPosition: "question section",
        internalLinkZoneName: "mirror quiz",
        internalLinkURL: "n/a",
        internalLinkName: "skip question",
        eventName: "mirror quiz:skip",
        internalLinkType: "navigation",
        eventType: "button",
        eventAction: "mirror quiz:skip"
    },
    [eventIds.PREVIOUS]: {
        clickInternalLinks: "true",
        internalLinkPosition: "question section",
        internalLinkZoneName: "mirror quiz",
        internalLinkURL: "n/a",
        internalLinkName: "previous question",
        eventName: "mirror quiz:previous",
        internalLinkType: "navigation",
        eventType: "button",
        eventAction: "mirror quiz:previous"
    },
    [eventIds.CLOSE]: {
        clickInternalLinks: "true",
        internalLinkPosition: "quiz header",
        internalLinkZoneName: "mirror quiz",
        internalLinkURL: "n/a",
        internalLinkName: "close quiz",
        eventName: "mirror quiz:close",
        internalLinkType: "icon",
        eventType: "button",
        eventAction: "mirror quiz:close"
    },
    [eventIds.CONTINUE]: {
        clickInternalLinks: "true",
        internalLinkPosition: "final question",
        internalLinkZoneName: "mirror quiz",
        internalLinkURL: "n/a",
        internalLinkName: "continue",
        eventName: "mirror quiz:complete",
        internalLinkType: "CTA",
        eventType: "button",
        eventAction: "mirror quiz:complete"
    },
    [eventIds.ANSWER_SELECTED]: (qid, aid, qTxt, aTxt)=>{
        return {
            clickInternalLinks: "true",
            internalLinkPosition: "question ".concat(qid),
            internalLinkZoneName: "mirror quiz",
            internalLinkURL: "n/a",
            internalLinkName: "select answer",
            eventName: "mirror quiz:answer",
            internalLinkType: "radio button",
            eventType: "option",
            eventAction: "mirror quiz:answer",
            questionId: "q".concat(qid),
            questionText: qTxt,
            answerId: "a".concat(aid),
            answerText: aTxt
        };
    }
};
const getPageInfo = ()=>{
    if (window && window.adobeDataLayer) {
        const state = window.adobeDataLayer.getState("page");
        return {
            site: state.site,
            pageInfo: state.pageInfo,
            category: {
                ...state === null || state === void 0 ? void 0 : state.category,
                subCategory2: "quiz",
                pageType: "interactive",
                subCategory1: "mirror",
                subCategoryID: "quiz-mirror"
            }
        };
    }
};
const quizAnalytics = function(eventId) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (window && window.adobeDataLayer) {
        const event = eventInfo[eventId];
        if (event) {
            window.adobeDataLayer.push({
                event: "cmp:click",
                eventInfo: typeof event === "function" ? event(...args) : event,
                page: getPageInfo()
            });
        } else {
            console.warn("No analytics info found for eventId: ".concat(eventId));
        }
    }
};

;// CONCATENATED MODULE: ./components/Quiz/index.jsx











const Quiz = (param)=>{
    let { data: authorData  } = param;
    var ref;
    const d = structuredClone(authorData);
    formatQuizData(d);
    const [data, setData] = (0,react.useState)(d);
    const [section, setSection] = (0,react.useState)(sections.LANDING);
    const [curQuestion, setCurQuestion] = (0,react.useState)(1);
    const [config, setConfig] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((d)=>{
            const { scene7BaseUrl ="" , dmScene7AccountName =""  } = d.general;
            setConfig({
                scene7BaseUrl,
                dmScene7AccountName
            });
        }).catch((e)=>console.log(e));
    }, []);
    const contextValue = {
        setSection,
        data,
        setData,
        curQuestion,
        setCurQuestion,
        totalQuestions: data === null || data === void 0 ? void 0 : (ref = data.questions) === null || ref === void 0 ? void 0 : ref.length,
        config,
        quizAnalytics: quizAnalytics,
        eventIds: eventIds
    };
    const queryClient = new modern_queryClient/* QueryClient */.S({
        defaultOptions: {
            queries: {
                staleTime: Infinity,
                cacheTime: 10 * 60 * 1000
            }
        }
    });
    let content = "";
    if (section === sections.LANDING) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_QuizIntro, {});
    } else if (section === sections.QUIZ) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_Questionnaire, {});
    } else if (section === sections.RESULTS) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(Quiz_QuizResults, {});
    }
    return config && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.StrictMode, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
            client: queryClient,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizProvider, {
                value: contextValue,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (quiz_module_default()).quizContainer,
                    children: content
                })
            })
        })
    });
};
/* harmony default export */ var components_Quiz = (Quiz);

// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var react_collapsible_dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(react_collapsible_dist);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./public/icons/arrow-down.svg
var arrow_down = __webpack_require__(32873);
;// CONCATENATED MODULE: ./components/core/Accordion/AccordionLoader.jsx








const AccordionLoader = (props)=>{
    const { data: { accordionProperties ={} , componentLinkType ="" , componentPosition , pageType  } , titleKey ="cq:panelTitle" , trigger =false , handleOpen , handleClose , containerElementProps , isArrow =false , contentOverflow =false  } = props;
    const { [":itemsOrder"]: itemsOrder , [":items"]: items , id  } = accordionProperties;
    const [isExpanded, setisExpanded] = (0,react.useState)(true);
    const accordiumObject = (0,react.useRef)(null);
    const handleAccordion = ()=>{
        setisExpanded(true);
    };
    const CollapsibleHeader = (param)=>{
        let { title , open =false  } = param;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("h2", {
            className: "cmp-accordion__header",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "cmp-accordion__button ".concat(open ? "cmp-accordion__button--expanded" : ""),
                onClick: handleAccordion,
                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(componentPosition ? componentPosition : "accordion", '",\n        "internalLinkZoneName":"n/a","internalLinkURL":"n/a","internalLinkName":"').concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "internalLinkType":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentLinkType ? componentLinkType : "navigation", '",\n        "eventType":"accordion",\n        "eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '"}'),
                "aria-expanded": open,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "heading",
                        "aria-level": "5",
                        className: "cmp-accordion__title",
                        children: title
                    }),
                    !isArrow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-2"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "down-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_down/* default.src */.Z.src,
                                    alt: "Arrow Down"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "up-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_up/* default.src */.Z.src,
                                    alt: "Arrow Up"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    const CollapsibleInnerText = (param)=>{
        let { gridColumnClassName , faqText , title  } = param;
        const finalText = (0,helper.sanitizeInnerHtml)(faqText);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-accordian-title": title,
            className: "cmp-accordion__panel".concat(isExpanded ? " cmp-accordion__panel--expanded" : " cmp-accordion__panel--hidden"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text ".concat(gridColumnClassName),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-text",
                    children: finalText
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        ref: accordiumObject,
        className: "cmp-accordion",
        "data-placeholder-text": "false",
        children: itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((item, i)=>{
            const title = items[item][titleKey];
            let gridColumnClassName = items[item]["appliedCssClassNames"];
            let faqText = items[item]["text"];
            if (!faqText) {
                faqText = "";
                const itemsOrderArr = items[item][":itemsOrder"];
                if (itemsOrderArr) {
                    itemsOrderArr.forEach((itemTx)=>{
                        faqText = "".concat(faqText).concat(items[item][":items"][itemTx]["text"]);
                        gridColumnClassName = "".concat(items[item][":items"][itemTx]["appliedCssClassNames"]);
                    });
                }
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-cmp-hook-accordion": "item",
                    className: "cmp-accordion__item",
                    id: "accordion-".concat(i, "-").concat((0,helper.getRandom)()),
                    "data-cmp-data-layer": '{"accordion-'.concat(i, "-").concat((0,helper.getRandom)(), '":{"@type":"kohler-us/components/accordion/item","dc:title":"').concat(title, '"}}'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        open: true,
                        onTriggerOpening: handleOpen,
                        onTriggerClosing: handleClose,
                        containerElementProps: containerElementProps,
                        overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                        openedClassName: "collapsible--open",
                        tabIndex: "0",
                        triggerOpenedClassName: "collapsible__trigger--open",
                        trigger: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title
                        }),
                        triggerWhenOpen: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title,
                            open: true
                        }),
                        transitionTime: 400,
                        easing: "ease-in-out",
                        triggerElementProps: {
                            id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                        },
                        contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleInnerText, {
                            gridColumnClassName: gridColumnClassName,
                            faqText: faqText,
                            title: title
                        })
                    })
                })
            }, "accordion-".concat(i, "-").concat((0,helper.getRandom)()));
        })
    });
};
/* harmony default export */ var Accordion_AccordionLoader = (AccordionLoader);

;// CONCATENATED MODULE: ./components/Default/TextFiller.jsx



const TextFiller = (props)=>{
    const { data: { text ="" , appliedCssClassNames =""  } = {}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: (0,helper.sanitizeInnerHtml)(text)
        })
    });
};
/* harmony default export */ var Default_TextFiller = (TextFiller);

// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(30534);
// EXTERNAL MODULE: ./components/VisualFilter/visual-filter.module.scss
var visual_filter_module = __webpack_require__(48520);
var visual_filter_module_default = /*#__PURE__*/__webpack_require__.n(visual_filter_module);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
;// CONCATENATED MODULE: ./components/VisualFilter/VisualFilter.jsx














function VisualFilter(param) {
    let { data , fullData  } = param;
    var ref;
    const [marketParamValues, setMarketParamValues] = (0,react.useState)(null);
    const rowsInitialValue = (0,product/* getRowsInitialValue */.U9)();
    const paginationState = {
        rows: rowsInitialValue,
        start: 0
    };
    const { rows , start  } = paginationState;
    const router = (0,next_router.useRouter)();
    const query = router.query;
    const selectedCategory = query.Category;
    const [category, setCategory] = (0,react.useState)(selectedCategory);
    const plpList = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    const categoryValue = plpList === null || plpList === void 0 ? void 0 : (ref = plpList.facets) === null || ref === void 0 ? void 0 : ref["**ProductLocalCategory_s"];
    const dispatch = (0,es/* useDispatch */.I0)();
    const changeCategoryFilter = (e, title)=>{
        document.querySelectorAll(".visual-filter__title").forEach((el)=>el.classList.remove("--active"));
        // Add active to clicked
        e.currentTarget.querySelector(".visual-filter__title").classList.add("--active");
        const object = {
            facet: "**ProductLocalCategory_s",
            value: [
                title
            ],
            display: [
                title
            ]
        };
        localStorage.setItem("selectedFilter", JSON.stringify(object));
        const componentProps = JSON.parse(localStorage.getItem("componentProps"));
        const { categoryKey  } = componentProps;
        const fusion = plpList.fusion;
        const params = new URLSearchParams(window.location.search);
        const sort = params.get("sort");
        let newUrl = "".concat(window.location.pathname, "?Category=").concat(encodeURIComponent(title));
        if (sort) {
            newUrl += "&sort=".concat(sort);
        }
        window.history.replaceState(window.location.pathname, document.title, "".concat(newUrl));
        let filterQuery = (0,helper.getAllFilterQueries)(componentProps, fusion, marketParamValues);
        filterQuery = (0,helper.checkCategoryFilter)(filterQuery);
        updateProductList(filterQuery, categoryKey, sort);
        setCategory(title);
    };
    const updateProductList = (queries, categoryKey, sort)=>{
        const fq = [];
        queries === null || queries === void 0 ? void 0 : queries.forEach((q)=>{
            let tag = '{!tag="'.concat(q.facet, '"}');
            if (!q.facet.match(/^\*{2}/)) {
                q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 ? fq.push(encodeURIComponent("".concat('{!tag="priceList.'.concat(persona, '.finalPrice_d"}') + "priceList.".concat(persona, ".finalPrice_d"), ":(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
                return;
            }
            q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 ? fq.push("".concat("priceList.".concat(persona, ".finalPrice_d").replace(/^\*{2}/, ""), ":(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
        });
        const persona = (0,helper.getUserPersona)();
        const query = {
            fq,
            rows,
            start,
            fl: (0,constants.resourceFacetLabels)(persona).join(",")
        };
        if (sort) {
            if (sort === "price asc") {
                query.sort = "".concat((0,helper.getPriceSortQuery)(plpList === null || plpList === void 0 ? void 0 : plpList.grouped), "+asc");
            } else if (sort === "price desc") {
                query.sort = "".concat((0,helper.getPriceSortQuery)(plpList === null || plpList === void 0 ? void 0 : plpList.grouped), "+desc");
            } else {
                query.sort = sort;
            }
        }
        dispatch((0,productListSlice/* getProducts */.Xp)({
            profileName: categoryKey,
            query,
            update: false
        })).then(()=>{
            console.log("updated");
        }).catch((err)=>{
            console.log(err);
        });
    };
    const storeCategoryList = ()=>{
        let categoryArray = [];
        if (localStorage.getItem("categoryArray")) {
            categoryArray = JSON.parse(localStorage.getItem("categoryArray"));
        }
        categoryArray.push(data.title ? (0,html_react_parser/* default */.ZP)(data.title) : "");
        localStorage.setItem("categoryArray", JSON.stringify(categoryArray));
    };
    (0,react.useEffect)(()=>{
        if (category && data.title && data.title === category) {
            const el = document.querySelectorAll(".visual-filter__title");
            el.forEach((item)=>{
                if (item.innerText === category) {
                    item.classList.add("--active");
                }
            });
            const object = {
                facet: "**ProductLocalCategory_s",
                value: category ? [
                    (0,html_react_parser/* default */.ZP)(category)
                ] : "",
                display: category ? [
                    (0,html_react_parser/* default */.ZP)(category)
                ] : ""
            };
            localStorage.setItem("selectedFilter", JSON.stringify(object));
        } else if (!category) {
            localStorage.removeItem("selectedFilter");
        }
        storeCategoryList();
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const marketParam = get_default()(config, "marketParamValues", {});
            setMarketParamValues(marketParam);
        });
    }, []);
    (0,react.useEffect)(()=>{
        document.querySelectorAll(".visual-filter__title").forEach((el)=>el.classList.remove("--active"));
        if (categoryValue && categoryValue.length === 2) {
            let categoryTitle = categoryValue[0];
            const el = document.querySelectorAll(".visual-filter__title");
            el.forEach((item)=>{
                if (item.innerText === categoryTitle) {
                    console.log(categoryTitle, item.innerText);
                    item.classList.add("--active");
                }
            });
        }
    }, [
        categoryValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (visual_filter_module_default()).visualFilter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: (e)=>changeCategoryFilter(e, data.title ? (0,html_react_parser/* default */.ZP)(data.title) : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "visual-filter",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "visual-filter__image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(data.imageUrl)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "visual-filter__title",
                        children: data.title ? (0,html_react_parser/* default */.ZP)(data.title) : ""
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/AemGrid.jsx




































const AemGrid = (props)=>{
    var ref, ref1;
    const { data ={} , itemKey ="" , count =0 , eventHandler ={} , fullData ={} , containerId ="" , ...extraProps } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if ((0,utils/* isAuthModal */.S)(data)) {
            dispatch((0,authSlice/* setAuthModalStaticText */.vu)(data));
        }
        if ((0,utils/* isCompareProducts */.Be)(data)) {
            dispatch((0,genericSlice/* setCompareproductsStaticText */.rA)(data));
        }
        if ((0,utils/* isNewsLetter */.C_)(data)) {
            dispatch((0,genericSlice/* setSubscribeModalContent */.ml)(data));
        }
        if ((0,utils/* isSiteWideWarning */.yd)(data)) {
            dispatch((0,genericSlice/* setSitewideWarningContent */.FV)(data));
        }
        if ((0,utils/* isNewsLetterSignUp */.f5)(data)) {
            dispatch((0,genericSlice/* setSitewideNewsLetterContent */._r)(data));
        }
        if ((0,utils/* isToaster */.bu)(data)) {
            dispatch((0,genericSlice/* setToastContent */.Ji)(data));
        }
    }, [
        data
    ]);
    const { pressReleaseLanding =()=>{} , associateMembership =()=>{}  } = extraProps;
    if ((0,utils/* isVideo */.Wv)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Video, {
            data: data
        });
    }
    if ((0,utils/* isSpacer */.MW)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Spacer, {
            data: data
        });
    }
    if ((0,utils/* isImage */.Or)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_Image, {
            data: data
        });
    }
    if ((0,utils/* isAemForm */.np)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_AemForm, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isProductcard */.po)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductCard, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isCarousel */.C2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Carousel, {
            data: data,
            fullData: fullData
        });
    }
    if ((0,utils/* isPromoBanner */.e7)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_PromoBanner, {
            data: data,
            ...extraProps
        });
    }
    if ((0,utils/* isSlick */.bd)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_CarouselSlick, {
            fullData: fullData,
            data: data
        });
    }
    if ((0,utils/* isTeaser */.j$)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Teaser, {
            data: data,
            fullData: fullData,
            ...extraProps
        });
    }
    if ((0,utils/* isText */.Gs)(data)) {
        if (!isSsr) return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Text, {
            data: data,
            ...extraProps
        });
        else return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default_TextFiller, {
            data: data
        });
    }
    if ((0,utils/* isTab */.wR)(data) && data["appliedCssClassNames"]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Tab, {
            data: data
        });
    }
    if ((0,utils/* isBrandHeader */.cD)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_BrandHeader, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isHeaderNav */.ZS)(data, extraProps)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNav, {
            data: data,
            eventHandler: eventHandler,
            ...extraProps
        });
    }
    if ((0,utils/* isEmbed */.P2)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Embed, {
            data: data,
            eventHandler: eventHandler
        });
    }
    if ((0,utils/* isFooter */.cl)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_Footer, {
            data: data,
            eventHandler: eventHandler,
            ...extraProps
        });
    }
    if ((0,utils/* isCustomerSupport */.lU)(data)) {
        return extraProps && extraProps.landing && extraProps.landing(data);
    }
    if ((0,utils/* isAemImage */.Pe)(data)) {
        return !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Image, {
            data: data
        }) : null;
    }
    if ((0,utils/* isAemList */.K5)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_List, {
            data: data
        });
    }
    if ((0,utils/* isCartLanding */.l1)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.landing && extraProps.landing(data);
        } else {
            return extraProps && extraProps.landingFiller && extraProps.landingFiller(data);
        }
    }
    if ((0,utils/* isCheckoutLanding */.Ar)(data) && !isSsr) {
        if (extraProps.paymentResp) {
            data.paymentResp = extraProps.paymentResp;
        }
        if (extraProps.checkoutMode) {
            data.checkoutMode = extraProps.checkoutMode;
        }
        if (extraProps.addrSet) {
            data.addrSet = extraProps.addrSet;
        }
        if (extraProps.razorpayResp) {
            data.razorpayResp = extraProps.razorpayResp;
        }
        return extraProps && extraProps.checkoutView && extraProps.checkoutView(data);
    }
    if ((0,utils/* isOrderConfirmation */.Uq)(data)) {
        return extraProps && extraProps.orderConfirmation && extraProps.orderConfirmation(data);
    }
    if ((0,utils/* isOrderStatus */.K0)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderStatus && extraProps.orderStatus(data);
        } else {
            return extraProps && extraProps.orderStatusFiller && extraProps.orderStatusFiller();
        }
    }
    if ((0,utils/* isOrderHistory */._$)(data) && !isSsr) {
        return extraProps && extraProps.orderHistory && extraProps.orderHistory(data);
    }
    if ((0,utils/* isOrderDetails */.pv)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.orderDetails && extraProps.orderDetails(data);
        } else {
            return extraProps && extraProps.orderDetailsFiller && extraProps.orderDetailsFiller(data);
        }
    }
    if ((0,utils/* isPairsWellWth */.oC)(data) && !isSsr) {
        return extraProps && extraProps.pairsWellWith && extraProps.pairsWellWith(data);
    }
    if ((0,utils/* isSharedCart */.sL)(data) && !isSsr) {
        return extraProps && extraProps.sharedCart && extraProps.sharedCart(data);
    }
    if ((0,utils/* isBreadcrumb */.Z3)(data)) {
        return extraProps && extraProps.breadCrumb && extraProps.breadCrumb(data, fullData);
    }
    if ((0,utils/* isProductEnquiry */.vI)(data)) {
        // return extraProps && extraProps.landing && extraProps.landing(data)
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductEnquiryView/* default */.Z, {
            data: data
        });
    }
    if ((0,utils/* isDealerEnquiry */.A_)(data)) {
        return extraProps && extraProps.landing && extraProps.landing(data);
    }
    if ((0,utils/* isBlogPage */.IE)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog, {
            data: data
        });
    }
    if ((0,utils/* isReturns */.xv)(data)) {
        return extraProps && extraProps.landing && extraProps.landing(data);
    }
    if ((0,utils/* isFindAStore */.ik)(data)) {
        return extraProps && extraProps.landing && extraProps.landing(data);
    }
    if ((0,utils/* isProductList */.Hx)(data)) {
        return extraProps && extraProps.productList && extraProps.productList(data, eventHandler);
    }
    if ((0,utils/* isSearch */.N)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.searchComponent && extraProps.searchComponent(data, eventHandler);
        } else {
            return extraProps && extraProps.searchFiller && extraProps.searchFiller(data);
        }
    }
    if ((0,utils/* isHelpSupport */.zK)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_HelpSupport, {
            data: data
        });
    }
    if ((0,utils/* isAccountSettings */.mg)(data) && !isSsr) {
        return extraProps && extraProps.accountSettings && extraProps.accountSettings(data);
    }
    if ((0,utils/* isMyservice */.U4)(data) && !isSsr) {
        return extraProps && extraProps.myServices && extraProps.myServices(data);
    }
    if ((0,utils/* isMyFavorites */.we)(data) && !isSsr) {
        return extraProps && extraProps.myFavorites && extraProps.myFavorites(data);
    }
    if ((0,utils/* isMyproducts */.Dx)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.myProducts && extraProps.myProducts(data);
        } else {
            return extraProps && extraProps.myProductsFiller && extraProps.myProductsFiller();
        }
    }
    if ((0,utils/* isLiterature */.ek)(data) && !isSsr) {
        return extraProps && extraProps.literature && extraProps.literature(data);
    }
    if ((0,utils/* isProductDetails */.jS)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.productDetail && extraProps.productDetail(data, extraProps === null || extraProps === void 0 ? void 0 : extraProps.slug, extraProps === null || extraProps === void 0 ? void 0 : extraProps.skuId, extraProps === null || extraProps === void 0 ? void 0 : extraProps.type);
        } else {
            return extraProps && extraProps.productDetailFiller && extraProps.productDetailFiller(data);
        }
    }
    if ((0,utils/* isProductAccordion */.eq)(data)) {
        if (!isSsr) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                data: data
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_AccordionLoader, {
                data: data
            });
        }
    }
    if ((0,utils/* isProductExfPdp */.V6)(data) && !isSsr) {
        return extraProps && extraProps.productExf && extraProps.productExf(data);
    }
    if ((0,utils/* isProductReview */.s3)(data) && !isSsr) {
        return extraProps && extraProps.review && extraProps.review(data);
    }
    if ((0,utils/* isRegisterOffline */.hn)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProducts(data);
        } else {
            return extraProps && extraProps.offlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,utils/* isRegisterOnline */.L)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.onlineProducts && extraProps.onlineProducts(data);
        } else {
            return extraProps && extraProps.onlineProducts && extraProps.offlineProductsFiller();
        }
    }
    if ((0,utils/* isKnowledgeArticle */.Mc)(data)) {
        if (!isSsr) {
            return extraProps && extraProps.knowledgeArticle && extraProps.knowledgeArticle(data);
        } else {
            return extraProps && extraProps.knowledgeArticleFiller && extraProps.knowledgeArticleFiller();
        }
    }
    if ((0,utils/* isBrowseAllStores */.MN)(data) && !isSsr) {
        return extraProps && extraProps.browseAllStores && extraProps.browseAllStores(data);
    }
    if ((0,utils/* isFindingModelNumber */.iL)(data) && !isSsr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FindingModelNumber, {
            data: data
        });
    }
    if ((0,utils/* isPressLanding */.GX)(data) && !isSsr) {
        return pressReleaseLanding(data);
    }
    if ((0,utils/* isAssociateMembership */.F0)(data)) {
        return associateMembership(data);
    }
    if ((0,utils/* isLeadGeneration */.iP)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGeneration_LeadGenerationView, {
            data: data,
            ...extraProps
        });
    }
    if ((0,utils/* isQuiz */.gb)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Quiz, {
            data: data
        });
    }
    if ((0,utils/* isVisualFilter */.$9)(data)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisualFilter, {
            data: data,
            fullData: fullData
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
            condition: (data === null || data === void 0 ? void 0 : data[":itemsOrder"]) && (data === null || data === void 0 ? void 0 : (ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.length) === 1 && (data === null || data === void 0 ? void 0 : (ref1 = data[":itemsOrder"]) === null || ref1 === void 0 ? void 0 : ref1.includes("text")) && !(0,utils/* isTeaserContainer */.xW)(data),
            wrapper: (children)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: data === null || data === void 0 ? void 0 : data.gridClassNames,
                    children: children
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AemGridColumn, {
                data: data,
                itemKey: itemKey,
                count: count,
                eventHandler: eventHandler,
                containerId: containerId,
                ...extraProps
            })
        })
    });
};
/* harmony default export */ var components_AemGrid = (AemGrid);


/***/ }),

/***/ 46576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_AuthUtilityNav; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(92798);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav.view/index.jsx








const MegaMenu = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2030).then(__webpack_require__.bind(__webpack_require__, 14334)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(14334)
            ]
    },
    suspense: true
});
const AuthUtilityNavView = (props)=>{
    const avatarIcon = "/icons/avatar.svg";
    const rightArrow = "/icons/right-white.svg";
    const { active , i18n , userMenuFragment , guestMenuFragment , isLoggedIn , logout , toggleAuthNav , setAuthNav , onAuthMenuClick , nomenu =false , setCloseAuthMenu =()=>{} , isFromUtiltyWidget =false  } = props;
    const { user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    const styleClass = classnames_default()({
        "auth-nav": true,
        "auth-nav--active": active
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    const onClickSignIn = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const onClickSignUp = ()=>{
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true,
            active: 1
        }));
    };
    const showMenuNav = ()=>{
        toggleAuthNav();
    };
    const signInEventInfo = JSON.stringify({
        eventName: "sign in start",
        eventAction: "sign in start",
        internalLinkName: "sign in start",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "global header",
        internalLinkURL: "n/a",
        internalLinkPosition: "global header sign in start",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: styleClass,
        "aria-expanded": active,
        children: [
            winWidth <= 1200 ? isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    tabIndex: "0",
                    "aria-label": "".concat(i18n.hi, " ").concat((0,helper.capitalizeFirstName)(user === null || user === void 0 ? void 0 : user.firstName)),
                    role: "button",
                    className: "auth-nav__sign-in-mobile",
                    onClick: ()=>{
                        toggleAuthNav();
                        onAuthMenuClick(!active);
                        setAuthNav(!active);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            name: "loggedInUser",
                            className: "auth-nav__user",
                            children: [
                                i18n.hi,
                                ", ",
                                (0,helper.capitalizeFirstName)(user === null || user === void 0 ? void 0 : user.firstName)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: rightArrow,
                            alt: i18n.rightArrowAlt,
                            className: "auth-nav__sign-in-right-arrow"
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: "Loading...",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                    userMenuFragment: userMenuFragment,
                    guestMenuFragment: guestMenuFragment,
                    isLoggedIn: isLoggedIn,
                    i18n: i18n,
                    user: user,
                    logout: logout,
                    toggleAuthNav: toggleAuthNav,
                    active: active,
                    handleSignin: onClickSignIn,
                    handleCreateAccount: onClickSignUp
                })
            }) : isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                tabIndex: "0",
                role: "button",
                "aria-label": active ? "".concat(i18n.user, " ").concat(i18n.expanded) : "".concat(i18n.user, " ").concat(i18n.collapsed),
                name: "loggedInUser",
                className: "auth-nav__user",
                onClick: showMenuNav,
                children: [
                    i18n.hi,
                    ", ",
                    (0,helper.capitalizeFirstName)(user === null || user === void 0 ? void 0 : user.firstName)
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                tabIndex: "0",
                role: "button",
                name: "avatarIcon",
                "aria-label": active ? "".concat(i18n.signIn, " ").concat(i18n.expanded) : "".concat(i18n.signIn, " ").concat(i18n.collapsed),
                src: avatarIcon,
                alt: i18n.signIn,
                onClick: showMenuNav,
                className: "gbh-data-layer",
                "data-gbh-data-layer": signInEventInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "auth-nav__menu ".concat(isFromUtiltyWidget ? "auth-nav__menu-login" : "", "   ").concat(isLoggedIn ? "auth-nav__menu-expand" : "", " ").concat(active ? "auth-nav__menu-open" : ""),
                "aria-hidden": !active,
                children: active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                    fallback: "Loading...",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu, {
                        userMenuFragment: userMenuFragment,
                        guestMenuFragment: guestMenuFragment,
                        isLoggedIn: isLoggedIn,
                        i18n: i18n,
                        user: user,
                        logout: logout,
                        toggleAuthNav: toggleAuthNav,
                        handleSignin: onClickSignIn,
                        handleCreateAccount: onClickSignUp,
                        onAuthMenuClick: onAuthMenuClick,
                        nomenu: nomenu,
                        setCloseAuthMenu: setCloseAuthMenu
                    })
                }) : null
            })
        ]
    });
};
AuthUtilityNavView.displayName = "AuthUtilityNavView";
/* harmony default export */ var AuthUtilityNav_view = (AuthUtilityNavView);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
;// CONCATENATED MODULE: ./i18n/useAuthUtilityNavi18n.js

const useAuthUtilityNavi18n = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        signIn: t("Sign In"),
        createAccount: t("Create Account"),
        hi: t("kf.auth.label.hi", "Hi"),
        title: t("kf.auth.label.bannerMssg", "Your Kohler Account"),
        welcome: t("kf.auth.label.welcome", "Welcome Back"),
        logout: t("kf.auth.label.logout", "Sign Out"),
        rightArrowAlt: t("kf.auth.label.rightArrowAlt", "right arrow"),
        leftArrowAlt: t("kf.auth.label.rightArrowAlt", "right arrow"),
        menu: t("kf.auth.label.menu", "Menu"),
        expanded: t("kf.auth.label.expanded", "Expanded"),
        collapsed: t("kf.auth.label.collapsed", "Collapsed"),
        user: t("kf.auth.label.user", "User"),
        orders: t("kf.account.label.orders", "Orders")
    };
    return i18n;
};
/* harmony default export */ var i18n_useAuthUtilityNavi18n = (useAuthUtilityNavi18n);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.module.scss
var index_module = __webpack_require__(50238);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/AuthUtilityNav/index.jsx










// import useOnClickOutside from "@/hooks/useOnClickOutside"

const AuthUtilityNav = (props)=>{
    const { show , active , toggleAuthNav , setAuthNav , onAuthMenuClick , nomenu =false , setCloseAuthMenu =()=>{} , isFromUtiltyWidget =false  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const authNavMenuRef = (0,react.useRef)(null);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { guestMenuFragment , userMenuFragment  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    // useOnClickOutside(authNavMenuRef, toggleAuthNav)
    (0,react.useEffect)(()=>{
        if (show || lib/* isMobile */.tq) {
            (0,config/* getConfig */.i)().then((CONFIG)=>{
                const userFragment = get_default()(CONFIG, "general.signInFragment", "");
                const guestFragment = get_default()(CONFIG, "general.signUpFragment", "");
                const guestMenuPayload = {
                    reload: false,
                    path: guestFragment,
                    fragmentName: "guestMenuFragment"
                };
                dispatch((0,genericSlice/* getAuthMenuFragment */.T8)(guestMenuPayload));
                const userMenuPayload = {
                    reload: false,
                    path: userFragment,
                    fragmentName: "userMenuFragment"
                };
                dispatch((0,genericSlice/* getAuthMenuFragment */.T8)(userMenuPayload));
            });
        }
    }, [
        show
    ]);
    const staticTexts = i18n_useAuthUtilityNavi18n();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "listitem",
        className: "auth-widget auth-widget__menu ".concat((index_module_default()).authUtilityNavWrapper),
        ref: authNavMenuRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthUtilityNav_view, {
            show: show,
            active: active,
            toggleAuthNav: toggleAuthNav,
            i18n: staticTexts,
            userMenuFragment: userMenuFragment,
            guestMenuFragment: guestMenuFragment,
            isLoggedIn: isAuth,
            logout: ()=>dispatch((0,authSlice/* logout */.kS)()),
            setAuthNav: setAuthNav,
            onAuthMenuClick: onAuthMenuClick,
            setCloseAuthMenu: setCloseAuthMenu,
            nomenu: nomenu,
            isFromUtiltyWidget: isFromUtiltyWidget
        })
    });
};
/* harmony default export */ var v1_AuthUtilityNav = (AuthUtilityNav);


/***/ }),

/***/ 86466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ doubleFeatureContentCardSettings; },
  "N": function() { return /* binding */ singleSliderSettings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Default/CarouselSlick/v1/Arrow.jsx

const Arrow = (props)=>{
    const { className ="" , style ="" , onClick =()=>{} , label ="" , topPosition =0 , addAnalyticsForArrows =()=>{}  } = props;
    const clickHandler = (e, label)=>{
        onClick && onClick(e);
        addAnalyticsForArrows(label);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: className,
        type: "button",
        "aria-label": label,
        style: {
            ...style,
            top: topPosition ? topPosition : ""
        },
        onClick: (e)=>clickHandler(e, label)
    });
};
/* harmony default export */ var v1_Arrow = (Arrow);

;// CONCATENATED MODULE: ./components/Default/CarouselSlick/v1/SlickSettings.js


const doubleFeatureContentCardSettings = {
    dots: false,
    infinite: true,
    fade: true,
    autoplay: false,
    cssEase: "ease-in-out",
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false
};
const singleSliderSettings = function(cb, topPosition, autoplay, autoplaySpeed, addAnalyticsForArrows) {
    let swipeEnabled = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
    return {
        autoplay,
        autoplaySpeed,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        swipe: swipeEnabled,
        arrows: true,
        infinite: true,
        centerMode: false,
        beforeChange: (_, current)=>cb ? cb(current + 1, current) : undefined,
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Next",
            topPosition: topPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        }),
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_Arrow, {
            label: "Previous",
            topPosition: topPosition,
            addAnalyticsForArrows: addAnalyticsForArrows
        })
    };
};


/***/ }),

/***/ 55089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FindAStore_FindAStore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
// EXTERNAL MODULE: ./components/FindAStore/index.module.scss
var index_module = __webpack_require__(49581);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./components/core/Accordion/Accordion.jsx
var Accordion = __webpack_require__(92173);
;// CONCATENATED MODULE: ./components/FindAStore/NoStoreAvailable.jsx


const NoStoreAvailable = (props)=>{
    const { staticTexts , error , isServiceLocator  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-a-store__horizontal-line"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-a-store__no-store-text",
                    children: error !== null && error !== void 0 ? error : isServiceLocator ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.selectStateMessage : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.selectDropdown
                })
            ]
        })
    });
};
/* harmony default export */ var FindAStore_NoStoreAvailable = (NoStoreAvailable);

// EXTERNAL MODULE: ./utils/findStore.js
var findStore = __webpack_require__(42605);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
;// CONCATENATED MODULE: ./components/FindAStore/analytics.js

const pageType = "find a store";
const breadcrumbAnalytics = (navItem)=>{
    var ref;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":landing:hero banner:breadcrumb"),
        eventName: "".concat(pageType, ":landing:  :hero banner:breadcrumb"),
        eventType: "navigation",
        internalLinkName: "home>find a store",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":landing:hero banner"),
        internalLinkURL: (ref = navItem === null || navItem === void 0 ? void 0 : navItem.url) !== null && ref !== void 0 ? ref : "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const kecBreadcrumbAnalytics = (navItem)=>{
    var ref;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":kohler experience centres:hero banner:breadcrumb"),
        eventName: "".concat(pageType, ":kohler experience centres:hero banner:breadcrumb"),
        eventType: "navigation",
        internalLinkName: "home>find a store",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":breadcrumb"),
        internalLinkZoneName: "".concat(pageType, ":kohler experience centres:hero banner"),
        internalLinkURL: (ref = navItem === null || navItem === void 0 ? void 0 : navItem.url) !== null && ref !== void 0 ? ref : "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const stateSelectionAnalytics = (state)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":landing:location info:select state"),
        eventName: "".concat(pageType, ":landing:location info:select state"),
        eventType: "navigation",
        internalLinkName: state.toLowerCase(),
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":landing:location info"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const citySelectionAnalytics = (city)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":landing:location info:select city"),
        eventName: "".concat(pageType, ":landing:location info:select city"),
        eventType: "navigation",
        internalLinkName: city.toLowerCase(),
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":landing:location info"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const accordionSelectionAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":landing:location info:expandOrCollapse"),
        eventName: "".concat(pageType, ":landing:location info:expandOrCollapse"),
        eventType: "navigation",
        internalLinkName: "AccordionExpandOrCollapse",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":exclusive showrooms"),
        internalLinkZoneName: "".concat(pageType, ":landing:location info"),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const contactClickAnalytics = (number, pinCode, storeName)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":landing:accordion:exclusive showrooms:contact number"),
        eventName: "".concat(pageType, ":landing:accordion:exclusive showrooms:contact number"),
        eventType: "navigation",
        internalLinkName: number,
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":").concat(pinCode, ":").concat(storeName.toLowerCase()),
        internalLinkZoneName: "".concat(pageType, ":landing:accordion:exclusive showrooms"),
        internalLinkURL: "tel:".concat(number)
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const emailClickAnalytics = (email, pinCode, storeName)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":landing:accordion:exclusive showrooms:email"),
        eventName: "".concat(pageType, ":landing:accordion:exclusive showrooms:email"),
        eventType: "navigation",
        internalLinkName: email,
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":").concat(pinCode, ":").concat(storeName.toLowerCase()),
        internalLinkZoneName: "".concat(pageType, ":landing:accordion:exclusive showrooms"),
        internalLinkURL: "mailto:".concat(email)
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const backToTopAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":landing:location info:back to top"),
        eventName: "".concat(pageType, ":landing:location info:back to top"),
        eventType: "navigation",
        internalLinkName: "back to top",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":landing:location info"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};

;// CONCATENATED MODULE: ./components/FindAStore/StoreListing.jsx








const StoreListing = (props)=>{
    const { storeCity , storeState , staticTexts , storeList , setError , error  } = props;
    const [storeListSeggrgated, setStoreListSeggregated] = (0,react.useState)(null);
    const [accordionOpen, setAccordionOpen] = (0,react.useState)(!lib/* isMobile */.tq);
    const storeTypes = [
        "kohler experience center",
        "studio kohler",
        "exclusive",
        "dealer"
    ];
    const storeTypesList = {
        "kohler experience center": staticTexts.kohlerExperienceCenter,
        "studio kohler": staticTexts.studioKohler,
        exclusive: staticTexts.exclusive,
        dealer: staticTexts.mbo
    };
    (0,react.useEffect)(()=>{
        seggregateStores(storeList);
        if ((storeList === null || storeList === void 0 ? void 0 : storeList.length) === 0) setError();
    }, [
        storeList
    ]);
    (0,react.useEffect)(()=>{
        getStoreList();
    }, [
        storeCity,
        storeState
    ]);
    const seggregateStores = (storesListing)=>{
        const storeListSeggrgated = storesListing === null || storesListing === void 0 ? void 0 : storesListing.reduce(function(memo, x) {
            if (!memo[x["storeType"]]) {
                memo[x["storeType"]] = [];
            }
            memo[x["storeType"]].push(x);
            return memo;
        }, {});
        setStoreListSeggregated(storeListSeggrgated);
    };
    const expandAnalytics = ()=>{
        (0,helper.pushAnalyticsObjToDataLayer)({
            clickInternalLinks: "true",
            eventAction: "find a store:landing:location info:accorddion ".concat(accordionOpen ? "collapse" : "expand"),
            eventName: "find a store:landing:location info:accordion ".concat(accordionOpen ? "collapse" : "expand"),
            eventType: "navigation",
            internalLinkName: "accordion ".concat(accordionOpen ? "collapse" : "expand"),
            internalLinkPosition: "find a store",
            internalLinkType: "find a store:exclusive showrooms",
            internalLinkZoneName: "find a store:landing:location info",
            internalLinkURL: "n/a"
        });
    };
    const getStoreList = ()=>{
        try {
            if (storeState && storeCity) {
                const response = (0,findStore/* getStoresList */.yh)(storeState, storeCity);
                response.then((resp)=>{
                    const { statusCode , result ={}  } = resp;
                    if (statusCode === 200) {
                        const res = result.data.stores;
                        seggregateStores(res);
                    }
                    return {
                        statusCode
                    };
                });
            }
        } catch (error) {
            return {
                statusCode: 400,
                message: error.message
            };
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: storeListSeggrgated && Object.keys(storeListSeggrgated).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-a-store__store-city",
                    children: storeCity
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "find-a-store__separator"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-a-store__collapsible",
                    children: storeTypes === null || storeTypes === void 0 ? void 0 : storeTypes.map((store, index)=>{
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: ((ref = storeListSeggrgated[store]) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                    contentOverflow: "visible",
                                    title: storeTypesList[store],
                                    isOpen: !lib/* isMobile */.tq ? true : false,
                                    triggerStyle: !lib/* isMobile */.tq ? {
                                        display: "none"
                                    } : null,
                                    containerElementProps: {
                                        id: "viewStoreList"
                                    },
                                    titleClassName: "find-a-store__store-type",
                                    expandAnalyticsEvent: expandAnalytics,
                                    handleOpen: ()=>setAccordionOpen(true),
                                    handleClose: ()=>setAccordionOpen(false),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "find-a-store__store-details row",
                                        children: (ref1 = storeListSeggrgated[store]) === null || ref1 === void 0 ? void 0 : ref1.map((storeItem, idx)=>{
                                            var ref, ref1, ref2;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "find-a-store__store-row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "find-a-store__store-name",
                                                        children: storeItem.storeName.toUpperCase()
                                                    }),
                                                    (storeItem === null || storeItem === void 0 ? void 0 : storeItem.storeOwnerName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "find-a-store__store-owner-name",
                                                        children: "".concat(storeItem === null || storeItem === void 0 ? void 0 : storeItem.storeOwnerName, ",")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "find-a-store__store-address-primary",
                                                        children: storeItem.addressLine1
                                                    }),
                                                    storeItem.addressLine2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "find-a-store__store-address-secondary",
                                                        children: storeItem.addressLine2
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "find-a-store__store-address-zone",
                                                        children: [
                                                            storeItem.city,
                                                            ", ",
                                                            storeItem.state,
                                                            " - ",
                                                            storeItem.zip
                                                        ]
                                                    }),
                                                    (storeItem === null || storeItem === void 0 ? void 0 : storeItem.mobile.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: ()=>{
                                                            return contactClickAnalytics(storeItem === null || storeItem === void 0 ? void 0 : storeItem.mobile[0], storeItem === null || storeItem === void 0 ? void 0 : storeItem.zip, storeItem === null || storeItem === void 0 ? void 0 : storeItem.storeName);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "find-a-store__store-mobile find-a-store__store-bold",
                                                                children: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.mobile, " : ")
                                                            }),
                                                            storeItem === null || storeItem === void 0 ? void 0 : (ref = storeItem.mobile) === null || ref === void 0 ? void 0 : ref.map((mobile, index)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "tel:".concat(mobile),
                                                                    className: "find-a-store__store-mobile find-a-store__store-bold",
                                                                    children: "".concat(mobile).concat(index < storeItem.mobile.length - 1 ? ", " : "")
                                                                });
                                                            })
                                                        ]
                                                    }),
                                                    (storeItem === null || storeItem === void 0 ? void 0 : storeItem.phone.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "find-a-store__store-mobile find-a-store__store-bold",
                                                                children: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.phone, " : ")
                                                            }),
                                                            storeItem === null || storeItem === void 0 ? void 0 : (ref1 = storeItem.phone) === null || ref1 === void 0 ? void 0 : ref1.map((phone, index)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "tel:".concat(phone),
                                                                    className: "find-a-store__store-mobile find-a-store__store-bold",
                                                                    children: "".concat(phone).concat(index < storeItem.phone.length - 1 ? ", " : "")
                                                                });
                                                            })
                                                        ]
                                                    }),
                                                    storeItem.email.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: ()=>{
                                                            return emailClickAnalytics(storeItem === null || storeItem === void 0 ? void 0 : storeItem.email[0], storeItem === null || storeItem === void 0 ? void 0 : storeItem.zip, storeItem === null || storeItem === void 0 ? void 0 : storeItem.storeName);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "find-a-store__store-mobile find-a-store__store-bold",
                                                                children: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.email, " : ")
                                                            }),
                                                            storeItem === null || storeItem === void 0 ? void 0 : (ref2 = storeItem.email) === null || ref2 === void 0 ? void 0 : ref2.map((email, index)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "mailto:".concat(email),
                                                                    className: "find-a-store__store-email",
                                                                    children: "".concat(email).concat(index < storeItem.email.length - 1 ? ", " : "")
                                                                });
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "find-a-store__store-live-area find-a-store__store-bold",
                                                        children: [
                                                            "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.liveArea, " :"),
                                                            " ",
                                                            storeItem.liveArea ? "Yes" : "No"
                                                        ]
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                })
                            }, index)
                        });
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAStore_NoStoreAvailable, {
            staticTexts: staticTexts,
            error: error
        })
    });
};
/* harmony default export */ var FindAStore_StoreListing = (StoreListing);

// EXTERNAL MODULE: ./components/core/Autocomplete/Autocomplete.jsx
var Autocomplete = __webpack_require__(81511);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
;// CONCATENATED MODULE: ./i18n/useFindAStore.js

const useFindAStore = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        selectState: t("kf.findstore.label.selectState"),
        selectCity: t("kf.findstore.label.selectCity"),
        buy: t("kf.findstore.label.buy"),
        exclusive: t("kf.findstore.label.exclusive"),
        kohlerExperienceCenter: t("kf.findstore.label.kohlerExperienceCenter"),
        dealer: t("kf.findstore.label.dealer"),
        mbo: t("kf.findstore.label.mbo"),
        studioKohler: t("kf.findstore.label.studioKohler"),
        selectDropdown: t("kf.findstore.message.selectDropdown"),
        selectStateMessage: t("kf.findstore.message.selectState"),
        notInRegion: t("kf.findstore.message.notInRegion"),
        backToTop: t("kf.favorite.label.backToTop"),
        email: t("kf.share.label.email"),
        mobile: t("kf.findstore.message.mobile"),
        phone: t("kf.findstore.message.phone"),
        liveArea: t("kf.findstore.message.liveArea")
    };
    return i18n;
};
/* harmony default export */ var i18n_useFindAStore = (useFindAStore);

// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
;// CONCATENATED MODULE: ./components/FindAStore/ServiceLocatorListing.jsx






const ServiceLocatorListing = (props)=>{
    const { storeState , staticTexts , error , storeList  } = props;
    const [storeListArray, setStoreListArray] = (0,react.useState)(storeList);
    const getStoreList = ()=>{
        try {
            if (storeState) {
                const response = (0,findStore/* getStoresList */.yh)(storeState, undefined, true);
                response.then((resp)=>{
                    const { statusCode , result ={}  } = resp;
                    if (statusCode === 200) {
                        const res = result.data.stores;
                        setStoreListArray(res);
                    }
                    return {
                        statusCode
                    };
                });
            }
        } catch (error) {
            return {
                statusCode: 400,
                message: error.message
            };
        }
    };
    (0,react.useEffect)(()=>{
        getStoreList();
    }, [
        storeState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).findStoreLanding,
        children: storeListArray && storeListArray.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-a-store__store-city",
                    children: storeState
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "find-a-store__separator mb-20"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-a-store__collapsible",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "find-a-store__store-details row",
                        children: storeListArray === null || storeListArray === void 0 ? void 0 : storeListArray.map((storeItem, idx)=>{
                            var ref, ref1, ref2;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "find-a-store__store-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "find-a-store__store-name",
                                        children: storeItem.storeName.toUpperCase()
                                    }),
                                    (storeItem === null || storeItem === void 0 ? void 0 : storeItem.storeOwnerName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "find-a-store__store-owner-name",
                                        children: "".concat(storeItem === null || storeItem === void 0 ? void 0 : storeItem.storeOwnerName, ",")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "find-a-store__store-address-primary",
                                        children: storeItem.addressLine1
                                    }),
                                    storeItem.addressLine2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "find-a-store__store-address-secondary",
                                        children: storeItem.addressLine2
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "find-a-store__store-address-zone",
                                        children: [
                                            storeItem.city,
                                            ", ",
                                            storeItem.state,
                                            " - ",
                                            storeItem.zip
                                        ]
                                    }),
                                    (storeItem === null || storeItem === void 0 ? void 0 : storeItem.mobile.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: ()=>{
                                            return contactClickAnalytics(storeItem === null || storeItem === void 0 ? void 0 : storeItem.mobile[0], storeItem === null || storeItem === void 0 ? void 0 : storeItem.zip, storeItem === null || storeItem === void 0 ? void 0 : storeItem.storeName);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "find-a-store__store-mobile find-a-store__store-bold",
                                                children: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.mobile, " : ")
                                            }),
                                            storeItem === null || storeItem === void 0 ? void 0 : (ref = storeItem.mobile) === null || ref === void 0 ? void 0 : ref.map((mobile, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "tel:".concat(mobile),
                                                    className: "find-a-store__store-mobile find-a-store__store-bold",
                                                    children: "".concat(mobile).concat(index < storeItem.mobile.length - 1 ? ", " : "")
                                                });
                                            })
                                        ]
                                    }),
                                    (storeItem === null || storeItem === void 0 ? void 0 : storeItem.phone.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "find-a-store__store-mobile find-a-store__store-bold",
                                                children: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.phone, " : ")
                                            }),
                                            storeItem === null || storeItem === void 0 ? void 0 : (ref1 = storeItem.phone) === null || ref1 === void 0 ? void 0 : ref1.map((phone, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "tel:".concat(phone),
                                                    className: "find-a-store__store-mobile find-a-store__store-bold",
                                                    children: "".concat(phone).concat(index < storeItem.phone.length - 1 ? ", " : "")
                                                });
                                            })
                                        ]
                                    }),
                                    storeItem.email.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: ()=>{
                                            return emailClickAnalytics(storeItem === null || storeItem === void 0 ? void 0 : storeItem.email[0], storeItem === null || storeItem === void 0 ? void 0 : storeItem.zip, storeItem === null || storeItem === void 0 ? void 0 : storeItem.storeName);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "find-a-store__store-mobile find-a-store__store-bold",
                                                children: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.email, " : ")
                                            }),
                                            storeItem === null || storeItem === void 0 ? void 0 : (ref2 = storeItem.email) === null || ref2 === void 0 ? void 0 : ref2.map((email, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "mailto:".concat(email),
                                                    className: "find-a-store__store-email",
                                                    children: "".concat(email).concat(index < storeItem.email.length - 1 ? ", " : "")
                                                });
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "find-a-store__store-live-area find-a-store__store-bold",
                                        children: [
                                            "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.liveArea, " :"),
                                            " ",
                                            storeItem.liveArea ? "Yes" : "No"
                                        ]
                                    })
                                ]
                            }, idx);
                        })
                    })
                }),
                " "
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAStore_NoStoreAvailable, {
            staticTexts: staticTexts,
            error: error
        })
    });
};
/* harmony default export */ var FindAStore_ServiceLocatorListing = (ServiceLocatorListing);

;// CONCATENATED MODULE: ./components/FindAStore/FindAStore.jsx












const FindAStore = (props)=>{
    const { stateWithCities , data: { isservicelocator =false  }  } = props;
    const staticTexts = i18n_useFindAStore();
    const [stateChange, setStateChange] = (0,react.useState)("");
    const [cityChange, setCityChange] = (0,react.useState)("");
    const [listData, setListData] = (0,react.useState)(null);
    const [cityList, setCityList] = (0,react.useState)([]);
    const [errorMessage, setErrorMessage] = (0,react.useState)(null);
    const [storeList, setServerList] = (0,react.useState)(null);
    const [backToTopButton, setBackToTopButton] = (0,react.useState)(false);
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        setListData(stateWithCities);
        getLocation();
        backToTop();
    }, [
        isSsr
    ]);
    const getLocation = async ()=>{
        const zipcode = await (0,findStore/* reverseGeo */.Kh)();
        if (zipcode) {
            let details = {
                state: "",
                city: ""
            };
            let result;
            let storeList = [];
            const resp = await (0,findStore/* getDetailsFromZipCode */.k_)(zipcode);
            if (resp !== 400) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                var ref8;
                details = {
                    state: (resp === null || resp === void 0 ? void 0 : (ref = resp.result) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.state) ? (resp === null || resp === void 0 ? void 0 : (ref2 = resp.result) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.state) === "Tamil Nadu" ? "Tamilnadu" : resp === null || resp === void 0 ? void 0 : (ref4 = resp.result) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.state : "",
                    city: (ref8 = resp === null || resp === void 0 ? void 0 : (ref6 = resp.result) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.city) !== null && ref8 !== void 0 ? ref8 : ""
                };
                result = await (0,findStore/* getStoresList */.yh)(details === null || details === void 0 ? void 0 : details.state, details === null || details === void 0 ? void 0 : details.city, isservicelocator);
                var _stores;
                storeList = (_stores = result.result.data.stores) !== null && _stores !== void 0 ? _stores : [];
                setStateChange(details.state);
                setCityChange(details.city);
                if (storeList.length === 0) {
                    const error = staticTexts.notInRegion;
                    setErrorMessage(error);
                } else {
                    setStateChange(details.state);
                    setCityChange(details.city);
                    setServerList(storeList);
                }
            } else {
                const error1 = isservicelocator ? staticTexts.selectStateMessage : staticTexts.selectDropdown;
                setErrorMessage(error1);
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (listData) {
            var ref, ref1;
            const validData = listData.indexOf(listData.find((states)=>{
                var ref;
                return (states === null || states === void 0 ? void 0 : (ref = states.stateName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (stateChange === null || stateChange === void 0 ? void 0 : stateChange.toLowerCase());
            }));
            var ref2;
            let data = validData > -1 ? (ref2 = (ref = listData.at(validData)) === null || ref === void 0 ? void 0 : (ref1 = ref.cityName) === null || ref1 === void 0 ? void 0 : ref1.map((data)=>{
                return {
                    name: data
                };
            })) !== null && ref2 !== void 0 ? ref2 : [] : [];
            const isCity = data.some((ele)=>ele.name === cityChange);
            if (cityChange && !isCity) data = [
                ...data,
                {
                    name: cityChange
                }
            ];
            setCityList(data);
        }
    }, [
        stateChange
    ]);
    const backToTop = ()=>{
        window.addEventListener("scroll", ()=>{
            if (window.scrollY > 100) {
                setBackToTopButton(true);
            } else {
                setBackToTopButton(false);
            }
        });
    };
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        backToTopAnalytics();
    };
    var ref;
    const dataList = (ref = listData === null || listData === void 0 ? void 0 : listData.map((states)=>{
        return {
            name: states === null || states === void 0 ? void 0 : states.stateName
        };
    })) !== null && ref !== void 0 ? ref : [];
    const handleStateChange = async (value)=>{
        setStateChange(value);
        setServerList([]);
        if (stateChange !== value) {
            setCityChange("");
        }
        stateSelectionAnalytics(value);
        const error = isservicelocator ? staticTexts.selectStateMessage : staticTexts.selectDropdown;
        setErrorMessage(error);
    };
    const handleCityChange = async (value)=>{
        setCityChange(value);
        if (value !== cityChange) setServerList([]);
        if (value === "") {
            const error = staticTexts.selectDropdown;
            setErrorMessage(error);
        }
        if (listData) {
            var ref, ref1;
            const validData = listData.indexOf(listData.find((states)=>{
                var ref;
                return (states === null || states === void 0 ? void 0 : (ref = states.stateName) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (stateChange === null || stateChange === void 0 ? void 0 : stateChange.toLowerCase());
            }));
            var ref2;
            let data = validData > -1 ? (ref2 = (ref = listData.at(validData)) === null || ref === void 0 ? void 0 : (ref1 = ref.cityName) === null || ref1 === void 0 ? void 0 : ref1.map((data)=>{
                return {
                    name: data
                };
            })) !== null && ref2 !== void 0 ? ref2 : [] : [];
            setCityList(data);
            citySelectionAnalytics(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).findStoreLanding,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "find-a-store__margin",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "find-a-store__container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "find-a-store__content find-a-store__flex-column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "find-a-store__section",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "find-a-store__topic",
                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.buy
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "find-a-store__selection",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "find-a-store__select-dropdown",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                                                        id: "find-a-store-select-state",
                                                        onChange: handleStateChange,
                                                        value: stateChange,
                                                        data: dataList,
                                                        label: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.selectState
                                                    })
                                                }),
                                                !isservicelocator ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "find-a-store__select-dropdown",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                                                        id: "find-a-store-select-city",
                                                        onChange: handleCityChange,
                                                        value: cityChange,
                                                        data: cityList,
                                                        label: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.selectCity
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                !isservicelocator ? stateChange && cityChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAStore_StoreListing, {
                                    storeCity: cityChange,
                                    storeState: stateChange,
                                    staticTexts: staticTexts,
                                    storeList: storeList,
                                    setError: ()=>{
                                        const error = staticTexts.selectDropdown;
                                        setErrorMessage(error);
                                    },
                                    error: errorMessage
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAStore_NoStoreAvailable, {
                                    staticTexts: staticTexts,
                                    error: errorMessage,
                                    isServiceLocator: false
                                }) : stateChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAStore_ServiceLocatorListing, {
                                    storeState: stateChange,
                                    staticTexts: staticTexts,
                                    storeList: storeList,
                                    setError: ()=>{
                                        const error = staticTexts.selectStateMessage;
                                        setErrorMessage(error);
                                    },
                                    error: errorMessage
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindAStore_NoStoreAvailable, {
                                    staticTexts: staticTexts,
                                    error: errorMessage,
                                    isServiceLocator: true
                                })
                            ]
                        })
                    })
                }),
                backToTopButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "find-a-store__back-to-top",
                    onClick: scrollToTop,
                    children: [
                        "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.backToTop),
                        " ↑"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var FindAStore_FindAStore = (FindAStore);


/***/ }),

/***/ 30534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v3_ProductAccordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./public/icons/arrow-down.svg
var arrow_down = __webpack_require__(32873);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordion/ProductAccordion.view.js








const Accordion = (props)=>{
    const { isOpen =false , contentOverflow =false , trigger =false , handleOpen , handleClose , containerElementProps , isArrow =false , items , itemsOrder , id , titleKey , componentPosition , componentLinkType , accordionProperties: { expandedItems =[]  } = {}  } = props;
    const [isExpanded, setisExpanded] = (0,react.useState)(true);
    const [general, setGeneral] = (0,react.useState)(null);
    const accordiumObject = (0,react.useRef)(null);
    const hostRef = (0,react.useRef)(null);
    const [hydrated, setHydrated] = (0,react.useState)(true);
    const [pageType, setPageType] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (!hydrated) return;
        const root = hostRef.current;
        if (!root) return;
        root.querySelectorAll(".Collapsible__contentOuter").forEach((el)=>{
            el.style.setProperty("height", "auto", "important");
            el.style.setProperty("overflow", "visible", "important");
        });
        root.querySelectorAll(".Collapsible__contentInner").forEach((el)=>{
            el.style.setProperty("opacity", "1", "important");
            el.style.setProperty("visibility", "visible", "important");
        });
    }, [
        hydrated
    ]);
    (0,react.useEffect)(()=>{
        setPageType( true ? window.eventPageType || "" : 0);
        setHydrated( true ? false : 0);
    }, []);
    const handleAccordion = ()=>{
        setisExpanded(true);
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(function() {
            let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    const CollapsibleHeader = (param)=>/*#__PURE__*/ {
        let { title , open =false  } = param;
        return (0,jsx_runtime.jsx)("h2", {
            className: "cmp-accordion__header",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "cmp-accordion__button ".concat(open ? "cmp-accordion__button--expanded" : ""),
                onClick: handleAccordion,
                ...pageType ? {
                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(componentPosition || "accordion", '",\n              "internalLinkZoneName":"n/a","internalLinkURL":"n/a","internalLinkName":"').concat((title || "").toLowerCase(), '",\n              "eventName":"').concat(pageType.toLowerCase(), ":").concat((title || "").toLowerCase(), '",\n              "internalLinkType":"').concat(pageType.toLowerCase(), ":").concat(componentLinkType || "navigation", '",\n              "eventType":"accordion",\n              "eventAction":"').concat(pageType.toLowerCase(), ":").concat((title || "").toLowerCase(), '"}')
                } : {},
                "aria-expanded": open,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "heading",
                        "aria-level": "5",
                        className: "cmp-accordion__title",
                        children: title
                    }),
                    !isArrow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-2"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "down-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_down/* default.src */.Z.src,
                                    alt: "Arrow Down"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "up-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_up/* default.src */.Z.src,
                                    alt: "Arrow Up"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    const CollapsibleInnerText = (param)=>{
        let { gridColumnClassName , faqText , title  } = param;
        let finalText;
        if (pageType) {
            finalText = (0,helper.sanitizeInnerHtml)((0,helper.getShortenedUrlwithGeneral)(faqText, general));
        } else {
            finalText = (0,helper.sanitizeInnerHtml)(faqText);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-accordian-title": title,
            className: "cmp-accordion__panel".concat(isExpanded ? " cmp-accordion__panel--expanded" : " cmp-accordion__panel--hidden"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text ".concat(gridColumnClassName),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cmp-text",
                    children: finalText
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        ref: accordiumObject,
        className: "cmp-accordion",
        "data-placeholder-text": "false",
        children: itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((item, i)=>{
            const title = items[item][titleKey];
            let gridColumnClassName = items[item]["appliedCssClassNames"];
            let faqText = items[item]["text"];
            if (!faqText) {
                faqText = "";
                const itemsOrderArr = items[item][":itemsOrder"];
                if (itemsOrderArr) {
                    itemsOrderArr.forEach((itemTx)=>{
                        faqText = "".concat(faqText).concat(items[item][":items"][itemTx]["text"]);
                        gridColumnClassName = "".concat(items[item][":items"][itemTx]["appliedCssClassNames"]);
                    });
                }
            }
            var ref;
            const isItemExpanded = (ref = expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems.includes(item)) !== null && ref !== void 0 ? ref : isOpen;
            const collapsibleKey = "faq-".concat(i, "-").concat(!hydrated ? "client" : "ssr");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-cmp-hook-accordion": "item",
                    className: "cmp-accordion__item",
                    id: "accordion-".concat(i),
                    "data-cmp-data-layer": '{"accordion-'.concat(i, '}":{"@type":"kohler-us/components/accordion/item","dc:title":"').concat(title, '"}}'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        open: hydrated || isItemExpanded,
                        onTriggerOpening: handleOpen,
                        onTriggerClosing: handleClose,
                        containerElementProps: containerElementProps,
                        overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                        openedClassName: "collapsible--open",
                        tabIndex: "0",
                        triggerOpenedClassName: "collapsible__trigger--open",
                        trigger: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title
                        }),
                        triggerWhenOpen: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title,
                            open: true
                        }),
                        transitionTime: hydrated ? 0 : 400,
                        easing: "ease-in-out",
                        triggerElementProps: {
                            id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                        },
                        contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleInnerText, {
                            gridColumnClassName: gridColumnClassName,
                            faqText: faqText,
                            title: title
                        })
                    }, collapsibleKey)
                })
            }, "accordion-".concat(i));
        })
    });
};
/* harmony default export */ var ProductAccordion_view = (Accordion);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx


const ProductAccordion = (props)=>{
    const { data: { accordionProperties ={} , componentLinkType =""  }  } = props;
    const { [":itemsOrder"]: itemsOrder , [":items"]: items , id  } = accordionProperties;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "accordion  ".concat(accordionProperties === null || accordionProperties === void 0 ? void 0 : accordionProperties.appliedCssClassNames, " productAccordionView"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion_view, {
            accordionProperties: accordionProperties,
            componentLinkType: componentLinkType,
            items: items,
            itemsOrder: itemsOrder,
            id: id,
            textKey: "text",
            titleKey: "cq:panelTitle",
            contentOverflow: "visible"
        })
    });
};
/* harmony default export */ var v3_ProductAccordion = (ProductAccordion);


/***/ }),

/***/ 90864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductEnquiry_ProductEnquiryView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ProductEnquiry/ProductEnquiryView/index.module.scss
var index_module = __webpack_require__(83468);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./i18n/useProductEnquiryi18n.js


const useProductEnquiry = (authorData)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    var ref;
    const i18n = {
        mainTitle: (authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryTitle) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryTitle.replaceAll("&amp;nbsp;", " ")) : t("kf.productEnquiry.main.title"),
        requiredInfoText: (authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryFormDescription) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryFormDescription.replaceAll("&amp;nbsp;", " ")) : t("kf.customerSupport.label.requiredFields"),
        addMobileNumber: (authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryText) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryText.replaceAll("&amp;nbsp;", " ")) : t("kf.productEnquiry.addMobileNumber"),
        enquiryTitle: t("kf.productEnquiry.main.enquiryTitle"),
        mobileNumber: t("kf.productEnquiry.mobileNumber"),
        alternateMobileNumber: t("kf.productEnquiry.alternateMobileNumber"),
        firstName: t("kf.productEnquiry.firstName"),
        lastName: t("kf.productEnquiry.lastName"),
        email: t("kf.dealershipEnquiry.emailAddress"),
        pinCode: t("kf.productEnquiry.pinCode"),
        firstNameError: t("kf.productEnquiry.error.firstName"),
        lastNameError: t("kf.productEnquiry.error.lastName"),
        errorPincode: t("kf.customerSupport.error.pincode"),
        errorSelectBox: t("kf.enquire.error.selectdropdown"),
        planToStartLabel: t("kf.enquire.select.plantostart"),
        commentsLabel: t("kf.enquire.comments"),
        planningLabel: t("kf.enquire.select.planning"),
        pincodeValid: t("kf.customerSupport.error.pincodeValid"),
        pincodeNotValid: t("kf.customerSupport.error.pincodeNotValid"),
        privacyText: (authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryPrivacyPolicyText) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryPrivacyPolicyText.replaceAll("&amp;nbsp;", " ")) : t("kf.productEnquiry.privacyText"),
        submit: t("kf.customerSupport.label.submit"),
        cancel: t("kf.customerSupport.label.cancel"),
        messageDescriptionSuccess: (authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryConfirmationText) ? authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryConfirmationText : t("kf.productEnquiry.messageDescriptionSuccess"),
        backToHomePage: (authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryConfirmationCtaLabel) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryConfirmationCtaLabel.replaceAll("&amp;nbsp;", " ")) : t("kf.productEnquiry.backToHomePage"),
        errorMobileNumber: t("kf.customerSupport.error.validMobileNumber"),
        emailId: t("kf.contactus.label.emailAddress"),
        validEmailId: t("kf.contactus.error.validEmail"),
        provideEmailError: t("kf.contactus.error.noEmailError"),
        verifyNumber: (authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryMobilePlaceholderDescription) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryMobilePlaceholderDescription.replaceAll("&amp;nbsp;", " ")) : t("kf.customerSupport.message.verifyPhone"),
        numberIsVerified: (authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryOtpDescription) ? (0,html_react_parser/* default */.ZP)(authorData === null || authorData === void 0 ? void 0 : authorData.productEnquiryOtpDescription.replaceAll("&amp;nbsp;", " ")) : t("kf.customerSupport.mobileVerified"),
        productEnqBannerText: (ref = authorData === null || authorData === void 0 ? void 0 : authorData.productEnqBannerText) !== null && ref !== void 0 ? ref : ""
    };
    return i18n;
};
/* harmony default export */ var useProductEnquiryi18n = (useProductEnquiry);

// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./public/icons/edit.svg
var edit = __webpack_require__(62617);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./utils/validate.js
var validate = __webpack_require__(45648);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./utils/enquiry.js
var enquiry = __webpack_require__(55754);
// EXTERNAL MODULE: ./components/Shared/Otp/v1/index.jsx + 1 modules
var v1 = __webpack_require__(30834);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./i18n/useAuthModali18n.js
var useAuthModali18n = __webpack_require__(20234);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./components/ProductEnquiry/analytics.js
var analytics = __webpack_require__(75668);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/ProductEnquiry/Form/ProductEnquiry.jsx


















const ProductEnquiry = (props)=>{
    var ref;
    const { staticText , setConfirmationSuccess  } = props;
    const { authModal: { staticTextPopup  } = {} , isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const dispatch = (0,es/* useDispatch */.I0)();
    const i18n = (0,useAuthModali18n/* default */.Z)(staticTextPopup);
    const [verifiedMobileNumber, setVerifiedMobileNumber] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)({});
    const [verifyOTP, setVerifyOTP] = (0,react.useState)(false);
    const [changeNumber, setChangeNumber] = (0,react.useState)(false);
    const [userDetails, setUserDetails] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const [data, setData] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        if (isAuth) {
            setVerifiedMobileNumber(true);
            let dataInitialValue = {
                firstName: get_default()(user, "firstName", ""),
                phone: get_default()(user, "login", ""),
                lastName: get_default()(user, "lastName", ""),
                email: get_default()(user, "sub", ""),
                pincode: "",
                alternativePhone: ""
            };
            setData(dataInitialValue);
        }
    }, [
        isAuth,
        verifiedMobileNumber
    ]);
    const onNameChange = (e)=>{
        const { name , value  } = e.target;
        if (value === "" || (0,validate/* validText */.WQ)(value)) {
            setData({
                ...data,
                [name]: value
            });
        }
    };
    const onChangeAlternatePhone = (e)=>{
        const { value  } = e.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                alternativePhone: value
            });
        }
    };
    const onChangePincode = (e)=>{
        const { value  } = e.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                pincode: value
            });
        }
        if (!(value === null || value === void 0 ? void 0 : value.trim())) setError({
            ...error,
            pincode: staticText === null || staticText === void 0 ? void 0 : staticText.errorPincode
        });
        else if ((value === null || value === void 0 ? void 0 : value.length) !== 6) setError({
            ...error,
            pincode: staticText === null || staticText === void 0 ? void 0 : staticText.pincodeValid
        });
    };
    const onBlur = (field)=>{
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const isValidNumber = constants.PHONE_REGEX.test(data === null || data === void 0 ? void 0 : data.phone);
    const validateExist = (field)=>{
        if (field === "firstName" || field === "lastName") {
            var ref;
            if (!((ref = data[field]) === null || ref === void 0 ? void 0 : ref.trim()) || !(0,helper.validateField)("name", data[field])) {
                return field === "firstName" ? staticText === null || staticText === void 0 ? void 0 : staticText.firstNameError : staticText === null || staticText === void 0 ? void 0 : staticText.lastNameError;
            } else return "";
        } else if (field === "pincode") {
            var ref1, ref2;
            if (!(data === null || data === void 0 ? void 0 : (ref1 = data.pincode) === null || ref1 === void 0 ? void 0 : ref1.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.errorPincode;
            else if ((data === null || data === void 0 ? void 0 : (ref2 = data.pincode) === null || ref2 === void 0 ? void 0 : ref2.length) !== 6) return staticText === null || staticText === void 0 ? void 0 : staticText.pincodeValid;
        } else if (field === "phone") {
            var ref3;
            if (!(data === null || data === void 0 ? void 0 : (ref3 = data.phone) === null || ref3 === void 0 ? void 0 : ref3.trim()) || !constants.PHONE_REGEX.test(data === null || data === void 0 ? void 0 : data.phone)) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.errorMobileNumber;
            }
        } else if (field === "emailId") {
            if (!data[field]) return "";
            else if (!(0,helper.validateField)("email", data[field]) || !(0,validate/* validateEmail */.oH)(data[field])) return staticText === null || staticText === void 0 ? void 0 : staticText.validEmailId;
        }
    };
    const handleSubmit = async ()=>{
        var ref;
        const errorList = getErrorList();
        const { sku , pname , id , ...rest } = router.query;
        let errorDataList = [];
        setError(errorList);
        if (errorList === null || errorList === void 0 ? void 0 : errorList.firstName) {
            errorDataList.push("firstName");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.lastName) {
            errorDataList.push("lastName");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.pincode) {
            errorDataList.push("pincode");
        }
        errorDataList.map((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            const { firstName , lastName , pincode , phone , email , alternativePhone  } = data;
            const payload = {
                firstName: firstName === null || firstName === void 0 ? void 0 : firstName.trim(),
                pincode: pincode,
                mobile: phone,
                lastName: lastName === null || lastName === void 0 ? void 0 : lastName.trim(),
                enquiryType: "product-enquiry",
                sku: sku !== null && sku !== void 0 ? sku : "",
                inRiver: id !== null && id !== void 0 ? id : "",
                productName: pname ? "".concat(pname, "&").concat(Object.keys(rest).join()) : "",
                email: email !== null && email !== void 0 ? email : "",
                atlernateNumber: alternativePhone
            };
            const utmParams = [
                "utm_source",
                "utm_content",
                "utm_medium",
                "utm_term",
                "utm_campaign"
            ];
            utmParams.forEach((param)=>{
                if (rest === null || rest === void 0 ? void 0 : rest[param]) {
                    payload[param] = decodeURIComponent(rest[param]);
                }
            });
            const response = await (0,enquiry/* submitProductEnquiry */.vn)(payload);
            if (response.statusCode === 200) {
                (0,analytics/* submitEnquiryAnalytics */.Fv)("success");
                setConfirmationSuccess(true);
                (0,helper.setBannerConfirmationText)(staticText.productEnqBannerText, "enquiry-form-banner");
                scrollToTop();
            } else {
                (0,analytics/* submitEnquiryAnalytics */.Fv)("failure", "form submission failed");
                setConfirmationSuccess(false);
                scrollToTop();
            }
        } else {
            (0,analytics/* submitEnquiryAnalytics */.Fv)("failure", "form validation failed");
        }
    };
    const handleResetData = ()=>{
        if (isAuth) {
            setData({
                ...data,
                alternativePhone: "",
                pincode: ""
            });
        } else {
            setData({});
        }
        setError({});
        setVerifiedMobileNumber(false);
        scrollToTop();
        (0,analytics/* cancelEnquiryAnalytics */.zc)();
    };
    const getErrorList = ()=>{
        const errorList = {
            firstName: validateExist("firstName"),
            lastName: validateExist("lastName"),
            pincode: validateExist("pincode"),
            phoneNumber: validateExist("phone"),
            emailId: validateExist("emailId")
        };
        return errorList;
    };
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            behavior: "smooth"
        });
    };
    const isEnabled = ((ref = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref === void 0 ? void 0 : ref.find((el)=>el)) || !verifiedMobileNumber ? true : false;
    const changeNumberHandler = async ()=>{
        setVerifyOTP(true);
        setChangeNumber(true);
    };
    const verifiedNumber = ()=>{
        setVerifiedMobileNumber(true);
        setVerifyOTP(false);
    };
    const getOTP = async ()=>{
        let { numberExists , factorId , userId  } = await (0,enquiry/* checkNumberExists */.gU)(data === null || data === void 0 ? void 0 : data.phone);
        const isBrandOrTransact = (0,utils/* isBrandTransact */.AY)();
        if (!isBrandOrTransact && numberExists && !isAuth) {
            dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
                show: true
            }));
        } else {
            if (isValidNumber) {
                setUserDetails({
                    factorId: factorId,
                    userId: userId
                });
                setVerifyOTP(true);
                setChangeNumber(false);
            } else {
                setVerifyOTP(false);
            }
        }
        (0,analytics/* getOtpAnalytics */.D2)();
    };
    const handleChangeNumber = (event)=>{
        const { value  } = event.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                phone: value
            });
            setError({
                ...error,
                phone: ""
            });
        }
    };
    const onChangeEmailId = (e)=>{
        const { value  } = e.target;
        setData({
            ...data,
            email: value
        });
        if (value) {
            if ((0,validate/* validateEmail */.oH)(value)) {
                setError({
                    ...error,
                    email: ""
                });
            } else {
                setError({
                    ...error,
                    email: staticText.validEmailId
                });
            }
        }
    };
    const setPhoneNumber = (phone)=>{
        setData({
            ...data,
            phone: phone
        });
    };
    var _phone, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-enquiry__margin-div",
        children: [
            !verifiedMobileNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-enquiry__phoneDiv",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-enquiry__countryIcon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "product-enquiry__countryField",
                            id: "contact-user-country-code",
                            type: "text",
                            disabled: true,
                            value: "+91"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-enquiry__phoneNumber",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            disabled: verifiedMobileNumber,
                            customClass: "product-enquiry__inputfield",
                            id: "contact-user-phone",
                            type: "text",
                            value: (_phone = data.phone) !== null && _phone !== void 0 ? _phone : "",
                            maxLength: 10,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                            onChange: handleChangeNumber,
                            showError: error === null || error === void 0 ? void 0 : error.phone,
                            errorMessage: error === null || error === void 0 ? void 0 : error.phone,
                            onBlur: ()=>onBlur("phone")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: getOTP,
                        style: isValidNumber ? {
                            cursor: "pointer"
                        } : {
                            cursor: "not-allowed"
                        },
                        className: "product-enquiry__getOTPLink ".concat(isValidNumber && "--active"),
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.getOTP
                    })
                ]
            }),
            verifiedMobileNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    customClass: "product-enquiry__phoneDivDisabled",
                    type: "text",
                    disabled: true,
                    value: "+91 ".concat(data === null || data === void 0 ? void 0 : data.phone),
                    placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                    label: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                    suffix: verifiedMobileNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: edit/* default */.Z === null || edit/* default */.Z === void 0 ? void 0 : edit/* default.src */.Z.src,
                        alt: "",
                        "aria-hidden": "true",
                        // onClick={!isAuth && changeNumberHandler}
                        style: {
                            cursor: "pointer"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(!verifiedMobileNumber && isValidNumber ? "product-enquiry__verifyNumberText --error" : "product-enquiry__verifyNumberText"),
                children: !verifiedMobileNumber ? staticText === null || staticText === void 0 ? void 0 : staticText.verifyNumber : staticText === null || staticText === void 0 ? void 0 : staticText.numberIsVerified
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pr-10 pl-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-fname",
                            type: "text",
                            customClass: "customer-support-inputfield",
                            value: (ref1 = data === null || data === void 0 ? void 0 : data.firstName) !== null && ref1 !== void 0 ? ref1 : "",
                            maxLength: 40,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.firstName,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.firstName,
                            onChange: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.firstName,
                            errorMessage: error === null || error === void 0 ? void 0 : error.firstName,
                            onBlur: ()=>onBlur("firstName"),
                            name: "firstName",
                            autoComplete: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-10 pr-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-lname",
                            type: "text",
                            customClass: "customer-support-inputfield",
                            value: (ref2 = data === null || data === void 0 ? void 0 : data.lastName) !== null && ref2 !== void 0 ? ref2 : "",
                            maxLength: 40,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.lastName,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.lastName,
                            onChange: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.lastName,
                            errorMessage: error === null || error === void 0 ? void 0 : error.lastName,
                            onBlur: ()=>onBlur("lastName"),
                            name: "lastName",
                            autoComplete: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "contact-user-emailId",
                type: "text",
                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.email,
                label: staticText === null || staticText === void 0 ? void 0 : staticText.email,
                value: (ref3 = data === null || data === void 0 ? void 0 : data.email) !== null && ref3 !== void 0 ? ref3 : "",
                onChange: onChangeEmailId,
                showError: error === null || error === void 0 ? void 0 : error.emailId,
                errorMessage: error === null || error === void 0 ? void 0 : error.emailId,
                maxLength: 60,
                onBlur: ()=>onBlur("emailId"),
                autoComplete: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-enquiry__phoneDiv",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-enquiry__countryIcon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "product-enquiry__countryField",
                            id: "contact-user-country-code",
                            type: "text",
                            disabled: true,
                            value: "+91"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-enquiry__phoneNumberAlternate",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "product-enquiry__inputfield",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.alternativePhone,
                            maxLength: 10,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.alternateMobileNumber,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.alternateMobileNumber,
                            onChange: onChangeAlternatePhone
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "contact-user-pincode",
                type: "text",
                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.pinCode,
                label: staticText === null || staticText === void 0 ? void 0 : staticText.pinCode,
                value: (ref4 = data === null || data === void 0 ? void 0 : data.pincode) !== null && ref4 !== void 0 ? ref4 : "",
                maxLength: 6,
                autoComplete: false,
                onChange: onChangePincode,
                showError: error === null || error === void 0 ? void 0 : error.pincode,
                errorMessage: error === null || error === void 0 ? void 0 : error.pincode,
                onBlur: ()=>onBlur("pincode")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-enquiry__privacyText",
                children: staticText === null || staticText === void 0 ? void 0 : staticText.privacyText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-enquiry__buttonDiv",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "black",
                        role: "button",
                        label: staticText.submit,
                        className: "product-enquiry__button",
                        flexible: true,
                        onClick: handleSubmit,
                        disabled: isEnabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "product-enquiry__button",
                        type: "ghost",
                        role: "button",
                        label: staticText.cancel,
                        flexible: true,
                        onClick: handleResetData
                    })
                ]
            }),
            verifyOTP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1/* default */.Z, {
                page: "place an enquiry",
                handleClose: ()=>setVerifyOTP(false),
                showModal: verifyOTP,
                staticTexts: staticText,
                mobile: data === null || data === void 0 ? void 0 : data.phone,
                verifiedNumber: verifiedNumber,
                changeMobileNumber: changeNumber,
                setDataEnquiry: (phoneNumber)=>setPhoneNumber(phoneNumber),
                userDetails: userDetails
            }) : null
        ]
    });
};
/* harmony default export */ var Form_ProductEnquiry = (ProductEnquiry);

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./components/ProductEnquiry/Confirmation.jsx





const Confirmation = (props)=>{
    const { staticText  } = props;
    const onClick = ()=>{
        window.location.href = "/";
        (0,analytics/* backToHomeAnalytics */.PK)(window.location.origin);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).productEnquiryLanding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-enquiry__success-box",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "product-enquiry__success-message",
                    children: staticText === null || staticText === void 0 ? void 0 : staticText.messageHeaderSuccess
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-enquiry__success-description",
                    dangerouslySetInnerHTML: {
                        __html: browser_default().sanitize(staticText === null || staticText === void 0 ? void 0 : staticText.messageDescriptionSuccess)
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        customClass: "kf-react-button",
                        className: "kf-react-button button large black flexible",
                        role: "button",
                        id: "submit-contact-form-button",
                        onClick: onClick,
                        type: "black",
                        label: staticText === null || staticText === void 0 ? void 0 : staticText.backToHomePage
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductEnquiry_Confirmation = (Confirmation);

// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
// EXTERNAL MODULE: ./components/core/TextArea/TextArea.jsx
var TextArea = __webpack_require__(29707);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/ProductEnquiry/Form/Enquiry.jsx
















const Enquiry = (props)=>{
    var ref, ref1, ref2;
    const { staticText , setConfirmationSuccess  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [error, setError] = (0,react.useState)({});
    const router = (0,next_router.useRouter)();
    const [data, setData] = (0,react.useState)({});
    const [comments, setComments] = (0,react.useState)("");
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* getGenericListPath */.Ln)()).then(()=>{
            dispatch((0,genericSlice/* getplanTimingList */.N1)());
            dispatch((0,genericSlice/* getplanTypeList */.bh)());
        });
    }, []);
    const generic = (0,es/* useSelector */.v9)((state)=>state.generic);
    const onNameChange = (e)=>{
        const { name , value  } = e.target;
        if (value === "" || (0,validate/* validText */.WQ)(value)) {
            setData({
                ...data,
                [name]: value
            });
        }
    };
    const onChangePincode = (e)=>{
        const { value  } = e.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                pincode: value
            });
        }
        if (!(value === null || value === void 0 ? void 0 : value.trim())) setError({
            ...error,
            pincode: staticText === null || staticText === void 0 ? void 0 : staticText.errorPincode
        });
        else if ((value === null || value === void 0 ? void 0 : value.length) !== 6) setError({
            ...error,
            pincode: staticText === null || staticText === void 0 ? void 0 : staticText.pincodeValid
        });
    };
    const onBlur = (field)=>{
        setError({
            ...error,
            [field]: validateExist(field)
        });
    };
    const validateExist = (field)=>{
        if (field === "firstName" || field === "lastName") {
            var ref;
            if (!((ref = data[field]) === null || ref === void 0 ? void 0 : ref.trim()) || !(0,helper.validateField)("name", data[field])) {
                return field === "firstName" ? staticText === null || staticText === void 0 ? void 0 : staticText.firstNameError : staticText === null || staticText === void 0 ? void 0 : staticText.lastNameError;
            } else return "";
        } else if (field === "pincode") {
            var ref1, ref2;
            if (!(data === null || data === void 0 ? void 0 : (ref1 = data.pincode) === null || ref1 === void 0 ? void 0 : ref1.trim())) return staticText === null || staticText === void 0 ? void 0 : staticText.errorPincode;
            else if ((data === null || data === void 0 ? void 0 : (ref2 = data.pincode) === null || ref2 === void 0 ? void 0 : ref2.length) !== 6) return staticText === null || staticText === void 0 ? void 0 : staticText.pincodeValid;
        } else if (field === "phone") {
            var ref3;
            if (!(data === null || data === void 0 ? void 0 : (ref3 = data.phone) === null || ref3 === void 0 ? void 0 : ref3.trim()) || !constants.PHONE_REGEX.test(data === null || data === void 0 ? void 0 : data.phone)) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.errorMobileNumber;
            }
        } else if (field === "emailId") {
            if (!data[field]) return staticText === null || staticText === void 0 ? void 0 : staticText.provideEmailError;
            else if (!(0,helper.validateField)("emailId", data[field]) || !(0,validate/* validateEmail */.oH)(data[field])) return staticText === null || staticText === void 0 ? void 0 : staticText.validEmailId;
            else {
                return "";
            }
        } else if (field === "planning" || field === "planStartsFrom") {
            if (!data[field]) {
                return staticText === null || staticText === void 0 ? void 0 : staticText.errorSelectBox;
            }
        }
    };
    const handleSubmit = async ()=>{
        var ref;
        const errorList = getErrorList();
        setIsLoading(true);
        const { id , ...rest } = router.query;
        let errorDataList = [];
        setError(errorList);
        if (errorList === null || errorList === void 0 ? void 0 : errorList.firstName) {
            errorDataList.push("firstName");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.lastName) {
            errorDataList.push("lastName");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.pincode) {
            errorDataList.push("pincode");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.planning) {
            errorDataList.push("planning");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.planStartsFrom) {
            errorDataList.push("planStartsFrom");
        }
        errorDataList.forEach((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object === null || Object === void 0 ? void 0 : Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            const { firstName , lastName , pincode , phone , emailId , planStartsFrom , planning , comments  } = data;
            const payload = {
                firstName: firstName === null || firstName === void 0 ? void 0 : firstName.trim(),
                pincode: pincode,
                mobile: phone,
                lastName: lastName === null || lastName === void 0 ? void 0 : lastName.trim(),
                enquiryType: "design-enquiry",
                email: emailId !== null && emailId !== void 0 ? emailId : "",
                plan: planning,
                planStartsFrom: planStartsFrom,
                comments: comments
            };
            const utmParams = [
                "utm_source",
                "utm_content",
                "utm_medium",
                "utm_term",
                "utm_campaign"
            ];
            utmParams.forEach((param)=>{
                if (rest === null || rest === void 0 ? void 0 : rest[param]) {
                    payload[param] = decodeURIComponent(rest[param]);
                }
            });
            const response = await (0,enquiry/* submitProductEnquiry */.vn)(payload);
            if (response.statusCode === 200) {
                (0,analytics/* submitEnquiryAnalytics */.Fv)("success");
                setConfirmationSuccess(true);
            } else {
                (0,analytics/* submitEnquiryAnalytics */.Fv)("failure", "form submission failed");
                setConfirmationSuccess(false);
            }
        } else {
            (0,analytics/* submitEnquiryAnalytics */.Fv)("failure", "form validation failed");
        }
        setIsLoading(false);
    };
    const getErrorList = ()=>{
        const errorList = {
            firstName: validateExist("firstName"),
            lastName: validateExist("lastName"),
            pincode: validateExist("pincode"),
            phoneNumber: validateExist("phone"),
            emailId: validateExist("emailId"),
            planning: validateExist("planning"),
            planStartsFrom: validateExist("planStartsFrom")
        };
        return errorList;
    };
    const isEnabled = ((ref = Object === null || Object === void 0 ? void 0 : Object.values(getErrorList())) === null || ref === void 0 ? void 0 : ref.find((el)=>el)) ? true : false;
    const handleChangeNumber = (event)=>{
        const { value  } = event.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setData({
                ...data,
                phone: value
            });
            setError({
                ...error,
                phone: ""
            });
        }
    };
    const onChangeEmailId = (e)=>{
        const { value  } = e.target;
        setData({
            ...data,
            emailId: value
        });
        if (value) {
            if ((0,validate/* validateEmail */.oH)(value)) {
                setError({
                    ...error,
                    emailId: null
                });
            } else {
                setError({
                    ...error,
                    emailId: staticText.validEmailId
                });
            }
        }
    };
    const handleSelectChange = (value, type)=>{
        setData({
            ...data,
            [type]: value
        });
        setError({
            ...error,
            [type]: false
        });
    };
    const handleSelectBlur = (type)=>{
        setError({
            ...error,
            [type]: !data[type]
        });
    };
    const handleChangeComments = async (value)=>{
        setComments(value);
        setData({
            ...data,
            comments: value
        });
    };
    var _phone, ref3, ref4, ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-enquiry__margin-div",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-enquiry__phoneDiv",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-enquiry__countryIcon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "product-enquiry__countryField",
                            id: "contact-user-country-code",
                            type: "text",
                            disabled: true,
                            value: "+91"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-enquiry__phoneNumber",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            customClass: "product-enquiry__inputfield",
                            id: "contact-user-phone",
                            type: "text",
                            value: (_phone = data.phone) !== null && _phone !== void 0 ? _phone : "",
                            maxLength: 10,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.mobileNumber,
                            onChange: handleChangeNumber,
                            showError: error === null || error === void 0 ? void 0 : error.phone,
                            errorMessage: error === null || error === void 0 ? void 0 : error.phone,
                            onBlur: ()=>onBlur("phone")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(lib/* isMobile */.tq || lib/* isTablet */.Em ? "pr-20" : "pr-0"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-fname",
                            type: "text",
                            customClass: "customer-support-inputfield",
                            value: (ref3 = data === null || data === void 0 ? void 0 : data.firstName) !== null && ref3 !== void 0 ? ref3 : "",
                            maxLength: 40,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.firstName,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.firstName,
                            onChange: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.firstName,
                            errorMessage: error === null || error === void 0 ? void 0 : error.firstName,
                            onBlur: ()=>onBlur("firstName"),
                            name: "firstName",
                            autoComplete: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(lib/* isMobile */.tq || lib/* isTablet */.Em ? "pl-0" : "pl-20"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-lname",
                            type: "text",
                            customClass: "customer-support-inputfield",
                            value: (ref4 = data === null || data === void 0 ? void 0 : data.lastName) !== null && ref4 !== void 0 ? ref4 : "",
                            maxLength: 40,
                            placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.lastName,
                            label: staticText === null || staticText === void 0 ? void 0 : staticText.lastName,
                            onChange: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.lastName,
                            errorMessage: error === null || error === void 0 ? void 0 : error.lastName,
                            onBlur: ()=>onBlur("lastName"),
                            name: "lastName",
                            autoComplete: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "contact-user-emailId",
                type: "text",
                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.email,
                label: staticText === null || staticText === void 0 ? void 0 : staticText.email,
                value: (ref5 = data === null || data === void 0 ? void 0 : data.emailId) !== null && ref5 !== void 0 ? ref5 : "",
                onChange: onChangeEmailId,
                onInput: onChangeEmailId,
                showError: (error === null || error === void 0 ? void 0 : error.emailId) !== "" && (error === null || error === void 0 ? void 0 : error.emailId),
                errorMessage: error === null || error === void 0 ? void 0 : error.emailId,
                onBlur: ()=>onBlur("emailId"),
                autoComplete: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                id: "contact-user-pincode",
                type: "text",
                placeholder: staticText === null || staticText === void 0 ? void 0 : staticText.pinCode,
                label: staticText === null || staticText === void 0 ? void 0 : staticText.pinCode,
                value: (ref6 = data === null || data === void 0 ? void 0 : data.pincode) !== null && ref6 !== void 0 ? ref6 : "",
                maxLength: 6,
                autoComplete: false,
                onChange: onChangePincode,
                showError: error === null || error === void 0 ? void 0 : error.pincode,
                errorMessage: error === null || error === void 0 ? void 0 : error.pincode,
                onBlur: ()=>onBlur("pincode")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-0 pb-20 ".concat(lib/* isMobile */.tq || lib/* isTablet */.Em ? "pr-20" : "pr-0"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            label: staticText.planToStartLabel,
                            data: (ref1 = generic["planTimingList"]) === null || ref1 === void 0 ? void 0 : ref1.map((value)=>value["value"]),
                            value: data === null || data === void 0 ? void 0 : data.planStartsFrom,
                            onChange: (val)=>handleSelectChange(val, "planStartsFrom"),
                            onBlur: ()=>handleSelectBlur("planStartsFrom"),
                            showError: error === null || error === void 0 ? void 0 : error.planStartsFrom,
                            errorMessage: staticText.errorSelectBox,
                            id: "planStartsFrom"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pr-0 pb-20 ".concat(lib/* isMobile */.tq || lib/* isTablet */.Em ? "pl-0" : "pl-20"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            label: staticText.planningLabel,
                            data: (ref2 = generic["planTypeList"]) === null || ref2 === void 0 ? void 0 : ref2.map((value)=>value["value"]),
                            value: data.planning,
                            onChange: (val)=>handleSelectChange(val, "planning"),
                            onBlur: ()=>handleSelectBlur("planning"),
                            showError: error === null || error === void 0 ? void 0 : error.planning,
                            errorMessage: staticText.errorSelectBox,
                            id: "planning"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "enquiry__formtextarea",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                    label: staticText.commentsLabel,
                    placeholder: staticText.commentsLabel,
                    onChange: (e)=>handleChangeComments(e.target.value),
                    value: comments,
                    className: "enquiry__textarea",
                    maxLength: "250"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-enquiry__privacyText",
                children: staticText === null || staticText === void 0 ? void 0 : staticText.privacyText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-enquiry__buttonDiv",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "black",
                    role: "button",
                    label: staticText.submit,
                    className: "product-enquiry__button",
                    flexible: true,
                    onClick: handleSubmit,
                    disabled: isEnabled,
                    loading: isLoading
                })
            })
        ]
    });
};
/* harmony default export */ var Form_Enquiry = (Enquiry);

;// CONCATENATED MODULE: ./components/ProductEnquiry/ProductEnquiryView/index.jsx








const ProductEnquiryView = (props)=>{
    const { data: authorData = {}  } = props;
    const confirmationRef = (0,react.useRef)(null);
    const staticText = useProductEnquiryi18n(authorData);
    const [confirmationSuccess, setConfirmationSuccess] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        const scrollToTop = ()=>{
            window.scroll({
                top: 0,
                behavior: "smooth"
            });
        };
        if (confirmationSuccess) {
            if (authorData["isEnquiry"]) {
                confirmationRef.current.scrollIntoView({
                    behaviour: "smooth",
                    block: "center"
                });
            } else {
                scrollToTop();
            }
        }
    }, [
        confirmationSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !confirmationSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default()).productEnquiryLanding,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: authorData["isEnquiry"] ? "product-enquiry enquiry" : "product-enquiry",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-enquiry__title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "product-enquiry__heading",
                                    children: authorData["isEnquiry"] ? staticText.enquiryTitle : staticText.mainTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product-enquiry__required-fields",
                                    children: staticText.requiredInfoText
                                })
                            ]
                        }),
                        !authorData["isEnquiry"] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_ProductEnquiry, {
                            staticText: staticText,
                            setConfirmationSuccess: setConfirmationSuccess
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Enquiry, {
                            staticText: staticText,
                            setConfirmationSuccess: setConfirmationSuccess
                        })
                    ]
                })
            }),
            confirmationSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: confirmationRef,
                className: (index_module_default()).productEnquiryLanding,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-enquiry",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductEnquiry_Confirmation, {
                        staticText: staticText
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProductEnquiry_ProductEnquiryView = (ProductEnquiryView);


/***/ }),

/***/ 75668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ getOtpAnalytics; },
/* harmony export */   "Fv": function() { return /* binding */ submitEnquiryAnalytics; },
/* harmony export */   "M2": function() { return /* binding */ breadcrumbAnalytics; },
/* harmony export */   "PK": function() { return /* binding */ backToHomeAnalytics; },
/* harmony export */   "zc": function() { return /* binding */ cancelEnquiryAnalytics; }
/* harmony export */ });
/* unused harmony export editMobileAnalytics */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);

const pageType = "place an enquiry";
const componentType = "product enquiry";
const breadcrumbAnalytics = (navItem)=>{
    const link = (navItem === null || navItem === void 0 ? void 0 : navItem.url) ? (navItem.url.indexOf("http") === -1 ? window.location.origin : "") + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.removeAndCleanLinkConcat)(navItem.url) : "n/a";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":hero banner:breadcrumb"),
        eventName: "".concat(pageType, ":hero banner:breadcrumb"),
        eventType: "navigation",
        internalLinkName: "home",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":breadcrumb"),
        internalLinkZoneName: "".concat(pageType, ":hero banner"),
        internalLinkURL: link
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getOtpAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(componentType, ":form:get otp"),
        eventName: "".concat(pageType, ":").concat(componentType, ":form:get otp"),
        eventType: "navigation",
        internalLinkName: "get otp",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":").concat(componentType, ":form"),
        internalLinkURL: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const editMobileAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(componentType, ":form:mobile number:edit"),
        eventName: "".concat(pageType, ":").concat(componentType, ":form:mobile number:edit"),
        eventType: "navigation",
        internalLinkName: "edit",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":").concat(componentType),
        internalLinkZoneName: "".concat(pageType, ":").concat(componentType, ":form:mobile number"),
        internalLinkURL: "n/a"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const submitEnquiryAnalytics = (status, statusMsg)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(componentType, ":form:submit"),
        eventName: "".concat(pageType, ":").concat(componentType, ":form:submit"),
        eventStatus: status,
        eventMsg: statusMsg !== null && statusMsg !== void 0 ? statusMsg : "n/a",
        eventType: "navigation",
        internalLinkName: "submit",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":").concat(componentType, ":form"),
        internalLinkURL: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const cancelEnquiryAnalytics = ()=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(componentType, ":form:cancel"),
        eventName: "".concat(pageType, ":").concat(componentType, ":form:cancel"),
        eventType: "navigation",
        internalLinkName: "cancel",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":").concat(componentType, ":form"),
        internalLinkURL: "n/a"
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};
const backToHomeAnalytics = (link)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(componentType, ":back to homepage"),
        eventName: "".concat(pageType, ":").concat(componentType, ":back to homepage"),
        eventType: "navigation",
        internalLinkName: "back to homepage",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkZoneName: "".concat(pageType, ":").concat(componentType),
        internalLinkURL: link
    };
    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.pushAnalyticsObjToDataLayer)(eventInfo);
};


/***/ }),

/***/ 54341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_Filter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./public/icons/print.svg
var print = __webpack_require__(30402);
// EXTERNAL MODULE: ./public/icons/share.svg
var share = __webpack_require__(66773);
;// CONCATENATED MODULE: ./public/icons/close-filter.svg
/* harmony default export */ var close_filter = ({"src":"/_next/static/media/close-filter.e8101cbe.svg","height":17,"width":17});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
// EXTERNAL MODULE: ./src/components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(94593);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
;// CONCATENATED MODULE: ./components/ProductList/v2/Filter/helper.js

const setUrlParams = function(filters, isReplace, type, facetLabels, resetTitle) {
    let clearAllFilters = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : ()=>{}, attributeName = arguments.length > 6 ? arguments[6] : void 0;
    let query = window.location.search;
    if (query.length && !query.includes("tab") && type) query += isReplace ? "" : "".concat(query.includes("?") ? "&" : "?", "tab=").concat(type);
    filters = filters.filter((f)=>f.facet !== attributeName);
    if (filters.length > 0) {
        query += query ? "&" : "";
        filters.forEach((filter, i)=>{
            var ref;
            const values = [
                ...filter.value
            ];
            const searches = location.search.split("&");
            const index = searches.findIndex((search)=>search.includes(filter.facet));
            if (index > -1) {
                searches.splice(index, 1);
                query = searches.join("&");
                query += query ? "&" : "";
            }
            if (values.length !== 0 && filter.facet === "Price_Range" ? true : facetLabels[(ref = filter.facet) === null || ref === void 0 ? void 0 : ref.replace(/^\*{2}/, "")]) {
                var ref1, ref2;
                var ref3;
                query += "".concat(filter.facet === "Price_Range" ? filter.facet : (ref3 = (ref2 = facetLabels[(ref1 = filter.facet) === null || ref1 === void 0 ? void 0 : ref1.replace(/^\*{2}/, "")]) === null || ref2 === void 0 ? void 0 : ref2.replace(/ /g, "_")) !== null && ref3 !== void 0 ? ref3 : filter.facet, "=").concat(filter.facet === "Price_Range" ? filter.value : encodeURIComponent(values)).concat(i !== filters.length - 1 ? "&" : "");
            }
        });
        if (resetTitle) resetTitle();
    } else {
        clearAllFilters(false);
    }
    const queryStr = query.toString();
    const queryParam = queryStr.length === 0 ? window.location.pathname : queryStr.includes("?") ? queryStr : "?".concat(queryStr);
    query && window.history.replaceState(window.location.pathname, document.title, queryParam);
    if (type) (0,helper.retainSearchQueryParams)(type);
};
const getAppliedFiltersForAnalytics = (appliedFilters, facetLabels)=>{
    const filterArray = [];
    appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.forEach((filter)=>{
        var ref;
        filter === null || filter === void 0 ? void 0 : (ref = filter.display) === null || ref === void 0 ? void 0 : ref.forEach((filtervalue)=>{
            filterArray === null || filterArray === void 0 ? void 0 : filterArray.push("".concat((0,helper.formatFacetName)(filter === null || filter === void 0 ? void 0 : filter.facet, null, facetLabels), ":").concat(filtervalue));
        });
    });
    return (filterArray === null || filterArray === void 0 ? void 0 : filterArray.length) ? filterArray === null || filterArray === void 0 ? void 0 : filterArray.join("|") : "";
};


;// CONCATENATED MODULE: ./components/ProductList/v2/Filter/filterAnalytics.js


const getShowHideFilterOptionAnalyticsData = function(collapse, facet, facetName, page) {
    let selectedTab = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "products";
    let analyticsData = JSON.stringify({
        eventAction: "plp filter ".concat(collapse[facet] ? "expand" : "collapse"),
        eventName: "plp filter ".concat(collapse[facet] ? "expand" : "collapse"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: collapse[facet] ? "expand" : "collapse",
        internalLinkPosition: "plp",
        internalLinkType: "plp:" + facetName,
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    if (page === "search") {
        analyticsData = JSON.stringify({
            eventAction: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters ").concat(collapse[facet] ? "expand" : "collapse"),
            eventName: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters ").concat(collapse[facet] ? "expand" : "collapse"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: collapse[facet] ? "expand" : "collapse",
            internalLinkPosition: "search results",
            internalLinkType: "search results:" + facetName,
            internalLinkZoneName: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
    } else if (page === "literature") {
        analyticsData = JSON.stringify({
            eventAction: "literature :filters ".concat(collapse[facet] ? "expand" : "collapse"),
            eventName: "literature :filters ".concat(collapse[facet] ? "expand" : "collapse"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: collapse[facet] ? "expand" : "collapse",
            internalLinkPosition: "literature",
            internalLinkType: "literature:" + facetName,
            internalLinkZoneName: "literature :filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
    }
    return analyticsData;
};
const getFilterOptionsAnalyticsData = (param)=>{
    let { obj , appliedFilters , facetLabels , facetName , isSelected , page , selectedTab  } = param;
    const getAppliedFiltersForPlpAnalyticsData = (objDisplay)=>{
        const dataLayerFilterArray = [];
        appliedFilters.forEach((filter)=>{
            filter.display.forEach((filtervalue)=>{
                dataLayerFilterArray.push("".concat((0,helper.formatFacetName)(filter.facet, null, facetLabels), ":").concat(filtervalue));
            });
        });
        const myIndex = dataLayerFilterArray.indexOf("".concat(facetName, ":").concat(objDisplay));
        if (myIndex !== -1) {
            dataLayerFilterArray.splice(myIndex, 1);
        } else {
            dataLayerFilterArray.push("".concat(facetName, ":").concat(objDisplay));
        }
        return dataLayerFilterArray.length ? dataLayerFilterArray.join("|") : "";
    };
    const plpFilterArrayData = getAppliedFiltersForPlpAnalyticsData(obj.display);
    let analyticsData = "";
    const appliedOrRemoved = isSelected(obj) ? "removed" : "applied";
    if (page === "search") {
        var ref;
        analyticsData = JSON.stringify({
            eventAction: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters ").concat(isSelected(obj) ? "removed" : "applied"),
            eventName: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters ").concat(isSelected(obj) ? "removed" : "applied"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat((ref = obj.display) === null || ref === void 0 ? void 0 : ref.toLowerCase()),
            internalLinkPosition: "search results",
            internalLinkType: "search results:".concat(facetName === null || facetName === void 0 ? void 0 : facetName.toLowerCase()),
            internalLinkZoneName: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: plpFilterArrayData === null || plpFilterArrayData === void 0 ? void 0 : plpFilterArrayData.toLowerCase()
        });
    } else if (page === "technicalspecs") {
        analyticsData = JSON.stringify({
            eventAction: "technical specs:filters ".concat(appliedOrRemoved),
            eventName: "technical specs:filters ".concat(appliedOrRemoved),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(obj.display, ":").concat(appliedOrRemoved),
            internalLinkPosition: "technical specs",
            internalLinkType: "technical specs:".concat(facetName),
            internalLinkZoneName: "technical specs:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: plpFilterArrayData
        });
    } else if (page === "article") {
        analyticsData = JSON.stringify({
            eventAction: "support:help and faq:filters:filter ".concat(appliedOrRemoved),
            eventName: "support:help and faq:filters:filter ".concat(appliedOrRemoved),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(obj.display, ":").concat(appliedOrRemoved),
            internalLinkPosition: "knowledge articles",
            internalLinkType: "support:help and faq:".concat(facetName),
            internalLinkZoneName: "support:help and faq:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: plpFilterArrayData
        });
    } else if (page === "literature") {
        analyticsData = JSON.stringify({
            eventAction: "literature :filters ".concat(isSelected(obj) ? "removed" : "applied"),
            eventName: "literature :filters ".concat(isSelected(obj) ? "removed" : "applied"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(obj.display.toLowerCase(), " :").concat(isSelected(obj) ? "removed" : "applied"),
            internalLinkPosition: "literature",
            internalLinkType: "literature:".concat(facetName.toLowerCase()),
            internalLinkZoneName: "literature:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: plpFilterArrayData.toLowerCase()
        });
    } else {
        var ref1;
        analyticsData = JSON.stringify({
            eventAction: "plp filter ".concat(isSelected(obj) ? "removed" : "applied"),
            eventName: "plp filter ".concat(isSelected(obj) ? "removed" : "applied"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat((ref1 = obj.display) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
            internalLinkPosition: "plp",
            internalLinkType: "plp:".concat(facetName === null || facetName === void 0 ? void 0 : facetName.toLowerCase()),
            internalLinkZoneName: "plp:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: "".concat(plpFilterArrayData === null || plpFilterArrayData === void 0 ? void 0 : plpFilterArrayData.toLowerCase())
        });
    }
    return analyticsData;
};
const addFilterCancelDataLayerOnClick = function(value, appliedFilters, facet, filter, selectedTab, page) {
    let facetLabels = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : [];
    const filterArrayList = getAppliedFiltersForPlpAnalyticsData(appliedFilters, facet.facet, filter, facetLabels);
    let type = "plp filter ";
    let internalLinkPosition = "plp";
    let internalValue = "plp";
    let internalLinkName = filter;
    if (page === "article") {
        type = "support:help and faq:filters:";
        internalLinkPosition = "knowledge articles";
        internalValue = "support:help and faq";
        internalLinkName = "".concat(filter, ":removed");
    } else if (page === "search") {
        type = "search results:".concat(selectedTab, ":filters ");
        internalLinkPosition = "search results";
        internalValue = "search results:".concat(selectedTab);
    } else if (page === "technicalspecs") {
        type = "technical specs:filter ";
        internalLinkPosition = "technical specs";
        internalValue = "technical specs";
        internalLinkName = "".concat(filter, ":removed");
    }
    const eventValue = "".concat(type).concat(value).toLowerCase();
    const eventInfo = {
        eventAction: eventValue,
        eventName: eventValue,
        eventType: "navigation",
        filterArray: filterArrayList,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName.toLowerCase(),
        internalLinkPosition: internalLinkPosition.toLowerCase(),
        internalLinkType: "".concat(internalValue, ":").concat((0,helper.formatFacetName)(facet["facet"], null, facetLabels)).toLowerCase(),
        internalLinkZoneName: "".concat(internalValue, ":filters").toLowerCase(),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getAppliedFiltersForPlpAnalyticsData = function(appliedFilters, facet, obj) {
    let facetLabels = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    const dataLayerFilterArray = [];
    appliedFilters.forEach((filter)=>{
        filter.display.forEach((filtervalue)=>{
            dataLayerFilterArray.push("".concat((0,helper.formatFacetName)(filter.facet, null, facetLabels), ":").concat(filtervalue).toLowerCase());
        });
    });
    const myIndex = dataLayerFilterArray.indexOf("".concat((0,helper.formatFacetName)(facet, null, facetLabels), ":").concat(obj).toLowerCase());
    if (myIndex !== -1) {
        dataLayerFilterArray.splice(myIndex, 1);
    } else {
        dataLayerFilterArray.push("".concat((0,helper.formatFacetName)(facet, null, facetLabels), ":").concat(obj).toLowerCase());
    }
    return dataLayerFilterArray.length ? dataLayerFilterArray.join("|") : "";
};
const getFilterClearAllAnalyticsData = (sectionTab, page)=>{
    let analyticsData = {
        eventAction: "plp clear all filter",
        eventName: "plp clear all filter",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "clear all",
        internalLinkPosition: "plp",
        internalLinkType: "plp:clear all",
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (page === "article") {
        analyticsData = {
            eventAction: "support:help and faq:filters​:clear all",
            eventName: "support:help and faq:filters​:clear all",
            eventType: "informative",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "clear all",
            internalLinkPosition: "knowledge articles",
            internalLinkType: "support:help and faq:navigation",
            internalLinkZoneName: "support:help and faq:filters​​",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    }
    if (page === "search") {
        analyticsData = {
            clickInternalLinks: "true",
            eventAction: "search results:".concat(sectionTab, ":clear all"),
            eventName: "search results:".concat(sectionTab, ":clear all"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "clear all",
            internalLinkPosition: "search results",
            internalLinkType: "search results:clear all",
            internalLinkURL: "n/a",
            internalLinkZoneName: "search results:".concat(sectionTab, ":filters")
        };
    }
    if (page === "literature") {
        analyticsData = {
            clickInternalLinks: "true",
            eventAction: "literature:filters:clear all",
            eventName: "literature:filters:clear all",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "clear all",
            internalLinkPosition: "literature",
            internalLinkType: "literature:clear all",
            internalLinkURL: "n/a",
            internalLinkZoneName: "literature:filters"
        };
    }
    return JSON.stringify(analyticsData);
};
const getAnalyticsData = (isUnchecked)=>{
    const hideDiscontinuedEventObj = {
        eventAction: "search results:technical:filters​:hide discontinued products",
        eventName: "search results:technical:filters​:hide discontinued products",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "hide discontinued products:".concat(isUnchecked ? "unchecked" : "checked"),
        internalLinkPosition: "search results",
        internalLinkType: "search results:checkbox",
        internalLinkZoneName: "search results:technical:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    return JSON.stringify(hideDiscontinuedEventObj);
};
const getPrintOrShareEventInfo = (printOrShare, selectedTab, page)=>{
    let analyticsData = "";
    if (page === "search") {
        analyticsData = {
            eventAction: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters:").concat(printOrShare),
            eventName: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters:").concat(printOrShare),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: printOrShare,
            internalLinkPosition: "search results",
            internalLinkType: "search results:".concat(printOrShare),
            internalLinkZoneName: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    } else if (page === "technicalspecs") {
        analyticsData = {
            eventAction: "technical specs:filters:".concat(printOrShare),
            eventName: "technical specs:filters:".concat(printOrShare),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: printOrShare,
            internalLinkPosition: "tech specs",
            internalLinkType: "technical specs:".concat(printOrShare),
            internalLinkZoneName: "technical specs:filters​",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    } else if (page === "literature") {
        analyticsData = {
            eventAction: "literature:filters:".concat(printOrShare),
            eventName: "literature:filters:".concat(printOrShare),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: printOrShare,
            internalLinkPosition: "literature",
            internalLinkType: "literature:".concat(printOrShare),
            internalLinkZoneName: "literature:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    } else {
        analyticsData = {
            eventAction: "plp ".concat(printOrShare),
            eventName: "plp ".concat(printOrShare),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: printOrShare,
            internalLinkPosition: "plp",
            internalLinkType: "plp:".concat(printOrShare),
            internalLinkZoneName: "plp:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    }
    return JSON.stringify(analyticsData);
};
const getFilterCloseAnalyticsData = (page)=>{
    let analyticsData = "";
    if (page === "article") {
        analyticsData = '{"eventAction":"support:help and faq:filters​:close","eventName":"support:help and faq:filters​:close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close(x)","internalLinkPosition":"knowledge articles","internalLinkType":"support:help and faq:close","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else {
        analyticsData = '{"eventAction":"plp filter close","eventName":"plp filter close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"plp","internalLinkType":"plp:close","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    }
    return analyticsData;
};
const getFilterViewResultsAnalyticsData = (facetLabels, page, appliedFilters)=>{
    let analyticsData = "";
    if (page === "article") {
        analyticsData = '{"eventAction":"support:help and faq:filters​:view results","eventName":"support:help and faq:filters​:view results","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view results","internalLinkPosition":"knowledge articles","internalLinkType":"support:help and faq:navigation","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else {
        analyticsData = '{"eventAction":"plp filter view result","eventName":"plp filter view result","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view result","internalLinkPosition":"plp","internalLinkType":"plp:filters","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true","filterArray":"' + getAppliedFiltersForAnalytics(appliedFilters, facetLabels) + '"}';
    }
    return analyticsData;
};
const getFilterCloseImgAnalyticsData = ()=>{
    const analyticsData = '{"eventAction":"plp filter close","eventName":"plp filter close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"close","internalLinkType":"plp:close","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    return analyticsData;
};
const getSocialShareAnalyticsData = (page, selectedTab)=>{
    let analyticsData = "";
    if (page === "technicalspecs") {
        analyticsData = {
            eventAction: "technical specs:filters:share",
            eventName: "technical specs:filters:share",
            internalLinkPosition: "tech specs",
            internalLinkType: "technical specs​:share",
            internalLinkZoneName: "technical specs:filters"
        };
    } else if (page === "search") {
        analyticsData = {
            eventAction: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters:share"),
            eventName: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters:share"),
            internalLinkPosition: "search results",
            internalLinkType: "search results:share",
            internalLinkZoneName: "search results:".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.toLowerCase(), ":filters")
        };
    } else {
        analyticsData = {
            eventAction: "plp share",
            eventName: "plp share",
            internalLinkPosition: "plp",
            internalLinkType: "plp:share",
            internalLinkZoneName: "plp:filters"
        };
    }
    return analyticsData;
};


;// CONCATENATED MODULE: ./src/components/ProductList/v2/Filter/collapsibleFacet.jsx






const CollapsibleFacet = (param)=>{
    let { facets , filterTitle , page , type ="" , appliedFilters , loading , onChange , isSelected , facetLabels , selectedTab , colors , showFilter , isAnnsacksPlp =false , priceRangeTitle ="Price_Range"  } = param;
    const [collapse, setCollapse] = (0,react.useState)({});
    const facet = facets[0];
    const facetList = facets[1];
    const facetName = (0,helper.formatFacetName)(facets[0], null, facetLabels);
    const facetCount = facets[1].length / 2;
    const handleCollapse = (state)=>{
        const action = {
            [facet]: state
        };
        setCollapse({
            ...action
        });
    };
    (0,react.useEffect)(()=>{
        if (appliedFilters.length > 0) {
            appliedFilters.forEach((obj)=>{
                const action = collapse || {};
                action[obj.facet] = true;
                setCollapse({
                    ...action
                });
            });
        } else {
            setCollapse({});
        }
    }, [
        appliedFilters,
        showFilter
    ]);
    const handleOnChange = (event, obj)=>{
        var ref;
        onChange((ref = event.target) === null || ref === void 0 ? void 0 : ref.checked, obj);
        try {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const pageEvent = getState && getState("page") || {};
            const eventInfo = JSON.parse(getFilterOptionsAnalyticsData({
                obj,
                appliedFilters,
                facetLabels,
                facetName,
                isSelected,
                page,
                selectedTab
            }) || "{}");
            window.adobeDataLayer.push({
                event: "cmp:click",
                page: pageEvent,
                eventInfo
            });
        } catch (err) {
        // console.log(err)
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
        tabIndex: "0",
        open: collapse[facet] && showFilter ? true : false,
        onTriggerOpening: ()=>handleCollapse(true),
        onTriggerClosing: ()=>handleCollapse(false),
        openedClassName: "is-open",
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "aria-label": filterTitle(facetName, facetCount),
            "aria-expanded": collapse[facet] ? true : false,
            className: "gbh-data-layer",
            "data-gbh-data-layer": getShowHideFilterOptionAnalyticsData(collapse, facet, facetName, page, selectedTab),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: facetName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "plus",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line-1 line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                })
            ]
        }),
        transitionTime: 400,
        easing: "ease-in-out",
        children: collapse[facet] && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                role: "list",
                className: "filter-list",
                children: facetList.map((filter, i, arr)=>{
                    if (i % 2 === 0) {
                        let displayText = null;
                        if (facet === priceRangeTitle) {
                            displayText = (0,helper.formatPriceRange)(filter, isAnnsacksPlp);
                        }
                        const obj = {
                            facet: facet,
                            value: filter,
                            display: displayText !== null && displayText !== void 0 ? displayText : filter
                        };
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                role: "checkbox",
                                "aria-checked": "false",
                                id: facet + filter,
                                disabled: loading,
                                checkBoxAria: facet === "Price_Range" ? obj.display : "".concat(obj.display, " (").concat(arr[i + 1], ")"),
                                tabIndex: collapse[facet] ? 0 : -1,
                                value: facet === "Price_Range" ? obj.display : "".concat(obj.display, " (").concat(arr[i + 1], ")"),
                                onChange: (e)=>handleOnChange(e, obj),
                                checked: isSelected(obj),
                                swatch: (0,helper.isColorFacet)(facet) ? colors[filter] : null
                            }, filter)
                        }, facet + filter);
                    }
                })
            })
        })
    });
};
/* harmony default export */ var collapsibleFacet = (CollapsibleFacet);

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 1 modules
var SocialShare = __webpack_require__(92513);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
;// CONCATENATED MODULE: ./components/ProductList/v2/Filter/index.jsx

















const Filter = (props)=>{
    const { showFilter =false , selectedSort ={} , facetLabels =[] , totalResults =0 , hidePriceRange , loading , discontinuedCheck , displayPrint =false , displayShare =false , facetData =[] , sort =[] , showSort =false , onSortChange =()=>{} , texts ={} , colors ={} , addToUrl =false , onFilter =()=>{} , handleScroll =()=>{} , page ="" , currFilters , isReplace , resetTitle , type ="" , close =()=>{} , isSearchTab , isAnnsacksPlp =false , attributeName  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const plpFilter = (0,react.useRef)(null);
    const [appliedFilters, setAppliedFilters] = (0,react.useState)([]);
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const [scrollInstance, setScrollInstance] = (0,react.useState)(null);
    const sortBy = (0,react.useRef)();
    const socialShareREf = (0,react.useRef)();
    const selectedTab = type || "products";
    const selectedFilter = localStorage.getItem("selectedFilter");
    (0,react.useEffect)(()=>{
        if (currFilters && currFilters.length > 0) {
            setAppliedFilters(currFilters);
        }
    }, [
        currFilters
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
        const instance = window.OverlayScrollbars ? window.OverlayScrollbars(plpFilter === null || plpFilter === void 0 ? void 0 : plpFilter.current, {
            className: "os-theme-dark os-host-flexbox",
            resize: "none",
            sizeAutoCapable: true,
            clipAlways: true,
            normalizeRTL: true,
            paddingAbsolute: false,
            autoUpdate: null,
            autoUpdateInterval: 33,
            nativeScrollbarsOverlaid: {
                showNativeScrollbars: false,
                initialize: true
            },
            overflow: {
                x: "hidden"
            },
            scrollbars: {
                visibility: "auto",
                autoHide: "never",
                autoHideDelay: 800,
                dragScrolling: true,
                clickScrolling: true,
                touchSupport: true,
                snapHandle: true
            }
        }) : null;
        setScrollInstance(instance);
    }, []);
    (0,react.useEffect)(()=>{
        if (window.location.pathname === constants.FILTER_WIDGET_PLP && localStorage.getItem("selectedFilter")) {
            setAppliedFilters([
                JSON.parse(localStorage.getItem("selectedFilter"))
            ]);
        }
    }, [
        selectedFilter
    ]);
    let filterList = {
        ...facetData
    };
    delete filterList["New_Products"];
    delete filterList["Hide_Discontinued"];
    delete filterList["Products"];
    delete filterList["Inspiration"];
    delete filterList["Technical"];
    delete filterList["Parts"];
    delete filterList["Help"];
    delete filterList["Resource"];
    if (hidePriceRange) {
        delete filterList["Price_Range"];
    } else if (filterList["Price_Range"]) {
        filterList = {
            Price_Range: filterList["Price_Range"],
            ...filterList
        };
    }
    let facets = Object.entries(filterList).filter((facet)=>facet[1].length > 0);
    facets = facets.filter((f)=>f[0] !== attributeName);
    const handleFilter = (checked, obj)=>{
        let curFilters = cloneDeep_default()(appliedFilters);
        const facet = curFilters.find((filter)=>filter.facet === obj.facet);
        if (checked) {
            if (facet) {
                facet.value.push(obj.value.replace(/"/g, '\\"'));
                facet.display.push(obj.display);
            } else curFilters.push({
                facet: obj.facet,
                value: [
                    obj.value.replace(/"/g, '\\"')
                ],
                display: [
                    obj.display
                ]
            });
        } else {
            const index = facet.display.indexOf(obj.display);
            facet.value.splice(index, 1);
            facet.display.splice(index, 1);
            if (!facet.value.length) {
                curFilters = curFilters.filter((f)=>f.facet !== obj.facet);
            }
        }
        (0,helper.resetFilterUrl)();
        setAppliedFilters([
            ...curFilters
        ]);
        addToUrl && setUrlParams(curFilters, isReplace, type, facetLabels, resetTitle, clearAllFilters, attributeName);
        onFilter(curFilters);
        handleScroll && handleScroll();
    };
    const clearAllFilters = function() {
        let isOnFilter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        let updatedFilters = appliedFilters.filter((f)=>f.facet === attributeName);
        setAppliedFilters(updatedFilters);
        isOnFilter && onFilter(updatedFilters);
        (0,helper.resetFilterUrl)();
        if (resetTitle) resetTitle();
        if (type) (0,helper.retainSearchQueryParams)(type);
        localStorage.removeItem("selectedFilter");
    };
    const printPlp = ()=>{
        scrollToAllProduct();
        setTimeout(()=>{
            window.print();
        }, 1250);
    };
    const scrollToAllProduct = ()=>{
        const scorllObjInterval = setInterval(()=>{
            const scrollPositions = document.querySelectorAll(".product-listing__tile div.LazyLoad:not(.is-visible)");
            if (scrollPositions.length > 0) {
                scrollPositions[0].scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest"
                });
            } else {
                clearInterval(scorllObjInterval);
            }
        }, 150);
        setTimeout(()=>{
            clearInterval(scorllObjInterval);
        }, 2000);
    };
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowSocialLink(!showSocialLink);
        setTimeout(()=>{
            const shareEl = socialShareREf.current;
            scrollInstance === null || scrollInstance === void 0 ? void 0 : scrollInstance.scroll({
                el: shareEl,
                block: "center"
            }, 500);
        }, 100);
        try {
            var ref, ref1;
            const { adobeDataLayer: { getState  } = {}  } = window;
            const eventInfo = JSON.parse((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.dataset) === null || ref1 === void 0 ? void 0 : ref1.gbhDataLayer) || "{}");
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo
            });
        } catch (err) {
        // console.log(err)
        }
    };
    const isSelected = (obj)=>{
        const facet = appliedFilters.find((filter)=>filter.facet === obj.facet);
        if (!facet) return false;
        return facet.display.includes(obj.display) ? true : false;
    };
    const showClearAll = ()=>{
        let updatedFilterList = appliedFilters.filter((f)=>f.facet !== attributeName);
        if (updatedFilterList.length > 0) return true;
        else return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: plpFilter,
        className: classnames_default()("product-listing filter"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filter__inner-container",
                children: [
                    !isSearchTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-listing__controls filter__mobile-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-listing__filter-toggle gbh-data-layer",
                                "data-gbh-data-layer": getFilterCloseAnalyticsData(page),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: texts.filterSort
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                tabIndex: "0",
                                role: "button",
                                src: close_filter === null || close_filter === void 0 ? void 0 : close_filter.src,
                                className: "product-listing__close-icon gbh-data-layer",
                                "data-gbh-data-layer": getFilterCloseImgAnalyticsData(),
                                alt: "Close Filter",
                                onClick: ()=>close(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__chips",
                        children: [
                            appliedFilters.map((facet)=>{
                                return facet.facet !== attributeName && facet.display.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter__chips-tag",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    filter === "Yes" || filter === "No" || !isNaN(parseInt(filter)) ? (0,helper.formatFacetName)(facet["facet"], filter, facetLabels) : filter
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: close_filter,
                                                tabIndex: "0",
                                                role: "button",
                                                "aria-label": "Remove filter ".concat(filter === "Yes" || filter === "No" ? (0,helper.formatFacetName)(facet["facet"], filter, facetLabels) : filter),
                                                alt: "close Icon",
                                                className: "filter__chips-close-icon gbh-data-layer",
                                                onClick: ()=>{
                                                    handleFilter(false, {
                                                        facet: facet.facet,
                                                        display: filter
                                                    });
                                                    addFilterCancelDataLayerOnClick("cancel", appliedFilters, facet, filter, selectedTab, page, facetLabels);
                                                }
                                            })
                                        ]
                                    }, filter));
                            }),
                            appliedFilters.length > 0 && showClearAll() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "filter__chips-clear-all gbh-data-layer",
                                tabIndex: "0",
                                role: "button",
                                "aria-label": "".concat(texts.clearAll, " ").concat(texts.filters),
                                "data-gbh-data-layer": getFilterClearAllAnalyticsData(selectedTab, page),
                                onClick: clearAllFilters,
                                children: texts.clearAll
                            })
                        ]
                    }),
                    showSort && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "filter__mobile-sort",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            role: "radiogroup",
                            "aria-labelledby": "sortBy-radio",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    id: "sortBy-radio",
                                    className: "filter__mobile-sort-title",
                                    "aria-label": selectedSort ? "".concat(selectedSort.name, " ").concat(texts.selected) : texts.sortByAria,
                                    children: "".concat(texts.sort, " ").concat(selectedSort ? ": " + selectedSort.name : "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "radio-wrapper",
                                    ref: sortBy,
                                    children: sort.map((item, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                            id: "sort-by-".concat(item.name),
                                            name: "sort-by",
                                            value: item.name,
                                            checked: item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name),
                                            onClick: ()=>onSortChange(item)
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    totalResults > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "list",
                        className: "filter__filter-list",
                        children: facets.map((facet)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "collapsible-outer",
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(collapsibleFacet, {
                                    facets: facet,
                                    showFilter: showFilter,
                                    facetLabels: facetLabels,
                                    filterTitle: texts.filterTitle,
                                    appliedFilters: appliedFilters,
                                    loading: loading,
                                    onChange: handleFilter,
                                    isSelected: isSelected,
                                    colors: colors,
                                    selectedTab: selectedTab,
                                    page: page,
                                    type: type,
                                    isAnnsacksPlp: isAnnsacksPlp
                                })
                            }, facet);
                        })
                    }),
                    discontinuedCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "filter__hide-discontinued",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                id: "discontinued",
                                onChange: (e)=>{
                                    return handleFilter(e.target.checked, {
                                        facet: "Hide_Discontinued",
                                        value: "true",
                                        display: texts === null || texts === void 0 ? void 0 : texts.discontinuedText
                                    });
                                },
                                checked: isSelected({
                                    facet: "Hide_Discontinued",
                                    value: "true",
                                    display: texts.discontinuedText
                                }),
                                value: texts.hideDiscontinued,
                                analyticsData: getAnalyticsData(isSelected({
                                    facet: "Hide_Discontinued",
                                    value: "true",
                                    display: texts.discontinuedText
                                }))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__print-and-share",
                        children: [
                            displayPrint !== undefined && displayPrint && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                tabIndex: "0",
                                role: "button",
                                "aria-label": texts.arialLabelPrint(page),
                                className: "gbh-data-layer",
                                hidden: width < 992,
                                "data-gbh-data-layer": getPrintOrShareEventInfo("print", selectedTab, page),
                                onClick: ()=>printPlp(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: print/* default */.Z === null || print/* default */.Z === void 0 ? void 0 : print/* default.src */.Z.src,
                                        alt: "print-icon",
                                        role: "presentation"
                                    }),
                                    texts.print
                                ]
                            }),
                            displayShare !== undefined && displayShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                tabIndex: "0",
                                role: "button",
                                "aria-label": texts.ariaLabelShare(page),
                                className: "gbh-data-layer",
                                hidden: width < 992,
                                "data-gbh-data-layer": getPrintOrShareEventInfo("share", selectedTab, page),
                                onClick: handleShare,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: share/* default */.Z === null || share/* default */.Z === void 0 ? void 0 : share/* default.src */.Z.src,
                                        alt: "share-icon",
                                        role: "presentation"
                                    }),
                                    texts.share
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                        showModal: showSocialLink,
                        id: "kf-plp-filter",
                        onClose: ()=>setShowSocialLink(false),
                        analyticData: getSocialShareAnalyticsData(page, selectedTab),
                        shareRef: socialShareREf
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "filter__footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: classnames_default()("filter__apply gbh-data-layer"),
                    "data-gbh-data-layer": getFilterViewResultsAnalyticsData(facetLabels, page, appliedFilters),
                    onClick: ()=>close(false),
                    children: [
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "filter__apply-loader"
                        }),
                        "".concat(texts.view, " ").concat(texts.results, " (").concat(totalResults, ")")
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v2_Filter = (Filter);


/***/ }),

/***/ 80498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_icons_filter_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24495);
/* harmony import */ var _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97274);
/* harmony import */ var _public_icons_grid_off_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8909);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11859);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55111);







const PLPLoader = (props)=>{
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const [rowCols, setRowCols] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setRowCols(width < _constants_index__WEBPACK_IMPORTED_MODULE_6__.ROW_COLUMN_MIN_WIDTH ? 2 : 3);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-listing",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-listing__sticky-nav-wrap",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container-fluid product-listing__sticky-nav false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-listing__row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "container kf-react-plp-container",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-listing__row",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__col product-listing__controls",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: "product-listing__total shimmer-loading__para30 shimmer width-240"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                                    className: "sorting-section",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "product-listing__fillter_sort",
                                                            children: "Filter & Sort"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                            id: "showFilter",
                                                            "aria-label": "Show Filters",
                                                            className: "product-listing__filter-toggle gbh-data-layer",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                    className: "product-listing__filter-toggle-text  product-listing__filter-toggle-text--show hideMobile\n                            }",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            className: "show",
                                                                            children: "Hide Filters"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            className: "hide",
                                                                            children: "Hide Filters"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: _public_icons_filter_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                                                                    className: "product-listing__filter-toggle-icon",
                                                                    alt: "Toggle Filter"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "product-listing__grid-control",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "d-block d-sm-none",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    className: "product-listing__grid-control-icon",
                                                                    src: _public_icons_grid_off_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                                                    alt: "grid off"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "sort",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                className: "sort__toggle",
                                                                tabIndex: "0",
                                                                "aria-label": "Featured selected",
                                                                children: [
                                                                    "Sort By: Featured",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                                                                        alt: "Sort",
                                                                        className: "sort__toggle-icon",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-listing kf-react-plp-container product-listing__tiles",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-listing__row",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col product-listing__tile-col product-listing__tile-col--full-width",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "product-listing__filter borderNone",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "filter__inner-container shimmer height-300"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "filter__footer",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "products-per-page width-240 mt60 mb20",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "shimmer-loading__headpara shimmer"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "products-per-page width-100",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "shimmer-loading__para shimmer"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "product-listing__tile-col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__row row-cols-".concat(rowCols),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: " product-listing__tile product-listing__col px-1 ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PLPLoader);


/***/ }),

/***/ 79903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_ProductList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store = __webpack_require__(45094);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
;// CONCATENATED MODULE: ./i18n/useProductListi18n.js

const useProductListi18n = (param)=>{
    let { componentProps , total , generalRef  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("plp");
    var _noResultsMsg;
    const i18n = {
        expanded: t("kf.productTab.aria.expanded"),
        collapsed: t("kf.productTab.aria.collapsed"),
        totalCount: t("kf.plp.label.totalCount", {
            count: total
        }),
        hideFilterAria: t("kf.plp.label.hideFilterAria"),
        showFilterAria: t("kf.plp.label.showFilterAria"),
        clearAllAria: "Clear all filters link",
        listWith: t("kf.plp.label.listWith"),
        items: t("kf.plp.label.items"),
        facetListAriaExpandOrCollapse: t("kf.plp.label.facetListAriaExpandOrCollapse"),
        showMoreFiltersAria: t("kf.plp.label.showMoreFiltersAria"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        sortBykey: t("kf.plp.label.sortBykey"),
        salePriceAria: t("kf.plp.label.salePriceAria"),
        originalPriceAria: t("kf.plp.label.originalPriceAria"),
        productDescription: t("kf.plp.label.productDescription"),
        colorsLinkAria: t("kf.plp.label.colorsLinkAria"),
        pageTitleAria: t("kf.plp.label.pageTitleAria", {
            categoryName: componentProps.categoryKey,
            brandName: generalRef === null || generalRef === void 0 ? void 0 : generalRef.brandName
        }),
        print: "Print",
        share: "Share",
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: "Show Filters",
        hideFilter: "Hide Filters",
        showFilterState: " Expanded",
        hideFilterState: " Collapsed",
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort", "Filter & Sort"),
        listviewFilter: t("kf.plp.label.listViewDeclare"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view", "View"),
        all: t("kf.plp.label.all"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        sort: "Sort By",
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        applyFilters: "Apply Filters",
        results: "Results",
        annsacksResults: t("kf.plp.label.annsacksResults"),
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: "Back to Top",
        showMore: componentProps.isAnnsacksPlp ? t("annsacks.plp.label.showMore") : t("kf.plp.label.showMore"),
        showLess: componentProps.isAnnsacksPlp ? t("annsacks.plp.label.showLess") : t("kf.plp.label.showLess"),
        clearAll: "Clear All",
        priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
        priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
        to: t("kf.plp.label.to"),
        minText: t("kf.plp.label.minText"),
        maxText: t("kf.plp.label.maxText"),
        sameCategory: componentProps.sameCategory ? componentProps.sameCategory : t("kf.compare.validation.sameCategory"),
        maxProduct: componentProps.maxProduct ? componentProps.maxProduct : t("kf.compare.validation.maxProducts"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        errors: {
            validRange: t("kf.plp.error.validRange"),
            minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
            maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
            checkValid: t("kf.error.message.price")
        },
        ariaLabel: {
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected")
        },
        startingAt: t("kf.plp.label.startingAt"),
        viewResults: t("kf.plp.label.viewResults"),
        new: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.new) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.new : t("kf.plp.label.new"),
        onSale: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.onSale) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.onSale : t("kf.plp.label.onSale"),
        exclusive: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.exclusive) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.exclusive : t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        filterOpenAlert: t("kf.plp.ariaLabel.filterOpenAlert"),
        filterCloseAlert: t("kf.plp.ariaLabel.filterCloseAlert"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        noResultsMssg: (_noResultsMsg = componentProps.noResultsMsg) !== null && _noResultsMsg !== void 0 ? _noResultsMsg : t("kf.plp.label.noResultsMssg", "Sorry, there are no products that meet your filter criteria. Contact Us if you need additional support."),
        featured: "Featured",
        // featured: "Featured",
        priceDesc: "Price: High - Low",
        priceAsc: "Price: Low - High",
        atoz: "A-Z",
        ztoa: "Z-A",
        // extras
        newToOld: t("kf.myProducts.sort.newToOld"),
        oldToNew: t("kf.myProducts.sort.oldToNew"),
        // needtoCheck check in getSelectedSort helper.js
        AToZ: t("kf.services.sort.AToZ"),
        ZToA: t("kf.services.sort.ZToA"),
        installationAvailable: t("kf.pdp.label.installationAvailable", "Installation Available"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        arialLabelPrint: (val)=>t("kf.plp.label.aria.print", {
                val: val
            }),
        ariaLabelShare: (val)=>t("kf.plp.label.aria.share", {
                val: "".concat(val, " page")
            })
    };
    return i18n;
};
/* harmony default export */ var i18n_useProductListi18n = (useProductListi18n);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.module.scss
var index_module = __webpack_require__(58088);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/Filter/index.module.scss
var Filter_index_module = __webpack_require__(3899);
var Filter_index_module_default = /*#__PURE__*/__webpack_require__.n(Filter_index_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/StickyNav/stickyNavHeader.jsx + 1 modules
var stickyNavHeader = __webpack_require__(24751);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/ProductListView/productListHelper.js
const keyPress = (e, filterModalRef, cb)=>{
    const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
    const focusContent = filterModalRef.current.querySelectorAll(focusElements);
    const firstElem = focusContent[0];
    const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
    if (e.key === "Escape") {
        cb(false);
    }
    if (e.key === "Tab") {
        if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterModalRef.current)) {
            e.preventDefault();
            lastElem.focus();
        }
        if (!e.shiftKey && document.activeElement === lastElem) {
            e.preventDefault();
            firstElem.focus();
        }
    }
};


// EXTERNAL MODULE: ./components/ProductList/v2/Filter/index.jsx + 4 modules
var Filter = __webpack_require__(54341);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/index.module.scss
var ProductListView_index_module = __webpack_require__(55266);
var ProductListView_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductListView_index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(50702);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/Pagination/index.jsx
var Pagination = __webpack_require__(57633);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.jsx + 2 modules
var ProductTile = __webpack_require__(75535);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/product.js
var utils_product = __webpack_require__(29843);
// EXTERNAL MODULE: ./src/components/PromoBanner/v2/PromoBanner.jsx + 1 modules
var PromoBanner = __webpack_require__(29295);
// EXTERNAL MODULE: ./src/hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83839);
// EXTERNAL MODULE: ./components/ProductList/v2/PLPLoader/index.jsx
var PLPLoader = __webpack_require__(80498);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductListView/index.jsx























const Index = (props)=>{
    const { facets , filterview ="showFilter" , staticTexts , sorts , selectedSort , loading , data , onSort , onFilter , totalResults , onLoadMore , curRows , displayPrint , displayShare , onRows , productsPerPage , facetLabels , colors , info , isLandscape , mpview , defaultImageTag , hoverImageTag , favorites , currFilters , presetConfigs , fusionQueryId , isGrouped , promoLayout , xfHtml , promoPlacementMobile , promoPlacementDesktop , compareData , promoJson , setPromoData , promoData , attributeName , plpBadge ={} , categoryKey , setPdpLoading =()=>{}  } = props;
    const { currencySign  } = info;
    const [width] = (0,useWindowResize/* default */.Z)(true);
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const [swatchCount, setSwatchCount] = (0,react.useState)(width > 812 ? 7 : 5);
    const plpRef = (0,react.useRef)(null);
    const filterModalWindow = (0,react.useRef)(null);
    const [showFilter, setShowFilter] = (0,react.useState)(width >= 992 ? filterview === "showFilter" : false);
    const [rowCols, setRowCols] = (0,react.useState)(width <= 1280 ? 2 : 3);
    const [isInitilaLoad, setInitilaLoad] = (0,react.useState)(true);
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !showFilter,
        "product-listing__filter--modal": showFilter
    });
    const tileClass = classnames_default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !showFilter
    });
    (0,react.useEffect)(()=>{
        if (width <= 480) {
            setRowCols(mpview === "1-col-mpview" ? 2 : 1);
        } else if (width > 480 && width <= 1280) {
            setRowCols(2);
        } else {
            setRowCols(3);
        }
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        setShowFilter(width >= 992 ? filterview === "showFilter" : false);
        if (width <= 480) {
            setRowCols(mpview === "1-col-mpview" ? 2 : 1);
        }
    }, [
        mpview,
        filterview
    ]);
    (0,react.useEffect)(()=>{
        if (!showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref;
            (ref = document.getElementById("showFilter")) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        showFilter
    ]);
    const plp = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    (0,react.useEffect)(()=>{
        setInitilaLoad(plp === null || plp === void 0 ? void 0 : plp.initialLoad);
    }, [
        plp
    ]);
    // calculate promo position
    const col = width < 768 ? {
        "one-column": "promo-col-3",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : width > 768 && width < 1281 ? {
        "one-column": "promo-col-1",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : {
        "one-column": "promo-col-1",
        "two-column": "promo-col-2",
        "three-column": "promo-col-3"
    };
    const colVal = {
        "one-column": 1,
        "two-column": 2,
        "three-column": 3
    };
    const row = lib/* isMobile */.tq ? parseInt(promoPlacementMobile) : parseInt(promoPlacementDesktop);
    const position = width <= 1280 ? rowCols === 1 ? row - 1 : row * rowCols - (colVal[promoLayout] === 1 && width > 767 ? 1 : 2) : row * rowCols - colVal[promoLayout];
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            setSwatchCount((0,helper.getSwatchCount)(true));
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const handleKeyPress = (e)=>{
        if (width < 992) {
            keyPress(e, filterModalWindow, setShowFilter);
        }
    };
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleSort = (sort)=>{
        onSort(sort);
        handleBackToTop();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-listing",
            ref: plpRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stickyNavHeader/* default */.Z, {
                    showFilter: showFilter,
                    rowCols: rowCols,
                    setShowFilter: setShowFilter,
                    setRowCols: setRowCols,
                    staticTexts: staticTexts,
                    sorts: sorts,
                    selectedSort: selectedSort,
                    handleSort: handleSort,
                    totalResults: totalResults
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-plp-container product-listing__tiles",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-listing__row d-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "filter-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: filterClass,
                                    "aria-modal": true,
                                    ref: filterModalWindow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-listing__filter--sticky",
                                        "aria-hidden": !showFilter,
                                        onKeyDown: handleKeyPress,
                                        children: facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter/* default */.Z, {
                                            tabIndex: "0",
                                            texts: staticTexts,
                                            close: setShowFilter,
                                            showFilter: showFilter,
                                            addToUrl: true,
                                            showSort: width <= 991,
                                            sort: sorts,
                                            selectedSort: selectedSort,
                                            facetData: facets,
                                            totalResults: totalResults,
                                            loading: loading,
                                            colors: colors,
                                            facetLabels: facetLabels,
                                            onFilter: onFilter,
                                            onSortChange: handleSort,
                                            displayShare: displayShare,
                                            displayPrint: displayPrint,
                                            currFilters: currFilters,
                                            attributeName: attributeName,
                                            handleBackToTop: handleBackToTop
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: tileClass,
                                    children: (data === null || data === void 0 ? void 0 : data.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-listing__no-results",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.noResultsMssg)
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-listing__row row-cols-".concat(rowCols),
                                                children: data === null || data === void 0 ? void 0 : data.map((product, i)=>// console.log( xfHtml && (i + 1) % position === 0)
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-listing__tile",
                                                                id: product["masterCustomerFacingSKU_s"],
                                                                children: i < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile/* default */.Z, {
                                                                        rowCols: rowCols,
                                                                        tabIndex: "0",
                                                                        loading: loading,
                                                                        data: product,
                                                                        mapImageToColor: true,
                                                                        texts: staticTexts,
                                                                        lite: !isLandscape && lib/* isMobile */.tq && rowCols === 2,
                                                                        addToCompare: utils_product/* addToCompareProduct */.dX,
                                                                        removeFromCompare: utils_product/* removeFromCompareProduct */.Zj,
                                                                        compareData: compareData,
                                                                        defaultImage: defaultImageTag,
                                                                        hoverImage: hoverImageTag,
                                                                        currencySign: currencySign,
                                                                        isGrouped: isGrouped,
                                                                        swatchCount: swatchCount,
                                                                        favorites: favorites,
                                                                        currFilters: currFilters,
                                                                        selectedSort: selectedSort,
                                                                        plpPage: true,
                                                                        index: i,
                                                                        presetConfigs: presetConfigs,
                                                                        fusionQueryId: fusionQueryId,
                                                                        parent: "PLP",
                                                                        plpBadge: plpBadge,
                                                                        categoryKey: categoryKey,
                                                                        fetchPriority: "high",
                                                                        setPdpLoading: setPdpLoading
                                                                    })
                                                                }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s, "-LAZY")) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                        className: "kf-lazyload-wrapper",
                                                                        height: "300",
                                                                        offset: "300px",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile/* default */.Z, {
                                                                            rowCols: rowCols,
                                                                            tabIndex: "0",
                                                                            loading: loading,
                                                                            data: product,
                                                                            mapImageToColor: true,
                                                                            texts: staticTexts,
                                                                            lite: !isLandscape && lib/* isMobile */.tq && rowCols === 2,
                                                                            addToCompare: utils_product/* addToCompareProduct */.dX,
                                                                            removeFromCompare: utils_product/* removeFromCompareProduct */.Zj,
                                                                            compareData: compareData,
                                                                            defaultImage: defaultImageTag,
                                                                            hoverImage: hoverImageTag,
                                                                            currencySign: currencySign,
                                                                            isGrouped: isGrouped,
                                                                            swatchCount: swatchCount,
                                                                            favorites: favorites,
                                                                            currFilters: currFilters,
                                                                            selectedSort: selectedSort,
                                                                            plpPage: true,
                                                                            index: i,
                                                                            presetConfigs: presetConfigs,
                                                                            fusionQueryId: fusionQueryId,
                                                                            parent: "PLP",
                                                                            plpBadge: plpBadge,
                                                                            setPdpLoading: setPdpLoading
                                                                        })
                                                                    })
                                                                }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s, "-LAZY"))
                                                            }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s)),
                                                            xfHtml && (i + 1) % position === 0 && i < position && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat(col[promoLayout], " product-listing__tile"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanner/* default */.Z, {
                                                                    promoJson: promoJson,
                                                                    xfLink: xfHtml,
                                                                    col: colVal[promoLayout],
                                                                    setPromoData: setPromoData,
                                                                    position: i,
                                                                    promoData: promoData,
                                                                    smartCrop: smartCrop,
                                                                    width: width
                                                                })
                                                            })
                                                        ]
                                                    }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s)))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                page: "plp",
                                                totalResults,
                                                staticTexts,
                                                onLoadMore,
                                                curRows,
                                                data,
                                                displayPrint,
                                                displayShare,
                                                productsPerPage,
                                                onRows,
                                                handleBackToTop,
                                                width
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductListView = (Index);

// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./src/hooks/usePrevious.js
var usePrevious = __webpack_require__(97349);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
;// CONCATENATED MODULE: ./components/ProductList/v2/analytics.js


const addAnalyticsShowEvent = function(promo, setPromoData) {
    let data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    let promoData = promo.filter((promo)=>promo && promo.ctaLink);
    promoData.sort((a, b)=>a.position - b.position);
    promoData = getUniqueList(promoData, "position");
    let slot = 1;
    const component = [];
    promoData.forEach((promoItem)=>{
        let title = promoItem.desc || "";
        if (title) {
            var ref;
            const div = document.createElement("div");
            div.innerHTML = title;
            // This contains HTML code so remove some bugs here.
            title = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
            title = title.replace(/\n/g, "");
        }
        promoItem.componentInfo = {
            componentID: "".concat(window.location.origin).concat(promoItem.ctaLink),
            componentMessage: "promo-".concat(slot++),
            componentName: title,
            componentLocation: "plp:promo tiles",
            componentType: "internal campaign"
        };
        component.push({
            componentInfo: promoItem.componentInfo
        });
    });
    setPromoData({
        promos: promoData,
        isUpdate: false
    });
    if (!(0,helper.isShowAnalyticsEventLoaded)()) {
        const page = window.pageObj || {};
        page.user = (0,helper.getUserAnalyticsObject)();
        if (page.category) {
            page.category.room = data && data[0] && data[0].category1_s ? (0,helper.sanitizeTextForAnalytics)(data[0].category1_s) : "n/a";
        } else {
            page.category = {
                room: data && data[0] && data[0].category1_s ? (0,helper.sanitizeTextForAnalytics)(data[0].category1_s) : "n/a"
            };
        }
        if ((!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
            page.component = component;
            window.pageObj = page;
            window.isShowAnalyticsEvent = true;
        } else {
            window.adobeDataLayer.push({
                event: "cmp:show",
                page: page,
                component: component
            });
        }
    }
};
const getUniqueList = (arr, key)=>{
    return [
        ...new Map(arr.map((item)=>[
                item[key],
                item
            ])).values()
    ];
};
const getClickSignalPayload = (param)=>{
    let { highlightText , productCategory , siteName , sku , ...props } = param;
    const userInfo = window.adobeDataLayer.getState("page.user.authStatus") === "anonymous" ? "guest" : window.adobeDataLayer.getState("page.user.commerceToolsID");
    const sTimeStamp = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().split(" ")[0] + "Z";
    return [
        {
            params: {
                query: highlightText !== null && highlightText !== void 0 ? highlightText : productCategory,
                app_id: siteName.toLowerCase(),
                doc_id: props.data.id,
                fusion_query_id: props.fusionQueryId,
                ctype: props.parent,
                user_id: userInfo,
                country: "USA",
                region: "Northeast",
                item_pos: props.index,
                plc: productCategory,
                sku_id: props.data.sku_s,
                session_id: props === null || props === void 0 ? void 0 : props.sessionId,
                count_i: "1",
                url: window.location
            },
            id: "".concat(new Date().valueOf(), "_").concat(userInfo, "_").concat(sku, " "),
            timestamp: sTimeStamp,
            type: "click"
        }
    ];
};
const triggerClickSignal = async (param)=>{
    let { highlightText , productCategory , siteName , sku , ...props } = param;
    const aSignalsPayload = getClickSignalPayload({
        highlightText,
        productCategory,
        siteName,
        sku,
        ...props
    });
    await apim.post("/search/signals/".concat(siteName.toLowerCase()), aSignalsPayload);
};


// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./components/Search/v1/ProductsTab/helper.js + 1 modules
var ProductsTab_helper = __webpack_require__(45344);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductList.jsx



























const ProductList = (props)=>{
    var ref;
    const isServer = "object" === "undefined";
    const isSsr = (0,useIsSsr/* default */.Z)();
    let plp;
    let compareData;
    const { eventHandler  } = props;
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const DEFAULT_PAGINATION_VALUE = constants.DEFAULT_PRODUCT_COUNT_PLP;
    const { data: componentProps  } = props;
    const { access_token: accessToken , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { categoryKey , attributevalue , attributeName  } = componentProps;
    if (isServer) {
        var ref1;
        plp = eventHandler === null || eventHandler === void 0 ? void 0 : (ref1 = eventHandler.store) === null || ref1 === void 0 ? void 0 : ref1.plp;
        compareData = {};
    } else {
        // eslint-disable-next-line
        plp = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
        // eslint-disable-next-line
        compareData = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    }
    const dispatch = (0,es/* useDispatch */.I0)();
    const [pdpLoading, setPdpLoading] = (0,react.useState)(false);
    const { data , total =0 , facets , facetLabels , status , initialLoad , colors , grouped , fusion ={}  } = plp;
    const rowsInitialValue = (0,utils_product/* getRowsInitialValue */.U9)();
    const [paginationState, setPaginationState] = (0,react.useState)({
        rows: rowsInitialValue,
        start: 0
    });
    const { rows , start  } = paginationState;
    const [promoData, setPromoData] = (0,react.useState)({
        promos: [],
        isUpdate: false
    });
    const prevRows = (0,usePrevious/* default */.Z)(rows);
    const [general, setGeneral] = (0,react.useState)({
        brandName: "",
        badgeText: ""
    });
    const [sessionId, setSessionId] = (0,react.useState)("") // setting initial state of sessionId
    ;
    // Need to read from env file
    const [info, setInfo] = (0,react.useState)({
        currencyCode: "INR",
        currencySign: "₹",
        locale: "en-US"
    });
    const [state, setState] = (0,react.useState)({
        position: "",
        promoJson: {}
    });
    const [fusionQueryId, setFusionQueryId] = (0,react.useState)("");
    const [curFilterQueries, setCurFilterQueries] = (0,react.useState)(null);
    const prevCurFilterQueries = (0,usePrevious/* default */.Z)(curFilterQueries);
    const [persona, setPersona] = (0,react.useState)("GST");
    const [isFusionLoaded, setIsFusionLoaded] = (0,react.useState)(false);
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    const [filterDataPopulated, setFilterDataPopulated] = (0,react.useState)(false);
    const [plpBadge, setPlpBadge] = (0,react.useState)({});
    /*
  Commenting unrequired code since it causes duplicate PLP call
  const [plpFacets, setPlpFacets] = useState(null)
  useEffect(() => {
    if (plp?.facets && !plpFacets) {
      getConfig().then(config => {
        const marketParamValues = _get(config, "marketParamValues", {})
        const filterQuery = getAllFilterQueries(
          componentProps,
          fusion,
          marketParamValues,
          plp?.facets
        )
        setCurFilterQueries(filterQuery)
        setPlpFacets(plp?.facets)
      })
    }
  }, [plp])
  */ (0,react.useEffect)(()=>{
        window.onpageshow = function(event) {
            if (event.persisted) {
                setPdpLoading(false);
            }
        };
        localStorage.setItem("componentProps", JSON.stringify(componentProps));
    }, []);
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        (0,config/* getConfig */.i)().then((config)=>{
            const { plpConfigurations: { myArrayList: plpBadgeList = []  } = {}  } = config;
            const locale = get_default()(config, "internationalization.locale", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const brandName = get_default()(config, "general.siteName");
            var ref;
            const displayOrderBadges = (ref = plpBadgeList.find((item)=>item.map.Key === "displayOrderBadges")) !== null && ref !== void 0 ? ref : {};
            const { map: { Values: { myArrayList: displayOrderBadgeList = []  } = {}  } = {}  } = displayOrderBadges;
            const plpBadges = {};
            displayOrderBadgeList.forEach((item)=>{
                plpBadges[item] = (0,helper.getBadgeValue)(item, plpBadgeList);
            });
            const badgeText = {
                new: get_default()(config, "general.newBadgeName", ""),
                onSale: get_default()(config, "general.saleBadgeName", ""),
                exclusive: get_default()(config, "general.exclusiveBadgeName", "")
            };
            const marketParamValues = get_default()(config, "marketParamValues", {});
            const general = {
                brandName: brandName,
                badgeText: badgeText
            };
            const info = {
                locale: locale,
                currencyCode: currencyCode,
                currencySign: currencySign,
                marketParamValues
            };
            let filterQuery = (0,helper.getAllFilterQueries)(componentProps, fusion, marketParamValues);
            filterQuery = (0,helper.checkCategoryFilter)(filterQuery);
            setCurFilterQueries(filterQuery);
            setGeneral(general);
            setInfo(info);
            setPlpBadge({
                plpBadges,
                displayOrderBadgeList
            });
            const cookie = document === null || document === void 0 ? void 0 : document.cookie;
            const cookieArray = cookie === null || cookie === void 0 ? void 0 : cookie.split(";");
            const sessionCookie = cookieArray.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.includes("session#");
            })[0];
            const sessionIdString = sessionCookie === null || sessionCookie === void 0 ? void 0 : sessionCookie.split("|")[1];
            setSessionId(sessionIdString === null || sessionIdString === void 0 ? void 0 : sessionIdString.split("#")[1]) // setting the value of session id from cookie information
            ;
        });
    }, [
        isSsr
    ]);
    const staticTexts = i18n_useProductListi18n({
        componentProps,
        total: total,
        generalRef: general
    });
    const [selectedSort, setSelectedSort] = (0,react.useState)({
        name: staticTexts.featured,
        query: ""
    });
    const prevSort = (0,usePrevious/* default */.Z)(selectedSort);
    const sorts = [
        {
            name: staticTexts.featured,
            query: ""
        },
        {
            name: staticTexts.priceDesc,
            query: "price+desc"
        },
        {
            name: staticTexts.priceAsc,
            query: "price+asc"
        },
        {
            name: staticTexts.atoz,
            query: "".concat(grouped ? "CollapseSort_s+asc" : "NonCollapseSort_s+asc")
        },
        {
            name: staticTexts.ztoa,
            query: "".concat(grouped ? "CollapseSort_s+desc" : "NonCollapseSort_s+desc")
        }
    ];
    const handleSort = (selectedSort)=>{
        (0,helper.replaceSearchUrl)("sort", selectedSort.query);
        setPaginationState((state)=>({
                ...state,
                start: 0
            }));
        setSelectedSort(selectedSort);
    };
    const handleLoadMore = ()=>{
        setRowsSession(start + rows + rows);
        setPaginationState((state)=>({
                ...state,
                start: start + rows
            }));
        const scrollPosition = document.getElementById("kf-product-list-tile-wrapper-".concat(sessionStorage.plpScroll));
        let IterCount = 10;
        const scorllObjInterval = setInterval(()=>{
            if (scrollPosition) {
                scrollPosition.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest"
                });
                if (IterCount === 0) {
                    delete sessionStorage.plpScroll;
                    clearInterval(scorllObjInterval);
                }
                IterCount--;
            }
        }, 150);
    };
    const setRowsSession = (rows)=>{
        if (sessionStorage.rows) {
            const rowStorage = JSON.parse(sessionStorage.rows);
            rowStorage[window.location.pathname] = rows;
            sessionStorage.rows = JSON.stringify(rowStorage);
        } else {
            sessionStorage.rows = JSON.stringify({
                [window.location.pathname]: rows
            });
        }
    };
    const handleRows = (rows)=>{
        setPaginationState({
            rows,
            start: 0
        });
        setRowsSession(rows);
    };
    (0,react.useEffect)(()=>{
        if (accessToken && curFilterQueries !== null) {
            var ref, ref1;
            const personaTemp = (user === null || user === void 0 ? void 0 : (ref = user.persona) === null || ref === void 0 ? void 0 : ref.length) > 0 ? (ref1 = user === null || user === void 0 ? void 0 : user.persona[0]) === null || ref1 === void 0 ? void 0 : ref1.split(":")[1] : "GST";
            setPersona(personaTemp);
            window.authAccessToken = accessToken;
            // will trigger from handleLoadMore
            if (start) {
                generateListingUrl(true, false);
            } else if (start == 0 && rows && !!prevRows && prevRows > rows) {
                generateListingUrl(false, true);
            } else if (start == 0 && rows && !!prevRows && prevRows != rows) {
                generateListingUrl(false, false);
            } else if (curFilterQueries.length > 0 || (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (curFilterQueries.length === 0 && prevCurFilterQueries != null) {
                generateListingUrl();
            } else if (prevSort && (prevSort === null || prevSort === void 0 ? void 0 : prevSort.query) != (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (prevRows == rows && rows > DEFAULT_PAGINATION_VALUE || personaTemp != "GST") {
                generateListingUrl();
            } else if (!data || data && data.length <= 3) {
                generateListingUrl();
            }
        }
    }, [
        start,
        rows,
        accessToken,
        curFilterQueries,
        selectedSort
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            const fusionQueryId = fusion === null || fusion === void 0 ? void 0 : fusion.fusionQueryId;
            setFusionQueryId(fusionQueryId);
            const sortUrl = (0,helper.getSortFromUrl)();
            const sortQuery = (0,helper.getSelectedSort)(staticTexts, sortUrl);
            setSelectedSort(sortQuery);
            if (componentProps) {
                if (componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfLink) {
                    setState({
                        ...state,
                        xfHtml: componentProps.xfLink
                    });
                } else {
                // log.warn("Promo banner xF is not configured")
                }
            } else {
            // log.warn("Product List: Get URL Property not found")
            }
        }
    }, [
        fusion,
        accessToken
    ]);
    // Function to generate the plp request url.
    const generateListingUrl = function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const start = paginationState.start;
        let queries = curFilterQueries;
        if (!update) {
            setPaginationState({
                ...paginationState,
                start: 0
            });
            setPromoData({
                promos: [],
                isUpdate: false
            });
        }
        const fq = [];
        const persona = (0,helper.getUserPersona)();
        const params = new URLSearchParams(window.location.search);
        const category = params.get("Category");
        if (window.location.pathname === constants.FILTER_WIDGET_PLP && category) {
            const facetIndex = queries === null || queries === void 0 ? void 0 : queries.findIndex((item)=>item.facet === "**ProductLocalCategory_s");
            queries = facetIndex >= 0 ? queries.map((item, index)=>index === facetIndex ? {
                    ...item,
                    value: [
                        category
                    ],
                    display: [
                        category
                    ]
                } : item) : [
                ...queries,
                {
                    facet: "**ProductLocalCategory_s",
                    value: [
                        category
                    ],
                    display: [
                        category
                    ]
                }
            ];
        }
        queries === null || queries === void 0 ? void 0 : queries.forEach((q)=>{
            let tag = '{!tag="'.concat(q.facet, '"}');
            if (!q.facet.match(/^\*{2}/)) {
                q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 ? fq.push(encodeURIComponent("".concat('{!tag="priceList.'.concat(persona, '.finalPrice_d"}') + "priceList.".concat(persona, ".finalPrice_d"), ":(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
                return;
            }
            q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 ? fq.push("".concat("priceList.".concat(persona, ".finalPrice_d").replace(/^\*{2}/, ""), ":(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
        });
        const query = {
            fq,
            rows,
            start,
            fl: (0,constants.resourceFacetLabels)(persona).join(",")
        };
        if (selectedSort.query) {
            if (selectedSort.query === "price+asc") {
                query.sort = "".concat((0,helper.getPriceSortQuery)(plp === null || plp === void 0 ? void 0 : plp.grouped), "+asc");
            } else if (selectedSort.query === "price+desc") {
                query.sort = "".concat((0,helper.getPriceSortQuery)(plp === null || plp === void 0 ? void 0 : plp.grouped), "+desc");
            } else {
                query.sort = selectedSort.query;
            }
        }
        if (enableScroll) setDataPopulated(false);
        dispatch((0,productListSlice/* getProducts */.Xp)({
            profileName: categoryKey,
            query,
            update
        })).then(()=>{
            setFilterDataPopulated(true);
            if (enableScroll) setDataPopulated(true);
        }).catch(()=>{
            setFilterDataPopulated(true);
            if (enableScroll) setDataPopulated(false);
        });
    };
    const setPromoInfo = (promo)=>{
        const promoDataNew = [
            ...promoData.promos
        ];
        if (promo && !promoData.promos.find((item)=>item.position === promo.position)) {
            // don't push duplicates
            promoDataNew.push(promo);
        }
        setPromoData({
            promos: promoDataNew,
            isUpdate: true
        });
    };
    (0,react.useEffect)(()=>{
        // checking if all responses are recorded
        if (isSsr) return;
        const { isUpdate , promos  } = promoData;
        if (isUpdate) {
            const { position  } = state;
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === promos.length) {
                addAnalyticsShowEvent(promos, setPromoData, data);
            }
        }
    }, [
        promoData.promos,
        promoData.isUpdate,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        // plpLoadedEvent implementation
        const { position , xfHtml  } = state;
        const { promos  } = promoData;
        if (!data || !data.length || parseInt(data.length / position) === 0 || !xfHtml) {
            addAnalyticsShowEvent(promos, setPromoData, data);
        } else {
            // checking if all responses are recorded
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === 0) {
                addAnalyticsShowEvent(promos, setPromoData, data);
            } else {
                setTimeout(()=>{
                    addAnalyticsShowEvent(promos, setPromoData, data);
                }, 5000);
            }
        }
    }, [
        data,
        state.position,
        componentProps.xfLink,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        // To scrollup the product list on back
        if (dataPopulated) window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        dataPopulated
    ]);
    const sendPositionToParent = (position)=>{
        setState({
            ...state,
            position: position
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Suspense, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: pdpLoading,
                showLoadingText: false
            }),
            !isEmpty_default()(info) && (!(attributeName && attributevalue) || attributevalue && attributeName && filterDataPopulated) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": "product-list",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListView, {
                    staticTexts: staticTexts,
                    sorts: sorts,
                    selectedSort: selectedSort,
                    info: info,
                    onLoadMore: handleLoadMore,
                    curRows: rows,
                    onRows: handleRows,
                    onSort: handleSort,
                    onFilter: setCurFilterQueries,
                    totalResults: total,
                    displayShare: componentProps.enableSharePlp,
                    displayPrint: componentProps.enablePrintPlp,
                    productsPerPage: productsPerPage,
                    data: data,
                    colors: colors,
                    loading: initialLoad ? false : status !== "succeeded",
                    ...componentProps,
                    facets: facets !== null && facets !== void 0 ? facets : false,
                    facetLabels: facetLabels,
                    xfHtml: state.xfHtml,
                    currFilters: curFilterQueries,
                    // resetTitle={""} The value is not using any where, so not implemented now
                    // urlTitle={""} The value is not using any where, so not implemented now
                    isGrouped: grouped,
                    favorites: (ref = (0,helper.getFavouraties)()) === null || ref === void 0 ? void 0 : ref.lineItems,
                    setPromoData: setPromoInfo,
                    sendPositionToParent: sendPositionToParent,
                    promoData: promoData.promos,
                    promoJson: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson) ? JSON.parse(componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson) : {},
                    fusionQueryId: fusionQueryId,
                    parent: "PLP",
                    compareData: compareData,
                    promoLayout: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout,
                    promoPlacementDesktop: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoPlacementDesktop,
                    promoPlacementMobile: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoPlacementMobile,
                    persona: persona,
                    sessionId: sessionId,
                    plpBadge: plpBadge,
                    setPdpLoading: setPdpLoading
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLPLoader/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var v2_ProductList = (ProductList);


/***/ }),

/***/ 69519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55111);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82476);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination_analytics_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48595);





const LoadMore = (param)=>{
    let { totalResults =0 , staticTexts ={} , onLoadMore =()=>{} , curRows =30 , data =[] , page ="" , type ="" , removeLoadAnimation =false  } = param;
    const transformClassName = removeLoadAnimation ? "no-transform" : "";
    const handleLoadMore = ()=>{
        sessionStorage.plpScroll = data[data.length - 1].ctId_s;
        onLoadMore();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "product-listing__row gbh-data-layer",
        "data-gbh-data-layer": (0,_components_ProductList_v2_ProductListView_Pagination_analytics_js__WEBPACK_IMPORTED_MODULE_4__/* .getLoadMoreAnalyticsData */ .Ql)(page, type),
        children: totalResults > _constants_index__WEBPACK_IMPORTED_MODULE_2__.DEFAULT_PRODUCT_COUNT_PLP && totalResults > curRows && totalResults > (data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            type: "load-more",
            size: "small",
            customClass: "product-listing__load-more ".concat(transformClassName),
            label: staticTexts.loadMore,
            onClick: handleLoadMore,
            parentClass: "div-wrapper",
            role: "button"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadMore);


/***/ }),

/***/ 48595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ql": function() { return /* binding */ getLoadMoreAnalyticsData; },
/* harmony export */   "a$": function() { return /* binding */ plpGetBackToTopAnalytics; },
/* harmony export */   "cI": function() { return /* binding */ defaultGetBackToTopAnalytics; },
/* harmony export */   "gr": function() { return /* binding */ technicalSpecGetBackToTopAnalytics; },
/* harmony export */   "tf": function() { return /* binding */ searchGetBackToTopAnalytics; }
/* harmony export */ });
/* unused harmony exports searchLoadMoreAnalyticsData, technicalSpecLoadMoreAnalyticsData, articleLoadMoreAnalyticsData, defaultLoadMoreAnalyticsData */
const searchGetBackToTopAnalytics = (type)=>JSON.stringify({
        eventAction: "search results:".concat(type, ":main content area:back to top"),
        eventName: "search results:".concat(type, ":main content area:back to top"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to top",
        internalLinkPosition: "search results",
        internalLinkType: "search results:navigation",
        internalLinkZoneName: "search results:".concat(type, ":main content area"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
const technicalSpecGetBackToTopAnalytics = JSON.stringify({
    eventAction: "technical specs:main content area:back to top",
    eventName: "technical specs:main content area:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "tech specs",
    internalLinkType: "technical specs:navigation",
    internalLinkZoneName: "technical specs:main content area",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const plpGetBackToTopAnalytics = JSON.stringify({
    eventAction: "plp:back to top",
    eventName: "plp:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "plp",
    internalLinkType: "plp:navigation",
    internalLinkZoneName: "plp:promo tiles",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const defaultGetBackToTopAnalytics = JSON.stringify({
    eventAction: "support:help and faq:article list:back to top",
    eventName: "support:help and faq:article list:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "support:help and faq",
    internalLinkType: "support:help and faq:navigation",
    internalLinkZoneName: "support:help and faq:article list",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const searchLoadMoreAnalyticsData = (tab)=>JSON.stringify({
        eventAction: "search results:".concat(tab, ":main content area:load more"),
        eventName: "search results:".concat(tab, ":main content area:load more"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "load more",
        internalLinkPosition: "search results",
        internalLinkType: "search results:load more",
        internalLinkZoneName: "search results:".concat(tab, ":main content area"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
const technicalSpecLoadMoreAnalyticsData = '{"eventAction":"technical specs:main content area:load more","eventName":"technical specs:main content area:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"tech specs","internalLinkType":"technical specs:load more","internalLinkZoneName":"technical specs:main content area","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const articleLoadMoreAnalyticsData = '{"eventAction":"support:help and faq:article list:load more","eventName":"support:help and faq:article list:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"support:help and faq","internalLinkType":"support:help and faq:load more","internalLinkZoneName":"support:help and faq:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const defaultLoadMoreAnalyticsData = '{"eventAction":"plp load more","eventName":"plp load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"plp","internalLinkType":"plp:load more","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const getLoadMoreAnalyticsData = function() {
    let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", tab = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "products";
    let analyticsData = "";
    if (page === "search") {
        analyticsData = searchLoadMoreAnalyticsData(tab.toLowerCase());
    } else if (page === "technicalspecs") {
        analyticsData = technicalSpecLoadMoreAnalyticsData;
    } else if (page === "article") {
        analyticsData = articleLoadMoreAnalyticsData;
    } else {
        analyticsData = defaultLoadMoreAnalyticsData;
    }
    return analyticsData;
};


/***/ }),

/***/ 1306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15803);
/* harmony import */ var _components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ProductsPerPage = (param)=>{
    let { data =[] , texts , page , onChange , totalResults , curRows =30 , pos ="top" , selectedTab  } = param;
    const [filteredData, setFilteredData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const getAnalyticsData = function() {
        let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", all = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        limit = limit + "";
        let analyticsData = "";
        if (page === "search") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: limit,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventName: "search results:".concat(selectedTab, ":main content area:pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: texts.all,
                    internalLinkPosition: "search results",
                    internalLinkType: "search results:pagination ".concat(pos),
                    internalLinkZoneName: "search results:".concat(selectedTab, ":main content area"),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "technicalspecs") {
            if (!all) {
                analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"technical specs:main content area​:pagination","eventName":"technical specs:main content area​:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"tech spec","internalLinkType":"technical specs​:pagination ' + pos + '","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "favorites") {
            if (!all) {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(limit),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            } else {
                analyticsData = JSON.stringify({
                    eventAction: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventName: "my account:favorites:".concat(selectedTab, ":pagination"),
                    eventType: "navigation",
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    internalLinkName: "".concat(texts.all),
                    internalLinkPosition: "favorites",
                    internalLinkType: "my account:pagination bottom",
                    internalLinkZoneName: "my account:favorites:".concat(selectedTab),
                    internalLinkURL: "n/a",
                    clickInternalLinks: "true"
                });
            }
        } else if (page === "article") {
            analyticsData = JSON.stringify({
                eventAction: "support:help and faq:article list:pagination",
                eventName: "support:help and faq:article list:pagination",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: !all ? limit : texts.all,
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:pagination " + pos,
                internalLinkZoneName: "support:help and faq:article list",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            });
        } else if (page === "literature") {
            if (!all) {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"literature:pagination","eventName":"literature:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"literature","internalLinkType":"literature:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-release") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press releases:pagination","eventName":"press room:press releases:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press releases:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press releases:pagination","eventName":"press room:press releases:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press releases:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else if (page === "press-kits") {
            if (!all) {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"press room:press kits:pagination","eventName":"press room:press kits:pagination","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"press room","internalLinkType":"press room:press kits:pagination","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        } else {
            const internalLinkZoneName = pos === "top" ? '"plp:sticky nav filter"' : '"plp:promo tiles"';
            if (!all) {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + limit + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            } else {
                analyticsData = '{"eventAction":"plp pagination ' + pos + '","eventName":"plp pagination ' + pos + '","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"' + texts.all + '","internalLinkPosition":"plp","internalLinkType":"plp:pagination","internalLinkZoneName":' + internalLinkZoneName + ',"internalLinkURL":"n/a","clickInternalLinks":"true"}';
            }
        }
        return analyticsData;
    };
    const checkPaginationPosition = (limit)=>{
        onChange(limit);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const filteredKeys = data.filter((key)=>key < totalResults);
        setFilteredData(filteredKeys);
    }, [
        totalResults
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_ProductList_v2_ProductListView_ProductsPerPage_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().productPerPageWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "products-per-page",
            children: totalResults > 30 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                role: "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "disabled",
                        "aria-hidden": true,
                        children: texts.view
                    }),
                    filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((limit, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            "aria-disabled": curRows === limit,
                            role: "button",
                            tabIndex: "0",
                            "aria-label": "".concat(texts.view, " ").concat(limit, " ").concat(texts.items),
                            className: (curRows === limit && "disabled") + " gbh-data-layer",
                            "data-gbh-data-layer": getAnalyticsData(limit),
                            onClick: ()=>checkPaginationPosition(limit),
                            children: limit
                        }, i)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        role: "button",
                        tabIndex: "0",
                        "aria-label": "".concat(texts.view, " ").concat(texts.all, " ").concat(texts.items),
                        className: (curRows === totalResults && "disabled") + " gbh-data-layer",
                        "data-gbh-data-layer": getAnalyticsData("", true),
                        onClick: ()=>onChange(totalResults),
                        children: texts.all
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductsPerPage);


/***/ }),

/***/ 24751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stickyNavHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var lib = __webpack_require__(75198);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.jsx + 2 modules
var Sort = __webpack_require__(73812);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductListView/StickyNav/showHide.jsx







const ShowHide = (param)=>{
    let { showFilter , staticTexts , setShowFilter , ariaHaspopup , ariaExpanded , page , type , isSearchTab , isFaq =false  } = param;
    const filterButtonClass = classnames_default()({
        "product-listing__filter-toggle-text": true,
        "product-listing__filter-toggle-text--show": !showFilter
    });
    const [width] = (0,useWindowResize/* default */.Z)();
    const customProps = {};
    if (ariaHaspopup) Object.assign(customProps, {
        "aria-haspopup": dist_lib/* isTablet */.Em || dist_lib/* isMobile */.tq
    });
    if (ariaExpanded) Object.assign(customProps, {
        "aria-expanded": dist_lib/* isTablet */.Em || dist_lib/* isMobile */.tq ? false : showFilter
    });
    const getShowHideAnalyticsData = function(showFilterFlag) {
        let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        let analyticsData = {
            eventAction: "support:help and faq:filters:".concat(showFilterFlag ? "show" : "hide", " filter"),
            eventName: "support:help and faq:filters:".concat(showFilterFlag ? "show" : "hide", " filter"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(showFilterFlag ? "show" : "hide", " filter"),
            internalLinkPosition: "support:help and faq",
            internalLinkType: "support:help and faq:".concat(showFilterFlag ? "show" : "hide"),
            internalLinkZoneName: "support:help and faq:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        if (page === "search") {
            const pagetype = type;
            analyticsData = {
                eventAction: "search results:".concat(pagetype, ":filters:").concat(!showFilterFlag ? "show" : "hide", " filters"),
                eventName: "search results:".concat(pagetype, ":filters:").concat(!showFilterFlag ? "show" : "hide", " filters"),
                eventType: "navigation",
                eventStatus: "n/a",
                internalLinkName: "".concat(!showFilterFlag ? "show" : "hide", " filters"),
                internalLinkPosition: "search results page",
                internalLinkType: "search result page:".concat(!showFilterFlag ? "show filters" : "hide filters"),
                internalLinkZoneName: "search results:".concat(pagetype, ":filters"),
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        if (needJson) return analyticsData;
        return JSON.stringify(analyticsData);
    };
    const addAnalyticsForShowHideFilter = (showFilter)=>{
        const filterType = !showFilter ? "show" : "hide";
        const eventNameAndInternalLinkType = "plp:".concat(filterType);
        let eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(eventNameAndInternalLinkType, " filter"),
            eventName: "".concat(eventNameAndInternalLinkType, " filter"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(filterType, " filters"),
            internalLinkType: eventNameAndInternalLinkType,
            internalLinkURL: "n/a",
            internalLinkPosition: "plp",
            internalLinkZoneName: "plp:filters"
        };
        if (isSearchTab || isFaq) {
            eventInfo = getShowHideAnalyticsData(showFilter, true);
        }
        (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
        setShowFilter(!showFilter);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        id: "showFilter",
        "aria-label": !showFilter ? staticTexts.showFilter : staticTexts.hideFilter,
        className: "product-listing__filter-toggle",
        onClick: ()=>addAnalyticsForShowHideFilter(showFilter),
        ...customProps,
        children: [
            width > 991 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: filterButtonClass,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: showFilter ? "show" : "hide",
                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.hideFilter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: !showFilter ? "show" : "hide",
                        children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.showFilter
                    })
                ]
            }) : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                className: "product-listing__filter-toggle-icon",
                alt: "Toggle Filter"
            })
        ]
    });
};
/* harmony default export */ var showHide = (ShowHide);

// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./public/icons/search.svg
var search = __webpack_require__(83790);
// EXTERNAL MODULE: ./public/icons/grid-on.svg
var grid_on = __webpack_require__(7520);
// EXTERNAL MODULE: ./public/icons/grid-off.svg
var grid_off = __webpack_require__(8909);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductListView/StickyNav/stickyNavHeader.jsx










const StickyNavHeader = (param)=>{
    let { staticTexts ={} , totalResults =0 , showFilter =false , sorts , selectedSort , setShowFilter =()=>{} , handleSort =()=>{} , isSearchTab , page , type ="" , searchKeyword ="" , onSearch , pageId , showTotal =true , isFaq =false , setRowCols =()=>{} , rowCols =""  } = param;
    const [navSticky, setNavSticky] = (0,react.useState)(false);
    const [width] = (0,useWindowResize/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
        onFixedToggle: ()=>setNavSticky(!navSticky),
        className: "product-listing__sticky-nav-wrap",
        stickyStyle: {
            zIndex: 9
        },
        stickyClassName: "sticky sticky-plp-listing",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-fluid product-listing__sticky-nav ".concat(navSticky && "product-listing__sticky-nav--shadow"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-listing__row ".concat(isSearchTab && "search-result__search-flex"),
                children: [
                    navSticky && width < 813 && isSearchTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "search-result__search-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    role: "presentation",
                                    src: search/* default.src */.Z.src,
                                    alt: "search-icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                value: searchKeyword,
                                onChange: (e)=>onSearch(e.target.value)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: ()=>onSearch("", false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: icons_close/* default.src */.Z.src,
                                    alt: "close-icon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-plp-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-listing__col product-listing__controls ".concat(isSearchTab && "search-result__sticky-search-pd"),
                                children: [
                                    isSearchTab ? navSticky ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        "aria-label": totalResults + staticTexts.resultsCaps,
                                        className: "product-listing__total",
                                        children: [
                                            totalResults === null || totalResults === void 0 ? void 0 : totalResults.toLocaleString(),
                                            " ",
                                            staticTexts.resultsCaps
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}) : showTotal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.totalResults,
                                        className: "product-listing__total",
                                        children: [
                                            totalResults,
                                            " ",
                                            staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                    navSticky && width > 812 && isSearchTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "search-result__sticky-search",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    role: "presentation",
                                                    src: search/* default.src */.Z.src,
                                                    alt: "search-icon"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                value: searchKeyword,
                                                onChange: (e)=>onSearch(e.target.value)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                onClick: ()=>onSearch(""),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: icons_close/* default.src */.Z.src,
                                                    alt: "close-icon"
                                                })
                                            })
                                        ]
                                    }),
                                    !pageId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: "sorting-section ".concat(isFaq && "px-1"),
                                        children: [
                                            !isSearchTab && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "product-listing__fillter_sort",
                                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.filterSort
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(showHide, {
                                                showFilter: showFilter,
                                                staticTexts: staticTexts,
                                                setShowFilter: setShowFilter,
                                                isSearchTab: isSearchTab,
                                                page: page,
                                                type: type === null || type === void 0 ? void 0 : type.toLowerCase(),
                                                isFaq: isFaq
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                                tabIndex: "0",
                                                data: sorts,
                                                selectedSort: selectedSort,
                                                texts: staticTexts,
                                                onChange: handleSort,
                                                page: page,
                                                selectedtab: type,
                                                isSearch: isSearchTab
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-listing__grid-control",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-block d-sm-none",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        onClick: ()=>setRowCols(rowCols === 1 ? 2 : 1),
                                                        className: "product-listing__grid-control-icon",
                                                        src: rowCols > 1 ? grid_on/* default.src */.Z.src : grid_off/* default.src */.Z.src,
                                                        alt: ""
                                                    })
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var stickyNavHeader = (StickyNavHeader);


/***/ }),

/***/ 75535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_ProductTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
// EXTERNAL MODULE: ./src/components/core/Highlight/Highlight.jsx
var Highlight = __webpack_require__(293);
// EXTERNAL MODULE: ./src/components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(45138);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(13678);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./public/images/swatch-missing.jpeg
var swatch_missing = __webpack_require__(36562);
// EXTERNAL MODULE: ./public/icons/share.svg
var share = __webpack_require__(66773);
// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(5702);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductTile/localization.js
const getTranslations = (t)=>{
    return {
        familyResults: t("kf.viewFamilyResults"),
        viewSterlingResults: t("kf.viewSterlingResults"),
        items: t("kf.plp.items", "Items"),
        bundle: t("kf.plp.bundle", "Bundle"),
        refPrice: t("kf.pdp.label.refPrice", "List"),
        percentOff: t("kf.pdp.label.percentOff", "OFF"),
        inclusiveOfAllTaxes: t("kf.pdp.label.inclusiveOfAllTaxes", "Inclusive of all taxes"),
        shopNow: t("kf.plp.label.shopNow", "Shop Now")
    };
};

// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductTile/serverActions.js
const getImageData = function(data, returnType) {
    let plpPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, defaultImage = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "IMGITEMISO";
    const sku = data["sku_s"] ? data["sku_s"] : data["preferenceSku_s"] || data["masterSKU_s"];
    let imagestmp = [];
    let setImagesData = [];
    let setImgUrlData = "";
    const setImages = (d)=>setImagesData = d;
    const setImgUrl = (d)=>setImgUrlData = d;
    const productVariantImages = data["productImages.labelWithUrl_s"] ? [
        data["productImages.labelWithUrl_s"]
    ] : data["productImages.labelWithUrl_ss"];
    let setDefaultProductImage = "";
    let setHoverProductImage = "";
    let isHover = true;
    if ((productVariantImages === null || productVariantImages === void 0 ? void 0 : productVariantImages.length) > 0) {
        const variantImages = productVariantImages.filter((img)=>sku === img.split("|")[0]);
        if (plpPage) {
            variantImages.find((img)=>{
                const imgDetails = img.split("|");
                if (imgDetails[2] === defaultImage) {
                    setImgUrl(imgDetails[5]);
                    return setDefaultProductImage = imgDetails[1];
                } else {
                    setDefaultProductImage = variantImages[0].split("|")[1];
                    setImgUrl(variantImages[0].split("|")[5]);
                }
            });
        } else {
            productVariantImages.find((img)=>{
                const imgDetails = img.split("|");
                if (sku === imgDetails[0]) {
                    setImgUrl(imgDetails[5]);
                    return setDefaultProductImage = imgDetails[1];
                }
            });
        }
        imagestmp.push(setDefaultProductImage);
        if (plpPage) {
            if (setHoverProductImage === "") {
                isHover = false;
            }
            isHover === false ? imagestmp.push(setDefaultProductImage) : imagestmp.push(setHoverProductImage);
        }
    } else {
        imagestmp = [
            "MissingImage"
        ];
    }
    setImages(imagestmp);
    if (returnType === "url") {
        return setImgUrlData;
    } else {
        return setImagesData;
    }
};
const getColorData = function(data) {
    let SWATCH_NA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "swatch_NA";
    let colorsTemp = [];
    if (data["Color.SKU.Details_ss"]) {
        colorsTemp = data["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                isDiscontinued: d[4],
                customerFacingSKU: d[5]
            };
        });
    } else if (data["Color.SKU.Details_s"]) {
        const d = data["Color.SKU.Details_s"].split("|");
        colorsTemp = [
            {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                isDiscontinued: d[4],
                customerFacingSKU: d[5]
            }
        ];
    } else if (data["SKU.Details_ss"]) {
        colorsTemp = data["SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                name: "",
                swatch: SWATCH_NA,
                sku: d[0],
                isStock: d[1],
                isDiscontinued: d[2],
                customerFacingSKU: d[3]
            };
        });
    }
    const colorsTempVal = colorsTemp.filter((item)=>{
        var ref;
        return ((ref = item.swatch) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== SWATCH_NA.toLowerCase() && (item.isDiscontinued === "false" || Date.parse(item.isDiscontinued) > Date.now());
    });
    return colorsTempVal;
};

;// CONCATENATED MODULE: ./components/ProductList/v2/ProductTile/index.jsx































const ProductTile = (props)=>{
    var ref;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { data , texts , lite , loading , addToCompare , removeFromCompare , compareData , highlightText , hideCompare , currencySign , isGrouped , rowCols , presetConfigs ="{}" , isPartsDiagramLinkVisible =false , swatchCount , plpPage , defaultImage , hoverImage , mapImageToColor , currFilters , favorites , exactSKU , type , selectedtab , handleOnClickPartsDiagramLink , favPage , index , selectedSort , onToggle , isSearchPanelTile , isSterling =false , sterlingData =[] , showSterlingButton =false , parent ="" , utilitywidgets =[] , plpBadge ={} , searchPagePath ="" , categoryKey , fetchPriority ="auto" , setPdpLoading =()=>{}  } = props;
    const { plpBadges ={} , displayOrderBadgeList =[]  } = plpBadge;
    plpBadges.bundle = {
        value: staticText.bundle
    };
    const router = (0,next_router.useRouter)();
    const { isAuth , access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { toaster  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [general, setGeneral] = (0,react.useState)({
        swatchUrl: "https://kohler.scene7.com/is/image/PAWEB/",
        siteName: "Kohler"
    });
    const [tileUrl, setTileUrl] = (0,react.useState)(data.slug_s);
    const [locale, setLocale] = (0,react.useState)("en-US");
    const [width] = (0,useWindowResize/* default */.Z)();
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    const { comparedProducts , isEnable  } = compareData;
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [showShare, setShowShare] = (0,react.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    const [onHover, setOnHover] = (0,react.useState)(false);
    const [hoverColor, setHoverColor] = (0,react.useState)({});
    const [selectedColor, setSelectedColor] = (0,react.useState)({});
    const EMPTY_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const [sku, setSku] = (0,react.useState)(data["preferenceSku_s"] || data["masterSKU_s"]);
    const [masterCustomerFacingSku, setMasterCustomerFacingSku] = (0,react.useState)("");
    const [productCategory, setProductCategory] = (0,react.useState)("");
    const [colorDetail, setColorDetail] = (0,react.useState)([]);
    const [colorCount, setColorCount] = (0,react.useState)(swatchCount || 7);
    const [persona, setPersona] = (0,react.useState)("");
    const [images, setImages] = (0,react.useState)(getImageData(data));
    const dispatch = (0,es/* useDispatch */.I0)();
    const [selColor, setSelColor] = (0,react.useState)("");
    const [variantPrice, setVariantPrice] = (0,react.useState)(0);
    const [variantDiscPrice, setVariantDiscPrice] = (0,react.useState)(0);
    const [colors, setColors] = (0,react.useState)(getColorData(data, constants.SWATCH_NA));
    const [selSku, setSelSku] = (0,react.useState)(data["preferenceSku_s"] || data["masterSKU_s"]);
    const [selCustomerFacingSKU, setSelCustomerFacingSKU] = (0,react.useState)("");
    const [tileTitle, setTileTitle] = (0,react.useState)("");
    const [productName, setProductName] = (0,react.useState)(((ref = data["bundleNameSlugDetails_ss"]) === null || ref === void 0 ? void 0 : ref.length) > 0 ? (0,helper.getBundleProductName)(data, selSku) : isGrouped ? get_default()(data, "Collapse_Title_s", "") : get_default()(data, "ProductBrandName_s", get_default()(data, "productName_s", "")));
    const [description, setDescription] = (0,react.useState)(isGrouped ? get_default()(data, "Collapse_Description_s", "") : get_default()(data, "ProductDescriptionProductShort_s", ""));
    const [category, setCategory] = (0,react.useState)("");
    const [shipmentDate, setShipmentDate] = (0,react.useState)("");
    const [badgeVal, setBadgeVal] = (0,react.useState)("");
    const [discountedPrice, setDiscountedPrice] = (0,react.useState)(0);
    const [finalPrice, setFinalPrice] = (0,react.useState)(0);
    const [price, setPrice] = (0,react.useState)(0);
    const [isFavorite, setIsFavorite] = (0,react.useState)(false);
    const [isDiscountedPrice, setIsDiscountedPrice] = (0,react.useState)(0);
    const [detaultSelectedColor, setDetaultSelectedColor] = (0,react.useState)("");
    const [defaultCustomerFacingSku, setDefaultCustomerFacingSku] = (0,react.useState)("");
    const [defaultImageTmp, setDefaultImageTmp] = (0,react.useState)("");
    const [defaultProductIsInStock, setDefaultProductIsInStock] = (0,react.useState)(false);
    const [discountPercent, setDiscountPercent] = (0,react.useState)(0);
    const [discountPriceState, setDiscountPriceState] = (0,react.useState)(0);
    const [productIsRetail, setProductIsRetail] = (0,react.useState)(false);
    const [isSuperSku, setIsSuperSku] = (0,react.useState)(false);
    const [discountAmount, setDiscountAmount] = (0,react.useState)(0);
    const [productSaleable, setProductSaleable] = (0,react.useState)(true);
    const [productRoom, setProductRoom] = (0,react.useState)("");
    const [productCollectionsName, setProductCollectionsName] = (0,react.useState)("");
    const [maxPrice, setMaxPrice] = (0,react.useState)(0);
    const [discountedMaxPrice, setDiscountedMaxPrice] = (0,react.useState)(0);
    const triggerAnalytics = (0,react.useRef)(null);
    const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
    const [imgUrl, setImgUrl] = (0,react.useState)(getImageData(data, "url"));
    const [isBrandEnabled, setIsBrandEnabled] = (0,react.useState)(null);
    const [isInstallationAvailable, setIsInstallationAvailable] = (0,react.useState)(null);
    const handleFavorite = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.preActiveElement = e.target;
        if (isFavorite === true) {
            favorites === null || favorites === void 0 ? void 0 : favorites.map((fav)=>{
                if (fav.productId === data["ctId_s"]) {
                    if (!isAuth) {
                        handleLogin(e);
                    } else {
                        dispatch((0,favoritesSlice/* removeItems */.Er)([
                            fav.id
                        ])).unwrap().then(()=>{
                            handleCallBack("success", texts.removeItem);
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: toasterContent.unfavoriteSuccessMessage || texts.removeItem,
                                isVisible: true
                            }));
                        }).catch((err)=>{
                            dispatch((0,genericSlice/* showToast */.CF)({
                                message: texts.removeItemError,
                                isVisible: true
                            }));
                            handleCallBack("failure", texts.removeItemError);
                        });
                    }
                }
            });
        } else {
            if (!isAuth) {
                handleLogin(e);
            } else {
                dispatch((0,favoritesSlice/* addProduct */.gK)(sku)).unwrap().then(()=>{
                    handleCallBack("success", texts.favSuccessMsg);
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: toasterContent.successMessage || texts.favSuccessMsg,
                        isVisible: true
                    }));
                }).catch((err)=>{
                    console.log(err, "err");
                    dispatch((0,genericSlice/* showToast */.CF)({
                        message: texts.favErrorMsg,
                        isVisible: true
                    }));
                    handleCallBack("failure", texts.favErrorMsg);
                });
            }
        }
        window.loginFavouriteCallback = null;
        setLoginFavouriteCallback(null);
    };
    const handleCallBack = (status, message)=>{
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        let isForSample = false;
        if (page && (page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategory1)) {
            const { category: { subCategory1  }  } = page;
            isForSample = subCategory1.includes("samples");
        }
        const eventInfo = getEventInfo("favorite", null, true, isForSample);
        const productInfo = getProductInfo(selectedColor, true);
        eventInfo.eventStatus = status;
        eventInfo.eventMsg = (0,helper.sanitizeTextForAnalytics)(message);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const handleViewSterlingResults = ()=>{
        const sterlingLink = utilitywidgets.filter((item)=>item.brandName.toLowerCase() === sterlingData[0].Brand_ss[0].toLowerCase())[0].link;
        window.open(sterlingLink + "?keyword=".concat(sterlingData[0].sku_s), "_blank");
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
            setLocale(get_default()(config, "internationalization.locale", ""));
            setIsBrandEnabled(get_default()(config, "general.isEnableBrand", ""));
        });
        setToasterMessage();
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(accessToken)) {
            setPersona((0,helper.getUserPersona)());
        }
    }, [
        accessToken
    ]);
    (0,react.useEffect)(()=>{
        if (loginFavouriteCallback && isAuth) {
            handleFavorite(loginFavouriteCallback);
        }
    }, [
        loginFavouriteCallback,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (selectedColor && triggerAnalytics.current) {
            colorClickHandler(selectedColor);
        }
    }, [
        selectedColor
    ]);
    const setToasterMessage = async ()=>{
        if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
            setToasterContent({
                successMessage: await (0,helper.getShortenedUrl)(successMessage),
                unfavoriteSuccessMessage: await (0,helper.getShortenedUrl)(unfavoriteSuccessMessage)
            });
        }
    };
    (0,react.useEffect)(()=>{
        let tempSku = data["preferenceSku_s"] || data["masterSKU_s"];
        if (data["sku_s"]) {
            tempSku = data["sku_s"];
        }
        setSku(tempSku);
        var ref;
        setMasterCustomerFacingSku((ref = data["masterSKU_s"]) !== null && ref !== void 0 ? ref : "");
        setProductCategory(get_default()(data, "Product_Category", ""));
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(persona)) {
            var ref;
            setColorDetail((ref = data["Color.".concat(persona, ".Details_ss")]) !== null && ref !== void 0 ? ref : []);
        }
    }, [
        data,
        persona
    ]);
    (0,react.useEffect)(()=>{
        if (!sku) return;
        let imagestmp = [];
        const productVariantImages = data["productImages.labelWithUrl_s"] ? [
            data["productImages.labelWithUrl_s"]
        ] : data["productImages.labelWithUrl_ss"];
        let setDefaultProductImage = "";
        let setHoverProductImage = "";
        let isHover = true;
        if ((productVariantImages === null || productVariantImages === void 0 ? void 0 : productVariantImages.length) > 0) {
            const variantImages = productVariantImages.filter((img)=>sku === img.split("|")[0]);
            if (plpPage) {
                variantImages.find((img)=>{
                    const imgDetails = img.split("|");
                    if (imgDetails[2] === defaultImage) {
                        setImgUrl(imgDetails[5]);
                        return setDefaultProductImage = imgDetails[1];
                    } else {
                        setDefaultProductImage = variantImages[0].split("|")[1];
                        setImgUrl(variantImages[0].split("|")[5]);
                    }
                });
                productVariantImages.find((img)=>{
                    const imgDetails = img.split("|");
                    if (imgDetails[2] === hoverImage) {
                        return setHoverProductImage = imgDetails[1];
                    }
                });
            } else {
                productVariantImages.find((img)=>{
                    const imgDetails = img.split("|");
                    if (sku === imgDetails[0]) {
                        setImgUrl(imgDetails[5]);
                        return setDefaultProductImage = imgDetails[1];
                    }
                });
            }
            imagestmp.push(setDefaultProductImage);
            if (plpPage) {
                if (setHoverProductImage === "") {
                    isHover = false;
                }
                isHover === false ? imagestmp.push(setDefaultProductImage) : imagestmp.push(setHoverProductImage);
            }
        } else {
            imagestmp = [
                "MissingImage"
            ];
        }
        if (mapImageToColor && currFilters) {
            const colorFilter = currFilters.find((q)=>(0,helper.isColorFacet)(q.facet));
            const selColors = colorFilter === null || colorFilter === void 0 ? void 0 : colorFilter.value;
            if ((selColors === null || selColors === void 0 ? void 0 : selColors.length) > 0) {
                let selectedProductImage = "";
                var ref;
                let i = (ref = (selColors === null || selColors === void 0 ? void 0 : selColors.length) - 1) !== null && ref !== void 0 ? ref : 0;
                let variantPriceTmp = 0;
                let variantDiscPriceTmp = 0;
                while(!selectedProductImage && i >= 0){
                    const colorName = selColors[i];
                    if (colorDetail === null || colorDetail === void 0 ? void 0 : colorDetail.length) {
                        var ref1, ref2;
                        var ref3;
                        const exactSKUDetails = (ref3 = (ref1 = colorDetail.find((item)=>item.split("|")[1] === colorName)) === null || ref1 === void 0 ? void 0 : ref1.split("|")) !== null && ref3 !== void 0 ? ref3 : [];
                        setSelColor(selColors[i]);
                        var ref4;
                        const productId = (ref4 = (ref2 = exactSKUDetails[5]) === null || ref2 === void 0 ? void 0 : ref2.split("?")[0].split("/").slice(-1)) !== null && ref4 !== void 0 ? ref4 : [];
                        var ref5;
                        selectedProductImage = (ref5 = productId[0]) !== null && ref5 !== void 0 ? ref5 : "";
                        var ref6;
                        variantPriceTmp = (ref6 = exactSKUDetails[2]) !== null && ref6 !== void 0 ? ref6 : 0;
                        var ref7;
                        variantDiscPriceTmp = (ref7 = exactSKUDetails[3]) !== null && ref7 !== void 0 ? ref7 : 0;
                    }
                    i--;
                }
                setVariantPrice(variantPriceTmp);
                setVariantDiscPrice(variantDiscPriceTmp);
                if (!selectedProductImage) selectedProductImage = "MissingImage";
                if (imagestmp[0] === imagestmp[1]) {
                    imagestmp = [
                        selectedProductImage,
                        selectedProductImage
                    ];
                } else {
                    imagestmp[0] = selectedProductImage;
                }
            }
        }
        setImages(imagestmp);
        let colorsTemp = [];
        if (data["Color.SKU.Details_ss"]) {
            colorsTemp = data["Color.SKU.Details_ss"].map((color)=>{
                const d = color.split("|");
                return {
                    name: d[0],
                    swatch: d[1],
                    sku: d[2],
                    isStock: d[3],
                    isDiscontinued: d[4],
                    customerFacingSKU: d[5]
                };
            });
        } else if (data["Color.SKU.Details_s"]) {
            const d = data["Color.SKU.Details_s"].split("|");
            colorsTemp = [
                {
                    name: d[0],
                    swatch: d[1],
                    sku: d[2],
                    isStock: d[3],
                    isDiscontinued: d[4],
                    customerFacingSKU: d[5]
                }
            ];
        } else if (data["SKU.Details_ss"]) {
            colorsTemp = data["SKU.Details_ss"].map((color)=>{
                const d = color.split("|");
                return {
                    name: "",
                    swatch: constants.SWATCH_NA,
                    sku: d[0],
                    isStock: d[1],
                    isDiscontinued: d[2],
                    customerFacingSKU: d[3]
                };
            });
        }
        const colorsTempVal = colorsTemp.filter((item)=>{
            var ref;
            return ((ref = item.swatch) === null || ref === void 0 ? void 0 : ref.toLowerCase()) !== constants.SWATCH_NA.toLowerCase() && (item.isDiscontinued === "false" || Date.parse(item.isDiscontinued) > Date.now());
        });
        setColors(colorsTempVal);
        setTileTitle(get_default()(data, "Tile_Title", ""));
        // setProductName(
        //   isGrouped
        //     ? _get(data, "Collapse_Title_s", "")
        //     : _get(data, "ProductBrandName_s", _get(data, "productName_s", ""))
        // )
        if (isSterling && sterlingData.length > 0) {
            setProductName(sterlingData[0].ProductBrandName_s);
        }
        setDescription(isGrouped ? get_default()(data, "Collapse_Description_s", "") : get_default()(data, "ProductDescriptionProductShort_s", ""));
        var _ProductLocalCategory_s;
        setCategory(data.Product_Category ? data.Product_Category : (_ProductLocalCategory_s = data.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "");
        setShipmentDate(get_default()(data, "RegionReleaseforShipment_dt", ""));
        const isInstallation = get_default()(data, "InstallationAvailable_s", "") === "Yes" ? true : false;
        setIsInstallationAvailable(isInstallation);
        setBadgeVal(get_default()(data, "priceList.".concat(persona, ".saleOffer_s"), ""));
        var ref8;
        const colorPricing = (ref8 = data["Color.".concat(persona, ".Details_ss")]) !== null && ref8 !== void 0 ? ref8 : [];
        const selSkuDetails = colorPricing.find((item)=>{
            return item.split("|")[0] === selSku;
        });
        const personaprice = selSkuDetails === null || selSkuDetails === void 0 ? void 0 : selSkuDetails.split("|")[3];
        const mrpprice = selSkuDetails === null || selSkuDetails === void 0 ? void 0 : selSkuDetails.split("|")[2];
        setDiscountedPrice(personaprice);
        setFinalPrice(mrpprice);
        setPrice(get_default()(data, "priceStartingAt.".concat(persona, "_d"), 0));
        setIsFavorite((favorites === null || favorites === void 0 ? void 0 : favorites.find((vl)=>vl.productId === data["ctId_s"])) ? true : false);
        setIsDiscountedPrice(get_default()(data, "priceList.".concat(persona, ".discountedPrice_d"), 0));
        const discountpercent = (Number(mrpprice) - Number(personaprice)) / Number(mrpprice) * 100;
        setDiscountPercent(Number(discountpercent).toFixed());
        setDiscountPriceState(Number(discountpercent) > 0 ? "percentOff|" + Number(discountpercent).toFixed() : "regular price");
        setProductIsRetail(get_default()(data, "ProductIsRetail", "") === "true" ? true : false);
        setIsSuperSku(get_default()(data, "comboSKUAvailable_b", null) ? true : false);
        setDiscountAmount(discountPercent ? Number((price - isDiscountedPrice).toFixed(2)) : 0);
        setProductRoom(get_default()(data, "category1_s", "n/a"));
        setProductCollectionsName(get_default()(data, "ProductBrandNameDisplay_s", "n/a"));
    }, [
        sku,
        data,
        mapImageToColor,
        currFilters,
        isGrouped,
        favorites,
        hoverColor,
        colorDetail
    ]);
    // Update price on hover
    (0,react.useEffect)(()=>{
        if (!sku) {
            return;
        }
        if (isGrouped) {
            setFinalPrice(get_default()(data, "min_price", 0));
            setMaxPrice(get_default()(data, "max_price", 0));
            setDiscountedPrice(get_default()(data, "disc_min_price", 0));
            setDiscountedMaxPrice(get_default()(data, "disc_max_price", 0));
        } else if (mapImageToColor && (selColor || hoverColor) && variantPrice > 0) {
            if (hoverColor) {
                var ref;
                var ref1;
                const exactSKUDetails = (ref1 = (ref = colorDetail === null || colorDetail === void 0 ? void 0 : colorDetail.find((item)=>item.split("|")[0] === hoverColor.sku)) === null || ref === void 0 ? void 0 : ref.split("|")) !== null && ref1 !== void 0 ? ref1 : [];
                setImgUrl(exactSKUDetails[5]);
            }
            const discountpercent = (Number(variantPrice) - Number(variantDiscPrice)) / Number(variantPrice) * 100;
            setDiscountPercent(Number(discountpercent).toFixed());
            setFinalPrice(variantPrice);
            setDiscountedPrice(variantDiscPrice);
        } else if (exactSKU) {
            var ref2;
            const exactSKUDetails1 = (ref2 = colorDetail.find((item)=>item.split("|")[0] === sku).split("|")) !== null && ref2 !== void 0 ? ref2 : [];
            var ref3;
            setFinalPrice((ref3 = exactSKUDetails1[2]) !== null && ref3 !== void 0 ? ref3 : 0);
            var ref4;
            setDiscountedPrice((ref4 = exactSKUDetails1[3]) !== null && ref4 !== void 0 ? ref4 : 0);
            var ref5, ref6, ref7;
            const discountpercent1 = (Number((ref5 = exactSKUDetails1[2]) !== null && ref5 !== void 0 ? ref5 : 0) - Number((ref6 = exactSKUDetails1[3]) !== null && ref6 !== void 0 ? ref6 : 0)) / Number((ref7 = exactSKUDetails1[2]) !== null && ref7 !== void 0 ? ref7 : 0) * 100;
            setDiscountPercent(Number(discountpercent1).toFixed());
        }
    }, [
        data,
        hoverColor,
        selColor,
        variantPrice,
        exactSKU,
        sku,
        mapImageToColor,
        isGrouped,
        colorDetail,
        variantDiscPrice
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(general)) {
            (0,helper.getPDPUrlForProductTile)(data, selSku).then((ret)=>setTileUrl(ret));
        }
    }, [
        general,
        data,
        selSku
    ]);
    (0,react.useEffect)(()=>{
        setDefaultImageTmp(images.length ? images[0] : "");
    }, [
        images
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        if (mapImageToColor && selColor && selColor !== "Not Applicable") {
            var ref2;
            const selColorDetails = (ref2 = colors.find((item)=>item.name === selColor)) !== null && ref2 !== void 0 ? ref2 : {};
            setSelSku(selColorDetails === null || selColorDetails === void 0 ? void 0 : selColorDetails.sku);
            setSelCustomerFacingSKU(selColorDetails === null || selColorDetails === void 0 ? void 0 : selColorDetails.customerFacingSKU);
        } else {
            const currentSku = selectedColor && selectedColor.sku ? selectedColor.sku : sku;
            setSelSku(currentSku);
            setSelCustomerFacingSKU(masterCustomerFacingSku);
        }
        setDetaultSelectedColor(colors.length ? (ref = colors[0]) === null || ref === void 0 ? void 0 : ref.name : "");
        setDefaultCustomerFacingSku(colors.length ? (ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.customerFacingSKU : "");
        setDefaultProductIsInStock(colors.length ? colors[0].isStock === "true" || colors[0].isStock === true : false);
        setProductSaleable(productIsRetail || !colors.length ? false : true);
    }, [
        mapImageToColor,
        masterCustomerFacingSku,
        selColor,
        sku,
        colors,
        productIsRetail
    ]);
    const [pageRedirectUrl, setPageRedirectUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const pageredirectUrlVal = (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "parts" ? "".concat(tileUrl).concat(selSku ? "?skuId=" + selSku : "?skuId=" + sku) : "".concat(tileUrl).concat(selSku ? "?skuId=" + selSku : "");
        setPageRedirectUrl(pageredirectUrlVal);
    }, [
        data,
        type,
        tileUrl,
        selSku
    ]);
    const cartData = (0,es/* useSelector */.v9)((state)=>state.cart.data);
    // Update image on Hover
    const setSelected = (color)=>{
        var ref, ref1;
        var ref2;
        const skuDetails = (ref2 = (ref = colorDetail.find((item)=>item.split("|")[0] === color.sku)) === null || ref === void 0 ? void 0 : ref.split("|")) !== null && ref2 !== void 0 ? ref2 : [];
        var ref3;
        const productId = (ref3 = (ref1 = skuDetails[5]) === null || ref1 === void 0 ? void 0 : ref1.split("?")[0].split("/").slice(-1)) !== null && ref3 !== void 0 ? ref3 : [];
        var ref4;
        const selProdImage = (ref4 = productId[0]) !== null && ref4 !== void 0 ? ref4 : "MissingImage";
        let imgValSelected = images;
        if (imgValSelected[0] === imgValSelected[1]) {
            imgValSelected = [
                selProdImage,
                selProdImage
            ];
        } else {
            imgValSelected[0] = selProdImage;
        }
        setImages(imgValSelected);
        if (!isGrouped) {
            var ref5;
            setVariantPrice((ref5 = skuDetails[2]) !== null && ref5 !== void 0 ? ref5 : 0);
            var ref6;
            setVariantDiscPrice((ref6 = skuDetails[3]) !== null && ref6 !== void 0 ? ref6 : 0);
        }
    };
    (0,react.useEffect)(()=>{
        if (hoverColor) {
            setSelected(hoverColor);
        } else if (selectedColor) {
            setSelected(selectedColor);
        }
    }, [
        hoverColor
    ]);
    (0,react.useEffect)(()=>{
        const compareSku = selSku !== "" ? selSku : sku;
        if (comparedProducts.find((prod)=>prod.compareSku === compareSku)) {
            setIsChecked(true);
        } else {
            setIsChecked(false);
        }
    }, [
        comparedProducts,
        data,
        selSku,
        sku
    ]);
    (0,react.useEffect)(()=>{
        setHoverColor("");
        setSelectedColor("");
    }, [
        currFilters,
        selectedSort
    ]);
    const colorSwatchDefaultImg = (e)=>{
        e.target.src = swatch_missing/* default.src */.Z.src;
    };
    const handleCompare = (event, sku)=>{
        setIsChecked(!isChecked);
        if (event.target.checked) {
            if (comparedProducts.length < 4) {
                if (compareData.category !== "" && compareData.category !== productCategory) {
                    setErrorMessage(texts.sameCategory);
                    setTimeout(()=>{
                        setErrorMessage("");
                    }, 2000);
                    setIsChecked(false);
                    removeFromCompare(sku);
                } else {
                    var ref;
                    addToCompare(sku, (ref = data === null || data === void 0 ? void 0 : data.RegionOnBackOrder_s) !== null && ref !== void 0 ? ref : false, imgUrl, categoryKey);
                }
            } else {
                setErrorMessage(texts.maxProduct);
                setTimeout(()=>{
                    setErrorMessage("");
                }, 2000);
                setIsChecked(false);
                removeFromCompare(sku);
            }
        } else {
            removeFromCompare(sku);
        }
        handleAnalytics("compare");
    };
    const handleAnalytics = (type)=>{
        try {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventInfo = getEventInfo(type, null, true);
            const productInfo = getProductInfo(selectedColor, true);
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo
            });
        } catch (err) {
            console.log(err);
        }
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.loginFavouriteCallback = ()=>{
            setLoginFavouriteCallback(e);
        };
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowShare(true);
        handleAnalytics("share");
    };
    const redirectPDP = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        window.location.href = pageRedirectUrl;
        const params = new URLSearchParams(window.location.search);
        params.set("back", masterCustomerFacingSku);
        window.history.replaceState(window.location.pathname, document.title, "?".concat(params.toString()));
        if (isSearchPanelTile) {
            onToggle();
        }
    };
    const handleMouseLeave = ()=>{
        onHover && setOnHover(false);
        setShowShare(false);
    };
    const handlehoverImgFunction = ()=>{
        try {
            const hoverImgLists = document.querySelectorAll("#kf-product-list-tile-wrapper-".concat(data["ctId_s"], " img.product-list-tile__hoverimg"));
            if (hoverImgLists.length > 0) {
                const hoverImg = hoverImgLists[0];
                const hoverSrc = hoverImg.getAttribute("imgsrc");
                const hoverSrcAlt = hoverImg.getAttribute("imgalt");
                hoverImg.src = hoverSrc;
                hoverImg.alt = hoverSrcAlt;
            }
        } catch (error) {
            console.log(error);
        }
    };
    const handleMouseEnter = ()=>{
        handlehoverImgFunction() && setOnHover(true);
    };
    const handleTouchStart = ()=>{
        handlehoverImgFunction() && setOnHover(true);
    };
    const handleTouchEnd = ()=>{
        onHover && setOnHover(false);
        setShowShare(false);
    };
    const presetConf = JSON.parse(presetConfigs);
    const getEventInfo = function(type, color) {
        let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isForSample = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        /**
     * type is default navigation, could be favorite or share
     * color is optional, could be selected color from plp or search page product
     * needsJSON returns either JSON or stringified value
     */ let alternameType;
        let compareInternalLinkName;
        if (type === "favorite") {
            if (isFavorite) {
                alternameType = "favorite remove";
            } else {
                alternameType = "favorite add";
            }
        } else if (type === "compare") {
            if (isChecked) {
                alternameType = "compare remove";
                compareInternalLinkName = "remove compare";
            } else {
                alternameType = "compare add";
                compareInternalLinkName = "add to compare";
            }
        }
        let selectedTab;
        let pageSection;
        if (favPage && selectedtab) {
            pageSection = "favorites";
            selectedTab = selectedtab.toLowerCase();
        }
        const plpPrefix = isForSample ? "plp:sample" : "plp";
        const selectedTabForSearchResults = "products";
        let internalLinkZoneName = "";
        if (selectedTab) internalLinkZoneName = "my account:".concat(pageSection, ":").concat(selectedTab, ":main content area");
        else if (plpPage) internalLinkZoneName = "".concat(plpPrefix, ":promo tiles");
        else if (parent.toLowerCase() === "utility widgets") internalLinkZoneName = "search results:top product results";
        else if (type === "share") internalLinkZoneName = "search results:products:share";
        else internalLinkZoneName = "search results:".concat(selectedTabForSearchResults, ":").concat(type === "share" ? "share" : "main content area");
        const colorSelection = color ? "color selection" : alternameType || (0,helper.sanitizeTextForAnalytics)(type || productName);
        const eventInfo = {
            eventAction: "".concat(pageSection ? "my account:" + pageSection + ":" : (plpPage ? plpPrefix : "search results") + (isForSample ? ":" : " "), "product ").concat(alternameType || type || "navigation"),
            eventName: "".concat(pageSection ? "my account:" + pageSection + ":" : (plpPage ? plpPrefix : "search results") + (isForSample ? ":" : " "), "product ").concat(alternameType || type || "navigation"),
            eventType: isForSample || type === "favorite" ? "wishlist save" : "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type === "compare" ? compareInternalLinkName : type === "service parts" ? type : colorSelection,
            internalLinkPosition: selectedTab !== null && selectedTab !== void 0 ? selectedTab : plpPage ? plpPrefix : "search results",
            internalLinkType: pageSection ? "my accounts:navigation" : "".concat(plpPage ? plpPrefix : "search results", ":").concat(type || (plpPage ? "navigation" : "product tiles")),
            internalLinkZoneName,
            internalLinkURL: !type ? ((tileUrl === null || tileUrl === void 0 ? void 0 : tileUrl.indexOf("http")) === -1 ? window.location.origin : "") + tileUrl + (color ? "?skuId=" + color.sku : selSku ? "?skuId=" + selSku : "") : "n/a",
            clickInternalLinks: "true"
        };
        if (needsJSON) {
            eventInfo.custom = getProductInfo();
            return eventInfo;
        }
        return JSON.stringify(eventInfo);
    };
    const getProductInfo = function(color) {
        let needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref, ref1, ref2;
        const { productCouponCode , productCoupondiscount  } = (0,helper.getCurrentSkuCouponDiscounts)({
            cart: cartData,
            sku: sku,
            locale: locale
        });
        var ref3;
        const colorDetail = (ref3 = data["Color.SKU.Details_ss"]) !== null && ref3 !== void 0 ? ref3 : [];
        var ref4;
        const colorName = color ? (ref4 = (ref = colorDetail.find((item)=>item.split("|")[2] === color.sku)) === null || ref === void 0 ? void 0 : ref.split("|")[0]) !== null && ref4 !== void 0 ? ref4 : "" : "";
        var ref5;
        const inStock = color ? (ref5 = (ref1 = colorDetail.find((item)=>item.split("|")[2] === color.sku)) === null || ref1 === void 0 ? void 0 : ref1.split("|")[3]) !== null && ref5 !== void 0 ? ref5 : "" : "";
        const description = isGrouped ? get_default()(data, "Collapse_Description_s", "") : get_default()(data, "ProductDescriptionProductShort_s", "");
        var ref6;
        const productInfo = {
            productInfo: {
                productBrand: general === null || general === void 0 ? void 0 : (ref2 = general.siteName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(),
                description: (0,helper.sanitizeTextForAnalytics)(description) || "n/a",
                globalPromotionPrice: Number(discountedPrice ? discountedPrice : finalPrice),
                priceState: discountPriceState,
                productBasePrice: Number(finalPrice),
                productCategory: (0,helper.sanitizeTextForAnalytics)(category) || "n/a",
                productColor: (0,helper.sanitizeTextForAnalytics)(colorName ? colorName : detaultSelectedColor) || "n/a",
                productID: (color ? color.customerFacingSKU : defaultCustomerFacingSku) || ((ref6 = data["masterSKU_s"]) !== null && ref6 !== void 0 ? ref6 : "n/a"),
                productName: (0,helper.sanitizeTextForAnalytics)(productName) || "n/a",
                productRoom: (0,helper.sanitizeTextForAnalytics)(productRoom || category) || "n/a",
                productSalePrice: Number(discountedPrice ? discountedPrice : finalPrice),
                productSaleable: productSaleable,
                productStatus: color ? inStock === "true" || inStock === true ? "in stock" : "out of stock" : defaultProductIsInStock ? "in stock" : "out of stock",
                productSuperSku: isSuperSku,
                productTileName: (0,helper.sanitizeTextForAnalytics)(tileTitle) || "n/a",
                defaultImageName: defaultImageTmp || "n/a",
                productCollectionsName: (0,helper.sanitizeTextForAnalytics)(productCollectionsName || category) || "n/a",
                globalOffer: badgeVal ? badgeVal : "n/a",
                globalDiscount: discountedPrice ? Number(finalPrice) - Number(discountedPrice) : 0,
                productPartnerBuyNow: productIsRetail,
                pdpType: "regular finished goods & service parts",
                productFindingMethod: "n/a",
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount,
                frequency: "n/a",
                isRecommended: false,
                isSendNow: "n/a",
                isSubscription: false,
                quantity: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a"
            }
        };
        if (needsJSON) {
            return productInfo.productInfo;
        }
        return JSON.stringify(productInfo);
    };
    const onSelectedColor = (e, color)=>{
        e.stopPropagation();
        let newName = (0,helper.getBundleProductName)(data, color.sku);
        setProductName(newName);
        const { sku , customerFacingSKU  } = color;
        setSelectedColor({
            sku: sku,
            customerFacingSKU: customerFacingSKU
        });
        setSelected({
            sku: sku,
            customerFacingSKU: customerFacingSKU
        });
        triggerAnalytics.current = true;
    };
    const colorClickHandler = (color)=>{
        triggerAnalytics.current = false;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = getEventInfo(null, color, true);
        const productInfo = getProductInfo(color, true);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const checkColorFocus = (e, colors, index)=>{
        const colorSlice = colors.slice(0, colorCount);
        if (e.key === "Tab" && colorSlice.length - 1 === index || e.shiftKey && e.key === "Tab" && index === 0) {
            setHoverColor(selectedColor !== null && selectedColor !== void 0 ? selectedColor : "");
        }
    };
    const handleOnClickPartsDiagramLinkTmp = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        handleOnClickPartsDiagramLink(data);
        partsAnalytics();
    };
    const partsAnalytics = ()=>{
        try {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const eventInfo = getEventInfo("service parts", null, true, true);
            const productInfo = getProductInfo(selectedColor, true);
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo,
                productInfo
            });
        } catch (err) {
            console.log(err);
        }
    };
    const partsDiagram = t("kf.search.partsdiagram");
    const serviceParts = t("kf.search.serviceparts");
    const productTileClickHandler = async ()=>{
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const eventInfo = getEventInfo("", null, true);
        const productInfo = getProductInfo(null, true);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
        setPdpLoading(true);
    };
    const renderBadge = (item)=>{
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: classnames_default()("product-list-tile__new", {
                "product-list-tile__bundle": item === "bundle"
            }),
            children: (ref = plpBadges[item]) === null || ref === void 0 ? void 0 : ref.value
        });
    };
    const isThreeDBadgeAvailable = (data)=>{
        var ref, ref1;
        return data["ResourceNvznId_s"] || data["ResourceVntanaProductId_s"] || ((ref = data["ResourceVntanaProductIdList_ss"]) === null || ref === void 0 ? void 0 : ref.length) || ((ref1 = data["ResourceNvznIdList_ss"]) === null || ref1 === void 0 ? void 0 : ref1.length);
    };
    const isBrandOrTransact = (0,utils/* isBrandTransact */.AY)();
    const tileDetails = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-list-tile__image wow ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: images.map((id, i)=>{
                        const imgUrlLink = !(imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("/PAWEB/")) ? imgUrl : (0,utils/* getPresetUrl */.v$)(width, rowCols, general.swatchUrl, id, presetConf);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            id: id + "_IMG_" + i,
                            role: "presentation",
                            src: isSterling ? data["productImage.url_ss"][0] : i === 0 ? imgUrlLink !== null && imgUrlLink !== void 0 ? imgUrlLink : image_missing/* default */.Z : images[0] != images[1] ? EMPTY_PIXEL : imgUrlLink !== null && imgUrlLink !== void 0 ? imgUrlLink : image_missing/* default */.Z,
                            className: classnames_default()({
                                "product-list-tile__image--hover test1": images.length > 1 && i === 0
                            }, {
                                "product-list-tile__hoverimg test2": images.length > 1 && i !== 0
                            }, {
                                "no-preset": !(imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("/PAWEB/"))
                            }),
                            alt: description,
                            imgsrc: imgUrlLink,
                            imgalt: description,
                            onError: (e)=>(0,utils/* onImageError */.Ac)(e, imgUrlLink),
                            fetchpriority: fetchPriority
                        }, id + "_IMG_" + i);
                    })
                })
            }),
            !favPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-list-tile__share",
                children: [
                    !isBrandOrTransact && !data["BundleList_ss"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        id: "kf-add-to-fav-".concat(index),
                        className: "product-list-tile__share-icon",
                        tabIndex: "0",
                        "aria-label": t("kf.plp.label.wishlist", {
                            product: productName
                        }),
                        "aria-hidden": width > 1024 ? onHover ? false : true : false,
                        onClick: isAuth ? handleFavorite : handleLogin,
                        onFocus: ()=>{
                            setOnHover(true);
                        },
                        onBlur: ()=>{
                            setOnHover(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            src: isFavorite ? wishlist_gray_filled/* default.src */.Z.src : wish/* default.src */.Z.src,
                            alt: texts.wishlist
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "product-list-tile__share-icon-plp",
                        tabIndex: "0",
                        "aria-label": t("kf.plp.label.share.aria", {
                            product: productName
                        }),
                        "aria-hidden": width > 1024 ? onHover ? false : true : false,
                        onClick: handleShare,
                        onFocus: ()=>{
                            setOnHover(true);
                        },
                        onBlur: ()=>{
                            setOnHover(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            src: share/* default.src */.Z.src,
                            alt: texts.share
                        })
                    })
                ]
            }),
            " "
        ]
    });
    return locale && locale !== "" && sku && selSku && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "kf-product-list-tile-wrapper-".concat(data["ctId_s"]),
        className: "product-list-tile__wrapper wow  ".concat(onHover && "--hover"),
        onFocus: ()=>{
            setOnHover(true);
        },
        onBlur: ()=>{
            setOnHover(false);
        },
        onMouseLeave: handleMouseLeave,
        onMouseEnter: handleMouseEnter,
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        children: [
            isSterling && showSterlingButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "family-of-brands",
                children: staticText.familyResults
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                showModal: showShare,
                id: "kf-plp-tile-".concat(data["ctId_s"]),
                url:  true ? window.location.origin + tileUrl : 0,
                onClose: ()=>setShowShare(false),
                analyticData: getEventInfo("share", null, true),
                disableInstagram: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "Inner-".concat(masterCustomerFacingSku),
                role: "link",
                tabIndex: "0",
                className: "product-list-tile__wrapper__card",
                "aria-label": t("kf.plp.ariaLabel.productInfo", {
                    productName: productName,
                    description: description,
                    price: discountedPrice > 0 ? "Sale Price: ".concat(currencySign + " " + discountedPrice, " Original Price: ").concat(currencySign + " " + price) : "Price: ".concat(currencySign + " " + price)
                }),
                onFocus: (e)=>e.stopPropagation(),
                onClick: !(isSterling && parent.toLowerCase() === "search") ? redirectPDP : ()=>{},
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()({
                        "product-list-tile": true,
                        "product-list-tile--lite": lite
                    }),
                    children: [
                        isSterling && parent.toLowerCase() === "search" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                cursor: "default"
                            },
                            children: tileDetails
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: debounce_default()(productTileClickHandler, 100),
                            tabIndex: "-1",
                            role: "link",
                            href: "".concat(tileUrl, "?skuId=").concat(selSku !== "" ? selSku : sku),
                            children: tileDetails
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: isSterling && parent.toLowerCase() === "search" ? "product-list-tile__sterling" : "product-list-tile__details wow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-list-tile__details product-list-tile__compare-main",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    onClick: debounce_default()(productTileClickHandler, 100),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            "aria-label": "".concat(colors.length).concat(texts.colorsLinkAria),
                                            className: "product-list-tile__colors",
                                            children: colors.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product-list-tile__colors--swatch",
                                                children: [
                                                    colors.slice(0, colorCount).map((color, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            onClick: (e)=>onSelectedColor(e, color),
                                                            role: "link",
                                                            tabIndex: "0",
                                                            "aria-label": "".concat(color.name, " color"),
                                                            "aria-hidden": onHover ? false : true,
                                                            rel: "noreferrer",
                                                            title: color.name,
                                                            className: classnames_default()({
                                                                "product-list-tile__color-swatch": true,
                                                                "selected-swatch": selectedColor.sku === color.sku
                                                            }),
                                                            onMouseEnter: ()=>{
                                                                setHoverColor({
                                                                    sku: color.sku,
                                                                    customerFacingSKU: color.customerFacingSKU
                                                                });
                                                            },
                                                            onMouseLeave: ()=>setHoverColor(selectedColor !== null && selectedColor !== void 0 ? selectedColor : {}),
                                                            onFocus: ()=>{
                                                                setHoverColor({
                                                                    sku: color.sku,
                                                                    customerFacingSKU: color.customerFacingSKU
                                                                });
                                                            },
                                                            onKeyDown: (e)=>checkColorFocus(e, colors, i),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                role: "presentation",
                                                                src: "".concat(general.swatchUrl).concat(color.swatch).concat(width <= 768 ? "?$PLPSwatch_Mobile50$" : "?$PLPSwatch_Desk100$"),
                                                                alt: color.name,
                                                                onError: (e)=>colorSwatchDefaultImg(e)
                                                            })
                                                        }, "color-".concat(color.sku, "-").concat(color.customerFacingSKU, "-").concat(i))),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: colors.length > colorCount && "+" + (colors.length - colorCount)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()({
                                                "product-list-tile__info": true,
                                                "mt-0": !colors.length
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "product-list-tile__badge",
                                                    children: [
                                                        data["BundleList_ss"] ? renderBadge("bundle") : null,
                                                        displayOrderBadgeList.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                children: [
                                                                    item.includes("new") && (0,helper.showNewBadge)(shipmentDate) ? renderBadge(item) : null,
                                                                    item.includes("sale") && !isEmpty_default()(badgeVal) ? renderBadge(item) : null,
                                                                    item.includes("3d") && isThreeDBadgeAvailable(data) ? renderBadge(item) : null,
                                                                    item.includes("exclusive") && data["ProductIsExclusive_s"] ? renderBadge(item) : null
                                                                ]
                                                            }, item))
                                                    ]
                                                }),
                                                isInstallationAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "product-list-tile__installation-badge",
                                                    children: texts === null || texts === void 0 ? void 0 : texts.installationAvailable
                                                }),
                                                productName && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    "aria-label": productName,
                                                    className: "product-list-tile__title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                        text: productName,
                                                        highlight: highlightText
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    "aria-label": "".concat(texts.productDescription).concat(description),
                                                    className: "product-list-tile__description",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                        text: description,
                                                        highlight: highlightText
                                                    })
                                                })
                                            ]
                                        }),
                                        !isGrouped && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "product-list-tile__product-sku",
                                            children: hoverColor ? hoverColor.sku && hoverColor.customerFacingSKU : selectedColor ? selectedColor.sku && selectedColor.customerFacingSKU : selSku || selCustomerFacingSKU
                                        }),
                                        data["BundleList_ss"] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "product-list-tile__bundle-items",
                                            children: "".concat(data["BundleList_ss"].length, " ").concat(staticText.items)
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: finalPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                "aria-label": "".concat(texts.salePriceAria).concat(currencySign).concat(discountedPrice > 0 ? discountedPrice : finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0, "\n                                ").concat(isGrouped && (discountedPrice > 0 ? discountedPrice !== discountedMaxPrice : finalPrice !== maxPrice) ? " - " + currencySign + (discountedMaxPrice > 0 ? discountedMaxPrice : maxPrice) : ""),
                                                className: "product-list-tile__price ".concat(!isGrouped && "product-list-tile_paddingtop"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: discountedPrice > 0 ? parseFloat(discountedPrice) : parseFloat(finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0),
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    }),
                                                    isGrouped && (discountedPrice > 0 ? discountedPrice !== discountedMaxPrice : finalPrice !== maxPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        value: discountedMaxPrice > 0 ? parseFloat(discountedMaxPrice) : parseFloat(maxPrice !== null && maxPrice !== void 0 ? maxPrice : 0),
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: " - ".concat(currencySign),
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    }),
                                                    discountedPrice !== finalPrice && discountedPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-list-tile__mrp-section",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "product-list-tile__mrp",
                                                                children: staticText.refPrice
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                "aria-label": "".concat(texts.originalPriceAria).concat(currencySign).concat(finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0).concat(isGrouped && finalPrice !== maxPrice ? " - " + currencySign + discountedMaxPrice : ""),
                                                                className: classnames_default()({
                                                                    "product-list-tile__discount-price": true,
                                                                    "pl-0 d-block": isGrouped && width <= 480 && rowCols === 2
                                                                }),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                        value: parseFloat(finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0),
                                                                        displayType: "text",
                                                                        thousandSeparator: true,
                                                                        prefix: currencySign,
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true
                                                                    }),
                                                                    isGrouped && finalPrice !== maxPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                        value: parseFloat(maxPrice),
                                                                        displayType: "text",
                                                                        thousandSeparator: true,
                                                                        prefix: " - ".concat(currencySign),
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true
                                                                    })
                                                                ]
                                                            }),
                                                            discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "product-detail-page__percent-off",
                                                                style: {
                                                                    letterSpacing: "-0.3px",
                                                                    color: "#494949"
                                                                },
                                                                children: [
                                                                    discountPercent + "%",
                                                                    " ",
                                                                    staticText.percentOff
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "product-list-tile__alltaxes-text",
                                                        children: staticText.inclusiveOfAllTaxes
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            isSterling && showSterlingButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "view-sterling-results",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sterling-results-button",
                    onClick: handleViewSterlingResults,
                    children: staticText.viewSterlingResults
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-list-tile--loading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-image shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-title shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-description shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "loading-swatch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v2_ProductTile = (/*#__PURE__*/react.memo(ProductTile));


/***/ }),

/***/ 32753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_ImageUpload; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var dist_es = __webpack_require__(68901);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./public/icons/pdf-grey.svg
var pdf_grey = __webpack_require__(1405);
;// CONCATENATED MODULE: ./components/RegisterOfflineProduct/v1/ImageUpload/ImageUploadView.jsx




const ImageUploadView = (props)=>{
    var ref, ref1;
    const [imageInfo, setImageInfo] = (0,react.useState)({
        url: "",
        comment: ""
    });
    (0,react.useEffect)(()=>{
        var _url, _comment;
        setImageInfo({
            ...imageInfo,
            url: (_url = props.url) !== null && _url !== void 0 ? _url : "",
            comment: (_comment = props.comment) !== null && _comment !== void 0 ? _comment : ""
        });
    }, [
        props.url,
        props.comment
    ]);
    (0,react.useEffect)(()=>{
        if (props.uploadedImage.length > 0 && imageInfo.comment !== "") {
            let uploadedImage = props.uploadedImage.map((data, index)=>{
                if (props.index === index) {
                    return Object.assign(data, {
                        comment: imageInfo.comment
                    });
                } else {
                    return data;
                }
            });
            props.setUploadedImage(uploadedImage);
        }
    }, [
        imageInfo
    ]);
    const handleClose = (e, index)=>{
        e.stopPropagation();
        let path = [
            ...props.path
        ];
        let pathIndex = path.indexOf(props.url);
        path.splice(pathIndex, 1);
        let uploads = [
            ...props.uploadedImage
        ];
        let paths = uploads.map((file)=>{
            return file.url;
        });
        let uploadIndex = paths.indexOf(props.file.preview);
        uploads.splice(index, 1);
        props.setUploadedImage(uploads);
        props.setPath(path);
        props.addCount(props.fileCount + 1);
        props.clearErrorMsg("");
        props.handleUploader(false);
        props.setClear(true);
    };
    const getAddProductCloseAnalytics = ()=>{
        return JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "my account:register offline kohler products:product information:remove uploaded product image",
            eventName: "my account:register offline kohler products:product information:remove uploaded product image",
            eventType: "informative",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "remove uploaded product image",
            internalLinkPosition: "register offline kohler products",
            internalLinkType: "my account:navigation",
            internalLinkZoneName: "my account:register offline kohler products:product information",
            internalLinkURL: "n/a"
        });
    };
    const fileSizeConverter = (data)=>{
        let size = parseInt(data);
        for (let unit of [
            "b",
            "Kb",
            "Mb",
            "Gb"
        ]){
            if (size < 1024) return "".concat(size.toFixed(2), " ").concat(unit);
            size /= 1024.0;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "image-preview",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "image-delete gbh-data-layer",
                "data-gbh-data-layer": getAddProductCloseAnalytics(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: icons_close/* default.src */.Z.src,
                    alt: "close",
                    tabIndex: "0",
                    onClick: (e)=>handleClose(e, props.index),
                    "aria-controls": "planetInfo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image-preview-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-uploaded",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "image-uploaded__preview-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "image-uploaded__preview-inner-container",
                                children: props.file.type === "application/pdf" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: pdf_grey/* default.src */.Z.src,
                                    className: "image-uploaded__image"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: props.file.preview,
                                    className: "image-uploaded__image"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "image-description",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: props === null || props === void 0 ? void 0 : (ref = props.file) === null || ref === void 0 ? void 0 : ref.path
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: fileSizeConverter(props === null || props === void 0 ? void 0 : (ref1 = props.file) === null || ref1 === void 0 ? void 0 : ref1.size)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ImageUpload_ImageUploadView = (ImageUploadView);

// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/ImageUpload/index.module.scss
var index_module = __webpack_require__(89844);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/RegisterOfflineProduct/v1/ImageUpload/index.jsx







const ImageUpload = (param)=>{
    let { data , staticText ={} , isOmnichannel =false , isDisabled =false , clearImage =false , setClearImage =()=>{} , setUploadImageLoading =()=>{} , authorData ={} , ...props } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [uploadedImage, setUploadedImage] = (0,react.useState)([]);
    const [infoArr, setInfoArr] = (0,react.useState)([]);
    const [imagePath, setImagePath] = (0,react.useState)([]);
    const [error, setError] = (0,react.useState)("");
    const [fileCount, setFileCount] = (0,react.useState)(5);
    const [path, setPath] = (0,react.useState)([]);
    const [uploaderStatus, setUploaderStatus] = (0,react.useState)(false);
    const [clear, setClear] = (0,react.useState)(false);
    const [status, setStatus] = (0,react.useState)("");
    const { getRootProps , getInputProps  } = (0,dist_es/* useDropzone */.u)({
        accept: !isOmnichannel ? "image/png, image/jpg, image/jpeg, application/pdf" : "image/png, image/jpg, image/jpeg, application/pdf, image/gif",
        maxFiles: fileCount,
        maxSize: 5242880 /*5MB in bytes(binary format) */ ,
        multiple: !isOmnichannel ? true : false,
        disabled: !isOmnichannel ? uploaderStatus : isDisabled,
        onFileDialogCancel: ()=>{
            if ((uploadedImage === null || uploadedImage === void 0 ? void 0 : uploadedImage.length) === 0 && !isOmnichannel) {
                setError(staticText.provideImageError);
            }
        },
        onDrop: (acceptedFiles)=>{
            if (uploadedImage.length < 5) {
                let list = [];
                setUploadImageLoading(true);
                acceptedFiles.map((files)=>{
                    dispatch((0,genericSlice/* uploadImage */.Ix)({
                        uplaodData: files,
                        isReturn: false,
                        isOmnichannel,
                        authorData
                    })).unwrap().then((res)=>{
                        setUploadImageLoading(false);
                        list.push(res.path);
                        setPath([
                            ...path,
                            ...list
                        ]);
                    }).catch((err)=>{
                        console.error("Failed to upload files", err);
                        setUploadImageLoading(false);
                    });
                });
                let imageFiles = acceptedFiles.map((files)=>Object.assign(files, {
                        preview: URL.createObjectURL(files)
                    }));
                setUploadedImage([
                    ...uploadedImage,
                    ...imageFiles
                ]);
                setFileCount(fileCount - acceptedFiles.length);
                setError("");
            } else {
                setUploaderStatus(true);
                setUploadImageLoading(false);
                setError(staticText.uploadLimitError);
            }
        },
        onDropRejected: (fileRejectionItems)=>{
            if (fileRejectionItems[0].errors[0].code === "file-too-large") {
                setError(staticText.uploadFileSizeError);
            } else if (fileRejectionItems[0].errors[0].code === "file-invalid-type") {
                setError(staticText.uploadFileTypeError);
            } else if (fileRejectionItems[0].errors[0].code === "too-many-files") {
                setError(staticText.uploadLimitError);
            }
            setUploadImageLoading(false);
        }
    });
    (0,react.useEffect)(()=>{
        var ref;
        if (data.customerImage.length > 0) {
            let path = data.customerImage.map((img)=>{
                return img.url;
            });
            setImagePath(path);
            setInfoArr(data.customerImage);
        }
        if (data.uploadedImage.length > 0) {
            setUploadedImage(data.uploadedImage);
            setFileCount(fileCount - data.uploadedImage.length);
        }
        if ((data === null || data === void 0 ? void 0 : (ref = data.productImages) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            setPath(data.productImages);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (infoArr.length > 0 && uploadedImage.length > 0) {
            setInfoArr(uploadedImage.map((data)=>{
                return {
                    url: data.url,
                    comment: data.comment
                };
            }));
        }
        props.handleData({
            ...data,
            uploadedImage: uploadedImage
        });
    }, [
        uploadedImage
    ]);
    (0,react.useEffect)(()=>{
        if (clearImage) {
            setUploadedImage([]);
            setError("");
            setClearImage(false);
        }
    }, [
        clearImage
    ]);
    (0,react.useEffect)(()=>{
        props.handleData({
            ...data,
            customerImage: infoArr
        });
    }, [
        infoArr
    ]);
    (0,react.useEffect)(()=>{
        props.handleData({
            ...data,
            productImages: path
        });
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (path.length > 0) {
            let pathList = [];
            uploadedImage.forEach((img, index)=>{
                pathList[index] = path.find((value)=>{
                    let name = value.split("/");
                    return name[4] === img.name;
                });
            });
            setImagePath(pathList);
            setClear(false);
        }
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (uploadedImage.length > 0) {
            let uploads = uploadedImage.map((data, index)=>{
                let path = imagePath.find((path, i)=>i === index);
                return Object.assign(data, {
                    url: path
                });
            });
            setUploadedImage(uploads);
            setInfoArr(uploadedImage.map((data)=>{
                return {
                    url: data.url,
                    comment: data.comment
                };
            }));
        }
        if (imagePath.length > 0) setStatus("");
    }, [
        imagePath
    ]);
    (0,react.useEffect)(()=>{
        if (clear) {
            setInfoArr(uploadedImage.map((data)=>{
                return {
                    url: data.url,
                    comment: data.comment
                };
            }));
            setStatus(staticText.ariaLabel.imageRemove);
        }
    }, [
        clear
    ]);
    const getAddMorePhotosAnalytics = ()=>{
        return JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "my account:register offline kohler products:product information:add more photos",
            eventName: "my account:register offline kohler products:product information:add more photos",
            eventType: "informative",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "add more photos",
            internalLinkPosition: "register offline kohler products",
            internalLinkType: "my account:navigation",
            internalLinkZoneName: "my account:register offline kohler products:product information",
            internalLinkURL: "n/a"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).imageUploadWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "image-upload-content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ...getRootProps({
                        className: "dropzone"
                    }),
                    id: "image-dropzone-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "kf-image-upload",
                            ...getInputProps()
                        }),
                        uploadedImage.length > 0 && uploadedImage.map((file, index)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ImageUpload_ImageUploadView, {
                                index: index,
                                file: file,
                                data: data,
                                url: file === null || file === void 0 ? void 0 : file.url,
                                comment: file === null || file === void 0 ? void 0 : file.comment,
                                uploadedImage: uploadedImage,
                                setUploadedImage: setUploadedImage,
                                imagePath: imagePath,
                                setImagePath: setImagePath,
                                path: path,
                                setPath: setPath,
                                clearErrorMsg: setError,
                                fileCount: fileCount,
                                addCount: setFileCount,
                                handleUploader: setUploaderStatus,
                                setClear: setClear,
                                ...props
                            }, index);
                        }),
                        (uploadedImage === null || uploadedImage === void 0 ? void 0 : uploadedImage.length) < 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "file-upload-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "drag-and-drop-title",
                                    children: [
                                        staticText.drag,
                                        " & ",
                                        staticText.drop
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "or-text",
                                    children: staticText.or
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "upload-button ".concat(props.uploadButtonAnalytics ? "gbh-data-layer" : "", " ").concat(isOmnichannel && isDisabled ? "disable" : ""),
                                    "data-gbh-data-layer": props.uploadButtonAnalytics,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "upload-button-text",
                                        children: staticText.uploadPhoto
                                    })
                                })
                            ]
                        }),
                        !isOmnichannel && (uploadedImage === null || uploadedImage === void 0 ? void 0 : uploadedImage.length) >= 1 && uploadedImage.length < 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "file-upload-container",
                            onClick: (e)=>e.stopPropagation(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "upload-button gbh-data-layer",
                                "data-gbh-data-layer": getAddMorePhotosAnalytics(),
                                tabIndex: "0",
                                role: "button",
                                ...getRootProps(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "upload-button-text",
                                    children: staticText.addPhoto
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "region",
                            label: "status",
                            "aria-live": "polite",
                            className: "aria-messages",
                            children: status
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "file-upload-container__error-msg",
                            children: error
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var v1_ImageUpload = (ImageUpload);


/***/ }),

/***/ 45344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sR": function() { return /* binding */ helper_getFilterQuery; },
  "c9": function() { return /* binding */ helper_getFlData; },
  "ur": function() { return /* binding */ helper_getSortList; },
  "n4": function() { return /* reexport */ handleKeyPress; },
  "nj": function() { return /* reexport */ scrollToFirstProduct; },
  "C1": function() { return /* reexport */ scrollToProduct; }
});

// UNUSED EXPORTS: resourceFacetLabels

// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
;// CONCATENATED MODULE: ./src/components/Search/v1/ProductsTab/helper.js

const getSortList = (staticTexts)=>[
        {
            name: staticTexts.featured
        },
        {
            name: staticTexts.bestSellers,
            query: "bestSeller_l+asc"
        },
        {
            name: staticTexts.priceDesc,
            query: "price+desc"
        },
        {
            name: staticTexts.priceAsc,
            query: "price+asc"
        },
        {
            name: staticTexts.atoz,
            query: "productName_s+asc"
        },
        {
            name: staticTexts.ztoa,
            query: "productName_s+desc"
        }
    ];
const handleKeyPress = (e, width, filterRef, cb)=>{
    if (width < 992) {
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
        const focusContent = filterRef.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            cb(false);
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterRef.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    }
};
const scrollToProduct = ()=>{
    const urlParams = window.location.search;
    let queryVal = "";
    let isBackSkuExists = false;
    if (urlParams) {
        const urlQuery = urlParams.replace("?", "").split("&");
        urlQuery.forEach((query, i)=>{
            const isBack = query.split("=")[0] === "back";
            if (isBack) {
                sessionStorage.plpScrollSku = query.split("=")[1];
                isBackSkuExists = true;
            }
            queryVal += isBack ? "" : "".concat(i > 0 ? "&" : "").concat(query);
        });
        window.history.replaceState(window.location.pathname, document.title, queryVal.length > 0 ? "?".concat(queryVal.toString()) : window.location.pathname);
        if (sessionStorage.plpScrollSku) {
            const scrollPosition = document.getElementById(sessionStorage.plpScrollSku);
            let IterCount = 10;
            const scorllObjInterval = setInterval(()=>{
                if (scrollPosition) {
                    scrollPosition.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest"
                    });
                    if (IterCount === 0) {
                        delete sessionStorage.plpScrollSku;
                        clearInterval(scorllObjInterval);
                    }
                    IterCount--;
                }
            }, 150);
        } else if (!isBackSkuExists) {
            scrollToFirstProduct(false, false);
        }
    } else {
        scrollToTop();
    }
};
const scrollToFirstProduct = function() {
    let isFaq = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shouldScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    setTimeout(()=>{
        const scrollPositions = isFaq ? document.querySelectorAll("div.product-listing") : document.querySelectorAll(".product-listing");
        if (scrollPositions && scrollPositions.length > 0 && shouldScroll) {
            scrollPositions[0].scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        } else {
            scrollToTop();
        }
    }, 200);
};
const scrollToTop = ()=>{
    window.scrollTo(0, 0);
};
const getFlData = (persona)=>[
        "id",
        "sku_s",
        "slug_s",
        "metaTitle_s",
        "productName_s",
        "masterSKU_s",
        "masterCustomerFacingSKU_s",
        "Product_Category",
        "ProductLocalCategory_s",
        "ProductBrandName_s",
        "productImages.url_s",
        "productImages.url_ss",
        "displayPriceStartingAt_s",
        "SKUColorSwatchFilename_s",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceList.".concat(persona, ".price_d"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "variantList.sku_ss",
        "variantList.sku_s",
        "SKU.Details_ss",
        "Color.SKU.Details_ss",
        "Color.SKU.Details_s",
        "Color.".concat(persona, ".Details_ss"),
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "productImages.labelWithUrl_ss",
        "productImages.labelWithUrl_s",
        "variantList.sku_ss",
        "variantList.sku_s",
        "RegionOnBackOrder_s",
        "RegionBrandName_s",
        "ProductIsRetail",
        "comboSKUAvailable_b",
        "category1_s",
        "ProductBrandNameDisplay_s",
        "ctId_s",
        "ProductResource.InteractiveSVG.resourceName_ss",
        "ProductProductNo_s",
        "ProductResource.InteractiveSVG.resourceTitle_ss",
        "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
        "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
        resourceFacetLabels.join(",")
    ];
const getFilterQuery = function(type, query) {
    let queries = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], persona = arguments.length > 3 ? arguments[3] : void 0;
    const fq = type === "parts" ? [] : [
        query
    ];
    queries.forEach((q)=>{
        const tag = '{!tag="'.concat(q.facet, '"}');
        if (!q.facet.match(/^\*{2}/)) {
            q.facet === "Price_Range" ? fq.push(encodeURIComponent('{!tag="priceList.'.concat(persona, '.finalPrice_d"}priceList.').concat(persona, ".finalPrice_d:(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
            return;
        }
        q.facet === "Price_Range" ? fq.push("priceList.".concat(persona, ".finalPrice_d:(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
    });
    return fq;
};


;// CONCATENATED MODULE: ./components/Search/v1/ProductsTab/helper.js
const helper_getSortList = (staticTexts)=>[
        {
            name: staticTexts.featured
        },
        {
            name: staticTexts.bestSellers,
            query: "bestSeller_l+asc"
        },
        {
            name: staticTexts.priceDesc,
            query: "price+desc"
        },
        {
            name: staticTexts.priceAsc,
            query: "price+asc"
        },
        {
            name: staticTexts.atoz,
            query: "ProductBrandName_s+asc"
        },
        {
            name: staticTexts.ztoa,
            query: "ProductBrandName_s+desc"
        }
    ];
const helper_resourceFacetLabels = [
    "ProductIsExclusive_s"
];
const helper_getFlData = (persona)=>[
        "id",
        "slug_s",
        "sourceId_s",
        "preferenceSku_s",
        "metaTitle_s",
        "productName_s",
        "masterSKU_s",
        "Product_Category",
        "ProductLocalCategory_s",
        "ProductBrandName_s",
        "productImages.url_ss",
        "displayPriceStartingAt_s",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceList.".concat(persona, ".price_d"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "variantList.sku_ss",
        "Color.SKU.Details_ss",
        "Color.".concat(persona, ".Details_ss"),
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "productImages.labelWithUrl_ss",
        "RegionBrandName_s",
        "ProductIsRetail",
        "category1_s",
        "ProductBrandNameDisplay_s",
        "ctId_s",
        "ProductResource.InteractiveSVG.resourceName_ss",
        "ProductProductNo_s",
        "ProductResource.InteractiveSVG.resourceTitle_ss",
        "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
        "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
        "BundleList_ss",
        "priceList.ANY.price_d",
        "InstallationAvailable_s",
        "bundleNameSlugDetails_ss",
        helper_resourceFacetLabels.join(",")
    ];
const helper_getFilterQuery = function(type, query) {
    let queries = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], persona = arguments.length > 3 ? arguments[3] : void 0;
    const fq = type === "parts" ? [] : [
        query
    ];
    queries === null || queries === void 0 ? void 0 : queries.forEach((q)=>{
        var ref;
        const tag = '{!tag="'.concat(q.facet, '"}');
        if (!(q === null || q === void 0 ? void 0 : (ref = q.facet) === null || ref === void 0 ? void 0 : ref.match(/^\*{2}/))) {
            var ref1, ref2;
            (q === null || q === void 0 ? void 0 : q.facet) === "Price_Range" ? fq.push(encodeURIComponent('{!tag="priceList.'.concat(persona, '.finalPrice_d"}priceList.').concat(persona, ".finalPrice_d:(").concat(q === null || q === void 0 ? void 0 : (ref1 = q.value) === null || ref1 === void 0 ? void 0 : ref1.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + (q === null || q === void 0 ? void 0 : q.facet), ':("').concat(q === null || q === void 0 ? void 0 : (ref2 = q.value) === null || ref2 === void 0 ? void 0 : ref2.join('" OR "'), '")')));
            return;
        }
        (q === null || q === void 0 ? void 0 : q.facet) === "Price_Range" ? fq.push("priceList.".concat(persona, ".finalPrice_d:(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
    });
    return fq;
};



/***/ }),

/***/ 74859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GlobalPage_GlobalPageFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 93 modules
var AemGrid = __webpack_require__(55064);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
;// CONCATENATED MODULE: ./components/AIAssistantChat/index.js
"use client";





const deploymentId = "kohler_co_in_40520613";
const orgUrl = "https://kohlerind.my.salesforce-sites.com/vconnect";
const scriptSrc = "https://kohlerind.my.salesforce-sites.com/vconnect/resource/aiAssistantWebChat/loader.js";
function AIAssistantChat() {
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    (0,react.useEffect)(()=>{
        if (!deploymentId || !orgUrl) return;
        const config = {
            deploymentId,
            orgUrl
        };
        if (isAuth && user) {
            if (user === null || user === void 0 ? void 0 : user.sub) config.email = user === null || user === void 0 ? void 0 : user.sub;
            if (user === null || user === void 0 ? void 0 : user.login) config.phone = user === null || user === void 0 ? void 0 : user.login;
        }
        window.AIAssistantChatConfig = config;
    }, [
        isAuth,
        user,
        deploymentId,
        orgUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: scriptSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            src: scriptSrc,
            strategy: "afterInteractive"
        }, "".concat((user === null || user === void 0 ? void 0 : user.sub) || "guest", "-").concat(isAuth))
    });
}

;// CONCATENATED MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx









const GlobalPageFooter = (props)=>{
    const { footer , footerScripting , isOmnichannel =false , omniQRParams  } = props;
    const [scripts, setScripts] = (0,react.useState)([]);
    const [bvScript, setBVScript] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { src , type , integrity  } = bvScript;
    (0,react.useEffect)(()=>{
        const { pageLevelDetails =[] , bazaarVoice =null  } = (0,helper.getPageLevelScriptsAndStyles)(footerScripting);
        setScripts(pageLevelDetails["pageScripts"]);
        if (bazaarVoice) {
            setBVScript(bazaarVoice);
        }
    }, [
        footerScripting
    ]);
    (0,react.useEffect)(()=>{
        (0,helper.getScriptsAndStyles)(footer);
    }, [
        footer
    ]);
    const eventHandler = {
        store: {},
        callbacks: {
            setGlobalScripts: (item)=>{
                dispatch((0,genericSlice/* setGlobalScripts */.n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,genericSlice/* setGlobalStyles */.cw)(item));
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            pageIsInteractive && scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "footerscript-".concat(i)
                }, "footerscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "footerscriptHtml-".concat(i),
                    children: "".concat(script.innerHTML)
                }, "footerscriptHtml-".concat(i));
            }),
            src ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "footerscript-bv",
                src: src,
                type: type,
                integrity: integrity
            }) : null,
            !isOmnichannel && /*#__PURE__*/ (0,jsx_runtime.jsx)(AIAssistantChat, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                data: footer,
                count: 0,
                eventHandler: eventHandler,
                fragment: constants.FRAGMENT_TYPES.FOOTER,
                isOmnichannel: isOmnichannel,
                omniQRParams: omniQRParams
            })
        ]
    });
};
/* harmony default export */ var GlobalPage_GlobalPageFooter = (GlobalPageFooter);


/***/ }),

/***/ 81169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51857);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55064);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46201);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33273);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52786);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34326);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88751);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55111);














const GlobalPageHeader = (props)=>{
    const { header ={} , title ="" , description ="" , templateName ="" , globalScripting ="" , seoPageScripting ="" , isOmnichannel =false , omniQRParams ={} , isQrService =false , mappingData ={}  } = props;
    if (header.pageComponentProperties) {
        Object.assign(header, header.pageComponentProperties);
    }
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { cartUrl  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_7__/* .selectCartState */ .xw);
    const cartCount = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_9__/* .getCartCount */ .c0)();
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen  } , pageIsInteractive  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .selectGenericState */ .Px);
    const toggleMenu = ()=>{
        isOpen ? dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .closeMenu */ .Wj)()) : dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .openMenu */ .qn)());
    };
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$G)("common");
    const ariaLabel = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_9__/* .getAriaLabel */ .Xw)(t, cartCount);
    const [metas, setMetas] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [styles, setStyles] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [scripts, setScripts] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [links, setLinks] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [hasGlobalNavigation, setHasGlobalNavigation] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const { pageLevelDetails =[]  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__.getPageLevelScriptsAndStyles)(globalScripting);
        const { pageLevelDetails: pageLevelScripts = []  } = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__.getPageLevelScriptsAndStyles)(seoPageScripting);
        setMetas([
            ...pageLevelDetails["metaList"],
            ...pageLevelScripts["metaList"]
        ]);
        setStyles([
            ...pageLevelDetails["stylesList"],
            ...pageLevelScripts["stylesList"]
        ]);
        setScripts([
            ...pageLevelDetails["pageScripts"],
            ...pageLevelScripts["pageScripts"]
        ]);
        setLinks([
            ...pageLevelDetails["linkList"],
            ...pageLevelScripts["linkList"]
        ]);
    }, [
        globalScripting,
        seoPageScripting
    ]);
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__.hasComponentType)(header, _constants__WEBPACK_IMPORTED_MODULE_13__.COMPONENT_TYPES.GLOBAL_NAVIGATION, ()=>setHasGlobalNavigation(true));
    }, []);
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            cartCount,
            ariaLabel,
            cartUrl
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setBrandLogoImg */ .XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .closeMenu */ .Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setActiveMainCategory */ .X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setRegionNav */ .qX)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGlobalScripts */ .n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGlobalStyles */ .cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    const [fullUrl, setFullUrl] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [globalFullUrl, setGlobalFullUrl] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (true) {
            let url = window.location.pathname + window.location.search;
            setFullUrl((0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__.generateCanonicalUrl)(url, "", _constants__WEBPACK_IMPORTED_MODULE_13__.publicWebsiteUrl));
            let globalUrlPath = Object.keys(mappingData).length > 0 && (mappingData === null || mappingData === void 0 ? void 0 : mappingData.filter((value)=>{
                if (url.includes("?")) {
                    return url.split("?")[0] === value.indiaURL;
                } else {
                    return url === value.indiaURL;
                }
            })) || [];
            if (globalUrlPath.length > 0) {
                const urlPath = globalUrlPath[0].globalURL;
                setGlobalFullUrl(urlPath);
            }
            if (url === "/") {
                setGlobalFullUrl("https://www.kohler.com/en");
            }
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }) : null,
                    title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }) : null,
                    fullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: fullUrl
                    }) : null,
                    fullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "alternate",
                        hrefLang: "en-in",
                        href: fullUrl
                    }) : null,
                    globalFullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "alternate",
                        href: globalFullUrl,
                        hreflang: "en-US"
                    }) : null,
                    globalFullUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "alternate",
                        href: globalFullUrl,
                        hreflang: "x-default"
                    }) : null,
                    description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }) : null,
                    templateName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: templateName
                    }) : null,
                    metas.map((meta, i)=>{
                        if (meta.name && meta.content) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: meta.name,
                            content: meta.content
                        }, "meta-".concat(i));
                    }),
                    styles.map((style, i)=>{
                        if (typeof style === "string") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                                id: style.__hash,
                                children: style
                            })
                        }, "pagestyle-".concat(i, "-").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_11__.getRandom)()));
                    }),
                    links.map((link, i)=>{
                        if (typeof link !== "string") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: link.rel,
                            href: link.href
                        }, "pageLinks-".concat(i));
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: "/images/favicons/favicon.ico"
                    })
                ]
            }),
            pageIsInteractive && scripts.map((script, i)=>{
                if (script.src) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_8___default()), {
                    src: script.src,
                    type: script.type,
                    integrity: script.integrity,
                    id: "headscript-".concat(i)
                }, "headscript-".concat(i));
                if (!script.src && script.innerHTML) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_8___default()), {
                    id: "headscriptHtml-".concat(i),
                    type: script.type,
                    children: "".concat(script.innerHTML)
                }, "headscriptHtml-".concat(i));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                data: header,
                count: 0,
                eventHandler: eventHandler,
                fragment: _constants__WEBPACK_IMPORTED_MODULE_13__.FRAGMENT_TYPES.HEADER,
                hasGlobalNavigation: hasGlobalNavigation,
                isOmnichannel: isOmnichannel,
                omniQRParams: omniQRParams,
                isQrService: isQrService
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GlobalPageHeader);


/***/ }),

/***/ 2901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_MiniCart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/cart.js + 1 modules
var cart = __webpack_require__(33273);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./public/icons/cart-icon.svg
/* harmony default export */ var cart_icon = ({"src":"/_next/static/media/cart-icon.9accb288.svg","height":25,"width":25});
// EXTERNAL MODULE: ./public/icons/cart-icon-empty.svg
var cart_icon_empty = __webpack_require__(27644);
// EXTERNAL MODULE: ./public/icons/cart-gray.svg
var cart_gray = __webpack_require__(82821);
;// CONCATENATED MODULE: ./public/icons/cart-filled.svg
/* harmony default export */ var cart_filled = ({"src":"/_next/static/media/cart-filled.4aa11106.svg","height":20,"width":25});
;// CONCATENATED MODULE: ./utils/prerender.js
const setPrerender = (rules, id)=>{
    const scriptEl = document.createElement("script");
    scriptEl.type = "speculationrules";
    if (id) {
        scriptEl.setAttribute("data-id", id);
    }
    scriptEl.textContent = JSON.stringify(rules);
    document.body.append(scriptEl);
};
const removePrerender = (id)=>{
    document.querySelectorAll('script[data-id="'.concat(id, '"]')).forEach((el)=>el.remove());
};
const cartPrerender = ()=>{
    const urls = [];
    const tagId = "cart";
    const regex = /^\/p\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]*$/;
    const isPLPOrPDP = regex.test(window.location.pathname);
    if (!(window.location.pathname === "/cart" || window.location.pathname === "/checkout" || window.location.pathname === "/cart/shared-cart" || isPLPOrPDP)) {
        urls.push("/cart");
    }
    const cartRule = {
        prerender: [
            {
                urls
            }
        ]
    };
    removePrerender(tagId);
    setTimeout(()=>setPrerender(cartRule, tagId), 500);
};
const initPrerender = ()=>{
    const commonRules = {
        prerender: [
            {
                where: {
                    href_matches: "/p/*/*"
                },
                eagerness: "moderate"
            }
        ]
    };
    setPrerender(commonRules, "common");
//cartPrerender()
};

;// CONCATENATED MODULE: ./components/Shared/MiniCart/v1/MiniCart.jsx










const MiniCart = (param)=>{
    let { eventHandler: { store: { cartCount , ariaLabel  } , callbacks: { onClick  }  } , checkoutPage  } = param;
    const [width] = (0,useWindowResize/* default */.Z)();
    const getWidth = window.outerWidth === 0 ? window.innerWidth : lib/* isSafari */.G6 ? window.innerWidth : window.outerWidth;
    const [isMobile, setIsMobile] = (0,react.useState)((getWidth || width) <= 1200);
    const [cartUrl, setCartUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        !checkoutPage ? setIsMobile((getWidth && width) <= 1200) : setIsMobile(false);
    }, [
        getWidth,
        width,
        checkoutPage
    ]);
    (0,react.useEffect)(()=>{
        (0,cart/* getCartLandingPagePath */.dZ)().then((res)=>{
            setCartUrl(res);
        });
        const regex = /^\/p\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]*$/;
        const isPLPOrPDP = regex.test(window.location.pathname);
        if (!isPLPOrPDP) {
            initPrerender();
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-indicator ".concat(cartCount > 0 && "cart-indicator__with-count"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: cartUrl,
            "aria-label": ariaLabel,
            role: "link",
            className: "gbh-data-layer",
            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"'.concat(cartUrl, '","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"global header:navigation","eventType":"global header","eventAction":"cart icon"}'),
            children: cartCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-indicator__count ".concat(cartCount < 100 && "cart-indicator__count--center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: isMobile ? cart_filled === null || cart_filled === void 0 ? void 0 : cart_filled.src : cart_icon === null || cart_icon === void 0 ? void 0 : cart_icon.src,
                        alt: "Cart"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartCount
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: isMobile ? cart_gray/* default */.Z === null || cart_gray/* default */.Z === void 0 ? void 0 : cart_gray/* default.src */.Z.src : cart_icon_empty/* default.src */.Z.src,
                alt: "Cart"
            })
        })
    });
};
const checkForRerender = (prevProps, nextProps)=>{
    return nextProps.eventHandler.store.cartCount === prevProps.eventHandler.store.cartCount;
};
/* harmony default export */ var v1_MiniCart = (/*#__PURE__*/(0,react.memo)(MiniCart, checkForRerender));


/***/ }),

/***/ 30834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/Shared/Otp/v1/index.module.scss
var index_module = __webpack_require__(15729);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/validate.js
var validate = __webpack_require__(45648);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(95357);
// EXTERNAL MODULE: ./utils/enquiry.js
var enquiry = __webpack_require__(55754);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./i18n/useAuthModali18n.js
var useAuthModali18n = __webpack_require__(20234);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
;// CONCATENATED MODULE: ./components/Shared/Otp/v1/analytics.js

const verifyOtpAnalytics = (page, status, statusMsg)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(page, ":mobile number verification modal:verify"),
        eventName: "".concat(page, ":mobile number verification modal:verify"),
        eventType: "navigation",
        eventStatus: status,
        eventMsg: statusMsg !== null && statusMsg !== void 0 ? statusMsg : "n/a",
        internalLinkName: "verify",
        internalLinkPosition: page,
        internalLinkType: "".concat(page, ":").concat(page === "support:contact" ? "service & support" : "navigation"),
        internalLinkZoneName: "".concat(page, ":").concat(page === "my account:register offline kohler products" ? "personal information:mobile number verification modal" : "mobile number verification modal"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const changeNumberAnalytics = (page)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(page, ":mobile number verification modal:edit number"),
        eventName: "".concat(page, ":mobile number verification modal:edit number"),
        eventType: "navigation",
        internalLinkName: "edit number",
        internalLinkPosition: page,
        internalLinkType: "".concat(page, ":").concat(page === "support:contact" ? "service & support" : "modal"),
        internalLinkZoneName: "".concat(page, ":mobile number verification modal"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const resendOtpAnalytics = (page)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(page, ":mobile number verification modal:resend otp"),
        eventName: "".concat(page, ":mobile number verification modal:resend otp"),
        eventType: "navigation",
        internalLinkName: "resend otp",
        internalLinkPosition: page,
        internalLinkType: "".concat(page, ":").concat(page === "support:contact" ? "service & support" : "modal"),
        internalLinkZoneName: "".concat(page, ":mobile number verification modal"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const closeOtpAnalytics = (page)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(page, ":mobile number verification modal:close"),
        eventName: "".concat(page, ":mobile number verification modal:close"),
        eventType: "navigation",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: "".concat(page, ":").concat(page === "support:contact" ? "service & support" : "navigation"),
        internalLinkZoneName: "".concat(page, ":").concat(page === "my account:register offline kohler products" ? "personal information:mobile number verification modal" : "mobile number verification modal"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const getOtpAnalytics = (page)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(page, ":mobile number verification modal:get otp"),
        eventName: "".concat(page, ":mobile number verification modal:get otp"),
        eventType: "navigation",
        internalLinkName: "get otp",
        internalLinkPosition: page,
        internalLinkType: "".concat(page, ":").concat(page === "support:contact" ? "service & support" : "modal"),
        internalLinkZoneName: "".concat(page, ":mobile number verification modal"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const wantToLeaveAnalytics = (page, choice)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(page, ":mobile number verification modal:want to leave modal:").concat(choice),
        eventName: "".concat(page, ":mobile number verification modal:want to leave modal:").concat(choice),
        eventType: "navigation",
        internalLinkName: choice,
        internalLinkPosition: page,
        internalLinkType: "".concat(page, ":").concat(page === "support:contact" ? "service & support" : "modal"),
        internalLinkZoneName: "".concat(page, ":mobile number verification modal:want to leave modal"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const confirmCloseAnalytics = (page)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(page, ":mobile number verification modal:want to leave modal:close"),
        eventName: "".concat(page, ":mobile number verification modal:want to leave modal:close"),
        eventType: "navigation",
        internalLinkName: "close",
        internalLinkPosition: page,
        internalLinkType: "".concat(page, ":").concat(page === "support:contact" ? "service & support" : "modal"),
        internalLinkZoneName: "".concat(page, ":mobile number verification modal:want to leave modal"),
        internalLinkURL: "n/a"
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};
const privacyStatementAnalytics = (page, text, link)=>{
    const linkUrl = (link.indexOf("http") === -1 ? window.location.origin : "") + link;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(page, ":mobile number verification modal:").concat(text),
        eventName: "".concat(page, ":mobile number verification modal:").concat(text),
        eventType: "navigation",
        internalLinkName: text,
        internalLinkPosition: page,
        internalLinkType: "".concat(page, ":service & support"),
        internalLinkZoneName: "".concat(page, ":mobile number verification modal"),
        internalLinkURL: linkUrl
    };
    (0,helper.pushAnalyticsObjToDataLayer)(eventInfo);
};

;// CONCATENATED MODULE: ./components/Shared/Otp/v1/index.jsx













const OtpFields = (props)=>{
    const { handleClose , mobile , showModal , verifiedNumber , changeMobileNumber , userData , setData =null , setDataEnquiry =null , userDetails: userFactor , page =""  } = props;
    const { authModal: { staticText  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const i18n = (0,useAuthModali18n/* default */.Z)(staticText);
    const [changeNumber, setChangeNumber] = (0,react.useState)(changeMobileNumber);
    const [mobileNumber, setMobileNumber] = (0,react.useState)(mobile);
    const [showMobileNumberError, setShowMobileNumberError] = (0,react.useState)({
        show: false,
        message: ""
    });
    const [loading, setLoading] = (0,react.useState)(false);
    const otpDigits = [
        0,
        1,
        2,
        3,
        4,
        5
    ];
    const [otpEnteredByUser, setOtpEnteredByUser] = (0,react.useState)([]);
    const [isVerifyDisabled, setIsVerifyDisabled] = (0,react.useState)(true);
    const [numberOfTries, setNumberOfTries] = (0,react.useState)(0);
    const [timer, setTimer] = (0,react.useState)(5) // 5 minutes
    ;
    const [minutes, setMinutes] = (0,react.useState)(0);
    const [seconds, setSeconds] = (0,react.useState)(0);
    const [showResendOTP, setShowResendOTP] = (0,react.useState)(false);
    const [showTimer, setShowTimer] = (0,react.useState)(false);
    const [reachedLimit, setReachedLimit] = (0,react.useState)(false);
    const [intervalId, setIntervalId] = (0,react.useState)(null);
    const [verifyOTPLoading, setVerifyOTPLoading] = (0,react.useState)(null);
    const [invalidOTP, setInvalidOTP] = (0,react.useState)(null);
    const DIGIT_REGEX = /[0-9]/;
    const [timeLeftToResend, setTimeLeftToResend] = (0,react.useState)(null);
    const mobileNumberRef = (0,react.useRef)(mobileNumber);
    const [userDetails, setUserDetails] = (0,react.useState)(userFactor);
    const [reachedInvalidAttemptsLimit, setReachedInvalidAttemptsLimit] = (0,react.useState)(0);
    const [confirmationModal, setConfirmationModal] = (0,react.useState)(false);
    const [exceedCountTimer, setExceedCountTimer] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (localStorage.getItem("timeLeftEnquiryForm")) {
            setTimeLeftToResend(localStorage.getItem("timeLeftEnquiryForm"));
            const now = new Date().getTime();
            const timeLimit = new Date(parseInt(now) + parseInt(localStorage.getItem("timeLeftEnquiryForm")));
            const interval = setInterval(()=>resendTimerFunc(interval, timeLimit), 1000);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (!changeNumber) {
            const now = new Date().getTime();
            const timeLimit = new Date(now + timer * 60000);
            const interval = setInterval(()=>timerFunc(interval, timeLimit), 1000);
            setShowTimer(true);
            setIntervalId(interval);
        }
    }, [
        changeNumber
    ]);
    const getOTP = async (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        clearError();
        const payload = {
            login: mobileNumber
        };
        const loginPhoneNumber = localStorage.getItem("loginPhoneNumberEnquiry");
        const timeLeft = localStorage.getItem("timeLeftEnquiryForm");
        let valid = true;
        if (!mobileNumber || !constants.PHONE_REGEX.test(mobileNumber)) {
            setShowMobileNumberError({
                show: true,
                message: i18n === null || i18n === void 0 ? void 0 : i18n.errorPhoneNumber
            });
            valid = false;
        }
        if (loginPhoneNumber && loginPhoneNumber === mobileNumber && timeLeft > 0) {
            valid = false;
            if (reachedLimit) setReachedLimit(true);
            setShowResendOTP(false);
            setChangeNumber(false);
            setReachedInvalidAttemptsLimit(true);
            setShowTimer(false);
        }
        if (loginPhoneNumber !== mobileNumber) {
            localStorage.setItem("loginPhoneNumberEnquiry", mobileNumber);
            localStorage.removeItem("timeLeftEnquiryForm");
        }
        if (valid) {
            setLoading(true);
            if (changeNumber) mobileNumberRef.current.disabled = true;
            let { numberExists , factorId , userId  } = await (0,enquiry/* checkNumberExists */.gU)(mobileNumber);
            if (!numberExists) {
                setUserDetails({
                    userId,
                    factorId
                });
                const now = new Date().getTime();
                const timeLimit = new Date(now + timer * 60000);
                const interval = setInterval(()=>timerFunc(interval, timeLimit), 1000);
                setShowTimer(true);
                setIntervalId(interval);
                setChangeNumber(false);
                setLoading(false);
                setShowResendOTP(false);
                setReachedInvalidAttemptsLimit(false);
            } else {
                setLoading(false);
                setShowResendOTP(true);
                setLoading(false);
                setShowTimer(false);
                setUserDetails({});
                setChangeNumber(false);
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (timeLeftToResend < 0) {
            setMinutes(0);
            setSeconds(0);
            setShowTimer(false);
            setNumberOfTries(0);
            setShowResendOTP(false);
            setReachedLimit(false);
            setReachedInvalidAttemptsLimit(true);
            localStorage.removeItem("timeLeftEnquiryForm");
        }
    }, [
        timeLeftToResend
    ]);
    const timerFunc = (interval, timeLimit)=>{
        const currentTime = new Date().getTime();
        const timeleft = timeLimit - currentTime;
        // Calculating the minutes and seconds left
        let minutes = Math.floor(timeleft % (1000 * 60 * 60) / (1000 * 60));
        let seconds = Math.floor(timeleft % (1000 * 60) / 1000);
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        setMinutes(minutes);
        setSeconds(seconds);
        if (timeleft < 0) {
            clearInterval(interval);
            setMinutes(0);
            setSeconds(0);
            setShowTimer(false);
            if (numberOfTries < 3) {
                setShowResendOTP(true);
            }
            setReachedLimit(false);
        }
    };
    const resendTimerFunc = (interval, timeLimit)=>{
        const currentTime = new Date().getTime();
        const timeleft = timeLimit - currentTime;
        localStorage.setItem("timeLeftEnquiryForm", timeleft);
        setTimeLeftToResend(timeleft);
        if (timeleft < 0) {
            clearInterval(interval);
        }
    };
    const isDisabled = mobileNumber === "" || !constants.PHONE_REGEX.test(mobileNumber);
    const verifyOTP = async (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        const filteredArray = otpEnteredByUser.filter((otp)=>{
            return otp === undefined || otp === "";
        });
        const isOTPVerifyDisabled = otpEnteredByUser.length !== 6 || filteredArray.length > 0;
        if (!isOTPVerifyDisabled) {
            const payload = {
                data: {
                    passCode: otpEnteredByUser.join("")
                },
                userId: userDetails === null || userDetails === void 0 ? void 0 : userDetails.userId,
                factorId: userDetails === null || userDetails === void 0 ? void 0 : userDetails.factorId
            };
            setVerifyOTPLoading(true);
            const { data , status  } = await (0,enquiry/* activateUserFactor */.H_)(payload);
            if (status === 403 && (data === null || data === void 0 ? void 0 : data.errorCode) === "E0000068") {
                setInvalidOTP(true);
                setVerifyOTPLoading(false);
                verifyOtpAnalytics(page, "failure", "otp verification failed");
            } else if (status === 200) {
                setVerifyOTPLoading(false);
                verifiedNumber();
                setReachedInvalidAttemptsLimit(false);
                setData === null || setData === void 0 ? void 0 : setData({
                    ...userData,
                    phone: {
                        ...userData === null || userData === void 0 ? void 0 : userData.phone,
                        value: mobileNumber
                    }
                });
                verifyOtpAnalytics(page, "success");
                setDataEnquiry === null || setDataEnquiry === void 0 ? void 0 : setDataEnquiry(mobileNumber);
            } else if (status === 429) {
                setVerifyOTPLoading(false);
                setShowTimer(false);
                setInvalidOTP(false);
                setIsVerifyDisabled(true);
                clearInterval(intervalId);
                const now = new Date().getTime();
                const time = 5;
                const timeLimit = new Date(now + time * 60000);
                const interval = setInterval(()=>resendTimerFunc(interval, timeLimit), 1000);
                setTimeout(()=>{
                    setExceedCountTimer(false);
                }, 5 * 60 * 1000);
                setExceedCountTimer(true);
                setShowResendOTP(false);
                setIntervalId(interval);
                setReachedInvalidAttemptsLimit(true);
                verifyOtpAnalytics(page, "failure", "otp verification failed by too many attempts");
            } else if (status === 404) {
                setInvalidOTP(true);
                setVerifyOTPLoading(false);
                verifyOtpAnalytics(page, "failure", "otp verification failed");
            }
        }
    };
    const clearError = ()=>{
        setShowMobileNumberError({
            show: false,
            message: ""
        });
    };
    const addOTPDigit = (event, index)=>{
        const otpEntered = [
            ...otpEnteredByUser
        ];
        const value = event.target.value;
        if (value === "") {
            otpEntered[index] = "";
            if (index > 0) document.getElementById("kf-signin-country-code-".concat(index - 1)).focus();
            setInvalidOTP(false);
        } else if (DIGIT_REGEX.test(value)) {
            otpEntered[index] = value;
            if (index < 5) document.getElementById("kf-signin-country-code-".concat(index + 1)).focus();
        } else {
            otpEntered[index] = "";
        }
        setOtpEnteredByUser(otpEntered);
        const filteredArray = otpEntered.filter((otp)=>{
            return otp === undefined || otp === "";
        });
        const isOTPVerifyDisabled = otpEntered.length !== 6 || filteredArray.length > 0 || loading;
        setIsVerifyDisabled(isOTPVerifyDisabled);
    };
    const inputChangeFocus = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        const filteredArray = otpEnteredByUser.filter((otp)=>{
            return otp === undefined || otp === "";
        });
        const isOTPVerifyDisabled = otpEnteredByUser.length !== 6 || filteredArray.length > 0 || loading;
        setIsVerifyDisabled(isOTPVerifyDisabled);
    };
    const resendOTP = async (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        clearInterval(intervalId);
        if (numberOfTries === 3) {
            setReachedLimit(true);
            setTimer(15) //15 mins
            ;
            setShowTimer(false);
            setShowResendOTP(false);
            setOtpEnteredByUser([]);
            setInvalidOTP(false);
            setIsVerifyDisabled(true);
            const now = new Date().getTime();
            const time = 15;
            const timeLimit = new Date(now + time * 60000);
            const interval = setInterval(()=>resendTimerFunc(interval, timeLimit), 1000);
            setIntervalId(interval);
        } else {
            setNumberOfTries(numberOfTries + 1);
            setShowResendOTP(false);
            setOtpEnteredByUser([]);
            const filteredArray = otpEnteredByUser.filter((otp)=>{
                return otp === undefined || otp === "";
            });
            const isOTPVerifyDisabled = otpEnteredByUser.length !== 6 || filteredArray.length > 0 || loading;
            setIsVerifyDisabled(isOTPVerifyDisabled);
            setReachedInvalidAttemptsLimit(false);
            setTimer(5);
            setShowTimer(true);
            setOtpEnteredByUser([]);
            setInvalidOTP(false);
            const payload = {
                login: mobileNumber
            };
            let { numberExists , factorId , userId  } = await (0,enquiry/* checkNumberExists */.gU)(mobileNumber);
            if (!numberExists) {
                setUserDetails({
                    userId,
                    factorId
                });
                setChangeNumber(false);
                setIsVerifyDisabled(true);
                setReachedLimit(false);
                const time1 = 5 // 5 mins
                ;
                setTimer(5) // 5mins
                ;
                const now1 = new Date().getTime();
                const timeLimit1 = new Date(now1 + time1 * 60000);
                const interval1 = setInterval(()=>timerFunc(interval1, timeLimit1), 1000);
                setIntervalId(interval1);
            } else {
                setLoading(false);
                setShowResendOTP(true);
                setLoading(false);
                setShowTimer(false);
                setUserDetails({});
                setChangeNumber(false);
            }
        }
        resendOtpAnalytics(page);
    };
    const backToSignIn = (event)=>{
        if (!loading) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
            setNumberOfTries(0);
            setShowMobileNumberError({
                show: false,
                message: ""
            });
            setMobileNumber("");
            setOtpEnteredByUser([]);
            setMinutes(0);
            setSeconds(0);
            setReachedLimit(false);
            setShowResendOTP(false);
            setInvalidOTP(false);
            clearInterval(intervalId);
            setTimer(5);
            setChangeNumber(true);
            changeNumberAnalytics(page);
        }
    };
    const handleChangeNumber = (event)=>{
        const { value  } = event.target;
        if (value === "" || (0,validate/* validNumber */.BP)(value)) {
            setMobileNumber(value);
        }
    };
    const onBlur = ()=>{
        if (!mobileNumber || !constants.PHONE_REGEX.test(mobileNumber)) {
            setShowMobileNumberError({
                show: true,
                message: i18n === null || i18n === void 0 ? void 0 : i18n.errorPhoneNumber
            });
        } else {
            setShowMobileNumberError({
                show: false,
                message: ""
            });
        }
    };
    const handleCloseConfirmation = ()=>{
        setConfirmationModal(true);
        closeOtpAnalytics(page);
    };
    const handleOnPaste = (event)=>{
        const otpEntered = event.clipboardData.getData("text");
        const otpArray = otpEntered.split("");
        setOtpEnteredByUser(otpArray);
        const filteredArray = otpArray.filter((otp)=>{
            return otp === undefined || otp === "";
        });
        const isOTPVerifyDisabled = otpEntered.length !== 6 || filteredArray.length > 0 || loading;
        setIsVerifyDisabled(isOTPVerifyDisabled);
    };
    const handleGetOtp = (e)=>{
        getOTP(e);
        getOtpAnalytics(page);
    };
    const handleWantToLeave = (choice)=>{
        if (choice === "yes") {
            setConfirmationModal(false);
            handleClose();
        } else {
            setConfirmationModal(false);
        }
        wantToLeaveAnalytics(page, choice);
    };
    (0,react.useEffect)(()=>{
        document.getElementById("kf-signin-country-code-0") && document.getElementById("kf-signin-country-code-0").focus();
    }, [
        document.getElementById("kf-signin-country-code-0")
    ]);
    const termsRef = (0,react.useRef)(null);
    const addTermsLinkAnalytics = ()=>{
        const links = termsRef.current.querySelectorAll("a");
        Array.from(links).forEach((link)=>{
            link.addEventListener("click", ()=>{
                var ref;
                return privacyStatementAnalytics(page, (ref = link.innerText) === null || ref === void 0 ? void 0 : ref.toLowerCase(), link.getAttribute("href"));
            });
        });
    };
    (0,react.useEffect)(()=>{
        // to add analytics for terms and policy links
        if (showModal) {
            setTimeout(addTermsLinkAnalytics, 100);
        }
    }, [
        showModal
    ]);
    var _otp;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                showModal: showModal,
                onModalClose: handleCloseConfirmation,
                labelledBy: "kf-signup-modal",
                hideCloseIcon: false,
                authModal: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).otpVerification,
                    children: [
                        !changeNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "otp-popup",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "otp-popup__title",
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.otpTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "otp-popup__description",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "otp-popup__mobileprint",
                                                children: [
                                                    i18n.label,
                                                    " +91 ".concat(mobileNumber, " ")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "otp-change-number",
                                                onClick: backToSignIn,
                                                style: loading ? {
                                                    cursor: "auto"
                                                } : {
                                                    cursor: "pointer",
                                                    textDecorationLine: "underline"
                                                },
                                                children: i18n.changeNumber
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        children: [
                                            showTimer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "otp-popup__timerDiv",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "expireotp",
                                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.otpexpire
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "auth-otp-modal__timer",
                                                        children: "".concat(minutes, ":").concat(seconds)
                                                    })
                                                ]
                                            }),
                                            showResendOTP && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "otp-popup__otpSendTextDiv",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "otp-popup__otpSendText",
                                                        children: i18n.otpNotReceived
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        className: "otp-popup__updateNumber",
                                                        rel: "noreferrer",
                                                        onClick: resendOTP,
                                                        children: i18n.resendOTP
                                                    })
                                                ]
                                            }),
                                            reachedInvalidAttemptsLimit ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "otp-popup__otpSendTextDiv",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "otp-popup__otpSendText",
                                                        children: [
                                                            i18n.tryagainmin,
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        className: exceedCountTimer ? "resend-disabled" : "otp-popup__updateNumber",
                                                        rel: "noreferrer",
                                                        onClick: resendOTP,
                                                        children: i18n.resendOTP
                                                    })
                                                ]
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "otp-popup__otpDigitsDiv",
                                                children: otpDigits.map((otp)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "otp-popup__otpDigit",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                            id: "kf-signin-country-code-".concat(otp),
                                                            type: "tel",
                                                            name: "countryCode-".concat(otp),
                                                            value: (_otp = otpEnteredByUser[otp]) !== null && _otp !== void 0 ? _otp : "",
                                                            onChange: (event)=>addOTPDigit(event, otp),
                                                            maxLength: "1",
                                                            onFocus: inputChangeFocus,
                                                            onKeyDown: (e)=>{
                                                                if ((e.key === "Delete" || e.key === "Backspace") && e.target.value === "") {
                                                                    if (otp > 0) {
                                                                        document.getElementById("kf-signin-country-code-".concat(otp - 1)).focus();
                                                                    }
                                                                }
                                                                const filteredArray = otpEnteredByUser.filter((otp)=>{
                                                                    return otp === undefined || otp === "";
                                                                });
                                                                const isOTPVerifyDisabled = otpEnteredByUser.length !== 6 || filteredArray.length > 0;
                                                                if (e.key === "Enter") {
                                                                    if (!isOTPVerifyDisabled) {
                                                                        e.preventDefault();
                                                                        verifyOTP();
                                                                    } else {
                                                                        e.preventDefault();
                                                                    }
                                                                }
                                                            },
                                                            showError: invalidOTP,
                                                            disabled: reachedLimit || reachedInvalidAttemptsLimit,
                                                            pattern: "\\d*",
                                                            onPaste: handleOnPaste
                                                        })
                                                    }, otp))
                                            }),
                                            invalidOTP && !showResendOTP && otpEnteredByUser.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "otp-popup__otpErrorDiv ",
                                                children: i18n === null || i18n === void 0 ? void 0 : i18n.errorOTP
                                            }),
                                            showResendOTP && otpEnteredByUser.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "otp-popup__otpErrorDiv ",
                                                children: i18n.invalidOTP
                                            }),
                                            reachedInvalidAttemptsLimit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "otp-popup__otpErrorDiv ",
                                                children: i18n.exceedlimit
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "otp-popup__otp-popup-button",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    role: "button",
                                                    className: "gbh-data-layer",
                                                    label: i18n.verifySignIn,
                                                    type: "black",
                                                    flexible: true,
                                                    onClick: verifyOTP,
                                                    loading: verifyOTPLoading,
                                                    disabled: isVerifyDisabled || reachedInvalidAttemptsLimit,
                                                    customClass: "otp-popup__button"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "otp-popup__footer",
                                                ref: termsRef,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: i18n.policyText
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        " ",
                        changeNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "change-number-popup",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "change-number-popup__title",
                                    children: i18n === null || i18n === void 0 ? void 0 : i18n.changeMobileTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "change-number-popup__description",
                                    children: i18n.changeMobileDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "change-number-popup__phoneDiv",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "change-number-popup__countryIcon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        type: "text",
                                                        name: "countryCode",
                                                        value: "+91",
                                                        disabled: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "change-number-popup__phoneNumber",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        id: "kf-signin-mobile-number",
                                                        type: "text",
                                                        name: "mobileNumber",
                                                        value: mobileNumber,
                                                        ref: mobileNumberRef,
                                                        ariaRequried: true,
                                                        placeholder: i18n.enterMobileNumber,
                                                        label: i18n.enterMobileNumber,
                                                        onChange: handleChangeNumber,
                                                        onKeyDown: (e)=>{
                                                            e.key === "Enter" && handleGetOtp(e);
                                                        },
                                                        showError: showMobileNumberError.show,
                                                        errorMessage: showMobileNumberError.message,
                                                        autoFocus: false,
                                                        maxLength: "10",
                                                        onBlur: onBlur
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "change-number-popup__wrap-button",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                role: "button",
                                                className: "gbh-data-layer",
                                                label: i18n.getOTP,
                                                type: "black",
                                                flexible: true,
                                                onClick: handleGetOtp,
                                                loading: loading,
                                                disabled: isDisabled,
                                                customClass: "change-number-popup__button"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "change-number-popup__footer",
                                            ref: termsRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: i18n.policyText
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                showModal: confirmationModal,
                onModalClose: ()=>{
                    setConfirmationModal(false);
                    confirmCloseAnalytics(page);
                },
                className: "confirmation",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "otp-popup__modal",
                    "aria-modal": true,
                    role: "dialog",
                    tabIndex: "-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "otp-popup__title",
                            children: i18n.exitConfirmation
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "otp-popup__buttonDiv",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "otp-popup__button",
                                    type: "black",
                                    role: "button",
                                    label: "Yes",
                                    onClick: ()=>handleWantToLeave("yes")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "otp-popup__button",
                                    type: "ghost",
                                    role: "button",
                                    label: "No",
                                    onClick: ()=>handleWantToLeave("no")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v1 = (OtpFields);


/***/ }),

/***/ 13678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52786);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34326);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55111);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34147);
/* harmony import */ var _components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_8__);









const ProductSocialShare = (props)=>{
    const { id ="" , url ="" , componentProp: { assetUrl ="" , url: compUrl = "" , showModal: componentPropShowModal = false  } = {} , disableInstagram =false , showModal =false , onClose =()=>{} , mailBody ="" , mailSubject =""  } = props;
    const [sites, setSites] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [general, setGeneral] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const origin =  true ? window.location.origin : 0;
    const emailBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const copyBtnRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const shareBoxRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const socialShareCopyIconPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const socialShareEmailIconPath = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    const [socialMediaConfigs, setSocialMediaConfigs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const brandName = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)().then(async (config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
            brandName.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.siteName", "");
            setSocialMediaConfigs(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "socialMediaConfig", {}));
            socialShareCopyIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.socialShareEmailIconPath", "");
        });
    }, []);
    // get component social share link url
    /**
   *
   * @return  {string} the the url
   */ const getLink = ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.getShortenedUrlwithGeneral)(compUrl, general);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.sanitizeUrl)(window.location.href);
        }
    };
    const link = getLink();
    const brandNameCurrent = brandName.current;
    const i18n = {
        email: "Email",
        emailSubject: "Shared Cart Invitation",
        copyLink: "Copy Link",
        copyLinkIndication: "Link Copied!",
        yourSharedCartNumber: t("Your cart #: {{cartNumber}}", {
            cartNumber: props.sharedCartNum
        }),
        linksCTA: (siteKey)=>t("Go to {{brandName}} {{siteKey}} Page", {
                brandNameCurrent,
                siteKey
            }),
        openNewTabText: "will open in a new tab"
    };
    const [copyIcon, setCopyIcon] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (socialMediaConfigs.myArrayList) {
            let siteList = [];
            socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : socialMediaConfigs.myArrayList.forEach((socialMediaConfig)=>{
                if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(socialMediaConfig.map) && socialMediaConfig.map.name) {
                    var _name, _iconPath;
                    const site = {
                        key: (_name = socialMediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                        icon: (_iconPath = socialMediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                    };
                    var _redirectUrl;
                    const url = (_redirectUrl = socialMediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                    if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
                        siteList.push({
                            ...site,
                            url: encodeURI(url + link + "&text=".concat(document.title))
                        });
                    } else if (socialMediaConfig.map.name.toLowerCase().includes("pinterest")) {
                        if (props.asset) siteList.push({
                            ...site,
                            url: url + "".concat(origin, "&media=").concat(props.asset.url, "&is_video=").concat(props.asset.isVideo, "$description=").concat(props.asset.description)
                        });
                    } else {
                        siteList.push({
                            ...site,
                            url: url + link
                        });
                    }
                }
            });
            if (disableInstagram && siteList.length) {
                siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
            }
            setSites(siteList);
        }
    }, [
        socialMediaConfigs
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    /**
   *
   * @param {string} e
   */ function socialLinks(e) {
        if (e.target && e.target.hostname && e.target.href) {
            const target = e.target;
            const nodeUrl = target.hostname.replace(/(^www\.)/, "");
            if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
                e.stopPropagation();
                e.preventDefault();
                if (window.handleShowModal) window.handleShowModal(target.href, target);
            } else if (target.href) {
                window.open(target.href);
            }
            const key = target.siteKey || nodeUrl || target.hostname;
            try {
                addDataLayer(key.split(".com")[0], target.href);
            // eslint-disable-next-line no-empty
            } catch (ee) {}
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        props.showModal
    ]);
    const { internallinkposition , internallinktype , internallinkzonename  } = props.componentProp || {};
    const analyticData = props.analyticData || {
        internalLinkPosition: internallinkposition || "n/a",
        internalLinkType: internallinktype || "n/a",
        internalLinkZoneName: internallinkzonename || "n/a"
    };
    const shareRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const handleClick = (e)=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument.getElementById(props.id) : document.getElementById(props.id);
        if (props.showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target))) props.onClose();
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            props.onClose();
            props.shareBtn.current.focus();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument : document;
        if (props.showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && props.showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        props.showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer("copy link", link !== null && link !== void 0 ? link : "n/a");
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const addDataLayer = (siteKey, link)=>{
        const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
        const eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" ? "true" : "false"
        };
        if (window.dataLayerEventType) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const dataLayerObj = {
            event: "cmp:click",
            page,
            eventInfo
        };
        let productInfo;
        if (custom) {
            try {
                productInfo = JSON.parse(custom).productInfo;
                dataLayerObj["productInfo"] = productInfo;
            } catch (e) {
                console.error(e);
            }
        }
        window.adobeDataLayer.push(dataLayerObj);
    };
    const { linksCTA =()=>{} , openNewTabText ="" , copyLinkIndication ="" , copyLink: staticTextcopyLink = "" , email =""  } = i18n;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_ProductSocialShare_v1_socialShare_module_scss__WEBPACK_IMPORTED_MODULE_8___default().socialShareWrapper),
        children: (showModal !== null && showModal !== void 0 ? showModal : componentPropShowModal) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "social-share",
            id: id,
            ref: shareRef,
            "data-testid": id,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "social-share__box",
                ref: shareBoxRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "social-share__sites",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            role: "list",
                            children: sites.map((param, i)=>{
                                let { url ="" , key ="" , icon =""  } = param;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        id: "kf-social-links-".concat(i),
                                        rel: "noreferrer",
                                        href: url,
                                        className: "kf-social-links",
                                        "aria-label": "".concat(linksCTA(key), " ").concat(openNewTabText),
                                        target: "_blank",
                                        "data-link-type": "social media",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            "aria-hidden": "true",
                                            src: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_7__.authorBaseUrl).concat(icon),
                                            alt: key,
                                            className: "social-share__".concat(key)
                                        })
                                    })
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "social-share__actions",
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    tabIndex: "0",
                                    role: "button",
                                    ref: copyBtnRef,
                                    className: "social-share__cta",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "social-share__copy-link-icon",
                                            "aria-hidden": true,
                                            src: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_7__.authorBaseUrl).concat(socialShareCopyIconPath.current),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        copyIcon ? copyLinkIndication : staticTextcopyLink
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    className: "social-share__cta social-share__email",
                                    "aria-label": "".concat(email, " ").concat(openNewTabText),
                                    onKeyDown: ()=>onClose(),
                                    ref: emailBtnRef,
                                    href: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.sanitizeUrl)("mailto:?body=".concat(mailBody + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "".concat(_constants_index__WEBPACK_IMPORTED_MODULE_7__.authorBaseUrl).concat(socialShareEmailIconPath.current),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        email
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductSocialShare);


/***/ }),

/***/ 92513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_SocialShare; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
;// CONCATENATED MODULE: ./i18n/useSocialSharei18n.js

const useSocialSharei18n = (shareCartNum, brandName)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        email: t("kf.share.label.email", "Email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink", "Copy Link"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: shareCartNum
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandName: brandName,
                siteKey: siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText"),
        shareCartDesc: t("kf.cart.label.shareCartDesc"),
        shareCart: t("kf.cart.label.shareCart"),
        mailSubject: t("kf.share.label.emailSubject"),
        downloadSpecs: t("kf.cart.label.downloadSpecs")
    };
    return i18n;
};
/* harmony default export */ var i18n_useSocialSharei18n = (useSocialSharei18n);

// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
;// CONCATENATED MODULE: ./components/SocialShare/v1/SocialShare.jsx








const SocialShare = (props)=>{
    const { url ="" , showModal , componentProp: { assetUrl ="" , url: compUrl = "" , internallinkposition , internallinktype , internallinkzonename , eventaction , eventname  } = {} , componentProp , id , sharedCartNum , onClose , mailBody , mailSubject , asset , analyticData: analyticPropData , iframeId , shareBtn , shareRef  } = props;
    const isSsr = (0,useIsSsr/* default */.Z)();
    const [sites, setSites] = (0,react.useState)([]);
    const [general, setGeneral] = (0,react.useState)(null);
    const [origin, setOrigin] = (0,react.useState)(null);
    const [href, setHref] = (0,react.useState)(null);
    const [socialMediaConfigs, setSocialMediaConfigs] = (0,react.useState)({});
    const emailBtnRef = (0,react.useRef)(null);
    const copyBtnRef = (0,react.useRef)(null);
    const shareBoxRef = (0,react.useRef)(null);
    const brandName = (0,react.useRef)("");
    const shareCartUrl = (0,react.useRef)("");
    const socialShareCopyIconPath = (0,react.useRef)("");
    const socialShareEmailIconPath = (0,react.useRef)("");
    (0,react.useEffect)(()=>{
        if (!isSsr) {
            setOrigin(window.location.origin);
            setHref(window.location.href);
        }
    }, [
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
            const socialMediaConfigs = get_default()(config, "socialMediaConfig", {});
            setSocialMediaConfigs(socialMediaConfigs);
            brandName.current = get_default()(config, "general?.siteName", "");
            socialShareCopyIconPath.current = get_default()(config, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = get_default()(config, "general.socialShareEmailIconPath", "");
            shareCartUrl.current = await (0,helper.getShortenedUrl)(get_default()(config, "general.shareCartPagePath", ""));
        });
    }, []);
    // get component social share link url
    const getLink = ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = (0,helper.getShortenedUrlwithGeneral)(compUrl, general);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else if (true) {
            return (0,helper.sanitizeUrl)(window.location.href);
        }
    };
    const link = getLink();
    const staticText = i18n_useSocialSharei18n(sharedCartNum, brandName);
    const [copyIcon, setCopyIcon] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        let siteList = [];
        socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : (ref = socialMediaConfigs.myArrayList) === null || ref === void 0 ? void 0 : ref.forEach((socialMediaConfig)=>{
            if (!isEmpty_default()(socialMediaConfig.map) && socialMediaConfig.map.name) {
                var _name, _iconPath;
                let site = {
                    key: (_name = socialMediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                    icon: (_iconPath = socialMediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                };
                var _redirectUrl;
                const url = (_redirectUrl = socialMediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
                    siteList.push({
                        ...site,
                        url: encodeURI(url + link + "&text=".concat(document.title))
                    });
                } else if (socialMediaConfig.map.name.toLowerCase().includes("pinterest")) {
                    if (asset) siteList.push({
                        ...site,
                        url: url + "".concat(origin, "&media=").concat(asset.url, "&description=").concat(asset.description)
                    });
                } else {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                }
            }
        });
        if (siteList.length) {
            siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
        }
        setSites(siteList);
    }, [
        socialMediaConfigs
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    const socialLinks = (e)=>{
        const target = e.target;
        const nodeUrl = target.hostname.replace(/(^www\.)/, "");
        if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
            e.stopPropagation();
            e.preventDefault();
            if (window.handleShowModal) window.handleShowModal(target.href);
        } else if (target.href) {
            window.open(target.href);
        }
        const key = target.siteKey || nodeUrl || target.hostname;
        try {
            addDataLayer(key.split(".com")[0], target.href);
        } catch (err) {
            console.log(err);
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        showModal
    ]);
    const analyticData = analyticPropData || {
        internalLinkPosition: internallinkposition || "n/a",
        internalLinkType: internallinktype || "n/a",
        internalLinkZoneName: internallinkzonename || "n/a",
        eventAction: eventaction || "n/a",
        eventName: eventname || "n/a"
    };
    const handleClick = (e)=>{
        var ref;
        const selELement = iframeId ? document.getElementById(iframeId).contentDocument.getElementById(id) : document.getElementById(id);
        if (showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target)) && !(shareBtn === null || shareBtn === void 0 ? void 0 : (ref = shareBtn.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            onClose();
        }
        if ((componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            onClose();
            shareBtn.current.focus();
        }
    };
    (0,react.useEffect)(()=>{
        const selELement = iframeId ? document.getElementById(iframeId).contentDocument : document;
        if (showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if ((componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) && showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer("copy link", link !== null && link !== void 0 ? link : "n/a");
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const addDataLayer = (siteKey, link)=>{
        const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
        const eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "copy link" || siteKey === "email a friend" ? "true" : "false"
        };
        if (window.dataLayerEventType) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        let productInfo;
        if (custom) {
            try {
                productInfo = JSON.parse(custom).productInfo;
            // eslint-disable-next-line no-empty
            } catch (e) {}
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    return (showModal !== null && showModal !== void 0 ? showModal : componentProp === null || componentProp === void 0 ? void 0 : componentProp.showModal) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "social-share",
        id: id,
        ref: shareRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "social-share__box",
            ref: shareBoxRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "social-share__sites",
                    children: sharedCartNum && sharedCartNum ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "social-share__shared-cart-number",
                        children: staticText.yourSharedCartNumber
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        role: "list",
                        children: sites.map((site, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    id: "kf-social-links-".concat(i),
                                    rel: "noreferrer",
                                    href: site.url,
                                    className: "kf-social-links",
                                    "aria-label": "".concat(staticText.linksCTA(site.key), " ").concat(staticText.openNewTabText),
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        "aria-hidden": "true",
                                        src: site === null || site === void 0 ? void 0 : site.icon,
                                        alt: site.key,
                                        className: "social-share__".concat(site.key)
                                    })
                                })
                            }, i);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "social-share__actions",
                    role: "list",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                tabIndex: "0",
                                role: "button",
                                ref: copyBtnRef,
                                className: "social-share__cta",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "social-share__copy-link-icon",
                                        "aria-hidden": true,
                                        src: socialShareCopyIconPath.current,
                                        role: "presentation",
                                        alt: ""
                                    }),
                                    copyIcon ? staticText.copyLinkIndication : staticText.copyLink
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "social-share__cta social-share__email",
                                "aria-label": "".concat(staticText.email, " ").concat(staticText.openNewTabText),
                                onKeyDown: ()=>onClose(),
                                ref: emailBtnRef,
                                href: (0,helper.sanitizeUrl)("mailto:?body=".concat((mailBody ? mailBody : "") + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: socialShareEmailIconPath.current,
                                        role: "presentation",
                                        alt: ""
                                    }),
                                    staticText.email
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var v1_SocialShare = (SocialShare);


/***/ }),

/***/ 13200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OrderSummary_SocialShare; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
;// CONCATENATED MODULE: ./public/icons/share-icon.svg
/* harmony default export */ var share_icon = ({"src":"/_next/static/media/share-icon.4dbdccdb.svg","height":23,"width":22});
// EXTERNAL MODULE: ./public/icons/download-dark-gray.svg
var download_dark_gray = __webpack_require__(91883);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/cart/OrderSummary/SocialShare.jsx












const SocialShare = (param)=>{
    let { dispatchCallback =()=>{} , cartId , analyticEventData , id , specFiles , mobileView =false , componentProp: { assetUrl ="" , url: compUrl = ""  } = {} , enableDownload =true , selectedItems =[]  } = param;
    // *****
    const [shareCart, setShareCart] = (0,react.useState)({
        show: false,
        id: "",
        url: ""
    });
    const [downloading, setDownloading] = (0,react.useState)(false);
    const url = shareCart.url || "";
    const [sites, setSites] = (0,react.useState)([]);
    const { t  } = (0,esm/* useTranslation */.$G)();
    const origin = window.location.origin;
    const brandName = (0,react.useRef)("");
    const [socialMediaConfigs, setSocialMediaConfigs] = (0,react.useState)({});
    const [loading, setLoading] = (0,react.useState)(false);
    const emailBtnRef = (0,react.useRef)(null);
    const copyBtnRef = (0,react.useRef)(null);
    const shareBoxRef = (0,react.useRef)(null);
    const shareCartUrl = (0,react.useRef)("");
    const socialShareCopyIconPath = (0,react.useRef)("");
    const socialShareEmailIconPath = (0,react.useRef)("");
    const shareRef = (0,react.useRef)(null);
    const [link, setLink] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            const socialMediaConfigs = get_default()(config, "socialMediaConfig", {});
            setSocialMediaConfigs(socialMediaConfigs);
            brandName.current = get_default()(config, "general?.siteName", "");
            socialShareCopyIconPath.current = get_default()(config, "general.socialShareCopyIconPath", "");
            socialShareEmailIconPath.current = get_default()(config, "general.socialShareEmailIconPath", "");
            shareCartUrl.current = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.shareCartPagePath", ""));
        });
        getLink().then((urlLink)=>{
            setLink(urlLink);
        });
    }, []);
    const handleShareCart = ()=>{
        setLoading(true);
        const payload = {
            cartId: cartId
        };
        if (selectedItems.length) {
            payload.sharedItems = selectedItems;
        }
        dispatchCallback("shareCart", payload).unwrap().then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.sharedCartId) {
                const shareUrl = window.location.origin + shareCartUrl.current + "?share-id=".concat(res.sharedCartId);
                if (cartId) {
                    setLink(shareUrl);
                    setShareCart({
                        show: true,
                        id: res.sharedCartId,
                        url: shareUrl
                    });
                }
            }
            setLoading(false);
        });
    };
    // get component social share link url
    const getLink = async ()=>{
        const isFullUrl = /^https?:\/\//i;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = await (0,utils_location/* getShortenedUrl */.Pp)(compUrl);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,helper.sanitizeUrl)(window.location.href);
        }
    };
    const i18n = {
        email: t("kf.share.label.email", "Email"),
        emailSubject: t("kf.share.label.emailSubject", "Shared Cart Invitation"),
        copyLink: t("kf.share.label.copyLink", "Copy Link"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication", "Link Copied!"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: shareCart.id
        }, "Your cart #: ".concat(shareCart.id)),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                brandName,
                siteKey
            }, "Go to ".concat(brandName, " ").concat(siteKey, " Page")),
        openNewTabText: t("kf.share.label.openNewTabText", "will open in a new tab"),
        shareCartDesc: t("kf.cart.label.shareCartDesc", "Share your cart or download technical specs for products in your cart."),
        shareCart: t("kf.cart.label.shareCart", "Share Cart"),
        mailSubject: t("kf.share.label.emailSubject", "Shared Cart Invitation"),
        downloadSpecs: t("kf.cart.label.downloadSpecs", "Download Specs")
    };
    const [copyIcon, setCopyIcon] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        const siteList = [];
        socialMediaConfigs && (socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : (ref = socialMediaConfigs.myArrayList) === null || ref === void 0 ? void 0 : ref.forEach((socialMediaConfig)=>{
            if (!isEmpty_default()(socialMediaConfig.map && socialMediaConfig.map.name)) {
                var _name, _iconPath;
                const site = {
                    key: (_name = socialMediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                    icon: (_iconPath = socialMediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                };
                var _redirectUrl;
                const url = (_redirectUrl = socialMediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
                    siteList.push({
                        ...site,
                        url: encodeURI(url + link + "&text=".concat(document.title))
                    });
                } else if (socialMediaConfig.map.name.toLowerCase().includes("pinterest")) {
                // if (props.asset)
                //   siteList.push({
                //     ...site,
                //     url:
                //       url +
                //       `${origin}&media=${props.asset.url}&is_video=${props.asset.isVideo}$description=${props.asset.description}`,
                //   })
                } else {
                    siteList.push({
                        ...site,
                        url: url + link
                    });
                }
            }
        }));
        setSites(siteList);
    }, [
        socialMediaConfigs
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        addDataLayer("email a friend", "n/a");
    };
    const socialLinks = (e)=>{
        // temp
        // const { hostname, href} = this;
        // const target = (hostname || href) ? this : e.target;
        const target = e.target;
        const nodeUrl = target.hostname.replace(/(^www\.)/, "");
        if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
            e.stopPropagation();
            e.preventDefault();
            if (window.handleShowModal) window.handleShowModal(target.href);
        } else if (target.href) {
            window.open(target.href);
        }
        const key = target.siteKey || nodeUrl || target.hostname;
        try {
            addDataLayer(key.split(".com")[0], target.href);
        // eslint-disable-next-line no-empty
        } catch (ee) {}
    };
    const handleClickOutside = (e)=>{
        if (shareRef.current && !shareRef.current.contains(e.target)) {
            setShareCart({
                ...shareCart,
                show: false
            });
        }
    };
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        if (shareCart.show) {
            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("touchstart", handleClickOutside);
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        shareCart.show
    ]);
    // temp
    // const { internallinkposition, internallinktype, internallinkzonename } = {}
    const analyticData = analyticEventData || {
        internalLinkPosition: "n/a",
        internalLinkType: "n/a",
        internalLinkZoneName: "n/a"
    };
    const handleClick = (e)=>{
        const selELement = document.getElementById(id);
        if (shareCart.show && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target))) handleShareCart();
        // if (
        //   props.componentProp?.showModal &&
        //   window.shareSrcElement !== null &&
        //   window.shareSrcElement !== undefined &&
        //   !shareRef.current.contains(e.target)
        // ) {
        //   const shareElems = [...document.getElementsByClassName("share-cmp")]
        //   shareElems.map(el => {
        //     el.style.display = "none"
        //   })
        //   window.shareSrcElement = null
        // }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            handleShareCart();
        }
    };
    (0,react.useEffect)(()=>{
        if (shareCart.show) {
            // document.addEventListener("click", handleClick)
            document.addEventListener("keydown", handleClose);
            return ()=>{
                document.removeEventListener("click", handleClick);
                document.removeEventListener("keydown", handleClose);
            };
        }
    // if (props.componentProp?.showModal && shareCart.show) {
    //   document.addEventListener("click", handleClick)
    // }
    }, [
        shareCart.show
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        navigator.clipboard.writeText(url);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
        addDataLayer("copy link", url !== null && url !== void 0 ? url : "n/a");
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const handleDownload = async ()=>{
        setDownloading(true);
        await (0,helper.handleZipDownload)(specFiles);
        setDownloading(false);
    };
    const addDataLayer = (siteKey, link)=>{
        const { eventAction ="n/a" , eventName ="n/a" , eventType ="informative" , eventMsg ="n/a" , eventStatus ="n/a" , internalLinkPosition ="n/a" , internalLinkType ="n/a" , internalLinkZoneName ="n/a" , internalLinkURL , custom  } = analyticData;
        const eventInfo = {
            eventAction,
            eventName,
            eventType,
            eventMsg,
            eventStatus,
            internalLinkName: siteKey,
            internalLinkPosition,
            internalLinkType,
            internalLinkZoneName,
            internalLinkURL: link || internalLinkURL || "n/a",
            clickInternalLinks: siteKey === "share cart" || siteKey === "email a friend" ? "true" : "false"
        };
        if (window.dataLayerEventType) {
            eventInfo.internalLinkType = window.dataLayerEventType;
        }
        if (window.dataLayerEventZoneName) {
            eventInfo.internalLinkZoneName = window.dataLayerEventZoneName;
            if (eventAction === "n/a") {
                eventInfo.eventAction = window.dataLayerEventZoneName + ":share";
                eventInfo.eventName = window.dataLayerEventZoneName + ":share";
            }
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        let productInfo;
        if (custom) {
            try {
                productInfo = JSON.parse(custom).productInfo;
            } catch (e) {}
        }
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils/* ConditionalWrapper */.M2, {
            condition: enableDownload,
            wrapper: (children)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "download-specs".concat(mobileView ? "--mobile" : " d-none d-lg-block"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: (0,helper.sanitizeInnerHtml)(i18n.shareCartDesc)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "download-specs".concat(mobileView ? "--mobile" : "", "__cta"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    onClick: ()=>handleShareCart(),
                                    name: "socialShareModelClose",
                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "loading-spinner",
                                        style: {
                                            marginRight: 0
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: share_icon === null || share_icon === void 0 ? void 0 : share_icon.src,
                                        role: "presentation",
                                        alt: "share"
                                    })
                                }),
                                (specFiles === null || specFiles === void 0 ? void 0 : specFiles.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    role: "button",
                                    tabIndex: "0",
                                    className: "gbh-data-layer",
                                    "data-gbh-data-layer": '{"eventAction":"cart:landing page:download specs","eventName":"cart:landing page:download specs","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"download specs","internalLinkPosition":"cart","internalLinkType":"cart:download","internalLinkZoneName":"cart:landing page:order summary","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    onClick: handleDownload,
                                    children: [
                                        i18n.downloadSpecs,
                                        downloading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "loading-spinner"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src,
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        children
                    ]
                });
            },
            children: shareCart.show || !enableDownload ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "social-share",
                id: "kf-order-summary",
                ref: shareRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "social-share__box",
                    ref: shareBoxRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "social-share__sites",
                            children: shareCart.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "social-share__shared-cart-number",
                                children: i18n.yourSharedCartNumber
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                role: "list",
                                children: sites.map((site, i)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            id: "kf-social-links-".concat(i),
                                            rel: "noreferrer",
                                            href: site.url,
                                            className: "kf-social-links",
                                            "aria-label": "".concat(i18n.linksCTA(site.key), " ").concat(i18n.openNewTabText),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                "aria-hidden": "true",
                                                src: "".concat("https://www.kohler.co.in").concat(site.icon),
                                                alt: site.key,
                                                className: "social-share__".concat(site.key)
                                            })
                                        })
                                    }, i);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "social-share__actions",
                            role: "list",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        tabIndex: "0",
                                        role: "button",
                                        ref: copyBtnRef,
                                        className: "social-share__cta",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "social-share__copy-link-icon",
                                                "aria-hidden": true,
                                                src: "".concat("https://www.kohler.co.in").concat(socialShareCopyIconPath.current),
                                                role: "presentation",
                                                alt: ""
                                            }),
                                            copyIcon ? i18n.copyLinkIndication : i18n.copyLink
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "social-share__cta social-share__email",
                                        "aria-label": "".concat(i18n.email, " ").concat(i18n.openNewTabText),
                                        onKeyDown: ()=>handleShareCart(),
                                        ref: emailBtnRef,
                                        href: (0,helper.sanitizeUrl)("mailto:?subject=".concat(i18n.mailSubject, "&body=").concat(encodeURIComponent("" + link))),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat("https://www.kohler.co.in").concat(socialShareEmailIconPath.current),
                                                role: "presentation",
                                                alt: ""
                                            }),
                                            i18n.email
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null
        })
    });
};
/* harmony default export */ var OrderSummary_SocialShare = (SocialShare);


/***/ }),

/***/ 75653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34326);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19514);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91296);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88751);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9473);
/**
 * It is Quantity Selector
 *  @returns {number} the QuantitySelector
 */ 







/**
 * It returns updated Value
 * @param {props} props is the only param.
 * @return {number} the updated Value in the cart
 */ function QuantitySelector(props) {
    const { isPDPQuantitySelector , source , doNotRequiredAnalyticsData , productData , productQuantity =0 , readOnly =false , setQuantity =()=>{} , onLoading =()=>{} , isError =false  } = props;
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.value);
    const [feildVal, setFieldVal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.value);
    const [focusControl, setFocusControl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [siteName, setSiteName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const product = productData && (productData.name || productData.desc) ? productData : {};
    const minusButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const addButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const qtyInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!props.loading && value !== props.value) {
            setValue(props.value);
        } else if (!props.loading && value === props.value && value !== 1 && focusControl) {
            focusControl.current.focus();
        }
    }, [
        props.value,
        props.loading
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_4__/* .getConfig */ .i)().then((config)=>{
            setSiteName(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(config, "general.siteName", ""));
        });
    }, []);
    /**
   * @param {val} val The first number.
   * @param {action} action The second number.
   */ const handleChange = (val, action)=>{
        let fieldValue;
        if (parseInt(val)) {
            if (props.isAddToCart) {
                onLoading(true);
            }
            if (!action) {
                setFocusControl(qtyInput);
            } else {
                setFocusControl(action === "add" ? addButton : minusButton);
            }
            fieldValue = val.toString().replace(/\D/, "");
            if (fieldValue.charAt(0) === "0") {
                fieldValue = fieldValue.length === 1 ? 0 : fieldValue.substring(1);
            }
            fieldValue = fieldValue === "" ? "" : Number(fieldValue);
            // if (!window.oldValue && window.oldValue !== 0) {
            window.oldValue = Number(props.value);
            // }
            if (productQuantity !== 0 && fieldValue > productQuantity) {
                fieldValue = productQuantity;
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_6__/* .showToast */ .CF)({
                    message: "Installation quantity cannot be more than the product quantity",
                    isVisible: true
                }));
            }
        }
        if (val === "") {
            window.tempValue = JSON.parse(JSON.stringify(props.value));
            setFieldVal("");
            setQuantity("");
            qtyInput.current.focus({
                preventScroll: true
            });
        } else {
            if (val < 1) {
                props.onLoading(false);
                setQuantity(1);
            } else {
                delayedChange(fieldValue, action);
            }
        }
    };
    const handleAddAnalytics = (action, val)=>{
        var ref, ref1, ref2, ref3, ref4;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        if (source !== "cart-preview" && source !== "cart-landing" && (page === null || page === void 0 ? void 0 : (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            // this is flow of cart page only
            let updatedSku;
            page.cart.item.forEach((prod)=>{
                var ref, ref1, ref2, ref3;
                const productId = (ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                if (productId === ((ref2 = product.customerFacingSKU) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || productId === ((ref3 = product.sku) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase())) {
                    const iQty = prod.productInfo.quantity;
                    prod.productInfo = {
                        ...prod.productInfo,
                        quantity: val,
                        initialQuantity: iQty !== null && iQty !== void 0 ? iQty : Number(value)
                    };
                    prod.quantity = val;
                    updatedSku = productId;
                }
            });
            // wait till api is updating cart details
            page.eventInfo = eventInfo(action);
            page.updatedSku = updatedSku;
            window.pageObj = page;
        } else if (source === "cart-preview" || source === "cart-landing" && (page === null || page === void 0 ? void 0 : (ref2 = page.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.length)) {
            var ref5, ref6;
            // This is flow of cart preview updates
            let customPI;
            if (page === null || page === void 0 ? void 0 : (ref5 = page.cart) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.item) === null || ref6 === void 0 ? void 0 : ref6.length) {
                // update this one too to get updated page state in analytics
                page.cart.item.forEach((prod)=>{
                    var ref, ref1, ref2, ref3;
                    const productId = (ref = prod.productInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.productID) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                    if (productId === ((ref2 = product.customerFacingSKU) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || productId === ((ref3 = product.sku) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase())) {
                        const iQty = prod.productInfo.quantity;
                        prod.productInfo = {
                            ...prod.productInfo,
                            quantity: val,
                            initialQuantity: iQty !== null && iQty !== void 0 ? iQty : Number(value)
                        };
                        prod.quantity = val;
                        customPI = prod.productInfo;
                    }
                });
            }
            if (!doNotRequiredAnalyticsData) {
                window.adobeDataLayer.push({
                    event: "cmp:click",
                    eventInfo: eventInfo(action),
                    productInfo: customPI !== null && customPI !== void 0 ? customPI : productInfo(val),
                    page
                });
            }
        }
        if (source !== "cart-preview" && page && !(window === null || window === void 0 ? void 0 : (ref4 = window.pageObj) === null || ref4 === void 0 ? void 0 : ref4.updatedSku)) {
            page.updatedSku = (productData === null || productData === void 0 ? void 0 : productData.customerFacingSKU) || "true";
            window.pageObj = page;
        }
    };
    const productInfo = (val)=>{
        const itemType = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.getCartItemType)(product.category, product.businessUnitName);
        var _productSaleable, _oldValue;
        return {
            productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
            description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeTextForAnalytics)(product.desc) || "n/a",
            frequency: "n/a",
            globalPromotionPrice: product.discountPrice ? product.discountPrice : product.unitPrice,
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            priceState: product.discountPercent > 0 || product.discountAmount > 0 ? "percentOff|" + product.discountPercent : "regular price",
            productBasePrice: product.unitPrice || "n/a",
            productCategory: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeTextForAnalytics)(product.category) || "n/a",
            productColor: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeTextForAnalytics)(product.color) || "n/a",
            productCoupondiscount: "n/a",
            productID: product.customerFacingSKU || product.sku || "n/a",
            productName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeTextForAnalytics)(product.name) || "n/a",
            productPartnerBuyNow: false,
            productRoom: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeTextForAnalytics)(product.productRoom || (itemType === "service" ? itemType : "non-catalog")) || "n/a",
            productSalePrice: product.discountPrice ? product.discountPrice || "n/a" : product.unitPrice || "n/a",
            productSaleable: (_productSaleable = product.productSaleable) !== null && _productSaleable !== void 0 ? _productSaleable : "true",
            productStatus: product.availableQty >= val ? "in stock" : "out of stock",
            productSuperSku: product.superSku ? true : false,
            productTileName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeTextForAnalytics)(product.name) || "n/a",
            quantity: val,
            initialQuantity: (_oldValue = window.oldValue) !== null && _oldValue !== void 0 ? _oldValue : Number(value),
            defaultImageName: product.image || "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.pdpTypeFormat)({
                businessUnitName: props.businessUnitName,
                ProductIsRetail: props.ProductIsRetail,
                discontinuedProductb: props.discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: props.ProductRequiredAccessoriesGroupsList,
                superSku: props.superSku
            }),
            productFindingMethod: "n/a",
            productCollectionsName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.sanitizeTextForAnalytics)(product.productCollectionsName || product.category) || "n/a",
            itemType
        };
    };
    const eventInfo = (action)=>{
        return {
            eventAction: "cart preview:cart update:".concat(action).concat(isPDPQuantitySelector ? " quantity" : ""),
            eventName: "cart preview:cart update:".concat(action).concat(isPDPQuantitySelector ? " quantity" : ""),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "cart update",
            internalLinkPosition: "cart",
            internalLinkType: "cart:".concat(action === "add" ? "addition" : action === "subtract" ? "removal" : "update"),
            internalLinkZoneName: "cart:preview",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    };
    const delayedChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(lodash_debounce__WEBPACK_IMPORTED_MODULE_5___default()((val, action)=>{
        if (!action) {
            var _oldValue;
            const oldVal = (_oldValue = window.oldValue) !== null && _oldValue !== void 0 ? _oldValue : value;
            if (val > oldVal) {
                action = "add";
            } else if (val < oldVal) {
                action = "subtract";
            }
        }
        handleAddAnalytics(action, val);
        if (val < 1) {
            onLoading(false);
            setQuantity(1);
            return;
        } else props.onChange(parseInt(val));
    }, 150), [
        props.onChange
    ]);
    /**
   * input value updates her
   */ const handleBlur = ()=>{
        if (!value || parseInt(value) === 0) {
            setValue(props.value);
        }
        if (feildVal === "") {
            setFieldVal(window.tempValue);
            setQuantity(window.tempValue);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "quantity-selector no-print ".concat(props.size === "small" ? "small" : "", " ").concat(readOnly ? "read-only" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: minusButton,
                onClick: ()=>handleChange(parseInt(value) - 1, "subtract"),
                "aria-disabled": props.loading || !value || value === 1,
                disabled: props.loading || !value || value === 1 || value === "",
                "data-testid": "decrement-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "plus",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "line-1 line"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: qtyInput,
                type: "number",
                className: "quantity-selector__count",
                value: value,
                onBlur: ()=>handleBlur(),
                onChange: (e)=>handleChange(e.target.value),
                disabled: props.loading,
                "data-testid": "quantity-input",
                readOnly: readOnly
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: addButton,
                onClick: ()=>handleChange(parseInt(value) + 1, "add"),
                "aria-disabled": props.loading,
                disabled: props.loading || value === "" || isError,
                "data-testid": "increment-button",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    className: "plus",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line-1 line"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (QuantitySelector);


/***/ }),

/***/ 24562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82476);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18787);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _v1_checkoutAnalytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82883);





const ConfirmationModal = (param)=>{
    let { staticTexts , handleModalClose , isOmnichannel =false  } = param;
    const onClick = ()=>{
        handleModalClose();
        if (!isOmnichannel) (0,_v1_checkoutAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .thankYouAnalytics */ .iy)();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().confirmationModal),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "confirmationModal-body",
                children: staticTexts.confirmationmodal
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                customClass: "quantity-modal__button",
                label: "Close",
                tag: "button",
                flexible: true,
                type: "black",
                onClick: onClick
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmationModal);


/***/ }),

/***/ 82883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bb": function() { return /* binding */ changeNumberSignInAnalytics; },
/* harmony export */   "C9": function() { return /* binding */ verifyOTPAnalytics; },
/* harmony export */   "HY": function() { return /* binding */ deliveryOverlayEventInfoAnalytics; },
/* harmony export */   "Hi": function() { return /* binding */ editDeliveryAnalytics; },
/* harmony export */   "Kq": function() { return /* binding */ saveAddressClickAnalytics; },
/* harmony export */   "Nx": function() { return /* binding */ addShippingAnalytics; },
/* harmony export */   "T$": function() { return /* binding */ descriptionClickAnalytics; },
/* harmony export */   "V4": function() { return /* binding */ continueToshippingAnalytics; },
/* harmony export */   "Ye": function() { return /* binding */ addPlaceOrderDataLayer; },
/* harmony export */   "ak": function() { return /* binding */ editCartAnalytics; },
/* harmony export */   "gV": function() { return /* binding */ getAddPromoEventInfo; },
/* harmony export */   "hO": function() { return /* binding */ closeClickAnalytics; },
/* harmony export */   "hq": function() { return /* binding */ resendOTPAnalytics; },
/* harmony export */   "iy": function() { return /* binding */ thankYouAnalytics; },
/* harmony export */   "nU": function() { return /* binding */ updatePromoAnalytics; },
/* harmony export */   "o2": function() { return /* binding */ addAnalyticsAddressEdit; },
/* harmony export */   "qg": function() { return /* binding */ changeNumberAnalytics; },
/* harmony export */   "r$": function() { return /* binding */ getOTPAnalytics; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; }
/* harmony export */ });
/* unused harmony exports calculateCartAnalytics, getCheckoutReviewEventInfo, getCheckoutSignEventInfo, addCheckoutSignDataLayer, continueToPaymentAnalytics */
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);


const addShippingAnalytics = (status, message, i18n)=>{
    if (window.adobeDataLayer) {
        const eventInfo = getShippingEventInfo("next", true);
        if (status) {
            eventInfo.eventStatus = status;
        }
        if (message) {
            if (message === "failed to set shipping address." || message === "failed to get shipping options.") {
                var ref;
                message = (ref = i18n.shippingProcessError) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            }
            eventInfo.eventMsg = message;
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    }
};
const getShippingEventInfo = function(type) {
    let needJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const eventInfo = {
        eventAction: "checkout:shipping:" + type,
        eventName: "checkout:shipping:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "continue to delivery",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:shipping",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const calculateCartAnalytics = (param)=>{
    let { cart  } = param;
    const page = window.pageObj || {};
    page.cart = cart;
    page.user = getUserAnalyticsObject();
    // push this data to data layer in show event
    if (page.user && (!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
        window.pageObj = page;
        window.isShowAnalyticsEvent = true;
    } else if (!isShowAnalyticsEventLoaded()) {
        window.adobeDataLayer.push({
            event: "cmp:show",
            page
        });
        delete window.pageObj;
    }
};
const getUserAnalyticsObject = function() {
    let isFromRegisterUser = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const hashedEmail = localStorage.getItem("hashedEmail");
    const customerProspect = localStorage.getItem("customerProspect");
    let isCustomerOrProspect = "n/a";
    if (hashedEmail && customerProspect) {
        try {
            const decryptedJSON = JSON.parse(caesarDecrypt(hashedEmail, customerProspect));
            if (decryptedJSON.pastOrders.length) {
                isCustomerOrProspect = "customer";
            } else {
                isCustomerOrProspect = "prospect";
            }
        } catch (es) {
            // eslint-disable-next-line no-console
            console.log("decrypt error: ", es);
        }
    }
    // this user object should be updated when user log in or out.
    const user = {
        gId: "n/a",
        abTestName: "n/a",
        adBlocker: false,
        authStatus: "anonymous",
        commerceToolsID: "n/a",
        customerProspect: isCustomerOrProspect,
        envName: "development",
        knownStatus: "unknown",
        profileRole: "guest",
        returningStatus: "new visitor",
        emailId: hashedEmail || "n/a"
    };
    // fetch okta tokens for both logged in and anonymous users
    const oktaToken = localStorage.getItem("okta-token-storage");
    const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token");
    if (oktaToken && oktaToken !== "{}") {
        var ref;
        // user is logged in
        const oktaObject = JSON.parse(oktaToken);
        const claim = (oktaObject === null || oktaObject === void 0 ? void 0 : (ref = oktaObject.accessToken) === null || ref === void 0 ? void 0 : ref.claims) || {};
        // user.uId = claim.uid || "n/a";
        claim.businessType === "Consumer" ? user.profileRole = "consumer" : user.profileRole = "professional";
        user.commerceToolsID = claim.commercetoolsID || "n/a";
        if (!isFromRegisterUser) {
            user.returningStatus = "returning customer";
        }
        user.authStatus = "logged in";
        user.knownStatus = "known";
    } else if (anonymousOktaToken) {
        // anonymous user
        let oktaObject1;
        try {
            oktaObject1 = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {};
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Anonymous Okta Token can not be decoded......");
        }
        if (oktaObject1) {
            user.gId = oktaObject1.gId || "n/a";
        }
    }
    return user;
};
const getEventInfo = (step)=>{
    return JSON.stringify({
        eventAction: "checkout:" + step + ":edit",
        eventName: "checkout:" + step + ":edit",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "edit",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:" + step,
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getAddPromoEventInfo = async function() {
    let promoCodeLable = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "expand";
    if (window.adobeDataLayer) {
        const eventInfo = {
            eventName: "checkout:payment & billing:promo code:expand",
            eventAction: "checkout:payment & billing:promo code:expand",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: promoCodeLable,
            internalLinkPosition: "checkout",
            internalLinkZoneName: "checkout:payment and billing",
            internalLinkType: "checkout:promo code",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    }
};
const updatePromoAnalytics = async (status, cartObj, promo, action, productDiscounts)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = {
        eventAction: "checkout:payment & billing:promo code:" + action,
        eventName: "checkout:payment & billing:promo code:" + action,
        eventType: "navigation",
        eventMsg: status === "success" ? action === "remove" ? "promocode removed successfully" : "promocode applied successfully" : status === null || status === void 0 ? void 0 : status.toLowerCase(),
        eventStatus: status === "success" ? "success" : "failure",
        internalLinkName: action,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:promo code",
        internalLinkZoneName: "checkout:payment & billing",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        promoCode: promo
    };
    if (cartObj) {
        const { cart  } = await (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.calculateCartData)({
            cart: cartObj,
            i18n: {
                productDiscounts: productDiscounts || "Product Discounts"
            }
        }, true);
        page.cart = cart;
    }
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getCheckoutReviewEventInfo = function(type, link, needJson) {
    let purchasePathAnalytics = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    const eventInfo = {
        eventAction: "checkout:review:" + type,
        eventName: "checkout:review:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:review",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true",
        productSource: purchasePathAnalytics
    };
    if (needJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const addPlaceOrderDataLayer = (link, purchasePathAnalytics)=>{
    const eventInfo = getCheckoutReviewEventInfo("place order", link, true, purchasePathAnalytics);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const getCheckoutSignEventInfo = (type)=>{
    const eventInfo = {
        eventAction: "checkout:shipping:sign in",
        eventName: "checkout:shipping:sign in",
        eventType: "navigation",
        eventMsg: type === "success" ? "n/a" : "please enter a valid password",
        eventStatus: type === "success" ? "success" : "failure",
        internalLinkName: "sign in",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:shipping",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    return eventInfo;
};
const addCheckoutSignDataLayer = (type)=>{
    const eventInfo = getCheckoutSignEventInfo(type);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const addAnalyticsAddressEdit = (contactNumber)=>{
    var ref, ref1;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const productInfo = page === null || page === void 0 ? void 0 : (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.map((i)=>{
        return i === null || i === void 0 ? void 0 : i.productInfo;
    });
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "checkout:shipping:edit",
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventName: "checkout:shipping:edit",
        eventType: "navigation",
        internalLinkName: "edit",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:shipping:edit",
        internalLinkURL: "n/a",
        internalLinkZoneName: "checkout:shipping:navigation"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const getOTPAnalytics = ()=>{
    const eventInfo = {
        eventAction: "checkout:customer information:get otp",
        eventName: "checkout:customer information:get otp",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "get otp",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:customer information",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const changeNumberAnalytics = function() {
    let edit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const eventInfo = {
        eventAction: "checkout:".concat(edit ? "customer information" : "mobile number verification modal", ":").concat(edit ? "mobile number edit" : "edit number"),
        eventName: "checkout:".concat(edit ? "customer information" : "mobile number verification modal", ":").concat(edit ? "mobile number edit" : "edit number"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: edit ? "edit" : "edit number",
        internalLinkPosition: "checkout",
        internalLinkType: edit ? "checkout:mobile number" : "checkout:modal",
        internalLinkZoneName: edit ? "checkout:customer information" : "checkout:mobile number verification modal",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const changeNumberSignInAnalytics = function() {
    let edit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const eventInfo = {
        eventAction: "checkout:customer information:mobile number edit",
        eventName: "checkout:customer information:mobile number edit",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "edit number",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:mobile number",
        internalLinkZoneName: "checkout:customer information",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const verifyOTPAnalytics = function() {
    let success = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const eventInfo = {
        eventAction: "checkout:mobile number verification modal:verify",
        eventName: "checkout:mobile number verification modal:verify",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: success ? "success" : "failure",
        internalLinkName: "verify",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:modal",
        internalLinkZoneName: "checkout:mobile number verification modal",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const resendOTPAnalytics = ()=>{
    const eventInfo = {
        eventAction: "checkout:mobile number verification modal:resend otp",
        eventName: "checkout:mobile number verification modal:resend otp",
        eventType: "navigation",
        eventMsg: "n/a",
        internalLinkName: "resend otp",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:modal",
        internalLinkZoneName: "checkout:mobile number verification modal",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const thankYouAnalytics = ()=>{
    const eventInfo = {
        eventAction: "checkout:mobile number verification modal:thank you modal:close",
        eventName: "checkout:mobile number verification modal:thank you modal:close",
        eventType: "navigation",
        eventMsg: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:modal",
        internalLinkZoneName: "checkout:mobile number verification modal:thank you modal",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const descriptionClickAnalytics = function() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", link = arguments.length > 1 ? arguments[1] : void 0;
    const linkText = text.toLowerCase();
    const linkUrl = (link.indexOf("http") === -1 ? window.location.origin : "") + link;
    const eventInfo = {
        eventAction: "checkout:mobile number verification modal:".concat(linkText),
        eventName: "checkout:mobile number verification modal:".concat(linkText),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkText,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:modal",
        internalLinkZoneName: "checkout:mobile number verification modal",
        internalLinkURL: linkUrl,
        clickInternalLinks: "false"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const closeClickAnalytics = ()=>{
    const eventInfo = {
        eventAction: "checkout:mobile number verification modal:close",
        eventName: "checkout:mobile number verification modal:close",
        eventType: "navigation",
        eventMsg: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:modal",
        internalLinkZoneName: "checkout:mobile number verification modal",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const continueToshippingAnalytics = ()=>{
    const eventInfo = {
        eventAction: "checkout:customer information:continue to shipping",
        eventName: "checkout:customer information:continue to shipping",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "continue to shipping",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:customer information",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const editCartAnalytics = ()=>{
    const eventInfo = {
        eventAction: "checkout:shipping:edit",
        eventName: "checkout:shipping:edit",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "edit",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:shipping",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const editDeliveryAnalytics = ()=>{
    const eventInfo = {
        eventAction: "checkout:delivery options:edit",
        eventName: "checkout:delivery options:edit",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "edit",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:delivery options",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const continueToPaymentAnalytics = ()=>{
    const eventInfo = {
        eventAction: "checkout:delivery options:next",
        eventName: "checkout:delivery options:next",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "continue to payment",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:delivery option:standard",
        internalLinkZoneName: "checkout:delivery options",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const saveAddressClickAnalytics = (status)=>{
    const eventInfo = {
        eventAction: "checkout:shipping:edit shipping address modal:".concat(status),
        eventName: "checkout:shipping:edit shipping address modal:".concat(status),
        eventType: "navigation",
        eventMsg: "n/a",
        internalLinkName: status,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:shipping:edit shipping address modal",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const deliveryOverlayEventInfoAnalytics = function() {
    let pdpUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, productInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "checkout:product navigation",
        eventMsg: "n/a",
        eventName: "checkout:product navigation",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(data.name),
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkURL: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.getAnalyticsUrl)(pdpUrl),
        internalLinkZoneName: "checkout:preview"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    if (productInfo.length > 0) page["productInfo"] = productInfo;
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};



/***/ }),

/***/ 92173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_collapsible__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97893);
/* harmony import */ var react_collapsible__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_collapsible__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97274);
/* harmony import */ var _public_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32873);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20558);
/* harmony import */ var _components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96724);
/* harmony import */ var _components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const Accordion = (props)=>{
    const { isOpen =false , analyticTitleData , analyticTitleCustomData , contentOverflow =false , trigger =false , children ="" , title , handleOpen , handleClose , containerElementProps , isArrow =false , titleClassName ="" , triggerElementId =null , contentElementId =null , expandAnalyticsEvent =()=>{}  } = props;
    const CollapsibleHeader = (param)=>/*#__PURE__*/ {
        let { title  } = param;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "collapsible__header ".concat(analyticTitleData ? "gbh-data-layer" : ""),
            "data-gbh-data-layer": analyticTitleData || null,
            "data-gbh-data-layer-custom": analyticTitleCustomData || null,
            onClick: expandAnalyticsEvent,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    role: "heading",
                    "aria-level": "5",
                    className: titleClassName,
                    children: title
                }),
                !isArrow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "plus",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "arrow",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "down-arrow",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: _public_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                    alt: "Arrow Down"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "up-arrow",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                                alt: "Arrow Up"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_6___default().accordionWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "collapsible-accordion",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_collapsible__WEBPACK_IMPORTED_MODULE_2___default()), {
                open: isOpen,
                onTriggerOpening: handleOpen,
                onTriggerClosing: handleClose,
                containerElementProps: containerElementProps,
                overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                openedClassName: "collapsible--open",
                tabIndex: "0",
                triggerOpenedClassName: "collapsible__trigger--open",
                trigger: trigger ? trigger : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollapsibleHeader, {
                    title: title
                }),
                transitionTime: 400,
                easing: "ease-in-out",
                triggerElementProps: {
                    id: triggerElementId !== null && triggerElementId !== void 0 ? triggerElementId : (0,_utils_index__WEBPACK_IMPORTED_MODULE_5__/* .accordionUniqueId */ .M0)("collapsible-trigger", 9999, 1000)
                },
                contentElementId: contentElementId !== null && contentElementId !== void 0 ? contentElementId : (0,_utils_index__WEBPACK_IMPORTED_MODULE_5__/* .accordionUniqueId */ .M0)("collapsible-content", 9999, 1000),
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 81511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55111);
/* harmony import */ var _components_core_Autocomplete_Autocomplete_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2534);
/* harmony import */ var _components_core_Autocomplete_Autocomplete_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_core_Autocomplete_Autocomplete_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const Autocomplete = (props)=>{
    const { customClass , id , tabIndex , label , ariaLabel , ariaRequired , value , ariaStateText , data , showError , errorMessage  } = props;
    const [dataList, setDataList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (data) {
            const sortData = data.sort((a, b)=>{
                return (a === null || a === void 0 ? void 0 : a.name) < (b === null || b === void 0 ? void 0 : b.name) ? -1 : (a === null || a === void 0 ? void 0 : a.name) > (b === null || b === void 0 ? void 0 : b.name) ? 1 : 0;
            });
            setDataList(sortData);
        }
    });
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const listRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [opened, setOpened] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [options, setOptions] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    let isFocused = false;
    const dropDownClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "select-dropdown": true,
        "dropdown--open": showList
    });
    const inputClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()("select-dropdown__border", props.disabled ? "--disabled" : null, props.showError ? "--with-error" : null, focus ? "--focused" : null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) {
            setOpened(true);
        } else if (!showList && opened && props.onClose) {
            props.onClose();
            setOpened(false);
        }
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.focus) {
            inputRef.current.focus();
        }
    }, [
        props === null || props === void 0 ? void 0 : props.focus
    ]);
    const handleSelect = (value)=>{
        props.onChange(value);
        setShowList(false);
    };
    const handleMouseDownEvent = ()=>{
        isFocused = true;
        setShowList(!showList);
    };
    const handleBlurEvent = (e)=>{
        if (e instanceof MouseEvent) {
            isFocused;
            setShowList(false);
        }
        if (typeof props.onBlur === "function") {
            props.onBlur();
        }
    };
    const toggleList = ()=>{
        if (showList) {
            setShowList(false);
            document.getElementById(props.id).focus();
        } else {
            var ref, ref1, ref2;
            setShowList(true);
            (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : (ref1 = ref.childNodes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.focus();
        }
    };
    const btnKeyDown = (e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        switch(e.keyCode){
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                e.preventDefault();
                toggleList();
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        const ele = document.getElementById("".concat(props.id, "-list")).childNodes;
        switch(e.keyCode){
            case KEYCODE.ESC:
                toggleList();
                break;
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                ele[i].click();
                document.getElementById(props.id).focus();
                break;
            default:
                break;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const indexValue = dataList.indexOf(dataList.find((val)=>{
            return (val === null || val === void 0 ? void 0 : val.name) === value;
        }));
        const filteredData = dataList === null || dataList === void 0 ? void 0 : dataList.filter((param)=>{
            let { name  } = param;
            return (name === null || name === void 0 ? void 0 : name.toLowerCase().includes(value === null || value === void 0 ? void 0 : value.toLowerCase())) && (name === null || name === void 0 ? void 0 : name.toLowerCase().startsWith(value === null || value === void 0 ? void 0 : value.toLowerCase()));
        });
        if (indexValue === -1) {
            setOptions(filteredData);
        } else {
            const tempData = dataList;
            const newListData = tempData.filter((val)=>{
                return (val === null || val === void 0 ? void 0 : val.name) !== value;
            });
            const validData = filteredData.concat(newListData);
            setOptions(validData);
        }
    }, [
        value,
        dataList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        document.addEventListener("click", function(e) {
            if (showList && document.getElementById(props.id) && !document.getElementById(props.id).contains(e.target)) {
                setShowList(false);
            }
        });
    });
    const handleValueChange = (event)=>{
        props.onChange(event.target.value);
        setShowList(true);
    };
    const keyDownAction = (e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        switch(e.keyCode){
            case KEYCODE.DOWN:
                var ref, ref1;
                listRef.current = document.getElementById("".concat(props.id, "-list-", 0));
                (ref = document.getElementById("".concat(id, "-list"))) === null || ref === void 0 ? void 0 : ref.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
                (ref1 = listRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_Autocomplete_Autocomplete_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: handleMouseDownEvent,
            onBlur: handleBlurEvent,
            className: "".concat(dropDownClass, " ").concat(customClass !== null && customClass !== void 0 ? customClass : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: id,
                    className: "select-dropdown__field ".concat(showError ? "--with-error" : ""),
                    onKeyDown: btnKeyDown,
                    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
                    role: "combobox",
                    "aria-controls": "dropdown-listbox",
                    "aria-expanded": showList,
                    "aria-haspopup": "true",
                    "aria-label": label ? label.replace(/\*/g, "") : ariaLabel ? ariaLabel.replace(/\*/g, "") : "",
                    "aria-required": (ariaRequired !== null && ariaRequired !== void 0 ? ariaRequired : label.indexOf("*") > 0) ? true : false,
                    "aria-describedby": "".concat(id, "-selected"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: inputClasses,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "select-dropdown__data-value",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "input-".concat(id),
                                        type: "text",
                                        value: value,
                                        name: props.name,
                                        maxLength: props.maxLength,
                                        disabled: props.disabled,
                                        placeholder: props.label.replace(/\*/g, ""),
                                        onChange: handleValueChange,
                                        autoComplete: "off",
                                        onKeyDown: keyDownAction
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        htmlFor: "input-".concat(id),
                                        "aria-hidden": "true",
                                        children: label
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "select-dropdown__icon ".concat(showList ? "--open" : ""),
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/icons/down-icon.svg",
                                alt: "open-icon"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    id: "".concat(id, "-list"),
                    className: "select-dropdown__dropdown",
                    role: "listbox",
                    tabIndex: "-1",
                    "aria-expanded": "true",
                    "data-testid": "select-dropdown",
                    children: showList && (options === null || options === void 0 ? void 0 : options.map((item, i)=>{
                        var ref, ref1;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            ref: listRef,
                            id: "".concat(id, "-list-").concat(i),
                            className: "select-dropdown__list-item ".concat((item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase()) && "selected-item"),
                            "aria-selected": (item === null || item === void 0 ? void 0 : (ref1 = item.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === (value === null || value === void 0 ? void 0 : value.toLowerCase()),
                            role: "option",
                            tabIndex: "-1",
                            onClick: ()=>{
                                return handleSelect(item === null || item === void 0 ? void 0 : item.name);
                            },
                            onKeyDown: (e)=>handleKeyDown(i, e),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "select-dropdown__list-value",
                                children: item === null || item === void 0 ? void 0 : item.name
                            })
                        }, i);
                    }))
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-live": "polite",
                    role: "region",
                    className: "select-dropdown__error-message",
                    children: errorMessage
                })
            ]
        })
    });
};
Autocomplete.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Autocomplete);


/***/ }),

/***/ 18377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83839);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7154);




const DynamicImage = (param)=>{
    let { imgUrl ="" , alt ="" , className ="" , uniqueId ="" , urlModifiers ="" , fetchPriority ="auto" , ...restProps } = param;
    const smartCrop = (0,_hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const cropedImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const isScene7Img = imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("scene7");
    const [bgColorImage, setBgColorImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && smartCrop.scriptStatus && isScene7Img && window.s7responsiveImage) {
            smartCrop.applySmartCrop(cropedImage.current);
        }
    }, [
        smartCrop.scriptStatus,
        imgUrl,
        window.s7responsiveImage,
        uniqueId,
        isSsr
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (urlModifiers && imgUrl) {
            setBgColorImage((imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("?")) ? "".concat(imgUrl, "&").concat(urlModifiers) : "".concat(imgUrl, "?").concat(urlModifiers));
        }
    }, [
        imgUrl,
        urlModifiers
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: cropedImage,
        src: fetchPriority === "high" ? imgUrl : imgPlaceholder,
        "data-src": urlModifiers ? bgColorImage : imgUrl,
        "data-mode": "smartcrop",
        alt: alt,
        className: className,
        fetchPriority: fetchPriority,
        ...restProps
    }, uniqueId);
};
/* harmony default export */ __webpack_exports__["Z"] = (DynamicImage);


/***/ }),

/***/ 77860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55111);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8618);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const SelectDropdown = (props)=>{
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [opened, setOpened] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [customLabel, setCustomLabel] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    let isFocused = false;
    const dropDownClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "select-dropdown": true,
        "dropdown--open": showList
    });
    const dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) {
            setOpened(true);
        } else if (!showList && opened && props.onClose) {
            props.onClose();
            setOpened(false);
        }
    }, [
        showList
    ]);
    const handleSelect = (value)=>{
        props.onChange(value);
        setShowList(false);
    };
    const handleMouseDownEvent = ()=>{
        if (disabled) {
            return;
        }
        isFocused = true;
        setShowList(!showList);
        if (props.labelAfterClick) setCustomLabel(true);
    };
    const handleBlurEvent = (e)=>{
        if (e instanceof MouseEvent) {
            isFocused;
            setShowList(false);
        }
        if (typeof props.onBlur === "function") {
            props.onBlur();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.addEventListener("mousedown", onClickEvent);
        return ()=>{
            window.removeEventListener("mousedown", onClickEvent);
        };
    }, [
        showList
    ]);
    const onClickEvent = (e)=>{
        const { current ={}  } = dropdownRef;
        if (showList && !current.contains(e.target)) {
            setShowList(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props.labelAfterClick && !props.value) setCustomLabel(false);
    }, [
        props.value
    ]);
    const toggleList = ()=>{
        if (showList) {
            setShowList(false);
            document.getElementById(props.id).focus();
        } else {
            var ref;
            setShowList(true);
            (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].focus();
        }
    };
    const btnKeyDown = (e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        switch(e.keyCode){
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                e.preventDefault();
                toggleList();
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_3__["default"];
        const ele = document.getElementById("".concat(props.id, "-list")).childNodes;
        switch(e.keyCode){
            case KEYCODE.ESC:
                toggleList();
                break;
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                ele[i].click();
                document.getElementById(props.id).focus();
                break;
            default:
                break;
        }
    };
    const { customClass , id , tabIndex , label , ariaLabel , ariaRequired , value , ariaStateText , data , showError , errorMessage , labelAfterClick , disabled  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        ref: dropdownRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: handleMouseDownEvent,
            onBlur: handleBlurEvent,
            className: "".concat(dropDownClass, " ").concat(customClass !== null && customClass !== void 0 ? customClass : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: id,
                    className: "select-dropdown__field ".concat(showError && !disabled ? "--with-error" : "", " ").concat(disabled ? "--with-disable" : ""),
                    onKeyDown: btnKeyDown,
                    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
                    role: "combobox",
                    "aria-controls": "dropdown-listbox",
                    "aria-expanded": showList,
                    "aria-haspopup": "true",
                    "aria-label": label ? label.replace(/\*/g, "") : ariaLabel ? ariaLabel.replace(/\*/g, "") : "",
                    "aria-required": (ariaRequired !== null && ariaRequired !== void 0 ? ariaRequired : label.indexOf("*") > 0) ? true : false,
                    "aria-describedby": "".concat(id, "-selected"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "select-dropdown__display",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    "aria-hidden": true,
                                    className: "select-dropdown__placeholder ".concat(value ? "--label" : ""),
                                    children: customLabel ? labelAfterClick : label
                                }),
                                value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    id: "".concat(id, "-selected"),
                                    className: "select-dropdown__value",
                                    children: value
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "select-dropdown__icon ".concat(showList ? "--open" : ""),
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/icons/down-icon.svg",
                                alt: "open-icon"
                            })
                        })
                    ]
                }),
                !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    id: "".concat(id, "-list"),
                    className: "select-dropdown__dropdown",
                    role: "listbox",
                    tabIndex: "-1",
                    "aria-expanded": "true",
                    "data-testid": "select-dropdown",
                    children: [
                        !ariaStateText && (data === null || data === void 0 ? void 0 : data.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item === value && "selected-item"),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                onClick: ()=>handleSelect(item),
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: item
                                })
                            }, i))),
                        ariaStateText && (data === null || data === void 0 ? void 0 : data.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item.code === value && "selected-item"),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                "aria-label": item.name,
                                onClick: ()=>handleSelect(item.code),
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: item.code
                                })
                            }, i)))
                    ]
                }),
                showError && errorMessage && !disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-live": "polite",
                    role: "region",
                    className: "select-dropdown__error-message",
                    children: errorMessage
                })
            ]
        })
    });
};
SelectDropdown.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectDropdown);


/***/ }),

/***/ 29707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_core_TextArea_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81770);
/* harmony import */ var _components_core_TextArea_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_core_TextArea_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Input = (props)=>{
    var ref;
    const { showError , errorMessage , id , hideLabelOnFocus =false  } = props;
    const [focus, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const errorRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.focus) {
            inputRef.current.focus();
        }
    }, [
        props === null || props === void 0 ? void 0 : props.focus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showError && errorMessage) {
            errorRef.current.focus();
        }
    }, [
        showError,
        errorMessage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_components_core_TextArea_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "textarea__wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                        value: props.value,
                        placeholder: props.placeholder,
                        onChange: props.onChange,
                        onFocus: (e)=>{
                            setFocus(true);
                            props.onFocus && props.onFocus(e);
                        },
                        onBlur: (e)=>{
                            setFocus(false);
                            props.onBlur && props.onBlur(e);
                        },
                        maxLength: props.maxLength,
                        className: "".concat(props.className, " ").concat(props.showError ? "--with-error" : "")
                    }),
                    !hideLabelOnFocus ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        children: props.label
                    }) : !focus && !(props === null || props === void 0 ? void 0 : (ref = props.value) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        children: props.label
                    })
                ]
            }),
            showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                ref: errorRef,
                "aria-live": "polite",
                role: "alert",
                id: "".concat(id, "-error"),
                className: "textarea__wrapper__error-message",
                children: errorMessage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 27221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Highlight_Highlight__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(293);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57333);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34326);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7154);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55111);
/* harmony import */ var _components_productCard_v1_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41740);









const ProductCardView = (param)=>{
    let { i18n , product , currencySign , presetConfigs , swatchUrl , parent , title , brandName , bestSellerContent  } = param;
    const { COMPONENT  } = _constants_index__WEBPACK_IMPORTED_MODULE_7__["default"];
    const [productCardWidth, setProductCardWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const productCardRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    const presetConfigObject = presetConfigs ? JSON.parse(presetConfigs) : {};
    const newTab = false;
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setProductCardWidth(productCardRef.current.clientWidth);
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_4__.getPDPUrl)(product === null || product === void 0 ? void 0 : product.productCategory, product === null || product === void 0 ? void 0 : product.slug).then((ret)=>setPdpNavigationURL(ret));
    }, [
        product
    ]);
    const formatUrl = (uUrl, iWidth)=>{
        if (!uUrl.includes("data:image")) {
            var ref;
            const sUrlPath = (ref = uUrl.split("?")[0]) === null || ref === void 0 ? void 0 : ref.split("/");
            const sUrlId = sUrlPath[sUrlPath.length - 1];
            let sPreset = "";
            if (iWidth <= 167) {
                var ref1;
                sPreset = (ref1 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobileLandscape) !== null && ref1 !== void 0 ? ref1 : "";
            } else if (iWidth <= 458) {
                var ref2;
                sPreset = (ref2 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.Desktop) !== null && ref2 !== void 0 ? ref2 : "";
            } else {
                var ref3;
                sPreset = (ref3 = presetConfigObject === null || presetConfigObject === void 0 ? void 0 : presetConfigObject.MobilePortrait) !== null && ref3 !== void 0 ? ref3 : "";
            }
            if (parent === COMPONENT.PAIRS_WELL_WITH) {
                return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?&product_src=is{PAWEB/").concat(sUrlId, "}&").concat(sPreset);
            }
            return "".concat(swatchUrl).concat(presetConfigObject.PotraitCategory, "?$product_src=is{PAWEB/").concat(sUrlId, "}&?").concat(sPreset);
        }
        return uUrl;
    };
    const getProductName = ()=>{
        if (!parent && title) {
            return title;
        }
        return product.name || brandName ? product.name || brandName : product.name ? product.name : product.description;
    };
    const redirectPdp = (e, url)=>{
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
    };
    var _mrpPrice, _price;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: productCardRef,
        className: "product-card",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: (e)=>{
                return redirectPdp(e, "".concat(pdpNavigationURL, "?skuId=").concat(product === null || product === void 0 ? void 0 : product.selSku));
            },
            "aria-label": "".concat(product.name, " ").concat(currencySign + product.price, " ").concat(product.colors.length, " ").concat(i18n.ariaLabelColor),
            className: "product-card__link gbh-data-layer",
            "data-gbh-data-layer": !isSsr ? (0,_components_productCard_v1_analytics__WEBPACK_IMPORTED_MODULE_8__/* .getMoreInCollectionsInfo */ .VA)(title !== null && title !== void 0 ? title : "", false, pdpNavigationURL, product) : "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__img-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: // _isEmpty(presetConfigs)
                        //   ? formatUrl(product.images, productCardWidth)
                        product.images,
                        className: "product-card__img",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "product-card__name".concat(!parent ? " default" : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Highlight_Highlight__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    text: getProductName()
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "product-card__right",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            className: "product-card__price".concat(!parent ? " default" : ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* .NumericFormat */ .h3, {
                                                value: product.discountPrice > 0 ? product.discountPrice : product.price,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currencySign,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        })
                                    ]
                                }),
                                bestSellerContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row product-card__discount-price",
                                            children: product.discountPrice > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: true,
                                                children: [
                                                    "MRP",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* .NumericFormat */ .h3, {
                                                        value: (_mrpPrice = product.mrpPrice) !== null && _mrpPrice !== void 0 ? _mrpPrice : 0,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row product-card__percent-off",
                                            children: product.discountPrice > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "colored-number",
                                                children: [
                                                    Number(product.discountpercent).toFixed(),
                                                    "%OFF"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "product-card__details",
                    children: [
                        !bestSellerContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "product-card-desc",
                                children: product.name || title || brandName ? product.description : ""
                            })
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__right",
                            children: product.discountedPrice !== product.price && product.discountedPrice > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "product-card__discount-price",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* .NumericFormat */ .h3, {
                                    value: (_price = product.price) !== null && _price !== void 0 ? _price : 0,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-card__details",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-card__left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "product-card__color-text",
                            children: !bestSellerContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: product.colors.length > 1 ? "".concat(product.colors.length, " ").concat(i18n.recentlyViewedColors) : "1 ".concat(i18n.recentlyViewedColor)
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardView);


/***/ }),

/***/ 81294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52786);

const useSearchi18n = (param)=>{
    let { componentProp  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)();
    const i18n = {
        searchPlaceHolder: t("kf.technical.label.searchPlaceHolder"),
        for: t("kf.search.label.for"),
        searchInstead: t("kf.search.label.searchInstead"),
        showing: t("kf.search.label.showing"),
        results: t("kf.search.label.results"),
        resultsCaps: t("kf.search.label.resultsCaps"),
        addToCart: t("kf.compare.label.addToCart"),
        products: t("kf.search.label.products"),
        parts: t("kf.search.label.parts"),
        technical: t("kf.search.label.technical"),
        inspiration: t("kf.search.label.inspiration"),
        resource: t("kf.search.label.resource"),
        help: t("kf.search.label.help"),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        sort: t("kf.plp.label.sort"),
        applyFilters: "Apply Filters",
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        showMore: t("kf.plp.label.showMore"),
        showLess: t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
        priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
        to: t("kf.plp.label.to"),
        minText: t("kf.plp.label.minText"),
        maxText: t("kf.plp.label.maxText"),
        bestSellers: t("kf.plp.label.bestSellers"),
        featured: t("kf.plp.label.featured"),
        onSale: t("kf.plp.label.onSale"),
        relevancy: t("kf.plp.label.relevancy"),
        date: t("kf.plp.label.date"),
        priceDesc: t("kf.plp.label.priceDesc"),
        priceAsc: t("kf.plp.label.priceAsc"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: t("kf.compare.validation.maxProducts"),
        errors: {
            validRange: t("kf.plp.error.validRange"),
            minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
            maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
            checkValid: t("kf.error.message.price")
        },
        new: t("kf.plp.label.new"),
        sale: t("kf.plp.label.sale"),
        category: t("kf.technical.label.category"),
        collection: t("kf.technical.label.collection"),
        certifications: t("kf.technical.label.certifications"),
        designFiles: t("kf.technical.label.designFiles"),
        technicalInfo: t("kf.pdp.label.specs"),
        installationSupport: t("kf.pdp.label.installationSupport"),
        addToFolder: t("kf.technical.label.addToFolder"),
        selectAll: t("kf.technical.label.selectAll"),
        download: t("kf.technical.label.download"),
        hideDiscontinued: t("kf.plp.label.hideDiscontinued"),
        file: t("kf.technical.label.file"),
        files: t("kf.technical.label.files"),
        specsSheet: t("kf.technical.label.specsSheet"),
        envDeclaration: t("kf.technical.label.envDeclaration"),
        installationGuide: t("kf.technical.label.installationGuide"),
        userGuide: t("kf.technical.label.userGuide"),
        homeOwnerGuide: t("kf.technical.label.homeOwnerGuide"),
        declareLabel: t("kf.technical.label.declareLabel"),
        tearSheet: t("kf.technical.label.tearSheet"),
        quickReference: t("kf.technical.label.quickReference"),
        warranty: t("kf.technical.label.warranty"),
        serviceParts: t("kf.technical.label.serviceParts"),
        suggestions: t("kf.search.label.suggestions"),
        checkSpelling: t("kf.search.label.checkSpelling"),
        simplerWord: t("kf.search.label.simplerWord"),
        searchSimilar: t("kf.search.label.searchSimilar"),
        popularSearch: t("kf.search.label.trendingSearch"),
        commonTopics: t("kf.search.label.commonTopics"),
        noResults: t("kf.search.label.noResults"),
        loading: t("kf.search.label.loading"),
        twoDplan: t("kf.technical.label.twoDplan"),
        twoDside: t("kf.technical.label.twoDside"),
        twoDfront: t("kf.technical.label.twoDfront"),
        threeDfile: t("kf.technical.label.threeDfile"),
        bimFile: t("kf.technical.label.bimFile"),
        cutoutTemplate: t("kf.technical.label.cutoutTemplate"),
        viewResults: t("kf.plp.label.viewResults"),
        popularSearchText: t("kf.search.label.trendingSearch"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        searchBrand: t("kf.search.label.searchBrand"),
        brand: t("kf.search.label.brand"),
        items: t("kf.plp.label.items"),
        etc: t("kf.plp.label.etc"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        discontinuedText: t("kf.pdp.label.discontinuedTxt"),
        partsDiagram: t("kf.pdp.label.partsDiagram"),
        guides: t("kf.technical.label.guides"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        ariaLabel: {
            tabs: (count, tabName)=>t("kf.search.aria.label.tabs", {
                    count,
                    tabName
                }),
            loadMore: t("kf.search.aria.label.loadMore"),
            loadMoreArticles: t("kf.search.aria.label.loadMoreArticles"),
            close: t("kf.search.aria.label.clear"),
            addToCompare: (product)=>t("kf.plp.label.aria.addToCompare", {
                    product
                }),
            currentPage: t("kf.pdp.label.aria.currentPage"),
            page: t("kf.pdp.label.aria.page"),
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected"),
            breadcrumb: t("kf.pdp.label.aria.breadcrumb")
        },
        home: t("kf.technical.label.home"),
        searchResults: t("kf.technical.label.searchResults"),
        searchText: t("kf.search.label.searchText"),
        searchNoResultErrorMessage: (componentProp === null || componentProp === void 0 ? void 0 : componentProp.searchFilterErrorMsg) ? componentProp === null || componentProp === void 0 ? void 0 : componentProp.searchFilterErrorMsg : t("kf.search.label.noResultsMssg"),
        noResults: t("kf.search.label.noResults"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        arialLabelPrint: (val)=>t("kf.plp.label.aria.print", {
                val: val
            }),
        ariaLabelShare: (val)=>t("kf.plp.label.aria.share", {
                val: "".concat(val, " page")
            }),
        favorites: t("kf.account.label.favorites"),
        removeItem: t("kf.favorites.removeItem"),
        downloadSuccess: t("kf.PressRoom.label.downloadSuccess"),
        downloadFailure: t("kf.PressRoom.label.downloadFailure"),
        installationAvailable: t("kf.pdp.label.installationAvailable")
    };
    return i18n;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSearchi18n);


/***/ }),

/***/ 47537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85518);
/* harmony import */ var _public_icons_back_top_arrow_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12522);
/* harmony import */ var _public_icons_print_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30402);
/* harmony import */ var _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66773);
/* harmony import */ var _components_ProductList_v2_ProductListView_ProductsPerPage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1306);
/* harmony import */ var _components_cart_OrderSummary_SocialShare__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13200);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48595);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20558);










const Pagination = (param)=>{
    let { displayPrint ="" , staticTexts ={} , displayShare ="" , curRows =30 , productsPerPage =[] , totalResults =0 , onRows =()=>{} , handleBackToTop =()=>{} , width =1280 , isSearchTab =false , page ="" , type ="" , customClass ={} , includeWrapper =true  } = param;
    const { print ="" , share ="" , backToTop =""  } = staticTexts;
    const [showSocialLink, setShowSocialLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { buttonClass ="" , spanClass ="" , imgClass =""  } = customClass !== null && customClass !== void 0 ? customClass : {};
    const getBackToTopAnalyticsData = ()=>{
        if (isSearchTab && page === "search") return (0,_components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .searchGetBackToTopAnalytics */ .tf)(type);
        else if (page === "technicalspecs") return _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .technicalSpecGetBackToTopAnalytics */ .gr;
        else if (page === "plp") return _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .plpGetBackToTopAnalytics */ .a$;
        else return _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .defaultGetBackToTopAnalytics */ .cI;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_utils__WEBPACK_IMPORTED_MODULE_9__/* .ConditionalWrapper */ .M2, {
        condition: includeWrapper,
        wrapper: (children)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-listing__row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-listing__back-to-top",
                    children: children
                })
            }),
        children: [
            react_device_detect__WEBPACK_IMPORTED_MODULE_2__/* .isMobile */ .tq && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "product-listing__print-and-share",
                children: [
                    displayPrint === "true" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        role: "button",
                        onClick: ()=>{
                            return window === null || window === void 0 ? void 0 : window.print();
                        },
                        children: [
                            print,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _public_icons_print_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _public_icons_print_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_print_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                alt: print
                            })
                        ]
                    }),
                    displayShare === "true" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        role: "button",
                        onClick: ()=>setShowSocialLink(!showSocialLink),
                        children: [
                            share,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === null || _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
                                alt: share
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_SocialShare__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        showModal: showSocialLink,
                        id: "kf-product-listing",
                        onClose: ()=>setShowSocialLink(false)
                    })
                ]
            }),
            width > 1023 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductListView_ProductsPerPage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                pos: "bottom",
                curRows: curRows,
                data: productsPerPage,
                totalResults: totalResults,
                texts: staticTexts,
                onChange: onRows,
                selectedTab: type,
                page: page
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                role: "link",
                className: "".concat(buttonClass || "product-listing__go-back", " gbh-data-layer"),
                "data-gbh-data-layer": getBackToTopAnalyticsData(),
                onClick: handleBackToTop,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "".concat(spanClass || "product-listing__go-back-text"),
                        children: backToTop
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "".concat(imgClass || "product-listing__go-back-image"),
                        "aria-hidden": "true",
                        src: _public_icons_back_top_arrow_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _public_icons_back_top_arrow_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_back_top_arrow_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                        alt: backToTop
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 57633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination_LoadMore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69519);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination_Pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47537);




const ProductPagination = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductListView_Pagination_LoadMore__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductListView_Pagination_Pagination__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                ...props
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductPagination);


/***/ }),

/***/ 73812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_Sort; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/Sort/sortAnalytics.js
const getAnalyticsData = function(item) {
    let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, { selectedtab , page  } = arguments.length > 2 ? arguments[2] : void 0;
    let analyticsData = {
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(item.name),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (page === "search" && selectedtab === "technical") {
        analyticsData = {
            ...analyticsData,
            eventAction: "search results:technical:main content area:sort by",
            eventName: "search results:technical:main content area:sort by",
            internalLinkPosition: "search results",
            internalLinkType: "search results:sort by",
            internalLinkZoneName: "search results:technical:main content area"
        };
    }
    switch(page){
        case "search":
            analyticsData = {
                ...analyticsData,
                eventAction: "search results:".concat(selectedtab, ":main content area:sort by"),
                eventName: "search results:".concat(selectedtab, ":main content area:sort by"),
                internalLinkPosition: "search results",
                internalLinkType: "search results:sort by",
                internalLinkZoneName: "search results:".concat(selectedtab, ":main content area")
            };
            break;
        case "favorites":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:favorites:".concat(selectedtab, ":sort by"),
                eventName: "my account:favorites:".concat(selectedtab, ":sort by"),
                internalLinkPosition: "favorites",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:favorites:".concat(selectedtab)
            };
            break;
        case "article":
            analyticsData = {
                ...analyticsData,
                eventAction: "support:help and faq:article list​:sort by",
                eventName: "support:help and faq:article list​:sort by",
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:sort by",
                internalLinkZoneName: "support:help and faq:article list​​"
            };
            break;
        case "active-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:active services​:sort by",
                eventName: "my account:services:active services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:active services"
            };
            break;
        case "past-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:past services​:sort by",
                eventName: "my account:services:past services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:past services"
            };
            break;
        case "literature":
            analyticsData = {
                ...analyticsData,
                eventAction: "literature:sort by",
                eventName: "literature:sort by",
                internalLinkPosition: "literature",
                internalLinkType: "literature:sort by",
                internalLinkZoneName: "literature:main content area"
            };
            break;
        case "press-release":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press releases:sort by",
                eventName: "press room:press releases:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press releases:main content area"
            };
            break;
        case "press-kits":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press kits:sort by",
                eventName: "press room:press kits:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press kits:main content area"
            };
            break;
        case "my products":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:products:sort by filter",
                eventName: "my account:products:sort by filter",
                internalLinkPosition: "my account",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:products"
            };
            break;
        default:
            analyticsData = {
                ...analyticsData,
                eventAction: "plp sort by filter",
                eventName: "plp sort by filter",
                internalLinkPosition: "plp",
                internalLinkType: "plp:sort by",
                internalLinkZoneName: "plp:sort by filter"
            };
    }
    if (needJson) return analyticsData;
    return JSON.stringify(analyticsData);
};

// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
;// CONCATENATED MODULE: ./src/hooks/useOnClickOutside.js


/**
 *
 * @param {*} ref
 * @param {*} handler
 */ const useOnClickOutside = (ref, handler)=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        const listener = (event)=>{
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        if (!isSsr) {
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
        }
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        ref,
        handler,
        isSsr
    ]);
};
/* harmony default export */ var hooks_useOnClickOutside = (useOnClickOutside);

;// CONCATENATED MODULE: ./src/components/ProductList/v2/Sort/index.jsx








const Sort = (param)=>{
    let { texts: { sort ="" , selected ="" , sortByAria ="" , altSort ="" , sortbyExpanded ="" , sortbyClosed =""  } , data , onChange , page , selectedtab , tabIndex =0 , isSearch , selectedSort , isMyFavoriteTab =false  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const sortClass = classnames_default()({
        sort: true,
        "sort--open": isOpen
    });
    const sortBtn = (0,react.useRef)(null);
    const pastServiceMenu = (0,react.useRef)(null);
    const sortByWrapper = (0,react.useRef)(null);
    hooks_useOnClickOutside(sortByWrapper, ()=>{
        isOpen && setIsOpen(false);
    });
    const btnKeyDown = (e)=>{
        switch(e.keyCode){
            case constants.KEYCODE.ENTER:
                e.preventDefault();
                !isOpen ? pastServiceMenu.current.firstElementChild.focus() : "";
                setIsOpen(!isOpen);
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        e.preventDefault();
        const ele = pastServiceMenu.current.childNodes;
        switch(e.keyCode){
            case constants.KEYCODE.ESC:
                setIsOpen(false);
                break;
            case constants.KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case constants.KEYCODE.DOWN:
                if (i < data.length - 1) ele[i + 1].focus();
                break;
            case constants.KEYCODE.SPACE:
            case constants.KEYCODE.ENTER:
                ele[i].click();
                sortBtn.current.focus();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: sortClass,
        ref: sortByWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ref: sortBtn,
                className: "sort__toggle",
                tabIndex: tabIndex,
                "aria-label": isSearch ? selectedSort ? "".concat(selectedSort.name, " ").concat(selected) : sortByAria : selectedSort ? "".concat(selectedSort.name, " ").concat(selected) : sortByAria,
                onClick: ()=>setIsOpen(!isOpen),
                onKeyDown: btnKeyDown,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sort-by-text",
                        children: [
                            sort,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sort-options",
                        children: " ".concat(isMyFavoriteTab ? "" : ":", " ").concat(selectedSort ? selectedSort.name : "Featured")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: arrow_up/* default */.Z === null || arrow_up/* default */.Z === void 0 ? void 0 : arrow_up/* default.src */.Z.src,
                        alt: altSort,
                        className: "sort__toggle-icon",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                ref: pastServiceMenu,
                className: "sort__drop-down",
                "aria-label": isOpen ? sortbyExpanded : sortbyClosed,
                "aria-hidden": !isOpen,
                children: data.map((item, i)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        id: "select-options-".concat(i),
                        role: "option",
                        tabIndex: "-1",
                        "aria-selected": (item === null || item === void 0 ? void 0 : item.name) === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name),
                        className: "sort__item gbh-data-layer ".concat((item && item.name) === (selectedSort && selectedSort.name) ? "active" : ""),
                        "data-gbh-data-layer": getAnalyticsData(item, null, {
                            selectedtab,
                            page
                        }),
                        onClick: ()=>{
                            onChange(item);
                            setIsOpen(false);
                        },
                        onKeyDown: (e)=>handleKeyDown(i, e),
                        children: item.name
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var v2_Sort = ((0,lib/* withOrientationChange */.Qe)(Sort));


/***/ }),

/***/ 29295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_PromoBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./components/core/Image/DynamicImage.jsx
var DynamicImage = __webpack_require__(18377);
// EXTERNAL MODULE: ./src/components/PromoBanner/v1/index.module.scss
var index_module = __webpack_require__(1745);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./src/components/PromoBanner/v2/promoBannerHelper.js




const getPromoData = async (link)=>{
    const finalData = (0,api/* aemAxiosInstance */.Gb)({
        url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
            path: link + ".model.json"
        }
    }).then((res)=>{
        const dat = (0,utils/* recursiveDataFunction */.Qe)(res === null || res === void 0 ? void 0 : res.data, constants.COMPONENT_TYPES === null || constants.COMPONENT_TYPES === void 0 ? void 0 : constants.COMPONENT_TYPES.PROMOBANNER);
        return dat[0];
    }).catch((err)=>{
        console.log("Failed to get compare attributes JSON file", err);
    });
    return finalData;
};

;// CONCATENATED MODULE: ./src/components/PromoBanner/v2/PromoBanner.jsx









const PromoBanner = (props)=>{
    var ref, ref1, ref2;
    const { setPromoData =()=>{} , xfLink ="" , col =0 , position =0 , width =0 , promoJson ={} , promoIndex =0 , parent =""  } = props;
    const [data, setData] = (0,react.useState)({
        imgUrl: "",
        desc: "",
        ctaText: "",
        ctaLink: "",
        position: "",
        promoBg: "",
        fontColor: "inherit"
    });
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const promoDesc = (0,react.useRef)(null);
    const buttonStyle = {
        color: data.fontColor,
        borderColor: data.fontColor
    };
    const [actionLink, setActionLink] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        getXfData();
    }, [
        xfLink,
        width
    ]);
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.desc) {
            const dynamicId = (0,helper.createIdFromString)(data === null || data === void 0 ? void 0 : data.desc);
            setDynamicId(dynamicId);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.desc
    ]);
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.ctaLink) {
            (0,utils_location/* getShortenedUrl */.Pp)(data === null || data === void 0 ? void 0 : data.ctaLink).then((res)=>setActionLink(res));
        }
    }, [
        data
    ]);
    const setPromoJsonData = async function() {
        let jsonData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (jsonData) {
            var _ctaLink;
            const shortenedCtaLink = await (0,utils_location/* getShortenedUrl */.Pp)((_ctaLink = jsonData.ctaLink) !== null && _ctaLink !== void 0 ? _ctaLink : "");
            var _imageUrl, _title, _ctaLabel, _ctaLabel1, _title1, _assetPath, ref, _fontColor;
            const result = {
                imgUrl: (_imageUrl = jsonData.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "",
                desc: (_title = jsonData.title) !== null && _title !== void 0 ? _title : "",
                altText: jsonData.isDecorativeTeaser !== "true" ? jsonData.altText : "",
                ctaText: (_ctaLabel = jsonData.ctaLabel) !== null && _ctaLabel !== void 0 ? _ctaLabel : "",
                ctaLink: (shortenedCtaLink === null || shortenedCtaLink === void 0 ? void 0 : shortenedCtaLink.includes(".html")) ? shortenedCtaLink : "".concat(shortenedCtaLink, ".html"),
                ctaAriaLabel: "".concat((_ctaLabel1 = jsonData.ctaLabel) !== null && _ctaLabel1 !== void 0 ? _ctaLabel1 : "", " ").concat((0,helper.sanitizeText)((_title1 = jsonData.title) !== null && _title1 !== void 0 ? _title1 : "")),
                assetPath: (_assetPath = jsonData.assetPath) !== null && _assetPath !== void 0 ? _assetPath : "",
                position: position,
                infoTextAlign: (ref = width > 1023 ? jsonData.contentPosition : jsonData.mobileContentPosition) !== null && ref !== void 0 ? ref : "dead-center",
                promoBg: getGradiant(jsonData),
                fontColor: (_fontColor = jsonData.fontColor) !== null && _fontColor !== void 0 ? _fontColor : "inherit",
                isNewTab: jsonData.isNewTab === "true",
                isBannerLink: jsonData.linkAll === "true",
                isSmartCrop: jsonData.presetType === "smartcrop"
            };
            setData(result);
            if (setPromoData) {
                setPromoData(result);
            }
        } else if (setPromoData) {
            setPromoData({
                position: position
            });
        }
    };
    const getXfData = async ()=>{
        if (promoJson && Object.keys(promoJson).length > 0) {
            setPromoJsonData(promoJson);
        } else {
            const link = xfLink === null || xfLink === void 0 ? void 0 : xfLink.split(".html")[0];
            if (link) {
                try {
                    const data = await getPromoData(link);
                    setPromoJsonData(data);
                } catch (error) {
                    console.error(error);
                }
            }
        }
    };
    const getGradiant = (promoRes)=>{
        const gradientData = width > 767 & width < 1024 ? Array.isArray(promoRes.mobileGradientPosition) ? promoRes.mobileGradientPosition : [
            promoRes.mobileGradientPosition
        ] : Array.isArray(promoRes.gradientPosition) ? promoRes.gradientPosition : [
            promoRes.gradientPosition
        ];
        let gradientBg = "";
        let gradientPos = "";
        const toColor = "".concat(promoRes.opacityColor).concat(Math.floor((width > 767 ? promoRes.gradientOpacity : promoRes.tintOverlayValue) / 100 * 255).toString(16).padStart(2, 0));
        if (width > 767) {
            gradientData === null || gradientData === void 0 ? void 0 : gradientData.forEach((pos, i)=>{
                if (pos === "topToBottom") {
                    gradientPos = "to bottom";
                } else if (pos === "bottomToTop") {
                    gradientPos = "to top";
                } else if (pos === "leftToRight") {
                    gradientPos = "to right";
                } else if (pos === "radialCenterOut") {
                    gradientPos = "circle";
                }
                gradientBg = gradientBg + (i > 0 ? ", " : "") + "".concat(pos === "radialCenterOut" ? "radial-gradient" : "linear-gradient", "(").concat(gradientPos, ", ").concat(promoRes.opacityColor + "00", " 0%, ").concat(toColor, " 100%)");
            });
        } else {
            gradientBg = toColor;
        }
        return gradientBg !== "" ? gradientBg : "rgba(0,0,0,0)";
    };
    const onBannerClick = (event)=>{
        if (data.isBannerLink) {
            handlePromoBannerClick(event, data);
            window.open(data.ctaLink, data.isNewTab ? "_blank" : "");
        }
    };
    const ctatitle = data === null || data === void 0 ? void 0 : (ref = data.ctaText) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    let eventInfo;
    if ((ref1 = window.location) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pathname) === null || ref2 === void 0 ? void 0 : ref2.includes("search")) {
        eventInfo = {
            eventAction: "search results:products:main content area:".concat(ctatitle),
            eventName: "search results:products:main content area:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "search",
            internalLinkType: "search results:internal campaign",
            internalLinkZoneName: "search results:products:main content area",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    } else if ((parent === null || parent === void 0 ? void 0 : parent.toLowerCase()) === constants.dynamicSearch) {
        eventInfo = {
            eventAction: "search results:products:main content area:".concat(ctatitle),
            eventName: "search results:products:main content area:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "suggested search",
            internalLinkType: "suggested search results:internal campaign",
            internalLinkZoneName: "suggested search results:top products results",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    } else {
        eventInfo = {
            eventAction: "plp:".concat(ctatitle),
            eventName: "plp:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "plp",
            internalLinkType: "plp:internal campaign",
            internalLinkZoneName: "plp:promo tiles",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    }
    const scrollToTop = ()=>{
        const scrollStep = -window.scrollY / (1000 / 15 // scroll speed here
        );
        const scrollInterval = setInterval(()=>{
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 15);
    };
    const handlePromoBannerClick = function(event) {
        let data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        actionLink === window.location.pathname ? scrollToTop() : "";
        event.stopPropagation();
        if (window.adobeDataLayer) {
            var ref;
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const componentInfo = {
                componentID: window.location.href,
                componentLocation: window.location.pathname.includes("search") ? "search results:promo tiles" : "plp:promo tiles",
                componentMessage: "promo-".concat(promoIndex),
                componentName: (ref = data === null || data === void 0 ? void 0 : data.desc.replace(/<\/?[^>]+(>|$)/g, " ").replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, " ")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                componentType: "internal campaign"
            };
            const eventDetails = {
                event: "cmp:click",
                eventInfo,
                componentInfo,
                page
            };
            window.adobeDataLayer.push(eventDetails);
        }
    };
    var _fontColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).productPromoBanner),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "plp-promo-banner wow animate__fadeInUp ".concat(col === 2 || col === 3 ? "--fixed-height" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                role: data.isBannerLink ? "link" : "",
                tabIndex: data.isBannerLink ? 0 : -1,
                onClick: onBannerClick,
                className: "plp-promo-banner__layout --col-".concat(col !== null && col !== void 0 ? col : 1),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "plp-promo-banner__image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage/* default */.Z, {
                            imgUrl: data === null || data === void 0 ? void 0 : data.imgUrl,
                            alt: data === null || data === void 0 ? void 0 : data.desc,
                            uniqueId: dynamicId
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "plp-promo-banner__info-bg",
                        style: {
                            background: "".concat(data.promoBg)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "plp-promo-banner__info plp-promo-banner__info-".concat(data.infoTextAlign),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: promoDesc,
                                className: "plp-promo-banner__desc",
                                style: {
                                    color: "".concat((_fontColor = data.fontColor) !== null && _fontColor !== void 0 ? _fontColor : "")
                                },
                                children: (0,helper.nbspSanitizeInnerHtml)(data.desc)
                            }),
                            actionLink !== "" && (actionLink === window.location.pathname ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "plp-promo-banner__button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    customClass: "plp-promo-banner__cta",
                                    type: "ghost",
                                    size: "small",
                                    label: data.ctaText,
                                    ariaLabel: data.ctaAriaLabel,
                                    onClick: (event)=>handlePromoBannerClick(event, data),
                                    style: buttonStyle,
                                    useDefaultClass: true
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "plp-promo-banner__button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "link",
                                    customClass: "plp-promo-banner__cta",
                                    type: "ghost",
                                    size: "small",
                                    to: actionLink,
                                    label: data.ctaText,
                                    ariaLabel: data.ctaAriaLabel,
                                    onClick: (event)=>handlePromoBannerClick(event, data),
                                    style: buttonStyle,
                                    useDefaultClass: true
                                })
                            }))
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v2_PromoBanner = (PromoBanner);


/***/ }),

/***/ 293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3522);
/* harmony import */ var lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2__);



const Highlight = (param)=>{
    let { text ="" , highlight =""  } = param;
    if (!highlight.trim()) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: text
    });
    const regex = new RegExp("(".concat(lodash_escapeRegExp__WEBPACK_IMPORTED_MODULE_2___default()(highlight), ")"), "gi");
    const parts = text.split(regex);
    return parts.filter((part)=>part).map((part, i)=>regex.test(part) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "highlight-text",
            children: part
        }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: part
        }, i));
};
/* harmony default export */ __webpack_exports__["Z"] = (Highlight);


/***/ }),

/***/ 94593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




const RadioButton = (param)=>{
    let { onKeydown , analyticsData , id ="" , name ="" , value =undefined , checked =undefined , onClick =()=>{}  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        role: "radio",
        onKeyDown: onKeydown,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
            radio: true
        }),
        htmlFor: id,
        "aria-checked": checked,
        tabIndex: checked ? 0 : -1,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "radio",
                className: "radio__input " + (analyticsData ? "gbh-data-layer" : ""),
                "data-gbh-data-layer": analyticsData,
                name: name,
                id: id,
                checked: checked,
                onClick: onClick,
                onChange: onClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "radio__custom"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: value
            })
        ]
    });
};
RadioButton.propTypes = {
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string) || (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 62863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReCaptcha_ReCaptcha; },
  "L": function() { return /* binding */ validateRecaptcha; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./src/components/core/ReCaptcha/analytics.js

const getInternalLinkURLS = (url)=>{
    return (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) ? "true" : "false";
};
const setLinkAnalytics = function(linkUrl, type, getAnalyticsData) {
    let eventType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "navigation";
    if (!getAnalyticsData) return null;
    const { pageTitle ="n/a" , internalLinkPosition ="n/a" , internalLinkTypeWithType ="n/a" , internalLinkType ="n/a" , addNoFooterInAttr =false  } = getAnalyticsData;
    if (typeof type !== "string") {
        var ref;
        // this is html content
        const div = document.createElement("div");
        div.innerHTML = type;
        // This contains HTML code so remove some bugs here.
        type = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
        type = type.replaceAll("\n", "");
    } else {
        type = type.toLowerCase();
    }
    var ref1;
    const eventInfo = {
        clickInternalLinks: getInternalLinkURLS(linkUrl),
        eventAction: "".concat(pageTitle).concat(addNoFooterInAttr ? "" : ":form:footer", ":").concat(type) || "n/a",
        eventName: "".concat(pageTitle).concat(addNoFooterInAttr ? "" : ":form:footer", ":").concat(type) || "n/a",
        eventType,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type || "n/a",
        internalLinkPosition: internalLinkPosition !== null && internalLinkPosition !== void 0 ? internalLinkPosition : "n/a",
        internalLinkType: internalLinkTypeWithType ? internalLinkTypeWithType + ":" + type : internalLinkType !== null && internalLinkType !== void 0 ? internalLinkType : "n/a",
        internalLinkURL: linkUrl ? (linkUrl.indexOf("http") === -1 ? window.location.origin : "") + linkUrl : "n/a",
        internalLinkZoneName: (ref1 = "".concat(pageTitle).concat(addNoFooterInAttr ? "" : ":form:footer")) !== null && ref1 !== void 0 ? ref1 : "n/a"
    };
    addAnalyticsForRecaptchLinks(eventInfo, "cmp:click");
};
const addAnalyticsForRecaptchLinks = function(eventInfo) {
    let event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click";
    const page = (0,helper.getPageInfo)();
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


// EXTERNAL MODULE: ./src/components/core/ReCaptcha/Recaptcha.module.scss
var Recaptcha_module = __webpack_require__(63898);
var Recaptcha_module_default = /*#__PURE__*/__webpack_require__.n(Recaptcha_module);
;// CONCATENATED MODULE: ./src/components/core/ReCaptcha/ReCaptcha.jsx
/* eslint-disable no-undef */ 









let promiseResolve;
let promiseReject;
const validateRecaptcha = ()=>{
    return new Promise((resolve, reject)=>{
        (0,config/* getConfig */.i)().then((CONFIG)=>{
            try {
                const { isDisableRecaptcha  } = CONFIG.general;
                if (isDisableRecaptcha) {
                    return resolve({
                        success: isDisableRecaptcha
                    });
                }
                const { captcha: { captchaSiteKeyV3 , captchaThreshold  } , general: { siteName  }  } = CONFIG;
                promiseResolve = resolve;
                promiseReject = reject;
                grecaptcha.ready(()=>{
                    grecaptcha.reset();
                    grecaptcha.execute(captchaSiteKeyV3).then(async (token)=>{
                        try {
                            const { data  } = await (0,api/* aemAxiosInstance */.Gb)({
                                url: "/bin/kohler/google/captchaAuth?type=V3&access_token=".concat(token, "&brandName=").concat(siteName.toLowerCase()),
                                method: "GET"
                            });
                            if (data.score < captchaThreshold) {
                                grecaptcha.reset();
                                grecaptcha.execute();
                            } else {
                                return resolve(data);
                            }
                        } catch (error) {
                            reject(error);
                        }
                    }).catch((err1)=>reject(err1));
                });
            } catch (error) {
                reject(error);
            }
        });
    });
};
const ReCaptcha = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [links, setLinks] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)({});
    const [i18n, seti18n] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const { legalPageLinks  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const getTranslations = (t)=>{
        return {
            protectedByGoogle: t("kf.associatemembership.label.protectedByGoogle"),
            privacyPolicyGoogle: t("kf.associatemembership.label.privacyPolicyGoogle"),
            privacyPolicy: t("kf.contactus.label.privacyPolicy"),
            termsOfService: t("kf.contactus.label.termsOfService"),
            and: t("kf.contactus.message.and"),
            apply: t("kf.contactus.message.apply")
        };
    };
    (0,react.useEffect)(()=>{
        seti18n(getTranslations(t));
        (0,config/* getConfig */.i)().then((config)=>{
            const { captcha: { captchaSiteKeyV2 , captchaSiteKeyV3  } , general: { siteName  }  } = config;
            setState({
                captchaSiteKeyV2,
                captchaSiteKeyV3,
                siteName
            });
        });
    }, []);
    (0,react.useEffect)(()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3 , siteName  } = state;
        if (captchaSiteKeyV2 && captchaSiteKeyV3 && siteName) {
            loadRecaptcha();
            getLegalPages();
        }
    }, [
        state.captchaSiteKeyV2,
        state.captchaSiteKeyV3,
        state.siteName
    ]);
    (0,react.useEffect)(()=>{
        if (legalPageLinks) {
            const { googlePrivacyPolicy , googleTermsOfService  } = legalPageLinks;
            setLinks({
                googlePrivacyPolicy,
                googleTermsOfService
            });
        }
    }, [
        legalPageLinks
    ]);
    const getLegalPages = async ()=>{
        dispatch((0,genericSlice/* getLegalPageLinks */.go)());
    };
    const loadRecaptcha = ()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3  } = state;
        const scriptExist = document.getElementById("recaptcha-key");
        if (!scriptExist) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=".concat(captchaSiteKeyV3);
            script.id = "recaptcha-key";
            script.onload = function onload() {
                grecaptcha.ready(()=>{
                    grecaptcha.render("recaptcha-container", {
                        sitekey: captchaSiteKeyV2,
                        callback: (t)=>verifyToken(t)
                    });
                });
            };
            document.body.appendChild(script);
        } else {
            grecaptcha.ready(()=>{
                grecaptcha.render("recaptcha-container", {
                    sitekey: captchaSiteKeyV2,
                    callback: (t)=>verifyToken(t)
                });
            });
        }
    };
    const verifyToken = async (token)=>{
        const CONFIG = await (0,config/* getConfig */.i)();
        const { isDisableRecaptcha  } = CONFIG.general;
        if (isDisableRecaptcha) {
            promiseResolve({
                success: isDisableRecaptcha
            });
        }
        try {
            const { data  } = await (0,api/* aemAxiosInstance */.Gb)({
                url: "/bin/kohler/google/captchaAuth?type=V2&access_token=".concat(token, "&brandName=").concat(state.siteName.toLowerCase()),
                method: "GET"
            });
            promiseResolve(data);
        } catch (error) {
            promiseReject(err);
        }
    };
    const { getAnalyticsData ={} , isPopupNeededBeforeRedirection =true  } = props;
    const { googlePrivacyPolicy ="n/a" , googleTermsOfService ="n/a"  } = links;
    const { privacyPolicyGoogle ="" , termsOfService =""  } = i18n;
    const handleClickOfLinks = (e, text, url)=>{
        const eventType = isPopupNeededBeforeRedirection ? "navigation" : "informative";
        if (props.addReviewRegistrationEventInfo) {
            const eventReviewInfo = props.addReviewRegistrationEventInfo(text, url, "false");
            addAnalyticsForRecaptchLinks(eventReviewInfo);
        } else {
            setLinkAnalytics(url, text, getAnalyticsData, eventType);
        }
        if (isPopupNeededBeforeRedirection) (0,helper.getSiteWideModal)(e, url);
        else window.open(url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Recaptcha_module_default()).reCatichWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "recaptcha-container",
                    className: "g-recaptcha",
                    "data-size": "invisible"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-20 mb-20 recaptcha-links",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(i18n.protectedByGoogle, " ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, privacyPolicyGoogle, googlePrivacyPolicy),
                            children: privacyPolicyGoogle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.and,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, termsOfService, googleTermsOfService),
                            children: termsOfService
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.apply
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ReCaptcha_ReCaptcha = (ReCaptcha);


/***/ }),

/***/ 45138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25219);
/* harmony import */ var _components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ToolTip = (props)=>{
    const [{ children =null , ...attr }, setAttribute] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        id: props.id,
        role: "tooltip",
        tabIndex: props.setFocus ? 0 : -1,
        "aria-label": props.ariaLabel,
        children: props.message
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setAttribute({
            ...attr,
            children: props.message
        });
    }, [
        props.message
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (props.setFocus) (ref = document.getElementById(props.id)) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        props.setFocus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_ToolTip_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tooltipWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tooltip__container",
            role: "alert",
            "aria-live": "polite",
            children: [
                props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "--label",
                            children: "".concat(props.label, ":")
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ...attr,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ToolTip);


/***/ }),

/***/ 41740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ getMoreInCollectionSlider; },
/* harmony export */   "VA": function() { return /* binding */ getMoreInCollectionsInfo; },
/* harmony export */   "__": function() { return /* binding */ callDesignServicesAddToCartAnalytics; },
/* harmony export */   "gA": function() { return /* binding */ callInstallServiceAddToCartAnalytics; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34326);
/**
 *
 * @param {Object} resInfo
 * @param {Object} productInfo
 * Kohler Data Layer Tech Spec 2021 - Batch 5 - Installation Services v1
 * Requirement#12 Add to Cart button
 */ 
const callInstallServiceAddToCartAnalytics = (param)=>{
    let { resInfo , productInfo , cartID , eventInfoObj  } = param;
    var ref;
    const { status , message ="n/a"  } = resInfo;
    const isStatus = status === 200;
    const eventInfo = eventInfoObj !== null && eventInfoObj !== void 0 ? eventInfoObj : {
        eventAction: "installer services:already have a product purchase a kohler installation service:add to cart",
        eventName: "installer services:already have a product purchase a kohler installation service:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: "installer services",
        internalLinkType: "installer services:in-person",
        internalLinkZoneName: "installer services:already have a product purchase a kohler installation service",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID
    };
    (ref = window.adobeDataLayer) === null || ref === void 0 ? void 0 : ref.push({
        event: "cmp:click",
        eventInfo,
        productInfo,
        page
    });
};
const callDesignServicesAddToCartAnalytics = (resInfo, productInfo, serviceName, cartID)=>{
    const { status , message ="n/a"  } = resInfo;
    const isStatus = status === 200;
    const eventInfo = {
        eventAction: serviceName + ":virtual bathroom design service:add to cart",
        eventName: serviceName + ":virtual bathroom design service:add to cart",
        eventType: "navigation",
        eventMsg: message === null || message === void 0 ? void 0 : message.toLowerCase(),
        eventStatus: isStatus ? "success" : "failure",
        internalLinkName: "add to cart",
        internalLinkPosition: serviceName,
        internalLinkType: serviceName + ":add to cart",
        internalLinkZoneName: serviceName + ":virtual bathroom design service",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    page.cart = {
        cartID
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page,
        productInfo
    });
};
const getMoreInCollectionsInfo = function(title, needsJSON) {
    let pdpNavigationURL = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", product = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var ref, ref1;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const subCategoryID = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategoryID;
    const primaryCategory = page === null || page === void 0 ? void 0 : (ref1 = page.category) === null || ref1 === void 0 ? void 0 : ref1.primaryCategory;
    const type = (title === null || title === void 0 ? void 0 : title.toLowerCase()) === "recently viewed";
    const eventAction = "".concat(type ? subCategoryID : primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(title !== null && title !== void 0 ? title : ""), ":product navigation");
    const internalLinkURL = ((pdpNavigationURL === null || pdpNavigationURL === void 0 ? void 0 : pdpNavigationURL.indexOf("http")) === -1 ? window.location.origin : "") + pdpNavigationURL;
    const internalLinkZoneName = "".concat(type ? subCategoryID : primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(title !== null && title !== void 0 ? title : ""), ":preview");
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventNavigation: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(product === null || product === void 0 ? void 0 : product.name), " "),
        internalLinkPosition: type ? subCategoryID : primaryCategory,
        internalLinkType: "".concat(type ? subCategoryID : primaryCategory, ":navigation"),
        internalLinkURL,
        internalLinkZoneName,
        clickInternalLinks: "true"
    };
    if (needsJSON) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getMoreInCollectionSlider = (title)=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const primaryCategory = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.primaryCategory;
    const eventAction = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(title !== null && title !== void 0 ? title : ""), ":product slider");
    const internalLinkZoneName = "".concat(primaryCategory, ":").concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__.sanitizeTextForAnalytics)(title !== null && title !== void 0 ? title : ""), ":preview");
    const eventInfo = {
        eventAction,
        eventName: eventAction,
        eventNavigation: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "slider",
        internalLinkPosition: primaryCategory,
        internalLinkType: "".concat(primaryCategory, ":navigation"),
        internalLinkURL: "n/a",
        internalLinkZoneName,
        clickInternalLinks: "true"
    };
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};


/***/ }),

/***/ 15011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ productCardAddToCart; }
/* harmony export */ });
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19514);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46201);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88751);
/* harmony import */ var _store_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45094);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33273);





const productCardAddToCart = async (items, showPreview, message, cb)=>{
    var ref;
    const CONFIG = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_0__/* .getConfig */ .i)();
    var ref1;
    const salesChannels = (ref1 = CONFIG === null || CONFIG === void 0 ? void 0 : (ref = CONFIG.salesChannelConfig) === null || ref === void 0 ? void 0 : ref.map) !== null && ref1 !== void 0 ? ref1 : {};
    const actions = [];
    let userZipCode;
    items.forEach((product)=>{
        var _brand;
        const fields = {
            salesChannel: (_brand = salesChannels[product.brand]) !== null && _brand !== void 0 ? _brand : "KOUS"
        };
        if (product.backorder) fields.isBackOrderable = true;
        actions.push({
            action: product.isBundle ? "addbundle" : "addLineItem",
            sku: product.sku,
            quantity: product.quantity,
            custom: product.additionalInfo ? {
                type: {
                    key: "lineItemShipping"
                },
                fields: {
                    salesChannel: salesChannels[product.brand],
                    roomInfo: product.additionalInfo.roomInfo,
                    customQuantity: product.additionalInfo.customQuantity,
                    overage: product.additionalInfo.overage
                }
            } : {
                type: {
                    key: "lineItemShipping"
                },
                fields: fields
            }
        });
        userZipCode = product === null || product === void 0 ? void 0 : product.userZipCode;
    });
    const body = {
        actions: actions
    };
    if (userZipCode) {
        body.servicesku = true;
        body.zipCode = userZipCode;
    }
    _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)(body)).unwrap().then((res)=>{
        if (res) {
            _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_4__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
            cb && cb({
                status: 200,
                message: "success"
            });
            if (message) {
                _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showToast */ .CF)(message));
            }
            if (showPreview) _store_index__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_2__/* .showPreviewCart */ .z0)());
        }
    });
};


/***/ }),

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const usePrevious = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrevious);


/***/ }),

/***/ 83839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7154);


const useSmartCrop = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const [scriptStatus, setScriptStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!isSsr && window.s7responsiveImage ? true : false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!isSsr) {
            loadSmartcrop();
        }
    }, [
        isSsr
    ]);
    const loadSmartcrop = ()=>{
        const scriptExist = document.querySelectorAll("script#smartcrop-react");
        if (scriptExist.length === 0 && !window.s7responsiveImage) {
            const script = document.createElement("script");
            script.src = "/js/responsive-images.js";
            script.id = "smartcrop-react";
            script.onload = function onload() {
                setScriptStatus(true);
            };
            document.body.appendChild(script);
        } else {
            setScriptStatus(true);
        }
    };
    const applySmartCrop = (ele)=>{
        window.s7responsiveImage && window.s7responsiveImage(ele);
    };
    return {
        scriptStatus,
        applySmartCrop
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSmartCrop);


/***/ }),

/***/ 92798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7154);



/**
 *
 * @return {{width, height}}
 */ const useWindowDimensions = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const [windowDimensions, setWindowDimensions] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        winWidth: 0,
        winHeight: 0
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) {
            return;
        }
        const { innerWidth: width , innerHeight: height  } = window;
        /**
     * Set window dimensions on resize
     */ const handleResize = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(()=>{
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
        }, 300);
        if (!isSsr) {
            setWindowDimensions({
                winWidth: width,
                winHeight: height
            });
            window.addEventListener("resize", handleResize);
        }
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        isSsr
    ]);
    return windowDimensions;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowDimensions);


/***/ }),

/***/ 49578:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleCard":"ArticleCard_articleCard___2_B4"};

/***/ }),

/***/ 62219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__Dzs60"};

/***/ }),

/***/ 37764:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogLanding":"Blog_blogLanding__xYUgk"};

/***/ }),

/***/ 50238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authUtilityNavWrapper":"AuthUtilityNav_authUtilityNavWrapper__iJgYU"};

/***/ }),

/***/ 19371:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 38326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promoBannerWrapper":"v1_promoBannerWrapper__J4Pwk"};

/***/ }),

/***/ 49581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"findStoreLanding":"FindAStore_findStoreLanding__qQGB8"};

/***/ }),

/***/ 48809:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leadGenerationLanding":"LeadGenerationView_leadGenerationLanding__6PQ0u"};

/***/ }),

/***/ 70427:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogStickyHeadWrapper":"Sticky_blogStickyHeadWrapper__E_QNe"};

/***/ }),

/***/ 92752:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageUploadWrapper":"DateTimePicker_imageUploadWrapper__VDOGD"};

/***/ }),

/***/ 56384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"OmniChannelFormWrapper":"OmniChannel_OmniChannelFormWrapper__k57VE"};

/***/ }),

/***/ 83468:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productEnquiryLanding":"ProductEnquiryView_productEnquiryLanding__ZMSM6"};

/***/ }),

/***/ 3899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListingFilterWrapper":"Filter_productListingFilterWrapper__Lmvl4","load":"Filter_load___YijE"};

/***/ }),

/***/ 50702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productTileWrapper":"ProductTile_productTileWrapper__SFQ2t"};

/***/ }),

/***/ 80484:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quizContainer":"quiz_quizContainer__YLU_S"};

/***/ }),

/***/ 89844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageUploadWrapper":"ImageUpload_imageUploadWrapper__T5GU7"};

/***/ }),

/***/ 62582:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsletterFooter_wrapper__YlEqt","gbh-footer-news-letter":"NewsletterFooter_gbh-footer-news-letter__J0nKA","form-group":"NewsletterFooter_form-group__RUpge","form-control":"NewsletterFooter_form-control__cT7ti","btn":"NewsletterFooter_btn__VWVsj","fadeInDown":"NewsletterFooter_fadeInDown__DQU3a"};

/***/ }),

/***/ 15729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"otpVerification":"v1_otpVerification__O_OPU"};

/***/ }),

/***/ 84181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"utilityWidgetsWrapper":"UtilityWidgets_utilityWidgetsWrapper__Wz0ZS"};

/***/ }),

/***/ 48520:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"visualFilter":"visual-filter_visualFilter__Kicys"};

/***/ }),

/***/ 18787:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirmationModal":"ConfimationModal_confirmationModal__EiLN_"};

/***/ }),

/***/ 96724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"Accordion_accordionWrapper__vZrfq"};

/***/ }),

/***/ 2534:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Autocomplete_wrapper__Wmo5c"};

/***/ }),

/***/ 8618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectDropdown_wrapper__ot64Z"};

/***/ }),

/***/ 81770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextArea_wrapper__fJ1_4"};

/***/ }),

/***/ 18476:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"helpSupportWrapper":"v1_helpSupportWrapper__ZxlFZ"};

/***/ }),

/***/ 15803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productPerPageWrapper":"ProductsPerPage_productPerPageWrapper___0U26"};

/***/ }),

/***/ 55266:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListWrapper":"ProductListView_productListWrapper__Q9ki_"};

/***/ }),

/***/ 58088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListingSearchWrapper":"Sort_productListingSearchWrapper__wyBcb"};

/***/ }),

/***/ 1745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productPromoBanner":"v1_productPromoBanner__UEqVf"};

/***/ }),

/***/ 34147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"socialShareWrapper":"socialShare_socialShareWrapper__r_m5b"};

/***/ }),

/***/ 24707:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"additionalFooterWrapper":"Shared_additionalFooterWrapper__Dk6ah","mainFooterWrapper":"Shared_mainFooterWrapper___kAyp","utilityNavHeaderWrapper":"Shared_utilityNavHeaderWrapper__8gG45"};

/***/ }),

/***/ 5196:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shopTheRoomWrapper":"v1_shopTheRoomWrapper__fxH9B"};

/***/ }),

/***/ 63898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reCatichWrapper":"Recaptcha_reCatichWrapper__4F7Lw"};

/***/ }),

/***/ 25219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"Tooltip_tooltipWrapper__JMsKi"};

/***/ }),

/***/ 49696:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v1_productCardWrapper__Mtggq"};

/***/ })

}]);